// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7mjtW":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Map
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _collectionJs = require("./Collection.js");
var _collectionJsDefault = parcelHelpers.interopDefault(_collectionJs);
var _collectionEventTypeJs = require("./CollectionEventType.js");
var _collectionEventTypeJsDefault = parcelHelpers.interopDefault(_collectionEventTypeJs);
var _mapBrowserEventJs = require("./MapBrowserEvent.js");
var _mapBrowserEventJsDefault = parcelHelpers.interopDefault(_mapBrowserEventJs);
var _mapBrowserEventHandlerJs = require("./MapBrowserEventHandler.js");
var _mapBrowserEventHandlerJsDefault = parcelHelpers.interopDefault(_mapBrowserEventHandlerJs);
var _mapBrowserEventTypeJs = require("./MapBrowserEventType.js");
var _mapBrowserEventTypeJsDefault = parcelHelpers.interopDefault(_mapBrowserEventTypeJs);
var _mapEventJs = require("./MapEvent.js");
var _mapEventJsDefault = parcelHelpers.interopDefault(_mapEventJs);
var _mapEventTypeJs = require("./MapEventType.js");
var _mapEventTypeJsDefault = parcelHelpers.interopDefault(_mapEventTypeJs);
var _mapPropertyJs = require("./MapProperty.js");
var _mapPropertyJsDefault = parcelHelpers.interopDefault(_mapPropertyJs);
var _objectJs = require("./Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _objectEventTypeJs = require("./ObjectEventType.js");
var _objectEventTypeJsDefault = parcelHelpers.interopDefault(_objectEventTypeJs);
var _tileQueueJs = require("./TileQueue.js");
var _tileQueueJsDefault = parcelHelpers.interopDefault(_tileQueueJs);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _viewHintJs = require("./ViewHint.js");
var _viewHintJsDefault = parcelHelpers.interopDefault(_viewHintJs);
var _arrayJs = require("./array.js");
var _assertsJs = require("./asserts.js");
var _consoleJs = require("./console.js");
var _defaultsJs = require("./control/defaults.js");
var _domJs = require("./dom.js");
var _eventsJs = require("./events.js");
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("./extent.js");
var _functionsJs = require("./functions.js");
var _hasJs = require("./has.js");
var _defaultsJs1 = require("./interaction/defaults.js");
var _groupJs = require("./layer/Group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _layerJs = require("./layer/Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
var _eventTypeJs1 = require("./pointer/EventType.js");
var _eventTypeJsDefault1 = parcelHelpers.interopDefault(_eventTypeJs1);
var _projJs = require("./proj.js");
var _eventTypeJs2 = require("./render/EventType.js");
var _eventTypeJsDefault2 = parcelHelpers.interopDefault(_eventTypeJs2);
var _compositeJs = require("./renderer/Composite.js");
var _compositeJsDefault = parcelHelpers.interopDefault(_compositeJs);
var _sizeJs = require("./size.js");
var _transformJs = require("./transform.js");
var _utilJs = require("./util.js");
/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source.js").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType.js").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable.js").OnSignature<MapObjectEventTypes, import("./Object.js").ObjectEvent, Return> &
 *    import("./Observable.js").OnSignature<import("./MapBrowserEventType.js").Types, import("./MapBrowserEvent.js").default, Return> &
 *    import("./Observable.js").OnSignature<import("./MapEventType.js").Types, import("./MapEvent.js").default, Return> &
 *    import("./Observable.js").OnSignature<import("./render/EventType.js").MapRenderEventTypes, import("./render/Event.js").default, Return> &
 *    import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType.js").Types|import("./MapEventType.js").Types|
 *      import("./render/EventType.js").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used. In a worker, no controls are added by default.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used. In a worker, no interactions are added by default.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string|HTMLCanvasElement|OffscreenCanvas} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For use in workers or when exporting a map, use an `OffscreenCanvas` or `HTMLCanvasElement` as target,
 * with a width and height in physical pixels, optionally multiplied by and a scale transform matching
 * the map's pixel ratio.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function removeLayerMapProperty(layer) {
    if (layer instanceof (0, _layerJsDefault.default)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, _groupJsDefault.default)) layer.getLayers().forEach(removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function setLayerMapProperty(layer, map) {
    if (layer instanceof (0, _layerJsDefault.default)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, _groupJsDefault.default)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class Map extends (0, _objectJsDefault.default) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, _hasJs.DEVICE_PIXEL_RATIO);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, _transformJs.create)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, _transformJs.create)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ if (!(0, _hasJs.WORKER_OFFSCREEN_CANVAS)) {
            this.viewport_ = document.createElement('div');
            this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
            this.viewport_.style.position = 'relative';
            this.viewport_.style.overflow = 'hidden';
            this.viewport_.style.width = '100%';
            this.viewport_.style.height = '100%';
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainer_ = document.createElement('div');
            this.overlayContainer_.style.position = 'absolute';
            this.overlayContainer_.style.zIndex = '0';
            this.overlayContainer_.style.width = '100%';
            this.overlayContainer_.style.height = '100%';
            this.overlayContainer_.style.pointerEvents = 'none';
            this.overlayContainer_.className = 'ol-overlaycontainer';
            this.viewport_.appendChild(this.overlayContainer_);
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainerStopEvent_ = document.createElement('div');
            this.overlayContainerStopEvent_.style.position = 'absolute';
            this.overlayContainerStopEvent_.style.zIndex = '0';
            this.overlayContainerStopEvent_.style.width = '100%';
            this.overlayContainerStopEvent_.style.height = '100%';
            this.overlayContainerStopEvent_.style.pointerEvents = 'none';
            this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
            this.viewport_.appendChild(this.overlayContainerStopEvent_);
        }
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        if (!(0, _hasJs.WORKER_OFFSCREEN_CANVAS)) /**
       * @private
       * @type {ResizeObserver}
       */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || ((0, _hasJs.WORKER_OFFSCREEN_CANVAS) ? new (0, _collectionJsDefault.default)() : (0, _defaultsJs.defaults)());
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || ((0, _hasJs.WORKER_OFFSCREEN_CANVAS) ? new (0, _collectionJsDefault.default)() : (0, _defaultsJs1.defaults)({
            onFocusOnly: true
        }));
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, _tileQueueJsDefault.default)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, _mapPropertyJsDefault.default).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, _mapPropertyJsDefault.default).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, _mapPropertyJsDefault.default).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, _mapPropertyJsDefault.default).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, _viewJsDefault.default))) options.view.then(function(viewOptions) {
            map.setView(new (0, _viewJsDefault.default)(viewOptions));
        });
        this.controls.addEventListener((0, _collectionEventTypeJsDefault.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, _collectionEventTypeJsDefault.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, _collectionEventTypeJsDefault.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_?.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source.js").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, _functionsJs.TRUE);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, _groupJsDefault.default)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, _functionsJs.TRUE);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, _mapPropertyJsDefault.default).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, _projJs.toUserCoordinate)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, _transformJs.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, _mapPropertyJsDefault.default).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, _collectionJsDefault.default)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, _projJs.fromUserCoordinate)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, _transformJs.apply)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the pixel ratio of the rendered map.
   * @return {number} Pixel ratio.
   * @api
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * Set the pixel ratio of the rendered map.
   * @param {number} pixelRatio Pixel ratio.
   * @api
   */ setPixelRatio(pixelRatio) {
        if (this.pixelRatio_ === pixelRatio) return;
        this.pixelRatio_ = pixelRatio;
        this.render();
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, _mapPropertyJsDefault.default).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, _mapPropertyJsDefault.default).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, _tileQueueJs.getTilePriority)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {PointerEvent|KeyboardEvent|WheelEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, _mapBrowserEventJsDefault.default)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, _eventTypeJsDefault1.default).POINTERDOWN || eventType === (0, _eventTypeJsDefault.default).WHEEL || eventType === (0, _eventTypeJsDefault.default).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            const hints = frameState ? frameState.viewHints : undefined;
            const animatingOrInteracting = hints ? hints[(0, _viewHintJsDefault.default).ANIMATING] || hints[(0, _viewHintJsDefault.default).INTERACTING] : false;
            if (animatingOrInteracting) {
                const lowOnFrameBudget = Date.now() - frameState.time > 8;
                maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                maxNewLoads = lowOnFrameBudget ? 0 : 2;
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                if (animatingOrInteracting) tileQueue.reprioritize();
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, _eventTypeJsDefault2.default).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, _eventTypeJsDefault2.default).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, _mapEventJsDefault.default)((0, _mapEventTypeJsDefault.default).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, _mapEventJsDefault.default)((0, _mapEventTypeJsDefault.default).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        if (frameState) for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, _eventsJs.unlistenByKey)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, _eventTypeJsDefault.default).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, _eventTypeJsDefault.default).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_ && !(0, _domJs.isCanvas)(this.targetElement_)) {
            this.resizeObserver_?.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            if (!(0, _domJs.isCanvas)(targetElement)) targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, _compositeJsDefault.default)(this);
            if (!(0, _domJs.isCanvas)(targetElement)) {
                this.mapBrowserEventHandler_ = new (0, _mapBrowserEventHandlerJsDefault.default)(this, this.moveTolerance_);
                for(const key in 0, _mapBrowserEventTypeJsDefault.default)this.mapBrowserEventHandler_.addEventListener((0, _mapBrowserEventTypeJsDefault.default)[key], this.handleMapBrowserEvent.bind(this));
                this.viewport_.addEventListener((0, _eventTypeJsDefault.default).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
                this.viewport_.addEventListener((0, _eventTypeJsDefault.default).WHEEL, this.boundHandleBrowserEvent_, (0, _hasJs.PASSIVE_EVENT_LISTENERS) ? {
                    passive: false
                } : false);
                let keyboardEventTarget;
                if (!this.keyboardEventTarget_) {
                    // check if map target is in shadowDOM, if yes use host element as target
                    const targetRoot = targetElement.getRootNode();
                    const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                    keyboardEventTarget = targetCandidate;
                } else keyboardEventTarget = this.keyboardEventTarget_;
                this.targetChangeHandlerKeys_ = [
                    (0, _eventsJs.listen)(keyboardEventTarget, (0, _eventTypeJsDefault.default).KEYDOWN, this.handleBrowserEvent, this),
                    (0, _eventsJs.listen)(keyboardEventTarget, (0, _eventTypeJsDefault.default).KEYPRESS, this.handleBrowserEvent, this)
                ];
                if (!(0, _domJs.isCanvas)(targetElement)) {
                    const rootNode = targetElement.getRootNode();
                    if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
                    this.resizeObserver_?.observe(targetElement);
                }
            }
            this.updateSize();
        }
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, _eventsJs.unlistenByKey)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, _eventsJs.unlistenByKey)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, _eventsJs.listen)(view, (0, _objectEventTypeJsDefault.default).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, _eventsJs.listen)(view, (0, _eventTypeJsDefault.default).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, _eventsJs.unlistenByKey));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, _groupJs.GroupEvent)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, _eventsJs.listen)(layerGroup, (0, _objectEventTypeJsDefault.default).PROPERTYCHANGE, this.render, this),
                (0, _eventsJs.listen)(layerGroup, (0, _eventTypeJsDefault.default).CHANGE, this.render, this),
                (0, _eventsJs.listen)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, _eventsJs.listen)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        if (!this.frameState_) return;
        const layerStates = this.frameState_.layerStatesArray;
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, _sizeJs.hasArea)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, _extentJs.getForViewAndSize)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, _utilJs.getUid)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, _extentJs.getForViewAndSize)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, _extentJs.isEmpty)(this.previousExtent_) && !(0, _extentJs.equals)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, _mapEventJsDefault.default)((0, _mapEventTypeJsDefault.default).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, _extentJs.createOrUpdateEmpty)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, _viewHintJsDefault.default).ANIMATING] && !frameState.viewHints[(0, _viewHintJsDefault.default).INTERACTING] && !(0, _extentJs.equals)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, _mapEventJsDefault.default)((0, _mapEventTypeJsDefault.default).MOVEEND, this, frameState));
                (0, _extentJs.clone)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, _mapEventJsDefault.default)((0, _mapEventTypeJsDefault.default).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, _mapEventTypeJsDefault.default).LOADSTART) || this.hasListener((0, _mapEventTypeJsDefault.default).LOADEND) || this.hasListener((0, _eventTypeJsDefault2.default).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, _groupJs.GroupEvent)('removelayer', oldLayerGroup));
        this.set((0, _mapPropertyJsDefault.default).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, _mapPropertyJsDefault.default).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, _mapPropertyJsDefault.default).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>|null} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, _viewJsDefault.default)) {
            this.set((0, _mapPropertyJsDefault.default).VIEW, view);
            return;
        }
        this.set((0, _mapPropertyJsDefault.default).VIEW, new (0, _viewJsDefault.default)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, _viewJsDefault.default)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            let width, height;
            if ((0, _domJs.isCanvas)(targetElement)) {
                const transform = targetElement.getContext('2d').getTransform();
                // Use scale components of the transform to calculate the size in CSS pixels
                width = targetElement.width / transform.a;
                height = targetElement.height / transform.d;
            } else {
                const computedStyle = getComputedStyle(targetElement);
                width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
                height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            }
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, _sizeJs.hasArea)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, _consoleJs.warn)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, _arrayJs.equals)(size, oldSize))) {
            this.updateViewportSize_(size);
            this.setSize(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, _groupJsDefault.default)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, _mapPropertyJsDefault.default).LAYERGROUP] = layerGroup;
    values[(0, _mapPropertyJsDefault.default).TARGET] = options.target;
    values[(0, _mapPropertyJsDefault.default).VIEW] = options.view instanceof (0, _viewJsDefault.default) ? options.view : new (0, _viewJsDefault.default)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, _collectionJsDefault.default)(options.controls.slice());
        else {
            (0, _assertsJs.assert)(typeof /** @type {?} */ options.controls.getArray === 'function', 'Expected `controls` to be an array or an `ol/Collection.js`');
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction.js").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, _collectionJsDefault.default)(options.interactions.slice());
        else {
            (0, _assertsJs.assert)(typeof /** @type {?} */ options.interactions.getArray === 'function', 'Expected `interactions` to be an array or an `ol/Collection.js`');
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, _collectionJsDefault.default)(options.overlays.slice());
        else {
            (0, _assertsJs.assert)(typeof /** @type {?} */ options.overlays.getArray === 'function', 'Expected `overlays` to be an array or an `ol/Collection.js`');
            overlays = options.overlays;
        }
    } else overlays = new (0, _collectionJsDefault.default)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
exports.default = Map;

},{"./Collection.js":"8dtMA","./CollectionEventType.js":"jVYia","./MapBrowserEvent.js":"1ZNR4","./MapBrowserEventHandler.js":"bB3ZL","./MapBrowserEventType.js":"dp3yB","./MapEvent.js":"b9nkH","./MapEventType.js":"aBTDg","./MapProperty.js":"o1ZkI","./Object.js":"lFhbz","./ObjectEventType.js":"i5oT2","./TileQueue.js":"b37tH","./View.js":"baCdC","./ViewHint.js":"fb2qR","./array.js":"2IuG2","./asserts.js":"csqTx","./console.js":"ltVs6","./control/defaults.js":"8Xvbb","./dom.js":"gfuif","./events.js":"Vqr1Z","./events/EventType.js":"79Bvl","./extent.js":"MPjK5","./functions.js":"5nAKV","./has.js":"hbGE6","./interaction/defaults.js":"gLSfG","./layer/Group.js":"6DIkJ","./layer/Layer.js":"aZQOw","./pointer/EventType.js":"kuPrT","./proj.js":"gN0IK","./render/EventType.js":"5YHp5","./renderer/Composite.js":"5dbSb","./size.js":"8DeXL","./transform.js":"7TqcG","./util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8dtMA":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Collection
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @classdesc
 * Events emitted by {@link module:ol/Collection~Collection} instances are instances of this
 * type.
 * @template T
 */ parcelHelpers.export(exports, "CollectionEvent", ()=>CollectionEvent);
var _collectionEventTypeJs = require("./CollectionEventType.js");
var _collectionEventTypeJsDefault = parcelHelpers.interopDefault(_collectionEventTypeJs);
var _objectJs = require("./Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _eventJs = require("./events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
/**
 * @enum {string}
 * @private
 */ const Property = {
    LENGTH: 'length'
};
class CollectionEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable.js").OnSignature<import("./ObjectEventType.js").Types|'change:length', import("./Object.js").ObjectEvent, Return> &
 *   import("./Observable.js").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|import("./ObjectEventType.js").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class Collection extends (0, _objectJsDefault.default) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ?? [];
        if (this.unique_) for(let i = 1, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get(Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new CollectionEvent((0, _collectionEventTypeJsDefault.default).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new CollectionEvent((0, _collectionEventTypeJsDefault.default).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new CollectionEvent((0, _collectionEventTypeJsDefault.default).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new CollectionEvent((0, _collectionEventTypeJsDefault.default).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set(Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i){
            if (array[i] === elem && i !== except) throw new Error('Duplicate item added to a unique collection');
        }
    }
}
exports.default = Collection;

},{"./CollectionEventType.js":"jVYia","./Object.js":"lFhbz","./events/Event.js":"5kI1G","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jVYia":[function(require,module,exports,__globalThis) {
/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: 'add',
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: 'remove'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"t8gd7":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"lFhbz":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Object
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @classdesc
 * Events emitted by {@link module:ol/Object~BaseObject} instances are instances of this type.
 */ parcelHelpers.export(exports, "ObjectEvent", ()=>ObjectEvent);
var _objectEventTypeJs = require("./ObjectEventType.js");
var _objectEventTypeJsDefault = parcelHelpers.interopDefault(_objectEventTypeJs);
var _observableJs = require("./Observable.js");
var _observableJsDefault = parcelHelpers.interopDefault(_observableJs);
var _eventJs = require("./events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _objJs = require("./obj.js");
var _utilJs = require("./util.js");
class ObjectEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable.js").OnSignature<import("./ObjectEventType.js").Types, ObjectEvent, Return> &
 *    import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|import("./ObjectEventType.js").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @api
 */ class BaseObject extends (0, _observableJsDefault.default) {
    /**
   * @param {NoInfer<Properties>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, _utilJs.getUid)(this);
        /**
     * @private
     * @type {Partial<NoInfer<Properties>>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {NoInfer<Properties>} Object.
   * @api
   */ getProperties() {
        return /** @type {NoInfer<Properties>} */ this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Partial<NoInfer<Properties>>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
        eventType = (0, _objectEventTypeJsDefault.default).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Partial<NoInfer<Properties>>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, _objJs.isEmpty)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
exports.default = BaseObject;

},{"./ObjectEventType.js":"i5oT2","./Observable.js":"jiDvm","./events/Event.js":"5kI1G","./obj.js":"GxveT","./util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"i5oT2":[function(require,module,exports,__globalThis) {
/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: 'propertychange'
}; /**
 * @typedef {'propertychange'} Types
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jiDvm":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Observable
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Removes an event listener using the key returned by `on()` or `once()`.
 * @param {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} key The key returned by `on()`
 *     or `once()` (or an array of keys).
 * @api
 */ parcelHelpers.export(exports, "unByKey", ()=>unByKey);
var _eventsJs = require("./events.js");
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _targetJs = require("./events/Target.js");
var _targetJsDefault = parcelHelpers.interopDefault(_targetJs);
/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event.js").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class Observable extends (0, _targetJsDefault.default) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events.js").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events.js").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, _eventTypeJsDefault.default).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event.js").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, _eventsJs.listen)(this, type[i], listener);
            return keys;
        }
        return (0, _eventsJs.listen)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event.js").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, _eventsJs.listenOnce)(this, type[i], listener);
        } else key = (0, _eventsJs.listenOnce)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event.js").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) unByKey(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event.js").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event.js").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event.js").default)): ?} listener The listener function.
 * @api
 */ Observable.prototype.un;
function unByKey(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, _eventsJs.unlistenByKey)(key[i]);
    else (0, _eventsJs.unlistenByKey)(/** @type {import("./events.js").EventsKey} */ key);
}
exports.default = Observable;

},{"./events.js":"Vqr1Z","./events/EventType.js":"79Bvl","./events/Target.js":"cPkjL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"Vqr1Z":[function(require,module,exports,__globalThis) {
/**
 * @module ol/events
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Key to use with {@link module:ol/Observable.unByKey}.
 * @typedef {Object} EventsKey
 * @property {ListenerFunction} listener Listener.
 * @property {import("./events/Target.js").EventTargetLike} target Target.
 * @property {string} type Type.
 * @api
 */ /**
 * Listener function. This function is called with an event object as argument.
 * When the function returns `false`, event propagation will stop.
 *
 * @typedef {function((Event|import("./events/Event.js").default)): (void|boolean)} ListenerFunction
 * @api
 */ /**
 * @typedef {Object} ListenerObject
 * @property {ListenerFunction} handleEvent HandleEvent listener function.
 */ /**
 * @typedef {ListenerFunction|ListenerObject} Listener
 */ /**
 * Registers an event listener on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * This function efficiently binds a `listener` to a `this` object, and returns
 * a key for use with {@link module:ol/events.unlistenByKey}.
 *
 * @param {import("./events/Target.js").EventTargetLike} target Event target.
 * @param {string} type Event type.
 * @param {ListenerFunction} listener Listener.
 * @param {Object} [thisArg] Object referenced by the `this` keyword in the
 *     listener. Default is the `target`.
 * @param {boolean} [once] If true, add the listener as one-off listener.
 * @return {EventsKey} Unique key for the listener.
 */ parcelHelpers.export(exports, "listen", ()=>listen);
/**
 * Registers a one-off event listener on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * This function efficiently binds a `listener` as self-unregistering listener
 * to a `this` object, and returns a key for use with
 * {@link module:ol/events.unlistenByKey} in case the listener needs to be
 * unregistered before it is called.
 *
 * When {@link module:ol/events.listen} is called with the same arguments after this
 * function, the self-unregistering listener will be turned into a permanent
 * listener.
 *
 * @param {import("./events/Target.js").EventTargetLike} target Event target.
 * @param {string} type Event type.
 * @param {ListenerFunction} listener Listener.
 * @param {Object} [thisArg] Object referenced by the `this` keyword in the
 *     listener. Default is the `target`.
 * @return {EventsKey} Key for unlistenByKey.
 */ parcelHelpers.export(exports, "listenOnce", ()=>listenOnce);
/**
 * Unregisters event listeners on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * The argument passed to this function is the key returned from
 * {@link module:ol/events.listen} or {@link module:ol/events.listenOnce}.
 *
 * @param {EventsKey} key The key.
 */ parcelHelpers.export(exports, "unlistenByKey", ()=>unlistenByKey);
var _objJs = require("./obj.js");
function listen(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @param {Event|import('./events/Event.js').default} event The event
     * @return {void|boolean} When the function returns `false`, event propagation will stop.
     * @this {typeof target}
     */ listener = function(event) {
            target.removeEventListener(type, listener);
            return originalListener.call(thisArg ?? this, event);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function listenOnce(target, type, listener, thisArg) {
    return listen(target, type, listener, thisArg, true);
}
function unlistenByKey(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, _objJs.clear)(key);
    }
}

},{"./obj.js":"GxveT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"GxveT":[function(require,module,exports,__globalThis) {
/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clear", ()=>clear);
/**
 * Determine if an object has any properties.
 * @param {Object} object The object to check.
 * @return {boolean} The object is empty.
 */ parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
function clear(object) {
    for(const property in object)delete object[property];
}
function isEmpty(object) {
    let property;
    for(property in object)return false;
    return !property;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"79Bvl":[function(require,module,exports,__globalThis) {
/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: 'change',
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cPkjL":[function(require,module,exports,__globalThis) {
/**
 * @module ol/events/Target
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _disposableJs = require("../Disposable.js");
var _disposableJsDefault = parcelHelpers.interopDefault(_disposableJs);
var _functionsJs = require("../functions.js");
var _objJs = require("../obj.js");
var _eventJs = require("./Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class Target extends (0, _disposableJsDefault.default) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === 'string';
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, _eventJsDefault.default)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, _functionsJs.VOID));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, _objJs.clear)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, _functionsJs.VOID);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
exports.default = Target;

},{"../Disposable.js":"7LWtn","../functions.js":"5nAKV","../obj.js":"GxveT","./Event.js":"5kI1G","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7LWtn":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
exports.default = Disposable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5nAKV":[function(require,module,exports,__globalThis) {
/**
 * @module ol/functions
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Always returns true.
 * @return {boolean} true.
 */ parcelHelpers.export(exports, "TRUE", ()=>TRUE);
/**
 * Always returns false.
 * @return {boolean} false.
 */ parcelHelpers.export(exports, "FALSE", ()=>FALSE);
/**
 * A reusable function, used e.g. as a default for callbacks.
 *
 * @return {void} Nothing.
 */ parcelHelpers.export(exports, "VOID", ()=>VOID);
/**
 * Wrap a function in another function that remembers the last return.  If the
 * returned function is called twice in a row with the same arguments and the same
 * this object, it will return the value from the first call in the second call.
 *
 * @param {function(...any): ReturnType} fn The function to memoize.
 * @return {function(...any): ReturnType} The memoized function.
 * @template ReturnType
 */ parcelHelpers.export(exports, "memoizeOne", ()=>memoizeOne);
/**
 * @template T
 * @param {function(): (T | Promise<T>)} getter A function that returns a value or a promise for a value.
 * @return {Promise<T>} A promise for the value.
 */ parcelHelpers.export(exports, "toPromise", ()=>toPromise);
var _arrayJs = require("./array.js");
function TRUE() {
    return true;
}
function FALSE() {
    return false;
}
function VOID() {}
function memoizeOne(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, _arrayJs.equals)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function toPromise(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}

},{"./array.js":"2IuG2","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2IuG2":[function(require,module,exports,__globalThis) {
/**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "binarySearch", ()=>binarySearch);
/**
 * Compare function sorting arrays in ascending order.  Safe to use for numeric values.
 * @param {*} a The first object to be compared.
 * @param {*} b The second object to be compared.
 * @return {number} A negative number, zero, or a positive number as the first
 *     argument is less than, equal to, or greater than the second.
 */ parcelHelpers.export(exports, "ascending", ()=>ascending);
/**
 * Compare function sorting arrays in descending order.  Safe to use for numeric values.
 * @param {*} a The first object to be compared.
 * @param {*} b The second object to be compared.
 * @return {number} A negative number, zero, or a positive number as the first
 *     argument is greater than, equal to, or less than the second.
 */ parcelHelpers.export(exports, "descending", ()=>descending);
/**
 * {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution} can use a function
 * of this type to determine which nearest resolution to use.
 *
 * This function takes a `{number}` representing a value between two array entries,
 * a `{number}` representing the value of the nearest higher entry and
 * a `{number}` representing the value of the nearest lower entry
 * as arguments and returns a `{number}`. If a negative number or zero is returned
 * the lower value will be used, if a positive number is returned the higher value
 * will be used.
 * @typedef {function(number, number, number): number} NearestDirectionFunction
 * @api
 */ /**
 * @param {Array<number>} arr Array in descending order.
 * @param {number} target Target.
 * @param {number|NearestDirectionFunction} direction
 *    0 means return the nearest,
 *    > 0 means return the largest nearest,
 *    < 0 means return the smallest nearest.
 * @return {number} Index.
 */ parcelHelpers.export(exports, "linearFindNearest", ()=>linearFindNearest);
/**
 * @param {Array<*>} arr Array.
 * @param {number} begin Begin index.
 * @param {number} end End index.
 */ parcelHelpers.export(exports, "reverseSubArray", ()=>reverseSubArray);
/**
 * @param {Array<VALUE>} arr The array to modify.
 * @param {!Array<VALUE>|VALUE} data The elements or arrays of elements to add to arr.
 * @template VALUE
 */ parcelHelpers.export(exports, "extend", ()=>extend);
/**
 * @param {Array<VALUE>} arr The array to modify.
 * @param {VALUE} obj The element to remove.
 * @template VALUE
 * @return {boolean} If the element was removed.
 */ parcelHelpers.export(exports, "remove", ()=>remove);
/**
 * @param {Array<any>|Uint8ClampedArray} arr1 The first array to compare.
 * @param {Array<any>|Uint8ClampedArray} arr2 The second array to compare.
 * @return {boolean} Whether the two arrays are equal.
 */ parcelHelpers.export(exports, "equals", ()=>equals);
/**
 * Sort the passed array such that the relative order of equal elements is preserved.
 * See https://en.wikipedia.org/wiki/Sorting_algorithm#Stability for details.
 * @param {Array<*>} arr The array to sort (modifies original).
 * @param {!function(*, *): number} compareFnc Comparison function.
 * @api
 * @deprecated
 */ parcelHelpers.export(exports, "stableSort", ()=>stableSort);
/**
 * @param {Array<*>} arr The array to test.
 * @param {Function} [func] Comparison function.
 * @param {boolean} [strict] Strictly sorted (default false).
 * @return {boolean} Return index.
 */ parcelHelpers.export(exports, "isSorted", ()=>isSorted);
function binarySearch(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || ascending;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function ascending(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function descending(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function linearFindNearest(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === 'function') {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function reverseSubArray(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function extend(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function remove(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function equals(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function stableSort(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function isSorted(arr, func, strict) {
    const compare = func || ascending;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5kI1G":[function(require,module,exports,__globalThis) {
/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Event|import("./Event.js").default} evt Event
 */ parcelHelpers.export(exports, "stopPropagation", ()=>stopPropagation);
/**
 * @param {Event|import("./Event.js").default} evt Event
 */ parcelHelpers.export(exports, "preventDefault", ()=>preventDefault);
class BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function stopPropagation(evt) {
    evt.stopPropagation();
}
function preventDefault(evt) {
    evt.preventDefault();
}
exports.default = BaseEvent;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9Y20j":[function(require,module,exports,__globalThis) {
/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abstract", ()=>abstract);
/**
 * Gets a unique ID for an object. This mutates the object so that further calls
 * with the same object as a parameter returns the same value. Unique IDs are generated
 * as a strictly increasing sequence. Adapted from goog.getUid.
 *
 * @param {Object} obj The object to get the unique ID for.
 * @return {string} The unique ID for the object.
 * @api
 */ parcelHelpers.export(exports, "getUid", ()=>getUid);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
function abstract() {
    throw new Error('Unimplemented abstract method.');
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let uidCounter_ = 0;
function getUid(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++uidCounter_));
}
const VERSION = '10.10.0';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1ZNR4":[function(require,module,exports,__globalThis) {
/**
 * @module ol/MapBrowserEvent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapEventJs = require("./MapEvent.js");
var _mapEventJsDefault = parcelHelpers.interopDefault(_mapEventJs);
/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {PointerEvent|KeyboardEvent|WheelEvent} [EVENT=PointerEvent|KeyboardEvent|WheelEvent]
 */ class MapBrowserEvent extends (0, _mapEventJsDefault.default) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
exports.default = MapBrowserEvent;

},{"./MapEvent.js":"b9nkH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b9nkH":[function(require,module,exports,__globalThis) {
/**
 * @module ol/MapEvent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventJs = require("./events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class MapEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
exports.default = MapEvent;

},{"./events/Event.js":"5kI1G","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bB3ZL":[function(require,module,exports,__globalThis) {
/**
 * @module ol/MapBrowserEventHandler
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapBrowserEventJs = require("./MapBrowserEvent.js");
var _mapBrowserEventJsDefault = parcelHelpers.interopDefault(_mapBrowserEventJs);
var _mapBrowserEventTypeJs = require("./MapBrowserEventType.js");
var _mapBrowserEventTypeJsDefault = parcelHelpers.interopDefault(_mapBrowserEventTypeJs);
var _eventsJs = require("./events.js");
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _targetJs = require("./events/Target.js");
var _targetJsDefault = parcelHelpers.interopDefault(_targetJs);
var _hasJs = require("./has.js");
var _eventTypeJs1 = require("./pointer/EventType.js");
var _eventTypeJsDefault1 = parcelHelpers.interopDefault(_eventTypeJs1);
class MapBrowserEventHandler extends (0, _targetJsDefault.default) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, _eventsJs.listen)(element, (0, _eventTypeJsDefault1.default).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, _eventsJs.listen)(element, (0, _eventTypeJsDefault1.default).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, _eventTypeJsDefault.default).TOUCHMOVE, this.boundHandleTouchMove_, (0, _hasJs.PASSIVE_EVENT_LISTENERS) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERUP || event.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERDOWN || event.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, _eventsJs.unlistenByKey));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, 'target', {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, _eventsJs.listen)(doc, (0, _mapBrowserEventTypeJsDefault.default).POINTERMOVE, this.handlePointerMove_, this), (0, _eventsJs.listen)(doc, (0, _mapBrowserEventTypeJsDefault.default).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, _eventsJs.listen)(this.element_, (0, _mapBrowserEventTypeJsDefault.default).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, _eventsJs.listen)(this.element_.getRootNode(), (0, _mapBrowserEventTypeJsDefault.default).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, _mapBrowserEventJsDefault.default)((0, _mapBrowserEventTypeJsDefault.default).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, _eventsJs.unlistenByKey)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, _eventTypeJsDefault.default).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, _eventsJs.unlistenByKey)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, _eventsJs.unlistenByKey));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
exports.default = MapBrowserEventHandler;

},{"./MapBrowserEvent.js":"1ZNR4","./MapBrowserEventType.js":"dp3yB","./events.js":"Vqr1Z","./events/EventType.js":"79Bvl","./events/Target.js":"cPkjL","./has.js":"hbGE6","./pointer/EventType.js":"kuPrT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dp3yB":[function(require,module,exports,__globalThis) {
/**
 * @module ol/MapBrowserEventType
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
/**
 * Constants for event names.
 * @enum {string}
 */ exports.default = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: 'singleclick',
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, _eventTypeJsDefault.default).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, _eventTypeJsDefault.default).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: 'pointerdrag',
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
}; /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */ 

},{"./events/EventType.js":"79Bvl","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hbGE6":[function(require,module,exports,__globalThis) {
/**
 * @module ol/has
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SAFARI", ()=>SAFARI);
parcelHelpers.export(exports, "SAFARI_BUG_237906", ()=>SAFARI_BUG_237906);
parcelHelpers.export(exports, "WEBKIT", ()=>WEBKIT);
parcelHelpers.export(exports, "MAC", ()=>MAC);
parcelHelpers.export(exports, "DEVICE_PIXEL_RATIO", ()=>DEVICE_PIXEL_RATIO);
parcelHelpers.export(exports, "WORKER_OFFSCREEN_CANVAS", ()=>WORKER_OFFSCREEN_CANVAS);
parcelHelpers.export(exports, "IMAGE_DECODE", ()=>IMAGE_DECODE);
parcelHelpers.export(exports, "CREATE_IMAGE_BITMAP", ()=>CREATE_IMAGE_BITMAP);
parcelHelpers.export(exports, "PASSIVE_EVENT_LISTENERS", ()=>PASSIVE_EVENT_LISTENERS);
const ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const SAFARI = ua.includes('safari') && !ua.includes('chrom');
const SAFARI_BUG_237906 = SAFARI && (ua.includes('version/15.4') || /cpu (os|iphone os) 15_4 like mac os x/.test(ua));
const WEBKIT = ua.includes('webkit') && !ua.includes('edge');
const MAC = ua.includes('macintosh');
const DEVICE_PIXEL_RATIO = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
const WORKER_OFFSCREEN_CANVAS = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
const IMAGE_DECODE = typeof Image !== 'undefined' && Image.prototype.decode;
const CREATE_IMAGE_BITMAP = typeof createImageBitmap === 'function';
const PASSIVE_EVENT_LISTENERS = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener('_', null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener('_', null, options);
    } catch  {
    // passive not supported
    }
    return passive;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kuPrT":[function(require,module,exports,__globalThis) {
/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aBTDg":[function(require,module,exports,__globalThis) {
/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: 'movestart',
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: 'moveend',
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: 'loadstart',
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: 'loadend'
}; /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"o1ZkI":[function(require,module,exports,__globalThis) {
/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b37tH":[function(require,module,exports,__globalThis) {
/**
 * @module ol/TileQueue
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {import('./Map.js').FrameState} frameState Frame state.
 * @param {import("./Tile.js").default} tile Tile.
 * @param {string} tileSourceKey Tile source key.
 * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
 * @param {number} tileResolution Tile resolution.
 * @return {number} Tile priority.
 */ parcelHelpers.export(exports, "getTilePriority", ()=>getTilePriority);
var _tileStateJs = require("./TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _priorityQueueJs = require("./structs/PriorityQueue.js");
var _priorityQueueJsDefault = parcelHelpers.interopDefault(_priorityQueueJs);
/**
 * @typedef {function(import("./Tile.js").default, string, import('./tilecoord.js').TileCoord, number): number} PriorityFunction
 */ /**
 * @typedef {[import('./Tile.js').default, string, import('./tilecoord.js').TileCoord, number]} TileQueueElement
 */ /**
 * @extends PriorityQueue<TileQueueElement>}
 */ class TileQueue extends (0, _priorityQueueJsDefault.default) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super((element)=>tilePriorityFunction.apply(null, element), (element)=>element[0].getKey());
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {TileQueueElement} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, _eventTypeJsDefault.default).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, _tileStateJsDefault.default).LOADED || state === (0, _tileStateJsDefault.default).ERROR || state === (0, _tileStateJsDefault.default).EMPTY) {
            if (state !== (0, _tileStateJsDefault.default).ERROR) tile.removeEventListener((0, _eventTypeJsDefault.default).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, _tileStateJsDefault.default).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
exports.default = TileQueue;
function getTilePriority(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, _priorityQueueJs.DROP;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, _priorityQueueJs.DROP;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}

},{"./TileState.js":"8OlGt","./events/EventType.js":"79Bvl","./structs/PriorityQueue.js":"anQn7","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8OlGt":[function(require,module,exports,__globalThis) {
/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"anQn7":[function(require,module,exports,__globalThis) {
/**
 * @module ol/structs/PriorityQueue
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROP", ()=>DROP);
var _assertsJs = require("../asserts.js");
var _objJs = require("../obj.js");
const DROP = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, _objJs.clear)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, _assertsJs.assert)(!(this.keyFunction_(element) in this.queuedElements_), 'Tried to enqueue an `element` that was already added to the queue');
        const priority = this.priorityFunction_(element);
        if (priority != DROP) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == DROP) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
exports.default = PriorityQueue;

},{"../asserts.js":"csqTx","../obj.js":"GxveT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"csqTx":[function(require,module,exports,__globalThis) {
/**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
function assert(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"baCdC":[function(require,module,exports,__globalThis) {
/**
 * @module ol/View
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {ViewOptions} options View options.
 * @return {import("./centerconstraint.js").Type} The constraint.
 */ parcelHelpers.export(exports, "createCenterConstraint", ()=>createCenterConstraint);
/**
 * @param {ViewOptions} options View options.
 * @return {{constraint: import("./resolutionconstraint.js").Type, maxResolution: number,
 *     minResolution: number, minZoom: number, zoomFactor: number}} The constraint.
 */ parcelHelpers.export(exports, "createResolutionConstraint", ()=>createResolutionConstraint);
/**
 * @param {ViewOptions} options View options.
 * @return {import("./rotationconstraint.js").Type} Rotation constraint.
 */ parcelHelpers.export(exports, "createRotationConstraint", ()=>createRotationConstraint);
/**
 * Determine if an animation involves no view change.
 * @param {Animation} animation The animation.
 * @return {boolean} The animation involves no view change.
 */ parcelHelpers.export(exports, "isNoopAnimation", ()=>isNoopAnimation);
/**
 * @typedef {function(ViewOptions):ViewOptions} ViewTransform
 */ /**
 * Adds higher resolutions.
 * @param {number} num The number of higher resolution levels to use.
 * @return {ViewTransform} A view transform.
 */ parcelHelpers.export(exports, "withHigherResolutions", ()=>withHigherResolutions);
/**
 * Adds lower resolutions.
 * @param {number} num The number of lower resolution levels to use.
 * @return {ViewTransform} A view transform.
 * @api
 */ parcelHelpers.export(exports, "withLowerResolutions", ()=>withLowerResolutions);
/**
 * Applies a center based on the extent.
 * @return {ViewTransform} A view transform.
 * @api
 */ parcelHelpers.export(exports, "withExtentCenter", ()=>withExtentCenter);
/**
 * Applies a zoom level.
 * @param {number} z The zoom level.
 * @return {ViewTransform} A view transform.
 * @api
 */ parcelHelpers.export(exports, "withZoom", ()=>withZoom);
/**
 * Applies a series of transforms to a view that is resolved from a source.
 * @param {import("./source/Source.js").default} source The source.
 * @param {...ViewTransform} transforms The transforms to apply.
 * @return {Promise<ViewOptions>} The view options.
 * @api
 */ parcelHelpers.export(exports, "getView", ()=>getView);
var _objectJs = require("./Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _viewHintJs = require("./ViewHint.js");
var _viewHintJsDefault = parcelHelpers.interopDefault(_viewHintJs);
var _viewPropertyJs = require("./ViewProperty.js");
var _viewPropertyJsDefault = parcelHelpers.interopDefault(_viewPropertyJs);
var _arrayJs = require("./array.js");
var _assertsJs = require("./asserts.js");
var _centerconstraintJs = require("./centerconstraint.js");
var _coordinateJs = require("./coordinate.js");
var _easingJs = require("./easing.js");
var _extentJs = require("./extent.js");
var _functionsJs = require("./functions.js");
var _polygonJs = require("./geom/Polygon.js");
var _mathJs = require("./math.js");
var _projJs = require("./proj.js");
var _resolutionconstraintJs = require("./resolutionconstraint.js");
var _rotationconstraintJs = require("./rotationconstraint.js");
var _commonJs = require("./tilegrid/common.js");
/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType.js").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable.js").OnSignature<ViewObjectEventTypes, import("./Object.js").ObjectEvent, Return> &
 *   import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 * @extends {BaseObject<ViewOptions>}
 */ class View extends (0, _objectJsDefault.default) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, _projJs.createProjection)(options.projection, 'EPSG:3857');
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, _projJs.disableCoordinateWarning)();
        if (options.center) options.center = (0, _projJs.fromUserCoordinate)(options.center, this.projection_);
        if (options.extent) options.extent = (0, _projJs.fromUserExtent)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, _viewPropertyJsDefault.default)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = createResolutionConstraint(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = createCenterConstraint(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = createRotationConstraint(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, _projJs.fromUserCoordinate)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, _projJs.fromUserCoordinate)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, _easingJs.inAndOut),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, _mathJs.modulo)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if (isNoopAnimation(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, _viewHintJsDefault.default).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, _viewHintJsDefault.default).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, _viewHintJsDefault.default).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, _viewHintJsDefault.default).ANIMATING, -this.hints_[(0, _viewHintJsDefault.default).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, _mathJs.modulo)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, _viewHintJsDefault.default).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, _coordinateJs.rotate)(center, rotation - this.getRotation());
            (0, _coordinateJs.add)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, _projJs.toUserCoordinate)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, _viewPropertyJsDefault.default).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get('constrainResolution');
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, _projJs.toUserExtent)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, _assertsJs.assert)(center, 'The view center is not defined');
        const resolution = /** @type {!number} */ this.getResolution();
        (0, _assertsJs.assert)(resolution !== undefined, 'The view resolution is not defined');
        const rotation = /** @type {!number} */ this.getRotation();
        (0, _assertsJs.assert)(rotation !== undefined, 'The view rotation is not defined');
        return (0, _extentJs.getForViewAndSize)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, _viewPropertyJsDefault.default).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, _projJs.fromUserExtent)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, _extentJs.getWidth)(extent) / size[0];
        const yResolution = (0, _extentJs.getHeight)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, _viewPropertyJsDefault.default).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, _arrayJs.linearFindNearest)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_?.length) {
            if (this.resolutions_.length === 1) return this.resolutions_[0];
            const baseLevel = (0, _mathJs.clamp)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, _mathJs.clamp)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, _assertsJs.assert)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 'Invalid extent or geometry provided as `geometry`');
        if (Array.isArray(geometryOrExtent)) {
            (0, _assertsJs.assert)(!(0, _extentJs.isEmpty)(geometryOrExtent), 'Cannot fit empty extent provided as `geometry`');
            const extent = (0, _projJs.fromUserExtent)(geometryOrExtent, this.getProjection());
            geometry = (0, _polygonJs.fromExtent)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            const extent = (0, _projJs.fromUserExtent)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, _polygonJs.fromExtent)(extent);
            geometry.rotate(this.getRotation(), (0, _extentJs.getCenter)(extent));
        } else {
            const userProjection = (0, _projJs.getUserProjection)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent.js").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, _extentJs.getCenter)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, _functionsJs.VOID);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, _projJs.fromUserCoordinate)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal(calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, _projJs.toUserCoordinate)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, _projJs.fromUserCoordinate)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, _projJs.fromUserCoordinate)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, _projJs.fromUserCoordinate)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, _viewPropertyJsDefault.default).ROTATION) !== newRotation) this.set((0, _viewPropertyJsDefault.default).ROTATION, newRotation);
        if (this.get((0, _viewPropertyJsDefault.default).RESOLUTION) !== newResolution) {
            this.set((0, _viewPropertyJsDefault.default).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, _viewPropertyJsDefault.default).CENTER) || !(0, _coordinateJs.equals)(this.get((0, _viewPropertyJsDefault.default).CENTER), newCenter)) this.set((0, _viewPropertyJsDefault.default).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, _coordinateJs.equals)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, _easingJs.easeOut),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, _viewHintJsDefault.default).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, _projJs.fromUserCoordinate)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, _viewHintJsDefault.default).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function createCenterConstraint(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, _centerconstraintJs.createExtent)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, _projJs.createProjection)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, _centerconstraintJs.createExtent)(extent, false, false);
    }
    return 0, _centerconstraintJs.none;
}
function createResolutionConstraint(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, _projJs.createProjection)(options.projection, 'EPSG:3857');
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, _resolutionconstraintJs.createSnapToResolutions)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, _resolutionconstraintJs.createMinMaxResolution)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, _projJs.METERS_PER_UNIT).degrees / projection.getMetersPerUnit() : Math.max((0, _extentJs.getWidth)(projExtent), (0, _extentJs.getHeight)(projExtent));
        const defaultMaxResolution = size / (0, _commonJs.DEFAULT_TILE_SIZE) / Math.pow(defaultZoomFactor, DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, _resolutionconstraintJs.createSnapToPower)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, _resolutionconstraintJs.createMinMaxResolution)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function createRotationConstraint(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, _rotationconstraintJs.createSnapToZero)();
        if (constrainRotation === false) return 0, _rotationconstraintJs.none;
        if (typeof constrainRotation === 'number') return (0, _rotationconstraintJs.createSnapToN)(constrainRotation);
        return 0, _rotationconstraintJs.none;
    }
    return 0, _rotationconstraintJs.disable;
}
function isNoopAnimation(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, _coordinateJs.equals)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
exports.default = View;
function withHigherResolutions(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const highest = resolutions[resolutions.length - 1];
        for(let i = 0; i < num; ++i)resolutions.push(highest / Math.pow(2, i + 1));
        return {
            ...options,
            resolutions
        };
    };
}
function withLowerResolutions(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const lowest = resolutions[0];
        for(let i = 0; i < num; ++i)resolutions.unshift(lowest * Math.pow(2, i + 1));
        return {
            ...options,
            resolutions
        };
    };
}
function withExtentCenter() {
    return function(options) {
        if (!options.extent) return options;
        const center = (0, _extentJs.getCenter)(options.extent);
        const newOptions = {
            ...options,
            center
        };
        delete newOptions.extent;
        return newOptions;
    };
}
function withZoom(z) {
    return function(options) {
        return {
            ...options,
            zoom: z
        };
    };
}
async function getView(source, ...transforms) {
    let config = await source.getView();
    for (const transform of transforms)config = transform(config);
    return config;
}

},{"./Object.js":"lFhbz","./ViewHint.js":"fb2qR","./ViewProperty.js":"lOcT0","./array.js":"2IuG2","./asserts.js":"csqTx","./centerconstraint.js":"3JUnq","./coordinate.js":"9bcSP","./easing.js":"1AzsJ","./extent.js":"MPjK5","./functions.js":"5nAKV","./geom/Polygon.js":"3zws5","./math.js":"b3dOZ","./proj.js":"gN0IK","./resolutionconstraint.js":"7p0AI","./rotationconstraint.js":"faoMn","./tilegrid/common.js":"bFvtm","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fb2qR":[function(require,module,exports,__globalThis) {
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    ANIMATING: 0,
    INTERACTING: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lOcT0":[function(require,module,exports,__globalThis) {
/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3JUnq":[function(require,module,exports,__globalThis) {
/**
 * @module ol/centerconstraint
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {function((import("./coordinate.js").Coordinate|undefined), number, import("./size.js").Size, boolean=, Array<number>=): (import("./coordinate.js").Coordinate|undefined)} Type
 */ /**
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {boolean} onlyCenter If true, the constraint will only apply to the view center.
 * @param {boolean} smooth If true, the view will be able to go slightly out of the given extent
 * (only during interaction and animation).
 * @return {Type} The constraint.
 */ parcelHelpers.export(exports, "createExtent", ()=>createExtent);
/**
 * @param {import("./coordinate.js").Coordinate} [center] Center.
 * @return {import("./coordinate.js").Coordinate|undefined} Center.
 */ parcelHelpers.export(exports, "none", ()=>none);
var _mathJs = require("./math.js");
function createExtent(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, _mathJs.clamp)(center[0], minX, maxX);
        let y = (0, _mathJs.clamp)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function none(center) {
    return center;
}

},{"./math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b3dOZ":[function(require,module,exports,__globalThis) {
/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
/**
 * Returns the square of the closest distance between the point (x, y) and the
 * line segment (x1, y1) to (x2, y2).
 * @param {number} x X.
 * @param {number} y Y.
 * @param {number} x1 X1.
 * @param {number} y1 Y1.
 * @param {number} x2 X2.
 * @param {number} y2 Y2.
 * @return {number} Squared distance.
 */ parcelHelpers.export(exports, "squaredSegmentDistance", ()=>squaredSegmentDistance);
/**
 * Returns the square of the distance between the points (x1, y1) and (x2, y2).
 * @param {number} x1 X1.
 * @param {number} y1 Y1.
 * @param {number} x2 X2.
 * @param {number} y2 Y2.
 * @return {number} Squared distance.
 */ parcelHelpers.export(exports, "squaredDistance", ()=>squaredDistance);
/**
 * Solves system of linear equations using Gaussian elimination method.
 *
 * @param {Array<Array<number>>} mat Augmented matrix (n x n + 1 column)
 *                                     in row-major order.
 * @return {Array<number>|null} The resulting vector.
 */ parcelHelpers.export(exports, "solveLinearSystem", ()=>solveLinearSystem);
/**
 * Converts radians to to degrees.
 *
 * @param {number} angleInRadians Angle in radians.
 * @return {number} Angle in degrees.
 */ parcelHelpers.export(exports, "toDegrees", ()=>toDegrees);
/**
 * Converts degrees to radians.
 *
 * @param {number} angleInDegrees Angle in degrees.
 * @return {number} Angle in radians.
 */ parcelHelpers.export(exports, "toRadians", ()=>toRadians);
/**
 * Returns the modulo of a / b, depending on the sign of b.
 *
 * @param {number} a Dividend.
 * @param {number} b Divisor.
 * @return {number} Modulo.
 */ parcelHelpers.export(exports, "modulo", ()=>modulo);
/**
 * Calculates the linearly interpolated value of x between a and b.
 *
 * @param {number} a Number
 * @param {number} b Number
 * @param {number} x Value to be interpolated.
 * @return {number} Interpolated value.
 */ parcelHelpers.export(exports, "lerp", ()=>lerp);
/**
 * Returns a number with a limited number of decimal digits.
 * @param {number} n The input number.
 * @param {number} decimals The maximum number of decimal digits.
 * @return {number} The input number with a limited number of decimal digits.
 */ parcelHelpers.export(exports, "toFixed", ()=>toFixed);
/**
 * Rounds a number to the nearest integer value considering only the given number
 * of decimal digits (with rounding on the final digit).
 * @param {number} n The input number.
 * @param {number} decimals The maximum number of decimal digits.
 * @return {number} The nearest integer.
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Rounds a number to the next smaller integer considering only the given number
 * of decimal digits (with rounding on the final digit).
 * @param {number} n The input number.
 * @param {number} decimals The maximum number of decimal digits.
 * @return {number} The next smaller integer.
 */ parcelHelpers.export(exports, "floor", ()=>floor);
/**
 * Rounds a number to the next bigger integer considering only the given number
 * of decimal digits (with rounding on the final digit).
 * @param {number} n The input number.
 * @param {number} decimals The maximum number of decimal digits.
 * @return {number} The next bigger integer.
 */ parcelHelpers.export(exports, "ceil", ()=>ceil);
/**
 * Wraps a number between some minimum and maximum values.
 * @param {number} n The number to wrap.
 * @param {number} min The minimum of the range (inclusive).
 * @param {number} max The maximum of the range (exclusive).
 * @return {number} The wrapped number.
 */ parcelHelpers.export(exports, "wrap", ()=>wrap);
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function squaredSegmentDistance(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return squaredDistance(x, y, x1, y1);
}
function squaredDistance(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function solveLinearSystem(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function toDegrees(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function toRadians(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function modulo(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function lerp(a, b, x) {
    return a + x * (b - a);
}
function toFixed(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function round(n, decimals) {
    return Math.round(toFixed(n, decimals));
}
function floor(n, decimals) {
    return Math.floor(toFixed(n, decimals));
}
function ceil(n, decimals) {
    return Math.ceil(toFixed(n, decimals));
}
function wrap(n, min, max) {
    if (n >= min && n < max) return n;
    const range = max - min;
    return ((n - min) % range + range) % range + min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9bcSP":[function(require,module,exports,__globalThis) {
/**
 * @module ol/coordinate
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An array of numbers representing an `xy`, `xyz` or `xyzm` coordinate.
 * Example: `[16, 48]`.
 * @typedef {Array<number>} Coordinate
 * @api
 */ /**
 * A function that takes a {@link module:ol/coordinate~Coordinate} and
 * transforms it into a `{string}`.
 *
 * @typedef {function((Coordinate|undefined)): string} CoordinateFormat
 * @api
 */ /**
 * Add `delta` to `coordinate`. `coordinate` is modified in place and returned
 * by the function.
 *
 * Example:
 *
 *     import {add} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     add(coord, [-2, 4]);
 *     // coord is now [5.85, 51.983333]
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {Coordinate} delta Delta.
 * @return {Coordinate} The input coordinate adjusted by
 * the given delta.
 * @api
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Calculates the point closest to the passed coordinate on the passed circle.
 *
 * @param {Coordinate} coordinate The coordinate.
 * @param {import("./geom/Circle.js").default} circle The circle.
 * @return {Coordinate} Closest point on the circumference.
 */ parcelHelpers.export(exports, "closestOnCircle", ()=>closestOnCircle);
/**
 * Calculates the point closest to the passed coordinate on the passed segment.
 * This is the foot of the perpendicular of the coordinate to the segment when
 * the foot is on the segment, or the closest segment coordinate when the foot
 * is outside the segment.
 *
 * @param {Coordinate} coordinate The coordinate.
 * @param {Array<Coordinate>} segment The two coordinates
 * of the segment.
 * @return {Coordinate} The foot of the perpendicular of
 * the coordinate to the segment.
 */ parcelHelpers.export(exports, "closestOnSegment", ()=>closestOnSegment);
/**
 * Returns a {@link module:ol/coordinate~CoordinateFormat} function that can be
 * used to format
 * a {Coordinate} to a string.
 *
 * Example without specifying the fractional digits:
 *
 *     import {createStringXY} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const stringifyFunc = createStringXY();
 *     const out = stringifyFunc(coord);
 *     // out is now '8, 48'
 *
 * Example with explicitly specifying 2 fractional digits:
 *
 *     import {createStringXY} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const stringifyFunc = createStringXY(2);
 *     const out = stringifyFunc(coord);
 *     // out is now '7.85, 47.98'
 *
 * @param {number} [fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {CoordinateFormat} Coordinate format.
 * @api
 */ parcelHelpers.export(exports, "createStringXY", ()=>createStringXY);
/**
 * @param {string} hemispheres Hemispheres.
 * @param {number} degrees Degrees.
 * @param {number} [fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} String.
 */ parcelHelpers.export(exports, "degreesToStringHDMS", ()=>degreesToStringHDMS);
/**
 * Transforms the given {@link module:ol/coordinate~Coordinate} to a string
 * using the given string template. The strings `{x}` and `{y}` in the template
 * will be replaced with the first and second coordinate values respectively.
 *
 * Example without specifying the fractional digits:
 *
 *     import {format} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const template = 'Coordinate is ({x}|{y}).';
 *     const out = format(coord, template);
 *     // out is now 'Coordinate is (8|48).'
 *
 * Example explicitly specifying the fractional digits:
 *
 *     import {format} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const template = 'Coordinate is ({x}|{y}).';
 *     const out = format(coord, template, 2);
 *     // out is now 'Coordinate is (7.85|47.98).'
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {string} template A template string with `{x}` and `{y}` placeholders
 *     that will be replaced by first and second coordinate values.
 * @param {number} [fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} Formatted coordinate.
 * @api
 */ parcelHelpers.export(exports, "format", ()=>format);
/**
 * @param {Coordinate} coordinate1 First coordinate.
 * @param {Coordinate} coordinate2 Second coordinate.
 * @return {boolean} The two coordinates are equal.
 */ parcelHelpers.export(exports, "equals", ()=>equals);
/**
 * Rotate `coordinate` by `angle`. `coordinate` is modified in place and
 * returned by the function.
 *
 * Example:
 *
 *     import {rotate} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const rotateRadians = Math.PI / 2; // 90 degrees
 *     rotate(coord, rotateRadians);
 *     // coord is now [-47.983333, 7.85]
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} angle Angle in radian.
 * @return {Coordinate} Coordinate.
 * @api
 */ parcelHelpers.export(exports, "rotate", ()=>rotate);
/**
 * Scale `coordinate` by `scale`. `coordinate` is modified in place and returned
 * by the function.
 *
 * Example:
 *
 *     import {scale as scaleCoordinate} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const scale = 1.2;
 *     scaleCoordinate(coord, scale);
 *     // coord is now [9.42, 57.5799996]
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} scale Scale factor.
 * @return {Coordinate} Coordinate.
 */ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * @param {Coordinate} coord1 First coordinate.
 * @param {Coordinate} coord2 Second coordinate.
 * @return {number} Squared distance between coord1 and coord2.
 */ parcelHelpers.export(exports, "squaredDistance", ()=>squaredDistance);
/**
 * @param {Coordinate} coord1 First coordinate.
 * @param {Coordinate} coord2 Second coordinate.
 * @return {number} Distance between coord1 and coord2.
 */ parcelHelpers.export(exports, "distance", ()=>distance);
/**
 * Calculate the squared distance from a coordinate to a line segment.
 *
 * @param {Coordinate} coordinate Coordinate of the point.
 * @param {Array<Coordinate>} segment Line segment (2
 * coordinates).
 * @return {number} Squared distance from the point to the line segment.
 */ parcelHelpers.export(exports, "squaredDistanceToSegment", ()=>squaredDistanceToSegment);
/**
 * Format a geographic coordinate with the hemisphere, degrees, minutes, and
 * seconds.
 *
 * Example without specifying fractional digits:
 *
 *     import {toStringHDMS} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const out = toStringHDMS(coord);
 *     // out is now '47° 58′ 60″ N 7° 50′ 60″ E'
 *
 * Example explicitly specifying 1 fractional digit:
 *
 *     import {toStringHDMS} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const out = toStringHDMS(coord, 1);
 *     // out is now '47° 58′ 60.0″ N 7° 50′ 60.0″ E'
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} [fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} Hemisphere, degrees, minutes and seconds.
 * @api
 */ parcelHelpers.export(exports, "toStringHDMS", ()=>toStringHDMS);
/**
 * Format a coordinate as a comma delimited string.
 *
 * Example without specifying fractional digits:
 *
 *     import {toStringXY} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const out = toStringXY(coord);
 *     // out is now '8, 48'
 *
 * Example explicitly specifying 1 fractional digit:
 *
 *     import {toStringXY} from 'ol/coordinate.js';
 *
 *     const coord = [7.85, 47.983333];
 *     const out = toStringXY(coord, 1);
 *     // out is now '7.8, 48.0'
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} [fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} XY.
 * @api
 */ parcelHelpers.export(exports, "toStringXY", ()=>toStringXY);
/**
 * Modifies the provided coordinate in-place to be within the real world
 * extent. The lower projection extent boundary is inclusive, the upper one
 * exclusive.
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {Coordinate} The coordinate within the real world extent.
 */ parcelHelpers.export(exports, "wrapX", ()=>wrapX);
/**
 * @param {Coordinate} coordinate Coordinate.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @param {number} [sourceExtentWidth] Width of the source extent.
 * @return {number} Offset in world widths.
 */ parcelHelpers.export(exports, "getWorldsAway", ()=>getWorldsAway);
/**
 * Compute the angle between p0pA and p0pB
 * @param {Coordinate} p0 Point 0
 * @param {Coordinate} pA Point A
 * @param {Coordinate} pB Point B
 * @return {number} a value in [0, 2PI]
 */ parcelHelpers.export(exports, "angleBetween", ()=>angleBetween);
var _extentJs = require("./extent.js");
var _mathJs = require("./math.js");
var _stringJs = require("./string.js");
function add(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function closestOnCircle(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function closestOnSegment(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function createStringXY(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return toStringXY(coordinate, fractionDigits);
    });
}
function degreesToStringHDMS(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, _mathJs.modulo)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, _mathJs.toFixed)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + '\u00b0';
    if (min !== 0 || sec !== 0) hdms += ' ' + (0, _stringJs.padNumber)(min, 2) + '\u2032';
    if (sec !== 0) hdms += ' ' + (0, _stringJs.padNumber)(sec, 2, decimals) + '\u2033';
    if (normalizedDegrees !== 0) hdms += ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function format(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(fractionDigits)).replace('{y}', coordinate[1].toFixed(fractionDigits));
    return '';
}
function equals(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function rotate(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function scale(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function squaredDistance(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function distance(coord1, coord2) {
    return Math.sqrt(squaredDistance(coord1, coord2));
}
function squaredDistanceToSegment(coordinate, segment) {
    return squaredDistance(coordinate, closestOnSegment(coordinate, segment));
}
function toStringHDMS(coordinate, fractionDigits) {
    if (coordinate) return degreesToStringHDMS('NS', coordinate[1], fractionDigits) + ' ' + degreesToStringHDMS('EW', coordinate[0], fractionDigits);
    return '';
}
function toStringXY(coordinate, fractionDigits) {
    return format(coordinate, '{x}, {y}', fractionDigits);
}
function wrapX(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, _extentJs.getWidth)(projection.getExtent());
        const worldsAway = getWorldsAway(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function getWorldsAway(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, _extentJs.getWidth)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}
function angleBetween(p0, pA, pB) {
    const lenA = Math.sqrt((pA[0] - p0[0]) * (pA[0] - p0[0]) + (pA[1] - p0[1]) * (pA[1] - p0[1]));
    const tangentA = [
        (pA[0] - p0[0]) / lenA,
        (pA[1] - p0[1]) / lenA
    ];
    const orthoA = [
        -tangentA[1],
        tangentA[0]
    ];
    const lenB = Math.sqrt((pB[0] - p0[0]) * (pB[0] - p0[0]) + (pB[1] - p0[1]) * (pB[1] - p0[1]));
    const tangentB = [
        (pB[0] - p0[0]) / lenB,
        (pB[1] - p0[1]) / lenB
    ];
    // this angle can be clockwise or anticlockwise; hence the computation afterwards
    let angle = lenA === 0 || lenB === 0 ? 0 : Math.acos((0, _mathJs.clamp)(tangentB[0] * tangentA[0] + tangentB[1] * tangentA[1], -1, 1));
    angle = Math.max(angle, 0.00001); // avoid a zero angle otherwise this is detected as a line cap
    const isClockwise = tangentB[0] * orthoA[0] + tangentB[1] * orthoA[1] > 0;
    return !isClockwise ? Math.PI * 2 - angle : angle;
}

},{"./extent.js":"MPjK5","./math.js":"b3dOZ","./string.js":"ladmP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"MPjK5":[function(require,module,exports,__globalThis) {
/**
 * @module ol/extent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An array of numbers representing an extent: `[minx, miny, maxx, maxy]`.
 * @typedef {Array<number>} Extent
 * @api
 */ /**
 * Extent corner.
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} Corner
 */ /**
 * Build an extent that includes all given coordinates.
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
 * @return {Extent} Bounding extent.
 * @api
 */ parcelHelpers.export(exports, "boundingExtent", ()=>boundingExtent);
/**
 * Return extent increased by the provided value.
 * @param {Extent} extent Extent.
 * @param {number} value The amount by which the extent should be buffered.
 * @param {Extent} [dest] Extent.
 * @return {Extent} Extent.
 * @api
 */ parcelHelpers.export(exports, "buffer", ()=>buffer);
/**
 * Creates a clone of an extent.
 *
 * @param {Extent} extent Extent to clone.
 * @param {Extent} [dest] Extent.
 * @return {Extent} The clone.
 */ parcelHelpers.export(exports, "clone", ()=>clone);
/**
 * @param {Extent} extent Extent.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {number} Closest squared distance.
 */ parcelHelpers.export(exports, "closestSquaredDistanceXY", ()=>closestSquaredDistanceXY);
/**
 * Check if the passed coordinate is contained or on the edge of the extent.
 *
 * @param {Extent} extent Extent.
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @return {boolean} The coordinate is contained in the extent.
 * @api
 */ parcelHelpers.export(exports, "containsCoordinate", ()=>containsCoordinate);
/**
 * Check if one extent contains another.
 *
 * An extent is deemed contained if it lies completely within the other extent,
 * including if they share one or more edges.
 *
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {boolean} The second extent is contained by or on the edge of the
 *     first.
 * @api
 */ parcelHelpers.export(exports, "containsExtent", ()=>containsExtent);
/**
 * Check if the passed coordinate is contained or on the edge of the extent.
 *
 * @param {Extent} extent Extent.
 * @param {number} x X coordinate.
 * @param {number} y Y coordinate.
 * @return {boolean} The x, y values are contained in the extent.
 * @api
 */ parcelHelpers.export(exports, "containsXY", ()=>containsXY);
/**
 * Get the relationship between a coordinate and extent.
 * @param {Extent} extent The extent.
 * @param {import("./coordinate.js").Coordinate} coordinate The coordinate.
 * @return {import("./extent/Relationship.js").default} The relationship (bitwise compare with
 *     import("./extent/Relationship.js").Relationship).
 */ parcelHelpers.export(exports, "coordinateRelationship", ()=>coordinateRelationship);
/**
 * Create an empty extent.
 * @return {Extent} Empty extent.
 * @api
 */ parcelHelpers.export(exports, "createEmpty", ()=>createEmpty);
/**
 * Create a new extent or update the provided extent.
 * @param {number} minX Minimum X.
 * @param {number} minY Minimum Y.
 * @param {number} maxX Maximum X.
 * @param {number} maxY Maximum Y.
 * @param {Extent} [dest] Destination extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "createOrUpdate", ()=>createOrUpdate);
/**
 * Create a new empty extent or make the provided one empty.
 * @param {Extent} [dest] Extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "createOrUpdateEmpty", ()=>createOrUpdateEmpty);
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {Extent} [dest] Extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "createOrUpdateFromCoordinate", ()=>createOrUpdateFromCoordinate);
/**
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
 * @param {Extent} [dest] Extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "createOrUpdateFromCoordinates", ()=>createOrUpdateFromCoordinates);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Extent} [dest] Extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "createOrUpdateFromFlatCoordinates", ()=>createOrUpdateFromFlatCoordinates);
/**
 * @param {Array<Array<import("./coordinate.js").Coordinate>>} rings Rings.
 * @param {Extent} [dest] Extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "createOrUpdateFromRings", ()=>createOrUpdateFromRings);
/**
 * Determine if two extents are equivalent.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {boolean} The two extents are equivalent.
 * @api
 */ parcelHelpers.export(exports, "equals", ()=>equals);
/**
 * Determine if two extents are approximately equivalent.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @param {number} tolerance Tolerance in extent coordinate units.
 * @return {boolean} The two extents differ by less than the tolerance.
 */ parcelHelpers.export(exports, "approximatelyEquals", ()=>approximatelyEquals);
/**
 * Modify an extent to include another extent.
 * @param {Extent} extent1 The extent to be modified.
 * @param {Extent} extent2 The extent that will be included in the first.
 * @return {Extent} A reference to the first (extended) extent.
 * @api
 */ parcelHelpers.export(exports, "extend", ()=>extend);
/**
 * @param {Extent} extent Extent.
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 */ parcelHelpers.export(exports, "extendCoordinate", ()=>extendCoordinate);
/**
 * @param {Extent} extent Extent.
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "extendCoordinates", ()=>extendCoordinates);
/**
 * @param {Extent} extent Extent.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "extendFlatCoordinates", ()=>extendFlatCoordinates);
/**
 * @param {Extent} extent Extent.
 * @param {Array<Array<import("./coordinate.js").Coordinate>>} rings Rings.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "extendRings", ()=>extendRings);
/**
 * @param {Extent} extent Extent.
 * @param {number} x X.
 * @param {number} y Y.
 */ parcelHelpers.export(exports, "extendXY", ()=>extendXY);
/**
 * This function calls `callback` for each corner of the extent. If the
 * callback returns a truthy value the function returns that value
 * immediately. Otherwise the function returns `false`.
 * @param {Extent} extent Extent.
 * @param {function(import("./coordinate.js").Coordinate): S} callback Callback.
 * @return {S|boolean} Value.
 * @template S
 */ parcelHelpers.export(exports, "forEachCorner", ()=>forEachCorner);
/**
 * Get the size of an extent.
 * @param {Extent} extent Extent.
 * @return {number} Area.
 * @api
 */ parcelHelpers.export(exports, "getArea", ()=>getArea);
/**
 * Get the bottom left coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Bottom left coordinate.
 * @api
 */ parcelHelpers.export(exports, "getBottomLeft", ()=>getBottomLeft);
/**
 * Get the bottom right coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Bottom right coordinate.
 * @api
 */ parcelHelpers.export(exports, "getBottomRight", ()=>getBottomRight);
/**
 * Get the center coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Center.
 * @api
 */ parcelHelpers.export(exports, "getCenter", ()=>getCenter);
/**
 * Get a corner coordinate of an extent.
 * @param {Extent} extent Extent.
 * @param {Corner} corner Corner.
 * @return {import("./coordinate.js").Coordinate} Corner coordinate.
 */ parcelHelpers.export(exports, "getCorner", ()=>getCorner);
/**
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {number} Enlarged area.
 */ parcelHelpers.export(exports, "getEnlargedArea", ()=>getEnlargedArea);
/**
 * @param {import("./coordinate.js").Coordinate} center Center.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @param {import("./size.js").Size} size Size.
 * @param {Extent} [dest] Destination extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "getForViewAndSize", ()=>getForViewAndSize);
/**
 * @param {import("./coordinate.js").Coordinate} center Center.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @param {import("./size.js").Size} size Size.
 * @return {Array<number>} Linear ring representing the viewport.
 */ parcelHelpers.export(exports, "getRotatedViewport", ()=>getRotatedViewport);
/**
 * Get the height of an extent.
 * @param {Extent} extent Extent.
 * @return {number} Height.
 * @api
 */ parcelHelpers.export(exports, "getHeight", ()=>getHeight);
/**
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {number} Intersection area.
 */ parcelHelpers.export(exports, "getIntersectionArea", ()=>getIntersectionArea);
/**
 * Get the intersection of two extents.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @param {Extent} [dest] Optional extent to populate with intersection.
 * @return {Extent} Intersecting extent.
 * @api
 */ parcelHelpers.export(exports, "getIntersection", ()=>getIntersection);
/**
 * Get the difference between two extents, i.e. the area(s) of `extent1` that
 * are not covered by `extent2`.  Returns an array of between 0 and 4 extents.
 *
 * When the extents do not intersect the returned array contains `extent1` as
 * its only element.  When `extent2` completely contains `extent1` the returned
 * array is empty.  Otherwise up to four non-overlapping extents are returned
 * that together cover exactly the parts of `extent1` outside `extent2`.
 *
 * The decomposition used is:
 *
 * ```
 * ┌────┬─────────┬────┐  ← y2
 * │    │   top   │    │
 * │    ├─────────┤    │  ← iy2
 * │left│ (gone)  │right│
 * │    ├─────────┤    │  ← iy1
 * │    │ bottom  │    │
 * └────┴─────────┴────┘  ← y1
 * x1  ix1       ix2   x2
 * ```
 *
 * The left and right strips span the full height of `extent1` while the top
 * and bottom strips are clamped horizontally to the intersection, so the four
 * rectangles tile perfectly without overlap or gaps.
 *
 * @param {Extent} extent1 Extent to subtract from.
 * @param {Extent} extent2 Extent to subtract.
 * @return {Array<Extent>} Remaining extents (0–4 elements).
 * @api
 */ parcelHelpers.export(exports, "getDifference", ()=>getDifference);
/**
 * @param {Extent} extent Extent.
 * @return {number} Margin.
 */ parcelHelpers.export(exports, "getMargin", ()=>getMargin);
/**
 * Get the size (width, height) of an extent.
 * @param {Extent} extent The extent.
 * @return {import("./size.js").Size} The extent size.
 * @api
 */ parcelHelpers.export(exports, "getSize", ()=>getSize);
/**
 * Get the top left coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Top left coordinate.
 * @api
 */ parcelHelpers.export(exports, "getTopLeft", ()=>getTopLeft);
/**
 * Get the top right coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Top right coordinate.
 * @api
 */ parcelHelpers.export(exports, "getTopRight", ()=>getTopRight);
/**
 * Get the width of an extent.
 * @param {Extent} extent Extent.
 * @return {number} Width.
 * @api
 */ parcelHelpers.export(exports, "getWidth", ()=>getWidth);
/**
 * Determine if one extent intersects another.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent.
 * @return {boolean} The two extents intersect.
 * @api
 */ parcelHelpers.export(exports, "intersects", ()=>intersects);
/**
 * Determine if an extent is empty.
 * @param {Extent} extent Extent.
 * @return {boolean} Is empty.
 * @api
 */ parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
/**
 * @param {Extent} extent Extent.
 * @param {Extent} [dest] Extent.
 * @return {Extent} Extent.
 */ parcelHelpers.export(exports, "returnOrUpdate", ()=>returnOrUpdate);
/**
 * @param {Extent} extent Extent.
 * @param {number} value Value.
 */ parcelHelpers.export(exports, "scaleFromCenter", ()=>scaleFromCenter);
/**
 * Determine if the segment between two coordinates intersects (crosses,
 * touches, or is contained by) the provided extent.
 * @param {Extent} extent The extent.
 * @param {import("./coordinate.js").Coordinate} start Segment start coordinate.
 * @param {import("./coordinate.js").Coordinate} end Segment end coordinate.
 * @return {boolean} The segment intersects the extent.
 */ parcelHelpers.export(exports, "intersectsSegment", ()=>intersectsSegment);
/**
 * Apply a transform function to the extent.
 * @param {Extent} extent Extent.
 * @param {import("./proj.js").TransformFunction} transformFn Transform function.
 * Called with `[minX, minY, maxX, maxY]` extent coordinates.
 * @param {Extent} [dest] Destination extent.
 * @param {number} [stops] Number of stops per side used for the transform.
 * By default only the corners are used.
 * @return {Extent} Extent.
 * @api
 */ parcelHelpers.export(exports, "applyTransform", ()=>applyTransform);
/**
 * Modifies the provided extent in-place to be within the real world
 * extent.
 *
 * @param {Extent} extent Extent.
 * @param {import("./proj/Projection.js").default} projection Projection
 * @return {Extent} The extent within the real world extent.
 */ parcelHelpers.export(exports, "wrapX", ()=>wrapX);
/**
 * Fits the extent to the real world
 *
 * If the extent does not cross the anti meridian, this will return the extent in an array
 * If the extent crosses the anti meridian, the extent will be sliced, so each part fits within the
 * real world
 *
 *
 * @param {Extent} extent Extent.
 * @param {import("./proj/Projection.js").default} projection Projection
 * @param {boolean} [multiWorld] Return all worlds
 * @return {Array<Extent>} The extent within the real world extent.
 */ parcelHelpers.export(exports, "wrapAndSliceX", ()=>wrapAndSliceX);
/**
 * Subtract several rectangles from a base rectangle. Returns a set of disjoint
 * rectangles that together cover the base rectangle minus the union of the
 * subtracted rectangles, by repeatedly applying {@link module:ol/extent.getDifference}.
 * @param {Extent} base Base rectangle.
 * @param {Array<Extent>} subtract Rectangles to subtract.
 * @return {Array<Extent>} Remainder rectangles.
 */ parcelHelpers.export(exports, "subtractExtents", ()=>subtractExtents);
var _relationshipJs = require("./extent/Relationship.js");
var _relationshipJsDefault = parcelHelpers.interopDefault(_relationshipJs);
function boundingExtent(coordinates) {
    const extent = createEmpty();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)extendCoordinate(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function _boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return createOrUpdate(minX, minY, maxX, maxY, dest);
}
function buffer(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function clone(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function closestSquaredDistanceXY(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function containsCoordinate(extent, coordinate) {
    return containsXY(extent, coordinate[0], coordinate[1]);
}
function containsExtent(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function containsXY(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function coordinateRelationship(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, _relationshipJsDefault.default).UNKNOWN;
    if (x < minX) relationship = relationship | (0, _relationshipJsDefault.default).LEFT;
    else if (x > maxX) relationship = relationship | (0, _relationshipJsDefault.default).RIGHT;
    if (y < minY) relationship = relationship | (0, _relationshipJsDefault.default).BELOW;
    else if (y > maxY) relationship = relationship | (0, _relationshipJsDefault.default).ABOVE;
    if (relationship === (0, _relationshipJsDefault.default).UNKNOWN) relationship = (0, _relationshipJsDefault.default).INTERSECTING;
    return relationship;
}
function createEmpty() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function createOrUpdate(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function createOrUpdateEmpty(dest) {
    return createOrUpdate(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function createOrUpdateFromCoordinate(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return createOrUpdate(x, y, x, y, dest);
}
function createOrUpdateFromCoordinates(coordinates, dest) {
    const extent = createOrUpdateEmpty(dest);
    return extendCoordinates(extent, coordinates);
}
function createOrUpdateFromFlatCoordinates(flatCoordinates, offset, end, stride, dest) {
    const extent = createOrUpdateEmpty(dest);
    return extendFlatCoordinates(extent, flatCoordinates, offset, end, stride);
}
function createOrUpdateFromRings(rings, dest) {
    const extent = createOrUpdateEmpty(dest);
    return extendRings(extent, rings);
}
function equals(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function approximatelyEquals(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function extend(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function extendCoordinate(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function extendCoordinates(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)extendCoordinate(extent, coordinates[i]);
    return extent;
}
function extendFlatCoordinates(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)extendXY(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function extendRings(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)extendCoordinates(extent, rings[i]);
    return extent;
}
function extendXY(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function forEachCorner(extent, callback) {
    let val;
    val = callback(getBottomLeft(extent));
    if (val) return val;
    val = callback(getBottomRight(extent));
    if (val) return val;
    val = callback(getTopRight(extent));
    if (val) return val;
    val = callback(getTopLeft(extent));
    if (val) return val;
    return false;
}
function getArea(extent) {
    let area = 0;
    if (!isEmpty(extent)) area = getWidth(extent) * getHeight(extent);
    return area;
}
function getBottomLeft(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function getBottomRight(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function getCenter(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function getCorner(extent, corner) {
    let coordinate;
    if (corner === 'bottom-left') coordinate = getBottomLeft(extent);
    else if (corner === 'bottom-right') coordinate = getBottomRight(extent);
    else if (corner === 'top-left') coordinate = getTopLeft(extent);
    else if (corner === 'top-right') coordinate = getTopRight(extent);
    else throw new Error('Invalid corner');
    return coordinate;
}
function getEnlargedArea(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function getForViewAndSize(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = getRotatedViewport(center, resolution, rotation, size);
    return createOrUpdate(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function getRotatedViewport(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function getHeight(extent) {
    return extent[3] - extent[1];
}
function getIntersectionArea(extent1, extent2) {
    const intersection = getIntersection(extent1, extent2);
    return getArea(intersection);
}
function getIntersection(extent1, extent2, dest) {
    const intersection = dest ? dest : createEmpty();
    if (intersects(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else createOrUpdateEmpty(intersection);
    return intersection;
}
function getDifference(extent1, extent2) {
    if (!intersects(extent1, extent2)) return [
        extent1.slice()
    ];
    if (containsExtent(extent2, extent1)) return [];
    const [x1, y1, x2, y2] = extent1;
    const ix1 = Math.max(x1, extent2[0]);
    const iy1 = Math.max(y1, extent2[1]);
    const ix2 = Math.min(x2, extent2[2]);
    const iy2 = Math.min(y2, extent2[3]);
    const result = [];
    // Left strip  (full height of extent1)
    if (ix1 > x1) result.push([
        x1,
        y1,
        ix1,
        y2
    ]);
    // Right strip (full height of extent1)
    if (ix2 < x2) result.push([
        ix2,
        y1,
        x2,
        y2
    ]);
    // Bottom strip (between the left and right strips)
    if (iy1 > y1) result.push([
        ix1,
        y1,
        ix2,
        iy1
    ]);
    // Top strip (between the left and right strips)
    if (iy2 < y2) result.push([
        ix1,
        iy2,
        ix2,
        y2
    ]);
    return result;
}
function getMargin(extent) {
    return getWidth(extent) + getHeight(extent);
}
function getSize(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function getTopLeft(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function getTopRight(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function getWidth(extent) {
    return extent[2] - extent[0];
}
function intersects(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function isEmpty(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function returnOrUpdate(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function scaleFromCenter(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function intersectsSegment(extent, start, end) {
    let intersects = false;
    const startRel = coordinateRelationship(extent, start);
    const endRel = coordinateRelationship(extent, end);
    if (startRel === (0, _relationshipJsDefault.default).INTERSECTING || endRel === (0, _relationshipJsDefault.default).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, _relationshipJsDefault.default).ABOVE) && !(startRel & (0, _relationshipJsDefault.default).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, _relationshipJsDefault.default).RIGHT) && !(startRel & (0, _relationshipJsDefault.default).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, _relationshipJsDefault.default).BELOW) && !(startRel & (0, _relationshipJsDefault.default).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, _relationshipJsDefault.default).LEFT) && !(startRel & (0, _relationshipJsDefault.default).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function applyTransform(extent, transformFn, dest, stops) {
    if (isEmpty(extent)) return createOrUpdateEmpty(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return _boundingExtentXYs(xs, ys, dest);
}
function wrapX(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = getCenter(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = getWidth(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function wrapAndSliceX(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        wrapX(extent, projection);
        const worldWidth = getWidth(projectionExtent);
        if (getWidth(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}
function subtractExtents(base, subtract) {
    let remainder = [
        base
    ];
    for(let i = 0, ii = subtract.length; i < ii && remainder.length > 0; ++i){
        /** @type {Array<Extent>} */ const next = [];
        for(let j = 0, jj = remainder.length; j < jj; ++j)next.push(...getDifference(remainder[j], subtract[i]));
        remainder = next;
    }
    return remainder;
}

},{"./extent/Relationship.js":"e46UI","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e46UI":[function(require,module,exports,__globalThis) {
/**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ladmP":[function(require,module,exports,__globalThis) {
/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "padNumber", ()=>padNumber);
/**
 * Adapted from https://github.com/omichelsen/compare-versions/blob/master/index.js
 * @param {string|number} v1 First version
 * @param {string|number} v2 Second version
 * @return {number} Value
 */ parcelHelpers.export(exports, "compareVersions", ()=>compareVersions);
function padNumber(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : '' + number;
    let decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function compareVersions(v1, v2) {
    const s1 = ('' + v1).split('.');
    const s2 = ('' + v2).split('.');
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || '0', 10);
        const n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1AzsJ":[function(require,module,exports,__globalThis) {
/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeIn", ()=>easeIn);
/**
 * Start fast and slow down.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ parcelHelpers.export(exports, "easeOut", ()=>easeOut);
/**
 * Start slow, speed up, and then slow down again.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ parcelHelpers.export(exports, "inAndOut", ()=>inAndOut);
/**
 * Maintain a constant speed over time.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ parcelHelpers.export(exports, "linear", ()=>linear);
/**
 * Start slow, speed up, and at the very end slow down again.  This has the
 * same general behavior as {@link module:ol/easing.inAndOut}, but the final
 * slowdown is delayed.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ parcelHelpers.export(exports, "upAndDown", ()=>upAndDown);
function easeIn(t) {
    return Math.pow(t, 3);
}
function easeOut(t) {
    return 1 - easeIn(1 - t);
}
function inAndOut(t) {
    return 3 * t * t - 2 * t * t * t;
}
function linear(t) {
    return t;
}
function upAndDown(t) {
    if (t < 0.5) return inAndOut(2 * t);
    return 1 - inAndOut(2 * (t - 0.5));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3zws5":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/Polygon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create an approximation of a circle on the surface of a sphere.
 * @param {import("../coordinate.js").Coordinate} center Center (`[lon, lat]` in degrees).
 * @param {number} radius The great-circle distance from the center to
 *     the polygon vertices in meters.
 * @param {number} [n] Optional number of vertices for the resulting
 *     polygon. Default is `32`.
 * @param {number} [sphereRadius] Optional radius for the sphere (defaults to
 *     the Earth's mean radius using the WGS84 ellipsoid).
 * @return {Polygon} The "circular" polygon.
 * @api
 */ parcelHelpers.export(exports, "circular", ()=>circular);
/**
 * Create a polygon from an extent. The layout used is `XY`.
 * @param {import("../extent.js").Extent} extent The extent.
 * @return {Polygon} The polygon.
 * @api
 */ parcelHelpers.export(exports, "fromExtent", ()=>fromExtent);
/**
 * Create a regular polygon from a circle.
 * @param {import("./Circle.js").default} circle Circle geometry.
 * @param {number} [sides] Number of sides of the polygon. Default is 32.
 * @param {number} [angle] Start angle for the first vertex of the polygon in
 *     counter-clockwise radians. 0 means East. Default is 0.
 * @return {Polygon} Polygon geometry.
 * @api
 */ parcelHelpers.export(exports, "fromCircle", ()=>fromCircle);
/**
 * Modify the coordinates of a polygon to make it a regular polygon.
 * @param {Polygon} polygon Polygon geometry.
 * @param {import("../coordinate.js").Coordinate} center Center of the regular polygon.
 * @param {number} radius Radius of the regular polygon.
 * @param {number} [angle] Start angle for the first vertex of the polygon in
 *     counter-clockwise radians. 0 means East. Default is 0.
 */ parcelHelpers.export(exports, "makeRegular", ()=>makeRegular);
var _arrayJs = require("../array.js");
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _sphereJs = require("../sphere.js");
var _linearRingJs = require("./LinearRing.js");
var _linearRingJsDefault = parcelHelpers.interopDefault(_linearRingJs);
var _pointJs = require("./Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _areaJs = require("./flat/area.js");
var _closestJs = require("./flat/closest.js");
var _containsJs = require("./flat/contains.js");
var _deflateJs = require("./flat/deflate.js");
var _inflateJs = require("./flat/inflate.js");
var _interiorpointJs = require("./flat/interiorpoint.js");
var _intersectsextentJs = require("./flat/intersectsextent.js");
var _orientJs = require("./flat/orient.js");
var _simplifyJs = require("./flat/simplify.js");
/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class Polygon extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, _arrayJs.extend)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, _extentJs.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, _closestJs.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, _closestJs.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, _containsJs.linearRingsContainsXY)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, _areaJs.linearRings)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, _orientJs.orientLinearRings)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, _inflateJs.inflateCoordinatesArray)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, _extentJs.getCenter)(this.getExtent());
            this.flatInteriorPoint_ = (0, _interiorpointJs.getInteriorPointOfArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, _pointJsDefault.default)(this.getFlatInteriorPoint(), 'XYM');
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, _linearRingJsDefault.default)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, _linearRingJsDefault.default)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, _orientJs.linearRingsAreOriented)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, _orientJs.orientLinearRings)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, _simplifyJs.quantizeArray)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new Polygon(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Polygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, _intersectsextentJs.intersectsLinearRingArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, _deflateJs.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
exports.default = Polygon;
function circular(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, _arrayJs.extend)(flatCoordinates, (0, _sphereJs.offset)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function fromExtent(extent) {
    if ((0, _extentJs.isEmpty)(extent)) throw new Error('Cannot create polygon from empty extent');
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function fromCircle(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new Polygon(flatCoordinates, layout, ends);
    makeRegular(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function makeRegular(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, _mathJs.modulo)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}

},{"../array.js":"2IuG2","../extent.js":"MPjK5","../math.js":"b3dOZ","../sphere.js":"hm1fa","./LinearRing.js":"eChQS","./Point.js":"95T6m","./SimpleGeometry.js":"5Lm1Z","./flat/area.js":"2VE1b","./flat/closest.js":"jFnaY","./flat/contains.js":"5TUtI","./flat/deflate.js":"8nFry","./flat/inflate.js":"ainGz","./flat/interiorpoint.js":"jo2rT","./flat/intersectsextent.js":"9jzv1","./flat/orient.js":"1iFdH","./flat/simplify.js":"5VJXL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hm1fa":[function(require,module,exports,__globalThis) {
/**
 * @module ol/sphere
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RADIUS", ()=>DEFAULT_RADIUS);
/**
 * Get the great circle distance (in meters) between two geographic coordinates.
 * @param {Array} c1 Starting coordinate.
 * @param {Array} c2 Ending coordinate.
 * @param {number} [radius] The sphere radius to use.  Defaults to the Earth's
 *     mean radius using the WGS84 ellipsoid.
 * @return {number} The great circle distance between the points (in meters).
 * @api
 */ parcelHelpers.export(exports, "getDistance", ()=>getDistance);
/**
 * Get the spherical length of a geometry.  This length is the sum of the
 * great circle distances between coordinates.  For polygons, the length is
 * the sum of all rings.  For points, the length is zero.  For multi-part
 * geometries, the length is the sum of the length of each part.
 * @param {import("./geom/Geometry.js").default} geometry A geometry.
 * @param {SphereMetricOptions} [options] Options for the
 * length calculation.  By default, geometries are assumed to be in 'EPSG:3857'.
 * You can change this by providing a `projection` option.
 * @return {number} The spherical length (in meters).
 * @api
 */ parcelHelpers.export(exports, "getLength", ()=>getLength);
/**
 * Get the spherical area of a geometry.  This is the area (in meters) assuming
 * that polygon edges are segments of great circles on a sphere.
 * @param {import("./geom/Geometry.js").default} geometry A geometry.
 * @param {SphereMetricOptions} [options] Options for the area
 *     calculation.  By default, geometries are assumed to be in 'EPSG:3857'.
 *     You can change this by providing a `projection` option.
 * @return {number} The spherical area (in square meters).
 * @api
 */ parcelHelpers.export(exports, "getArea", ()=>getArea);
/**
 * Returns the coordinate at the given distance and bearing from `c1`.
 *
 * @param {import("./coordinate.js").Coordinate} c1 The origin point (`[lon, lat]` in degrees).
 * @param {number} distance The great-circle distance between the origin
 *     point and the target point.
 * @param {number} bearing The bearing (in radians).
 * @param {number} [radius] The sphere radius to use.  Defaults to the Earth's
 *     mean radius using the WGS84 ellipsoid.
 * @return {import("./coordinate.js").Coordinate} The target point.
 */ parcelHelpers.export(exports, "offset", ()=>offset);
var _mathJs = require("./math.js");
const DEFAULT_RADIUS = 6371008.8;
function getDistance(c1, c2, radius) {
    radius = radius || DEFAULT_RADIUS;
    const lat1 = (0, _mathJs.toRadians)(c1[1]);
    const lat2 = (0, _mathJs.toRadians)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, _mathJs.toRadians)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += getDistance(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function getLength(geometry, options) {
    options = options || {};
    const radius = options.radius || DEFAULT_RADIUS;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += getLength(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, _mathJs.toRadians)(x2 - x1) * (2 + Math.sin((0, _mathJs.toRadians)(y1)) + Math.sin((0, _mathJs.toRadians)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function getArea(geometry, options) {
    options = options || {};
    const radius = options.radius || DEFAULT_RADIUS;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs(getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs(getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs(getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs(getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += getArea(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function offset(c1, distance, bearing, radius) {
    radius = radius || DEFAULT_RADIUS;
    const lat1 = (0, _mathJs.toRadians)(c1[1]);
    const lon1 = (0, _mathJs.toRadians)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, _mathJs.toDegrees)(lon),
        (0, _mathJs.toDegrees)(lat)
    ];
}

},{"./math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eChQS":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/LinearRing
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extentJs = require("../extent.js");
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _areaJs = require("./flat/area.js");
var _closestJs = require("./flat/closest.js");
var _deflateJs = require("./flat/deflate.js");
var _inflateJs = require("./flat/inflate.js");
var _intersectsextentJs = require("./flat/intersectsextent.js");
var _simplifyJs = require("./flat/simplify.js");
/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class LinearRing extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, _extentJs.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, _closestJs.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, _closestJs.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, _areaJs.linearRing)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, _inflateJs.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, _simplifyJs.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LinearRing(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LinearRing';
    }
    /**
   * Test if the geometry and the passed extent intersect. A linear ring is
   * treated as a line string for this test.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, _intersectsextentJs.intersectsLineString)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, _deflateJs.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
exports.default = LinearRing;

},{"../extent.js":"MPjK5","./SimpleGeometry.js":"5Lm1Z","./flat/area.js":"2VE1b","./flat/closest.js":"jFnaY","./flat/deflate.js":"8nFry","./flat/inflate.js":"ainGz","./flat/intersectsextent.js":"9jzv1","./flat/simplify.js":"5VJXL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5Lm1Z":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/SimpleGeometry
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {number} stride Stride.
 * @return {import("./Geometry.js").GeometryLayout} layout Layout.
 */ parcelHelpers.export(exports, "getLayoutForStride", ()=>getLayoutForStride);
/**
 * @param {import("./Geometry.js").GeometryLayout} layout Layout.
 * @return {number} Stride.
 */ parcelHelpers.export(exports, "getStrideForLayout", ()=>getStrideForLayout);
/**
 * @param {SimpleGeometry} simpleGeometry Simple geometry.
 * @param {import("../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Transformed flat coordinates.
 */ parcelHelpers.export(exports, "transformGeom2D", ()=>transformGeom2D);
var _extentJs = require("../extent.js");
var _utilJs = require("../util.js");
var _geometryJs = require("./Geometry.js");
var _geometryJsDefault = parcelHelpers.interopDefault(_geometryJs);
var _transformJs = require("./flat/transform.js");
/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class SimpleGeometry extends (0, _geometryJsDefault.default) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = 'XY';
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, _extentJs.createOrUpdateFromFlatCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = getStrideForLayout(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, _utilJs.abstract)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = getStrideForLayout(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = 'XY';
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = getLayoutForStride(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith('XYZ') ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, _transformJs.rotate)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, _extentJs.getCenter)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, _transformJs.scale)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, _transformJs.translate)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function getLayoutForStride(stride) {
    let layout;
    if (stride == 2) layout = 'XY';
    else if (stride == 3) layout = 'XYZ';
    else if (stride == 4) layout = 'XYZM';
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function getStrideForLayout(layout) {
    let stride;
    if (layout == 'XY') stride = 2;
    else if (layout == 'XYZ' || layout == 'XYM') stride = 3;
    else if (layout == 'XYZM') stride = 4;
    return /** @type {number} */ stride;
}
function transformGeom2D(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, _transformJs.transform2D)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
exports.default = SimpleGeometry;

},{"../extent.js":"MPjK5","../util.js":"9Y20j","./Geometry.js":"2pFcG","./flat/transform.js":"ahZFf","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2pFcG":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/Geometry
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectJs = require("../Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _extentJs = require("../extent.js");
var _functionsJs = require("../functions.js");
var _projJs = require("../proj.js");
var _transformJs = require("../transform.js");
var _utilJs = require("../util.js");
var _transformJs1 = require("./flat/transform.js");
/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const tmpTransform = (0, _transformJs.create)();
/** @type {import('../coordinate.js').Coordinate} */ const tmpPoint = [
    NaN,
    NaN
];
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class Geometry extends (0, _objectJsDefault.default) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, _extentJs.createEmpty)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, _functionsJs.memoizeOne)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, _utilJs.abstract)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, _utilJs.abstract)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return this.closestPointXY(x, y, tmpPoint, Number.MIN_VALUE) === 0;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, _extentJs.createOrUpdateEmpty)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, _extentJs.returnOrUpdate)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, _utilJs.abstract)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, _utilJs.abstract)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, _utilJs.abstract)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, _utilJs.abstract)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, _projJs.get)(source);
        const transformFn = sourceProj.getUnits() == 'tile-pixels' ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, _extentJs.getHeight)(projectedExtent) / (0, _extentJs.getHeight)(pixelExtent);
            (0, _transformJs.compose)(tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            const transformed = (0, _transformJs1.transform2D)(inCoordinates, 0, inCoordinates.length, stride, tmpTransform, outCoordinates);
            const projTransform = (0, _projJs.getTransform)(sourceProj, destination);
            if (projTransform) return projTransform(transformed, transformed, stride);
            return transformed;
        } : (0, _projJs.getTransform)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
exports.default = Geometry;

},{"../Object.js":"lFhbz","../extent.js":"MPjK5","../functions.js":"5nAKV","../proj.js":"gN0IK","../transform.js":"7TqcG","../util.js":"9Y20j","./flat/transform.js":"ahZFf","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gN0IK":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://spatialreference.org/, and are a JS function, so can be loaded in a
 * script tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A transform function accepts an array of input coordinate values, an optional
 * output array, and an optional dimension (default should be 2).  The function
 * transforms the input coordinate values, populates the output array, and
 * returns the output array.
 *
 * @callback TransformFunction
 * @param {Array<number>} input
 * @param {Array<number>} [output]
 * @param {number} [dimension]
 * @param {number} [stride]
 * @return {Array<number>}
 *
 * @api
 */ parcelHelpers.export(exports, "METERS_PER_UNIT", ()=>(0, _unitsJs.METERS_PER_UNIT));
parcelHelpers.export(exports, "Projection", ()=>(0, _projectionJsDefault.default));
/**
 * @param {boolean} [disable] Disable console info about `useGeographic()`
 */ parcelHelpers.export(exports, "disableCoordinateWarning", ()=>disableCoordinateWarning);
/**
 * @param {Array<number>} input Input coordinate array.
 * @param {Array<number>} [output] Output array of coordinate values.
 * @return {Array<number>} Output coordinate array (new array, same coordinate
 *     values).
 */ parcelHelpers.export(exports, "cloneTransform", ()=>cloneTransform);
/**
 * @param {Array<number>} input Input coordinate array.
 * @param {Array<number>} [output] Output array of coordinate values.
 * @return {Array<number>} Input coordinate array (same array as input).
 */ parcelHelpers.export(exports, "identityTransform", ()=>identityTransform);
/**
 * Add a Projection object to the list of supported projections that can be
 * looked up by their code.
 *
 * @param {Projection} projection Projection instance.
 * @api
 */ parcelHelpers.export(exports, "addProjection", ()=>addProjection);
/**
 * @param {Array<Projection>} projections Projections.
 */ parcelHelpers.export(exports, "addProjections", ()=>addProjections);
/**
 * Fetches a Projection object for the code specified.
 *
 * @param {ProjectionLike} projectionLike Either a code string which is
 *     a combination of authority and identifier such as "EPSG:4326", or an
 *     existing projection object, or undefined.
 * @return {Projection|null} Projection object, or null if not in list.
 * @api
 */ parcelHelpers.export(exports, "get", ()=>get);
/**
 * Get the resolution of the point in degrees or distance units.
 * For projections with degrees as the unit this will simply return the
 * provided resolution. For other projections the point resolution is
 * by default estimated by transforming the `point` pixel to EPSG:4326,
 * measuring its width and height on the normal sphere,
 * and taking the average of the width and height.
 * A custom function can be provided for a specific projection, either
 * by setting the `getPointResolution` option in the
 * {@link module:ol/proj/Projection~Projection} constructor or by using
 * {@link module:ol/proj/Projection~Projection#setGetPointResolution} to change an existing
 * projection object.
 * @param {ProjectionLike} projection The projection.
 * @param {number} resolution Nominal resolution in projection units.
 * @param {import("./coordinate.js").Coordinate} point Point to find adjusted resolution at.
 * @param {import("./proj/Units.js").Units} [units] Units to get the point resolution in.
 * Default is the projection's units.
 * @return {number} Point resolution.
 * @api
 */ parcelHelpers.export(exports, "getPointResolution", ()=>getPointResolution);
/**
 * Registers transformation functions that don't alter coordinates. Those allow
 * to transform between projections with equal meaning.
 *
 * @param {Array<Projection>} projections Projections.
 * @api
 */ parcelHelpers.export(exports, "addEquivalentProjections", ()=>addEquivalentProjections);
/**
 * Registers transformation functions to convert coordinates in any projection
 * in projection1 to any projection in projection2.
 *
 * @param {Array<Projection>} projections1 Projections with equal
 *     meaning.
 * @param {Array<Projection>} projections2 Projections with equal
 *     meaning.
 * @param {TransformFunction} forwardTransform Transformation from any
 *   projection in projection1 to any projection in projection2.
 * @param {TransformFunction} inverseTransform Transform from any projection
 *   in projection2 to any projection in projection1..
 */ parcelHelpers.export(exports, "addEquivalentTransforms", ()=>addEquivalentTransforms);
/**
 * Clear all cached projections and transforms.
 */ parcelHelpers.export(exports, "clearAllProjections", ()=>clearAllProjections);
/**
 * @param {Projection|string|undefined} projection Projection.
 * @param {string} defaultCode Default code.
 * @return {Projection} Projection.
 */ parcelHelpers.export(exports, "createProjection", ()=>createProjection);
/**
 * Creates a {@link module:ol/proj~TransformFunction} from a simple 2D coordinate transform
 * function.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} coordTransform Coordinate
 *     transform.
 * @return {TransformFunction} Transform function.
 */ parcelHelpers.export(exports, "createTransformFromCoordinateTransform", ()=>createTransformFromCoordinateTransform);
/**
 * Registers coordinate transform functions to convert coordinates between the
 * source projection and the destination projection.
 * The forward and inverse functions convert coordinate pairs; this function
 * converts these into the functions used internally which also handle
 * extents and coordinate arrays.
 *
 * @param {ProjectionLike} source Source projection.
 * @param {ProjectionLike} destination Destination projection.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} forward The forward transform
 *     function (that is, from the source projection to the destination
 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
 *     the transformed {@link module:ol/coordinate~Coordinate}.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} inverse The inverse transform
 *     function (that is, from the destination projection to the source
 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
 *     the transformed {@link module:ol/coordinate~Coordinate}. If the transform function can only
 *     transform less dimensions than the input coordinate, it is supposeed to return a coordinate
 *     with only the length it can transform. The other dimensions will be taken unchanged from the
 *     source.
 * @api
 */ parcelHelpers.export(exports, "addCoordinateTransforms", ()=>addCoordinateTransforms);
/**
 * Transforms a coordinate from longitude/latitude to a different projection.
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate as longitude and latitude, i.e.
 *     an array with longitude as 1st and latitude as 2nd element.
 * @param {ProjectionLike} [projection] Target projection. The
 *     default is Web Mercator, i.e. 'EPSG:3857'.
 * @return {import("./coordinate.js").Coordinate} Coordinate projected to the target projection.
 * @api
 */ parcelHelpers.export(exports, "fromLonLat", ()=>fromLonLat);
/**
 * Transforms a coordinate to longitude/latitude.
 * @param {import("./coordinate.js").Coordinate} coordinate Projected coordinate.
 * @param {ProjectionLike} [projection] Projection of the coordinate.
 *     The default is Web Mercator, i.e. 'EPSG:3857'.
 * @return {import("./coordinate.js").Coordinate} Coordinate as longitude and latitude, i.e. an array
 *     with longitude as 1st and latitude as 2nd element.
 * @api
 */ parcelHelpers.export(exports, "toLonLat", ()=>toLonLat);
/**
 * Checks if two projections are the same, that is every coordinate in one
 * projection does represent the same geographic point as the same coordinate in
 * the other projection.
 *
 * @param {Projection} projection1 Projection 1.
 * @param {Projection} projection2 Projection 2.
 * @return {boolean} Equivalent.
 * @api
 */ parcelHelpers.export(exports, "equivalent", ()=>equivalent);
/**
 * Searches in the list of transform functions for the function for converting
 * coordinates from the source projection to the destination projection.
 *
 * @param {Projection} source Source Projection object.
 * @param {Projection} destination Destination Projection
 *     object.
 * @return {TransformFunction|null} Transform function.
 */ parcelHelpers.export(exports, "getTransformFromProjections", ()=>getTransformFromProjections);
/**
 * Given the projection-like objects, searches for a transformation
 * function to convert a coordinates array from the source projection to the
 * destination projection.
 *
 * @param {ProjectionLike} source Source.
 * @param {ProjectionLike} destination Destination.
 * @return {TransformFunction} Transform function.
 * @api
 */ parcelHelpers.export(exports, "getTransform", ()=>getTransform);
/**
 * Transforms a coordinate from source projection to destination projection.
 * This returns a new coordinate (and does not modify the original). If there
 * is no available transform between the two projection, the function will throw
 * an error.
 *
 * See {@link module:ol/proj.transformExtent} for extent transformation.
 * See the transform method of {@link module:ol/geom/Geometry~Geometry} and its
 * subclasses for geometry transforms.
 *
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {ProjectionLike} source Source projection-like.
 * @param {ProjectionLike} destination Destination projection-like.
 * @return {import("./coordinate.js").Coordinate} Coordinate.
 * @api
 */ parcelHelpers.export(exports, "transform", ()=>transform);
/**
 * Transforms an extent from source projection to destination projection.  This
 * returns a new extent (and does not modify the original).
 *
 * @param {import("./extent.js").Extent} extent The extent to transform.
 * @param {ProjectionLike} source Source projection-like.
 * @param {ProjectionLike} destination Destination projection-like.
 * @param {number} [stops] Number of stops per side used for the transform.
 * By default only the corners are used.
 * @return {import("./extent.js").Extent} The transformed extent.
 * @api
 */ parcelHelpers.export(exports, "transformExtent", ()=>transformExtent);
/**
 * Transforms the given point to the destination projection.
 *
 * @param {import("./coordinate.js").Coordinate} point Point.
 * @param {Projection} sourceProjection Source projection.
 * @param {Projection} destinationProjection Destination projection.
 * @return {import("./coordinate.js").Coordinate} Point.
 */ parcelHelpers.export(exports, "transformWithProjections", ()=>transformWithProjections);
/**
 * Set the projection for coordinates supplied from and returned by API methods.
 * This includes all API methods except for those interacting with tile grids,
 * plus {@link import("./Map.js").FrameState} and {@link import("./View.js").State}.
 * @param {ProjectionLike} projection The user projection.
 * @api
 */ parcelHelpers.export(exports, "setUserProjection", ()=>setUserProjection);
/**
 * Clear the user projection if set.
 * @api
 */ parcelHelpers.export(exports, "clearUserProjection", ()=>clearUserProjection);
/**
 * Get the projection for coordinates supplied from and returned by API methods.
 * @return {Projection|null} The user projection (or null if not set).
 * @api
 */ parcelHelpers.export(exports, "getUserProjection", ()=>getUserProjection);
/**
 * Use geographic coordinates (WGS-84 datum) in API methods.
 * This includes all API methods except for those interacting with tile grids,
 * plus {@link import("./Map.js").FrameState} and {@link import("./View.js").State}.
 * @api
 */ parcelHelpers.export(exports, "useGeographic", ()=>useGeographic);
/**
 * Return a coordinate transformed into the user projection.  If no user projection
 * is set, the original coordinate is returned.
 * @param {Array<number>} coordinate Input coordinate.
 * @param {ProjectionLike} sourceProjection The input coordinate projection.
 * @return {Array<number>} The input coordinate in the user projection.
 */ parcelHelpers.export(exports, "toUserCoordinate", ()=>toUserCoordinate);
/**
 * Return a coordinate transformed from the user projection.  If no user projection
 * is set, the original coordinate is returned.
 * @param {Array<number>} coordinate Input coordinate.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {Array<number>} The input coordinate transformed.
 */ parcelHelpers.export(exports, "fromUserCoordinate", ()=>fromUserCoordinate);
/**
 * Return an extent transformed into the user projection.  If no user projection
 * is set, the original extent is returned.
 * @param {import("./extent.js").Extent} extent Input extent.
 * @param {ProjectionLike} sourceProjection The input extent projection.
 * @return {import("./extent.js").Extent} The input extent in the user projection.
 */ parcelHelpers.export(exports, "toUserExtent", ()=>toUserExtent);
/**
 * Return an extent transformed from the user projection.  If no user projection
 * is set, the original extent is returned.
 * @param {import("./extent.js").Extent} extent Input extent.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {import("./extent.js").Extent} The input extent transformed.
 */ parcelHelpers.export(exports, "fromUserExtent", ()=>fromUserExtent);
/**
 * Return the resolution in user projection units per pixel. If no user projection
 * is set, or source or user projection are missing units, the original resolution
 * is returned.
 * @param {number} resolution Resolution in input projection units per pixel.
 * @param {ProjectionLike} sourceProjection The input projection.
 * @return {number} Resolution in user projection units per pixel.
 */ parcelHelpers.export(exports, "toUserResolution", ()=>toUserResolution);
/**
 * Return the resolution in user projection units per pixel. If no user projection
 * is set, or source or user projection are missing units, the original resolution
 * is returned.
 * @param {number} resolution Resolution in user projection units per pixel.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {number} Resolution in destination projection units per pixel.
 */ parcelHelpers.export(exports, "fromUserResolution", ()=>fromUserResolution);
/**
 * Creates a safe coordinate transform function from a coordinate transform function.
 * "Safe" means that it can handle wrapping of x-coordinates for global projections,
 * and that coordinates exceeding the source projection validity extent's range will be
 * clamped to the validity range.
 * @param {Projection} sourceProj Source projection.
 * @param {Projection} destProj Destination projection.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} transform Transform function (source to destination).
 * @return {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} Safe transform function (source to destination).
 */ parcelHelpers.export(exports, "createSafeCoordinateTransform", ()=>createSafeCoordinateTransform);
/**
 * Add transforms to and from EPSG:4326 and EPSG:3857.  This function is called
 * by when this module is executed and should only need to be called again after
 * `clearAllProjections()` is called (e.g. in tests).
 */ parcelHelpers.export(exports, "addCommon", ()=>addCommon);
var _consoleJs = require("./console.js");
var _coordinateJs = require("./coordinate.js");
var _extentJs = require("./extent.js");
var _mathJs = require("./math.js");
var _projectionJs = require("./proj/Projection.js");
var _projectionJsDefault = parcelHelpers.interopDefault(_projectionJs);
var _unitsJs = require("./proj/Units.js");
var _epsg3857Js = require("./proj/epsg3857.js");
var _epsg4326Js = require("./proj/epsg4326.js");
var _projectionsJs = require("./proj/projections.js");
var _transformsJs = require("./proj/transforms.js");
var _utmJs = require("./proj/utm.js");
var _sphereJs = require("./sphere.js");
/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */ /**
 * @typedef {Object} Transforms
 * @property {TransformFunction} forward The forward transform (from geographic).
 * @property {TransformFunction} inverse The inverse transform (to geographic).
 */ /**
 * @type {Array<function(Projection): Transforms|null>}
 */ const transformFactories = [
    (0, _utmJs.makeTransforms)
];
/**
 * @type {Array<function(string): Projection|null>}
 */ const projectionFactories = [
    (0, _utmJs.makeProjection)
];
let showCoordinateWarning = true;
function disableCoordinateWarning(disable) {
    const hide = disable === undefined ? true : disable;
    showCoordinateWarning = !hide;
}
function cloneTransform(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function identityTransform(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function addProjection(projection) {
    (0, _projectionsJs.add)(projection.getCode(), projection);
    (0, _transformsJs.add)(projection, projection, cloneTransform);
}
function addProjections(projections) {
    projections.forEach(addProjection);
}
function get(projectionLike) {
    if (!(typeof projectionLike === 'string')) return projectionLike;
    const projection = (0, _projectionsJs.get)(projectionLike);
    if (projection) return projection;
    for (const makeProjection of projectionFactories){
        const projection = makeProjection(projectionLike);
        if (projection) return projection;
    }
    return null;
}
function getPointResolution(projection, resolution, point, units) {
    projection = get(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, _unitsJs.METERS_PER_UNIT)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == 'degrees' && !units || units == 'degrees') pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = getTransformFromProjections(projection, get('EPSG:4326'));
            if (!toEPSG4326 && projUnits !== 'degrees') // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, _sphereJs.getDistance)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, _sphereJs.getDistance)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, _unitsJs.METERS_PER_UNIT)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function addEquivalentProjections(projections) {
    addProjections(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, _transformsJs.add)(source, destination, cloneTransform);
        });
    });
}
function addEquivalentTransforms(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, _transformsJs.add)(projection1, projection2, forwardTransform);
            (0, _transformsJs.add)(projection2, projection1, inverseTransform);
        });
    });
}
function clearAllProjections() {
    (0, _projectionsJs.clear)();
    (0, _transformsJs.clear)();
}
function createProjection(projection, defaultCode) {
    if (!projection) return get(defaultCode);
    if (typeof projection === 'string') return get(projection);
    return /** @type {Projection} */ projection;
}
function createTransformFromCoordinateTransform(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function addCoordinateTransforms(source, destination, forward, inverse) {
    const sourceProj = get(source);
    const destProj = get(destination);
    (0, _transformsJs.add)(sourceProj, destProj, createTransformFromCoordinateTransform(forward));
    (0, _transformsJs.add)(destProj, sourceProj, createTransformFromCoordinateTransform(inverse));
}
function fromLonLat(coordinate, projection) {
    disableCoordinateWarning();
    return transform(coordinate, 'EPSG:4326', projection !== undefined ? projection : 'EPSG:3857');
}
function toLonLat(coordinate, projection) {
    const lonLat = transform(coordinate, projection !== undefined ? projection : 'EPSG:3857', 'EPSG:4326');
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, _mathJs.modulo)(lon + 180, 360) - 180;
    return lonLat;
}
function equivalent(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = getTransformFromProjections(projection1, projection2);
    return transformFunc === cloneTransform && equalUnits;
}
function getTransformFromProjections(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    let transformFunc = (0, _transformsJs.get)(sourceCode, destinationCode);
    if (transformFunc) return transformFunc;
    /**
   * @type {Transforms|null}
   */ let sourceTransforms = null;
    /**
   * @type {Transforms|null}
   */ let destinationTransforms = null;
    // lazily add projections if we have supported transforms
    for (const makeTransforms of transformFactories){
        if (!sourceTransforms) sourceTransforms = makeTransforms(source);
        if (!destinationTransforms) destinationTransforms = makeTransforms(destination);
    }
    if (!sourceTransforms && !destinationTransforms) return null;
    const intermediateCode = 'EPSG:4326';
    if (!destinationTransforms) {
        const toDestination = (0, _transformsJs.get)(intermediateCode, destinationCode);
        if (toDestination) transformFunc = composeTransformFuncs(sourceTransforms.inverse, toDestination);
    } else if (!sourceTransforms) {
        const fromSource = (0, _transformsJs.get)(sourceCode, intermediateCode);
        if (fromSource) transformFunc = composeTransformFuncs(fromSource, destinationTransforms.forward);
    } else transformFunc = composeTransformFuncs(sourceTransforms.inverse, destinationTransforms.forward);
    if (transformFunc) {
        addProjection(source);
        addProjection(destination);
        (0, _transformsJs.add)(source, destination, transformFunc);
    }
    return transformFunc;
}
/**
 * @param {TransformFunction} t1 The first transform function.
 * @param {TransformFunction} t2 The second transform function.
 * @return {TransformFunction} The composed transform function.
 */ function composeTransformFuncs(t1, t2) {
    return function(input, output, dimensions, stride) {
        output = t1(input, output, dimensions, stride);
        return t2(output, output, dimensions, stride);
    };
}
function getTransform(source, destination) {
    const sourceProjection = get(source);
    const destinationProjection = get(destination);
    return getTransformFromProjections(sourceProjection, destinationProjection);
}
function transform(coordinate, source, destination) {
    const transformFunc = getTransform(source, destination);
    if (!transformFunc) {
        const sourceCode = get(source).getCode();
        const destinationCode = get(destination).getCode();
        throw new Error(`No transform available between ${sourceCode} and ${destinationCode}`);
    }
    return transformFunc(coordinate, undefined, coordinate.length);
}
function transformExtent(extent, source, destination, stops) {
    const transformFunc = getTransform(source, destination);
    return (0, _extentJs.applyTransform)(extent, transformFunc, undefined, stops);
}
function transformWithProjections(point, sourceProjection, destinationProjection) {
    const transformFunc = getTransformFromProjections(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let userProjection = null;
function setUserProjection(projection) {
    userProjection = get(projection);
}
function clearUserProjection() {
    userProjection = null;
}
function getUserProjection() {
    return userProjection;
}
function useGeographic() {
    setUserProjection('EPSG:4326');
}
function toUserCoordinate(coordinate, sourceProjection) {
    if (!userProjection) return coordinate;
    return transform(coordinate, sourceProjection, userProjection);
}
function fromUserCoordinate(coordinate, destProjection) {
    if (!userProjection) {
        if (showCoordinateWarning && !(0, _coordinateJs.equals)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            showCoordinateWarning = false;
            (0, _consoleJs.warn)('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return transform(coordinate, userProjection, destProjection);
}
function toUserExtent(extent, sourceProjection) {
    if (!userProjection) return extent;
    return transformExtent(extent, sourceProjection, userProjection);
}
function fromUserExtent(extent, destProjection) {
    if (!userProjection) return extent;
    return transformExtent(extent, userProjection, destProjection);
}
function toUserResolution(resolution, sourceProjection) {
    if (!userProjection) return resolution;
    const sourceMetersPerUnit = get(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function fromUserResolution(resolution, destProjection) {
    if (!userProjection) return resolution;
    const destMetersPerUnit = get(destProjection).getMetersPerUnit();
    const userMetersPerUnit = userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function createSafeCoordinateTransform(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, _extentJs.getWidth)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, _coordinateJs.getWorldsAway)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, _mathJs.clamp)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, _mathJs.clamp)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, _extentJs.getWidth)(destProj.getExtent());
        return transformed;
    };
}
function addCommon() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    addEquivalentProjections((0, _epsg3857Js.PROJECTIONS));
    addEquivalentProjections((0, _epsg4326Js.PROJECTIONS));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    addEquivalentTransforms((0, _epsg4326Js.PROJECTIONS), (0, _epsg3857Js.PROJECTIONS), (0, _epsg3857Js.fromEPSG4326), (0, _epsg3857Js.toEPSG4326));
}
addCommon();

},{"./console.js":"ltVs6","./coordinate.js":"9bcSP","./extent.js":"MPjK5","./math.js":"b3dOZ","./proj/Projection.js":"2SzJN","./proj/Units.js":"7FLCv","./proj/epsg3857.js":"XXMJe","./proj/epsg4326.js":"5lBKF","./proj/projections.js":"5I9lt","./proj/transforms.js":"5nKMN","./proj/utm.js":"fPNPQ","./sphere.js":"hm1fa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ltVs6":[function(require,module,exports,__globalThis) {
/**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Set the logging level.  By default, the level is set to 'info' and all
 * messages will be logged.  Set to 'warn' to only display warnings and errors.
 * Set to 'error' to only display errors.  Set to 'none' to silence all messages.
 *
 * @param {Level} l The new level.
 */ parcelHelpers.export(exports, "setLevel", ()=>setLevel);
/**
 * @param  {...any} args Arguments to log
 */ parcelHelpers.export(exports, "log", ()=>log);
/**
 * @param  {...any} args Arguments to log
 */ parcelHelpers.export(exports, "warn", ()=>warn);
/**
 * @param  {...any} args Arguments to log
 */ parcelHelpers.export(exports, "error", ()=>error);
const levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let level = levels.info;
function setLevel(l) {
    level = levels[l];
}
function log(...args) {
    if (level > levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function warn(...args) {
    if (level > levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function error(...args) {
    if (level > levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2SzJN":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj/Projection
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unitsJs = require("./Units.js");
/**
 * The function is called with a `number` view resolution and a
 * {@link module:ol/coordinate~Coordinate} as arguments, and returns the `number` resolution
 * in projection units at the passed coordinate.
 * @typedef {function(number, import("../coordinate.js").Coordinate):number} GetPointResolution
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {GetPointResolution} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * In most cases, you should not need to create instances of this class.
 * Instead, where projection information is required, you can use a string
 * projection code or identifier (e.g. `EPSG:4326`) instead of a projection
 * instance.
 *
 * The library includes support for transforming coordinates between the following
 * projections:
 *
 *  WGS 84 / Geographic - Using codes `EPSG:4326`, `CRS:84`, `urn:ogc:def:crs:EPSG:6.6:4326`,
 *    `urn:ogc:def:crs:OGC:1.3:CRS84`, `urn:ogc:def:crs:OGC:2:84`, `http://www.opengis.net/gml/srs/epsg.xml#4326`,
 *    or `urn:x-ogc:def:crs:EPSG:4326`
 *  WGS 84 / Spherical Mercator - Using codes `EPSG:3857`, `EPSG:102100`, `EPSG:102113`, `EPSG:900913`,
 *    `urn:ogc:def:crs:EPSG:6.18:3:3857`, or `http://www.opengis.net/gml/srs/epsg.xml#3857`
 *  WGS 84 / UTM zones - Using codes `EPSG:32601` through `EPSG:32660` for northern zones
 *    and `EPSG:32701` through `EPSG:32760` for southern zones. Note that the built-in UTM transforms
 *    are lower accuracy (with errors on the order of 0.1 m) than those that you might get in a
 *    library like [proj4js](https://github.com/proj4js/proj4js).
 *
 * For additional projection support, or to use higher accuracy transforms than the built-in ones, you can use
 * the [proj4js](https://github.com/proj4js/proj4js) library. With `proj4js`, after adding any new projection
 * definitions, call the {@link module:ol/proj/proj4.register} function.
 *
 * You can use the {@link module:ol/proj.get} function to retrieve a projection instance
 * for one of the registered projections.
 *
 * @api
 */ class Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {GetPointResolution|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, _unitsJs.METERS_PER_UNIT)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {GetPointResolution|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
exports.default = Projection;

},{"./Units.js":"7FLCv","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7FLCv":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {number} code Unit code.
 * @return {Units} Units.
 */ parcelHelpers.export(exports, "fromCode", ()=>fromCode);
parcelHelpers.export(exports, "METERS_PER_UNIT", ()=>METERS_PER_UNIT);
const unitByCode = {
    '9001': 'm',
    '9002': 'ft',
    '9003': 'us-ft',
    '9101': 'radians',
    '9102': 'degrees'
};
function fromCode(code) {
    return unitByCode[code];
}
const METERS_PER_UNIT = {
    // use the radius of the Normal sphere
    'radians': 6370997 / (2 * Math.PI),
    'degrees': 2 * Math.PI * 6370997 / 360,
    'ft': 0.3048,
    'm': 1,
    'us-ft': 1200 / 3937
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"XXMJe":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj/epsg3857
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIUS", ()=>RADIUS);
parcelHelpers.export(exports, "HALF_SIZE", ()=>HALF_SIZE);
parcelHelpers.export(exports, "EXTENT", ()=>EXTENT);
parcelHelpers.export(exports, "WORLD_EXTENT", ()=>WORLD_EXTENT);
parcelHelpers.export(exports, "MAX_SAFE_Y", ()=>MAX_SAFE_Y);
parcelHelpers.export(exports, "PROJECTIONS", ()=>PROJECTIONS);
/**
 * Transformation from EPSG:4326 to EPSG:3857.
 *
 * @param {Array<number>} input Input array of coordinate values.
 * @param {Array<number>} [output] Output array of coordinate values.
 * @param {number} [dimension] Dimension (default is `2`).
 * @param {number} [stride] Stride (default is `dimension`).
 * @return {Array<number>} Output array of coordinate values.
 */ parcelHelpers.export(exports, "fromEPSG4326", ()=>fromEPSG4326);
/**
 * Transformation from EPSG:3857 to EPSG:4326.
 *
 * @param {Array<number>} input Input array of coordinate values.
 * @param {Array<number>} [output] Output array of coordinate values.
 * @param {number} [dimension] Dimension (default is `2`).
 * @param {number} [stride] Stride (default is `dimension`).
 * @return {Array<number>} Output array of coordinate values.
 */ parcelHelpers.export(exports, "toEPSG4326", ()=>toEPSG4326);
var _projectionJs = require("./Projection.js");
var _projectionJsDefault = parcelHelpers.interopDefault(_projectionJs);
const RADIUS = 6378137;
const HALF_SIZE = Math.PI * RADIUS;
const EXTENT = [
    -HALF_SIZE,
    -HALF_SIZE,
    HALF_SIZE,
    HALF_SIZE
];
const WORLD_EXTENT = [
    -180,
    -85,
    180,
    85
];
const MAX_SAFE_Y = RADIUS * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class EPSG3857Projection extends (0, _projectionJsDefault.default) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: 'm',
            extent: EXTENT,
            global: true,
            worldExtent: WORLD_EXTENT,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / RADIUS);
            }
        });
    }
}
const PROJECTIONS = [
    new EPSG3857Projection('EPSG:3857'),
    new EPSG3857Projection('EPSG:102100'),
    new EPSG3857Projection('EPSG:102113'),
    new EPSG3857Projection('EPSG:900913'),
    new EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function fromEPSG4326(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = HALF_SIZE * input[i] / 180;
        let y = RADIUS * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > MAX_SAFE_Y) y = MAX_SAFE_Y;
        else if (y < -MAX_SAFE_Y) y = -MAX_SAFE_Y;
        output[i + 1] = y;
    }
    return output;
}
function toEPSG4326(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / HALF_SIZE;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / RADIUS)) / Math.PI - 90;
    }
    return output;
}

},{"./Projection.js":"2SzJN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5lBKF":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj/epsg4326
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIUS", ()=>RADIUS);
parcelHelpers.export(exports, "EXTENT", ()=>EXTENT);
parcelHelpers.export(exports, "METERS_PER_UNIT", ()=>METERS_PER_UNIT);
parcelHelpers.export(exports, "PROJECTIONS", ()=>PROJECTIONS);
var _projectionJs = require("./Projection.js");
var _projectionJsDefault = parcelHelpers.interopDefault(_projectionJs);
const RADIUS = 6378137;
const EXTENT = [
    -180,
    -90,
    180,
    90
];
const METERS_PER_UNIT = Math.PI * RADIUS / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class EPSG4326Projection extends (0, _projectionJsDefault.default) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: 'degrees',
            extent: EXTENT,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: METERS_PER_UNIT,
            worldExtent: EXTENT
        });
    }
}
const PROJECTIONS = [
    new EPSG4326Projection('CRS:84'),
    new EPSG4326Projection('EPSG:4326', 'neu'),
    new EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];

},{"./Projection.js":"2SzJN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5I9lt":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Clear the projections cache.
 */ parcelHelpers.export(exports, "clear", ()=>clear);
/**
 * Get a cached projection by code.
 * @param {string} code The code for the projection.
 * @return {import("./Projection.js").default|null} The projection (if cached).
 */ parcelHelpers.export(exports, "get", ()=>get);
/**
 * Add a projection to the cache.
 * @param {string} code The projection code.
 * @param {import("./Projection.js").default} projection The projection to cache.
 */ parcelHelpers.export(exports, "add", ()=>add);
let cache = {};
function clear() {
    cache = {};
}
function get(code) {
    return cache[code] || cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function add(code, projection) {
    cache[code] = projection;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5nKMN":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj/transforms
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Clear the transform cache.
 */ parcelHelpers.export(exports, "clear", ()=>clear);
/**
 * Registers a conversion function to convert coordinates from the source
 * projection to the destination projection.
 *
 * @param {import("./Projection.js").default} source Source.
 * @param {import("./Projection.js").default} destination Destination.
 * @param {import("../proj.js").TransformFunction} transformFn Transform.
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Unregisters the conversion function to convert coordinates from the source
 * projection to the destination projection.  This method is used to clean up
 * cached transforms during testing.
 *
 * @param {import("./Projection.js").default} source Source projection.
 * @param {import("./Projection.js").default} destination Destination projection.
 * @return {import("../proj.js").TransformFunction} transformFn The unregistered transform.
 */ parcelHelpers.export(exports, "remove", ()=>remove);
/**
 * Get a transform given a source code and a destination code.
 * @param {string} sourceCode The code for the source projection.
 * @param {string} destinationCode The code for the destination projection.
 * @return {import("../proj.js").TransformFunction|null} The transform function (if found).
 */ parcelHelpers.export(exports, "get", ()=>get);
var _objJs = require("../obj.js");
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let transforms = {};
function clear() {
    transforms = {};
}
function add(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in transforms)) transforms[sourceCode] = {};
    transforms[sourceCode][destinationCode] = transformFn;
}
function remove(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = transforms[sourceCode][destinationCode];
    delete transforms[sourceCode][destinationCode];
    if ((0, _objJs.isEmpty)(transforms[sourceCode])) delete transforms[sourceCode];
    return transform;
}
function get(sourceCode, destinationCode) {
    if (sourceCode in transforms && destinationCode in transforms[sourceCode]) return transforms[sourceCode][destinationCode];
    return null;
}

},{"../obj.js":"GxveT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fPNPQ":[function(require,module,exports,__globalThis) {
/**
 * @module ol/proj/utm
 */ /**
 * Adapted from https://github.com/Turbo87/utm
 * Copyright (c) 2012-2017 Tobias Bieniek
 *
 * The functions here provide approximate transforms to and from UTM.
 * They are not appropriate for use beyond the validity extend of a UTM
 * zone, and the accuracy of the transform decreases toward the zone
 * edges.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} code The projection code.
 * @return {UTMZone|null} The UTM zone info (or null if not UTM).
 */ parcelHelpers.export(exports, "zoneFromCode", ()=>zoneFromCode);
/**
 * @param {string} code The projection code.
 * @return {import('./Projection.js').default|null} A projection or null if unable to create one.
 */ parcelHelpers.export(exports, "makeProjection", ()=>makeProjection);
/**
 * @param {import('./Projection.js').default} projection The projection.
 * @return {import('../proj.js').Transforms|null} The transforms lookup or null if unable to handle projection.
 */ parcelHelpers.export(exports, "makeTransforms", ()=>makeTransforms);
var _mathJs = require("../math.js");
var _projectionJs = require("./Projection.js");
var _projectionJsDefault = parcelHelpers.interopDefault(_projectionJs);
/**
 * @typedef {Object} UTMZone
 * @property {number} number The zone number (1 - 60).
 * @property {boolean} north The northern hemisphere.
 */ const K0 = 0.9996;
const E = 0.00669438;
const E2 = E * E;
const E3 = E2 * E;
const E_P2 = E / (1 - E);
const SQRT_E = Math.sqrt(1 - E);
const _E = (1 - SQRT_E) / (1 + SQRT_E);
const _E2 = _E * _E;
const _E3 = _E2 * _E;
const _E4 = _E3 * _E;
const _E5 = _E4 * _E;
const M1 = 1 - E / 4 - 3 * E2 / 64 - 5 * E3 / 256;
const M2 = 3 * E / 8 + 3 * E2 / 32 + 45 * E3 / 1024;
const M3 = 15 * E2 / 256 + 45 * E3 / 1024;
const M4 = 35 * E3 / 3072;
const P2 = 1.5 * _E - 27 / 32 * _E3 + 269 / 512 * _E5;
const P3 = 21 / 16 * _E2 - 55 / 32 * _E4;
const P4 = 151 / 96 * _E3 - 417 / 128 * _E5;
const P5 = 1097 / 512 * _E4;
const R = 6378137;
/**
 * @param {number} easting Easting value of coordinate.
 * @param {number} northing Northing value of coordinate.
 * @param {UTMZone} zone The UTM zone.
 * @return {import("../coordinate.js").Coordinate} The transformed coordinate.
 */ function toLonLat(easting, northing, zone) {
    const x = easting - 500000;
    const y = zone.north ? northing : northing - 10000000;
    const m = y / K0;
    const mu = m / (R * M1);
    const pRad = mu + P2 * Math.sin(2 * mu) + P3 * Math.sin(4 * mu) + P4 * Math.sin(6 * mu) + P5 * Math.sin(8 * mu);
    const pSin = Math.sin(pRad);
    const pSin2 = pSin * pSin;
    const pCos = Math.cos(pRad);
    const pTan = pSin / pCos;
    const pTan2 = pTan * pTan;
    const pTan4 = pTan2 * pTan2;
    const epSin = 1 - E * pSin2;
    const epSinSqrt = Math.sqrt(1 - E * pSin2);
    const n = R / epSinSqrt;
    const r = (1 - E) / epSin;
    const c = E_P2 * pCos ** 2;
    const c2 = c * c;
    const d = x / (n * K0);
    const d2 = d * d;
    const d3 = d2 * d;
    const d4 = d3 * d;
    const d5 = d4 * d;
    const d6 = d5 * d;
    const latitude = pRad - pTan / r * (d2 / 2 - d4 / 24 * (5 + 3 * pTan2 + 10 * c - 4 * c2 - 9 * E_P2)) + d6 / 720 * (61 + 90 * pTan2 + 298 * c + 45 * pTan4 - 252 * E_P2 - 3 * c2);
    let longitude = (d - d3 / 6 * (1 + 2 * pTan2 + c) + d5 / 120 * (5 - 2 * c + 28 * pTan2 - 3 * c2 + 8 * E_P2 + 24 * pTan4)) / pCos;
    longitude = (0, _mathJs.wrap)(longitude + (0, _mathJs.toRadians)(zoneToCentralLongitude(zone.number)), -Math.PI, Math.PI);
    return [
        (0, _mathJs.toDegrees)(longitude),
        (0, _mathJs.toDegrees)(latitude)
    ];
}
const MIN_LATITUDE = -80;
const MAX_LATITUDE = 84;
const MIN_LONGITUDE = -180;
const MAX_LONGITUDE = 180;
/**
 * @param {number} longitude The longitude.
 * @param {number} latitude The latitude.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../coordinate.js').Coordinate} The UTM coordinate.
 */ function fromLonLat(longitude, latitude, zone) {
    longitude = (0, _mathJs.wrap)(longitude, MIN_LONGITUDE, MAX_LONGITUDE);
    if (latitude < MIN_LATITUDE) latitude = MIN_LATITUDE;
    else if (latitude > MAX_LATITUDE) latitude = MAX_LATITUDE;
    const latRad = (0, _mathJs.toRadians)(latitude);
    const latSin = Math.sin(latRad);
    const latCos = Math.cos(latRad);
    const latTan = latSin / latCos;
    const latTan2 = latTan * latTan;
    const latTan4 = latTan2 * latTan2;
    const lonRad = (0, _mathJs.toRadians)(longitude);
    const centralLon = zoneToCentralLongitude(zone.number);
    const centralLonRad = (0, _mathJs.toRadians)(centralLon);
    const n = R / Math.sqrt(1 - E * latSin ** 2);
    const c = E_P2 * latCos ** 2;
    const a = latCos * (0, _mathJs.wrap)(lonRad - centralLonRad, -Math.PI, Math.PI);
    const a2 = a * a;
    const a3 = a2 * a;
    const a4 = a3 * a;
    const a5 = a4 * a;
    const a6 = a5 * a;
    const m = R * (M1 * latRad - M2 * Math.sin(2 * latRad) + M3 * Math.sin(4 * latRad) - M4 * Math.sin(6 * latRad));
    const easting = K0 * n * (a + a3 / 6 * (1 - latTan2 + c) + a5 / 120 * (5 - 18 * latTan2 + latTan4 + 72 * c - 58 * E_P2)) + 500000;
    let northing = K0 * (m + n * latTan * (a2 / 2 + a4 / 24 * (5 - latTan2 + 9 * c + 4 * c ** 2) + a6 / 720 * (61 - 58 * latTan2 + latTan4 + 600 * c - 330 * E_P2)));
    if (!zone.north) northing += 10000000;
    return [
        easting,
        northing
    ];
}
/**
 * @param {number} zone The zone number.
 * @return {number} The central longitude in degrees.
 */ function zoneToCentralLongitude(zone) {
    return (zone - 1) * 6 - 180 + 3;
}
/**
 * @type {Array<RegExp>}
 */ const epsgRegExes = [
    /^EPSG:(\d+)$/,
    /^urn:ogc:def:crs:EPSG::(\d+)$/,
    /^http:\/\/www\.opengis\.net\/def\/crs\/EPSG\/0\/(\d+)$/
];
function zoneFromCode(code) {
    let epsgId = 0;
    for (const re of epsgRegExes){
        const match = code.match(re);
        if (match) {
            epsgId = parseInt(match[1]);
            break;
        }
    }
    if (!epsgId) return null;
    let number = 0;
    let north = false;
    if (epsgId > 32700 && epsgId < 32761) number = epsgId - 32700;
    else if (epsgId > 32600 && epsgId < 32661) {
        north = true;
        number = epsgId - 32600;
    }
    if (!number) return null;
    return {
        number,
        north
    };
}
/**
 * @param {function(number, number, UTMZone): import('../coordinate.js').Coordinate} transformer The transformer.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../proj.js').TransformFunction} The transform function.
 */ function makeTransformFunction(transformer, zone) {
    return function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension > 1 ? dimension : 2;
        stride = stride ?? dimension;
        if (!output) {
            if (dimension > 2) output = input.slice();
            else output = new Array(length);
        }
        for(let i = 0; i < length; i += stride){
            const x = input[i];
            const y = input[i + 1];
            const coord = transformer(x, y, zone);
            output[i] = coord[0];
            output[i + 1] = coord[1];
        }
        return output;
    };
}
function makeProjection(code) {
    const zone = zoneFromCode(code);
    if (!zone) return null;
    return new (0, _projectionJsDefault.default)({
        code,
        units: 'm'
    });
}
function makeTransforms(projection) {
    const zone = zoneFromCode(projection.getCode());
    if (!zone) return null;
    return {
        forward: makeTransformFunction(fromLonLat, zone),
        inverse: makeTransformFunction(toLonLat, zone)
    };
}

},{"../math.js":"b3dOZ","./Projection.js":"2SzJN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7TqcG":[function(require,module,exports,__globalThis) {
/**
 * @module ol/transform
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IDENTITY_TRANSFORM", ()=>IDENTITY_TRANSFORM);
/**
 * Create an identity transform.
 * @return {!Transform} Identity transform.
 */ parcelHelpers.export(exports, "create", ()=>create);
/**
 * Resets the given transform to an identity transform.
 * @param {!Transform} transform Transform.
 * @return {!Transform} Transform.
 */ parcelHelpers.export(exports, "reset", ()=>reset);
/**
 * Multiply the underlying matrices of two transforms and return the result in
 * the first transform.
 * @param {!Transform} transform1 Transform parameters of matrix 1.
 * @param {!Transform} transform2 Transform parameters of matrix 2.
 * @return {!Transform} transform1 multiplied with transform2.
 */ parcelHelpers.export(exports, "multiply", ()=>multiply);
/**
 * Set the transform components a-f on a given transform.
 * @param {!Transform} transform Transform.
 * @param {number} a The a component of the transform.
 * @param {number} b The b component of the transform.
 * @param {number} c The c component of the transform.
 * @param {number} d The d component of the transform.
 * @param {number} e The e component of the transform.
 * @param {number} f The f component of the transform.
 * @return {!Transform} Matrix with transform applied.
 */ parcelHelpers.export(exports, "set", ()=>set);
/**
 * Set transform on one matrix from another matrix.
 * @param {!Transform} transform1 Matrix to set transform to.
 * @param {!Transform} transform2 Matrix to set transform from.
 * @return {!Transform} transform1 with transform from transform2 applied.
 */ parcelHelpers.export(exports, "setFromArray", ()=>setFromArray);
/**
 * Transforms the given coordinate with the given transform returning the
 * resulting, transformed coordinate. The coordinate will be modified in-place.
 *
 * @param {Transform} transform The transformation.
 * @param {import("./coordinate.js").Coordinate|import("./pixel.js").Pixel} coordinate The coordinate to transform.
 * @return {import("./coordinate.js").Coordinate|import("./pixel.js").Pixel} return coordinate so that operations can be
 *     chained together.
 */ parcelHelpers.export(exports, "apply", ()=>apply);
/**
 * Applies rotation to the given transform.
 * @param {!Transform} transform Transform.
 * @param {number} angle Angle in radians.
 * @return {!Transform} The rotated transform.
 */ parcelHelpers.export(exports, "rotate", ()=>rotate);
/**
 * Applies scale to a given transform.
 * @param {!Transform} transform Transform.
 * @param {number} x Scale factor x.
 * @param {number} y Scale factor y.
 * @return {!Transform} The scaled transform.
 */ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * Creates a scale transform.
 * @param {!Transform} target Transform to overwrite.
 * @param {number} x Scale factor x.
 * @param {number} y Scale factor y.
 * @return {!Transform} The scale transform.
 */ parcelHelpers.export(exports, "makeScale", ()=>makeScale);
/**
 * Applies translation to the given transform.
 * @param {!Transform} transform Transform.
 * @param {number} dx Translation x.
 * @param {number} dy Translation y.
 * @return {!Transform} The translated transform.
 */ parcelHelpers.export(exports, "translate", ()=>translate);
/**
 * Creates a composite transform given an initial translation, scale, rotation, and
 * final translation (in that order only, not commutative).
 * @param {!Transform} transform The transform (will be modified in place).
 * @param {number} dx1 Initial translation x.
 * @param {number} dy1 Initial translation y.
 * @param {number} sx Scale factor x.
 * @param {number} sy Scale factor y.
 * @param {number} angle Rotation (in counter-clockwise radians).
 * @param {number} dx2 Final translation x.
 * @param {number} dy2 Final translation y.
 * @return {!Transform} The composite transform.
 */ parcelHelpers.export(exports, "compose", ()=>compose);
/**
 * Creates a composite transform given an initial translation, scale, rotation, and
 * final translation (in that order only, not commutative). The resulting transform
 * string can be applied as `transform` property of an HTMLElement's style.
 * @param {number} dx1 Initial translation x.
 * @param {number} dy1 Initial translation y.
 * @param {number} sx Scale factor x.
 * @param {number} sy Scale factor y.
 * @param {number} angle Rotation (in counter-clockwise radians).
 * @param {number} dx2 Final translation x.
 * @param {number} dy2 Final translation y.
 * @return {string} The composite css transform.
 * @api
 */ parcelHelpers.export(exports, "composeCssTransform", ()=>composeCssTransform);
/**
 * Invert the given transform.
 * @param {!Transform} source The source transform to invert.
 * @return {!Transform} The inverted (source) transform.
 */ parcelHelpers.export(exports, "invert", ()=>invert);
/**
 * Invert the given transform.
 * @param {!Transform} target Transform to be set as the inverse of
 *     the source transform.
 * @param {!Transform} source The source transform to invert.
 * @return {!Transform} The inverted (target) transform.
 */ parcelHelpers.export(exports, "makeInverse", ()=>makeInverse);
/**
 * Returns the determinant of the given matrix.
 * @param {!Transform} mat Matrix.
 * @return {number} Determinant.
 */ parcelHelpers.export(exports, "determinant", ()=>determinant);
/**
 * A matrix string version of the transform.  This can be used
 * for CSS transforms.
 * @param {!Transform} mat Matrix.
 * @return {string} The transform as a string.
 */ parcelHelpers.export(exports, "toString", ()=>toString);
/**
 * Create a transform from a CSS transform matrix string.
 * @param {string} cssTransform The CSS string to parse.
 * @return {!Transform} The transform.
 */ parcelHelpers.export(exports, "fromString", ()=>fromString);
/**
 * Compare two matrices for equality.
 * @param {!string} cssTransform1 A CSS transform matrix string.
 * @param {!string} cssTransform2 A CSS transform matrix string.
 * @return {boolean} The two matrices are equal.
 */ parcelHelpers.export(exports, "equivalent", ()=>equivalent);
var _assertsJs = require("./asserts.js");
const IDENTITY_TRANSFORM = [
    1,
    0,
    0,
    1,
    0,
    0
];
/**
 * @private
 * @type {Transform}
 */ const tmp_ = new Array(6);
function create() {
    return IDENTITY_TRANSFORM.slice(0);
}
function reset(transform) {
    return set(transform, 1, 0, 0, 1, 0, 0);
}
function multiply(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function set(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function setFromArray(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function apply(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function rotate(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return multiply(transform, set(tmp_, cos, sin, -sin, cos, 0, 0));
}
function scale(transform, x, y) {
    return multiply(transform, set(tmp_, x, 0, 0, y, 0, 0));
}
function makeScale(target, x, y) {
    return set(target, x, 0, 0, y, 0, 0);
}
function translate(transform, dx, dy) {
    return multiply(transform, set(tmp_, 1, 0, 0, 1, dx, dy));
}
function compose(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function composeCssTransform(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return toString(compose(create(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function invert(source) {
    return makeInverse(source, source);
}
function makeInverse(target, source) {
    const det = determinant(source);
    (0, _assertsJs.assert)(det !== 0, 'Transformation matrix cannot be inverted');
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function determinant(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const matrixPrecision = [
    1e5,
    1e5,
    1e5,
    1e5,
    2,
    2
];
function toString(mat) {
    const transformString = 'matrix(' + mat.join(', ') + ')';
    return transformString;
}
function fromString(cssTransform) {
    const values = cssTransform.substring(7, cssTransform.length - 1).split(',');
    return values.map(parseFloat);
}
function equivalent(cssTransform1, cssTransform2) {
    const mat1 = fromString(cssTransform1);
    const mat2 = fromString(cssTransform2);
    for(let i = 0; i < 6; ++i){
        if (Math.round((mat1[i] - mat2[i]) * matrixPrecision[i]) !== 0) return false;
    }
    return true;
}

},{"./asserts.js":"csqTx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ahZFf":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transform2D", ()=>transform2D);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} angle Angle.
 * @param {Array<number>} anchor Rotation anchor point.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */ parcelHelpers.export(exports, "rotate", ()=>rotate);
/**
 * Scale the coordinates.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} sx Scale factor in the x-direction.
 * @param {number} sy Scale factor in the y-direction.
 * @param {Array<number>} anchor Scale anchor point.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} deltaX Delta X.
 * @param {number} deltaY Delta Y.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */ parcelHelpers.export(exports, "translate", ()=>translate);
function transform2D(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function rotate(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function scale(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function translate(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2VE1b":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearRing", ()=>linearRing);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ parcelHelpers.export(exports, "linearRings", ()=>linearRings);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ parcelHelpers.export(exports, "linearRingss", ()=>linearRingss);
function linearRing(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function linearRings(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += linearRing(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function linearRingss(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += linearRings(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jFnaY":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/closest
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return the squared of the largest distance between any pair of consecutive
 * coordinates.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} max Max squared delta.
 * @return {number} Max squared delta.
 */ parcelHelpers.export(exports, "maxSquaredDelta", ()=>maxSquaredDelta);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} max Max squared delta.
 * @return {number} Max squared delta.
 */ parcelHelpers.export(exports, "arrayMaxSquaredDelta", ()=>arrayMaxSquaredDelta);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} max Max squared delta.
 * @return {number} Max squared delta.
 */ parcelHelpers.export(exports, "multiArrayMaxSquaredDelta", ()=>multiArrayMaxSquaredDelta);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} maxDelta Max delta.
 * @param {boolean} isRing Is ring.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 * @param {number} minSquaredDistance Minimum squared distance.
 * @param {Array<number>} [tmpPoint] Temporary point object.
 * @return {number} Minimum squared distance.
 */ parcelHelpers.export(exports, "assignClosestPoint", ()=>assignClosestPoint);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} maxDelta Max delta.
 * @param {boolean} isRing Is ring.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 * @param {number} minSquaredDistance Minimum squared distance.
 * @param {Array<number>} [tmpPoint] Temporary point object.
 * @return {number} Minimum squared distance.
 */ parcelHelpers.export(exports, "assignClosestArrayPoint", ()=>assignClosestArrayPoint);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} maxDelta Max delta.
 * @param {boolean} isRing Is ring.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 * @param {number} minSquaredDistance Minimum squared distance.
 * @param {Array<number>} [tmpPoint] Temporary point object.
 * @return {number} Minimum squared distance.
 */ parcelHelpers.export(exports, "assignClosestMultiArrayPoint", ()=>assignClosestMultiArrayPoint);
var _mathJs = require("../../math.js");
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, _mathJs.lerp)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function maxSquaredDelta(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, _mathJs.squaredDistance)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function arrayMaxSquaredDelta(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = maxSquaredDelta(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function multiArrayMaxSquaredDelta(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = arrayMaxSquaredDelta(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function assignClosestPoint(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, _mathJs.squaredDistance)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, _mathJs.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, _mathJs.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function assignClosestArrayPoint(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = assignClosestPoint(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function assignClosestMultiArrayPoint(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = assignClosestArrayPoint(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}

},{"../../math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8nFry":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deflateCoordinate", ()=>deflateCoordinate);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<import("../../coordinate.js").Coordinate>} coordinates Coordinates.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ parcelHelpers.export(exports, "deflateCoordinates", ()=>deflateCoordinates);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<import("../../coordinate.js").Coordinate>>} coordinatess Coordinatess.
 * @param {number} stride Stride.
 * @param {Array<number>} [ends] Ends.
 * @return {Array<number>} Ends.
 */ parcelHelpers.export(exports, "deflateCoordinatesArray", ()=>deflateCoordinatesArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} coordinatesss Coordinatesss.
 * @param {number} stride Stride.
 * @param {Array<Array<number>>} [endss] Endss.
 * @return {Array<Array<number>>} Endss.
 */ parcelHelpers.export(exports, "deflateMultiCoordinatesArray", ()=>deflateMultiCoordinatesArray);
function deflateCoordinate(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function deflateCoordinates(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function deflateCoordinatesArray(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = deflateCoordinates(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function deflateMultiCoordinatesArray(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = deflateCoordinatesArray(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ainGz":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inflateCoordinates", ()=>inflateCoordinates);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {Array<Array<import("../../coordinate.js").Coordinate>>} [coordinatess] Coordinatess.
 * @return {Array<Array<import("../../coordinate.js").Coordinate>>} Coordinatess.
 */ parcelHelpers.export(exports, "inflateCoordinatesArray", ()=>inflateCoordinatesArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} [coordinatesss]
 *     Coordinatesss.
 * @return {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} Coordinatesss.
 */ parcelHelpers.export(exports, "inflateMultiCoordinatesArray", ()=>inflateMultiCoordinatesArray);
function inflateCoordinates(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function inflateCoordinatesArray(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = inflateCoordinates(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function inflateMultiCoordinatesArray(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : inflateCoordinatesArray(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9jzv1":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/intersectsextent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @param {import('../../extent.js').Extent} [coordinatesExtent] Coordinates extent
 * @return {boolean} True if the geometry and the extent intersect.
 */ parcelHelpers.export(exports, "intersectsLineString", ()=>intersectsLineString);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */ parcelHelpers.export(exports, "intersectsLineStringArray", ()=>intersectsLineStringArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */ parcelHelpers.export(exports, "intersectsLinearRing", ()=>intersectsLinearRing);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */ parcelHelpers.export(exports, "intersectsLinearRingArray", ()=>intersectsLinearRingArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */ parcelHelpers.export(exports, "intersectsLinearRingMultiArray", ()=>intersectsLinearRingMultiArray);
var _extentJs = require("../../extent.js");
var _containsJs = require("./contains.js");
var _segmentsJs = require("./segments.js");
function intersectsLineString(flatCoordinates, offset, end, stride, extent, coordinatesExtent) {
    coordinatesExtent = coordinatesExtent ?? (0, _extentJs.extendFlatCoordinates)((0, _extentJs.createEmpty)(), flatCoordinates, offset, end, stride);
    if (!(0, _extentJs.intersects)(extent, coordinatesExtent)) return false;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2] || coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, _segmentsJs.forEach)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, _extentJs.intersectsSegment)(extent, point1, point2);
    });
}
function intersectsLineStringArray(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if (intersectsLineString(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function intersectsLinearRing(flatCoordinates, offset, end, stride, extent) {
    if (intersectsLineString(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, _containsJs.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, _containsJs.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, _containsJs.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, _containsJs.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function intersectsLinearRingArray(flatCoordinates, offset, ends, stride, extent) {
    if (!intersectsLinearRing(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, _containsJs.linearRingContainsExtent)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!intersectsLineString(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function intersectsLinearRingMultiArray(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (intersectsLinearRingArray(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}

},{"../../extent.js":"MPjK5","./contains.js":"5TUtI","./segments.js":"bEawF","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5TUtI":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/contains
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} Contains extent.
 */ parcelHelpers.export(exports, "linearRingContainsExtent", ()=>linearRingContainsExtent);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */ parcelHelpers.export(exports, "linearRingContainsXY", ()=>linearRingContainsXY);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */ parcelHelpers.export(exports, "linearRingsContainsXY", ()=>linearRingsContainsXY);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */ parcelHelpers.export(exports, "linearRingssContainsXY", ()=>linearRingssContainsXY);
var _extentJs = require("../../extent.js");
function linearRingContainsExtent(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, _extentJs.forEachCorner)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !linearRingContainsXY(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function linearRingContainsXY(flatCoordinates, offset, end, stride, x, y) {
    // https://web.archive.org/web/20210504233957/http://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!linearRingContainsXY(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if (linearRingContainsXY(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function linearRingssContainsXY(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}

},{"../../extent.js":"MPjK5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bEawF":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forEach", ()=>forEach);
/**
 * Calculate the intersection point of two line segments.
 * Reference: https://stackoverflow.com/a/72474223/2389327
 * @param {Array<import("../../coordinate.js").Coordinate>} segment1 The first line segment as an array of two points.
 * @param {Array<import("../../coordinate.js").Coordinate>} segment2 The second line segment as an array of two points.
 * @return {import("../../coordinate.js").Coordinate|undefined} The intersection point or `undefined` if no intersection.
 */ parcelHelpers.export(exports, "getIntersectionPoint", ()=>getIntersectionPoint);
function forEach(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}
function getIntersectionPoint(segment1, segment2) {
    const [a, b] = segment1;
    const [c, d] = segment2;
    const t = ((a[0] - c[0]) * (c[1] - d[1]) - (a[1] - c[1]) * (c[0] - d[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    const u = ((a[0] - c[0]) * (a[1] - b[1]) - (a[1] - c[1]) * (a[0] - b[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    // Check if lines actually intersect
    if (0 <= t && t <= 1 && 0 <= u && u <= 1) return [
        a[0] + t * (b[0] - a[0]),
        a[1] + t * (b[1] - a[1])
    ];
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5VJXL":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {boolean} highQuality Highest quality.
 * @param {Array<number>} [simplifiedFlatCoordinates] Simplified flat
 *     coordinates.
 * @return {Array<number>} Simplified line string.
 */ parcelHelpers.export(exports, "simplifyLineString", ()=>simplifyLineString);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @return {number} Simplified offset.
 */ parcelHelpers.export(exports, "douglasPeucker", ()=>douglasPeucker);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<number>} simplifiedEnds Simplified ends.
 * @return {number} Simplified offset.
 */ parcelHelpers.export(exports, "douglasPeuckerArray", ()=>douglasPeuckerArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<Array<number>>} simplifiedEndss Simplified endss.
 * @return {number} Simplified offset.
 */ parcelHelpers.export(exports, "douglasPeuckerMultiArray", ()=>douglasPeuckerMultiArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @return {number} Simplified offset.
 */ parcelHelpers.export(exports, "radialDistance", ()=>radialDistance);
/**
 * @param {number} value Value.
 * @param {number} tolerance Tolerance.
 * @return {number} Rounded value.
 */ parcelHelpers.export(exports, "snap", ()=>snap);
/**
 * Simplifies a line string using an algorithm designed by Tim Schaub.
 * Coordinates are snapped to the nearest value in a virtual grid and
 * consecutive duplicate coordinates are discarded.  This effectively preserves
 * topology as the simplification of any subsection of a line string is
 * independent of the rest of the line string.  This means that, for examples,
 * the common edge between two polygons will be simplified to the same line
 * string independently in both polygons.  This implementation uses a single
 * pass over the coordinates and eliminates intermediate collinear points.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} tolerance Tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @return {number} Simplified offset.
 */ parcelHelpers.export(exports, "quantize", ()=>quantize);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} tolerance Tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<number>} simplifiedEnds Simplified ends.
 * @return {number} Simplified offset.
 */ parcelHelpers.export(exports, "quantizeArray", ()=>quantizeArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} tolerance Tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<Array<number>>} simplifiedEndss Simplified endss.
 * @return {number} Simplified offset.
 */ parcelHelpers.export(exports, "quantizeMultiArray", ()=>quantizeMultiArray);
var _mathJs = require("../../math.js");
function simplifyLineString(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = radialDistance(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = douglasPeucker(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function douglasPeucker(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, _mathJs.squaredSegmentDistance)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function douglasPeuckerArray(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = douglasPeucker(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function douglasPeuckerMultiArray(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = douglasPeuckerArray(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function radialDistance(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, _mathJs.squaredDistance)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function snap(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function quantize(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = snap(flatCoordinates[offset], tolerance);
    let y1 = snap(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = snap(flatCoordinates[offset], tolerance);
        y2 = snap(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = snap(flatCoordinates[offset], tolerance);
        const y3 = snap(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function quantizeArray(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = quantize(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function quantizeMultiArray(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = quantizeArray(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}

},{"../../math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"95T6m":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/Point
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _deflateJs = require("./flat/deflate.js");
/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class Point extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, _mathJs.squaredDistance)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, _extentJs.createOrUpdateFromCoordinate)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Point';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, _extentJs.containsXY)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, _deflateJs.deflateCoordinate)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
exports.default = Point;

},{"../extent.js":"MPjK5","../math.js":"b3dOZ","./SimpleGeometry.js":"5Lm1Z","./flat/deflate.js":"8nFry","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jo2rT":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/interiorpoint
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calculates a point that is likely to lie in the interior of the linear rings.
 * Inspired by JTS's com.vividsolutions.jts.geom.Geometry#getInteriorPoint.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {Array<number>} flatCenters Flat centers.
 * @param {number} flatCentersOffset Flat center offset.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Destination point as XYM coordinate, where M is the
 * length of the horizontal intersection that the point belongs to.
 */ parcelHelpers.export(exports, "getInteriorPointOfArray", ()=>getInteriorPointOfArray);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {Array<number>} flatCenters Flat centers.
 * @return {Array<number>} Interior points as XYM coordinates, where M is the
 * length of the horizontal intersection that the point belongs to.
 */ parcelHelpers.export(exports, "getInteriorPointsOfMultiArray", ()=>getInteriorPointsOfMultiArray);
var _arrayJs = require("../../array.js");
var _containsJs = require("./contains.js");
function getInteriorPointOfArray(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, _arrayJs.ascending));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, _containsJs.linearRingsContainsXY)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function getInteriorPointsOfMultiArray(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = getInteriorPointOfArray(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}

},{"../../array.js":"2IuG2","./contains.js":"5TUtI","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1iFdH":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/orient
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Is the linear ring oriented clockwise in a coordinate system with a bottom-left
 * coordinate origin? For a coordinate system with a top-left coordinate origin,
 * the ring's orientation is clockwise when this function returns false.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {boolean|undefined} Is clockwise.
 */ parcelHelpers.export(exports, "linearRingIsClockwise", ()=>linearRingIsClockwise);
/**
 * Determines if linear rings are oriented.  By default, left-hand orientation
 * is tested (first ring must be clockwise, remaining rings counter-clockwise).
 * To test for right-hand orientation, use the `right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Array of end indexes.
 * @param {number} stride Stride.
 * @param {boolean} [right] Test for right-hand orientation
 *     (counter-clockwise exterior ring and clockwise interior rings).
 * @return {boolean} Rings are correctly oriented.
 */ parcelHelpers.export(exports, "linearRingsAreOriented", ()=>linearRingsAreOriented);
/**
 * Determines if linear rings are oriented.  By default, left-hand orientation
 * is tested (first ring must be clockwise, remaining rings counter-clockwise).
 * To test for right-hand orientation, use the `right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Array of array of end indexes.
 * @param {number} stride Stride.
 * @param {boolean} [right] Test for right-hand orientation
 *     (counter-clockwise exterior ring and clockwise interior rings).
 * @return {boolean} Rings are correctly oriented.
 */ parcelHelpers.export(exports, "linearRingssAreOriented", ()=>linearRingssAreOriented);
/**
 * Orient coordinates in a flat array of linear rings.  By default, rings
 * are oriented following the left-hand rule (clockwise for exterior and
 * counter-clockwise for interior rings).  To orient according to the
 * right-hand rule, use the `right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {boolean} [right] Follow the right-hand rule for orientation.
 * @return {number} End.
 */ parcelHelpers.export(exports, "orientLinearRings", ()=>orientLinearRings);
/**
 * Orient coordinates in a flat array of linear rings.  By default, rings
 * are oriented following the left-hand rule (clockwise for exterior and
 * counter-clockwise for interior rings).  To orient according to the
 * right-hand rule, use the `right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Array of array of end indexes.
 * @param {number} stride Stride.
 * @param {boolean} [right] Follow the right-hand rule for orientation.
 * @return {number} End.
 */ parcelHelpers.export(exports, "orientLinearRingsArray", ()=>orientLinearRingsArray);
/**
 * Return a two-dimensional endss
 * @param {Array<number>} flatCoordinates Flat coordinates
 * @param {Array<number>} ends Linear ring end indexes
 * @return {Array<Array<number>>} Two dimensional endss array that can
 * be used to construct a MultiPolygon
 */ parcelHelpers.export(exports, "inflateEnds", ()=>inflateEnds);
var _reverseJs = require("./reverse.js");
function linearRingIsClockwise(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function linearRingsAreOriented(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = linearRingIsClockwise(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function linearRingssAreOriented(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!linearRingsAreOriented(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function orientLinearRings(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = linearRingIsClockwise(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, _reverseJs.coordinates)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function orientLinearRingsArray(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = orientLinearRings(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function inflateEnds(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = linearRingIsClockwise(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}

},{"./reverse.js":"bL4Wy","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bL4Wy":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "coordinates", ()=>coordinates);
function coordinates(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7p0AI":[function(require,module,exports,__globalThis) {
/**
 * @module ol/resolutionconstraint
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<number>} resolutions Resolutions.
 * @param {boolean} [smooth] If true, the view will be able to slightly exceed resolution limits. Default: true.
 * @param {import("./extent.js").Extent} [maxExtent] Maximum allowed extent.
 * @param {boolean} [showFullExtent] If true, allows us to show the full extent. Default: false.
 * @return {Type} Zoom function.
 */ parcelHelpers.export(exports, "createSnapToResolutions", ()=>createSnapToResolutions);
/**
 * @param {number} power Power.
 * @param {number} maxResolution Maximum resolution.
 * @param {number} [minResolution] Minimum resolution.
 * @param {boolean} [smooth] If true, the view will be able to slightly exceed resolution limits. Default: true.
 * @param {import("./extent.js").Extent} [maxExtent] Maximum allowed extent.
 * @param {boolean} [showFullExtent] If true, allows us to show the full extent. Default: false.
 * @return {Type} Zoom function.
 */ parcelHelpers.export(exports, "createSnapToPower", ()=>createSnapToPower);
/**
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @param {boolean} [smooth] If true, the view will be able to slightly exceed resolution limits. Default: true.
 * @param {import("./extent.js").Extent} [maxExtent] Maximum allowed extent.
 * @param {boolean} [showFullExtent] If true, allows us to show the full extent. Default: false.
 * @return {Type} Zoom function.
 */ parcelHelpers.export(exports, "createMinMaxResolution", ()=>createMinMaxResolution);
var _arrayJs = require("./array.js");
var _extentJs = require("./extent.js");
var _mathJs = require("./math.js");
/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, _extentJs.getWidth)(maxExtent) / viewportSize[0];
    const yResolution = (0, _extentJs.getHeight)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, _mathJs.clamp)(result, minResolution / 2, maxResolution * 2);
}
function createSnapToResolutions(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, _mathJs.clamp)(resolution, minResolution, cappedMaxRes);
                return getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, _arrayJs.linearFindNearest)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function createSnapToPower(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, _mathJs.clamp)(resolution, minResolution, cappedMaxRes);
                return getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, _mathJs.clamp)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function createMinMaxResolution(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, _mathJs.clamp)(resolution, minResolution, cappedMaxRes);
            return getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}

},{"./array.js":"2IuG2","./extent.js":"MPjK5","./math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"faoMn":[function(require,module,exports,__globalThis) {
/**
 * @module ol/rotationconstraint
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {function((number|undefined), boolean=): (number|undefined)} Type
 */ /**
 * @param {number|undefined} rotation Rotation.
 * @return {number|undefined} Rotation.
 */ parcelHelpers.export(exports, "disable", ()=>disable);
/**
 * @param {number|undefined} rotation Rotation.
 * @return {number|undefined} Rotation.
 */ parcelHelpers.export(exports, "none", ()=>none);
/**
 * @param {number} n N.
 * @return {Type} Rotation constraint.
 */ parcelHelpers.export(exports, "createSnapToN", ()=>createSnapToN);
/**
 * @param {number} [tolerance] Tolerance.
 * @return {Type} Rotation constraint.
 */ parcelHelpers.export(exports, "createSnapToZero", ()=>createSnapToZero);
var _mathJs = require("./math.js");
function disable(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function none(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function createSnapToN(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function createSnapToZero(tolerance) {
    const t = tolerance === undefined ? (0, _mathJs.toRadians)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}

},{"./math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bFvtm":[function(require,module,exports,__globalThis) {
/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MAX_ZOOM", ()=>DEFAULT_MAX_ZOOM);
parcelHelpers.export(exports, "DEFAULT_TILE_SIZE", ()=>DEFAULT_TILE_SIZE);
const DEFAULT_MAX_ZOOM = 42;
const DEFAULT_TILE_SIZE = 256;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8Xvbb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/control/defaults
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} DefaultsOptions
 * @property {boolean} [attribution=true] Include
 * {@link module:ol/control/Attribution~Attribution}.
 * @property {import("./Attribution.js").Options} [attributionOptions]
 * Options for {@link module:ol/control/Attribution~Attribution}.
 * @property {boolean} [rotate=true] Include
 * {@link module:ol/control/Rotate~Rotate}.
 * @property {import("./Rotate.js").Options} [rotateOptions] Options
 * for {@link module:ol/control/Rotate~Rotate}.
 * @property {boolean} [zoom] Include {@link module:ol/control/Zoom~Zoom}.
 * @property {import("./Zoom.js").Options} [zoomOptions] Options for
 * {@link module:ol/control/Zoom~Zoom}.
 */ /**
 * Set of controls included in maps by default. Unless configured otherwise,
 * this returns a collection containing an instance of each of the following
 * controls:
 * {@link module:ol/control/Zoom~Zoom}
 * {@link module:ol/control/Rotate~Rotate}
 * {@link module:ol/control/Attribution~Attribution}
 *
 * @param {DefaultsOptions} [options] Options for the default controls.
 * @return {Collection<import("./Control.js").default>} A collection of controls
 * to be used with the {@link module:ol/Map~Map} constructor's `controls` option.
 * @api
 */ parcelHelpers.export(exports, "defaults", ()=>defaults);
var _collectionJs = require("../Collection.js");
var _collectionJsDefault = parcelHelpers.interopDefault(_collectionJs);
var _attributionJs = require("./Attribution.js");
var _attributionJsDefault = parcelHelpers.interopDefault(_attributionJs);
var _rotateJs = require("./Rotate.js");
var _rotateJsDefault = parcelHelpers.interopDefault(_rotateJs);
var _zoomJs = require("./Zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
function defaults(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, _collectionJsDefault.default)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, _zoomJsDefault.default)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, _rotateJsDefault.default)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, _attributionJsDefault.default)(options.attributionOptions));
    return controls;
}

},{"../Collection.js":"8dtMA","./Attribution.js":"3Tuc5","./Rotate.js":"6m2Ug","./Zoom.js":"9dXKz","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3Tuc5":[function(require,module,exports,__globalThis) {
/**
 * @module ol/control/Attribution
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../array.js");
var _cssJs = require("../css.js");
var _domJs = require("../dom.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _functionsJs = require("../functions.js");
var _controlJs = require("./Control.js");
var _controlJsDefault = parcelHelpers.interopDefault(_controlJs);
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered.
 * **Caution:** Attributions are rendered dynamically using `innerHTML`, which can lead to potential
 * [**XSS (Cross-Site Scripting)**](https://en.wikipedia.org/wiki/Cross-site_scripting) vulnerabilities.
 * Use this feature only for trusted content
 * or ensure that the content is properly sanitized before inserting it.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class Attribution extends (0, _controlJsDefault.default) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement('ul');
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : 'ol-attribution';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement('button');
        this.toggleButton_.setAttribute('type', 'button');
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, _eventTypeJsDefault.default).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, _cssJs.CLASS_UNSELECTABLE) + ' ' + (0, _cssJs.CLASS_CONTROL) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, _cssJs.CLASS_COLLAPSED) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, _functionsJs.toPromise)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, _arrayJs.equals)(attributions, this.renderedAttributions_)) return;
        (0, _domJs.removeChildren)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, _cssJs.CLASS_COLLAPSED));
        if (this.collapsed_) (0, _domJs.replaceNode)(this.collapseLabel_, this.label_);
        else (0, _domJs.replaceNode)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
exports.default = Attribution;

},{"../array.js":"2IuG2","../css.js":"eP7Pk","../dom.js":"gfuif","../events/EventType.js":"79Bvl","../functions.js":"5nAKV","./Control.js":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eP7Pk":[function(require,module,exports,__globalThis) {
/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLASS_HIDDEN", ()=>CLASS_HIDDEN);
parcelHelpers.export(exports, "CLASS_SELECTABLE", ()=>CLASS_SELECTABLE);
parcelHelpers.export(exports, "CLASS_UNSELECTABLE", ()=>CLASS_UNSELECTABLE);
parcelHelpers.export(exports, "CLASS_UNSUPPORTED", ()=>CLASS_UNSUPPORTED);
parcelHelpers.export(exports, "CLASS_CONTROL", ()=>CLASS_CONTROL);
parcelHelpers.export(exports, "CLASS_COLLAPSED", ()=>CLASS_COLLAPSED);
parcelHelpers.export(exports, "fontWeights", ()=>fontWeights);
parcelHelpers.export(exports, "getFontParameters", ()=>getFontParameters);
const CLASS_HIDDEN = 'ol-hidden';
const CLASS_SELECTABLE = 'ol-selectable';
const CLASS_UNSELECTABLE = 'ol-unselectable';
const CLASS_UNSUPPORTED = 'ol-unsupported';
const CLASS_CONTROL = 'ol-control';
const CLASS_COLLAPSED = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z0-9]+?)\\s*$'
].join(''), 'i');
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
const fontWeights = {
    normal: 400,
    bold: 700
};
const getFontParameters = function(fontSpec) {
    const match = fontSpec.match(fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: '400',
        variant: 'normal'
    };
    for(let i = 0, ii = fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[fontRegExMatchIndex[i]] = typeof value === 'string' ? value.trim() : value;
    }
    if (isNaN(Number(style.weight)) && style.weight in fontWeights) style.weight = fontWeights[style.weight];
    style.families = style.family.split(/,\s?/).map((f)=>f.trim().replace(/^['"]|['"]$/g, ''));
    return style;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gfuif":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @module ol/dom
 */ /**
 * @typedef {Object} ImageAttributes
 * @property {string|null} [crossOrigin] Cross origin.
 * @property {ReferrerPolicy} [referrerPolicy]  Referrer policy.
 */ //FIXME Move this function to the canvas module
/**
 * Create an html canvas element and returns its 2d context.
 * @param {number} [width] Canvas width.
 * @param {number} [height] Canvas height.
 * @param {Array<HTMLCanvasElement|OffscreenCanvas>} [canvasPool] Canvas pool to take existing canvas from.
 * @param {CanvasRenderingContext2DSettings} [settings] CanvasRenderingContext2DSettings
 * @return {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} The context.
 */ parcelHelpers.export(exports, "createCanvasContext2D", ()=>createCanvasContext2D);
/**
 * @return {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} Shared canvas context.
 */ parcelHelpers.export(exports, "getSharedCanvasContext2D", ()=>getSharedCanvasContext2D);
/**
 * Releases canvas memory to avoid exceeding memory limits in Safari.
 * See https://pqina.nl/blog/total-canvas-memory-use-exceeds-the-maximum-limit/
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
 */ parcelHelpers.export(exports, "releaseCanvas", ()=>releaseCanvas);
/**
 * Get the current computed width for the given element including margin,
 * padding and border.
 * Equivalent to jQuery's `$(el).outerWidth(true)`.
 * @param {!HTMLElement} element Element.
 * @return {number} The width.
 */ parcelHelpers.export(exports, "outerWidth", ()=>outerWidth);
/**
 * Get the current computed height for the given element including margin,
 * padding and border.
 * Equivalent to jQuery's `$(el).outerHeight(true)`.
 * @param {!HTMLElement} element Element.
 * @return {number} The height.
 */ parcelHelpers.export(exports, "outerHeight", ()=>outerHeight);
/**
 * @param {Node} newNode Node to replace old node
 * @param {Node} oldNode The node to be replaced
 */ parcelHelpers.export(exports, "replaceNode", ()=>replaceNode);
/**
 * @param {Node} node The node to remove the children from.
 */ parcelHelpers.export(exports, "removeChildren", ()=>removeChildren);
/**
 * Transform the children of a parent node so they match the
 * provided list of children.  This function aims to efficiently
 * remove, add, and reorder child nodes while maintaining a simple
 * implementation (it is not guaranteed to minimize DOM operations).
 * @param {Node} node The parent node whose children need reworking.
 * @param {Array<Node>} children The desired children.
 */ parcelHelpers.export(exports, "replaceChildren", ()=>replaceChildren);
/**
 * Creates a minimal structure that mocks a DIV to be used by the composite and
 * layer renderer in a worker environment
 * @return {HTMLDivElement} mocked DIV
 */ parcelHelpers.export(exports, "createMockDiv", ()=>createMockDiv);
/***
 * @param {*} obj The object to check.
 * @return {obj is (HTMLCanvasElement | OffscreenCanvas)} The object is a canvas.
 */ parcelHelpers.export(exports, "isCanvas", ()=>isCanvas);
var _hasJs = require("./has.js");
function createCanvasContext2D(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, _hasJs.WORKER_OFFSCREEN_CANVAS) canvas = new class extends OffscreenCanvas {
        style = {};
    }(width ?? 300, height ?? 150);
    else canvas = document.createElement('canvas');
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    return /** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ canvas.getContext('2d', settings);
}
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let sharedCanvasContext;
function getSharedCanvasContext2D() {
    if (!sharedCanvasContext) sharedCanvasContext = createCanvasContext2D(1, 1);
    return sharedCanvasContext;
}
function releaseCanvas(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function outerWidth(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function outerHeight(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function replaceNode(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function removeChildren(node) {
    while(node.lastChild)node.lastChild.remove();
}
function replaceChildren(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}
function createMockDiv() {
    const mockedDiv = new Proxy({
        /**
       * @type {Array<HTMLElement>}
       */ childNodes: [],
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ appendChild: function(node) {
            this.childNodes.push(node);
            return node;
        },
        /**
       * dummy function, as this structure is not supposed to have a parent.
       */ remove: function() {},
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ removeChild: function(node) {
            const index = this.childNodes.indexOf(node);
            if (index === -1) throw new Error('Node to remove was not found');
            this.childNodes.splice(index, 1);
            return node;
        },
        /**
       * @param {HTMLElement} newNode new html node.
       * @param {HTMLElement} referenceNode reference html node.
       * @return {HTMLElement} new html node.
       */ insertBefore: function(newNode, referenceNode) {
            const index = this.childNodes.indexOf(referenceNode);
            if (index === -1) throw new Error('Reference node not found');
            this.childNodes.splice(index, 0, newNode);
            return newNode;
        },
        style: {}
    }, {
        get (target, prop, receiver) {
            if (prop === 'firstElementChild') return target.childNodes.length > 0 ? target.childNodes[0] : null;
            return Reflect.get(target, prop, receiver);
        }
    });
    return /** @type {*} */ mockedDiv;
}
function isCanvas(obj) {
    return typeof HTMLCanvasElement !== 'undefined' && obj instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && obj instanceof OffscreenCanvas;
}

},{"./has.js":"hbGE6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8KSMn":[function(require,module,exports,__globalThis) {
/**
 * @module ol/control/Control
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapEventTypeJs = require("../MapEventType.js");
var _mapEventTypeJsDefault = parcelHelpers.interopDefault(_mapEventTypeJs);
var _objectJs = require("../Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _eventsJs = require("../events.js");
var _functionsJs = require("../functions.js");
/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class Control extends (0, _objectJsDefault.default) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, _eventsJs.unlistenByKey)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            if (this.element) target.appendChild(this.element);
            if (this.render !== (0, _functionsJs.VOID)) this.listenerKeys.push((0, _eventsJs.listen)(map, (0, _mapEventTypeJsDefault.default).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    }
}
exports.default = Control;

},{"../MapEventType.js":"aBTDg","../Object.js":"lFhbz","../events.js":"Vqr1Z","../functions.js":"5nAKV","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6m2Ug":[function(require,module,exports,__globalThis) {
/**
 * @module ol/control/Rotate
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssJs = require("../css.js");
var _easingJs = require("../easing.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _controlJs = require("./Control.js");
var _controlJsDefault = parcelHelpers.interopDefault(_controlJs);
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class Rotate extends (0, _controlJsDefault.default) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-rotate';
        const label = options.label !== undefined ? options.label : '\u21E7';
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === 'string') {
            this.label_ = document.createElement('span');
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        const button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, _eventTypeJsDefault.default).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, _cssJs.CLASS_UNSELECTABLE) + ' ' + (0, _cssJs.CLASS_CONTROL);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, _cssJs.CLASS_HIDDEN));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, _easingJs.easeOut)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, _cssJs.CLASS_HIDDEN));
                if (!contains && rotation === 0) this.element.classList.add((0, _cssJs.CLASS_HIDDEN));
                else if (contains && rotation !== 0) this.element.classList.remove((0, _cssJs.CLASS_HIDDEN));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
exports.default = Rotate;

},{"../css.js":"eP7Pk","../easing.js":"1AzsJ","../events/EventType.js":"79Bvl","./Control.js":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9dXKz":[function(require,module,exports,__globalThis) {
/**
 * @module ol/control/Zoom
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssJs = require("../css.js");
var _easingJs = require("../easing.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _controlJs = require("./Control.js");
var _controlJsDefault = parcelHelpers.interopDefault(_controlJs);
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class Zoom extends (0, _controlJsDefault.default) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-zoom';
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        const inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, _eventTypeJsDefault.default).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, _eventTypeJsDefault.default).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + ' ' + (0, _cssJs.CLASS_UNSELECTABLE) + ' ' + (0, _cssJs.CLASS_CONTROL);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, _easingJs.easeOut)
                });
            } else view.setZoom(newZoom);
        }
    }
}
exports.default = Zoom;

},{"../css.js":"eP7Pk","../easing.js":"1AzsJ","../events/EventType.js":"79Bvl","./Control.js":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gLSfG":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/defaults
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} DefaultsOptions
 * @property {boolean} [altShiftDragRotate=true] Whether Alt-Shift-drag rotate is
 * desired.
 * @property {boolean} [onFocusOnly=false] Interact only when the map has the
 * focus. This affects the `MouseWheelZoom` and `DragPan` interactions and is
 * useful when page scroll is desired for maps that do not have the browser's
 * focus.
 * @property {boolean} [doubleClickZoom=true] Whether double click zoom is
 * desired.
 * @property {boolean} [keyboard=true] Whether keyboard interaction is desired.
 * @property {boolean} [mouseWheelZoom=true] Whether mousewheel zoom is desired.
 * @property {boolean} [shiftDragZoom=true] Whether Shift-drag zoom is desired.
 * @property {boolean} [dragPan=true] Whether drag pan is desired.
 * @property {boolean} [pinchRotate=true] Whether pinch rotate is desired.
 * @property {boolean} [pinchZoom=true] Whether pinch zoom is desired.
 * @property {number} [zoomDelta] Zoom level delta when using keyboard or double click zoom.
 * @property {number} [zoomDuration] Duration of the zoom animation in
 * milliseconds.
 */ /**
 * Set of interactions included in maps by default. Specific interactions can be
 * excluded by setting the appropriate option to false in the constructor
 * options, but the order of the interactions is fixed.  If you want to specify
 * a different order for interactions, you will need to create your own
 * {@link module:ol/interaction/Interaction~Interaction} instances and insert
 * them into a {@link module:ol/Collection~Collection} in the order you want
 * before creating your {@link module:ol/Map~Map} instance. Changing the order can
 * be of interest if the event propagation needs to be stopped at a point.
 * The default set of interactions, in sequence, is:
 * {@link module:ol/interaction/DragRotate~DragRotate}
 * {@link module:ol/interaction/DoubleClickZoom~DoubleClickZoom}
 * {@link module:ol/interaction/DragPan~DragPan}
 * {@link module:ol/interaction/PinchRotate~PinchRotate}
 * {@link module:ol/interaction/PinchZoom~PinchZoom}
 * {@link module:ol/interaction/KeyboardPan~KeyboardPan}
 * {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}
 * {@link module:ol/interaction/MouseWheelZoom~MouseWheelZoom}
 * {@link module:ol/interaction/DragZoom~DragZoom}
 *
 * @param {DefaultsOptions} [options] Defaults options.
 * @return {Collection<import("./Interaction.js").default>}
 * A collection of interactions to be used with the {@link module:ol/Map~Map}
 * constructor's `interactions` option.
 * @api
 */ parcelHelpers.export(exports, "defaults", ()=>defaults);
var _collectionJs = require("../Collection.js");
var _collectionJsDefault = parcelHelpers.interopDefault(_collectionJs);
var _kineticJs = require("../Kinetic.js");
var _kineticJsDefault = parcelHelpers.interopDefault(_kineticJs);
var _doubleClickZoomJs = require("./DoubleClickZoom.js");
var _doubleClickZoomJsDefault = parcelHelpers.interopDefault(_doubleClickZoomJs);
var _dragPanJs = require("./DragPan.js");
var _dragPanJsDefault = parcelHelpers.interopDefault(_dragPanJs);
var _dragRotateJs = require("./DragRotate.js");
var _dragRotateJsDefault = parcelHelpers.interopDefault(_dragRotateJs);
var _dragZoomJs = require("./DragZoom.js");
var _dragZoomJsDefault = parcelHelpers.interopDefault(_dragZoomJs);
var _keyboardPanJs = require("./KeyboardPan.js");
var _keyboardPanJsDefault = parcelHelpers.interopDefault(_keyboardPanJs);
var _keyboardZoomJs = require("./KeyboardZoom.js");
var _keyboardZoomJsDefault = parcelHelpers.interopDefault(_keyboardZoomJs);
var _mouseWheelZoomJs = require("./MouseWheelZoom.js");
var _mouseWheelZoomJsDefault = parcelHelpers.interopDefault(_mouseWheelZoomJs);
var _pinchRotateJs = require("./PinchRotate.js");
var _pinchRotateJsDefault = parcelHelpers.interopDefault(_pinchRotateJs);
var _pinchZoomJs = require("./PinchZoom.js");
var _pinchZoomJsDefault = parcelHelpers.interopDefault(_pinchZoomJs);
function defaults(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, _collectionJsDefault.default)();
    const kinetic = new (0, _kineticJsDefault.default)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, _dragRotateJsDefault.default)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, _doubleClickZoomJsDefault.default)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, _dragPanJsDefault.default)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, _pinchRotateJsDefault.default)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, _pinchZoomJsDefault.default)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, _keyboardPanJsDefault.default)());
        interactions.push(new (0, _keyboardZoomJsDefault.default)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, _mouseWheelZoomJsDefault.default)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, _dragZoomJsDefault.default)({
        duration: options.zoomDuration
    }));
    return interactions;
}

},{"../Collection.js":"8dtMA","../Kinetic.js":"6V9Oq","./DoubleClickZoom.js":"e4k2h","./DragPan.js":"9rZ3D","./DragRotate.js":"1sWlR","./DragZoom.js":"k3jrt","./KeyboardPan.js":"aOPFA","./KeyboardZoom.js":"bIfPb","./MouseWheelZoom.js":"iUPNQ","./PinchRotate.js":"2xvPv","./PinchZoom.js":"7Rvxp","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6V9Oq":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
exports.default = Kinetic;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e4k2h":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/DoubleClickZoom
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapBrowserEventTypeJs = require("../MapBrowserEventType.js");
var _mapBrowserEventTypeJsDefault = parcelHelpers.interopDefault(_mapBrowserEventTypeJs);
var _interactionJs = require("./Interaction.js");
var _interactionJsDefault = parcelHelpers.interopDefault(_interactionJs);
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class DoubleClickZoom extends (0, _interactionJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, _interactionJs.zoomByDelta)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
exports.default = DoubleClickZoom;

},{"../MapBrowserEventType.js":"dp3yB","./Interaction.js":"1QCYK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1QCYK":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/Interaction
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {import("../View.js").default} view View.
 * @param {import("../coordinate.js").Coordinate} delta Delta.
 * @param {number} [duration] Duration.
 */ parcelHelpers.export(exports, "pan", ()=>pan);
/**
 * @param {import("../View.js").default} view View.
 * @param {number} delta Delta from previous zoom level.
 * @param {import("../coordinate.js").Coordinate} [anchor] Anchor coordinate in the user projection.
 * @param {number} [duration] Duration.
 */ parcelHelpers.export(exports, "zoomByDelta", ()=>zoomByDelta);
var _objectJs = require("../Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _easingJs = require("../easing.js");
var _propertyJs = require("./Property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types|
 *     'change:active', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class Interaction extends (0, _objectJsDefault.default) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, _propertyJsDefault.default).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, _propertyJsDefault.default).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function pan(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, _easingJs.linear),
            center: view.getConstrainedCenter(center)
        });
    }
}
function zoomByDelta(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, _easingJs.easeOut)
    });
}
exports.default = Interaction;

},{"../Object.js":"lFhbz","../easing.js":"1AzsJ","./Property.js":"4UwNl","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4UwNl":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    ACTIVE: 'active'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9rZ3D":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/DragPan
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coordinateJs = require("../coordinate.js");
var _easingJs = require("../easing.js");
var _conditionJs = require("../events/condition.js");
var _functionsJs = require("../functions.js");
var _pointerJs = require("./Pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class DragPan extends (0, _pointerJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, _functionsJs.FALSE)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, _conditionJs.all)((0, _conditionJs.noModifierKeys), (0, _conditionJs.primaryAction));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, _conditionJs.all)((0, _conditionJs.focusWithTabindex), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, _pointerJs.centroid)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, _coordinateJs.scale)(delta, view.getResolution());
                (0, _coordinateJs.rotate)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, _easingJs.easeOut)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
exports.default = DragPan;

},{"../coordinate.js":"9bcSP","../easing.js":"1AzsJ","../events/condition.js":"2tMOf","../functions.js":"5nAKV","./Pointer.js":"hxa0H","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2tMOf":[function(require,module,exports,__globalThis) {
/**
 * @module ol/events/condition
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * `{boolean}`. If the condition is met, true should be returned.
 *
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default): boolean} Condition
 */ /**
 * Creates a condition function that passes when all provided conditions pass.
 * @param {...Condition} var_args Conditions to check.
 * @return {Condition} Condition function.
 */ parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "altKeyOnly", ()=>altKeyOnly);
parcelHelpers.export(exports, "altShiftKeysOnly", ()=>altShiftKeysOnly);
parcelHelpers.export(exports, "focus", ()=>focus);
parcelHelpers.export(exports, "focusWithTabindex", ()=>focusWithTabindex);
parcelHelpers.export(exports, "always", ()=>always);
parcelHelpers.export(exports, "click", ()=>click);
parcelHelpers.export(exports, "mouseActionButton", ()=>mouseActionButton);
parcelHelpers.export(exports, "never", ()=>never);
parcelHelpers.export(exports, "pointerMove", ()=>pointerMove);
parcelHelpers.export(exports, "singleClick", ()=>singleClick);
parcelHelpers.export(exports, "doubleClick", ()=>doubleClick);
parcelHelpers.export(exports, "noModifierKeys", ()=>noModifierKeys);
parcelHelpers.export(exports, "platformModifierKeyOnly", ()=>platformModifierKeyOnly);
parcelHelpers.export(exports, "platformModifierKey", ()=>platformModifierKey);
parcelHelpers.export(exports, "shiftKeyOnly", ()=>shiftKeyOnly);
parcelHelpers.export(exports, "targetNotEditable", ()=>targetNotEditable);
parcelHelpers.export(exports, "mouseOnly", ()=>mouseOnly);
parcelHelpers.export(exports, "touchOnly", ()=>touchOnly);
parcelHelpers.export(exports, "penOnly", ()=>penOnly);
parcelHelpers.export(exports, "primaryAction", ()=>primaryAction);
var _mapBrowserEventTypeJs = require("../MapBrowserEventType.js");
var _mapBrowserEventTypeJsDefault = parcelHelpers.interopDefault(_mapBrowserEventTypeJs);
var _functionsJs = require("../functions.js");
var _hasJs = require("../has.js");
function all(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const altKeyOnly = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const altShiftKeysOnly = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const focus = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const focusWithTabindex = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute('tabindex') ? focus(event) : true;
};
const always = (0, _functionsJs.TRUE);
const click = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).CLICK;
};
const mouseActionButton = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in originalEvent && originalEvent.button == 0 && !((0, _hasJs.WEBKIT) && (0, _hasJs.MAC) && originalEvent.ctrlKey);
};
const never = (0, _functionsJs.FALSE);
const pointerMove = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
const singleClick = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).SINGLECLICK;
};
const doubleClick = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).DBLCLICK;
};
const noModifierKeys = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const platformModifierKeyOnly = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, _hasJs.MAC) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const platformModifierKey = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return (0, _hasJs.MAC) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const shiftKeyOnly = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const targetNotEditable = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const mouseOnly = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvent && pointerEvent.pointerType == 'mouse';
};
const touchOnly = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'touch';
};
const penOnly = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'pen';
};
const primaryAction = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in pointerEvent && pointerEvent.isPrimary && pointerEvent.button === 0;
};

},{"../MapBrowserEventType.js":"dp3yB","../functions.js":"5nAKV","../has.js":"hbGE6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hxa0H":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/Pointer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<PointerEvent>} pointerEvents List of events.
 * @return {{clientX: number, clientY: number}} Centroid pixel.
 */ parcelHelpers.export(exports, "centroid", ()=>centroid);
var _mapBrowserEventTypeJs = require("../MapBrowserEventType.js");
var _mapBrowserEventTypeJsDefault = parcelHelpers.interopDefault(_mapBrowserEventTypeJs);
var _interactionJs = require("./Interaction.js");
var _interactionJsDefault = parcelHelpers.interopDefault(_interactionJs);
/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class PointerInteraction extends (0, _interactionJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, _mapBrowserEventTypeJsDefault.default).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function centroid(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
exports.default = PointerInteraction;

},{"../MapBrowserEventType.js":"dp3yB","./Interaction.js":"1QCYK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1sWlR":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/DragRotate
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _conditionJs = require("../events/condition.js");
var _functionsJs = require("../functions.js");
var _rotationconstraintJs = require("../rotationconstraint.js");
var _pointerJs = require("./Pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class DragRotate extends (0, _pointerJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, _functionsJs.FALSE)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, _conditionJs.altShiftKeysOnly);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, _conditionJs.mouseOnly)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, _rotationconstraintJs.disable)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, _conditionJs.mouseOnly)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, _conditionJs.mouseOnly)(mapBrowserEvent)) return false;
        if ((0, _conditionJs.mouseActionButton)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
exports.default = DragRotate;

},{"../events/condition.js":"2tMOf","../functions.js":"5nAKV","../rotationconstraint.js":"faoMn","./Pointer.js":"hxa0H","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"k3jrt":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/DragZoom
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _easingJs = require("../easing.js");
var _conditionJs = require("../events/condition.js");
var _dragBoxJs = require("./DragBox.js");
var _dragBoxJsDefault = parcelHelpers.interopDefault(_dragBoxJs);
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class DragZoom extends (0, _dragBoxJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, _conditionJs.shiftKeyOnly);
        super({
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, _easingJs.easeOut)
        });
    }
}
exports.default = DragZoom;

},{"../easing.js":"1AzsJ","../events/condition.js":"2tMOf","./DragBox.js":"lSkdA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lSkdA":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragBox~DragBox} instances are instances of
 * this type.
 */ parcelHelpers.export(exports, "DragBoxEvent", ()=>DragBoxEvent);
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _conditionJs = require("../events/condition.js");
var _boxJs = require("../render/Box.js");
var _boxJsDefault = parcelHelpers.interopDefault(_boxJs);
var _pointerJs = require("./Pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: 'boxstart',
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: 'boxdrag',
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: 'boxend',
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: 'boxcancel'
};
class DragBoxEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types|
 *     'change:active', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class DragBox extends (0, _pointerJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, _boxJsDefault.default)(options.className || 'ol-dragbox');
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, _conditionJs.mouseActionButton);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new DragBoxEvent(completeBox ? DragBoxEventType.BOXEND : DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
exports.default = DragBox;

},{"../events/Event.js":"5kI1G","../events/condition.js":"2tMOf","../render/Box.js":"gwsDb","./Pointer.js":"hxa0H","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gwsDb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/Box
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _disposableJs = require("../Disposable.js");
var _disposableJsDefault = parcelHelpers.interopDefault(_disposableJs);
var _polygonJs = require("../geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
class RenderBox extends (0, _disposableJsDefault.default) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement('div');
        this.element_.style.position = 'absolute';
        this.element_.style.pointerEvents = 'auto';
        this.element_.className = 'ol-box ' + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = 'px';
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, _polygonJsDefault.default)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
exports.default = RenderBox;

},{"../Disposable.js":"7LWtn","../geom/Polygon.js":"3zws5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aOPFA":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/KeyboardPan
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coordinateJs = require("../coordinate.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _keyJs = require("../events/Key.js");
var _keyJsDefault = parcelHelpers.interopDefault(_keyJs);
var _conditionJs = require("../events/condition.js");
var _interactionJs = require("./Interaction.js");
var _interactionJsDefault = parcelHelpers.interopDefault(_interactionJs);
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class KeyboardPan extends (0, _interactionJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, _conditionJs.noModifierKeys)(mapBrowserEvent) && (0, _conditionJs.targetNotEditable)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, _eventTypeJsDefault.default).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, _keyJsDefault.default).DOWN || key == (0, _keyJsDefault.default).LEFT || key == (0, _keyJsDefault.default).RIGHT || key == (0, _keyJsDefault.default).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, _keyJsDefault.default).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, _keyJsDefault.default).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, _keyJsDefault.default).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, _coordinateJs.rotate)(delta, view.getRotation());
                (0, _interactionJs.pan)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
exports.default = KeyboardPan;

},{"../coordinate.js":"9bcSP","../events/EventType.js":"79Bvl","../events/Key.js":"6Sj0Q","../events/condition.js":"2tMOf","./Interaction.js":"1QCYK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6Sj0Q":[function(require,module,exports,__globalThis) {
/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bIfPb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/KeyboardZoom
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _conditionJs = require("../events/condition.js");
var _interactionJs = require("./Interaction.js");
var _interactionJsDefault = parcelHelpers.interopDefault(_interactionJs);
/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class KeyboardZoom extends (0, _interactionJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, _conditionJs.platformModifierKey)(mapBrowserEvent) && (0, _conditionJs.targetNotEditable)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, _eventTypeJsDefault.default).KEYDOWN || mapBrowserEvent.type == (0, _eventTypeJsDefault.default).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === '+' || key === '-')) {
                const map = mapBrowserEvent.map;
                const delta = key === '+' ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, _interactionJs.zoomByDelta)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
exports.default = KeyboardZoom;

},{"../events/EventType.js":"79Bvl","../events/condition.js":"2tMOf","./Interaction.js":"1QCYK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iUPNQ":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/MouseWheelZoom
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventsJs = require("../events.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _conditionJs = require("../events/condition.js");
var _mathJs = require("../math.js");
var _interactionJs = require("./Interaction.js");
var _interactionJsDefault = parcelHelpers.interopDefault(_interactionJs);
/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * Mutliplier for the DOM_DELTA_LINE delta value.
 * @type {number}
 */ const DELTA_LINE_MULTIPLIER = 40;
/**
 * Mutliplier for the DOM_DELTA_PAGE delta value.
 * @type {number}
 */ const DELTA_PAGE_MULTIPLIER = 300;
/**
 * Mutliplier for the delta value when using pinch-to-zoom
 * @type {number}
 */ const DELTA_TRACKPAD_PINCH_TO_ZOOM_MULTIPLIER = 3; // 5 = google maps. 3 = apple maps, MapLibre.
/**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class MouseWheelZoom extends (0, _interactionJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, _conditionJs.always);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, _conditionJs.all)((0, _conditionJs.focusWithTabindex), condition) : condition;
        /**
     * @private
     * @type {?import("../pixel.js").Pixel}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
        /**
     * Tracks whether the Ctrl key is physically held down (as opposed to the
     * browser synthesizing ctrlKey=true for pinch-to-zoom trackpad gestures).
     * @private
     * @type {boolean}
     */ this.ctrlKeyPressed_ = false;
        /**
     * @private
     * @type {Array<import('../events.js').EventsKey>}
     */ this.ctrlKeyListenerKeys_ = [];
    }
    /**
   * @param {import('../Map.js').default|null} map Map.
   * @override
   */ setMap(map) {
        this.ctrlKeyListenerKeys_.forEach((0, _eventsJs.unlistenByKey));
        this.ctrlKeyListenerKeys_.length = 0;
        this.ctrlKeyPressed_ = false;
        super.setMap(map);
        if (map) {
            const doc = map.getOwnerDocument();
            this.ctrlKeyListenerKeys_.push((0, _eventsJs.listen)(doc, 'keydown', (/** @type {KeyboardEvent} */ e)=>{
                if (e.key === 'Control') this.ctrlKeyPressed_ = true;
            }), (0, _eventsJs.listen)(doc, 'keyup', (/** @type {KeyboardEvent} */ e)=>{
                if (e.key === 'Control') this.ctrlKeyPressed_ = false;
            }));
        }
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        const direction = this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0;
        view.endInteraction(this.constrainResolution_ || view.getConstrainResolution() ? 100 : undefined, direction, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, _eventTypeJsDefault.default).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        const isPinchToZoom = wheelEvent.ctrlKey && !this.ctrlKeyPressed_;
        if (!wheelEvent.ctrlKey) this.ctrlKeyPressed_ = false;
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.pixel;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta = wheelEvent.deltaY;
        switch(wheelEvent.deltaMode){
            case WheelEvent.DOM_DELTA_LINE:
                delta *= DELTA_LINE_MULTIPLIER;
                break;
            case WheelEvent.DOM_DELTA_PAGE:
                delta *= DELTA_PAGE_MULTIPLIER;
                break;
            default:
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? 'trackpad' : 'wheel';
        const view = map.getView();
        if (this.mode_ === 'trackpad') {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            if (isPinchToZoom) delta = delta * DELTA_TRACKPAD_PINCH_TO_ZOOM_MULTIPLIER;
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, _mathJs.clamp)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, _interactionJs.zoomByDelta)(view, delta, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
exports.default = MouseWheelZoom;

},{"../events.js":"Vqr1Z","../events/EventType.js":"79Bvl","../events/condition.js":"2tMOf","../math.js":"b3dOZ","./Interaction.js":"1QCYK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2xvPv":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/PinchRotate
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _functionsJs = require("../functions.js");
var _rotationconstraintJs = require("../rotationconstraint.js");
var _pointerJs = require("./Pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class PinchRotate extends (0, _pointerJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, _functionsJs.FALSE);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, _rotationconstraintJs.disable)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, _pointerJs.centroid)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
exports.default = PinchRotate;

},{"../functions.js":"5nAKV","../rotationconstraint.js":"faoMn","./Pointer.js":"hxa0H","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7Rvxp":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/PinchZoom
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _functionsJs = require("../functions.js");
var _pointerJs = require("./Pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class PinchZoom extends (0, _pointerJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, _functionsJs.FALSE);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, _pointerJs.centroid)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
exports.default = PinchZoom;

},{"../functions.js":"5nAKV","./Pointer.js":"hxa0H","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6DIkJ":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Group
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @classdesc
 * A layer group triggers 'addlayer' and 'removelayer' events when layers are added to or removed from
 * the group or one of its child groups.  When a layer group is added to or removed from another layer group,
 * a single event will be triggered (instead of one per layer in the group added or removed).
 */ parcelHelpers.export(exports, "GroupEvent", ()=>GroupEvent);
var _collectionJs = require("../Collection.js");
var _collectionJsDefault = parcelHelpers.interopDefault(_collectionJs);
var _collectionEventTypeJs = require("../CollectionEventType.js");
var _collectionEventTypeJsDefault = parcelHelpers.interopDefault(_collectionEventTypeJs);
var _objectEventTypeJs = require("../ObjectEventType.js");
var _objectEventTypeJsDefault = parcelHelpers.interopDefault(_objectEventTypeJs);
var _assertsJs = require("../asserts.js");
var _eventsJs = require("../events.js");
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("../extent.js");
var _objJs = require("../obj.js");
var _utilJs = require("../util.js");
var _baseJs = require("./Base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
/**
 * @enum {string}
 */ const GroupEventType = {
    /**
   * Triggered when a layer is added
   * @event GroupEvent#addlayer
   * @api
   */ ADDLAYER: 'addlayer',
    /**
   * Triggered when a layer is removed
   * @event GroupEvent#removelayer
   * @api
   */ REMOVELAYER: 'removelayer'
};
class GroupEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("./Base.js").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<'addlayer'|'removelayer', GroupEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("./Base.js").BaseLayerObjectEventTypes|'addlayer'|'removelayer'|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @fires GroupEvent
 * @api
 */ class LayerGroup extends (0, _baseJsDefault.default) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener(Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, _collectionJsDefault.default)(layers.slice(), {
                unique: true
            });
            else (0, _assertsJs.assert)(typeof /** @type {?} */ layers.getArray === 'function', 'Expected `layers` to be an array or a `Collection`');
        } else layers = new (0, _collectionJsDefault.default)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, _eventsJs.unlistenByKey));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, _eventsJs.listen)(layers, (0, _collectionEventTypeJsDefault.default).ADD, this.handleLayersAdd_, this), (0, _eventsJs.listen)(layers, (0, _collectionEventTypeJsDefault.default).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, _eventsJs.unlistenByKey));
        (0, _objJs.clear)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new GroupEvent(GroupEventType.ADDLAYER, layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, _eventsJs.listen)(layer, (0, _objectEventTypeJsDefault.default).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, _eventsJs.listen)(layer, (0, _eventTypeJsDefault.default).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof LayerGroup) listenerKeys.push((0, _eventsJs.listen)(layer, GroupEventType.ADDLAYER, this.handleLayerGroupAdd_, this), (0, _eventsJs.listen)(layer, GroupEventType.REMOVELAYER, this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, _utilJs.getUid)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new GroupEvent(GroupEventType.ADDLAYER, event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new GroupEvent(GroupEventType.REMOVELAYER, event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new GroupEvent(GroupEventType.ADDLAYER, layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, _utilJs.getUid)(layer);
        this.listenerKeys_[key].forEach((0, _eventsJs.unlistenByKey));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new GroupEvent(GroupEventType.REMOVELAYER, layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get(Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new GroupEvent(GroupEventType.REMOVELAYER, currentLayers[i]));
        }
        this.set(Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, _extentJs.getIntersection)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return 'ready';
    }
}
exports.default = LayerGroup;

},{"../Collection.js":"8dtMA","../CollectionEventType.js":"jVYia","../ObjectEventType.js":"i5oT2","../asserts.js":"csqTx","../events.js":"Vqr1Z","../events/Event.js":"5kI1G","../events/EventType.js":"79Bvl","../extent.js":"MPjK5","../obj.js":"GxveT","../util.js":"9Y20j","./Base.js":"akrp5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"akrp5":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Base
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectJs = require("../Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _assertsJs = require("../asserts.js");
var _mathJs = require("../math.js");
var _utilJs = require("../util.js");
var _propertyJs = require("./Property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType.js").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<BaseLayerObjectEventTypes, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties> & Object<string, *>>}
 */ class BaseLayer extends (0, _objectJsDefault.default) {
    /**
   * @param {Options<NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {?}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, _propertyJsDefault.default).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, _assertsJs.assert)(typeof properties[(0, _propertyJsDefault.default).OPACITY] === 'number', 'Layer opacity must be a number');
        properties[(0, _propertyJsDefault.default).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, _propertyJsDefault.default).Z_INDEX] = options.zIndex;
        properties[(0, _propertyJsDefault.default).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, _propertyJsDefault.default).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, _propertyJsDefault.default).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, _propertyJsDefault.default).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, _mathJs.clamp)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, _utilJs.abstract)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, _propertyJsDefault.default).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, _propertyJsDefault.default).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, _propertyJsDefault.default).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, _propertyJsDefault.default).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, _propertyJsDefault.default).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, _propertyJsDefault.default).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, _propertyJsDefault.default).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, _propertyJsDefault.default).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, _propertyJsDefault.default).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, _propertyJsDefault.default).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, _propertyJsDefault.default).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, _propertyJsDefault.default).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, _propertyJsDefault.default).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, _assertsJs.assert)(typeof opacity === 'number', 'Layer opacity must be a number');
        this.set((0, _propertyJsDefault.default).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, _propertyJsDefault.default).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, _propertyJsDefault.default).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
exports.default = BaseLayer;

},{"../Object.js":"lFhbz","../asserts.js":"csqTx","../math.js":"b3dOZ","../util.js":"9Y20j","./Property.js":"6eJKI","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6eJKI":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aZQOw":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Layer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return `true` if the layer is visible and if the provided view state
 * has resolution and zoom levels that are in range of the layer's min/max.
 * @param {State} layerState Layer state.
 * @param {import("../View.js").State} viewState View state.
 * @return {boolean} The layer is visible at the given view state.
 */ parcelHelpers.export(exports, "inView", ()=>inView);
var _viewJs = require("../View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _assertsJs = require("../asserts.js");
var _eventsJs = require("../events.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("../extent.js");
var _eventTypeJs1 = require("../render/EventType.js");
var _eventTypeJsDefault1 = parcelHelpers.interopDefault(_eventTypeJs1);
var _baseJs = require("./Base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _propertyJs = require("./Property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("./Base.js").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("../render/EventType.js").LayerRenderEventTypes, import("../render/Event.js").default, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("./Base.js").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType.js").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseLayer<NoInfer<Properties>>}
 * @api
 */ class Layer extends (0, _baseJsDefault.default) {
    /**
   * @param {Options<SourceType, NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, _propertyJsDefault.default).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, _propertyJsDefault.default).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? 'undefined' : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== 'ready') return;
        this.sourceReady_ = true;
        this.dispatchEvent('sourceready');
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, _eventsJs.unlistenByKey)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, _eventsJs.listen)(source, (0, _eventTypeJsDefault.default).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === 'ready') {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent('sourceready');
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature.js").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, _viewJsDefault.default)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) {
            layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
            if (!layerState) return false;
        } else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return inView(layerState, frameState.viewState) && (!layerExtent || (0, _extentJs.intersects)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, _viewJsDefault.default) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, _propertyJsDefault.default).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, _propertyJsDefault.default).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, _eventsJs.unlistenByKey)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, _eventsJs.unlistenByKey)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, _eventsJs.listen)(map, (0, _eventTypeJsDefault1.default).PRECOMPOSE, this.handlePrecompose_, this);
            this.mapRenderKey_ = (0, _eventsJs.listen)(this, (0, _eventTypeJsDefault.default).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * @param {import("../events/Event.js").default} renderEvent Render event
   * @private
   */ handlePrecompose_(renderEvent) {
        const layerStatesArray = /** @type {import("../render/Event.js").default} */ renderEvent.frameState.layerStatesArray;
        const layerState = this.getLayerState(false);
        (0, _assertsJs.assert)(!layerStatesArray.some((arrayLayerState)=>arrayLayerState.layer === layerState.layer), 'A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.');
        layerStatesArray.push(layerState);
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, _propertyJsDefault.default).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * This will clear the renderer so that a new one can be created next time it is needed
   */ clearRenderer() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.clearRenderer();
        this.setSource(null);
        super.disposeInternal();
    }
}
function inView(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
exports.default = Layer;

},{"../View.js":"baCdC","../asserts.js":"csqTx","../events.js":"Vqr1Z","../events/EventType.js":"79Bvl","../extent.js":"MPjK5","../render/EventType.js":"5YHp5","./Base.js":"akrp5","./Property.js":"6eJKI","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5YHp5":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: 'prerender',
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: 'precompose',
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: 'postcompose',
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: 'rendercomplete'
}; /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5dbSb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/Composite
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectEventTypeJs = require("../ObjectEventType.js");
var _objectEventTypeJsDefault = parcelHelpers.interopDefault(_objectEventTypeJs);
var _cssJs = require("../css.js");
var _domJs = require("../dom.js");
var _eventsJs = require("../events.js");
var _hasJs = require("../has.js");
var _baseVectorJs = require("../layer/BaseVector.js");
var _baseVectorJsDefault = parcelHelpers.interopDefault(_baseVectorJs);
var _layerJs = require("../layer/Layer.js");
var _eventJs = require("../render/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _eventTypeJs = require("../render/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _canvasJs = require("../render/canvas.js");
var _transformJs = require("../transform.js");
var _mapJs = require("./Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class CompositeMapRenderer extends (0, _mapJsDefault.default) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, _eventsJs.listen)((0, _canvasJs.checkedFonts), (0, _objectEventTypeJsDefault.default).PROPERTYCHANGE, map.redrawText, map);
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = (0, _hasJs.WORKER_OFFSCREEN_CANVAS) ? (0, _domJs.createMockDiv)() : document.createElement('div');
        const style = this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        this.element_.className = (0, _cssJs.CLASS_UNSELECTABLE) + ' ol-layers';
        const container = map.getViewport();
        if (container) // maps in a worker do not have a viewport.
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, _eventJsDefault.default)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, _eventsJs.unlistenByKey)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, _eventTypeJsDefault.default).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, _baseVectorJsDefault.default) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const map = this.getMap();
        const mapCanvas = map.getTargetElement();
        /** @type {CanvasRenderingContext2D|undefined} */ let mapContext;
        if ((0, _domJs.isCanvas)(mapCanvas)) {
            mapContext = /** @type {CanvasRenderingContext2D} */ mapCanvas.getContext('2d');
            mapContext.setTransform(1, 0, 0, 1, 0, 0);
            mapContext.clearRect(0, 0, mapCanvas.width, mapCanvas.height);
        }
        const renderedLayerStates = [];
        let previousElement = mapContext ? mapCanvas : null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, _layerJs.inView)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, _domJs.replaceChildren)(this.element_, this.children_);
        for (const container of mapContext ? this.children_ : []){
            const canvas = container.firstElementChild || container;
            const backgroundColor = container.style.backgroundColor;
            if (backgroundColor && (!(0, _domJs.isCanvas)(canvas) || canvas.width > 0)) {
                mapContext.fillStyle = backgroundColor;
                mapContext.fillRect(0, 0, mapContext.canvas.width, mapContext.canvas.height);
            }
            if (!(0, _domJs.isCanvas)(canvas) || canvas.width === 0) continue;
            mapContext.save();
            const opacity = container.style.opacity || canvas.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            if (transform) // Get the transform parameters from the style's transform matrix
            mapContext.transform(.../** @type {[number, number, number, number, number, number]} */ (0, _transformJs.fromString)(transform));
            else {
                const w = parseFloat(canvas.style.width) / canvas.width;
                const h = parseFloat(canvas.style.height) / canvas.height;
                mapContext.transform(w, 0, 0, h, 0, 0);
            }
            mapContext.drawImage(canvas, 0, 0);
            mapContext.restore();
        }
        this.dispatchRenderEvent((0, _eventTypeJsDefault.default).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
exports.default = CompositeMapRenderer;

},{"../ObjectEventType.js":"i5oT2","../css.js":"eP7Pk","../dom.js":"gfuif","../events.js":"Vqr1Z","../has.js":"hbGE6","../layer/BaseVector.js":"1iN2T","../layer/Layer.js":"aZQOw","../render/Event.js":"3wbs1","../render/EventType.js":"5YHp5","../render/canvas.js":"8UJXP","../transform.js":"7TqcG","./Map.js":"aH9V2","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1iN2T":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/BaseVector
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rbush = require("rbush");
var _rbushDefault = parcelHelpers.interopDefault(_rbush);
var _styleJs = require("../render/canvas/style.js");
var _styleJs1 = require("../style/Style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs1);
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/VectorLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class BaseVectorLayer extends (0, _layerJsDefault.default) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature.js").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {import("../render.js").OrderFunction|null|undefined} Render order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get(Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, _rbushDefault.default)(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set(Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, _styleJs1.createDefaultStyle) : style;
        const styleLike = toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, _styleJs1.toFunction)(styleLike);
        this.changed();
    }
    /**
   * @param {boolean|string|number} declutter Declutter images and text.
   * @api
   */ setDeclutter(declutter) {
        this.declutter_ = declutter ? String(declutter) : undefined;
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function toStyleLike(style) {
    if (style === undefined) return 0, _styleJs1.createDefaultStyle;
    if (!style) return null;
    if (typeof style === 'function') return style;
    if (style instanceof (0, _styleJsDefault.default)) return style;
    if (Array.isArray(style) && style.length === 0) return [];
    if (Array.isArray(style) && style[0] instanceof (0, _styleJsDefault.default)) {
        const length = style.length;
        const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, _styleJsDefault.default))) throw new Error('Expected a list of style instances');
            styles[i] = candidate;
        }
        return styles;
    }
    const flatStyleLike = /** @type {import("../style/flat.js").FlatStyleLike} */ style;
    return (0, _styleJs.flatStyleLikeToStyleFunction)(flatStyleLike);
}
exports.default = BaseVectorLayer;

},{"rbush":"Ksj8v","../render/canvas/style.js":"jLSYm","../style/Style.js":"gqpPW","./Layer.js":"aZQOw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"Ksj8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _quickselect = require("quickselect");
var _quickselectDefault = parcelHelpers.interopDefault(_quickselect);
class RBush {
    constructor(maxEntries = 9){
        // max entries in a node is 9 by default; min node fill is 40% for best performance
        this._maxEntries = Math.max(4, maxEntries);
        this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
        this.clear();
    }
    all() {
        return this._all(this.data, []);
    }
    search(bbox) {
        let node = this.data;
        const result = [];
        if (!intersects(bbox, node)) return result;
        const toBBox = this.toBBox;
        const nodesToSearch = [];
        while(node){
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const childBBox = node.leaf ? toBBox(child) : child;
                if (intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if (contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return result;
    }
    collides(bbox) {
        let node = this.data;
        if (!intersects(bbox, node)) return false;
        const nodesToSearch = [];
        while(node){
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const childBBox = node.leaf ? this.toBBox(child) : child;
                if (intersects(bbox, childBBox)) {
                    if (node.leaf || contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return false;
    }
    load(data) {
        if (!(data && data.length)) return this;
        if (data.length < this._minEntries) {
            for(let i = 0; i < data.length; i++)this.insert(data[i]);
            return this;
        }
        // recursively build the tree with the given data from scratch using OMT algorithm
        let node = this._build(data.slice(), 0, data.length - 1, 0);
        if (!this.data.children.length) // save as is if tree is empty
        this.data = node;
        else if (this.data.height === node.height) // split root if trees have the same height
        this._splitRoot(this.data, node);
        else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                const tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }
            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }
        return this;
    }
    insert(item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    }
    clear() {
        this.data = createNode([]);
        return this;
    }
    remove(item, equalsFn) {
        if (!item) return this;
        let node = this.data;
        const bbox = this.toBBox(item);
        const path = [];
        const indexes = [];
        let i, parent, goingUp;
        // depth-first iterative tree traversal
        while(node || path.length){
            if (!node) {
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }
            if (node.leaf) {
                const index = findItem(item, node.children, equalsFn);
                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }
            if (!goingUp && !node.leaf && contains(node, bbox)) {
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];
            } else if (parent) {
                i++;
                node = parent.children[i];
                goingUp = false;
            } else node = null; // nothing found
        }
        return this;
    }
    toBBox(item) {
        return item;
    }
    compareMinX(a, b) {
        return a.minX - b.minX;
    }
    compareMinY(a, b) {
        return a.minY - b.minY;
    }
    toJSON() {
        return this.data;
    }
    fromJSON(data) {
        this.data = data;
        return this;
    }
    _all(node, result) {
        const nodesToSearch = [];
        while(node){
            if (node.leaf) result.push(...node.children);
            else nodesToSearch.push(...node.children);
            node = nodesToSearch.pop();
        }
        return result;
    }
    _build(items, left, right, height) {
        const N = right - left + 1;
        let M = this._maxEntries;
        let node;
        if (N <= M) {
            // reached leaf level; return leaf
            node = createNode(items.slice(left, right + 1));
            calcBBox(node, this.toBBox);
            return node;
        }
        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));
            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }
        node = createNode([]);
        node.leaf = false;
        node.height = height;
        // split the items into M mostly square tiles
        const N2 = Math.ceil(N / M);
        const N1 = N2 * Math.ceil(Math.sqrt(M));
        multiSelect(items, left, right, N1, this.compareMinX);
        for(let i = left; i <= right; i += N1){
            const right2 = Math.min(i + N1 - 1, right);
            multiSelect(items, i, right2, N2, this.compareMinY);
            for(let j = i; j <= right2; j += N2){
                const right3 = Math.min(j + N2 - 1, right2);
                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }
        calcBBox(node, this.toBBox);
        return node;
    }
    _chooseSubtree(bbox, node, level, path) {
        while(true){
            path.push(node);
            if (node.leaf || path.length - 1 === level) break;
            let minArea = Infinity;
            let minEnlargement = Infinity;
            let targetNode;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const area = bboxArea(child);
                const enlargement = enlargedArea(bbox, child) - area;
                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;
                } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                {
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }
            node = targetNode || node.children[0];
        }
        return node;
    }
    _insert(item, level, isNode) {
        const bbox = isNode ? item : this.toBBox(item);
        const insertPath = [];
        // find the best node for accommodating the item, saving all nodes along the path too
        const node = this._chooseSubtree(bbox, this.data, level, insertPath);
        // put the item into the node
        node.children.push(item);
        extend(node, bbox);
        // split on node overflow; propagate upwards if necessary
        while(level >= 0){
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }
        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    }
    // split overflowed node into two
    _split(insertPath, level) {
        const node = insertPath[level];
        const M = node.children.length;
        const m = this._minEntries;
        this._chooseSplitAxis(node, m, M);
        const splitIndex = this._chooseSplitIndex(node, m, M);
        const newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;
        calcBBox(node, this.toBBox);
        calcBBox(newNode, this.toBBox);
        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    }
    _splitRoot(node, newNode) {
        // split root node
        this.data = createNode([
            node,
            newNode
        ]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        calcBBox(this.data, this.toBBox);
    }
    _chooseSplitIndex(node, m, M) {
        let index;
        let minOverlap = Infinity;
        let minArea = Infinity;
        for(let i = m; i <= M - m; i++){
            const bbox1 = distBBox(node, 0, i, this.toBBox);
            const bbox2 = distBBox(node, i, M, this.toBBox);
            const overlap = intersectionArea(bbox1, bbox2);
            const area = bboxArea(bbox1) + bboxArea(bbox2);
            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;
                minArea = area < minArea ? area : minArea;
            } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
            {
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }
        return index || M - m;
    }
    // sorts node children by the best axis for split
    _chooseSplitAxis(node, m, M) {
        const compareMinX = node.leaf ? this.compareMinX : compareNodeMinX;
        const compareMinY = node.leaf ? this.compareMinY : compareNodeMinY;
        const xMargin = this._allDistMargin(node, m, M, compareMinX);
        const yMargin = this._allDistMargin(node, m, M, compareMinY);
        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    }
    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin(node, m, M, compare) {
        node.children.sort(compare);
        const toBBox = this.toBBox;
        const leftBBox = distBBox(node, 0, m, toBBox);
        const rightBBox = distBBox(node, M - m, M, toBBox);
        let margin = bboxMargin(leftBBox) + bboxMargin(rightBBox);
        for(let i = m; i < M - m; i++){
            const child = node.children[i];
            extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(leftBBox);
        }
        for(let i = M - m - 1; i >= m; i--){
            const child = node.children[i];
            extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(rightBBox);
        }
        return margin;
    }
    _adjustParentBBoxes(bbox, path, level) {
        // adjust bboxes along the given tree path
        for(let i = level; i >= 0; i--)extend(path[i], bbox);
    }
    _condense(path) {
        // go through the path, removing empty nodes and updating bboxes
        for(let i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
            if (i > 0) {
                siblings = path[i - 1].children;
                siblings.splice(siblings.indexOf(path[i]), 1);
            } else this.clear();
        } else calcBBox(path[i], this.toBBox);
    }
}
exports.default = RBush;
function findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);
    for(let i = 0; i < items.length; i++){
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}
// calculate node's bbox from bboxes of its children
function calcBBox(node, toBBox) {
    distBBox(node, 0, node.children.length, toBBox, node);
}
// min bounding rectangle of node children from k to p-1
function distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;
    for(let i = k; i < p; i++){
        const child = node.children[i];
        extend(destNode, node.leaf ? toBBox(child) : child);
    }
    return destNode;
}
function extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}
function compareNodeMinX(a, b) {
    return a.minX - b.minX;
}
function compareNodeMinY(a, b) {
    return a.minY - b.minY;
}
function bboxArea(a) {
    return (a.maxX - a.minX) * (a.maxY - a.minY);
}
function bboxMargin(a) {
    return a.maxX - a.minX + (a.maxY - a.minY);
}
function enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}
function intersectionArea(a, b) {
    const minX = Math.max(a.minX, b.minX);
    const minY = Math.max(a.minY, b.minY);
    const maxX = Math.min(a.maxX, b.maxX);
    const maxY = Math.min(a.maxY, b.maxY);
    return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
}
function contains(a, b) {
    return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
}
function intersects(a, b) {
    return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
}
function createNode(children) {
    return {
        children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}
// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach
function multiSelect(arr, left, right, n, compare) {
    const stack = [
        left,
        right
    ];
    while(stack.length){
        right = stack.pop();
        left = stack.pop();
        if (right - left <= n) continue;
        const mid = left + Math.ceil((right - left) / n / 2) * n;
        (0, _quickselectDefault.default)(arr, mid, left, right, compare);
        stack.push(left, mid, mid, right);
    }
}

},{"quickselect":"9dXRY","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9dXRY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
function quickselect(arr, k, left, right, compare) {
    quickselectStep(arr, k, left || 0, right || arr.length - 1, compare || defaultCompare);
}
function quickselectStep(arr, k, left, right, compare) {
    while(right > left){
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselectStep(arr, k, newLeft, newRight, compare);
        }
        var t = arr[k];
        var i = left;
        var j = right;
        swap(arr, left, k);
        if (compare(arr[right], t) > 0) swap(arr, left, right);
        while(i < j){
            swap(arr, i, j);
            i++;
            j--;
            while(compare(arr[i], t) < 0)i++;
            while(compare(arr[j], t) > 0)j--;
        }
        if (compare(arr[left], t) === 0) swap(arr, left, j);
        else {
            j++;
            swap(arr, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
function swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jLSYm":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/style
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This function adapts a rule evaluator to the existing style function interface.
 * After we have deprecated the style function, we can use the compiled rules directly
 * and pass a more complete evaluation context (variables, zoom, time, etc.).
 *
 * @param {Array<import('../../style/flat.js').Rule>} rules The rules.
 * @param {ParsingContext} [parsingContext] Optional parsing context; will create a new one if not provided
 * @return {import('../../style/Style.js').StyleFunction} A style function.
 */ parcelHelpers.export(exports, "rulesToStyleFunction", ()=>rulesToStyleFunction);
/**
 * This function adapts a style evaluator to the existing style function interface.
 * After we have deprecated the style function, we can use the compiled rules directly
 * and pass a more complete evaluation context (variables, zoom, time, etc.).
 *
 * @param {Array<import('../../style/flat.js').FlatStyle>} flatStyles The flat styles.
 * @param {ParsingContext} [parsingContext] Optional parsing context; will create a new one if not provided
 * @return {import('../../style/Style.js').StyleFunction} A style function.
 */ parcelHelpers.export(exports, "flatStylesToStyleFunction", ()=>flatStylesToStyleFunction);
/**
 * This function handles any kind of style that matches the FlatStyleLike type.
 *
 * @param {import('../../style/flat.js').FlatStyleLike} flatStyleLike The flat style.
 * @param {ParsingContext} [parsingContext] Optional parsing context; will create a new one if not provided
 * @return {import('../../style/Style.js').StyleFunction} A style function.
 */ parcelHelpers.export(exports, "flatStyleLikeToStyleFunction", ()=>flatStyleLikeToStyleFunction);
/**
 * @typedef {function(EvaluationContext):Array<Style>} RuleSetEvaluator
 */ /**
 * @typedef {Object} CompiledRule
 * @property {ExpressionEvaluator} filter The compiled filter evaluator.
 * @property {Array<StyleEvaluator>} styles The list of compiled style evaluators.
 */ /**
 * @param {Array<import('../../style/flat.js').Rule>} rules The rules.
 * @param {ParsingContext} context The parsing context.
 * @return {RuleSetEvaluator} The evaluator function.
 */ parcelHelpers.export(exports, "buildRuleSet", ()=>buildRuleSet);
/**
 * @typedef {function(EvaluationContext):Style|null} StyleEvaluator
 */ /**
 * @param {FlatStyle} flatStyle A flat style literal.
 * @param {ParsingContext} context The parsing context.
 * @return {StyleEvaluator} A function that evaluates to a style.  The style returned by
 * this function will be reused between invocations.
 */ parcelHelpers.export(exports, "buildStyle", ()=>buildStyle);
var _colorJs = require("../../color.js");
var _cpuJs = require("../../expr/cpu.js");
var _expressionJs = require("../../expr/expression.js");
var _objJs = require("../../obj.js");
var _sizeJs = require("../../size.js");
var _circleJs = require("../../style/Circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _fillJs = require("../../style/Fill.js");
var _fillJsDefault = parcelHelpers.interopDefault(_fillJs);
var _iconJs = require("../../style/Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
var _regularShapeJs = require("../../style/RegularShape.js");
var _regularShapeJsDefault = parcelHelpers.interopDefault(_regularShapeJs);
var _strokeJs = require("../../style/Stroke.js");
var _strokeJsDefault = parcelHelpers.interopDefault(_strokeJs);
var _styleJs = require("../../style/Style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _textJs = require("../../style/Text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function always(context) {
    return true;
}
function rulesToStyleFunction(rules, parsingContext) {
    parsingContext = parsingContext ?? (0, _expressionJs.newParsingContext)();
    const evaluator = buildRuleSet(rules, parsingContext);
    const evaluationContext = (0, _cpuJs.newEvaluationContext)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, _expressionJs.computeGeometryType)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function flatStylesToStyleFunction(flatStyles, parsingContext) {
    parsingContext = parsingContext ?? (0, _expressionJs.newParsingContext)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = buildStyle(flatStyles[i], parsingContext);
    const evaluationContext = (0, _cpuJs.newEvaluationContext)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, _expressionJs.computeGeometryType)(feature.getGeometry());
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function flatStyleLikeToStyleFunction(flatStyleLike, parsingContext) {
    parsingContext = parsingContext ?? (0, _expressionJs.newParsingContext)();
    // single FlatStyle
    if (!Array.isArray(flatStyleLike)) return flatStylesToStyleFunction([
        flatStyleLike
    ], parsingContext);
    const length = flatStyleLike.length;
    const first = flatStyleLike[0];
    // array of Rule
    if ('style' in first) {
        /**
     * @type {Array<import("../../style/flat.js").Rule>}
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = flatStyleLike[i];
            if (!('style' in candidate)) throw new Error('Expected a list of rules with a style property');
            rules[i] = candidate;
        }
        return rulesToStyleFunction(rules, parsingContext);
    }
    // array of FlatStyle
    const flatStyles = /** @type {Array<import("../../style/flat.js").FlatStyle>} */ flatStyleLike;
    return flatStylesToStyleFunction(flatStyles, parsingContext);
}
function buildRuleSet(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = 'filter' in rule ? (0, _cpuJs.buildExpression)(rule.filter, (0, _expressionJs.BooleanType), context) : always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = buildStyle(rule.style[j], context);
        } else styles = [
            buildStyle(rule.style, context)
        ];
        compiledRules[i] = {
            filter,
            styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function buildStyle(flatStyle, context) {
    const evaluateFill = buildFill(flatStyle, '', context);
    const evaluateStroke = buildStroke(flatStyle, '', context);
    const evaluateText = buildText(flatStyle, context);
    const evaluateImage = buildImage(flatStyle, context);
    const evaluateZIndex = numberEvaluator(flatStyle, 'z-index', context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, _objJs.isEmpty)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error('No fill, stroke, point, or text symbolizer properties in style: ' + JSON.stringify(flatStyle));
    const style = new (0, _styleJsDefault.default)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + 'fill-pattern-src' in flatStyle) evaluateColor = patternEvaluator(flatStyle, prefix + 'fill-', context);
    else {
        if (flatStyle[prefix + 'fill-color'] === 'none') // avoids hit detection
        return (context)=>null;
        evaluateColor = colorLikeEvaluator(flatStyle, prefix + 'fill-color', context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, _fillJsDefault.default)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, _colorJs.NO_COLOR)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = numberEvaluator(flatStyle, prefix + 'stroke-width', context);
    const evaluateColor = colorLikeEvaluator(flatStyle, prefix + 'stroke-color', context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = stringEvaluator(flatStyle, prefix + 'stroke-line-cap', context);
    const evaluateLineJoin = stringEvaluator(flatStyle, prefix + 'stroke-line-join', context);
    const evaluateLineDash = numberArrayEvaluator(flatStyle, prefix + 'stroke-line-dash', context);
    const evaluateLineDashOffset = numberEvaluator(flatStyle, prefix + 'stroke-line-dash-offset', context);
    const evaluateMiterLimit = numberEvaluator(flatStyle, prefix + 'stroke-miter-limit', context);
    const evaluateOffset = numberEvaluator(flatStyle, prefix + 'stroke-offset', context);
    const stroke = new (0, _strokeJsDefault.default)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, _colorJs.NO_COLOR)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== 'butt' && lineCap !== 'round' && lineCap !== 'square') throw new Error('Expected butt, round, or square line cap');
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== 'bevel' && lineJoin !== 'round' && lineJoin !== 'miter') throw new Error('Expected bevel, round, or miter line join');
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        if (evaluateOffset) stroke.setOffset(evaluateOffset(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function buildText(flatStyle, context) {
    const prefix = 'text-';
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = stringEvaluator(flatStyle, prefix + 'value', context);
    if (!evaluateValue) return null;
    const evaluateFill = buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = buildFill(flatStyle, prefix + 'background-', context);
    const evaluateStroke = buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = buildStroke(flatStyle, prefix + 'background-', context);
    const evaluateFont = stringEvaluator(flatStyle, prefix + 'font', context);
    const evaluateMaxAngle = numberEvaluator(flatStyle, prefix + 'max-angle', context);
    const evaluateOffsetX = numberEvaluator(flatStyle, prefix + 'offset-x', context);
    const evaluateOffsetY = numberEvaluator(flatStyle, prefix + 'offset-y', context);
    const evaluateOverflow = booleanEvaluator(flatStyle, prefix + 'overflow', context);
    const evaluatePlacement = stringEvaluator(flatStyle, prefix + 'placement', context);
    const evaluateRepeat = numberEvaluator(flatStyle, prefix + 'repeat', context);
    const evaluateScale = sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateRotateWithView = booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    const evaluateRotation = numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateAlign = stringEvaluator(flatStyle, prefix + 'align', context);
    const evaluateJustify = stringEvaluator(flatStyle, prefix + 'justify', context);
    const evaluateBaseline = stringEvaluator(flatStyle, prefix + 'baseline', context);
    const evaluateKeepUpright = booleanEvaluator(flatStyle, prefix + 'keep-upright', context);
    const evaluatePadding = numberArrayEvaluator(flatStyle, prefix + 'padding', context);
    // The following properties are not currently settable
    const declutterMode = optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const text = new (0, _textJsDefault.default)({
        declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== 'point' && placement !== 'line') throw new Error('Expected point or line for text-placement');
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== 'left' && textAlign !== 'center' && textAlign !== 'right' && textAlign !== 'end' && textAlign !== 'start') throw new Error('Expected left, right, center, start, or end for text-align');
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== 'left' && justify !== 'right' && justify !== 'center') throw new Error('Expected left, right, or center for text-justify');
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== 'bottom' && textBaseline !== 'top' && textBaseline !== 'middle' && textBaseline !== 'alphabetic' && textBaseline !== 'hanging') throw new Error('Expected bottom, top, middle, alphabetic, or hanging for text-baseline');
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        if (evaluateKeepUpright) text.setKeepUpright(evaluateKeepUpright(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function buildImage(flatStyle, context) {
    if ('icon-src' in flatStyle) return buildIcon(flatStyle, context);
    if ('shape-points' in flatStyle) return buildShape(flatStyle, context);
    if ('circle-radius' in flatStyle) return buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function buildIcon(flatStyle, context) {
    const prefix = 'icon-';
    // required property
    const srcName = prefix + 'src';
    const src = requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = coordinateEvaluator(flatStyle, prefix + 'anchor', context);
    const evaluateScale = sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateOpacity = numberEvaluator(flatStyle, prefix + 'opacity', context);
    const evaluateDisplacement = coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = optionalIconOrigin(flatStyle, prefix + 'anchor-origin');
    const anchorXUnits = optionalIconAnchorUnits(flatStyle, prefix + 'anchor-x-units');
    const anchorYUnits = optionalIconAnchorUnits(flatStyle, prefix + 'anchor-y-units');
    const colorValue = getExpressionValue(flatStyle, prefix + 'color');
    let color;
    let evaluateColor = null;
    if (colorValue !== undefined) {
        const isColorExpression = Array.isArray(colorValue) && colorValue.length > 0 && typeof colorValue[0] === 'string';
        if (isColorExpression) evaluateColor = colorLikeEvaluator(flatStyle, prefix + 'color', context);
        else color = requireColorLike(colorValue, prefix + 'color');
    }
    const crossOrigin = optionalString(flatStyle, prefix + 'cross-origin');
    const offset = optionalNumberArray(flatStyle, prefix + 'offset');
    const offsetOrigin = optionalIconOrigin(flatStyle, prefix + 'offset-origin');
    const width = optionalNumber(flatStyle, prefix + 'width');
    const height = optionalNumber(flatStyle, prefix + 'height');
    const size = optionalSize(flatStyle, prefix + 'size');
    const declutterMode = optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const iconOptions = {
        src,
        anchorOrigin,
        anchorXUnits,
        anchorYUnits,
        crossOrigin,
        offset,
        offsetOrigin,
        height,
        width,
        size,
        declutterMode
    };
    let icon = null;
    return function(context) {
        if (!icon) {
            // lazily create the icon to allow for expression evaluation
            const initialColor = evaluateColor ? evaluateColor(context) : color;
            icon = new (0, _iconJsDefault.default)(initialColor !== undefined ? Object.assign({}, iconOptions, {
                color: initialColor
            }) : Object.assign({}, iconOptions));
        } else if (evaluateColor) icon.setColor(evaluateColor(context));
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function buildShape(flatStyle, context) {
    const prefix = 'shape-';
    // required property
    const pointsName = prefix + 'points';
    const radiusName = prefix + 'radius';
    const points = requireNumber(flatStyle[pointsName], pointsName);
    if (!(radiusName in flatStyle)) throw new Error(`Expected a number for ${radiusName}`);
    const evaluateRadius = numberEvaluator(flatStyle, radiusName, context);
    const initialRadius = typeof flatStyle[radiusName] === 'number' ? flatStyle[radiusName] : 5;
    const radius2Name = prefix + 'radius2';
    const evaluateRadius2 = numberEvaluator(flatStyle, radius2Name, context);
    const initialRadius2 = typeof flatStyle[radius2Name] === 'number' ? flatStyle[radius2Name] : undefined;
    // settable properties
    const evaluateFill = buildFill(flatStyle, prefix, context);
    const evaluateStroke = buildStroke(flatStyle, prefix, context);
    const evaluateScale = sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const angle = optionalNumber(flatStyle, prefix + 'angle');
    const declutterMode = optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const shape = new (0, _regularShapeJsDefault.default)({
        points,
        radius: initialRadius,
        radius2: initialRadius2,
        angle,
        declutterMode
    });
    return function(context) {
        if (evaluateRadius) shape.setRadius(evaluateRadius(context));
        if (evaluateRadius2) shape.setRadius2(evaluateRadius2(context));
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function buildCircle(flatStyle, context) {
    const prefix = 'circle-';
    // settable properties
    const evaluateFill = buildFill(flatStyle, prefix, context);
    const evaluateStroke = buildStroke(flatStyle, prefix, context);
    const evaluateRadius = numberEvaluator(flatStyle, prefix + 'radius', context);
    const evaluateScale = sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const declutterMode = optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const circle = new (0, _circleJsDefault.default)({
        radius: 5,
        declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @return {any|undefined} The encoded value, or undefined if not provided.
 */ function getExpressionValue(flatStyle, name) {
    if (!(name in flatStyle)) return undefined;
    const value = flatStyle[name];
    return value === undefined ? undefined : value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function numberEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return undefined;
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.NumberType), context);
    return function(context) {
        return requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function stringEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.StringType), context);
    return function(context) {
        return requireString(evaluator(context), name);
    };
}
function patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = stringEvaluator(flatStyle, prefix + 'pattern-src', context);
    const offsetEvaluator = sizeEvaluator(flatStyle, prefix + 'pattern-offset', context);
    const patternSizeEvaluator = sizeEvaluator(flatStyle, prefix + 'pattern-size', context);
    const colorEvaluator = colorLikeEvaluator(flatStyle, prefix + 'color', context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function booleanEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.BooleanType), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== 'boolean') throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function colorLikeEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.ColorType), context);
    return function(context) {
        return requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function numberArrayEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    if (Array.isArray(encoded) && (encoded.length === 0 || typeof encoded[0] !== 'string')) {
        /** @type {Array<import('../../expr/cpu.js').NumberEvaluator>} */ const evaluators = encoded.map((value, index)=>{
            if (typeof value === 'number') return ()=>value;
            const evaluator = (0, _cpuJs.buildExpression)(value, (0, _expressionJs.NumberType), context);
            return function(context) {
                return requireNumber(evaluator(context), `${name}[${index}]`);
            };
        });
        return function(context) {
            const array = new Array(evaluators.length);
            for(let i = 0; i < evaluators.length; ++i)array[i] = evaluators[i](context);
            return array;
        };
    }
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.NumberArrayType), context);
    return function(context) {
        return requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function coordinateEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.NumberArrayType), context);
    return function(context) {
        const array = requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function sizeEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.NumberArrayType), context);
    return function(context) {
        return requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function sizeLikeEvaluator(flatStyle, name, context) {
    const encoded = getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, _cpuJs.buildExpression)(encoded, (0, _expressionJs.NumberArrayType) | (0, _expressionJs.NumberType), context);
    return function(context) {
        return requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === 'number') return (0, _sizeJs.toSize)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== 'number' || typeof encoded[1] !== 'number') throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'bottom-left' && encoded !== 'bottom-right' && encoded !== 'top-left' && encoded !== 'top-right') throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'pixels' && encoded !== 'fraction') throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    if (encoded !== 'declutter' && encoded !== 'obstacle' && encoded !== 'none') throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== 'number') throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function requireString(value, property) {
    if (typeof value !== 'string') throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function requireNumber(value, property) {
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function requireColorLike(value, property) {
    if (typeof value === 'string') return value;
    const array = requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function requireSize(value, property) {
    const size = requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function requireSizeLike(value, property) {
    if (typeof value === 'number') return value;
    return requireSize(value, property);
}

},{"../../color.js":"jC16r","../../expr/cpu.js":"oNxJT","../../expr/expression.js":"6qTeh","../../obj.js":"GxveT","../../size.js":"8DeXL","../../style/Circle.js":"3Wl62","../../style/Fill.js":"24G0i","../../style/Icon.js":"ib4Ft","../../style/RegularShape.js":"k8Wqi","../../style/Stroke.js":"cese4","../../style/Style.js":"gqpPW","../../style/Text.js":"118sC","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jC16r":[function(require,module,exports,__globalThis) {
/**
 * @module ol/color
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NO_COLOR", ()=>NO_COLOR);
/**
 * Return the color as an rgba string.
 * @param {Color|string} color Color.
 * @return {string} Rgba string.
 * @api
 */ parcelHelpers.export(exports, "asString", ()=>asString);
/**
 * @param {Color} color A color that may or may not have an alpha channel.
 * @return {Color} The input color with an alpha channel.  If the input color has
 * an alpha channel, the input color will be returned unchanged.  Otherwise, a new
 * array will be returned with the input color and an alpha channel of 1.
 */ parcelHelpers.export(exports, "withAlpha", ()=>withAlpha);
/**
 * @param {Color} color RGBA color.
 * @return {Color} LCHuv color with alpha.
 */ parcelHelpers.export(exports, "rgbaToLcha", ()=>rgbaToLcha);
/**
 * @param {Color} color LCHuv color with alpha.
 * @return {Color} RGBA color.
 */ parcelHelpers.export(exports, "lchaToRgba", ()=>lchaToRgba);
/**
 * @param {string} s String.
 * @return {Color} Color.
 */ parcelHelpers.export(exports, "fromString", ()=>fromString);
/**
 * Return the color as an array. This function maintains a cache of calculated
 * arrays which means the result should not be modified.
 * @param {Color|string} color Color.
 * @return {Color} Color.
 * @api
 */ parcelHelpers.export(exports, "asArray", ()=>asArray);
/**
 * @param {Color} color Color.
 * @return {string} String.
 */ parcelHelpers.export(exports, "toString", ()=>toString);
/**
 * @param {string} s String.
 * @return {boolean} Whether the string is actually a valid color
 */ parcelHelpers.export(exports, "isStringColor", ()=>isStringColor);
var _domJs = require("./dom.js");
var _mathJs = require("./math.js");
const NO_COLOR = [
    NaN,
    NaN,
    NaN,
    0
];
let colorParseContext;
/**
 * @return {CanvasRenderingContext2D} The color parse context
 */ function getColorParseContext() {
    if (!colorParseContext) colorParseContext = (0, _domJs.createCanvasContext2D)(1, 1, undefined, {
        willReadFrequently: true,
        desynchronized: true
    });
    return colorParseContext;
}
const rgbModernRegEx = /^rgba?\(\s*(\d+%?)\s+(\d+%?)\s+(\d+%?)(?:\s*\/\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const rgbLegacyAbsoluteRegEx = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const rgbLegacyPercentageRegEx = /^rgba?\(\s*(\d+%)\s*,\s*(\d+%)\s*,\s*(\d+%)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const hexRegEx = /^#([\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i;
/**
 * @param {string} s Color component as number or percentage.
 * @param {number} divider Divider for percentage.
 * @return {number} Color component.
 */ function toColorComponent(s, divider) {
    return s.endsWith('%') ? Number(s.substring(0, s.length - 1)) / divider : Number(s);
}
/**
 * @param {string} color Color string.
 */ function throwInvalidColor(color) {
    throw new Error('failed to parse "' + color + '" as color');
}
/**
 * @param {string} color Color string.
 * @return {Color} RGBa color array.
 */ function parseRgba(color) {
    // Fast lane for rgb(a) colors
    if (color.toLowerCase().startsWith('rgb')) {
        const rgb = color.match(rgbLegacyAbsoluteRegEx) || color.match(rgbModernRegEx) || color.match(rgbLegacyPercentageRegEx);
        if (rgb) {
            const alpha = rgb[4];
            const rgbDivider = 100 / 255;
            return [
                (0, _mathJs.clamp)(toColorComponent(rgb[1], rgbDivider) + 0.5 | 0, 0, 255),
                (0, _mathJs.clamp)(toColorComponent(rgb[2], rgbDivider) + 0.5 | 0, 0, 255),
                (0, _mathJs.clamp)(toColorComponent(rgb[3], rgbDivider) + 0.5 | 0, 0, 255),
                alpha !== undefined ? (0, _mathJs.clamp)(toColorComponent(alpha, 100), 0, 1) : 1
            ];
        }
        throwInvalidColor(color);
    }
    // Fast lane for hex colors (also with alpha)
    if (color.startsWith('#')) {
        if (hexRegEx.test(color)) {
            const hex = color.substring(1);
            const step = hex.length <= 4 ? 1 : 2;
            const colorFromHex = [
                0,
                0,
                0,
                255
            ];
            for(let i = 0, ii = hex.length; i < ii; i += step){
                let colorComponent = parseInt(hex.substring(i, i + step), 16);
                if (step === 1) colorComponent += colorComponent << 4;
                colorFromHex[i / step] = colorComponent;
            }
            colorFromHex[3] = colorFromHex[3] / 255;
            return colorFromHex;
        }
        throwInvalidColor(color);
    }
    // Use canvas color serialization to parse the color into hex or rgba
    // See https://www.w3.org/TR/2021/SPSD-2dcontext-20210128/#serialization-of-a-color
    const context = getColorParseContext();
    context.fillStyle = '#abcdef';
    let invalidCheckFillStyle = context.fillStyle;
    context.fillStyle = color;
    if (context.fillStyle === invalidCheckFillStyle) {
        context.fillStyle = '#fedcba';
        invalidCheckFillStyle = context.fillStyle;
        context.fillStyle = color;
        if (context.fillStyle === invalidCheckFillStyle) throwInvalidColor(color);
    }
    const colorString = context.fillStyle;
    if (colorString.startsWith('#') || colorString.startsWith('rgba')) return parseRgba(colorString);
    context.clearRect(0, 0, 1, 1);
    context.fillRect(0, 0, 1, 1);
    const colorFromImage = Array.from(context.getImageData(0, 0, 1, 1).data);
    colorFromImage[3] = (0, _mathJs.toFixed)(colorFromImage[3] / 255, 3);
    return colorFromImage;
}
function asString(color) {
    if (typeof color === 'string') return color;
    return toString(color);
}
/**
 * @type {number}
 */ const MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const cache = {};
/**
 * @type {number}
 */ let cacheSize = 0;
function withAlpha(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
// The functions b1, b2, a1, a2, rgbaToLcha and lchaToRgba below are adapted from
// https://stackoverflow.com/a/67219995/2389327
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function b1(v) {
    return v > 0.0031308 ? Math.pow(v, 1 / 2.4) * 269.025 - 14.025 : v * 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function b2(v) {
    return v > 0.2068965 ? Math.pow(v, 3) : (v - 4 / 29) * (108 / 841);
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function a1(v) {
    return v > 10.314724 ? Math.pow((v + 14.025) / 269.025, 2.4) : v / 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function a2(v) {
    return v > 0.0088564 ? Math.pow(v, 1 / 3) : v / (108 / 841) + 4 / 29;
}
function rgbaToLcha(color) {
    const r = a1(color[0]);
    const g = a1(color[1]);
    const b = a1(color[2]);
    const y = a2(r * 0.222488403 + g * 0.716873169 + b * 0.06060791);
    const l = 500 * (a2(r * 0.452247074 + g * 0.399439023 + b * 0.148375274) - y);
    const q = 200 * (y - a2(r * 0.016863605 + g * 0.117638439 + b * 0.865350722));
    const h = Math.atan2(q, l) * (180 / Math.PI);
    return [
        116 * y - 16,
        Math.sqrt(l * l + q * q),
        h < 0 ? h + 360 : h,
        color[3]
    ];
}
function lchaToRgba(color) {
    const l = (color[0] + 16) / 116;
    const c = color[1];
    const h = color[2] * Math.PI / 180;
    const y = b2(l);
    const x = b2(l + c / 500 * Math.cos(h));
    const z = b2(l - c / 200 * Math.sin(h));
    const r = b1(x * 3.021973625 - y * 1.617392459 - z * 0.404875592);
    const g = b1(x * -0.943766287 + y * 1.916279586 + z * 0.027607165);
    const b = b1(x * 0.069407491 - y * 0.22898585 + z * 1.159737864);
    return [
        (0, _mathJs.clamp)(r + 0.5 | 0, 0, 255),
        (0, _mathJs.clamp)(g + 0.5 | 0, 0, 255),
        (0, _mathJs.clamp)(b + 0.5 | 0, 0, 255),
        color[3]
    ];
}
function fromString(s) {
    if (s === 'none') return NO_COLOR;
    if (cache.hasOwnProperty(s)) return cache[s];
    if (cacheSize >= MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in cache)if ((i++ & 3) === 0) {
            delete cache[key];
            --cacheSize;
        }
    }
    const color = parseRgba(s);
    if (color.length !== 4) throwInvalidColor(s);
    for (const c of color)if (isNaN(c)) throwInvalidColor(s);
    cache[s] = color;
    ++cacheSize;
    return color;
}
function asArray(color) {
    if (Array.isArray(color)) return color;
    return fromString(color);
}
function toString(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function isStringColor(s) {
    try {
        fromString(s);
        return true;
    } catch  {
        return false;
    }
}

},{"./dom.js":"gfuif","./math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"oNxJT":[function(require,module,exports,__globalThis) {
/**
 * @module ol/expr/cpu
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('./expression.js').ValueType} ValueType
 */ /**
 * @fileoverview This module includes functions to build expressions for evaluation on the CPU.
 * Building is composed of two steps: parsing and compiling.  The parsing step takes an encoded
 * expression and returns an instance of one of the expression classes.  The compiling step takes
 * the expression instance and returns a function that can be evaluated in to return a literal
 * value.  The evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {Object} EvaluationContext
 * @property {Object} properties The values for properties used in 'get' expressions.
 * @property {Object} variables The values for variables used in 'var' expressions.
 * @property {number} resolution The map resolution.
 * @property {string|number|null} featureId The feature id.
 * @property {string} geometryType Geometry type of the current object.
 */ /**
 * @return {EvaluationContext} A new evaluation context.
 */ parcelHelpers.export(exports, "newEvaluationContext", ()=>newEvaluationContext);
/**
 * @typedef {function(EvaluationContext):import("./expression.js").LiteralValue} ExpressionEvaluator
 */ /**
 * @typedef {function(EvaluationContext):boolean} BooleanEvaluator
 */ /**
 * @typedef {function(EvaluationContext):number} NumberEvaluator
 */ /**
 * @typedef {function(EvaluationContext):string} StringEvaluator
 */ /**
 * @typedef {function(EvaluationContext):(Array<number>|string)} ColorLikeEvaluator
 */ /**
 * @typedef {function(EvaluationContext):Array<number>} NumberArrayEvaluator
 */ /**
 * @typedef {function(EvaluationContext):Array<number>} CoordinateEvaluator
 */ /**
 * @typedef {function(EvaluationContext):(Array<number>)} SizeEvaluator
 */ /**
 * @typedef {function(EvaluationContext):(Array<number>|number)} SizeLikeEvaluator
 */ /**
 * @param {import('./expression.js').EncodedExpression} encoded The encoded expression.
 * @param {ValueType} type The expected type.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The expression evaluator.
 */ parcelHelpers.export(exports, "buildExpression", ()=>buildExpression);
var _colorJs = require("../color.js");
var _expressionJs = require("./expression.js");
function newEvaluationContext() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ''
    };
}
function buildExpression(encoded, type, context) {
    const expression = (0, _expressionJs.parse)(encoded, type, context);
    return compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function compileExpression(expression, context) {
    if (expression instanceof (0, _expressionJs.LiteralExpression)) {
        // convert colors to array if possible
        if (expression.type === (0, _expressionJs.ColorType) && typeof expression.value === 'string') {
            const colorValue = (0, _colorJs.fromString)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, _expressionJs.Ops).Number:
        case (0, _expressionJs.Ops).String:
        case (0, _expressionJs.Ops).Coalesce:
            return compileAssertionExpression(expression, context);
        case (0, _expressionJs.Ops).Get:
        case (0, _expressionJs.Ops).Var:
        case (0, _expressionJs.Ops).Has:
            return compileAccessorExpression(expression, context);
        case (0, _expressionJs.Ops).Id:
            return (context)=>context.featureId;
        case (0, _expressionJs.Ops).GeometryType:
            return (context)=>context.geometryType;
        case (0, _expressionJs.Ops).Concat:
            {
                const args = expression.args.map((e)=>compileExpression(e, context));
                return (context)=>''.concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, _expressionJs.Ops).Resolution:
            return (context)=>context.resolution;
        case (0, _expressionJs.Ops).Any:
        case (0, _expressionJs.Ops).All:
        case (0, _expressionJs.Ops).Between:
        case (0, _expressionJs.Ops).In:
        case (0, _expressionJs.Ops).Not:
            return compileLogicalExpression(expression, context);
        case (0, _expressionJs.Ops).Equal:
        case (0, _expressionJs.Ops).NotEqual:
        case (0, _expressionJs.Ops).LessThan:
        case (0, _expressionJs.Ops).LessThanOrEqualTo:
        case (0, _expressionJs.Ops).GreaterThan:
        case (0, _expressionJs.Ops).GreaterThanOrEqualTo:
            return compileComparisonExpression(expression, context);
        case (0, _expressionJs.Ops).Multiply:
        case (0, _expressionJs.Ops).Divide:
        case (0, _expressionJs.Ops).Add:
        case (0, _expressionJs.Ops).Subtract:
        case (0, _expressionJs.Ops).Clamp:
        case (0, _expressionJs.Ops).Mod:
        case (0, _expressionJs.Ops).Pow:
        case (0, _expressionJs.Ops).Abs:
        case (0, _expressionJs.Ops).Floor:
        case (0, _expressionJs.Ops).Ceil:
        case (0, _expressionJs.Ops).Round:
        case (0, _expressionJs.Ops).Sin:
        case (0, _expressionJs.Ops).Cos:
        case (0, _expressionJs.Ops).Atan:
        case (0, _expressionJs.Ops).Sqrt:
            return compileNumericExpression(expression, context);
        case (0, _expressionJs.Ops).Case:
            return compileCaseExpression(expression, context);
        case (0, _expressionJs.Ops).Match:
            return compileMatchExpression(expression, context);
        case (0, _expressionJs.Ops).Interpolate:
            return compileInterpolateExpression(expression, context);
        case (0, _expressionJs.Ops).ToString:
            return compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = compileExpression(expression.args[i], context);
    switch(type){
        case (0, _expressionJs.Ops).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== 'undefined' && value !== null) return value;
                }
                throw new Error('Expected one of the values to be non-null');
            };
        case (0, _expressionJs.Ops).Number:
        case (0, _expressionJs.Ops).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, _expressionJs.Ops).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, _expressionJs.Ops).Var:
            return (context)=>context.variables[name];
        case (0, _expressionJs.Ops).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = compileExpression(expression.args[0], context);
    const right = compileExpression(expression.args[1], context);
    switch(op){
        case (0, _expressionJs.Ops).Equal:
            return (context)=>left(context) === right(context);
        case (0, _expressionJs.Ops).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, _expressionJs.Ops).LessThan:
            return (context)=>left(context) < right(context);
        case (0, _expressionJs.Ops).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, _expressionJs.Ops).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, _expressionJs.Ops).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = compileExpression(expression.args[i], context);
    switch(op){
        case (0, _expressionJs.Ops).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, _expressionJs.Ops).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, _expressionJs.Ops).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, _expressionJs.Ops).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, _expressionJs.Ops).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = compileExpression(expression.args[i], context);
    switch(op){
        case (0, _expressionJs.Ops).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, _expressionJs.Ops).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, _expressionJs.Ops).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, _expressionJs.Ops).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, _expressionJs.Ops).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, _expressionJs.Ops).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, _expressionJs.Ops).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, _expressionJs.Ops).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, _expressionJs.Ops).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, _expressionJs.Ops).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, _expressionJs.Ops).Round:
            return (context)=>Math.round(args[0](context));
        case (0, _expressionJs.Ops).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, _expressionJs.Ops).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, _expressionJs.Ops).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, _expressionJs.Ops).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length - 1; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, _colorJs.withAlpha)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return interpolateColor(base, value, previousInput, previousOutput, input, output);
                return interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = compileExpression(expression.args[i], context);
    switch(op){
        case (0, _expressionJs.Ops).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, _expressionJs.ColorType)) return (0, _colorJs.toString)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, _colorJs.rgbaToLcha)(rgba1);
    const lcha2 = (0, _colorJs.rgbaToLcha)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + interpolateNumber(base, value, input1, 0, input2, deltaHue),
        interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, _colorJs.lchaToRgba)(lcha);
}

},{"../color.js":"jC16r","./expression.js":"6qTeh","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6qTeh":[function(require,module,exports,__globalThis) {
/**
 * @module ol/expr/expression
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoneType", ()=>NoneType);
parcelHelpers.export(exports, "BooleanType", ()=>BooleanType);
parcelHelpers.export(exports, "NumberType", ()=>NumberType);
parcelHelpers.export(exports, "StringType", ()=>StringType);
parcelHelpers.export(exports, "ColorType", ()=>ColorType);
parcelHelpers.export(exports, "NumberArrayType", ()=>NumberArrayType);
parcelHelpers.export(exports, "SizeType", ()=>SizeType);
parcelHelpers.export(exports, "AnyType", ()=>AnyType);
/**
 * Get a string representation for a type.
 * @param {ValueType} type The type.
 * @return {string} The type name.
 */ parcelHelpers.export(exports, "typeName", ()=>typeName);
/**
 * @param {ValueType} broad The broad type.
 * @param {ValueType} specific The specific type.
 * @return {boolean} The broad type includes the specific type.
 */ parcelHelpers.export(exports, "includesType", ()=>includesType);
/**
 * @param {ValueType} oneType One type.
 * @param {ValueType} otherType Another type.
 * @return {boolean} The set of types overlap (share a common specific type)
 */ parcelHelpers.export(exports, "overlapsType", ()=>overlapsType);
/**
 * @param {ValueType} type The type.
 * @param {ValueType} expected The expected type.
 * @return {boolean} The given type is exactly the expected type.
 */ parcelHelpers.export(exports, "isType", ()=>isType);
/**
 * @typedef {boolean|number|string|Array<number>} LiteralValue
 */ parcelHelpers.export(exports, "LiteralExpression", ()=>LiteralExpression);
parcelHelpers.export(exports, "CallExpression", ()=>CallExpression);
/**
 * @typedef {LiteralExpression|CallExpression} Expression
 */ /**
 * @typedef {Object} ParsingContext
 * @property {Map<string, ValueType>} variables Variables referenced with the 'var' operator; key is name, value is type.
 * @property {Map<string, ValueType>} properties Properties referenced with the 'get' operator; key is name, value is type.
 * @property {boolean} featureId The style uses the feature id.
 * @property {boolean} geometryType The style uses the feature geometry type.
 * @property {boolean} mCoordinate The style uses the M coordinate of geometries
 * @property {boolean} mapState The style uses the map state (view state or time elapsed).
 * @property {import('../style/flat.js').StyleVariables} [inputVariables] Variable values (i.e. style variables) given as input during parsing to help with type narrowing
 */ /**
 * @param {import('../style/flat.js').StyleVariables} [inputVariables] Variable values (i.e. style variables) given as input during parsing to help with type narrowing
 * @return {ParsingContext} A new parsing context.
 */ parcelHelpers.export(exports, "newParsingContext", ()=>newParsingContext);
/**
 * @typedef {LiteralValue|Array} EncodedExpression
 */ /**
 * @param {EncodedExpression} encoded The encoded expression.
 * @param {ValueType} expectedType The expected type.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression result.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "Ops", ()=>Ops);
/**
 * Returns a simplified geometry type suited for the `geometry-type` operator
 * @param {import('../geom/Geometry.js').default|import('../render/Feature.js').default} geometry Geometry object
 * @return {'Point'|'LineString'|'Polygon'|''} Simplified geometry type; empty string of no geometry found
 */ parcelHelpers.export(exports, "computeGeometryType", ()=>computeGeometryType);
var _arrayJs = require("../array.js");
var _colorJs = require("../color.js");
var _sizeJs = require("../size.js");
/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   * `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *   * `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *     Note that for WebGL layers, the hardcoded value `-9999999` is used to distinguish when a property is not defined.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *     This works as well for number arrays although it is not required. Mixing types (numbers and strings) will produce undefined results.
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ /**
 * @typedef {number} ValueType
 */ let numTypes = 0;
const NoneType = 0;
const BooleanType = 1 << numTypes++;
const NumberType = 1 << numTypes++;
const StringType = 1 << numTypes++;
const ColorType = 1 << numTypes++;
const NumberArrayType = 1 << numTypes++;
const SizeType = 1 << numTypes++;
const AnyType = Math.pow(2, numTypes) - 1;
const typeNames = {
    [BooleanType]: 'boolean',
    [NumberType]: 'number',
    [StringType]: 'string',
    [ColorType]: 'color',
    [NumberArrayType]: 'number[]',
    [SizeType]: 'size'
};
const namedTypes = Object.keys(typeNames).map(Number).sort((0, _arrayJs.ascending));
/**
 * @param {ValueType} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function isSpecific(type) {
    return type in typeNames;
}
function typeName(type) {
    const names = [];
    for (const namedType of namedTypes)if (includesType(type, namedType)) names.push(typeNames[namedType]);
    if (names.length === 0) return 'untyped';
    if (names.length < 3) return names.join(' or ');
    return names.slice(0, -1).join(', ') + ', or ' + names[names.length - 1];
}
function includesType(broad, specific) {
    return (broad & specific) === specific;
}
function overlapsType(oneType, otherType) {
    return !!(oneType & otherType);
}
function isType(type, expected) {
    return type === expected;
}
class LiteralExpression {
    /**
   * @param {ValueType} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${typeName(type)}`);
        this.type = type;
        this.value = value;
    }
}
class CallExpression {
    /**
   * @param {ValueType} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function newParsingContext(inputVariables) {
    return {
        variables: new Map(),
        properties: new Map(),
        featureId: false,
        geometryType: false,
        mCoordinate: false,
        mapState: false,
        inputVariables
    };
}
function parse(encoded, expectedType, context) {
    switch(typeof encoded){
        case 'boolean':
            if (isType(expectedType, StringType)) return new LiteralExpression(StringType, encoded ? 'true' : 'false');
            if (!includesType(expectedType, BooleanType)) throw new Error(`got a boolean, but expected ${typeName(expectedType)}`);
            return new LiteralExpression(BooleanType, encoded);
        case 'number':
            if (isType(expectedType, SizeType)) return new LiteralExpression(SizeType, (0, _sizeJs.toSize)(encoded));
            if (isType(expectedType, BooleanType)) return new LiteralExpression(BooleanType, !!encoded);
            if (isType(expectedType, StringType)) return new LiteralExpression(StringType, encoded.toString());
            if (!includesType(expectedType, NumberType)) throw new Error(`got a number, but expected ${typeName(expectedType)}`);
            return new LiteralExpression(NumberType, encoded);
        case 'string':
            if (isType(expectedType, ColorType)) return new LiteralExpression(ColorType, (0, _colorJs.fromString)(encoded));
            if (isType(expectedType, BooleanType)) return new LiteralExpression(BooleanType, !!encoded);
            if (!includesType(expectedType, StringType)) throw new Error(`got a string, but expected ${typeName(expectedType)}`);
            return new LiteralExpression(StringType, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error('expression must be an array or a primitive value');
    if (encoded.length === 0) throw new Error('empty expression');
    if (typeof encoded[0] === 'string') return parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== 'number') throw new Error('expected an array of numbers');
    }
    if (isType(expectedType, SizeType)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new LiteralExpression(SizeType, encoded);
    }
    if (isType(expectedType, ColorType)) {
        if (encoded.length === 3) return new LiteralExpression(ColorType, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new LiteralExpression(ColorType, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!includesType(expectedType, NumberArrayType)) throw new Error(`got an array of numbers, but expected ${typeName(expectedType)}`);
    return new LiteralExpression(NumberArrayType, encoded);
}
const Ops = {
    Get: 'get',
    Var: 'var',
    Concat: 'concat',
    GeometryType: 'geometry-type',
    LineMetric: 'line-metric',
    Any: 'any',
    All: 'all',
    Not: '!',
    Resolution: 'resolution',
    Zoom: 'zoom',
    Time: 'time',
    Equal: '==',
    NotEqual: '!=',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Multiply: '*',
    Divide: '/',
    Add: '+',
    Subtract: '-',
    Clamp: 'clamp',
    Mod: '%',
    Pow: '^',
    Abs: 'abs',
    Floor: 'floor',
    Ceil: 'ceil',
    Round: 'round',
    Sin: 'sin',
    Cos: 'cos',
    Atan: 'atan',
    Sqrt: 'sqrt',
    Match: 'match',
    Between: 'between',
    Interpolate: 'interpolate',
    Coalesce: 'coalesce',
    Case: 'case',
    In: 'in',
    Number: 'number',
    String: 'string',
    Array: 'array',
    Color: 'color',
    Id: 'id',
    Band: 'band',
    Palette: 'palette',
    ToString: 'to-string',
    Has: 'has'
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const parsers = {
    [Ops.Get]: createCallExpressionParser(hasArgsCount(1, Infinity), withGetArgs),
    [Ops.Var]: createVarExpressionParser(),
    [Ops.Has]: createCallExpressionParser(hasArgsCount(1, Infinity), withGetArgs),
    [Ops.Id]: createCallExpressionParser(usesFeatureId, withNoArgs),
    [Ops.Concat]: createCallExpressionParser(hasArgsCount(2, Infinity), withArgsOfType(StringType)),
    [Ops.GeometryType]: createCallExpressionParser(usesGeometryType, withNoArgs),
    [Ops.LineMetric]: createCallExpressionParser(usesMCoordinate, withNoArgs),
    [Ops.Resolution]: createCallExpressionParser(usesMapState, withNoArgs),
    [Ops.Zoom]: createCallExpressionParser(usesMapState, withNoArgs),
    [Ops.Time]: createCallExpressionParser(usesMapState, withNoArgs),
    [Ops.Any]: createCallExpressionParser(hasArgsCount(2, Infinity), withArgsOfType(BooleanType)),
    [Ops.All]: createCallExpressionParser(hasArgsCount(2, Infinity), withArgsOfType(BooleanType)),
    [Ops.Not]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(BooleanType)),
    [Ops.Equal]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfIdenticalType()),
    [Ops.NotEqual]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfIdenticalType()),
    [Ops.GreaterThan]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.GreaterThanOrEqualTo]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.LessThan]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.LessThanOrEqualTo]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.Multiply]: createCallExpressionParser(hasArgsCount(2, Infinity), withArgsOfReturnType),
    [Ops.Coalesce]: createCallExpressionParser(hasArgsCount(2, Infinity), withArgsOfReturnType),
    [Ops.Divide]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.Add]: createCallExpressionParser(hasArgsCount(2, Infinity), withArgsOfType(NumberType)),
    [Ops.Subtract]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.Clamp]: createCallExpressionParser(hasArgsCount(3, 3), withArgsOfType(NumberType)),
    [Ops.Mod]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.Pow]: createCallExpressionParser(hasArgsCount(2, 2), withArgsOfType(NumberType)),
    [Ops.Abs]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(NumberType)),
    [Ops.Floor]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(NumberType)),
    [Ops.Ceil]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(NumberType)),
    [Ops.Round]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(NumberType)),
    [Ops.Sin]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(NumberType)),
    [Ops.Cos]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(NumberType)),
    [Ops.Atan]: createCallExpressionParser(hasArgsCount(1, 2), withArgsOfType(NumberType)),
    [Ops.Sqrt]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(NumberType)),
    [Ops.Match]: createCallExpressionParser(hasArgsCount(4, Infinity), hasEvenArgs, withMatchArgs),
    [Ops.Between]: createCallExpressionParser(hasArgsCount(3, 3), withArgsOfType(NumberType)),
    [Ops.Interpolate]: createCallExpressionParser(hasArgsCount(6, Infinity), hasEvenArgs, withInterpolateArgs),
    [Ops.Case]: createCallExpressionParser(hasArgsCount(3, Infinity), hasOddArgs, withCaseArgs),
    [Ops.In]: createCallExpressionParser(hasArgsCount(2, 2), withInArgs),
    [Ops.Number]: createCallExpressionParser(hasArgsCount(1, Infinity), withArgsOfType(AnyType)),
    [Ops.String]: createCallExpressionParser(hasArgsCount(1, Infinity), withArgsOfType(AnyType)),
    [Ops.Array]: createCallExpressionParser(hasArgsCount(1, Infinity), withArgsOfType(NumberType)),
    [Ops.Color]: createCallExpressionParser(hasArgsCount(1, 4), withArgsOfType(NumberType)),
    [Ops.Band]: createCallExpressionParser(hasArgsCount(1, 3), withArgsOfType(NumberType)),
    [Ops.Palette]: createCallExpressionParser(hasArgsCount(2, 2), withPaletteArgs),
    [Ops.ToString]: createCallExpressionParser(hasArgsCount(1, 1), withArgsOfType(BooleanType | NumberType | StringType | ColorType))
};
/**
 * @typedef {function(Array<EncodedExpression>, ValueType, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type {ArgValidator}
 */ function withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case 'number':
                args[i] = new LiteralExpression(NumberType, key);
                break;
            case 'string':
                args[i] = new LiteralExpression(StringType, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.set(String(key), returnType);
    }
    return args;
}
/**
 * This special expression parser reads style variables present in the context to narrow down
 * the expected return type of the 'var' operator
 * @return {Parser} The parser.
 */ function createVarExpressionParser() {
    return function(encoded, returnType, context) {
        const name = encoded[1];
        if (typeof name !== 'string') throw new Error('expected a string argument for var operation');
        let type = returnType;
        const variableValue = context.inputVariables?.[name];
        if (variableValue !== undefined) {
            const parsedInput = parse(variableValue, AnyType, context);
            if (!(parsedInput instanceof LiteralExpression)) throw new Error(`style variables should only be literal values (no expressions!), variable name: ${name}`);
            let parsedType = parsedInput.type;
            // special cases (because variables are not embedded in expressions and as such are harder to figure out their types)
            // * if the variable is a string (e.g. 'blue') and we know that the expected type is not
            //   StringType but ColorType, assume that the variable is indeed a color and not a string
            // * if the variable is 2-elements a number array and we know that the expected type is SizeType
            //   and not NumberArrayType, assume that the variable is indeed a size
            if (typeof variableValue === 'string' && overlapsType(type, ColorType) && !overlapsType(type, StringType)) parsedType = ColorType;
            else if (Array.isArray(variableValue) && variableValue.length === 2 && overlapsType(type, SizeType) && !overlapsType(type, NumberArrayType)) parsedType = SizeType;
            type &= parsedType;
            if (type === NoneType) throw new Error(`the type expected from the var operator (${typeName(returnType)}) did not have any overlap with the type of the corresponding style variables (${typeName(parsedType)}), variable name: ${name}`);
        }
        if (context.variables.has(name)) {
            const existingType = context.variables.get(name);
            type &= existingType;
            if (type === NoneType) throw new Error(`a new type expected from the var operator (${typeName(returnType)}) did not have any overlap with the previous type expected for it (${typeName(existingType)}), variable name: ${name}`);
        }
        context.variables.set(name, type);
        return new CallExpression(type, 'var', new LiteralExpression(StringType, name));
    };
}
/**
 * @type {ArgValidator}
 */ function usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type {ArgValidator}
 */ function usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type {ArgValidator}
 */ function usesMCoordinate(encoded, returnType, context) {
    context.mCoordinate = true;
}
/**
 * @type {ArgValidator}
 */ function usesMapState(encoded, returnType, context) {
    context.mapState = true;
}
/**
 * @type {ArgValidator}
 */ function withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? '' : 's';
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = parse(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {ValueType} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = parse(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @return {ArgValidator} The argument validator
 */ function withArgsOfIdenticalType() {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        let commonType = AnyType;
        for(let i = 0; i < argCount; ++i){
            const expression = parse(encoded[i + 1], commonType, context);
            commonType &= expression.type;
        }
        if (commonType === NoneType) throw new Error(`no common type was found among the arguments of ${operation}`);
        // second loop to compile actual args
        for(let i = 0; i < argCount; ++i){
            const expression = parse(encoded[i + 1], commonType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const fallback = parse(encoded[encoded.length - 1], returnType, context);
    let inputType = StringType | NumberType | BooleanType;
    const args = new Array(argsCount - 2);
    // first round to determine input type
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = parse(encoded[i + 2], inputType, context);
            inputType &= match.type;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        if (inputType === NoneType) throw new Error(`no common type was found among the arguments of match expression`);
    }
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = parse(encoded[i + 2], inputType, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = parse(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    const input = parse(encoded[1], inputType, context);
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type {ArgValidator}
 */ function withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case 'linear':
            base = 1;
            break;
        case 'exponential':
            const b = interpolationType[1];
            if (typeof b !== 'number' || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new LiteralExpression(NumberType, base);
    let input;
    try {
        input = parse(encoded[2], NumberType, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = parse(encoded[i + 3], NumberType, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = parse(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function withCaseArgs(encoded, returnType, context) {
    const fallback = parse(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = parse(encoded[i + 1], BooleanType, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = parse(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type {ArgValidator}
 */ function withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {ValueType}
   */ let needleType;
    // check if we're using the 'literal' operator for the haystack
    if (haystack[0] === 'literal') {
        haystack = haystack[1];
        if (!Array.isArray(haystack)) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
    } else if (typeof haystack[0] === 'string') throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
    if (typeof haystack[0] === 'string') needleType = StringType;
    else needleType = NumberType;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = parse(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = parse(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = parse(encoded[1], NumberType, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error('the second argument of palette must be an array');
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = parse(colors[i], ColorType, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof LiteralExpression)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error('expected last argument validator to return the parsed args');
                args = parsed;
            }
        }
        return new CallExpression(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {ValueType} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function computeGeometryType(geometry) {
    if (!geometry) return '';
    const type = geometry.getType();
    switch(type){
        case 'Point':
        case 'LineString':
        case 'Polygon':
            return type;
        case 'MultiPoint':
        case 'MultiLineString':
        case 'MultiPolygon':
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case 'Circle':
            return 'Polygon';
        case 'GeometryCollection':
            return computeGeometryType(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return '';
    }
}

},{"../array.js":"2IuG2","../color.js":"jC16r","../size.js":"8DeXL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8DeXL":[function(require,module,exports,__globalThis) {
/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", ()=>buffer);
/**
 * Determines if a size has a positive area.
 * @param {Size} size The size to test.
 * @return {boolean} The size has a positive area.
 */ parcelHelpers.export(exports, "hasArea", ()=>hasArea);
/**
 * Returns a size scaled by a ratio. The result will be an array of integers.
 * @param {Size} size Size.
 * @param {number} ratio Ratio.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The scaled size.
 */ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * Returns an `Size` array for the passed in number (meaning: square) or
 * `Size` array.
 * (meaning: non-square),
 * @param {number|Size} size Width and height.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} Size.
 * @api
 */ parcelHelpers.export(exports, "toSize", ()=>toSize);
function buffer(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function hasArea(size) {
    return size[0] > 0 && size[1] > 0;
}
function scale(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function toSize(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3Wl62":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/Circle
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regularShapeJs = require("./RegularShape.js");
var _regularShapeJsDefault = parcelHelpers.interopDefault(_regularShapeJs);
/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class CircleStyle extends (0, _regularShapeJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
}
exports.default = CircleStyle;

},{"./RegularShape.js":"k8Wqi","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"k8Wqi":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/RegularShape
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _colorJs = require("../color.js");
var _colorlikeJs = require("../colorlike.js");
var _domJs = require("../dom.js");
var _canvasJs = require("../render/canvas.js");
var _iconImageJs = require("./IconImage.js");
var _iconImageJsDefault = parcelHelpers.interopDefault(_iconImageJs);
var _iconImageCacheJs = require("./IconImageCache.js");
var _imageJs = require("./Image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class RegularShape extends (0, _imageJsDefault.default) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, _imageStateJsDefault.default).LOADING : (0, _imageStateJsDefault.default).LOADED;
        if (this.imageState_ === (0, _imageStateJsDefault.default).LOADING) this.ready().then(()=>this.imageState_ = (0, _imageStateJsDefault.default).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement|OffscreenCanvas} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        const fillKey = this.fill_?.getKey();
        const cacheKey = `${pixelRatio},${this.angle_},${this.radius},${this.radius2_},${this.points_},${fillKey}` + Object.values(this.renderOptions_).join(',');
        let image = /** @type {HTMLCanvasElement|OffscreenCanvas} */ (0, _iconImageCacheJs.shared).get(cacheKey, null)?.getImage(1);
        if (!image) {
            const renderOptions = this.renderOptions_;
            const size = Math.ceil(renderOptions.size * pixelRatio);
            const context = (0, _domJs.createCanvasContext2D)(size, size);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            const iconImage = new (0, _iconImageJsDefault.default)(image, undefined, null, (0, _imageStateJsDefault.default).LOADED, null);
            (0, _iconImageCacheJs.shared).set(cacheKey, null, iconImage);
            // Update the image in place to an ImageBitmap for better performance and lower memory usage
            createImageBitmap(image).then((imageBitmap)=>{
                iconImage.setImage(imageBitmap);
            });
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Set the (primary) radius for the shape.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        if (this.radius === radius) return;
        this.radius = radius;
        this.render();
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Set the secondary radius for the shape.
   * @param {number|undefined} radius2 Radius2.
   * @api
   */ setRadius2(radius2) {
        if (this.radius2_ === radius2) return;
        this.radius2_ = radius2;
        this.render();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, _canvasJs.defaultLineCap);
        let lineJoin = (0, _canvasJs.defaultLineJoin);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, _colorlikeJs.asColorLike)(this.stroke_.getColor() ?? (0, _canvasJs.defaultStrokeStyle));
            strokeWidth = this.stroke_.getWidth() ?? (0, _canvasJs.defaultLineWidth);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, _canvasJs.defaultLineJoin);
            lineCap = this.stroke_.getLineCap() ?? (0, _canvasJs.defaultLineCap);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, _canvasJs.defaultMiterLimit);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, _canvasJs.defaultFillStyle);
            context.fillStyle = (0, _colorlikeJs.asColorLike)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === 'string') color = (0, _colorJs.asArray)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, _domJs.createCanvasContext2D)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, _canvasJs.defaultFillStyle);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
exports.default = RegularShape;

},{"../ImageState.js":"7kySV","../color.js":"jC16r","../colorlike.js":"8r5Mb","../dom.js":"gfuif","../render/canvas.js":"8UJXP","./IconImage.js":"l473j","./IconImageCache.js":"iGRH9","./Image.js":"5jOyA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7kySV":[function(require,module,exports,__globalThis) {
/**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8r5Mb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/colorlike
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} PatternDescriptor
 * @property {string} src Pattern image URL
 * @property {import("./color.js").Color|string} [color] Color to tint the pattern with.
 * @property {import("./size.js").Size} [size] Size of the desired slice from the pattern image.
 * Use this together with `offset` when the pattern image is a sprite sheet.
 * @property {import("./size.js").Size} [offset] Offset of the desired slice from the pattern image.
 * Use this together with `size` when the pattern image is a sprite sheet.
 */ /**
 * A type accepted by CanvasRenderingContext2D.fillStyle
 * or CanvasRenderingContext2D.strokeStyle.
 * Represents a color, [CanvasPattern](https://developer.mozilla.org/en-US/docs/Web/API/CanvasPattern),
 * or [CanvasGradient](https://developer.mozilla.org/en-US/docs/Web/API/CanvasGradient). The origin for
 * patterns and gradients as fill style is an increment of 512 css pixels from map coordinate
 * `[0, 0]`. For seamless repeat patterns, width and height of the pattern image
 * must be a factor of two (2, 4, 8, ..., 512).
 *
 * @typedef {string|CanvasPattern|CanvasGradient} ColorLike
 * @api
 */ /**
 * @param {import("./color.js").Color|ColorLike|PatternDescriptor|null} color Color.
 * @return {ColorLike|null} The color as an {@link ol/colorlike~ColorLike}.
 * @api
 */ parcelHelpers.export(exports, "asColorLike", ()=>asColorLike);
var _imageStateJs = require("./ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _colorJs = require("./color.js");
var _domJs = require("./dom.js");
var _iconImageJs = require("./style/IconImage.js");
var _iconImageCacheJs = require("./style/IconImageCache.js");
function asColorLike(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, _colorJs.toString)(color);
    if (typeof color === 'object' && 'src' in color) return asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, _iconImageCacheJs.shared).getPattern(pattern.src, pattern.color);
    const cacheKey = pattern.src + ':' + pattern.offset;
    const canvasPattern = (0, _iconImageCacheJs.shared).getPattern(cacheKey, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, _iconImageCacheJs.shared).get(pattern.src, null);
    if (iconImage.getImageState() !== (0, _imageStateJsDefault.default).LOADED) return null;
    const patternCanvasContext = (0, _domJs.createCanvasContext2D)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, _iconImageJs.get)(patternCanvasContext.canvas, cacheKey, undefined, (0, _imageStateJsDefault.default).LOADED, pattern.color, true);
    return (0, _iconImageCacheJs.shared).getPattern(cacheKey, pattern.color);
}

},{"./ImageState.js":"7kySV","./color.js":"jC16r","./dom.js":"gfuif","./style/IconImage.js":"l473j","./style/IconImageCache.js":"iGRH9","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"l473j":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/IconImage
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null} image Image.
 * @param {string|undefined} src Src.
 * @param {import('../dom.js').ImageAttributes} imageAttributes Image attributes options.
 * @param {import("../ImageState.js").default|undefined} imageState Image state.
 * @param {import("../color.js").Color|string|null} color Color.
 * @param {boolean} [pattern] Also cache a `repeat` pattern with the icon image.
 * @return {IconImage} Icon image.
 */ parcelHelpers.export(exports, "get", ()=>get);
var _imageJs = require("../Image.js");
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _colorJs = require("../color.js");
var _domJs = require("../dom.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _targetJs = require("../events/Target.js");
var _targetJsDefault = parcelHelpers.interopDefault(_targetJs);
var _iconImageCacheJs = require("./IconImageCache.js");
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let taintedTestContext = null;
class IconImage extends (0, _targetJsDefault.default) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {import('../dom.js').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, imageAttributes, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|OffscreenCanvas|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement|OffscreenCanvas>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, _imageStateJsDefault.default).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, _imageStateJsDefault.default).LOADED) {
            if (!taintedTestContext) taintedTestContext = (0, _domJs.createCanvasContext2D)(1, 1, undefined, {
                willReadFrequently: true
            });
            taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch  {
                taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, _eventTypeJsDefault.default).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, _imageStateJsDefault.default).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, _imageStateJsDefault.default).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} image Image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, _domJs.createCanvasContext2D)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, _imageStateJsDefault.default).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, _imageStateJsDefault.default).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch  {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, _imageJs.decodeFallback)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, _imageStateJsDefault.default).LOADED) return;
        const image = this.image_;
        const ctx = (0, _domJs.createCanvasContext2D)(Math.ceil(image.width * pixelRatio), Math.ceil(image.height * pixelRatio));
        const canvas = ctx.canvas;
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = (0, _colorJs.asString)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, _imageStateJsDefault.default).LOADED || this.imageState_ === (0, _imageStateJsDefault.default).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, _imageStateJsDefault.default).LOADED || this.imageState_ === (0, _imageStateJsDefault.default).ERROR) {
                        this.removeEventListener((0, _eventTypeJsDefault.default).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, _eventTypeJsDefault.default).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function get(image, src, imageAttributes, imageState, color, pattern) {
    let iconImage = src === undefined ? undefined : (0, _iconImageCacheJs.shared).get(src, color);
    if (!iconImage) {
        iconImage = new IconImage(image, image && 'src' in image ? image.src || undefined : src, imageAttributes, imageState, color);
        (0, _iconImageCacheJs.shared).set(src, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, _iconImageCacheJs.shared).getPattern(src, color)) (0, _iconImageCacheJs.shared).set(src, color, iconImage, pattern);
    return iconImage;
}
exports.default = IconImage;

},{"../Image.js":"dfn7g","../ImageState.js":"7kySV","../color.js":"jC16r","../dom.js":"gfuif","../events/EventType.js":"79Bvl","../events/Target.js":"cPkjL","./IconImageCache.js":"iGRH9","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dfn7g":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Image
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {import('./DataTile.js').ImageLike} image Image element.
 * @param {function():any} loadHandler Load callback function.
 * @param {function():any} errorHandler Error callback function.
 * @return {function():void} Callback to stop listening.
 */ parcelHelpers.export(exports, "listenImage", ()=>listenImage);
/**
 * Loads an image.
 * @param {HTMLImageElement} image Image, not yet loaded.
 * @param {string} [src] `src` attribute of the image. Optional, not required if already present.
 * @return {Promise<HTMLImageElement>} Promise resolving to an `HTMLImageElement`.
 * @api
 */ parcelHelpers.export(exports, "load", ()=>load);
/**
 * @param {HTMLImageElement} image Image, not yet loaded.
 * @param {string} [src] `src` attribute of the image. Optional, not required if already present.
 * @return {Promise<HTMLImageElement>} Promise resolving to an `HTMLImageElement`.
 */ parcelHelpers.export(exports, "decodeFallback", ()=>decodeFallback);
/**
 * Loads an image and decodes it to an `ImageBitmap` if `createImageBitmap()` is supported. Returns
 * the loaded image otherwise.
 * @param {HTMLImageElement} image Image, not yet loaded.
 * @param {string} [src] `src` attribute of the image. Optional, not required if already present.
 * @return {Promise<ImageBitmap|HTMLImageElement>} Promise resolving to an `ImageBitmap` or an
 * `HTMLImageElement` if `createImageBitmap()` is not supported.
 * @api
 */ parcelHelpers.export(exports, "decode", ()=>decode);
var _imageStateJs = require("./ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _eventsJs = require("./events.js");
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _targetJs = require("./events/Target.js");
var _targetJsDefault = parcelHelpers.interopDefault(_targetJs);
var _functionsJs = require("./functions.js");
var _hasJs = require("./has.js");
/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class ImageWrapper extends (0, _targetJsDefault.default) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === 'function' ? (0, _imageStateJsDefault.default).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {Loader|null}
     */ this.loader = typeof stateOrLoader === 'function' ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, _eventTypeJsDefault.default).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, _imageStateJsDefault.default).IDLE) {
            if (this.loader) {
                this.state = (0, _imageStateJsDefault.default).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, _functionsJs.toPromise)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ('image' in image) this.image_ = image.image;
                    if ('extent' in image) this.extent = image.extent;
                    if ('resolution' in image) this.resolution = image.resolution;
                    if ('pixelRatio' in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || (0, _hasJs.CREATE_IMAGE_BITMAP) && image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, _imageStateJsDefault.default).LOADED;
                }).catch((error)=>{
                    this.state = (0, _imageStateJsDefault.default).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function listenImage(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, _eventsJs.listenOnce)(img, (0, _eventTypeJsDefault.default).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, _hasJs.IMAGE_DECODE)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, _eventsJs.listenOnce)(img, (0, _eventTypeJsDefault.default).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, _eventsJs.unlistenByKey));
    };
}
function load(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error('Image load error'));
        }
        function unlisten() {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        }
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (src) image.src = src;
    });
}
function decodeFallback(image, src) {
    if (src) image.src = src;
    return image.src && (0, _hasJs.IMAGE_DECODE) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : load(image);
}
function decode(image, src) {
    if (src) image.src = src;
    return image.src && (0, _hasJs.IMAGE_DECODE) && (0, _hasJs.CREATE_IMAGE_BITMAP) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : decodeFallback(image);
}
exports.default = ImageWrapper;

},{"./ImageState.js":"7kySV","./events.js":"Vqr1Z","./events/EventType.js":"79Bvl","./events/Target.js":"cPkjL","./functions.js":"5nAKV","./has.js":"hbGE6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iGRH9":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/IconImageCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} src Src.
 * @param {import("../color.js").Color|string|null} color Color.
 * @return {string} Cache key.
 */ parcelHelpers.export(exports, "getCacheKey", ()=>getCacheKey);
parcelHelpers.export(exports, "shared", ()=>shared);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _colorJs = require("../color.js");
var _domJs = require("../dom.js");
/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 1024;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, color) {
        const key = getCacheKey(src, color);
        const icon = key in this.cache_ ? this.cache_[key] : null;
        return icon;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, color) {
        const key = getCacheKey(src, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, color, iconImage, pattern) {
        const key = getCacheKey(src, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, _imageStateJsDefault.default).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, _imageStateJsDefault.default).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, _domJs.getSharedCanvasContext2D)().createPattern(iconImage.getImage(1), 'repeat');
            });
            else this.patternCache_[key] = (0, _domJs.getSharedCanvasContext2D)().createPattern(iconImage.getImage(1), 'repeat');
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `1024`. Change this value when
   * your map uses more than 1024 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function getCacheKey(src, color) {
    const colorString = color ? (0, _colorJs.asArray)(color) : 'null';
    return src + ':' + colorString;
}
exports.default = IconImageCache;
const shared = new IconImageCache();

},{"../ImageState.js":"7kySV","../color.js":"jC16r","../dom.js":"gfuif","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8UJXP":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultFont", ()=>defaultFont);
parcelHelpers.export(exports, "defaultFillStyle", ()=>defaultFillStyle);
parcelHelpers.export(exports, "defaultLineCap", ()=>defaultLineCap);
parcelHelpers.export(exports, "defaultLineDash", ()=>defaultLineDash);
parcelHelpers.export(exports, "defaultLineDashOffset", ()=>defaultLineDashOffset);
parcelHelpers.export(exports, "defaultLineJoin", ()=>defaultLineJoin);
parcelHelpers.export(exports, "defaultMiterLimit", ()=>defaultMiterLimit);
parcelHelpers.export(exports, "defaultStrokeOffset", ()=>defaultStrokeOffset);
parcelHelpers.export(exports, "defaultStrokeStyle", ()=>defaultStrokeStyle);
parcelHelpers.export(exports, "defaultTextAlign", ()=>defaultTextAlign);
parcelHelpers.export(exports, "defaultTextBaseline", ()=>defaultTextBaseline);
parcelHelpers.export(exports, "defaultPadding", ()=>defaultPadding);
parcelHelpers.export(exports, "defaultLineWidth", ()=>defaultLineWidth);
parcelHelpers.export(exports, "checkedFonts", ()=>checkedFonts);
parcelHelpers.export(exports, "textHeights", ()=>textHeights);
parcelHelpers.export(exports, "registerFont", ()=>registerFont);
parcelHelpers.export(exports, "measureTextHeight", ()=>measureTextHeight);
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {number} Width.
 */ parcelHelpers.export(exports, "measureTextWidth", ()=>measureTextWidth);
/**
 * Measure text width using a cache.
 * @param {string} font The font.
 * @param {string} text The text to measure.
 * @param {Object<string, number>} cache A lookup of cached widths by text.
 * @return {number} The text width.
 */ parcelHelpers.export(exports, "measureAndCacheTextWidth", ()=>measureAndCacheTextWidth);
/**
 * @param {TextState} baseStyle Base style.
 * @param {Array<string>} chunks Text chunks to measure.
 * @return {{width: number, height: number, widths: Array<number>, heights: Array<number>, lineWidths: Array<number>}}} Text metrics.
 */ parcelHelpers.export(exports, "getTextDimensions", ()=>getTextDimensions);
/**
 * @param {CanvasRenderingContext2D} context Context.
 * @param {number} rotation Rotation.
 * @param {number} offsetX X offset.
 * @param {number} offsetY Y offset.
 */ parcelHelpers.export(exports, "rotateAtOffset", ()=>rotateAtOffset);
/**
 * @param {CanvasRenderingContext2D|import("../render/canvas/ZIndexContext.js").ZIndexContextProxy} context Context.
 * @param {import("../transform.js").Transform|null} transform Transform.
 * @param {number} opacity Opacity.
 * @param {Label|HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} labelOrImage Label.
 * @param {number} originX Origin X.
 * @param {number} originY Origin Y.
 * @param {number} w Width.
 * @param {number} h Height.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {import("../size.js").Size} scale Scale.
 */ parcelHelpers.export(exports, "drawImageOrLabel", ()=>drawImageOrLabel);
var _objectJs = require("../Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _cssJs = require("../css.js");
var _domJs = require("../dom.js");
var _hasJs = require("../has.js");
var _objJs = require("../obj.js");
const defaultFont = '10px sans-serif';
const defaultFillStyle = '#000';
const defaultLineCap = 'round';
const defaultLineDash = [];
const defaultLineDashOffset = 0;
const defaultLineJoin = 'round';
const defaultMiterLimit = 10;
const defaultStrokeOffset = 0;
const defaultStrokeStyle = '#000';
const defaultTextAlign = 'center';
const defaultTextBaseline = 'middle';
const defaultPadding = [
    0,
    0,
    0,
    0
];
const defaultLineWidth = 1;
const checkedFonts = new (0, _objectJsDefault.default)();
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let measureContext = null;
/**
 * @type {string}
 */ let measureFont;
const textHeights = {};
const genericFontFamilies = new Set([
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'emoji',
    'math',
    'fangsong'
]);
/**
 * @param {string} style Css font-style
 * @param {string} weight Css font-weight
 * @param {string} family Css font-family
 * @return {string} Font key.
 */ function getFontKey(style, weight, family) {
    return `${style} ${weight} 16px "${family}"`;
}
const registerFont = function() {
    const retries = 100;
    let timeout, fontFaceSet;
    /**
   * @param {string} fontSpec Css font spec
   * @return {Promise<boolean>} Font with style and weight is available
   */ async function isAvailable(fontSpec) {
        await fontFaceSet.ready;
        const font = (0, _cssJs.getFontParameters)(fontSpec);
        const checkFamily = font.families[0].toLowerCase();
        const checkWeight = font.weight;
        /** @type {Array<FontFace>} */ const matching = [];
        fontFaceSet.forEach(/**
       * @param {FontFace} f Font face.
       */ (f)=>{
            const family = f.family.replace(/^['"]|['"]$/g, '').toLowerCase();
            const weight = (0, _cssJs.fontWeights)[f.weight] || f.weight;
            if (family === checkFamily && f.style === font.style && weight == checkWeight) matching.push(f);
        });
        if (matching.length === 0) return false;
        // Load each matching face with `FontFace.load()` instead of querying the
        // set with `FontFaceSet.load()`. The latter only resolves faces whose
        // `unicode-range` covers its (default) test string, so subset fonts -
        // e.g. those served by Google Fonts - would never be detected.
        const loaded = await Promise.all(matching.map((f)=>f.load().then(()=>true, ()=>false)));
        return loaded.some((available)=>available);
    }
    async function check() {
        await fontFaceSet.ready;
        let done = true;
        const checkedFontsProperties = checkedFonts.getProperties();
        const fonts = Object.keys(checkedFontsProperties).filter((key)=>checkedFontsProperties[key] < retries);
        for(let i = fonts.length - 1; i >= 0; --i){
            const font = fonts[i];
            let currentRetries = checkedFontsProperties[font];
            if (currentRetries < retries) {
                if (await isAvailable(font)) {
                    (0, _objJs.clear)(textHeights);
                    checkedFonts.set(font, retries);
                } else {
                    currentRetries += 10;
                    checkedFonts.set(font, currentRetries, true);
                    if (currentRetries < retries) done = false;
                }
            }
        }
        timeout = undefined;
        if (!done) timeout = setTimeout(check, 100);
    }
    return async function(fontSpec) {
        if (!fontFaceSet) fontFaceSet = (0, _hasJs.WORKER_OFFSCREEN_CANVAS) ? self.fonts : document.fonts;
        const font = (0, _cssJs.getFontParameters)(fontSpec);
        if (!font) return;
        const families = font.families;
        let needCheck = false;
        for (const family of families){
            if (genericFontFamilies.has(family)) continue;
            const key = getFontKey(font.style, font.weight, family);
            if (checkedFonts.get(key) !== undefined) continue;
            checkedFonts.set(key, 0, true);
            needCheck = true;
        }
        if (needCheck) {
            clearTimeout(timeout);
            timeout = setTimeout(check, 100);
        }
    };
}();
const measureTextHeight = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = textHeights[fontSpec];
        if (height == undefined) {
            if (0, _hasJs.WORKER_OFFSCREEN_CANVAS) {
                const font = (0, _cssJs.getFontParameters)(fontSpec);
                const metrics = measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            textHeights[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function measureText(font, text) {
    if (!measureContext) measureContext = (0, _domJs.createCanvasContext2D)(1, 1);
    if (font != measureFont) {
        measureContext.font = font;
        measureFont = measureContext.font;
    }
    return measureContext.measureText(text);
}
function measureTextWidth(font, text) {
    return measureText(font, text).width;
}
function measureAndCacheTextWidth(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split('\n').reduce((prev, curr)=>Math.max(prev, measureTextWidth(font, curr)), 0);
    cache[text] = width;
    return width;
}
function getTextDimensions(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = measureTextWidth(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = measureTextHeight(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width,
        height,
        widths,
        heights,
        lineWidths
    };
}
function rotateAtOffset(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function drawImageOrLabel(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
 */ function executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}

},{"../Object.js":"lFhbz","../css.js":"eP7Pk","../dom.js":"gfuif","../has.js":"hbGE6","../obj.js":"GxveT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5jOyA":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/Image
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sizeJs = require("../size.js");
var _utilJs = require("../util.js");
/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, _sizeJs.toSize)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, _utilJs.abstract)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, _utilJs.abstract)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, _sizeJs.toSize)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, _utilJs.abstract)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, _utilJs.abstract)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, _utilJs.abstract)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
exports.default = ImageStyle;

},{"../size.js":"8DeXL","../util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"24G0i":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/Fill
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _colorJs = require("../color.js");
var _utilJs = require("../util.js");
var _iconImageJs = require("./IconImage.js");
/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === 'object' && 'src' in color) {
            const patternImage = (0, _iconImageJs.get)(null, color.src, {
                crossOrigin: 'anonymous'
            }, undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, _imageStateJsDefault.default).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, _imageStateJsDefault.default).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {string} Key of the fill for cache lookup.
   */ getKey() {
        const fill = this.getColor();
        if (!fill) return '';
        return fill instanceof CanvasPattern || fill instanceof CanvasGradient ? (0, _utilJs.getUid)(fill) : typeof fill === 'object' && 'src' in fill ? fill.src + ':' + fill.offset : (0, _colorJs.asArray)(fill).toString();
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
exports.default = Fill;

},{"../ImageState.js":"7kySV","../color.js":"jC16r","../util.js":"9Y20j","./IconImage.js":"l473j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ib4Ft":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/Icon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _assertsJs = require("../asserts.js");
var _colorJs = require("../color.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _utilJs = require("../util.js");
var _iconImageJs = require("./IconImage.js");
var _imageJs = require("./Image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class Icon extends (0, _imageJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : 'top-left';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : 'fraction';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : 'fraction';
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = options.referrerPolicy;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, _assertsJs.assert)(!(cacheKey !== undefined && image), '`image` and `src` cannot be provided at the same time');
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, _utilJs.getUid)(image);
        (0, _assertsJs.assert)(cacheKey !== undefined && cacheKey.length > 0, 'A defined and non-empty `src` or `image` must be provided');
        (0, _assertsJs.assert)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), '`width` or `height` cannot be provided together with `scale`');
        let imageState;
        if (options.src !== undefined) imageState = (0, _imageStateJsDefault.default).IDLE;
        else if (image !== undefined) {
            if ('complete' in image) {
                if (image.complete) imageState = image.src ? (0, _imageStateJsDefault.default).LOADED : (0, _imageStateJsDefault.default).IDLE;
                else imageState = (0, _imageStateJsDefault.default).LOADING;
            } else imageState = (0, _imageStateJsDefault.default).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, _colorJs.asArray)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, _iconImageJs.get)(image, /** @type {string} */ cacheKey, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : 'top-left';
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale(calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale(calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale,
            width,
            height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == 'fraction' || this.anchorYUnits_ == 'fraction') {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == 'fraction') anchor[0] *= size[0];
                if (this.anchorYUnits_ == 'fraction') anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != 'top-left') {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == 'top-right' || this.anchorOrigin_ == 'bottom-right') anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == 'bottom-left' || this.anchorOrigin_ == 'bottom-right') anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the icon color.
   *
   * Warning: Repeatedly setting the color on an icon style
   * causes the icon image to be re-created each time. This can have a
   * severe performance impact.
   *
   * @param {import("../color.js").Color|string|null|undefined} color Color.
   */ setColor(color) {
        const nextColor = color ? (0, _colorJs.asArray)(color) : null;
        if (this.color_ === nextColor || this.color_ && nextColor && this.color_.length === nextColor.length && this.color_.every((value, index)=>value === nextColor[index])) // Discard if the color hasn't changed.
        return;
        this.color_ = nextColor;
        const src = this.getSrc();
        const image = src !== undefined ? null : this.getHitDetectionImage();
        const imageState = src !== undefined ? (0, _imageStateJsDefault.default).IDLE : this.iconImage_.getImageState();
        this.iconImage_ = (0, _iconImageJs.get)(image, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != 'top-left') {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == 'top-right' || this.offsetOrigin_ == 'bottom-right') offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == 'bottom-left' || this.offsetOrigin_ == 'bottom-right') offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Set the image URI
   * @param {string} src Image source URI
   * @api
   */ setSrc(src) {
        this.iconImage_ = (0, _iconImageJs.get)(null, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, (0, _imageStateJsDefault.default).IDLE, this.color_);
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, _imageStateJsDefault.default).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, _imageStateJsDefault.default).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, _eventTypeJsDefault.default).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, _eventTypeJsDefault.default).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
exports.default = Icon;

},{"../ImageState.js":"7kySV","../asserts.js":"csqTx","../color.js":"jC16r","../events/EventType.js":"79Bvl","../util.js":"9Y20j","./IconImage.js":"l473j","./Image.js":"5jOyA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cese4":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [offset] Line offset in pixels along the normal. A positive value offsets the line to the right,
 * relative to the direction of the line. Default is `undefined` (no offset).
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.offset_ = options.offset;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            offset: this.getOffset(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the line offset in pixels.
   * @return {number|undefined} Offset.
   * @api
   */ getOffset() {
        return this.offset_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the line offset in pixels.
   *
   * @param {number|undefined} offset Offset.
   * @api
   */ setOffset(offset) {
        this.offset_ = offset;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
exports.default = Stroke;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gqpPW":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/Style
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert the provided object into a style function.  Functions passed through
 * unchanged.  Arrays of Style or single style objects wrapped in a
 * new style function.
 * @param {StyleFunction|Array<Style>|Style} obj
 *     A style function, a single style, or an array of styles.
 * @return {StyleFunction} A style function.
 */ parcelHelpers.export(exports, "toFunction", ()=>toFunction);
/**
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} resolution Resolution.
 * @return {Array<Style>} Style.
 */ parcelHelpers.export(exports, "createDefaultStyle", ()=>createDefaultStyle);
/**
 * Default styles for editing features.
 * @return {Object<import("../geom/Geometry.js").Type, Array<Style>>} Styles
 */ parcelHelpers.export(exports, "createEditingStyle", ()=>createEditingStyle);
var _assertsJs = require("../asserts.js");
var _circleJs = require("./Circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _fillJs = require("./Fill.js");
var _fillJsDefault = parcelHelpers.interopDefault(_fillJs);
var _strokeJs = require("./Stroke.js");
var _strokeJsDefault = parcelHelpers.interopDefault(_strokeJs);
/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * **declutter**: Overlapping symbols and text are decluttered.
 * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction|null} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function toFunction(obj) {
    let styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, _assertsJs.assert)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `Style` or an array of `Style`');
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let defaultStyles = null;
function createDefaultStyle(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!defaultStyles) {
        const fill = new (0, _fillJsDefault.default)({
            color: 'rgba(255,255,255,0.4)'
        });
        const stroke = new (0, _strokeJsDefault.default)({
            color: '#3399CC',
            width: 1.25
        });
        defaultStyles = [
            new Style({
                image: new (0, _circleJsDefault.default)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return defaultStyles;
}
function createEditingStyle() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles['Polygon'] = [
        new Style({
            fill: new (0, _fillJsDefault.default)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new Style({
            stroke: new (0, _strokeJsDefault.default)({
                color: white,
                width: width + 2
            })
        }),
        new Style({
            stroke: new (0, _strokeJsDefault.default)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new Style({
            image: new (0, _circleJsDefault.default)({
                radius: width * 2,
                fill: new (0, _fillJsDefault.default)({
                    color: blue
                }),
                stroke: new (0, _strokeJsDefault.default)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
exports.default = Style;

},{"../asserts.js":"csqTx","./Circle.js":"3Wl62","./Fill.js":"24G0i","./Stroke.js":"cese4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"118sC":[function(require,module,exports,__globalThis) {
/**
 * @module ol/style/Text
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sizeJs = require("../size.js");
var _fillJs = require("./Fill.js");
var _fillJsDefault = parcelHelpers.interopDefault(_fillJs);
/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {boolean} [keepUpright=true] Whether the text can be rotated 180° to prevent being rendered upside down.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.keepUpright_ = options.keepUpright;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, _sizeJs.toSize)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, _fillJsDefault.default)({
            color: DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : 'point';
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            keepUpright: this.getKeepUpright(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() instanceof (0, _fillJsDefault.default) ? this.getFill().clone() : this.getFill(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Determine whether the text can be rendered upside down.
   * @return {boolean|undefined} Keep text upright.
   * @api
   */ getKeepUpright() {
        return this.keepUpright_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set whether the text can be rendered upside down.
   *
   * @param {boolean} keepUpright Keep text upright.
   * @api
   */ setKeepUpright(keepUpright) {
        this.keepUpright_ = keepUpright;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, _sizeJs.toSize)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
exports.default = Text;

},{"../size.js":"8DeXL","./Fill.js":"24G0i","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3wbs1":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/Event
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
class RenderEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
exports.default = RenderEvent;

},{"../events/Event.js":"5kI1G","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aH9V2":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/Map
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _disposableJs = require("../Disposable.js");
var _disposableJsDefault = parcelHelpers.interopDefault(_disposableJs);
var _coordinateJs = require("../coordinate.js");
var _extentJs = require("../extent.js");
var _functionsJs = require("../functions.js");
var _layerJs = require("../layer/Layer.js");
var _iconImageCacheJs = require("../style/IconImageCache.js");
var _transformJs = require("../transform.js");
var _utilJs = require("../util.js");
/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class MapRenderer extends (0, _disposableJsDefault.default) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, _utilJs.abstract)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, _transformJs.compose)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, _transformJs.makeInverse)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, _coordinateJs.wrapX)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, _extentJs.getWidth)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, _layerJs.inView)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, _functionsJs.TRUE), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, _utilJs.abstract)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, _iconImageCacheJs.shared).canExpireCache()) frameState.postRenderFunctions.push(expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function expireIconCache(map, frameState) {
    (0, _iconImageCacheJs.shared).expire();
}
exports.default = MapRenderer;

},{"../Disposable.js":"7LWtn","../coordinate.js":"9bcSP","../extent.js":"MPjK5","../functions.js":"5nAKV","../layer/Layer.js":"aZQOw","../style/IconImageCache.js":"iGRH9","../transform.js":"7TqcG","../util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hik4h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AzureLoginControl", ()=>AzureLoginControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _msalBrowser = require("@azure/msal-browser");
var _getMsalObj = require("../auth/getMsalObj");
// ID tokens are short-lived (~60-90 min). Re-acquiring silently on this
// interval keeps AzureLoginControl's idToken/idTokenClaims fresh for
// consumers (WFSLayer, SDOLayer, DirectionalLayers, BoundaryCodesControl,
// HeatmapLayersAndControls) that read a cached token instead of asking MSAL
// per-request the way monkeyFetch.js does.
const TOKEN_REFRESH_INTERVAL_MS = 300000;
class AzureLoginControl extends (0, _controlDefault.default) {
    constructor(){
        const div = document.createElement("div");
        div.className = "login";
        super({
            element: div
        });
        const this_ = this;
        function refreshToken(msalObj) {
            const account = msalObj.getAllAccounts()[0];
            const request = {
                account: account,
                scopes: [
                    "https://storage.azure.com/user_impersonation"
                ]
            };
            return msalObj.acquireTokenSilent(request).then(function(tokenResponse) {
                this_.set("idToken", tokenResponse.idToken);
                this_.set("idTokenClaims", tokenResponse.idTokenClaims);
            }).catch(function(error) {
                console.log(error);
                if (error instanceof _msalBrowser.InteractionRequiredAuthError || error instanceof _msalBrowser.BrowserAuthError) msalObj.acquireTokenRedirect(request);
            });
        }
        (0, _getMsalObj.getMsalObjPromise)().then((msalObj)=>{
            refreshToken(msalObj);
            setInterval(()=>refreshToken(msalObj), TOKEN_REFRESH_INTERVAL_MS);
        });
        const button = document.createElement("button");
        button.textContent = "Log In";
        button.className = "login-btn";
        div.appendChild(button);
        this.on("propertychange", function(e) {
            if (e.key === "idToken" && e.target.get("idToken")) {
                button.textContent = "Logged In";
                button.style.background = "#3CB371";
            }
        });
    }
}

},{"ol/control/Control":"8KSMn","@azure/msal-browser":"kSeZg","../auth/getMsalObj":"hTW2R","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kSeZg":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", ()=>(0, _browser.AuthError));
parcelHelpers.export(exports, "AuthErrorCodes", ()=>(0, _browser.AuthErrorCodes));
parcelHelpers.export(exports, "AuthenticationHeaderParser", ()=>(0, _browser.AuthenticationHeaderParser));
parcelHelpers.export(exports, "AzureCloudInstance", ()=>(0, _browser.AzureCloudInstance));
parcelHelpers.export(exports, "ClientAuthError", ()=>(0, _browser.ClientAuthError));
parcelHelpers.export(exports, "ClientAuthErrorCodes", ()=>(0, _browser.ClientAuthErrorCodes));
parcelHelpers.export(exports, "ClientConfigurationError", ()=>(0, _browser.ClientConfigurationError));
parcelHelpers.export(exports, "ClientConfigurationErrorCodes", ()=>(0, _browser.ClientConfigurationErrorCodes));
parcelHelpers.export(exports, "InteractionRequiredAuthError", ()=>(0, _browser.InteractionRequiredAuthError));
parcelHelpers.export(exports, "InteractionRequiredAuthErrorCodes", ()=>(0, _browser.InteractionRequiredAuthErrorCodes));
parcelHelpers.export(exports, "LogLevel", ()=>(0, _browser.LogLevel));
parcelHelpers.export(exports, "Logger", ()=>(0, _browser.Logger));
parcelHelpers.export(exports, "ProtocolMode", ()=>(0, _browser.ProtocolMode));
parcelHelpers.export(exports, "ServerError", ()=>(0, _browser.ServerError));
parcelHelpers.export(exports, "StubPerformanceClient", ()=>(0, _browser.StubPerformanceClient));
parcelHelpers.export(exports, "enforceResourceParameter", ()=>(0, _browser.enforceResourceParameter));
parcelHelpers.export(exports, "PublicClientApplication", ()=>(0, _publicClientApplicationMjs.PublicClientApplication));
parcelHelpers.export(exports, "createNestablePublicClientApplication", ()=>(0, _publicClientApplicationMjs.createNestablePublicClientApplication));
parcelHelpers.export(exports, "createStandardPublicClientApplication", ()=>(0, _publicClientApplicationMjs.createStandardPublicClientApplication));
parcelHelpers.export(exports, "DEFAULT_IFRAME_TIMEOUT_MS", ()=>(0, _configurationMjs.DEFAULT_IFRAME_TIMEOUT_MS));
parcelHelpers.export(exports, "ApiId", ()=>(0, _browserConstantsMjs.ApiId));
parcelHelpers.export(exports, "BrowserCacheLocation", ()=>(0, _browserConstantsMjs.BrowserCacheLocation));
parcelHelpers.export(exports, "CacheLookupPolicy", ()=>(0, _browserConstantsMjs.CacheLookupPolicy));
parcelHelpers.export(exports, "InteractionStatus", ()=>(0, _browserConstantsMjs.InteractionStatus));
parcelHelpers.export(exports, "InteractionType", ()=>(0, _browserConstantsMjs.InteractionType));
parcelHelpers.export(exports, "WrapperSKU", ()=>(0, _browserConstantsMjs.WrapperSKU));
parcelHelpers.export(exports, "BrowserAuthError", ()=>(0, _browserAuthErrorMjs.BrowserAuthError));
parcelHelpers.export(exports, "BrowserConfigurationAuthError", ()=>(0, _browserConfigurationAuthErrorMjs.BrowserConfigurationAuthError));
parcelHelpers.export(exports, "stubbedPublicClientApplication", ()=>(0, _ipublicClientApplicationMjs.stubbedPublicClientApplication));
parcelHelpers.export(exports, "NavigationClient", ()=>(0, _navigationClientMjs.NavigationClient));
parcelHelpers.export(exports, "loadExternalTokens", ()=>(0, _tokenCacheMjs.loadExternalTokens));
parcelHelpers.export(exports, "MemoryStorage", ()=>(0, _memoryStorageMjs.MemoryStorage));
parcelHelpers.export(exports, "LocalStorage", ()=>(0, _localStorageMjs.LocalStorage));
parcelHelpers.export(exports, "SessionStorage", ()=>(0, _sessionStorageMjs.SessionStorage));
parcelHelpers.export(exports, "EventMessageUtils", ()=>(0, _eventMessageMjs.EventMessageUtils));
parcelHelpers.export(exports, "EventType", ()=>(0, _eventTypeMjs.EventType));
parcelHelpers.export(exports, "EventHandler", ()=>(0, _eventHandlerMjs.EventHandler));
parcelHelpers.export(exports, "SignedHttpRequest", ()=>(0, _signedHttpRequestMjs.SignedHttpRequest));
parcelHelpers.export(exports, "BrowserPerformanceClient", ()=>(0, _browserPerformanceClientMjs.BrowserPerformanceClient));
parcelHelpers.export(exports, "BrowserPerformanceMeasurement", ()=>(0, _browserPerformanceMeasurementMjs.BrowserPerformanceMeasurement));
parcelHelpers.export(exports, "version", ()=>(0, _packageMetadataMjs.version));
parcelHelpers.export(exports, "isPlatformBrokerAvailable", ()=>(0, _platformAuthProviderMjs.isPlatformBrokerAvailable));
parcelHelpers.export(exports, "BrowserUtils", ()=>_browserUtilsMjs);
parcelHelpers.export(exports, "BrowserRootPerformanceEvents", ()=>_browserRootPerformanceEventsMjs);
parcelHelpers.export(exports, "BrowserAuthErrorCodes", ()=>_browserAuthErrorCodesMjs);
parcelHelpers.export(exports, "BrowserConfigurationAuthErrorCodes", ()=>_browserConfigurationAuthErrorCodesMjs);
parcelHelpers.export(exports, "AuthenticationScheme", ()=>AuthenticationScheme);
parcelHelpers.export(exports, "JsonWebTokenTypes", ()=>JsonWebTokenTypes);
parcelHelpers.export(exports, "OIDC_DEFAULT_SCOPES", ()=>OIDC_DEFAULT_SCOPES);
parcelHelpers.export(exports, "PromptValue", ()=>PromptValue);
parcelHelpers.export(exports, "ResponseMode", ()=>ResponseMode);
var _browserUtilsMjs = require("./utils/BrowserUtils.mjs");
var _browser = require("@azure/msal-common/browser");
var _publicClientApplicationMjs = require("./app/PublicClientApplication.mjs");
var _configurationMjs = require("./config/Configuration.mjs");
var _browserConstantsMjs = require("./utils/BrowserConstants.mjs");
var _browserAuthErrorMjs = require("./error/BrowserAuthError.mjs");
var _browserConfigurationAuthErrorMjs = require("./error/BrowserConfigurationAuthError.mjs");
var _ipublicClientApplicationMjs = require("./app/IPublicClientApplication.mjs");
var _navigationClientMjs = require("./navigation/NavigationClient.mjs");
var _tokenCacheMjs = require("./cache/TokenCache.mjs");
var _memoryStorageMjs = require("./cache/MemoryStorage.mjs");
var _localStorageMjs = require("./cache/LocalStorage.mjs");
var _sessionStorageMjs = require("./cache/SessionStorage.mjs");
var _eventMessageMjs = require("./event/EventMessage.mjs");
var _eventTypeMjs = require("./event/EventType.mjs");
var _eventHandlerMjs = require("./event/EventHandler.mjs");
var _signedHttpRequestMjs = require("./crypto/SignedHttpRequest.mjs");
var _browserPerformanceClientMjs = require("./telemetry/BrowserPerformanceClient.mjs");
var _browserPerformanceMeasurementMjs = require("./telemetry/BrowserPerformanceMeasurement.mjs");
var _browserRootPerformanceEventsMjs = require("./telemetry/BrowserRootPerformanceEvents.mjs");
var _packageMetadataMjs = require("./packageMetadata.mjs");
var _platformAuthProviderMjs = require("./broker/nativeBroker/PlatformAuthProvider.mjs");
var _browserAuthErrorCodesMjs = require("./error/BrowserAuthErrorCodes.mjs");
var _browserConfigurationAuthErrorCodesMjs = require("./error/BrowserConfigurationAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @packageDocumentation
 * @module @azure/msal-browser
 */ // Common constants
const AuthenticationScheme = (0, _browser.Constants).AuthenticationScheme;
const ResponseMode = (0, _browser.Constants).ResponseMode;
const PromptValue = (0, _browser.Constants).PromptValue;
const JsonWebTokenTypes = (0, _browser.Constants).JsonWebTokenTypes;
const OIDC_DEFAULT_SCOPES = (0, _browser.Constants).OIDC_DEFAULT_SCOPES;

},{"./utils/BrowserUtils.mjs":"eyRWO","@azure/msal-common/browser":[["AuthenticationHeaderParser","al9yc"],["AuthError","8TWYe"],["AuthErrorCodes","hf916","*"],["AzureCloudInstance","9DjNg"],["ClientAuthError","e8Ku4"],["ClientAuthErrorCodes","8keAa","*"],["ClientConfigurationError","ebyn4"],["ClientConfigurationErrorCodes","iMtlX","*"],["Constants","5eRZy","*"],["enforceResourceParameter","aeuO6"],["InteractionRequiredAuthError","jiVlC"],["InteractionRequiredAuthErrorCodes","9FSE5","*"],["Logger","9bvcp"],["LogLevel","9bvcp"],["ProtocolMode","8zD57"],["ServerError","dvxy4"],["StubPerformanceClient","9VScD"]],"./app/PublicClientApplication.mjs":"ahOhN","./config/Configuration.mjs":"iuw8A","./utils/BrowserConstants.mjs":"5kHn0","./error/BrowserAuthError.mjs":"k9YIy","./error/BrowserConfigurationAuthError.mjs":"401zU","./app/IPublicClientApplication.mjs":"immww","./navigation/NavigationClient.mjs":"67Dgq","./cache/TokenCache.mjs":"2kbCw","./cache/MemoryStorage.mjs":"a1m3z","./cache/LocalStorage.mjs":"diYxJ","./cache/SessionStorage.mjs":"j6Bc1","./event/EventMessage.mjs":"efjbW","./event/EventType.mjs":"gVLUh","./event/EventHandler.mjs":"5hEJZ","./crypto/SignedHttpRequest.mjs":"e5ix7","./telemetry/BrowserPerformanceClient.mjs":"bZJ5C","./telemetry/BrowserPerformanceMeasurement.mjs":"9orQb","./telemetry/BrowserRootPerformanceEvents.mjs":"cD5vH","./packageMetadata.mjs":"7kVpA","./broker/nativeBroker/PlatformAuthProvider.mjs":"80VhX","./error/BrowserAuthErrorCodes.mjs":"c0BSJ","./error/BrowserConfigurationAuthErrorCodes.mjs":"f0n3B","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eyRWO":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invoke", ()=>(0, _browser.invoke));
parcelHelpers.export(exports, "invokeAsync", ()=>(0, _browser.invokeAsync));
parcelHelpers.export(exports, "blockAPICallsBeforeInitialize", ()=>blockAPICallsBeforeInitialize);
parcelHelpers.export(exports, "blockAcquireTokenInPopups", ()=>blockAcquireTokenInPopups);
parcelHelpers.export(exports, "blockNonBrowserEnvironment", ()=>blockNonBrowserEnvironment);
parcelHelpers.export(exports, "blockRedirectInIframe", ()=>blockRedirectInIframe);
parcelHelpers.export(exports, "blockReloadInHiddenIframes", ()=>blockReloadInHiddenIframes);
parcelHelpers.export(exports, "buildMergedClaims", ()=>buildMergedClaims);
parcelHelpers.export(exports, "cancelPendingBridgeResponse", ()=>cancelPendingBridgeResponse);
parcelHelpers.export(exports, "clearAuthResponseFromUrl", ()=>clearAuthResponseFromUrl);
parcelHelpers.export(exports, "clearHash", ()=>clearHash);
parcelHelpers.export(exports, "createGuid", ()=>createGuid);
parcelHelpers.export(exports, "getCurrentUri", ()=>getCurrentUri);
parcelHelpers.export(exports, "getHomepage", ()=>getHomepage);
parcelHelpers.export(exports, "isInIframe", ()=>isInIframe);
parcelHelpers.export(exports, "isInPopup", ()=>isInPopup);
parcelHelpers.export(exports, "parseAuthResponseFromUrl", ()=>parseAuthResponseFromUrl);
parcelHelpers.export(exports, "preconnect", ()=>preconnect);
parcelHelpers.export(exports, "preflightCheck", ()=>preflightCheck);
parcelHelpers.export(exports, "redirectPreflightCheck", ()=>redirectPreflightCheck);
parcelHelpers.export(exports, "replaceHash", ()=>replaceHash);
parcelHelpers.export(exports, "waitForBridgeResponse", ()=>waitForBridgeResponse);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _browserConstantsMjs = require("./BrowserConstants.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _browserConfigurationAuthErrorMjs = require("../error/BrowserConfigurationAuthError.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
var _browserConfigurationAuthErrorCodesMjs = require("../error/BrowserConfigurationAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts and parses the authentication response from URL (hash and/or query string).
 * This is a shared utility used across multiple components in msal-browser.
 *
 * @returns {Object} An object containing the parsed state information and URL parameters.
 * @returns {URLSearchParams} params - The parsed URL parameters from the payload.
 * @returns {string} payload - The combined query string and hash content.
 * @returns {string} urlHash - The original URL hash.
 * @returns {string} urlQuery - The original URL query string.
 * @returns {LibraryStateObject} libraryState - The decoded library state from the state parameter.
 *
 * @throws {AuthError} If no authentication payload is found in the URL.
 * @throws {AuthError} If the state parameter is missing.
 * @throws {AuthError} If the state is missing required 'id' or 'meta' attributes.
 */ function parseAuthResponseFromUrl() {
    // Extract both hash and query string to support hybrid response format
    const urlHash = window.location.hash;
    const urlQuery = window.location.search;
    // Determine which part contains the auth response by checking for 'state' parameter
    let hasResponseInHash = false;
    let hasResponseInQuery = false;
    let payload = "";
    let params = undefined;
    if (urlHash && urlHash.length > 1) {
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        const hashParams = new URLSearchParams(hashContent);
        if (hashParams.has("state")) {
            hasResponseInHash = true;
            payload = hashContent;
            params = hashParams;
        }
    }
    if (urlQuery && urlQuery.length > 1) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const queryParams = new URLSearchParams(queryContent);
        if (queryParams.has("state")) {
            hasResponseInQuery = true;
            payload = queryContent;
            params = queryParams;
        }
    }
    // If response is in both, combine them (hybrid format)
    if (hasResponseInHash && hasResponseInQuery) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        payload = `${queryContent}${hashContent}`;
        params = new URLSearchParams(payload);
    }
    /*
     * Called by the redirect-bridge entry point before any request context exists,
     * so correlationId is intentionally empty for the throws below.
     */ if (!payload || !params) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.emptyResponse), "");
    const state = params.get("state");
    if (!state) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.noStateInHash), "");
    const { libraryState } = (0, _browser.ProtocolUtils).parseRequestState((0, _base64DecodeMjs.base64Decode), state, "");
    const { id, meta } = libraryState;
    if (!id || !meta) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.unableToParseState), "", "missing_library_state");
    return {
        params,
        payload,
        urlHash,
        urlQuery,
        hasResponseInHash,
        hasResponseInQuery,
        libraryState: {
            id,
            meta
        }
    };
}
/**
 * Clears hash from window url.
 */ function clearHash(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Strips both hash and query string from the given window's URL by replacing
 * with origin + pathname only. Used to remove auth response parameters
 * (auth code, state, etc.) before the window is closed or navigated away.
 */ function clearAuthResponseFromUrl(contentWindow) {
    if (typeof contentWindow.history?.replaceState === "function") contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function replaceHash(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function isInIframe() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function isInPopup() {
    if (isInIframe()) return false;
    try {
        const { libraryState } = parseAuthResponseFromUrl();
        const { meta } = libraryState;
        return meta["interactionType"] === (0, _browserConstantsMjs.InteractionType).Popup;
    } catch (e) {
        // If parsing fails (no state, invalid URL, etc.), we're not in a popup
        return false;
    }
}
/**
 * Await a response from a redirect bridge using BroadcastChannel.
 * This unified function works for both popup and iframe scenarios by listening on a
 * BroadcastChannel for the server payload.
 *
 * @param timeoutMs - Timeout in milliseconds.
 * @param logger - Logger instance for logging monitoring events.
 * @param browserCrypto - Browser crypto instance for decoding state.
 * @param request - The authorization or end session request.
 * @returns Promise<string> - Resolves with the response string (query or hash) from the window.
 */ // Track the active bridge monitor to allow cancellation when overriding interactions
let activeBridgeMonitor = null;
/**
 * Cancels the pending bridge response monitor if one exists.
 * This is called when overrideInteractionInProgress is used to cancel
 * any pending popup interaction before starting a new one.
 */ function cancelPendingBridgeResponse(logger, correlationId) {
    if (activeBridgeMonitor) {
        logger.verbose("18y01k", correlationId);
        clearTimeout(activeBridgeMonitor.timeoutId);
        activeBridgeMonitor.channel.close();
        activeBridgeMonitor.reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.interactionInProgressCancelled), ""));
        activeBridgeMonitor = null;
    }
}
/** @internal */ async function waitForBridgeResponse(timeoutMs, logger, request, performanceClient, experimentalConfig) {
    return new Promise((resolve, reject)=>{
        logger.verbose("1rf6em", request.correlationId);
        const correlationId = request.correlationId;
        performanceClient.addFields({
            redirectBridgeTimeoutMs: timeoutMs,
            lateResponseExperimentEnabled: experimentalConfig?.iframeTimeoutTelemetry || false
        }, correlationId);
        const { libraryState } = (0, _browser.ProtocolUtils).parseRequestState((0, _base64DecodeMjs.base64Decode), request.state || "", request.correlationId);
        const channel = new BroadcastChannel(libraryState.id);
        let responseString = undefined;
        let timedOut$1 = false;
        let lateTimeoutId;
        let lateMeasurement;
        const timeoutId = window.setTimeout(()=>{
            // Clear the active monitor
            activeBridgeMonitor = null;
            if (experimentalConfig?.iframeTimeoutTelemetry) {
                lateMeasurement = performanceClient.startMeasurement((0, _browserPerformanceEventsMjs.WaitForBridgeLateResponse), correlationId);
                timedOut$1 = true;
                lateTimeoutId = window.setTimeout(()=>{
                    lateMeasurement?.end({
                        success: false
                    });
                    clearTimeout(lateTimeoutId);
                    channel.close();
                }, 60000); // 60s late response timeout to allow for telemetry of late responses
            } else channel.close();
            reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.timedOut), "", "redirect_bridge_timeout"));
        }, timeoutMs);
        // Track this monitor so it can be cancelled if needed
        activeBridgeMonitor = {
            timeoutId,
            channel,
            reject
        };
        channel.onmessage = (event)=>{
            responseString = event.data.payload;
            const messageVersion = event?.data && typeof event.data.v === "number" ? event.data.v : undefined;
            if (timedOut$1) {
                lateMeasurement?.end({
                    success: responseString ? true : false
                });
                clearTimeout(lateTimeoutId);
                channel.close();
                return;
            }
            performanceClient.addFields({
                redirectBridgeMessageVersion: messageVersion
            }, correlationId);
            // Clear the active monitor
            activeBridgeMonitor = null;
            clearTimeout(timeoutId);
            channel.close();
            if (responseString) resolve(responseString);
            else reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.redirectBridgeEmptyResponse), correlationId));
        };
    });
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function getCurrentUri() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function getHomepage(correlationId) {
    const currentUrl = new (0, _browser.UrlString)(window.location.href, correlationId || "");
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function blockReloadInHiddenIframes() {
    const isResponseHash = (0, _browser.UrlUtils).getDeserializedResponse(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && isInIframe()) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.blockIframeReload), "");
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function blockRedirectInIframe(allowRedirectInIframe) {
    if (isInIframe() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.redirectInIframe), "");
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function blockAcquireTokenInPopups() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if (isInPopup()) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.blockNestedPopups), "");
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function blockNonBrowserEnvironment() {
    if (typeof window === "undefined") throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.nonBrowserEnvironment), "");
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function blockAPICallsBeforeInitialize(initialized) {
    if (!initialized) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.uninitializedPublicClientApplication), "");
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function preflightCheck(initialized) {
    // Block request if not in browser environment
    blockNonBrowserEnvironment();
    // Block auth requests inside a hidden iframe
    blockReloadInHiddenIframes();
    // Block redirectUri opened in a popup from calling MSAL APIs
    blockAcquireTokenInPopups();
    // Block token acquisition before initialize has been called
    blockAPICallsBeforeInitialize(initialized);
}
/**
 * Helper to validate app environment before making redirect request
 * @param initialized
 * @param config
 * @internal
 */ function redirectPreflightCheck(initialized, config) {
    preflightCheck(initialized);
    blockRedirectInIframe(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled
    if (config.cache.cacheLocation === (0, _browserConstantsMjs.BrowserCacheLocation).MemoryStorage) throw (0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.inMemRedirectUnavailable), "");
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function preconnect(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function createGuid() {
    return (0, _browserCryptoMjs.createNewGuid)();
}
const buildMergedClaims = (0, _browser.RequestParameterBuilder).buildMergedClaims;

},{"@azure/msal-common/browser":[["invoke","4kFBF"],["invokeAsync","4kFBF"],["ProtocolUtils","ipQ3L","*"],["RequestParameterBuilder","lAS2Y","*"],["UrlString","9Z8Lm"],["UrlUtils","2SeAw","*"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../error/BrowserAuthError.mjs":"k9YIy","../encode/Base64Decode.mjs":"evkpn","./BrowserConstants.mjs":"5kHn0","../crypto/BrowserCrypto.mjs":"a5L0H","../error/BrowserConfigurationAuthError.mjs":"401zU","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","../error/BrowserConfigurationAuthErrorCodes.mjs":"f0n3B","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4kFBF":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invoke", ()=>invoke);
parcelHelpers.export(exports, "invokeAsync", ()=>invokeAsync);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const invoke = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`1plfzx ${eventName}`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        try {
            const result = callback(...args);
            inProgressEvent.end({
                success: true
            });
            logger.trace(`1g8n6a ${eventName}`, correlationId);
            return result;
        } catch (e) {
            logger.trace(`0cfd8i ${eventName}`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("00dty7", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const invokeAsync = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`1plfzx ${eventName}`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`1g8n6a ${eventName}`, correlationId);
            inProgressEvent.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`0cfd8i ${eventName}`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("00dty7", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        });
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ipQ3L":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateLibraryState", ()=>generateLibraryState);
parcelHelpers.export(exports, "parseRequestState", ()=>parseRequestState);
parcelHelpers.export(exports, "setRequestState", ()=>setRequestState);
var _constantsMjs = require("./Constants.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Appends user state with random guid, or returns random guid.
 * @param cryptoObj
 * @param userState
 * @param meta
 * @param correlationId
 */ function setRequestState(cryptoObj, userState, meta, correlationId) {
    const libraryState = generateLibraryState(cryptoObj, correlationId, meta);
    return userState ? `${libraryState}${0, _constantsMjs.RESOURCE_DELIM}${userState}` : libraryState;
}
/**
 * Generates the state value used by the common library.
 * @param cryptoObj
 * @param correlationId
 * @param meta
 */ function generateLibraryState(cryptoObj, correlationId, meta) {
    if (!cryptoObj) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.noCryptoObject), correlationId);
    // Create a state object containing a unique id and the timestamp of the request creation
    const stateObj = {
        id: cryptoObj.createNewGuid()
    };
    if (meta) stateObj.meta = meta;
    const stateString = JSON.stringify(stateObj);
    return cryptoObj.base64Encode(stateString);
}
/**
 * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
 * @param base64Decode
 * @param state
 * @param correlationId
 */ function parseRequestState(base64Decode, state, correlationId) {
    if (!base64Decode) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.noCryptoObject), correlationId);
    if (!state) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.invalidState), correlationId);
    try {
        // Split the state between library state and user passed state and decode them separately
        const splitState = state.split((0, _constantsMjs.RESOURCE_DELIM));
        const libraryState = splitState[0];
        const userState = splitState.length > 1 ? splitState.slice(1).join((0, _constantsMjs.RESOURCE_DELIM)) : "";
        const libraryStateString = base64Decode(libraryState);
        const libraryStateObj = JSON.parse(libraryStateString);
        return {
            userRequestState: userState || "",
            libraryState: libraryStateObj
        };
    } catch (e) {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.invalidState), correlationId);
    }
}

},{"./Constants.mjs":"5eRZy","../error/ClientAuthError.mjs":"e8Ku4","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5eRZy":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AADAuthority", ()=>AADAuthority);
parcelHelpers.export(exports, "AAD_INSTANCE_DISCOVERY_ENDPT", ()=>AAD_INSTANCE_DISCOVERY_ENDPT);
parcelHelpers.export(exports, "AAD_TENANT_DOMAIN_SUFFIX", ()=>AAD_TENANT_DOMAIN_SUFFIX);
parcelHelpers.export(exports, "ADFS", ()=>ADFS);
parcelHelpers.export(exports, "APP_METADATA", ()=>APP_METADATA);
parcelHelpers.export(exports, "AUTHORITY_METADATA_CACHE_KEY", ()=>AUTHORITY_METADATA_CACHE_KEY);
parcelHelpers.export(exports, "AUTHORITY_METADATA_REFRESH_TIME_SECONDS", ()=>AUTHORITY_METADATA_REFRESH_TIME_SECONDS);
parcelHelpers.export(exports, "AUTHORIZATION_PENDING", ()=>AUTHORIZATION_PENDING);
parcelHelpers.export(exports, "AZURE_REGION_AUTO_DISCOVER_FLAG", ()=>AZURE_REGION_AUTO_DISCOVER_FLAG);
parcelHelpers.export(exports, "AuthenticationScheme", ()=>AuthenticationScheme);
parcelHelpers.export(exports, "AuthorityMetadataSource", ()=>AuthorityMetadataSource);
parcelHelpers.export(exports, "CACHE_ACCOUNT_TYPE_ADFS", ()=>CACHE_ACCOUNT_TYPE_ADFS);
parcelHelpers.export(exports, "CACHE_ACCOUNT_TYPE_GENERIC", ()=>CACHE_ACCOUNT_TYPE_GENERIC);
parcelHelpers.export(exports, "CACHE_ACCOUNT_TYPE_MSAV1", ()=>CACHE_ACCOUNT_TYPE_MSAV1);
parcelHelpers.export(exports, "CACHE_ACCOUNT_TYPE_MSSTS", ()=>CACHE_ACCOUNT_TYPE_MSSTS);
parcelHelpers.export(exports, "CACHE_KEY_SEPARATOR", ()=>CACHE_KEY_SEPARATOR);
parcelHelpers.export(exports, "CIAM_AUTH_URL", ()=>CIAM_AUTH_URL);
parcelHelpers.export(exports, "CLIENT_INFO", ()=>CLIENT_INFO);
parcelHelpers.export(exports, "CLIENT_INFO_SEPARATOR", ()=>CLIENT_INFO_SEPARATOR);
parcelHelpers.export(exports, "CLIENT_MISMATCH_ERROR", ()=>CLIENT_MISMATCH_ERROR);
parcelHelpers.export(exports, "CODE_GRANT_TYPE", ()=>CODE_GRANT_TYPE);
parcelHelpers.export(exports, "CONSUMER_UTID", ()=>CONSUMER_UTID);
parcelHelpers.export(exports, "CacheOutcome", ()=>CacheOutcome);
parcelHelpers.export(exports, "CacheType", ()=>CacheType);
parcelHelpers.export(exports, "ClaimsRequestKeys", ()=>ClaimsRequestKeys);
parcelHelpers.export(exports, "CodeChallengeMethodValues", ()=>CodeChallengeMethodValues);
parcelHelpers.export(exports, "CredentialType", ()=>CredentialType);
parcelHelpers.export(exports, "DEFAULT_AUTHORITY", ()=>DEFAULT_AUTHORITY);
parcelHelpers.export(exports, "DEFAULT_AUTHORITY_HOST", ()=>DEFAULT_AUTHORITY_HOST);
parcelHelpers.export(exports, "DEFAULT_COMMON_TENANT", ()=>DEFAULT_COMMON_TENANT);
parcelHelpers.export(exports, "DEFAULT_MAX_THROTTLE_TIME_SECONDS", ()=>DEFAULT_MAX_THROTTLE_TIME_SECONDS);
parcelHelpers.export(exports, "DEFAULT_THROTTLE_TIME_SECONDS", ()=>DEFAULT_THROTTLE_TIME_SECONDS);
parcelHelpers.export(exports, "DEFAULT_TOKEN_RENEWAL_OFFSET_SEC", ()=>DEFAULT_TOKEN_RENEWAL_OFFSET_SEC);
parcelHelpers.export(exports, "DSTS", ()=>DSTS);
parcelHelpers.export(exports, "EMAIL_SCOPE", ()=>EMAIL_SCOPE);
parcelHelpers.export(exports, "EncodingTypes", ()=>EncodingTypes);
parcelHelpers.export(exports, "FORWARD_SLASH", ()=>FORWARD_SLASH);
parcelHelpers.export(exports, "GrantType", ()=>GrantType);
parcelHelpers.export(exports, "HTTP_BAD_REQUEST", ()=>HTTP_BAD_REQUEST);
parcelHelpers.export(exports, "HTTP_CLIENT_ERROR", ()=>HTTP_CLIENT_ERROR);
parcelHelpers.export(exports, "HTTP_CLIENT_ERROR_RANGE_END", ()=>HTTP_CLIENT_ERROR_RANGE_END);
parcelHelpers.export(exports, "HTTP_CLIENT_ERROR_RANGE_START", ()=>HTTP_CLIENT_ERROR_RANGE_START);
parcelHelpers.export(exports, "HTTP_GATEWAY_TIMEOUT", ()=>HTTP_GATEWAY_TIMEOUT);
parcelHelpers.export(exports, "HTTP_GONE", ()=>HTTP_GONE);
parcelHelpers.export(exports, "HTTP_MULTI_SIDED_ERROR", ()=>HTTP_MULTI_SIDED_ERROR);
parcelHelpers.export(exports, "HTTP_NOT_FOUND", ()=>HTTP_NOT_FOUND);
parcelHelpers.export(exports, "HTTP_REDIRECT", ()=>HTTP_REDIRECT);
parcelHelpers.export(exports, "HTTP_REQUEST_TIMEOUT", ()=>HTTP_REQUEST_TIMEOUT);
parcelHelpers.export(exports, "HTTP_SERVER_ERROR", ()=>HTTP_SERVER_ERROR);
parcelHelpers.export(exports, "HTTP_SERVER_ERROR_RANGE_END", ()=>HTTP_SERVER_ERROR_RANGE_END);
parcelHelpers.export(exports, "HTTP_SERVER_ERROR_RANGE_START", ()=>HTTP_SERVER_ERROR_RANGE_START);
parcelHelpers.export(exports, "HTTP_SERVICE_UNAVAILABLE", ()=>HTTP_SERVICE_UNAVAILABLE);
parcelHelpers.export(exports, "HTTP_SUCCESS", ()=>HTTP_SUCCESS);
parcelHelpers.export(exports, "HTTP_SUCCESS_RANGE_END", ()=>HTTP_SUCCESS_RANGE_END);
parcelHelpers.export(exports, "HTTP_SUCCESS_RANGE_START", ()=>HTTP_SUCCESS_RANGE_START);
parcelHelpers.export(exports, "HTTP_TOO_MANY_REQUESTS", ()=>HTTP_TOO_MANY_REQUESTS);
parcelHelpers.export(exports, "HTTP_UNAUTHORIZED", ()=>HTTP_UNAUTHORIZED);
parcelHelpers.export(exports, "HeaderNames", ()=>HeaderNames);
parcelHelpers.export(exports, "HttpMethod", ()=>HttpMethod);
parcelHelpers.export(exports, "IMDS_ENDPOINT", ()=>IMDS_ENDPOINT);
parcelHelpers.export(exports, "IMDS_TIMEOUT", ()=>IMDS_TIMEOUT);
parcelHelpers.export(exports, "IMDS_VERSION", ()=>IMDS_VERSION);
parcelHelpers.export(exports, "INVALID_GRANT_ERROR", ()=>INVALID_GRANT_ERROR);
parcelHelpers.export(exports, "INVALID_INSTANCE", ()=>INVALID_INSTANCE);
parcelHelpers.export(exports, "JsonWebTokenTypes", ()=>JsonWebTokenTypes);
parcelHelpers.export(exports, "KNOWN_PUBLIC_CLOUDS", ()=>KNOWN_PUBLIC_CLOUDS);
parcelHelpers.export(exports, "NOT_APPLICABLE", ()=>NOT_APPLICABLE);
parcelHelpers.export(exports, "NOT_AVAILABLE", ()=>NOT_AVAILABLE);
parcelHelpers.export(exports, "OAuthResponseType", ()=>OAuthResponseType);
parcelHelpers.export(exports, "OFFLINE_ACCESS_SCOPE", ()=>OFFLINE_ACCESS_SCOPE);
parcelHelpers.export(exports, "OIDC_DEFAULT_SCOPES", ()=>OIDC_DEFAULT_SCOPES);
parcelHelpers.export(exports, "OIDC_SCOPES", ()=>OIDC_SCOPES);
parcelHelpers.export(exports, "ONE_DAY_IN_MS", ()=>ONE_DAY_IN_MS);
parcelHelpers.export(exports, "OPENID_SCOPE", ()=>OPENID_SCOPE);
parcelHelpers.export(exports, "PROFILE_SCOPE", ()=>PROFILE_SCOPE);
parcelHelpers.export(exports, "PasswordGrantConstants", ()=>PasswordGrantConstants);
parcelHelpers.export(exports, "PersistentCacheKeys", ()=>PersistentCacheKeys);
parcelHelpers.export(exports, "PromptValue", ()=>PromptValue);
parcelHelpers.export(exports, "REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX", ()=>REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX);
parcelHelpers.export(exports, "RESOURCE_DELIM", ()=>RESOURCE_DELIM);
parcelHelpers.export(exports, "RegionDiscoveryOutcomes", ()=>RegionDiscoveryOutcomes);
parcelHelpers.export(exports, "RegionDiscoverySources", ()=>RegionDiscoverySources);
parcelHelpers.export(exports, "ResponseMode", ()=>ResponseMode);
parcelHelpers.export(exports, "S256_CODE_CHALLENGE_METHOD", ()=>S256_CODE_CHALLENGE_METHOD);
parcelHelpers.export(exports, "SERVER_TELEM_CACHE_KEY", ()=>SERVER_TELEM_CACHE_KEY);
parcelHelpers.export(exports, "SERVER_TELEM_CATEGORY_SEPARATOR", ()=>SERVER_TELEM_CATEGORY_SEPARATOR);
parcelHelpers.export(exports, "SERVER_TELEM_MAX_CACHED_ERRORS", ()=>SERVER_TELEM_MAX_CACHED_ERRORS);
parcelHelpers.export(exports, "SERVER_TELEM_MAX_CUR_HEADER_BYTES", ()=>SERVER_TELEM_MAX_CUR_HEADER_BYTES);
parcelHelpers.export(exports, "SERVER_TELEM_MAX_LAST_HEADER_BYTES", ()=>SERVER_TELEM_MAX_LAST_HEADER_BYTES);
parcelHelpers.export(exports, "SERVER_TELEM_OVERFLOW_FALSE", ()=>SERVER_TELEM_OVERFLOW_FALSE);
parcelHelpers.export(exports, "SERVER_TELEM_OVERFLOW_TRUE", ()=>SERVER_TELEM_OVERFLOW_TRUE);
parcelHelpers.export(exports, "SERVER_TELEM_SCHEMA_VERSION", ()=>SERVER_TELEM_SCHEMA_VERSION);
parcelHelpers.export(exports, "SERVER_TELEM_UNKNOWN_ERROR", ()=>SERVER_TELEM_UNKNOWN_ERROR);
parcelHelpers.export(exports, "SERVER_TELEM_VALUE_SEPARATOR", ()=>SERVER_TELEM_VALUE_SEPARATOR);
parcelHelpers.export(exports, "SHR_NONCE_VALIDITY", ()=>SHR_NONCE_VALIDITY);
parcelHelpers.export(exports, "SKU", ()=>SKU);
parcelHelpers.export(exports, "THE_FAMILY_ID", ()=>THE_FAMILY_ID);
parcelHelpers.export(exports, "THROTTLING_PREFIX", ()=>THROTTLING_PREFIX);
parcelHelpers.export(exports, "URL_FORM_CONTENT_TYPE", ()=>URL_FORM_CONTENT_TYPE);
parcelHelpers.export(exports, "X_MS_LIB_CAPABILITY_VALUE", ()=>X_MS_LIB_CAPABILITY_VALUE);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const SKU = "msal.js.common";
// default authority
const DEFAULT_AUTHORITY = "https://login.microsoftonline.com/common/";
const DEFAULT_AUTHORITY_HOST = "login.microsoftonline.com";
const DEFAULT_COMMON_TENANT = "common";
// ADFS String
const ADFS = "adfs";
const DSTS = "dstsv2";
// Default AAD Instance Discovery Endpoint
const AAD_INSTANCE_DISCOVERY_ENDPT = `${DEFAULT_AUTHORITY}discovery/instance?api-version=1.1&authorization_endpoint=`;
// CIAM URL
const CIAM_AUTH_URL = ".ciamlogin.com";
const AAD_TENANT_DOMAIN_SUFFIX = ".onmicrosoft.com";
// Resource delimiter - used for certain cache entries
const RESOURCE_DELIM = "|";
// Consumer UTID
const CONSUMER_UTID = "9188040d-6c67-4c5b-b112-36a304b66dad";
// Default scopes
const OPENID_SCOPE = "openid";
const PROFILE_SCOPE = "profile";
const OFFLINE_ACCESS_SCOPE = "offline_access";
const EMAIL_SCOPE = "email";
const CODE_GRANT_TYPE = "authorization_code";
const S256_CODE_CHALLENGE_METHOD = "S256";
const URL_FORM_CONTENT_TYPE = "application/x-www-form-urlencoded;charset=utf-8";
const AUTHORIZATION_PENDING = "authorization_pending";
const NOT_APPLICABLE = "N/A";
const NOT_AVAILABLE = "Not Available";
const FORWARD_SLASH = "/";
const IMDS_ENDPOINT = "http://169.254.169.254/metadata/instance/compute";
const IMDS_VERSION = "2021-02-01";
const IMDS_TIMEOUT = 2000;
const AZURE_REGION_AUTO_DISCOVER_FLAG = "TryAutoDetect";
const REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX = "login.microsoft.com";
const KNOWN_PUBLIC_CLOUDS = [
    "login.microsoftonline.com",
    "login.windows.net",
    "login.microsoft.com",
    "sts.windows.net"
];
const SHR_NONCE_VALIDITY = 240;
const INVALID_INSTANCE = "invalid_instance";
const HTTP_SUCCESS = 200;
const HTTP_SUCCESS_RANGE_START = 200;
const HTTP_SUCCESS_RANGE_END = 299;
const HTTP_REDIRECT = 302;
const HTTP_CLIENT_ERROR = 400;
const HTTP_CLIENT_ERROR_RANGE_START = 400;
const HTTP_BAD_REQUEST = 400;
const HTTP_UNAUTHORIZED = 401;
const HTTP_NOT_FOUND = 404;
const HTTP_REQUEST_TIMEOUT = 408;
const HTTP_GONE = 410;
const HTTP_TOO_MANY_REQUESTS = 429;
const HTTP_CLIENT_ERROR_RANGE_END = 499;
const HTTP_SERVER_ERROR = 500;
const HTTP_SERVER_ERROR_RANGE_START = 500;
const HTTP_SERVICE_UNAVAILABLE = 503;
const HTTP_GATEWAY_TIMEOUT = 504;
const HTTP_SERVER_ERROR_RANGE_END = 599;
const HTTP_MULTI_SIDED_ERROR = 600;
const HttpMethod = {
    GET: "GET",
    POST: "POST"
};
const OIDC_DEFAULT_SCOPES = [
    OPENID_SCOPE,
    PROFILE_SCOPE,
    OFFLINE_ACCESS_SCOPE
];
const OIDC_SCOPES = [
    ...OIDC_DEFAULT_SCOPES,
    EMAIL_SCOPE
];
/**
 * Request header names
 */ const HeaderNames = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const PersistentCacheKeys = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const AADAuthority = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const ClaimsRequestKeys = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc",
    ID_TOKEN: "id_token",
    SIGNIN_STATE: "signin_state",
    LOGIN_HINT: "login_hint"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const PromptValue = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const CodeChallengeMethodValues = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * Allowed values for response_type
 */ const OAuthResponseType = {
    CODE: "code",
    IDTOKEN_TOKEN: "id_token token",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for response_mode
 */ const ResponseMode = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const GrantType = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer",
    USER_FIC: "user_fic"
};
/**
 * Account types in Cache
 */ const CACHE_ACCOUNT_TYPE_MSSTS = "MSSTS";
const CACHE_ACCOUNT_TYPE_ADFS = "ADFS";
const CACHE_ACCOUNT_TYPE_MSAV1 = "MSA";
const CACHE_ACCOUNT_TYPE_GENERIC = "Generic";
/**
 * Separators used in cache
 */ const CACHE_KEY_SEPARATOR = "-";
const CLIENT_INFO_SEPARATOR = ".";
/**
 * Credential Type stored in the cache
 */ const CredentialType = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const CacheType = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const APP_METADATA = "appmetadata";
const CLIENT_INFO = "client_info";
const THE_FAMILY_ID = "1";
const AUTHORITY_METADATA_CACHE_KEY = "authority-metadata";
const AUTHORITY_METADATA_REFRESH_TIME_SECONDS = 86400; // 24 Hours
const AuthorityMetadataSource = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const SERVER_TELEM_SCHEMA_VERSION = 5;
const SERVER_TELEM_MAX_CUR_HEADER_BYTES = 80; // ESTS limit is 100B, set to 80 to provide a 20B buffer
const SERVER_TELEM_MAX_LAST_HEADER_BYTES = 330; // ESTS limit is 350B, set to 330 to provide a 20B buffer,
const SERVER_TELEM_MAX_CACHED_ERRORS = 50; // Limit the number of errors that can be stored to prevent uncontrolled size gains
const SERVER_TELEM_CACHE_KEY = "server-telemetry";
const SERVER_TELEM_CATEGORY_SEPARATOR = "|";
const SERVER_TELEM_VALUE_SEPARATOR = ",";
const SERVER_TELEM_OVERFLOW_TRUE = "1";
const SERVER_TELEM_OVERFLOW_FALSE = "0";
const SERVER_TELEM_UNKNOWN_ERROR = "unknown_error";
/**
 * Type of the authentication request
 */ const AuthenticationScheme = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const DEFAULT_THROTTLE_TIME_SECONDS = 60;
// Default maximum time to throttle in seconds, overrides what the server sends back
const DEFAULT_MAX_THROTTLE_TIME_SECONDS = 3600;
// Prefix for storing throttling entries
const THROTTLING_PREFIX = "throttling";
// Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
const X_MS_LIB_CAPABILITY_VALUE = "retry-after, h429";
/**
 * Errors
 */ const INVALID_GRANT_ERROR = "invalid_grant";
const CLIENT_MISMATCH_ERROR = "client_mismatch";
/**
 * Password grant parameters
 */ const PasswordGrantConstants = {
    username: "username",
    password: "password"
};
/**
 * Region Discovery Sources
 */ const RegionDiscoverySources = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const RegionDiscoveryOutcomes = {
    CONFIGURED_MATCHES_DETECTED: "1",
    CONFIGURED_NO_AUTO_DETECTION: "2",
    CONFIGURED_NOT_DETECTED: "3",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const CacheOutcome = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const JsonWebTokenTypes = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const ONE_DAY_IN_MS = 86400000;
// Token renewal offset default in seconds
const DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
const EncodingTypes = {
    BASE64: "base64",
    HEX: "hex",
    UTF8: "utf-8"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e8Ku4":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientAuthError", ()=>ClientAuthError);
parcelHelpers.export(exports, "createClientAuthError", ()=>createClientAuthError);
var _authErrorMjs = require("./AuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class ClientAuthError extends (0, _authErrorMjs.AuthError) {
    constructor(errorCode, correlationId, additionalMessage){
        super(errorCode, correlationId, additionalMessage);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, ClientAuthError.prototype);
    }
}
function createClientAuthError(errorCode, correlationId, additionalMessage) {
    return new ClientAuthError(errorCode, correlationId, additionalMessage);
}

},{"./AuthError.mjs":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8TWYe":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", ()=>AuthError);
parcelHelpers.export(exports, "createAuthError", ()=>createAuthError);
parcelHelpers.export(exports, "getDefaultErrorMessage", ()=>getDefaultErrorMessage);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function getDefaultErrorMessage(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * General error class thrown by the MSAL.js library.
 */ class AuthError extends Error {
    constructor(errorCode, correlationId, errorMessage, suberror){
        const message = errorMessage || (errorCode ? getDefaultErrorMessage(errorCode) : "");
        const errorString = message ? `${errorCode}: ${message}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, AuthError.prototype);
        this.errorCode = errorCode || "";
        this.errorMessage = message || "";
        this.subError = suberror || "";
        this.correlationId = correlationId;
        this.name = "AuthError";
    }
}
function createAuthError(code, correlationId, additionalMessage) {
    return new AuthError(code, correlationId, additionalMessage || getDefaultErrorMessage(code));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8keAa":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authorizationCodeMissingFromServerResponse", ()=>authorizationCodeMissingFromServerResponse);
parcelHelpers.export(exports, "bindingKeyNotRemoved", ()=>bindingKeyNotRemoved);
parcelHelpers.export(exports, "cannotAppendScopeSet", ()=>cannotAppendScopeSet);
parcelHelpers.export(exports, "cannotRemoveEmptyScope", ()=>cannotRemoveEmptyScope);
parcelHelpers.export(exports, "clientInfoDecodingError", ()=>clientInfoDecodingError);
parcelHelpers.export(exports, "clientInfoEmptyError", ()=>clientInfoEmptyError);
parcelHelpers.export(exports, "emptyInputScopeSet", ()=>emptyInputScopeSet);
parcelHelpers.export(exports, "endSessionEndpointNotSupported", ()=>endSessionEndpointNotSupported);
parcelHelpers.export(exports, "endpointResolutionError", ()=>endpointResolutionError);
parcelHelpers.export(exports, "hashNotDeserialized", ()=>hashNotDeserialized);
parcelHelpers.export(exports, "invalidCacheEnvironment", ()=>invalidCacheEnvironment);
parcelHelpers.export(exports, "invalidCacheRecord", ()=>invalidCacheRecord);
parcelHelpers.export(exports, "invalidState", ()=>invalidState);
parcelHelpers.export(exports, "keyIdMissing", ()=>keyIdMissing);
parcelHelpers.export(exports, "methodNotImplemented", ()=>methodNotImplemented);
parcelHelpers.export(exports, "misplacedResourceParam", ()=>misplacedResourceParam);
parcelHelpers.export(exports, "multipleMatchingAppMetadata", ()=>multipleMatchingAppMetadata);
parcelHelpers.export(exports, "multipleMatchingTokens", ()=>multipleMatchingTokens);
parcelHelpers.export(exports, "nestedAppAuthBridgeDisabled", ()=>nestedAppAuthBridgeDisabled);
parcelHelpers.export(exports, "networkError", ()=>networkError);
parcelHelpers.export(exports, "noAccountFound", ()=>noAccountFound);
parcelHelpers.export(exports, "noAccountInSilentRequest", ()=>noAccountInSilentRequest);
parcelHelpers.export(exports, "noCryptoObject", ()=>noCryptoObject);
parcelHelpers.export(exports, "noNetworkConnectivity", ()=>noNetworkConnectivity);
parcelHelpers.export(exports, "nonceMismatch", ()=>nonceMismatch);
parcelHelpers.export(exports, "nullOrEmptyToken", ()=>nullOrEmptyToken);
parcelHelpers.export(exports, "openIdConfigError", ()=>openIdConfigError);
parcelHelpers.export(exports, "platformBrokerError", ()=>platformBrokerError);
parcelHelpers.export(exports, "requestCannotBeMade", ()=>requestCannotBeMade);
parcelHelpers.export(exports, "resourceParameterRequired", ()=>resourceParameterRequired);
parcelHelpers.export(exports, "stateMismatch", ()=>stateMismatch);
parcelHelpers.export(exports, "stateNotFound", ()=>stateNotFound);
parcelHelpers.export(exports, "tokenClaimsCnfRequiredForSignedJwt", ()=>tokenClaimsCnfRequiredForSignedJwt);
parcelHelpers.export(exports, "tokenParsingError", ()=>tokenParsingError);
parcelHelpers.export(exports, "tokenRefreshRequired", ()=>tokenRefreshRequired);
parcelHelpers.export(exports, "unexpectedCredentialType", ()=>unexpectedCredentialType);
parcelHelpers.export(exports, "userCanceled", ()=>userCanceled);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const clientInfoDecodingError = "client_info_decoding_error";
const clientInfoEmptyError = "client_info_empty_error";
const tokenParsingError = "token_parsing_error";
const nullOrEmptyToken = "null_or_empty_token";
const endpointResolutionError = "endpoints_resolution_error";
const networkError = "network_error";
const openIdConfigError = "openid_config_error";
const hashNotDeserialized = "hash_not_deserialized";
const invalidState = "invalid_state";
const stateMismatch = "state_mismatch";
const stateNotFound = "state_not_found";
const nonceMismatch = "nonce_mismatch";
const multipleMatchingTokens = "multiple_matching_tokens";
const multipleMatchingAppMetadata = "multiple_matching_appMetadata";
const requestCannotBeMade = "request_cannot_be_made";
const cannotRemoveEmptyScope = "cannot_remove_empty_scope";
const cannotAppendScopeSet = "cannot_append_scopeset";
const emptyInputScopeSet = "empty_input_scopeset";
const noAccountInSilentRequest = "no_account_in_silent_request";
const invalidCacheRecord = "invalid_cache_record";
const invalidCacheEnvironment = "invalid_cache_environment";
const noAccountFound = "no_account_found";
const noCryptoObject = "no_crypto_object";
const unexpectedCredentialType = "unexpected_credential_type";
const tokenRefreshRequired = "token_refresh_required";
const tokenClaimsCnfRequiredForSignedJwt = "token_claims_cnf_required_for_signedjwt";
const authorizationCodeMissingFromServerResponse = "authorization_code_missing_from_server_response";
const bindingKeyNotRemoved = "binding_key_not_removed";
const endSessionEndpointNotSupported = "end_session_endpoint_not_supported";
const keyIdMissing = "key_id_missing";
const noNetworkConnectivity = "no_network_connectivity";
const userCanceled = "user_canceled";
const methodNotImplemented = "method_not_implemented";
const nestedAppAuthBridgeDisabled = "nested_app_auth_bridge_disabled";
const platformBrokerError = "platform_broker_error";
const resourceParameterRequired = "resource_parameter_required";
const misplacedResourceParam = "misplaced_resource_parameter";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lAS2Y":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addApplicationTelemetry", ()=>addApplicationTelemetry);
parcelHelpers.export(exports, "addAuthorizationCode", ()=>addAuthorizationCode);
parcelHelpers.export(exports, "addBrokerParameters", ()=>addBrokerParameters);
parcelHelpers.export(exports, "addCcsOid", ()=>addCcsOid);
parcelHelpers.export(exports, "addCcsUpn", ()=>addCcsUpn);
parcelHelpers.export(exports, "addClaims", ()=>addClaims);
parcelHelpers.export(exports, "addCliData", ()=>addCliData);
parcelHelpers.export(exports, "addClientAssertion", ()=>addClientAssertion);
parcelHelpers.export(exports, "addClientAssertionType", ()=>addClientAssertionType);
parcelHelpers.export(exports, "addClientId", ()=>addClientId);
parcelHelpers.export(exports, "addClientInfo", ()=>addClientInfo);
parcelHelpers.export(exports, "addClientSecret", ()=>addClientSecret);
parcelHelpers.export(exports, "addCodeChallengeParams", ()=>addCodeChallengeParams);
parcelHelpers.export(exports, "addCodeVerifier", ()=>addCodeVerifier);
parcelHelpers.export(exports, "addCorrelationId", ()=>addCorrelationId);
parcelHelpers.export(exports, "addDeviceCode", ()=>addDeviceCode);
parcelHelpers.export(exports, "addDomainHint", ()=>addDomainHint);
parcelHelpers.export(exports, "addEARParameters", ()=>addEARParameters);
parcelHelpers.export(exports, "addExtraParameters", ()=>addExtraParameters);
parcelHelpers.export(exports, "addGrantType", ()=>addGrantType);
parcelHelpers.export(exports, "addIdTokenHint", ()=>addIdTokenHint);
parcelHelpers.export(exports, "addInstanceAware", ()=>addInstanceAware);
parcelHelpers.export(exports, "addLibraryInfo", ()=>addLibraryInfo);
parcelHelpers.export(exports, "addLoginHint", ()=>addLoginHint);
parcelHelpers.export(exports, "addLogoutHint", ()=>addLogoutHint);
parcelHelpers.export(exports, "addNativeBroker", ()=>addNativeBroker);
parcelHelpers.export(exports, "addNonce", ()=>addNonce);
parcelHelpers.export(exports, "addOboAssertion", ()=>addOboAssertion);
parcelHelpers.export(exports, "addPassword", ()=>addPassword);
parcelHelpers.export(exports, "addPopToken", ()=>addPopToken);
parcelHelpers.export(exports, "addPostLogoutRedirectUri", ()=>addPostLogoutRedirectUri);
parcelHelpers.export(exports, "addPrompt", ()=>addPrompt);
parcelHelpers.export(exports, "addRedirectUri", ()=>addRedirectUri);
parcelHelpers.export(exports, "addRefreshToken", ()=>addRefreshToken);
parcelHelpers.export(exports, "addRequestTokenUse", ()=>addRequestTokenUse);
parcelHelpers.export(exports, "addResource", ()=>addResource);
parcelHelpers.export(exports, "addResponseMode", ()=>addResponseMode);
parcelHelpers.export(exports, "addResponseType", ()=>addResponseType);
parcelHelpers.export(exports, "addScopes", ()=>addScopes);
parcelHelpers.export(exports, "addServerTelemetry", ()=>addServerTelemetry);
parcelHelpers.export(exports, "addSid", ()=>addSid);
parcelHelpers.export(exports, "addSshJwk", ()=>addSshJwk);
parcelHelpers.export(exports, "addState", ()=>addState);
parcelHelpers.export(exports, "addThrottling", ()=>addThrottling);
parcelHelpers.export(exports, "addUsername", ()=>addUsername);
parcelHelpers.export(exports, "buildMergedClaims", ()=>buildMergedClaims);
parcelHelpers.export(exports, "instrumentBrokerParams", ()=>instrumentBrokerParams);
var _constantsMjs = require("../utils/Constants.mjs");
var _aadserverParamKeysMjs = require("../constants/AADServerParamKeys.mjs");
var _scopeSetMjs = require("./ScopeSet.mjs");
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function instrumentBrokerParams(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, _aadserverParamKeysMjs.CLIENT_ID));
    if (clientId && parameters.has((0, _aadserverParamKeysMjs.BROKER_CLIENT_ID))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, _aadserverParamKeysMjs.REDIRECT_URI))
    }, correlationId);
}
/**
 * Add the given response_type
 * @param parameters
 * @param responseType
 */ function addResponseType(parameters, responseType) {
    parameters.set((0, _aadserverParamKeysMjs.RESPONSE_TYPE), responseType);
}
/**
 * add response_mode. defaults to query.
 * @param responseMode
 */ function addResponseMode(parameters, responseMode) {
    parameters.set((0, _aadserverParamKeysMjs.RESPONSE_MODE), responseMode ? responseMode : (0, _constantsMjs.ResponseMode).QUERY);
}
/**
 * Add flag to indicate STS should attempt to use WAM if available
 */ function addNativeBroker(parameters) {
    parameters.set((0, _aadserverParamKeysMjs.NATIVE_BROKER), "1");
}
/**
 * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
 * @param scopeSet
 * @param addOidcScopes
 */ function addScopes(parameters, scopes, correlationId, addOidcScopes = true, defaultScopes = (0, _constantsMjs.OIDC_DEFAULT_SCOPES)) {
    // Always add openid to the scopes when adding OIDC scopes
    if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
    const requestScopes = addOidcScopes ? [
        ...scopes || [],
        ...defaultScopes
    ] : scopes || [];
    const scopeSet = new (0, _scopeSetMjs.ScopeSet)(requestScopes, correlationId);
    parameters.set((0, _aadserverParamKeysMjs.SCOPE), scopeSet.printScopes());
}
/**
 * add clientId
 * @param clientId
 */ function addClientId(parameters, clientId) {
    parameters.set((0, _aadserverParamKeysMjs.CLIENT_ID), clientId);
}
/**
 * add redirect_uri
 * @param redirectUri
 */ function addRedirectUri(parameters, redirectUri) {
    parameters.set((0, _aadserverParamKeysMjs.REDIRECT_URI), redirectUri);
}
/**
 * add post logout redirectUri
 * @param redirectUri
 */ function addPostLogoutRedirectUri(parameters, redirectUri) {
    parameters.set((0, _aadserverParamKeysMjs.POST_LOGOUT_URI), redirectUri);
}
/**
 * add id_token_hint to logout request
 * @param idTokenHint
 */ function addIdTokenHint(parameters, idTokenHint) {
    parameters.set((0, _aadserverParamKeysMjs.ID_TOKEN_HINT), idTokenHint);
}
/**
 * add domain_hint
 * @param domainHint
 */ function addDomainHint(parameters, domainHint) {
    parameters.set((0, _aadserverParamKeysMjs.DOMAIN_HINT), domainHint);
}
/**
 * add login_hint
 * @param loginHint
 */ function addLoginHint(parameters, loginHint) {
    parameters.set((0, _aadserverParamKeysMjs.LOGIN_HINT), loginHint);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for login_hint
 * @param loginHint
 */ function addCcsUpn(parameters, loginHint) {
    parameters.set((0, _constantsMjs.HeaderNames).CCS_HEADER, `UPN:${loginHint}`);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for account object
 * @param loginHint
 */ function addCcsOid(parameters, clientInfo) {
    parameters.set((0, _constantsMjs.HeaderNames).CCS_HEADER, `Oid:${clientInfo.uid}@${clientInfo.utid}`);
}
/**
 * add sid
 * @param sid
 */ function addSid(parameters, sid) {
    parameters.set((0, _aadserverParamKeysMjs.SID), sid);
}
/**
 * Adds claims to request parameters, conditionally excluding clientCapabilities
 * when skipBrokerClaims is true and a brokered flow is in effect.
 * @param parameters - The request parameters map
 * @param correlationId - The request correlation id
 * @param claims - The claims string from the request
 * @param clientCapabilities - The client capabilities from configuration
 * @param skipBrokerClaims - When true and BROKER_CLIENT_ID is present, excludes clientCapabilities from claims
 */ function addClaims(parameters, correlationId, claims, clientCapabilities, skipBrokerClaims) {
    // Skip clientCapabilities if skipBrokerClaims is set to true and this is a brokered authentication flow
    const configClaims = skipBrokerClaims && parameters.has((0, _aadserverParamKeysMjs.BROKER_CLIENT_ID)) ? undefined : clientCapabilities;
    const mergedClaims = buildMergedClaims(claims, configClaims, correlationId);
    parameters.set((0, _aadserverParamKeysMjs.CLAIMS), mergedClaims);
}
/**
 * add correlationId
 * @param correlationId
 */ function addCorrelationId(parameters, correlationId) {
    parameters.set((0, _aadserverParamKeysMjs.CLIENT_REQUEST_ID), correlationId);
}
/**
 * add library info query params
 * @param libraryInfo
 */ function addLibraryInfo(parameters, libraryInfo) {
    // Telemetry Info
    parameters.set((0, _aadserverParamKeysMjs.X_CLIENT_SKU), libraryInfo.sku);
    parameters.set((0, _aadserverParamKeysMjs.X_CLIENT_VER), libraryInfo.version);
    if (libraryInfo.os) parameters.set((0, _aadserverParamKeysMjs.X_CLIENT_OS), libraryInfo.os);
    if (libraryInfo.cpu) parameters.set((0, _aadserverParamKeysMjs.X_CLIENT_CPU), libraryInfo.cpu);
}
/**
 * Add client telemetry parameters
 * @param appTelemetry
 */ function addApplicationTelemetry(parameters, appTelemetry) {
    if (appTelemetry?.appName) parameters.set((0, _aadserverParamKeysMjs.X_APP_NAME), appTelemetry.appName);
    if (appTelemetry?.appVersion) parameters.set((0, _aadserverParamKeysMjs.X_APP_VER), appTelemetry.appVersion);
}
/**
 * add prompt
 * @param prompt
 */ function addPrompt(parameters, prompt) {
    parameters.set((0, _aadserverParamKeysMjs.PROMPT), prompt);
}
/**
 * add state
 * @param state
 */ function addState(parameters, state) {
    if (state) parameters.set((0, _aadserverParamKeysMjs.STATE), state);
}
/**
 * add nonce
 * @param nonce
 */ function addNonce(parameters, nonce) {
    parameters.set((0, _aadserverParamKeysMjs.NONCE), nonce);
}
/**
 * add code_challenge and code_challenge_method
 * - throw if either of them are not passed
 * @param codeChallenge
 * @param codeChallengeMethod
 */ function addCodeChallengeParams(parameters, codeChallenge, codeChallengeMethod) {
    if (codeChallenge && codeChallengeMethod) {
        parameters.set((0, _aadserverParamKeysMjs.CODE_CHALLENGE), codeChallenge);
        parameters.set((0, _aadserverParamKeysMjs.CODE_CHALLENGE_METHOD), codeChallengeMethod);
    } else throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.pkceParamsMissing), "");
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function addAuthorizationCode(parameters, code) {
    parameters.set((0, _aadserverParamKeysMjs.CODE), code);
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function addDeviceCode(parameters, code) {
    parameters.set((0, _aadserverParamKeysMjs.DEVICE_CODE), code);
}
/**
 * add the `refreshToken` passed by the user
 * @param refreshToken
 */ function addRefreshToken(parameters, refreshToken) {
    parameters.set((0, _aadserverParamKeysMjs.REFRESH_TOKEN), refreshToken);
}
/**
 * add the `code_verifier` passed by the user to exchange for a token
 * @param codeVerifier
 */ function addCodeVerifier(parameters, codeVerifier) {
    parameters.set((0, _aadserverParamKeysMjs.CODE_VERIFIER), codeVerifier);
}
/**
 * add client_secret
 * @param clientSecret
 */ function addClientSecret(parameters, clientSecret) {
    parameters.set((0, _aadserverParamKeysMjs.CLIENT_SECRET), clientSecret);
}
/**
 * add clientAssertion for confidential client flows
 * @param clientAssertion
 */ function addClientAssertion(parameters, clientAssertion) {
    if (clientAssertion) parameters.set((0, _aadserverParamKeysMjs.CLIENT_ASSERTION), clientAssertion);
}
/**
 * add clientAssertionType for confidential client flows
 * @param clientAssertionType
 */ function addClientAssertionType(parameters, clientAssertionType) {
    if (clientAssertionType) parameters.set((0, _aadserverParamKeysMjs.CLIENT_ASSERTION_TYPE), clientAssertionType);
}
/**
 * add OBO assertion for confidential client flows
 * @param clientAssertion
 */ function addOboAssertion(parameters, oboAssertion) {
    parameters.set((0, _aadserverParamKeysMjs.OBO_ASSERTION), oboAssertion);
}
/**
 * add grant type
 * @param grantType
 */ function addRequestTokenUse(parameters, tokenUse) {
    parameters.set((0, _aadserverParamKeysMjs.REQUESTED_TOKEN_USE), tokenUse);
}
/**
 * add grant type
 * @param grantType
 */ function addGrantType(parameters, grantType) {
    parameters.set((0, _aadserverParamKeysMjs.GRANT_TYPE), grantType);
}
/**
 * add client info
 *
 */ function addClientInfo(parameters) {
    parameters.set((0, _constantsMjs.CLIENT_INFO), "1");
}
/**
 * add clidata=1 to request to indicate client data support
 */ function addCliData(parameters) {
    parameters.set((0, _aadserverParamKeysMjs.CLI_DATA), "1");
}
function addInstanceAware(parameters) {
    if (!parameters.has((0, _aadserverParamKeysMjs.INSTANCE_AWARE))) parameters.set((0, _aadserverParamKeysMjs.INSTANCE_AWARE), "true");
}
/**
 * Add extraParameters
 * @param extraParams - String dictionary containing extra parameters to be added.
 */ function addExtraParameters(parameters, extraParams) {
    Object.entries(extraParams).forEach(([key, value])=>{
        if (!parameters.has(key) && value) parameters.set(key, value);
    });
}
/**
 * Default optional idToken claims requested on all auth requests.
 * signin_state enables KMSI detection; login_hint enables login hint propagation.
 */ const DEFAULT_ID_TOKEN_CLAIMS = {
    [(0, _constantsMjs.ClaimsRequestKeys).SIGNIN_STATE]: {
        essential: false
    },
    [(0, _constantsMjs.ClaimsRequestKeys).LOGIN_HINT]: {
        essential: false
    }
};
/**
 * Parses claims JSON, merges default optional idToken claims (signin_state, login_hint),
 * and appends client capabilities (xms_cc) to the access_token section.
 * Does not overwrite idToken claims already specified by the caller.
 * @param claims - Existing claims JSON string from the request (may be undefined)
 * @param clientCapabilities - Client capabilities array from configuration
 * @returns Merged claims JSON string
 */ function buildMergedClaims(claims, clientCapabilities, correlationId = "") {
    let mergedClaims;
    // Parse provided claims into JSON object or initialize empty object
    if (!claims) mergedClaims = {};
    else try {
        const parsed = JSON.parse(claims);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) throw new Error("Claims must be a JSON object");
        mergedClaims = parsed;
    } catch (e) {
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.invalidClaims), correlationId);
    }
    // Add default optional idToken claims
    if (!Object.prototype.hasOwnProperty.call(mergedClaims, (0, _constantsMjs.ClaimsRequestKeys).ID_TOKEN)) mergedClaims[(0, _constantsMjs.ClaimsRequestKeys).ID_TOKEN] = {};
    const idTokenClaims = mergedClaims[(0, _constantsMjs.ClaimsRequestKeys).ID_TOKEN];
    for (const [key, value] of Object.entries(DEFAULT_ID_TOKEN_CLAIMS))if (!(key in idTokenClaims)) idTokenClaims[key] = value;
    // Add client capabilities
    if (clientCapabilities && clientCapabilities.length > 0) {
        if (!Object.prototype.hasOwnProperty.call(mergedClaims, (0, _constantsMjs.ClaimsRequestKeys).ACCESS_TOKEN)) // Add access_token key to claims object
        mergedClaims[(0, _constantsMjs.ClaimsRequestKeys).ACCESS_TOKEN] = {};
        // Add xms_cc claim with provided clientCapabilities to access_token key
        mergedClaims[(0, _constantsMjs.ClaimsRequestKeys).ACCESS_TOKEN][(0, _constantsMjs.ClaimsRequestKeys).XMS_CC] = {
            values: clientCapabilities
        };
    }
    return JSON.stringify(mergedClaims);
}
/**
 * adds `username` for Password Grant flow
 * @param username
 */ function addUsername(parameters, username) {
    parameters.set((0, _constantsMjs.PasswordGrantConstants).username, username);
}
/**
 * adds `password` for Password Grant flow
 * @param password
 */ function addPassword(parameters, password) {
    parameters.set((0, _constantsMjs.PasswordGrantConstants).password, password);
}
/**
 * add pop_jwk to query params
 * @param cnfString
 */ function addPopToken(parameters, cnfString) {
    if (cnfString) {
        parameters.set((0, _aadserverParamKeysMjs.TOKEN_TYPE), (0, _constantsMjs.AuthenticationScheme).POP);
        parameters.set((0, _aadserverParamKeysMjs.REQ_CNF), cnfString);
    }
}
/**
 * add SSH JWK and key ID to query params
 */ function addSshJwk(parameters, sshJwkString) {
    if (sshJwkString) {
        parameters.set((0, _aadserverParamKeysMjs.TOKEN_TYPE), (0, _constantsMjs.AuthenticationScheme).SSH);
        parameters.set((0, _aadserverParamKeysMjs.REQ_CNF), sshJwkString);
    }
}
/**
 * add server telemetry fields
 * @param serverTelemetryManager
 * @internal
 */ function addServerTelemetry(parameters, serverTelemetryManager) {
    parameters.set((0, _aadserverParamKeysMjs.X_CLIENT_CURR_TELEM), serverTelemetryManager.generateCurrentRequestHeaderValue());
    parameters.set((0, _aadserverParamKeysMjs.X_CLIENT_LAST_TELEM), serverTelemetryManager.generateLastRequestHeaderValue());
}
/**
 * Adds parameter that indicates to the server that throttling is supported
 */ function addThrottling(parameters) {
    parameters.set((0, _aadserverParamKeysMjs.X_MS_LIB_CAPABILITY), (0, _constantsMjs.X_MS_LIB_CAPABILITY_VALUE));
}
/**
 * Adds logout_hint parameter for "silent" logout which prevent server account picker
 */ function addLogoutHint(parameters, logoutHint) {
    parameters.set((0, _aadserverParamKeysMjs.LOGOUT_HINT), logoutHint);
}
function addBrokerParameters(parameters, brokerClientId, brokerRedirectUri) {
    if (!parameters.has((0, _aadserverParamKeysMjs.BROKER_CLIENT_ID))) parameters.set((0, _aadserverParamKeysMjs.BROKER_CLIENT_ID), brokerClientId);
    if (!parameters.has((0, _aadserverParamKeysMjs.BROKER_REDIRECT_URI))) parameters.set((0, _aadserverParamKeysMjs.BROKER_REDIRECT_URI), brokerRedirectUri);
}
/**
 * Add EAR (Encrypted Authorize Response) request parameters
 * @param parameters
 * @param jwk
 */ function addEARParameters(parameters, jwk) {
    parameters.set((0, _aadserverParamKeysMjs.EAR_JWK), encodeURIComponent(jwk));
    // ear_jwe_crypto will always have value: {"alg":"dir","enc":"A256GCM"} so we can hardcode this
    const jweCryptoB64Encoded = "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0";
    parameters.set((0, _aadserverParamKeysMjs.EAR_JWE_CRYPTO), jweCryptoB64Encoded);
}
function addResource(parameters, resource) {
    if (resource) parameters.set((0, _aadserverParamKeysMjs.RESOURCE), resource);
}

},{"../utils/Constants.mjs":"5eRZy","../constants/AADServerParamKeys.mjs":"kjH8Y","./ScopeSet.mjs":"7niwa","../error/ClientConfigurationError.mjs":"ebyn4","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kjH8Y":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCESS_TOKEN", ()=>ACCESS_TOKEN);
parcelHelpers.export(exports, "BROKER_CLIENT_ID", ()=>BROKER_CLIENT_ID);
parcelHelpers.export(exports, "BROKER_REDIRECT_URI", ()=>BROKER_REDIRECT_URI);
parcelHelpers.export(exports, "CCS_HEADER", ()=>CCS_HEADER);
parcelHelpers.export(exports, "CLAIMS", ()=>CLAIMS);
parcelHelpers.export(exports, "CLIENT_ASSERTION", ()=>CLIENT_ASSERTION);
parcelHelpers.export(exports, "CLIENT_ASSERTION_TYPE", ()=>CLIENT_ASSERTION_TYPE);
parcelHelpers.export(exports, "CLIENT_ID", ()=>CLIENT_ID);
parcelHelpers.export(exports, "CLIENT_INFO", ()=>CLIENT_INFO);
parcelHelpers.export(exports, "CLIENT_REQUEST_ID", ()=>CLIENT_REQUEST_ID);
parcelHelpers.export(exports, "CLIENT_SECRET", ()=>CLIENT_SECRET);
parcelHelpers.export(exports, "CLI_DATA", ()=>CLI_DATA);
parcelHelpers.export(exports, "CODE", ()=>CODE);
parcelHelpers.export(exports, "CODE_CHALLENGE", ()=>CODE_CHALLENGE);
parcelHelpers.export(exports, "CODE_CHALLENGE_METHOD", ()=>CODE_CHALLENGE_METHOD);
parcelHelpers.export(exports, "CODE_VERIFIER", ()=>CODE_VERIFIER);
parcelHelpers.export(exports, "DEVICE_CODE", ()=>DEVICE_CODE);
parcelHelpers.export(exports, "DOMAIN_HINT", ()=>DOMAIN_HINT);
parcelHelpers.export(exports, "EAR_JWE_CRYPTO", ()=>EAR_JWE_CRYPTO);
parcelHelpers.export(exports, "EAR_JWK", ()=>EAR_JWK);
parcelHelpers.export(exports, "ERROR", ()=>ERROR);
parcelHelpers.export(exports, "ERROR_DESCRIPTION", ()=>ERROR_DESCRIPTION);
parcelHelpers.export(exports, "EXPIRES_IN", ()=>EXPIRES_IN);
parcelHelpers.export(exports, "FMI_PATH", ()=>FMI_PATH);
parcelHelpers.export(exports, "FOCI", ()=>FOCI);
parcelHelpers.export(exports, "GRANT_TYPE", ()=>GRANT_TYPE);
parcelHelpers.export(exports, "ID_TOKEN", ()=>ID_TOKEN);
parcelHelpers.export(exports, "ID_TOKEN_HINT", ()=>ID_TOKEN_HINT);
parcelHelpers.export(exports, "INSTANCE_AWARE", ()=>INSTANCE_AWARE);
parcelHelpers.export(exports, "LOGIN_HINT", ()=>LOGIN_HINT);
parcelHelpers.export(exports, "LOGOUT_HINT", ()=>LOGOUT_HINT);
parcelHelpers.export(exports, "NATIVE_BROKER", ()=>NATIVE_BROKER);
parcelHelpers.export(exports, "NONCE", ()=>NONCE);
parcelHelpers.export(exports, "OBO_ASSERTION", ()=>OBO_ASSERTION);
parcelHelpers.export(exports, "ON_BEHALF_OF", ()=>ON_BEHALF_OF);
parcelHelpers.export(exports, "POST_LOGOUT_URI", ()=>POST_LOGOUT_URI);
parcelHelpers.export(exports, "PROMPT", ()=>PROMPT);
parcelHelpers.export(exports, "REDIRECT_URI", ()=>REDIRECT_URI);
parcelHelpers.export(exports, "REFRESH_TOKEN", ()=>REFRESH_TOKEN);
parcelHelpers.export(exports, "REFRESH_TOKEN_EXPIRES_IN", ()=>REFRESH_TOKEN_EXPIRES_IN);
parcelHelpers.export(exports, "REQUESTED_TOKEN_USE", ()=>REQUESTED_TOKEN_USE);
parcelHelpers.export(exports, "REQ_CNF", ()=>REQ_CNF);
parcelHelpers.export(exports, "RESOURCE", ()=>RESOURCE);
parcelHelpers.export(exports, "RESPONSE_MODE", ()=>RESPONSE_MODE);
parcelHelpers.export(exports, "RESPONSE_TYPE", ()=>RESPONSE_TYPE);
parcelHelpers.export(exports, "RETURN_SPA_CODE", ()=>RETURN_SPA_CODE);
parcelHelpers.export(exports, "SCOPE", ()=>SCOPE);
parcelHelpers.export(exports, "SESSION_STATE", ()=>SESSION_STATE);
parcelHelpers.export(exports, "SID", ()=>SID);
parcelHelpers.export(exports, "STATE", ()=>STATE);
parcelHelpers.export(exports, "TOKEN_TYPE", ()=>TOKEN_TYPE);
parcelHelpers.export(exports, "USERNAME", ()=>USERNAME);
parcelHelpers.export(exports, "USER_FEDERATED_IDENTITY_CREDENTIAL", ()=>USER_FEDERATED_IDENTITY_CREDENTIAL);
parcelHelpers.export(exports, "USER_ID", ()=>USER_ID);
parcelHelpers.export(exports, "X_APP_NAME", ()=>X_APP_NAME);
parcelHelpers.export(exports, "X_APP_VER", ()=>X_APP_VER);
parcelHelpers.export(exports, "X_CLIENT_CPU", ()=>X_CLIENT_CPU);
parcelHelpers.export(exports, "X_CLIENT_CURR_TELEM", ()=>X_CLIENT_CURR_TELEM);
parcelHelpers.export(exports, "X_CLIENT_EXTRA_SKU", ()=>X_CLIENT_EXTRA_SKU);
parcelHelpers.export(exports, "X_CLIENT_LAST_TELEM", ()=>X_CLIENT_LAST_TELEM);
parcelHelpers.export(exports, "X_CLIENT_OS", ()=>X_CLIENT_OS);
parcelHelpers.export(exports, "X_CLIENT_SKU", ()=>X_CLIENT_SKU);
parcelHelpers.export(exports, "X_CLIENT_VER", ()=>X_CLIENT_VER);
parcelHelpers.export(exports, "X_MS_LIB_CAPABILITY", ()=>X_MS_LIB_CAPABILITY);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const CLIENT_ID = "client_id";
const REDIRECT_URI = "redirect_uri";
const RESPONSE_TYPE = "response_type";
const RESPONSE_MODE = "response_mode";
const GRANT_TYPE = "grant_type";
const CLAIMS = "claims";
const SCOPE = "scope";
const ERROR = "error";
const ERROR_DESCRIPTION = "error_description";
const ACCESS_TOKEN = "access_token";
const ID_TOKEN = "id_token";
const REFRESH_TOKEN = "refresh_token";
const EXPIRES_IN = "expires_in";
const REFRESH_TOKEN_EXPIRES_IN = "refresh_token_expires_in";
const STATE = "state";
const NONCE = "nonce";
const PROMPT = "prompt";
const SESSION_STATE = "session_state";
const CLIENT_INFO = "client_info";
const CODE = "code";
const CODE_CHALLENGE = "code_challenge";
const CODE_CHALLENGE_METHOD = "code_challenge_method";
const CODE_VERIFIER = "code_verifier";
const CLIENT_REQUEST_ID = "client-request-id";
const X_CLIENT_SKU = "x-client-SKU";
const X_CLIENT_VER = "x-client-VER";
const X_CLIENT_OS = "x-client-OS";
const X_CLIENT_CPU = "x-client-CPU";
const X_CLIENT_CURR_TELEM = "x-client-current-telemetry";
const X_CLIENT_LAST_TELEM = "x-client-last-telemetry";
const X_MS_LIB_CAPABILITY = "x-ms-lib-capability";
const X_APP_NAME = "x-app-name";
const X_APP_VER = "x-app-ver";
const POST_LOGOUT_URI = "post_logout_redirect_uri";
const ID_TOKEN_HINT = "id_token_hint";
const DEVICE_CODE = "device_code";
const CLIENT_SECRET = "client_secret";
const CLIENT_ASSERTION = "client_assertion";
const CLIENT_ASSERTION_TYPE = "client_assertion_type";
const TOKEN_TYPE = "token_type";
const REQ_CNF = "req_cnf";
const OBO_ASSERTION = "assertion";
const REQUESTED_TOKEN_USE = "requested_token_use";
const ON_BEHALF_OF = "on_behalf_of";
const FOCI = "foci";
const CCS_HEADER = "X-AnchorMailbox";
const RETURN_SPA_CODE = "return_spa_code";
const NATIVE_BROKER = "nativebroker";
const LOGOUT_HINT = "logout_hint";
const SID = "sid";
const LOGIN_HINT = "login_hint";
const DOMAIN_HINT = "domain_hint";
const X_CLIENT_EXTRA_SKU = "x-client-xtra-sku";
const BROKER_CLIENT_ID = "brk_client_id";
const BROKER_REDIRECT_URI = "brk_redirect_uri";
const INSTANCE_AWARE = "instance_aware";
const EAR_JWK = "ear_jwk";
const EAR_JWE_CRYPTO = "ear_jwe_crypto";
const RESOURCE = "resource";
const CLI_DATA = "clidata";
const USER_FEDERATED_IDENTITY_CREDENTIAL = "user_federated_identity_credential";
const USERNAME = "username";
const USER_ID = "user_id";
const FMI_PATH = "fmi_path";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7niwa":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScopeSet", ()=>ScopeSet);
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _stringUtilsMjs = require("../utils/StringUtils.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class ScopeSet {
    constructor(inputScopes, correlationId){
        this.correlationId = correlationId;
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, _stringUtilsMjs.StringUtils).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, _stringUtilsMjs.StringUtils).removeEmptyStringsFromArray(scopeArr) : [];
        // Check if scopes array has at least one member
        if (!filteredInput || !filteredInput.length) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.emptyInputScopesError), correlationId);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString, correlationId) {
        const scopeString = inputScopeString || "";
        const inputScopes = scopeString.split(" ");
        return new ScopeSet(inputScopes, correlationId);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString, correlationId) {
        // Handle empty scopes by using default OIDC scopes for cache lookup
        const scopesToUse = inputScopeString && inputScopeString.length > 0 ? inputScopeString : [
            ...(0, _constantsMjs.OIDC_DEFAULT_SCOPES)
        ];
        const scopeSet = new ScopeSet(scopesToUse, correlationId);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, _constantsMjs.OFFLINE_ACCESS_SCOPE));
        return scopeSet;
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new ScopeSet(lowerCaseScopes, this.correlationId);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, _constantsMjs.OIDC_SCOPES).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.cannotAppendScopeSet), this.correlationId);
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.cannotRemoveEmptyScope), this.correlationId);
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, _constantsMjs.OIDC_SCOPES).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.emptyInputScopeSet), this.correlationId);
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.emptyInputScopeSet), this.correlationId);
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return "";
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}

},{"../error/ClientConfigurationError.mjs":"ebyn4","../utils/StringUtils.mjs":"d70Cd","../error/ClientAuthError.mjs":"e8Ku4","../utils/Constants.mjs":"5eRZy","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ebyn4":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientConfigurationError", ()=>ClientConfigurationError);
parcelHelpers.export(exports, "createClientConfigurationError", ()=>createClientConfigurationError);
var _authErrorMjs = require("./AuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class ClientConfigurationError extends (0, _authErrorMjs.AuthError) {
    constructor(errorCode, correlationId){
        super(errorCode, correlationId);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, ClientConfigurationError.prototype);
    }
}
function createClientConfigurationError(errorCode, correlationId) {
    return new ClientConfigurationError(errorCode, correlationId);
}

},{"./AuthError.mjs":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"d70Cd":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringUtils", ()=>StringUtils);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class StringUtils {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iMtlX":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authorityMismatch", ()=>authorityMismatch);
parcelHelpers.export(exports, "authorityUriInsecure", ()=>authorityUriInsecure);
parcelHelpers.export(exports, "cannotAllowPlatformBroker", ()=>cannotAllowPlatformBroker);
parcelHelpers.export(exports, "cannotSetOIDCOptions", ()=>cannotSetOIDCOptions);
parcelHelpers.export(exports, "claimsRequestParsingError", ()=>claimsRequestParsingError);
parcelHelpers.export(exports, "emptyInputScopesError", ()=>emptyInputScopesError);
parcelHelpers.export(exports, "invalidAuthenticationHeader", ()=>invalidAuthenticationHeader);
parcelHelpers.export(exports, "invalidAuthorityMetadata", ()=>invalidAuthorityMetadata);
parcelHelpers.export(exports, "invalidClaims", ()=>invalidClaims);
parcelHelpers.export(exports, "invalidCloudDiscoveryMetadata", ()=>invalidCloudDiscoveryMetadata);
parcelHelpers.export(exports, "invalidCodeChallengeMethod", ()=>invalidCodeChallengeMethod);
parcelHelpers.export(exports, "invalidDpopHtm", ()=>invalidDpopHtm);
parcelHelpers.export(exports, "invalidDpopHtu", ()=>invalidDpopHtu);
parcelHelpers.export(exports, "invalidPlatformBrokerConfiguration", ()=>invalidPlatformBrokerConfiguration);
parcelHelpers.export(exports, "invalidRequestMethodForEAR", ()=>invalidRequestMethodForEAR);
parcelHelpers.export(exports, "invalidResponseMode", ()=>invalidResponseMode);
parcelHelpers.export(exports, "issuerValidationFailed", ()=>issuerValidationFailed);
parcelHelpers.export(exports, "logoutRequestEmpty", ()=>logoutRequestEmpty);
parcelHelpers.export(exports, "missingNonceAuthenticationHeader", ()=>missingNonceAuthenticationHeader);
parcelHelpers.export(exports, "missingSshJwk", ()=>missingSshJwk);
parcelHelpers.export(exports, "missingSshKid", ()=>missingSshKid);
parcelHelpers.export(exports, "pkceParamsMissing", ()=>pkceParamsMissing);
parcelHelpers.export(exports, "redirectUriEmpty", ()=>redirectUriEmpty);
parcelHelpers.export(exports, "tokenRequestEmpty", ()=>tokenRequestEmpty);
parcelHelpers.export(exports, "untrustedAuthority", ()=>untrustedAuthority);
parcelHelpers.export(exports, "urlEmptyError", ()=>urlEmptyError);
parcelHelpers.export(exports, "urlParseError", ()=>urlParseError);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const redirectUriEmpty = "redirect_uri_empty";
const claimsRequestParsingError = "claims_request_parsing_error";
const authorityUriInsecure = "authority_uri_insecure";
const urlParseError = "url_parse_error";
const urlEmptyError = "empty_url_error";
const emptyInputScopesError = "empty_input_scopes_error";
const invalidClaims = "invalid_claims";
const tokenRequestEmpty = "token_request_empty";
const logoutRequestEmpty = "logout_request_empty";
const invalidCodeChallengeMethod = "invalid_code_challenge_method";
const pkceParamsMissing = "pkce_params_missing";
const invalidCloudDiscoveryMetadata = "invalid_cloud_discovery_metadata";
const invalidAuthorityMetadata = "invalid_authority_metadata";
const untrustedAuthority = "untrusted_authority";
const missingSshJwk = "missing_ssh_jwk";
const missingSshKid = "missing_ssh_kid";
const missingNonceAuthenticationHeader = "missing_nonce_authentication_header";
const invalidAuthenticationHeader = "invalid_authentication_header";
const cannotSetOIDCOptions = "cannot_set_OIDCOptions";
const cannotAllowPlatformBroker = "cannot_allow_platform_broker";
const authorityMismatch = "authority_mismatch";
const invalidRequestMethodForEAR = "invalid_request_method_for_EAR";
const invalidPlatformBrokerConfiguration = "invalid_platform_broker_configuration";
const issuerValidationFailed = "issuer_validation_failed";
const invalidResponseMode = "invalid_response_mode";
const invalidDpopHtm = "invalid_dpop_htm";
const invalidDpopHtu = "invalid_dpop_htu";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9Z8Lm":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UrlString", ()=>UrlString);
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _stringUtilsMjs = require("../utils/StringUtils.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class UrlString {
    get urlString() {
        return this._urlString;
    }
    constructor(url, correlationId){
        this._urlString = url;
        this.correlationId = correlationId;
        if (!this._urlString) // Throws error if url is empty
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.urlEmptyError), correlationId);
        if (!url.includes("#")) this._urlString = UrlString.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, _stringUtilsMjs.StringUtils).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, _stringUtilsMjs.StringUtils).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, _stringUtilsMjs.StringUtils).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.urlParseError), this.correlationId);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.urlParseError), this.correlationId);
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.authorityUriInsecure), this.correlationId);
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return UrlString.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, _constantsMjs.AADAuthority).COMMON || pathArray[0] === (0, _constantsMjs.AADAuthority).ORGANIZATIONS)) pathArray[0] = tenantId;
        return UrlString.constructAuthorityUriFromObject(urlObject, this.correlationId);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.urlParseError), this.correlationId);
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url, correlationId) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.urlParseError), correlationId);
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl, correlationId) {
        if (relativeUrl[0] === (0, _constantsMjs.FORWARD_SLASH)) {
            const url = new UrlString(baseUrl, correlationId);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject, correlationId) {
        return new UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"), correlationId);
    }
}

},{"../error/ClientConfigurationError.mjs":"ebyn4","../utils/StringUtils.mjs":"d70Cd","../utils/Constants.mjs":"5eRZy","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2SeAw":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDeserializedResponse", ()=>getDeserializedResponse);
parcelHelpers.export(exports, "mapToQueryString", ()=>mapToQueryString);
parcelHelpers.export(exports, "normalizeUrlForComparison", ()=>normalizeUrlForComparison);
parcelHelpers.export(exports, "stripLeadingHashOrQuery", ()=>stripLeadingHashOrQuery);
parcelHelpers.export(exports, "validateUrl", ()=>validateUrl);
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function stripLeadingHashOrQuery(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function getDeserializedResponse(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = stripLeadingHashOrQuery(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.ear_jwe || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.hashNotDeserialized), "");
    }
    return null;
}
/**
 * Utility to create a URL from the params map
 */ function mapToQueryString(parameters) {
    const queryParameterArray = new Array();
    parameters.forEach((value, key)=>{
        queryParameterArray.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParameterArray.join("&");
}
/**
 * Normalizes URLs for comparison per MDN & RFC 3986 standards:
 * - Hash/fragment is removed
 * - Scheme and host are lowercased (case-insensitive per spec)
 * - Path and query parameters preserve original casing (case-sensitive per spec)
 * - Percent-encoding in pathname is normalized (e.g., %27 and ' are treated equivalently)
 * - Ensures pathname ends with /
 * Throws a urlParseError if the provided URL is malformed and cannot be parsed.
 * @param url - URL to normalize
 * @param logger - Optional logger used to log parse failures
 * @param correlationId - Optional correlationId associated with the log entry
 * @returns Normalized URL string for comparison
 */ function normalizeUrlForComparison(url, logger, correlationId) {
    if (!url) return url;
    const urlWithoutHash = url.split("#")[0];
    if (!urlWithoutHash) return urlWithoutHash;
    try {
        const urlObj = new URL(urlWithoutHash);
        // Treat an empty query string (a bare trailing "?") as equivalent to no query
        if (!urlObj.search) urlObj.search = "";
        // Decode the pathname to normalize percent-encoding and ensure trailing slash
        let pathname;
        try {
            pathname = decodeURIComponent(urlObj.pathname);
        } catch (e) {
            pathname = urlObj.pathname;
        }
        if (!pathname.endsWith("/")) pathname += "/";
        urlObj.pathname = pathname;
        return urlObj.href;
    } catch (e) {
        logger?.error(`15apdm ${e}`, correlationId || "");
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.urlParseError), correlationId || "");
    }
}
/**
 * Validates that the provided value is a well-formed, parseable absolute URL.
 * Throws a urlParseError if the value cannot be parsed by the URL API (e.g. the
 * literal string "null", an empty string, or any malformed/relative URL). Use this
 * to guard against persisting an invalid value (such as a redirect URL) to the cache.
 * @param url - URL to validate
 * @param logger - Optional logger used to log validation failures
 * @param correlationId - Optional correlationId associated with the log entry
 */ function validateUrl(url, logger, correlationId) {
    try {
        new URL(url);
    } catch (e) {
        logger?.error(`1lrjz7 ${e}`, correlationId || "");
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.urlParseError), correlationId || "");
    }
}

},{"../error/ClientAuthError.mjs":"e8Ku4","../error/ClientConfigurationError.mjs":"ebyn4","../error/ClientAuthErrorCodes.mjs":"8keAa","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bwxx0":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcquireTokenByCodeAsync", ()=>AcquireTokenByCodeAsync);
parcelHelpers.export(exports, "AcquireTokenByRefreshToken", ()=>AcquireTokenByRefreshToken);
parcelHelpers.export(exports, "AcquireTokenBySilentIframe", ()=>AcquireTokenBySilentIframe);
parcelHelpers.export(exports, "AcquireTokenFromCache", ()=>AcquireTokenFromCache);
parcelHelpers.export(exports, "AcquireTokenSilentAsync", ()=>AcquireTokenSilentAsync);
parcelHelpers.export(exports, "AuthClientAcquireToken", ()=>AuthClientAcquireToken);
parcelHelpers.export(exports, "AuthorityFactoryCreateDiscoveredInstance", ()=>AuthorityFactoryCreateDiscoveredInstance);
parcelHelpers.export(exports, "AwaitConcurrentIframe", ()=>AwaitConcurrentIframe);
parcelHelpers.export(exports, "Base64Decode", ()=>Base64Decode);
parcelHelpers.export(exports, "CryptoOptsGetPublicKeyThumbprint", ()=>CryptoOptsGetPublicKeyThumbprint);
parcelHelpers.export(exports, "CryptoOptsSignJwt", ()=>CryptoOptsSignJwt);
parcelHelpers.export(exports, "Decrypt", ()=>Decrypt);
parcelHelpers.export(exports, "DecryptEarResponse", ()=>DecryptEarResponse);
parcelHelpers.export(exports, "DeserializeResponse", ()=>DeserializeResponse);
parcelHelpers.export(exports, "Encrypt", ()=>Encrypt);
parcelHelpers.export(exports, "GenerateBaseKey", ()=>GenerateBaseKey);
parcelHelpers.export(exports, "GenerateCodeChallengeFromVerifier", ()=>GenerateCodeChallengeFromVerifier);
parcelHelpers.export(exports, "GenerateCodeVerifier", ()=>GenerateCodeVerifier);
parcelHelpers.export(exports, "GenerateEarKey", ()=>GenerateEarKey);
parcelHelpers.export(exports, "GenerateHKDF", ()=>GenerateHKDF);
parcelHelpers.export(exports, "GeneratePkceCodes", ()=>GeneratePkceCodes);
parcelHelpers.export(exports, "GetRandomValues", ()=>GetRandomValues);
parcelHelpers.export(exports, "GetStandardParams", ()=>GetStandardParams);
parcelHelpers.export(exports, "HandleCodeResponse", ()=>HandleCodeResponse);
parcelHelpers.export(exports, "HandleNativeRedirectPromiseMeasurement", ()=>HandleNativeRedirectPromiseMeasurement);
parcelHelpers.export(exports, "HandleRedirectPromiseMeasurement", ()=>HandleRedirectPromiseMeasurement);
parcelHelpers.export(exports, "HandleResponseCode", ()=>HandleResponseCode);
parcelHelpers.export(exports, "HandleResponseEar", ()=>HandleResponseEar);
parcelHelpers.export(exports, "HandleResponsePlatformBroker", ()=>HandleResponsePlatformBroker);
parcelHelpers.export(exports, "ImportExistingCache", ()=>ImportExistingCache);
parcelHelpers.export(exports, "InitializeBaseRequest", ()=>InitializeBaseRequest);
parcelHelpers.export(exports, "InitializeCache", ()=>InitializeCache);
parcelHelpers.export(exports, "InitializeSilentRequest", ()=>InitializeSilentRequest);
parcelHelpers.export(exports, "LoadAccessToken", ()=>LoadAccessToken);
parcelHelpers.export(exports, "LoadAccount", ()=>LoadAccount);
parcelHelpers.export(exports, "LoadIdToken", ()=>LoadIdToken);
parcelHelpers.export(exports, "LoadRefreshToken", ()=>LoadRefreshToken);
parcelHelpers.export(exports, "NativeInteractionClientAcquireToken", ()=>NativeInteractionClientAcquireToken);
parcelHelpers.export(exports, "NativeInteractionClientAcquireTokenRedirect", ()=>NativeInteractionClientAcquireTokenRedirect);
parcelHelpers.export(exports, "NativeMessageHandlerHandshake", ()=>NativeMessageHandlerHandshake);
parcelHelpers.export(exports, "RefreshTokenClientAcquireTokenByRefreshToken", ()=>RefreshTokenClientAcquireTokenByRefreshToken);
parcelHelpers.export(exports, "RemoveHiddenIframe", ()=>RemoveHiddenIframe);
parcelHelpers.export(exports, "Sha256Digest", ()=>Sha256Digest);
parcelHelpers.export(exports, "SilentCacheClientAcquireToken", ()=>SilentCacheClientAcquireToken);
parcelHelpers.export(exports, "SilentFlowClientAcquireCachedToken", ()=>SilentFlowClientAcquireCachedToken);
parcelHelpers.export(exports, "SilentHandlerInitiateAuthRequest", ()=>SilentHandlerInitiateAuthRequest);
parcelHelpers.export(exports, "SilentHandlerMonitorIframeForHash", ()=>SilentHandlerMonitorIframeForHash);
parcelHelpers.export(exports, "SilentIframeClientAcquireToken", ()=>SilentIframeClientAcquireToken);
parcelHelpers.export(exports, "SilentIframeClientTokenHelper", ()=>SilentIframeClientTokenHelper);
parcelHelpers.export(exports, "SilentRefreshClientAcquireToken", ()=>SilentRefreshClientAcquireToken);
parcelHelpers.export(exports, "StandardInteractionClientCreateAuthCodeClient", ()=>StandardInteractionClientCreateAuthCodeClient);
parcelHelpers.export(exports, "StandardInteractionClientGetClientConfiguration", ()=>StandardInteractionClientGetClientConfiguration);
parcelHelpers.export(exports, "StandardInteractionClientGetDiscoveredAuthority", ()=>StandardInteractionClientGetDiscoveredAuthority);
parcelHelpers.export(exports, "StandardInteractionClientInitializeAuthorizationRequest", ()=>StandardInteractionClientInitializeAuthorizationRequest);
parcelHelpers.export(exports, "UrlEncodeArr", ()=>UrlEncodeArr);
parcelHelpers.export(exports, "WaitForBridgeLateResponse", ()=>WaitForBridgeLateResponse);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenFromCache (msal-browser).
 * Internal API for acquiring token from cache
 */ const AcquireTokenFromCache = "acquireTokenFromCache";
/**
 * acquireTokenByRefreshToken API (msal-browser and msal-node).
 * Used to renew an access token using a refresh token against the token endpoint.
 */ const AcquireTokenByRefreshToken = "acquireTokenByRefreshToken";
/**
 * acquireTokenSilentAsync (msal-browser).
 * Internal API for acquireTokenSilent.
 */ const AcquireTokenSilentAsync = "acquireTokenSilentAsync";
/**
 * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
 * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
 */ const CryptoOptsGetPublicKeyThumbprint = "cryptoOptsGetPublicKeyThumbprint";
/**
 * signJwt API in CryptoOpts class (msal-browser).
 * Used to signed a pop token.
 */ const CryptoOptsSignJwt = "cryptoOptsSignJwt";
/**
 * acquireToken API in the SilentCacheClient class (msal-browser).
 * Used to read access tokens from the cache.
 */ const SilentCacheClientAcquireToken = "silentCacheClientAcquireToken";
/**
 * acquireToken API in the SilentIframeClient class (msal-browser).
 * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
 */ const SilentIframeClientAcquireToken = "silentIframeClientAcquireToken";
const AwaitConcurrentIframe = "awaitConcurrentIframe"; // Time spent waiting for a concurrent iframe to complete
/**
 * acquireToken API in SilentRereshClient (msal-browser).
 * Used to acquire a new set of tokens from the token endpoint using a refresh token.
 */ const SilentRefreshClientAcquireToken = "silentRefreshClientAcquireToken";
/**
 * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
 * Used to load authority metadata for a request.
 */ const StandardInteractionClientGetDiscoveredAuthority = "standardInteractionClientGetDiscoveredAuthority";
/**
 * acquireToken API in NativeInteractionClient class (msal-browser).
 * Used to acquire a token from Native component when native brokering is enabled.
 */ const NativeInteractionClientAcquireToken = "nativeInteractionClientAcquireToken";
const NativeInteractionClientAcquireTokenRedirect = "nativeInteractionClientAcquireToken";
/**
 * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
 */ const RefreshTokenClientAcquireTokenByRefreshToken = "refreshTokenClientAcquireTokenByRefreshToken";
/**
 * acquireTokenBySilentIframe (msal-browser).
 * Internal API for acquiring token by silent Iframe
 */ const AcquireTokenBySilentIframe = "acquireTokenBySilentIframe";
/**
 * Internal API for initializing base request in BaseInteractionClient (msal-browser)
 */ const InitializeBaseRequest = "initializeBaseRequest";
/**
 * Internal API for initializing silent request in SilentCacheClient (msal-browser)
 */ const InitializeSilentRequest = "initializeSilentRequest";
const InitializeCache = "initializeCache";
/**
 * Helper function in SilentIframeClient class (msal-browser).
 */ const SilentIframeClientTokenHelper = "silentIframeClientTokenHelper";
/**
 * SilentHandler
 */ const SilentHandlerInitiateAuthRequest = "silentHandlerInitiateAuthRequest";
const SilentHandlerMonitorIframeForHash = "silentHandlerMonitorIframeForHash";
/**
 * Helper functions in StandardInteractionClient class (msal-browser)
 */ const StandardInteractionClientCreateAuthCodeClient = "standardInteractionClientCreateAuthCodeClient";
const StandardInteractionClientGetClientConfiguration = "standardInteractionClientGetClientConfiguration";
const StandardInteractionClientInitializeAuthorizationRequest = "standardInteractionClientInitializeAuthorizationRequest";
const SilentFlowClientAcquireCachedToken = "silentFlowClientAcquireCachedToken";
const GetStandardParams = "getStandardParams";
const HandleCodeResponse = "handleCodeResponse";
const HandleResponseEar = "handleResponseEar";
const HandleResponsePlatformBroker = "handleResponsePlatformBroker";
const HandleResponseCode = "handleResponseCode";
const AuthClientAcquireToken = "authClientAcquireToken";
const DeserializeResponse = "deserializeResponse";
const AuthorityFactoryCreateDiscoveredInstance = "authorityFactoryCreateDiscoveredInstance";
const AcquireTokenByCodeAsync = "acquireTokenByCodeAsync";
const HandleRedirectPromiseMeasurement = "handleRedirectPromise";
const HandleNativeRedirectPromiseMeasurement = "handleNativeRedirectPromise";
const NativeMessageHandlerHandshake = "nativeMessageHandlerHandshake";
const RemoveHiddenIframe = "removeHiddenIframe";
const ImportExistingCache = "importExistingCache";
/**
 * Crypto Operations
 */ const GeneratePkceCodes = "generatePkceCodes";
const GenerateCodeVerifier = "generateCodeVerifier";
const GenerateCodeChallengeFromVerifier = "generateCodeChallengeFromVerifier";
const Sha256Digest = "sha256Digest";
const GetRandomValues = "getRandomValues";
const GenerateHKDF = "generateHKDF";
const GenerateBaseKey = "generateBaseKey";
const Base64Decode = "base64Decode";
const UrlEncodeArr = "urlEncodeArr";
const Encrypt = "encrypt";
const Decrypt = "decrypt";
const GenerateEarKey = "generateEarKey";
const DecryptEarResponse = "decryptEarResponse";
const LoadAccount = "loadAccount";
const LoadIdToken = "loadIdToken";
const LoadAccessToken = "loadAccessToken";
const LoadRefreshToken = "loadRefreshToken";
/**
 * Background telemetry measurement that tracks whether a late bridge response
 * arrives after the iframe timeout has already fired.
 */ const WaitForBridgeLateResponse = "waitForBridgeLateResponse";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"k9YIy":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserAuthError", ()=>BrowserAuthError);
parcelHelpers.export(exports, "createBrowserAuthError", ()=>createBrowserAuthError);
parcelHelpers.export(exports, "getDefaultErrorMessage", ()=>getDefaultErrorMessage);
var _browser = require("@azure/msal-common/browser");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function getDefaultErrorMessage(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class BrowserAuthError extends (0, _browser.AuthError) {
    constructor(errorCode, correlationId, subError){
        super(errorCode, correlationId, getDefaultErrorMessage(errorCode), subError);
        Object.setPrototypeOf(this, BrowserAuthError.prototype);
        this.name = "BrowserAuthError";
    }
}
function createBrowserAuthError(errorCode, correlationId, subError) {
    return new BrowserAuthError(errorCode, correlationId, subError);
}

},{"@azure/msal-common/browser":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"evkpn":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base64DecToArr", ()=>base64DecToArr);
parcelHelpers.export(exports, "base64Decode", ()=>base64Decode);
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function base64Decode(input) {
    return new TextDecoder().decode(base64DecToArr(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function base64DecToArr(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.invalidBase64String), "");
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}

},{"../error/BrowserAuthError.mjs":"k9YIy","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"c0BSJ":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authCodeOrNativeAccountIdRequired", ()=>authCodeOrNativeAccountIdRequired);
parcelHelpers.export(exports, "authCodeRequired", ()=>authCodeRequired);
parcelHelpers.export(exports, "authRequestNotSetError", ()=>authRequestNotSetError);
parcelHelpers.export(exports, "blockIframeReload", ()=>blockIframeReload);
parcelHelpers.export(exports, "blockNestedPopups", ()=>blockNestedPopups);
parcelHelpers.export(exports, "cryptoKeyNotFound", ()=>cryptoKeyNotFound);
parcelHelpers.export(exports, "cryptoNonExistent", ()=>cryptoNonExistent);
parcelHelpers.export(exports, "databaseNotOpen", ()=>databaseNotOpen);
parcelHelpers.export(exports, "databaseUnavailable", ()=>databaseUnavailable);
parcelHelpers.export(exports, "earJweEmpty", ()=>earJweEmpty);
parcelHelpers.export(exports, "earJwkEmpty", ()=>earJwkEmpty);
parcelHelpers.export(exports, "emptyNavigateUri", ()=>emptyNavigateUri);
parcelHelpers.export(exports, "emptyResponse", ()=>emptyResponse);
parcelHelpers.export(exports, "emptyWindowError", ()=>emptyWindowError);
parcelHelpers.export(exports, "failedToBuildHeaders", ()=>failedToBuildHeaders);
parcelHelpers.export(exports, "failedToDecryptEarResponse", ()=>failedToDecryptEarResponse);
parcelHelpers.export(exports, "failedToParseHeaders", ()=>failedToParseHeaders);
parcelHelpers.export(exports, "failedToParseResponse", ()=>failedToParseResponse);
parcelHelpers.export(exports, "getRequestFailed", ()=>getRequestFailed);
parcelHelpers.export(exports, "hashDoesNotContainKnownProperties", ()=>hashDoesNotContainKnownProperties);
parcelHelpers.export(exports, "hashEmptyError", ()=>hashEmptyError);
parcelHelpers.export(exports, "iframeClosedPrematurely", ()=>iframeClosedPrematurely);
parcelHelpers.export(exports, "interactionInProgress", ()=>interactionInProgress);
parcelHelpers.export(exports, "interactionInProgressCancelled", ()=>interactionInProgressCancelled);
parcelHelpers.export(exports, "invalidBase64String", ()=>invalidBase64String);
parcelHelpers.export(exports, "invalidCacheType", ()=>invalidCacheType);
parcelHelpers.export(exports, "invalidPopTokenRequest", ()=>invalidPopTokenRequest);
parcelHelpers.export(exports, "invalidPublicJwk", ()=>invalidPublicJwk);
parcelHelpers.export(exports, "nativeConnectionNotEstablished", ()=>nativeConnectionNotEstablished);
parcelHelpers.export(exports, "nativeExtensionNotInstalled", ()=>nativeExtensionNotInstalled);
parcelHelpers.export(exports, "nativeHandshakeTimeout", ()=>nativeHandshakeTimeout);
parcelHelpers.export(exports, "nativePromptNotSupported", ()=>nativePromptNotSupported);
parcelHelpers.export(exports, "noAccountError", ()=>noAccountError);
parcelHelpers.export(exports, "noNetworkConnectivity", ()=>noNetworkConnectivity);
parcelHelpers.export(exports, "noStateInHash", ()=>noStateInHash);
parcelHelpers.export(exports, "noTokenRequestCacheError", ()=>noTokenRequestCacheError);
parcelHelpers.export(exports, "nonBrowserEnvironment", ()=>nonBrowserEnvironment);
parcelHelpers.export(exports, "pkceNotCreated", ()=>pkceNotCreated);
parcelHelpers.export(exports, "popupRelayUnsupportedFlow", ()=>popupRelayUnsupportedFlow);
parcelHelpers.export(exports, "popupWindowError", ()=>popupWindowError);
parcelHelpers.export(exports, "postRequestFailed", ()=>postRequestFailed);
parcelHelpers.export(exports, "redirectBridgeEmptyResponse", ()=>redirectBridgeEmptyResponse);
parcelHelpers.export(exports, "redirectInIframe", ()=>redirectInIframe);
parcelHelpers.export(exports, "silentLogoutUnsupported", ()=>silentLogoutUnsupported);
parcelHelpers.export(exports, "silentPromptValueError", ()=>silentPromptValueError);
parcelHelpers.export(exports, "spaCodeAndNativeAccountIdPresent", ()=>spaCodeAndNativeAccountIdPresent);
parcelHelpers.export(exports, "stateInteractionTypeMismatch", ()=>stateInteractionTypeMismatch);
parcelHelpers.export(exports, "timedOut", ()=>timedOut);
parcelHelpers.export(exports, "unableToAcquireTokenFromNativePlatform", ()=>unableToAcquireTokenFromNativePlatform);
parcelHelpers.export(exports, "unableToLoadToken", ()=>unableToLoadToken);
parcelHelpers.export(exports, "unableToParseState", ()=>unableToParseState);
parcelHelpers.export(exports, "unableToParseTokenRequestCacheError", ()=>unableToParseTokenRequestCacheError);
parcelHelpers.export(exports, "uninitializedPublicClientApplication", ()=>uninitializedPublicClientApplication);
parcelHelpers.export(exports, "userCancelled", ()=>userCancelled);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const pkceNotCreated = "pkce_not_created";
const earJwkEmpty = "ear_jwk_empty";
const earJweEmpty = "ear_jwe_empty";
const cryptoNonExistent = "crypto_nonexistent";
const emptyNavigateUri = "empty_navigate_uri";
const hashEmptyError = "hash_empty_error";
const noStateInHash = "no_state_in_hash";
const hashDoesNotContainKnownProperties = "hash_does_not_contain_known_properties";
const unableToParseState = "unable_to_parse_state";
const stateInteractionTypeMismatch = "state_interaction_type_mismatch";
const interactionInProgress = "interaction_in_progress";
const interactionInProgressCancelled = "interaction_in_progress_cancelled";
const popupWindowError = "popup_window_error";
const emptyWindowError = "empty_window_error";
const userCancelled = "user_cancelled";
const redirectBridgeEmptyResponse = "redirect_bridge_empty_response";
const redirectInIframe = "redirect_in_iframe";
const blockIframeReload = "block_iframe_reload";
const blockNestedPopups = "block_nested_popups";
const popupRelayUnsupportedFlow = "popup_relay_unsupported_flow";
const iframeClosedPrematurely = "iframe_closed_prematurely";
const silentLogoutUnsupported = "silent_logout_unsupported";
const noAccountError = "no_account_error";
const silentPromptValueError = "silent_prompt_value_error";
const noTokenRequestCacheError = "no_token_request_cache_error";
const unableToParseTokenRequestCacheError = "unable_to_parse_token_request_cache_error";
const authRequestNotSetError = "auth_request_not_set_error";
const invalidCacheType = "invalid_cache_type";
const nonBrowserEnvironment = "non_browser_environment";
const databaseNotOpen = "database_not_open";
const noNetworkConnectivity = "no_network_connectivity";
const postRequestFailed = "post_request_failed";
const getRequestFailed = "get_request_failed";
const failedToParseResponse = "failed_to_parse_response";
const unableToLoadToken = "unable_to_load_token";
const cryptoKeyNotFound = "crypto_key_not_found";
const invalidPublicJwk = "invalid_public_jwk";
const authCodeRequired = "auth_code_required";
const authCodeOrNativeAccountIdRequired = "auth_code_or_nativeAccountId_required";
const spaCodeAndNativeAccountIdPresent = "spa_code_and_nativeAccountId_present";
const databaseUnavailable = "database_unavailable";
const unableToAcquireTokenFromNativePlatform = "unable_to_acquire_token_from_native_platform";
const nativeHandshakeTimeout = "native_handshake_timeout";
const nativeExtensionNotInstalled = "native_extension_not_installed";
const nativeConnectionNotEstablished = "native_connection_not_established";
const uninitializedPublicClientApplication = "uninitialized_public_client_application";
const nativePromptNotSupported = "native_prompt_not_supported";
const invalidBase64String = "invalid_base64_string";
const invalidPopTokenRequest = "invalid_pop_token_request";
const failedToBuildHeaders = "failed_to_build_headers";
const failedToParseHeaders = "failed_to_parse_headers";
const failedToDecryptEarResponse = "failed_to_decrypt_ear_response";
const timedOut = "timed_out";
const emptyResponse = "empty_response";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5kHn0":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApiId", ()=>ApiId);
parcelHelpers.export(exports, "ApiName", ()=>ApiName);
parcelHelpers.export(exports, "BrowserCacheLocation", ()=>BrowserCacheLocation);
parcelHelpers.export(exports, "BrowserConstants", ()=>BrowserConstants);
parcelHelpers.export(exports, "CacheLookupPolicy", ()=>CacheLookupPolicy);
parcelHelpers.export(exports, "DB_NAME", ()=>DB_NAME);
parcelHelpers.export(exports, "DB_TABLE_NAME", ()=>DB_TABLE_NAME);
parcelHelpers.export(exports, "DB_VERSION", ()=>DB_VERSION);
parcelHelpers.export(exports, "DEFAULT_REQUEST", ()=>DEFAULT_REQUEST);
parcelHelpers.export(exports, "HTTP_REQUEST_TYPE", ()=>HTTP_REQUEST_TYPE);
parcelHelpers.export(exports, "INTERACTION_TYPE", ()=>INTERACTION_TYPE);
parcelHelpers.export(exports, "InMemoryCacheKeys", ()=>InMemoryCacheKeys);
parcelHelpers.export(exports, "InteractionStatus", ()=>InteractionStatus);
parcelHelpers.export(exports, "InteractionType", ()=>InteractionType);
parcelHelpers.export(exports, "KEY_FORMAT_JWK", ()=>KEY_FORMAT_JWK);
parcelHelpers.export(exports, "NativeExtensionMethod", ()=>NativeExtensionMethod);
parcelHelpers.export(exports, "PlatformAuthConstants", ()=>PlatformAuthConstants);
parcelHelpers.export(exports, "TemporaryCacheKeys", ()=>TemporaryCacheKeys);
parcelHelpers.export(exports, "WrapperSKU", ()=>WrapperSKU);
parcelHelpers.export(exports, "apiIdToName", ()=>apiIdToName);
parcelHelpers.export(exports, "iFrameRenewalPolicies", ()=>iFrameRenewalPolicies);
var _browser = require("@azure/msal-common/browser");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const BrowserConstants = {
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const PlatformAuthConstants = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS",
    MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
    DOM_API_NAME: "DOM API",
    PLATFORM_DOM_APIS: "get-token-and-sign-out",
    PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
    PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
};
const NativeExtensionMethod = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const BrowserCacheLocation = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const HTTP_REQUEST_TYPE = {
    GET: "GET",
    POST: "POST"
};
const INTERACTION_TYPE = {
    SIGNIN: "signin",
    SIGNOUT: "signout"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const TemporaryCacheKeys = {
    ORIGIN_URI: "request.origin",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    VERIFIER: "code.verifier",
    INTERACTION_STATUS_KEY: "interaction.status",
    NATIVE_REQUEST: "request.native"
};
/**
 * Cache keys stored in-memory
 */ const InMemoryCacheKeys = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 * 900-999 Misc
 */ const ApiId = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962,
    hydrateCache: 963,
    loadExternalTokens: 964
};
/**
 * API Names for Telemetry purposes.
 */ const ApiName = {
    861: "acquireTokenRedirect",
    862: "acquireTokenPopup",
    863: "ssoSilent",
    864: "acquireTokenSilent_authCode",
    865: "handleRedirectPromise",
    866: "acquireTokenByCode",
    61: "acquireTokenSilent_silentFlow",
    961: "logout",
    962: "logoutPopup",
    963: "hydrateCache",
    964: "loadExternalTokens"
};
const apiIdToName = (id)=>{
    if (typeof id === "number" && id in ApiName) return ApiName[id];
    return "unknown";
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var InteractionType;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})(InteractionType || (InteractionType = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const InteractionStatus = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const DEFAULT_REQUEST = {
    scopes: (0, _browser.Constants).OIDC_DEFAULT_SCOPES
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const KEY_FORMAT_JWK = "jwk";
// Supported wrapper SKUs
const WrapperSKU = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const DB_NAME = "msal.db";
const DB_VERSION = 1;
const DB_TABLE_NAME = `${DB_NAME}.keys`;
const CacheLookupPolicy = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const iFrameRenewalPolicies = [
    CacheLookupPolicy.Default,
    CacheLookupPolicy.Skip,
    CacheLookupPolicy.RefreshTokenAndNetwork
];

},{"@azure/msal-common/browser":[["Constants","5eRZy","*"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"a5L0H":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RSA_KEYGEN_ALGORITHM_OPTIONS", ()=>RSA_KEYGEN_ALGORITHM_OPTIONS);
parcelHelpers.export(exports, "RSA_SIGN_ALGORITHM_OPTIONS", ()=>RSA_SIGN_ALGORITHM_OPTIONS);
parcelHelpers.export(exports, "computeJwkThumbprint", ()=>computeJwkThumbprint);
parcelHelpers.export(exports, "createNewGuid", ()=>createNewGuid);
parcelHelpers.export(exports, "decrypt", ()=>decrypt);
parcelHelpers.export(exports, "decryptEarResponse", ()=>decryptEarResponse);
parcelHelpers.export(exports, "encrypt", ()=>encrypt);
parcelHelpers.export(exports, "exportJwk", ()=>exportJwk);
parcelHelpers.export(exports, "generateBaseKey", ()=>generateBaseKey);
parcelHelpers.export(exports, "generateEarKey", ()=>generateEarKey);
parcelHelpers.export(exports, "generateHKDF", ()=>generateHKDF);
parcelHelpers.export(exports, "generateKeyPair", ()=>generateKeyPair);
parcelHelpers.export(exports, "getRandomValues", ()=>getRandomValues);
parcelHelpers.export(exports, "hashString", ()=>hashString);
parcelHelpers.export(exports, "importEarKey", ()=>importEarKey);
parcelHelpers.export(exports, "importJwk", ()=>importJwk);
parcelHelpers.export(exports, "sha256Digest", ()=>sha256Digest);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "validateCryptoAvailable", ()=>validateCryptoAvailable);
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _base64EncodeMjs = require("../encode/Base64Encode.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // Algorithms
const PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
const AES_GCM = "AES-GCM";
const HKDF = "HKDF";
// SHA-256 hashing algorithm
const S256_HASH_ALG = "SHA-256";
const JSON_WEB_KEY_TYPE_EC = "EC";
const JSON_WEB_KEY_TYPE_RSA = "RSA";
const MISSING_JWK_KTY_SUBERROR = "missing_jwk_kty";
const UNSUPPORTED_JWK_KTY_SUBERROR = "unsupported_jwk_kty";
const MISSING_JWK_MEMBER_SUBERROR = "missing_jwk_member";
const EMPTY_JWK_MEMBER_SUBERROR = "empty_jwk_member";
// MOD length for PoP tokens
const MODULUS_LENGTH = 2048;
// Public Exponent
const PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const UINT32_ARR = new Uint32Array(1);
// Key Format
const RAW = "raw";
// Key Usages
const ENCRYPT = "encrypt";
const DECRYPT = "decrypt";
const DERIVE_KEY = "deriveKey";
// Suberror
const SUBTLE_SUBERROR = "crypto_subtle_undefined";
const RSA_KEYGEN_ALGORITHM_OPTIONS = {
    name: PKCS1_V15_KEYGEN_ALG,
    hash: S256_HASH_ALG,
    modulusLength: MODULUS_LENGTH,
    publicExponent: PUBLIC_EXPONENT
};
const RSA_SIGN_ALGORITHM_OPTIONS = {
    name: PKCS1_V15_KEYGEN_ALG
};
/**
 * Check whether browser crypto is available.
 */ function validateCryptoAvailable(skipValidateSubtleCrypto) {
    if (!window) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.nonBrowserEnvironment), "");
    if (!window.crypto) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.cryptoNonExistent), "");
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.cryptoNonExistent), "", SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function sha256Digest(dataString) {
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest(S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function getRandomValues(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function getRandomUint32() {
    window.crypto.getRandomValues(UINT32_ARR);
    return UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function createNewGuid() {
    const currentTimestamp = Date.now();
    const baseRand = getRandomUint32() * 0x400 + (getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += UUID_CHARS.charAt(bytes[i] >>> 4);
        text += UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on the provided algorithm config.
 * @param extractable
 * @param usages
 * @param algorithm
 */ async function generateKeyPair(extractable, usages, algorithm) {
    return window.crypto.subtle.generateKey(algorithm, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function exportJwk(key) {
    return window.crypto.subtle.exportKey((0, _browserConstantsMjs.KEY_FORMAT_JWK), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 * @param algorithm
 */ async function importJwk(key, extractable, usages, algorithm) {
    return window.crypto.subtle.importKey((0, _browserConstantsMjs.KEY_FORMAT_JWK), key, algorithm, extractable, usages);
}
/**
 * Signs given data with given key.
 * @param key
 * @param data
 * @param algorithm
 */ async function sign(key, data, algorithm) {
    return window.crypto.subtle.sign(algorithm, key, data);
}
/**
 * Generates Base64 encoded jwk used in the Encrypted Authorize Response (EAR) flow
 */ async function generateEarKey() {
    const key = await generateBaseKey();
    const keyStr = (0, _base64EncodeMjs.urlEncodeArr)(new Uint8Array(key));
    const jwk = {
        alg: "dir",
        kty: "oct",
        k: keyStr
    };
    return (0, _base64EncodeMjs.base64Encode)(JSON.stringify(jwk));
}
/**
 * Parses earJwk for encryption key and returns CryptoKey object
 * @param earJwk
 * @returns
 */ async function importEarKey(earJwk) {
    const b64DecodedJwk = (0, _base64DecodeMjs.base64Decode)(earJwk);
    const jwkJson = JSON.parse(b64DecodedJwk);
    const rawKey = jwkJson.k;
    const keyBuffer = (0, _base64DecodeMjs.base64DecToArr)(rawKey);
    return window.crypto.subtle.importKey(RAW, keyBuffer, AES_GCM, false, [
        DECRYPT
    ]);
}
/**
 * Decrypt ear_jwe response returned in the Encrypted Authorize Response (EAR) flow
 * @param earJwk
 * @param earJwe
 * @returns
 */ async function decryptEarResponse(earJwk, earJwe) {
    const earJweParts = earJwe.split(".");
    if (earJweParts.length !== 5) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.failedToDecryptEarResponse), "", "jwe_length");
    const key = await importEarKey(earJwk).catch(()=>{
        throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.failedToDecryptEarResponse), "", "import_key");
    });
    try {
        const header = new TextEncoder().encode(earJweParts[0]);
        const iv = (0, _base64DecodeMjs.base64DecToArr)(earJweParts[2]);
        const ciphertext = (0, _base64DecodeMjs.base64DecToArr)(earJweParts[3]);
        const tag = (0, _base64DecodeMjs.base64DecToArr)(earJweParts[4]);
        const tagLengthBits = tag.byteLength * 8;
        // Concat ciphertext and tag
        const encryptedData = new Uint8Array(ciphertext.length + tag.length);
        encryptedData.set(ciphertext);
        encryptedData.set(tag, ciphertext.length);
        const decryptedData = await window.crypto.subtle.decrypt({
            name: AES_GCM,
            iv: iv,
            tagLength: tagLengthBits,
            additionalData: header
        }, key, encryptedData);
        return new TextDecoder().decode(decryptedData);
    } catch (e) {
        throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.failedToDecryptEarResponse), "", "decrypt");
    }
}
/**
 * Generates symmetric base encryption key. This may be stored as all encryption/decryption keys will be derived from this one.
 */ async function generateBaseKey() {
    const key = await window.crypto.subtle.generateKey({
        name: AES_GCM,
        length: 256
    }, true, [
        ENCRYPT,
        DECRYPT
    ]);
    return window.crypto.subtle.exportKey(RAW, key);
}
/**
 * Returns the raw key to be passed into the key derivation function
 * @param baseKey
 * @returns
 */ async function generateHKDF(baseKey) {
    return window.crypto.subtle.importKey(RAW, baseKey, HKDF, false, [
        DERIVE_KEY
    ]);
}
/**
 * Given a base key and a nonce generates a derived key to be used in encryption and decryption.
 * Note: every time we encrypt a new key is derived
 * @param baseKey
 * @param nonce
 * @returns
 */ async function deriveKey(baseKey, nonce, context) {
    return window.crypto.subtle.deriveKey({
        name: HKDF,
        salt: nonce,
        hash: S256_HASH_ALG,
        info: new TextEncoder().encode(context)
    }, baseKey, {
        name: AES_GCM,
        length: 256
    }, false, [
        ENCRYPT,
        DECRYPT
    ]);
}
/**
 * Encrypt the given data given a base key. Returns encrypted data and a nonce that must be provided during decryption
 * @param key
 * @param rawData
 */ async function encrypt(baseKey, rawData, context) {
    const encodedData = new TextEncoder().encode(rawData);
    // The nonce must never be reused with a given key.
    const nonce = window.crypto.getRandomValues(new Uint8Array(16));
    const derivedKey = await deriveKey(baseKey, nonce, context);
    const encryptedData = await window.crypto.subtle.encrypt({
        name: AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return {
        data: (0, _base64EncodeMjs.urlEncodeArr)(new Uint8Array(encryptedData)),
        nonce: (0, _base64EncodeMjs.urlEncodeArr)(nonce)
    };
}
/**
 * Decrypt data with the given key and nonce
 * @param key
 * @param nonce
 * @param encryptedData
 * @returns
 */ async function decrypt(baseKey, nonce, context, encryptedData) {
    const encodedData = (0, _base64DecodeMjs.base64DecToArr)(encryptedData);
    const derivedKey = await deriveKey(baseKey, (0, _base64DecodeMjs.base64DecToArr)(nonce), context);
    const decryptedData = await window.crypto.subtle.decrypt({
        name: AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return new TextDecoder().decode(decryptedData);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function hashString(plainText) {
    const hashBuffer = await sha256Digest(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, _base64EncodeMjs.urlEncodeArr)(hashBytes);
}
const JWK_THUMBPRINT_REQUIRED_MEMBERS = {
    [JSON_WEB_KEY_TYPE_EC]: [
        "crv",
        "kty",
        "x",
        "y"
    ],
    [JSON_WEB_KEY_TYPE_RSA]: [
        "e",
        "kty",
        "n"
    ]
};
function getJwkThumbprintMembers(publicJwk) {
    const kty = publicJwk.kty;
    if (typeof kty !== "string" || kty.length === 0) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.invalidPublicJwk), "", MISSING_JWK_KTY_SUBERROR);
    const requiredMembers = JWK_THUMBPRINT_REQUIRED_MEMBERS[kty];
    if (!requiredMembers) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.invalidPublicJwk), "", UNSUPPORTED_JWK_KTY_SUBERROR);
    return requiredMembers.reduce((thumbprintMembers, memberName)=>{
        const memberValue = publicJwk[memberName];
        if (typeof memberValue !== "string") throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.invalidPublicJwk), "", MISSING_JWK_MEMBER_SUBERROR);
        if (memberValue.length === 0) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.invalidPublicJwk), "", EMPTY_JWK_MEMBER_SUBERROR);
        thumbprintMembers[memberName] = memberValue;
        return thumbprintMembers;
    }, {});
}
/**
 * Computes an RFC 7638 JWK thumbprint for a public key.
 * The required members for the JWK key type are serialised in lexicographic order
 * and the SHA-256 digest is returned as a base64url string.
 * @internal
 */ async function computeJwkThumbprint(publicJwk) {
    const thumbprintMembers = getJwkThumbprintMembers(publicJwk);
    // RFC 7638 §3.3: use only required members, sorted lexicographically
    const thumbprintJson = JSON.stringify(thumbprintMembers, Object.keys(thumbprintMembers).sort());
    return hashString(thumbprintJson);
}

},{"../error/BrowserAuthError.mjs":"k9YIy","../utils/BrowserConstants.mjs":"5kHn0","../encode/Base64Encode.mjs":"b1HK9","../encode/Base64Decode.mjs":"evkpn","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b1HK9":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base64Encode", ()=>base64Encode);
parcelHelpers.export(exports, "urlEncode", ()=>urlEncode);
parcelHelpers.export(exports, "urlEncodeArr", ()=>urlEncodeArr);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function urlEncode(input) {
    return encodeURIComponent(base64Encode(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function urlEncodeArr(inputArr) {
    return base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function base64Encode(input) {
    return base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"401zU":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserConfigurationAuthError", ()=>BrowserConfigurationAuthError);
parcelHelpers.export(exports, "createBrowserConfigurationAuthError", ()=>createBrowserConfigurationAuthError);
var _browser = require("@azure/msal-common/browser");
var _browserAuthErrorMjs = require("./BrowserAuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class BrowserConfigurationAuthError extends (0, _browser.AuthError) {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, BrowserConfigurationAuthError.prototype);
    }
}
function createBrowserConfigurationAuthError(errorCode, correlationId) {
    return new BrowserConfigurationAuthError(errorCode, correlationId, (0, _browserAuthErrorMjs.getDefaultErrorMessage)(errorCode));
}

},{"@azure/msal-common/browser":"8TWYe","./BrowserAuthError.mjs":"k9YIy","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"f0n3B":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inMemRedirectUnavailable", ()=>inMemRedirectUnavailable);
parcelHelpers.export(exports, "storageNotSupported", ()=>storageNotSupported);
parcelHelpers.export(exports, "stubbedPublicClientApplicationCalled", ()=>stubbedPublicClientApplicationCalled);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const storageNotSupported = "storage_not_supported";
const stubbedPublicClientApplicationCalled = "stubbed_public_client_application_called";
const inMemRedirectUnavailable = "in_mem_redirect_unavailable";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"al9yc":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthenticationHeaderParser", ()=>AuthenticationHeaderParser);
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This is a helper class that parses supported HTTP response authentication headers to extract and return
 * header challenge values that can be used outside the basic authorization flows.
 */ class AuthenticationHeaderParser {
    constructor(headers){
        this.headers = headers;
    }
    /**
     * This method parses the SHR nonce value out of either the Authentication-Info or WWW-Authenticate authentication headers.
     * @returns
     */ getShrNonce() {
        // Attempt to parse nonce from Authentiacation-Info
        const authenticationInfo = this.headers[(0, _constantsMjs.HeaderNames).AuthenticationInfo];
        if (authenticationInfo) {
            const authenticationInfoChallenges = this.parseChallenges(authenticationInfo);
            if (authenticationInfoChallenges.nextnonce) return authenticationInfoChallenges.nextnonce;
            throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.invalidAuthenticationHeader), "");
        }
        // Attempt to parse nonce from WWW-Authenticate
        const wwwAuthenticate = this.headers[(0, _constantsMjs.HeaderNames).WWWAuthenticate];
        if (wwwAuthenticate) {
            const wwwAuthenticateChallenges = this.parseChallenges(wwwAuthenticate);
            if (wwwAuthenticateChallenges.nonce) return wwwAuthenticateChallenges.nonce;
            throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.invalidAuthenticationHeader), "");
        }
        // If neither header is present, throw missing headers error
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.missingNonceAuthenticationHeader), "");
    }
    /**
     * Parses an HTTP header's challenge set into a key/value map.
     * @param header
     * @returns
     */ parseChallenges(header) {
        const schemeSeparator = header.indexOf(" ");
        const challenges = header.substr(schemeSeparator + 1).split(",");
        const challengeMap = {};
        challenges.forEach((challenge)=>{
            const [key, value] = challenge.split("=");
            // Remove escaped quotation marks (', ") from challenge string to keep only the challenge value
            challengeMap[key] = unescape(value.replace(/['"]+/g, ""));
        });
        return challengeMap;
    }
}

},{"../error/ClientConfigurationError.mjs":"ebyn4","../utils/Constants.mjs":"5eRZy","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hf916":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "postRequestFailed", ()=>postRequestFailed);
parcelHelpers.export(exports, "unexpectedError", ()=>unexpectedError);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const unexpectedError = "unexpected_error";
const postRequestFailed = "post_request_failed";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9DjNg":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AzureCloudInstance", ()=>AzureCloudInstance);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const AzureCloudInstance = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aeuO6":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enforceResourceParameter", ()=>enforceResourceParameter);
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Helper to enforce resource parameter presence in token requests when isMcp is set in the configuration.
 * If resource parameter is set in both the request and in extraQueryParameters or extraParameters, an error will be thrown.
 * This is used for MCP flows.
 * @param isMcp - Flag indicating if application is an MCP app, from configuration
 * @param request - Auth request
 */ function enforceResourceParameter(isMcp, request) {
    if (!isMcp) return;
    if (request.resource && (containsResourceParam(request.extraParameters) || containsResourceParam(request.extraQueryParameters))) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.misplacedResourceParam), request.correlationId || "");
    if (!request.resource) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.resourceParameterRequired), request.correlationId || "");
}
function containsResourceParam(params) {
    if (!params) return false;
    return Object.prototype.hasOwnProperty.call(params, "resource");
}

},{"../error/ClientAuthError.mjs":"e8Ku4","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jiVlC":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InteractionRequiredAuthErrorCodes", ()=>_interactionRequiredAuthErrorCodesMjs);
parcelHelpers.export(exports, "InteractionRequiredAuthError", ()=>InteractionRequiredAuthError);
parcelHelpers.export(exports, "InteractionRequiredAuthSubErrorMessage", ()=>InteractionRequiredAuthSubErrorMessage);
parcelHelpers.export(exports, "InteractionRequiredServerErrorMessage", ()=>InteractionRequiredServerErrorMessage);
parcelHelpers.export(exports, "createInteractionRequiredAuthError", ()=>createInteractionRequiredAuthError);
parcelHelpers.export(exports, "isInteractionRequiredError", ()=>isInteractionRequiredError);
var _authErrorMjs = require("./AuthError.mjs");
var _interactionRequiredAuthErrorCodesMjs = require("./InteractionRequiredAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const InteractionRequiredServerErrorMessage = [
    (0, _interactionRequiredAuthErrorCodesMjs.interactionRequired),
    (0, _interactionRequiredAuthErrorCodesMjs.consentRequired),
    (0, _interactionRequiredAuthErrorCodesMjs.loginRequired),
    (0, _interactionRequiredAuthErrorCodesMjs.badToken),
    (0, _interactionRequiredAuthErrorCodesMjs.uiNotAllowed),
    (0, _interactionRequiredAuthErrorCodesMjs.interruptedUser)
];
const InteractionRequiredAuthSubErrorMessage = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token",
    "ui_not_allowed",
    "interrupted_user"
];
/**
 * Error thrown when user interaction is required.
 */ class InteractionRequiredAuthError extends (0, _authErrorMjs.AuthError) {
    constructor(errorCode, correlationId, errorMessage, subError, timestamp, traceId, claims, errorNo){
        super(errorCode, correlationId, errorMessage, subError);
        Object.setPrototypeOf(this, InteractionRequiredAuthError.prototype);
        this.timestamp = timestamp || "";
        this.traceId = traceId || "";
        this.claims = claims || "";
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function isInteractionRequiredError(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && InteractionRequiredServerErrorMessage.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && InteractionRequiredAuthSubErrorMessage.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && InteractionRequiredServerErrorMessage.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function createInteractionRequiredAuthError(errorCode, correlationId, errorMessage) {
    return new InteractionRequiredAuthError(errorCode, correlationId, errorMessage);
}

},{"./AuthError.mjs":"8TWYe","./InteractionRequiredAuthErrorCodes.mjs":"9FSE5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9FSE5":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "badToken", ()=>badToken);
parcelHelpers.export(exports, "consentRequired", ()=>consentRequired);
parcelHelpers.export(exports, "interactionRequired", ()=>interactionRequired);
parcelHelpers.export(exports, "interruptedUser", ()=>interruptedUser);
parcelHelpers.export(exports, "loginRequired", ()=>loginRequired);
parcelHelpers.export(exports, "nativeAccountUnavailable", ()=>nativeAccountUnavailable);
parcelHelpers.export(exports, "noTokensFound", ()=>noTokensFound);
parcelHelpers.export(exports, "refreshTokenExpired", ()=>refreshTokenExpired);
parcelHelpers.export(exports, "uiNotAllowed", ()=>uiNotAllowed);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * MSAL-defined interaction required error code indicating no tokens are found in cache.
 * @public
 */ const noTokensFound = "no_tokens_found";
/**
 * MSAL-defined error code indicating a native account is unavailable on the platform.
 * @public
 */ const nativeAccountUnavailable = "native_account_unavailable";
/**
 * MSAL-defined error code indicating the refresh token has expired and user interaction is needed.
 * @public
 */ const refreshTokenExpired = "refresh_token_expired";
/**
 * MSAL-defined error code indicating UI/UX is not allowed (e.g., blocked by policy), requiring alternate interaction.
 * @public
 */ const uiNotAllowed = "ui_not_allowed";
/**
 * Server-originated error code indicating interaction is required to complete the request.
 * @public
 */ const interactionRequired = "interaction_required";
/**
 * Server-originated error code indicating user consent is required.
 * @public
 */ const consentRequired = "consent_required";
/**
 * Server-originated error code indicating user login is required.
 * @public
 */ const loginRequired = "login_required";
/**
 * Server-originated error code indicating the token is invalid or corrupted.
 * @public
 */ const badToken = "bad_token";
/**
 * Server-originated error code indicating the user is in an interrupted state and interaction is required.
 * @public
 */ const interruptedUser = "interrupted_user";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9bvcp":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "Logger", ()=>Logger);
parcelHelpers.export(exports, "getAndFlushLogsFromCache", ()=>getAndFlushLogsFromCache);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})(LogLevel || (LogLevel = {}));
// Shared cache state for better minification - using Map's insertion order for LRU
const CACHE_CAPACITY = 50;
const MAX_LOGS_PER_CORRELATION = 500;
const correlationCache = new Map();
/**
 * Mark correlation ID as recently used by moving it to end of Map
 * @param correlationId
 * @param {CorrelationLogData} data
 */ function markAsRecentlyUsed(correlationId, data) {
    correlationCache.delete(correlationId);
    correlationCache.set(correlationId, data);
}
/**
 * Add log message to cache for specific correlation ID
 * @param correlationId
 * @param {LoggedMessage} loggedMessage
 */ function addLogToCache(correlationId, loggedMessage) {
    const currentTime = Date.now();
    let data = correlationCache.get(correlationId);
    if (data) // Mark as recently used
    markAsRecentlyUsed(correlationId, data);
    else {
        // Create new entry
        data = {
            logs: [],
            firstEventTime: currentTime
        };
        correlationCache.set(correlationId, data);
        // Remove LRU (first entry) if capacity exceeded
        if (correlationCache.size > CACHE_CAPACITY) {
            const firstKey = correlationCache.keys().next().value;
            if (firstKey !== undefined) correlationCache.delete(firstKey);
        }
    }
    // Add log to the data, maintaining max logs per correlation
    data.logs.push({
        ...loggedMessage,
        milliseconds: currentTime - data.firstEventTime
    });
    if (data.logs.length > MAX_LOGS_PER_CORRELATION) data.logs.shift(); // Remove oldest log
}
/**
 * Get logs for correlation ID and flush them from cache
 * Attaches logs with empty correlation id to the requested correlation logs
 * @param correlationId
 */ function getAndFlushLogsFromCache(correlationId) {
    const res = [];
    for (const id of [
        "",
        correlationId
    ]){
        const data = correlationCache.get(id);
        res.push(...data?.logs ?? []);
        correlationCache.delete(id); // Remove the correlation ID completely from cache
    }
    return res;
}
/**
 * Extracts the leading minification hash from a log message, if present.
 *
 * Minified messages are produced by the logger-minify rollup plugin and are
 * either a bare 6-character alphanumeric hash, or that hash followed by a space
 * and runtime variables appended for local (console) logging, e.g.
 * "abc123 user-1 popup". Only the leading hash is returned so that telemetry
 * never captures the appended variables. Returns null when the message is not
 * a minified message.
 */ function getMessageHash(str) {
    if (str.length < 6) return null;
    /*
     * If the message is longer than the hash, the hash must be delimited by a
     * space (the separator the plugin inserts before appended variables).
     */ if (str.length > 6 && str[6] !== " ") return null;
    for(let i = 0; i < 6; i++){
        const char = str[i];
        const isAlphaNumeric = char >= "a" && char <= "z" || char >= "A" && char <= "Z" || char >= "0" && char <= "9";
        if (!isAlphaNumeric) return null;
    }
    return str.substring(0, 6);
}
/**
 * Class which facilitates logging of messages to a specific place.
 */ class Logger {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = LogLevel.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || Logger.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : LogLevel.Info;
        this.packageName = packageName || "";
        this.packageVersion = packageVersion || "";
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion) {
        return new Logger({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        const correlationId = options.correlationId;
        const messageHash = getMessageHash(logMessage);
        if (messageHash) {
            const loggedMessage = {
                hash: messageHash,
                level: options.logLevel,
                containsPii: options.containsPii || false,
                milliseconds: 0
            };
            addLogToCache(correlationId, loggedMessage);
        }
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${correlationId}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${LogLevel[options.logLevel]} - ${logMessage}`;
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Error,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Error,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Warning,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Warning,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Info,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Info,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Verbose,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Verbose,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Trace,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Trace,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8zD57":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProtocolMode", ()=>ProtocolMode);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const ProtocolMode = {
    /**
     * Auth Code + PKCE with Entra ID (formerly AAD) specific optimizations and features
     */ AAD: "AAD",
    /**
     * Auth Code + PKCE without Entra ID specific optimizations and features. For use only with non-Microsoft owned authorities.
     * Support is limited for this mode.
     */ OIDC: "OIDC",
    /**
     * Encrypted Authorize Response (EAR) with Entra ID specific optimizations and features
     */ EAR: "EAR"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dvxy4":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerError", ()=>ServerError);
var _authErrorMjs = require("./AuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class ServerError extends (0, _authErrorMjs.AuthError) {
    constructor(errorCode, correlationId, errorMessage, subError, errorNo, status){
        super(errorCode, correlationId, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, ServerError.prototype);
    }
}

},{"./AuthError.mjs":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9VScD":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StubPerformanceClient", ()=>StubPerformanceClient);
var _performanceEventMjs = require("./PerformanceEvent.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class StubPerformanceClient {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, _performanceEventMjs.PerformanceEventStatus).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            }
        };
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    addGlobalFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}

},{"./PerformanceEvent.mjs":"1zWJT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1zWJT":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EXT_FIELD_PREFIX", ()=>EXT_FIELD_PREFIX);
parcelHelpers.export(exports, "IntFields", ()=>IntFields);
parcelHelpers.export(exports, "PerformanceEventStatus", ()=>PerformanceEventStatus);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const PerformanceEventStatus = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
/**
 * Prefix used to mark telemetry field names as dynamic.
 * Fields with this prefix in addFields/incrementFields calls will be routed
 * to the PerformanceEvent.ext sub-object.
 */ const EXT_FIELD_PREFIX = "ext.";
const IntFields = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT",
    "unencryptedCacheCount",
    "encryptedCacheExpiredCount",
    "oldAccountCount",
    "oldAccessCount",
    "oldIdCount",
    "oldRefreshCount",
    "currAccountCount",
    "currAccessCount",
    "currIdCount",
    "currRefreshCount",
    "ttlExpiredAcntCount",
    "ttlExpiredITCount",
    "ttlExpiredATCount",
    "ttlExpiredRTCount",
    "decryptFailedAcntCount",
    "decryptFailedITCount",
    "decryptFailedATCount",
    "decryptFailedRTCount",
    "invalidAcntCount",
    "invalidITCount",
    "invalidATCount",
    "invalidRTCount",
    "expiredATCount",
    "expiredRTCount",
    "upgradedCacheCount",
    "cacheMatchedAccounts",
    "networkRtt",
    "redirectBridgeTimeoutMs",
    "redirectBridgeMessageVersion"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ahOhN":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PublicClientApplication", ()=>PublicClientApplication);
parcelHelpers.export(exports, "createNestablePublicClientApplication", ()=>createNestablePublicClientApplication);
parcelHelpers.export(exports, "createStandardPublicClientApplication", ()=>createStandardPublicClientApplication);
var _standardControllerMjs = require("../controllers/StandardController.mjs");
var _standardOperatingContextMjs = require("../operatingcontext/StandardOperatingContext.mjs");
var _nestedAppAuthControllerMjs = require("../controllers/NestedAppAuthController.mjs");
var _nestedAppOperatingContextMjs = require("../operatingcontext/NestedAppOperatingContext.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class PublicClientApplication {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.controller = controller || new (0, _standardControllerMjs.StandardController)(new (0, _standardOperatingContextMjs.StandardOperatingContext)(configuration, {
            waitForPopupResponse: this.waitForPopupResponse.bind(this),
            waitForIframeResponse: this.waitForIframeResponse.bind(this)
        }));
    }
    /**
     * Waits for the auth response from a popup window opened by MSAL.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge.
     * Subclasses must return the raw response string (hash/query/fragment), or reject
     * with an `AuthError` on failure.
     *
     * @internal
     * @param request The in-flight authorization or end-session request.
     * @param popupWindow The popup window opened by MSAL.
     * @param popupWindowParent The parent window that opened the popup.
     */ async waitForPopupResponse(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    popupWindow, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    popupWindowParent) {
        const controller = this.controller;
        return (0, _browserUtilsMjs.waitForBridgeResponse)(controller.getConfiguration().system.popupBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient());
    }
    /**
     * Waits for the auth response from a hidden iframe used by MSAL silent flows.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge.
     * Subclasses must return the raw response string (hash/query/fragment), or reject
     * with an `AuthError` on failure.
     *
     * @internal
     * @param iframe The hidden iframe MSAL attached to the document.
     * @param request The in-flight authorization request.
     */ async waitForIframeResponse(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    iframe, request) {
        const controller = this.controller;
        const config = controller.getConfiguration();
        return (0, _browserUtilsMjs.waitForBridgeResponse)(config.system.iframeBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient(), config.experimental);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(options) {
        return this.controller.handleRedirectPromise(options);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @param correlationId
 * @param pcaFactory
 * @returns IPublicClientApplication
 *
 */ async function createNestablePublicClientApplication(configuration, correlationId, pcaFactory) {
    const nestedAppAuth = new (0, _nestedAppOperatingContextMjs.NestedAppOperatingContext)(configuration);
    await nestedAppAuth.initialize(correlationId);
    if (nestedAppAuth.isAvailable()) {
        const cid = correlationId || (0, _browserCryptoMjs.createNewGuid)();
        const controller = new (0, _nestedAppAuthControllerMjs.NestedAppAuthController)(nestedAppAuth);
        const nestablePCA = pcaFactory ? pcaFactory(configuration, controller) : new PublicClientApplication(configuration, controller);
        await nestablePCA.initialize({
            correlationId: cid
        });
        return nestablePCA;
    }
    return createStandardPublicClientApplication(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function createStandardPublicClientApplication(configuration) {
    const pca = new PublicClientApplication(configuration);
    await pca.initialize();
    return pca;
}

},{"../controllers/StandardController.mjs":"1NwNG","../operatingcontext/StandardOperatingContext.mjs":"eMGN5","../controllers/NestedAppAuthController.mjs":"fxZ9g","../operatingcontext/NestedAppOperatingContext.mjs":"g2g5x","../crypto/BrowserCrypto.mjs":"a5L0H","../utils/BrowserUtils.mjs":"eyRWO","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1NwNG":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardController", ()=>StandardController);
var _cryptoOpsMjs = require("../crypto/CryptoOps.mjs");
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserRootPerformanceEventsMjs = require("../telemetry/BrowserRootPerformanceEvents.mjs");
var _browserCacheManagerMjs = require("../cache/BrowserCacheManager.mjs");
var _cacheKeysMjs = require("../cache/CacheKeys.mjs");
var _accountManagerMjs = require("../cache/AccountManager.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _eventTypeMjs = require("../event/EventType.mjs");
var _eventHandlerMjs = require("../event/EventHandler.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _popupClientMjs = require("../interaction_client/PopupClient.mjs");
var _redirectClientMjs = require("../interaction_client/RedirectClient.mjs");
var _silentIframeClientMjs = require("../interaction_client/SilentIframeClient.mjs");
var _silentRefreshClientMjs = require("../interaction_client/SilentRefreshClient.mjs");
var _platformAuthInteractionClientMjs = require("../interaction_client/PlatformAuthInteractionClient.mjs");
var _nativeAuthErrorMjs = require("../error/NativeAuthError.mjs");
var _silentCacheClientMjs = require("../interaction_client/SilentCacheClient.mjs");
var _silentAuthCodeClientMjs = require("../interaction_client/SilentAuthCodeClient.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _requestHelpersMjs = require("../request/RequestHelpers.mjs");
var _pkceGeneratorMjs = require("../crypto/PkceGenerator.mjs");
var _platformAuthProviderMjs = require("../broker/nativeBroker/PlatformAuthProvider.mjs");
var _msalFrameStatsUtilsMjs = require("../utils/MsalFrameStatsUtils.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function preflightCheck(initialized, performanceEvent, config, request) {
    try {
        (0, _browserUtilsMjs.preflightCheck)(initialized);
        (0, _browser.enforceResourceParameter)(config.auth.isMcp, request);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e, request.account);
        throw e;
    }
}
class StandardController {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, _cryptoOpsMjs.CryptoOps)(this.logger, this.performanceClient) : (0, _browser.DEFAULT_CRYPTO_IMPLEMENTATION);
        this.eventHandler = new (0, _eventHandlerMjs.EventHandler)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, _browserCacheManagerMjs.BrowserCacheManager)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, _browser.buildStaticAuthorityOptions)(this.config.auth)) : (0, _browserCacheManagerMjs.DEFAULT_BROWSER_CACHE_MANAGER)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, _browserConstantsMjs.BrowserCacheLocation).MemoryStorage,
            cacheRetentionDays: 5
        };
        this.nativeInternalStorage = new (0, _browserCacheManagerMjs.BrowserCacheManager)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackStateChange = this.trackStateChange.bind(this);
        // Register listener functions
        this.trackStateChangeWithMeasurement = this.trackStateChangeWithMeasurement.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new StandardController(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackStateChange(correlationId, event) {
        if (!correlationId) return;
        if (event.type === "visibilitychange") {
            this.logger.info("16v6hv", correlationId);
            this.performanceClient.incrementFields({
                visibilityChangeCount: 1
            }, correlationId);
        } else if (event.type === "online") {
            this.logger.info("0zirfd", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        } else if (event.type === "offline") {
            this.logger.info("1xk9ef", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        }
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1f7joy", correlationId);
        if (this.initialized) {
            this.logger.info("061m5x", correlationId);
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("19fvpi", correlationId);
            this.initialized = true;
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).INITIALIZE_END, correlationId);
            return;
        }
        const allowPlatformBroker = this.config.system.allowPlatformBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.InitializeClientApplication), correlationId);
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).INITIALIZE_START, correlationId);
        // Broker applications are initialized twice, so we avoid double-counting it
        this.logMultipleInstances(initMeasurement, correlationId);
        initMeasurement.add({
            isMcp: this.config.auth.isMcp
        });
        await (0, _browser.invokeAsync)(this.browserStorage.initialize.bind(this.browserStorage), (0, _browserPerformanceEventsMjs.InitializeCache), this.logger, this.performanceClient, correlationId)(correlationId);
        if (allowPlatformBroker) try {
            // check if platform authentication is available via DOM or browser extension and create relevant handlers
            this.platformAuthProvider = await (0, _platformAuthProviderMjs.getPlatformAuthProvider)(this.logger, this.performanceClient, correlationId, this.config.system.nativeBrokerHandshakeTimeout, this.config.experimental.allowPlatformBrokerWithDOM);
        } catch (e) {
            this.logger.verbose(e, correlationId);
        }
        if (this.config.cache.cacheLocation === (0, _browserConstantsMjs.BrowserCacheLocation).LocalStorage) this.eventHandler.subscribeCrossTab();
        !this.config.system.navigatePopups && await this.preGeneratePkceCodes(correlationId);
        this.initialized = true;
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).INITIALIZE_END, correlationId);
        initMeasurement.end({
            allowPlatformBroker: allowPlatformBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(options) {
        this.logger.verbose("02l8bm", "");
        // Block token acquisition before initialize has been called
        (0, _browserUtilsMjs.blockAPICallsBeforeInitialize)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = options?.hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(options);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("1wn9kp", "");
            } else this.logger.verbose("0w0gm3", "");
            return response;
        }
        this.logger.verbose("12xi63", "");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(options) {
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("0le6uv", "");
            return null;
        }
        const interactionType = this.browserStorage.getInteractionInProgress()?.type;
        if (interactionType === (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNOUT) {
            this.logger.verbose("1ywcv2", "");
            this.browserStorage.setInteractionInProgress(false);
            return Promise.resolve(null);
        }
        const loggedInAccounts = this.getAllAccounts();
        const platformBrokerRequest = this.browserStorage.getCachedNativeRequest();
        const useNative = platformBrokerRequest && !options?.hash;
        let rootMeasurement;
        let redirectResponse;
        let cachedRedirectRequest;
        try {
            if (useNative && this.platformAuthProvider) {
                const correlationId = platformBrokerRequest?.correlationId || "";
                this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).HANDLE_REDIRECT_START, correlationId, (0, _browserConstantsMjs.InteractionType).Redirect);
                rootMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenRedirect), correlationId);
                this.logger.trace("12v7is", correlationId);
                rootMeasurement.add({
                    isPlatformBrokerRequest: true
                });
                const nativeClient = new (0, _platformAuthInteractionClientMjs.PlatformAuthInteractionClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, _browserConstantsMjs.ApiId).handleRedirectPromise, this.performanceClient, this.platformAuthProvider, platformBrokerRequest.accountId, this.nativeInternalStorage, platformBrokerRequest.correlationId);
                redirectResponse = (0, _browser.invokeAsync)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, _browserPerformanceEventsMjs.HandleNativeRedirectPromiseMeasurement), this.logger, this.performanceClient, rootMeasurement.event.correlationId)();
            } else {
                const [standardRequest, codeVerifier] = this.browserStorage.getCachedRequest("");
                cachedRedirectRequest = standardRequest;
                const correlationId = standardRequest.correlationId;
                this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).HANDLE_REDIRECT_START, correlationId, (0, _browserConstantsMjs.InteractionType).Redirect);
                // Reset rootMeasurement now that we have correlationId
                rootMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenRedirect), correlationId);
                this.logger.trace("0znzs5", correlationId);
                const redirectClient = this.createRedirectClient(correlationId);
                redirectResponse = (0, _browser.invokeAsync)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, _browserPerformanceEventsMjs.HandleRedirectPromiseMeasurement), this.logger, this.performanceClient, rootMeasurement.event.correlationId)(standardRequest, codeVerifier, rootMeasurement, options);
            }
        } catch (e) {
            this.browserStorage.resetRequestCache("");
            throw e;
        }
        return redirectResponse.then((result)=>{
            if (result) {
                this.browserStorage.resetRequestCache(result.correlationId);
                this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, result.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, result);
                this.logger.verbose("0ui8f5", result.correlationId);
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGIN_SUCCESS, result.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, result.account);
                    this.logger.verbose("16im3l", result.correlationId);
                }
                rootMeasurement.end({
                    success: true
                }, undefined, result.account);
                // Fire-and-forget SSO capability verification in background
                this.verifySsoCapability(cachedRedirectRequest, (0, _browserConstantsMjs.InteractionType).Redirect);
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            }, undefined);
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect);
            return result;
        }).catch((e)=>{
            this.browserStorage.resetRequestCache(rootMeasurement.event.correlationId);
            const eventError = e;
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, rootMeasurement.event.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0os66p", correlationId);
        (0, _browserUtilsMjs.redirectPreflightCheck)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNIN);
        const atrMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenPreRedirect), correlationId);
        atrMeasurement.add({
            scenarioId: request.scenarioId
        });
        const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
        this.config.auth.onRedirectNavigate = (url)=>{
            const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
            atrMeasurement.add({
                navigateCallbackResult: navigate !== false
            });
            atrMeasurement.event = atrMeasurement.end({
                success: true
            }, undefined, request.account) || atrMeasurement.event;
            return navigate;
        };
        try {
            (0, _browser.enforceResourceParameter)(this.config.auth.isMcp, request);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START, correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, request);
            let result;
            if (this.platformAuthProvider && this.canUsePlatformBroker(request)) {
                const nativeClient = new (0, _platformAuthInteractionClientMjs.PlatformAuthInteractionClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, _browserConstantsMjs.ApiId).acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = (0, _browser.invokeAsync)(nativeClient.acquireTokenRedirect.bind(nativeClient), (0, _browserPerformanceEventsMjs.NativeInteractionClientAcquireTokenRedirect), this.logger, this.performanceClient, correlationId)(request, atrMeasurement).catch((e)=>{
                    atrMeasurement.add({
                        brokerErrorName: e.name,
                        brokerErrorCode: e.errorCode
                    });
                    if (e instanceof (0, _nativeAuthErrorMjs.NativeAuthError) && (0, _nativeAuthErrorMjs.isFatalNativeAuthError)(e)) {
                        this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, _browser.InteractionRequiredAuthError)) {
                        this.logger.verbose("1ipyz4", correlationId);
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            this.browserStorage.resetRequestCache(correlationId);
            /*
             * Pre-redirect event completes before navigation occurs.
             * Timed out navigation needs to be instrumented separately as a post-redirect event.
             */ if (atrMeasurement.event.status === 2) this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenRedirect), correlationId).end({
                success: false
            }, e, request.account);
            else atrMeasurement.end({
                success: false
            }, e, request.account);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenPopup), correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            this.logger.verbose("0ch87b", correlationId);
            preflightCheck(this.initialized, atPopupMeasurement, this.config, request);
            this.browserStorage.setInteractionInProgress(true, (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNIN, request.overrideInteractionInProgress, correlationId);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, request);
        let result;
        const pkce = this.getPreGeneratedPkceCodes(correlationId);
        if (this.canUsePlatformBroker(request)) {
            atPopupMeasurement.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative({
                ...request,
                correlationId
            }, (0, _browserConstantsMjs.ApiId).acquireTokenPopup).then((response)=>{
                atPopupMeasurement.end({
                    success: true,
                    isNativeBroker: true
                }, undefined, response.account);
                return response;
            }).catch((e)=>{
                atPopupMeasurement.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                if (e instanceof (0, _nativeAuthErrorMjs.NativeAuthError) && (0, _nativeAuthErrorMjs.isFatalNativeAuthError)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                } else if (e instanceof (0, _browser.InteractionRequiredAuthError)) {
                    this.logger.verbose("0yy5fw", correlationId);
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                }
                throw e;
            });
        } else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request, pkce);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, result);
            if (isLoggingIn) this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGIN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, result.account);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            // SSO capability verification in background
            this.verifySsoCapability(request, (0, _browserConstantsMjs.InteractionType).Popup);
            return result;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }).finally(async ()=>{
            this.browserStorage.setInteractionInProgress(false);
            if (!this.config.system.navigatePopups) await this.preGeneratePkceCodes(correlationId);
        });
    }
    trackStateChangeWithMeasurement(event) {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        if (event.type === "visibilitychange") {
            this.logger.info(`0yzimq ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                visibilityChangeCount: 1
            });
        } else if (event.type === "online") {
            this.logger.info(`1caf53 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        } else if (event.type === "offline") {
            this.logger.info(`0fdyk7 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        }
    }
    addStateChangeListeners(listener) {
        document.addEventListener("visibilitychange", listener);
        window.addEventListener("online", listener);
        window.addEventListener("offline", listener);
    }
    removeStateChangeListeners(listener) {
        document.removeEventListener("visibilitychange", listener);
        window.removeEventListener("online", listener);
        window.removeEventListener("offline", listener);
    }
    /**
     * Reads the cached ssoCapable value from localStorage.
     * @returns The cached ssoCapable boolean value, or undefined if not cached or expired.
     */ getCachedSsoCapable() {
        try {
            const cachedValue = window.localStorage.getItem((0, _cacheKeysMjs.SSO_CAPABLE));
            if (cachedValue) {
                const parsed = JSON.parse(cachedValue);
                if (parsed && typeof parsed.ssoCapable === "boolean" && parsed.expiresOn && Date.now() < parsed.expiresOn) return parsed.ssoCapable;
            }
        } catch  {
        // If parsing fails, return undefined
        }
        return undefined;
    }
    /**
     * SSO capability verification in the background.
     * This method makes an iframe request to /authorize to verify SSO capability without calling /token.
     * This method does not block the caller and tracks telemetry for success/failure.
     * This method only executes if verifySSO is set to true in the auth configuration.
     * The result is cached in localStorage with a 24-hour TTL; the SSO verification call
     * is only attempted when the cached value is absent or expired.
     * @param request - The original request used for the authentication flow
     * @param interactionType - The interactionType of the AT operation for logging purposes
     */ verifySsoCapability(request, interactionType) {
        // Check if SSO capability verification is enabled
        if (!this.config.auth.verifySSO) return;
        // Check TTL: derive ssoCapable state from localStorage and skip if not expired
        const ssoCacheKey = (0, _cacheKeysMjs.SSO_CAPABLE);
        const SSO_CAPABLE_TTL_MS = 86400000; // 24 hours
        const cachedSsoCapable = this.getCachedSsoCapable();
        if (cachedSsoCapable !== undefined) {
            this.logger.verbose(`13poou ${interactionType}`, "");
            return;
        }
        const correlationId = (0, _browserCryptoMjs.createNewGuid)();
        const ssoCapableMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.SsoCapable), correlationId);
        ssoCapableMeasurement.add({
            "ext.interactionType": interactionType
        });
        this.logger.verbose(`0pbr0i ${interactionType}`, correlationId);
        /*
         * Use setTimeout to ensure this runs in a separate macrotask after the current call stack completes
         * This ensures the result is returned to the caller before the SSO verification starts and doesn't affect performance
         */ setTimeout(()=>{
            const ssoVerificationRequest = {
                ...request,
                correlationId: correlationId
            };
            const silentIframeClient = this.createSilentIframeClient(correlationId);
            silentIframeClient.verifySso(ssoVerificationRequest).then((result)=>{
                this.logger.verbose(`1gd1iv ${interactionType} ${result}`, correlationId);
                // TBD to add profileTelemetry later in localStorage with 24h TTL
                try {
                    const cacheEntry = JSON.stringify({
                        ssoCapable: result,
                        expiresOn: Date.now() + SSO_CAPABLE_TTL_MS
                    });
                    window.localStorage.setItem(ssoCacheKey, cacheEntry);
                } catch  {
                    this.logger.warning(`18lmoj ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: result
                }, undefined);
            }).catch((error)=>{
                this.logger.warning(`05g83w ${interactionType} ${error.message}`, correlationId);
                // reset the cache
                try {
                    window.localStorage.removeItem(ssoCacheKey);
                } catch  {
                    this.logger.warning(`0nlf9q ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: false
                }, error);
            });
        }, 0);
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.SsoSilent), correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        preflightCheck(this.initialized, this.ssoSilentMeasurement, this.config, validRequest);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const loggedInAccounts = this.getAllAccounts();
        this.logger.verbose("0w1b45", correlationId);
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, validRequest);
        let result;
        if (this.canUsePlatformBroker(validRequest)) {
            this.ssoSilentMeasurement?.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative(validRequest, (0, _browserConstantsMjs.ApiId).ssoSilent).catch((e)=>{
                this.ssoSilentMeasurement?.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                // If native token acquisition fails for availability reasons fallback to standard flow
                if (e instanceof (0, _nativeAuthErrorMjs.NativeAuthError) && (0, _nativeAuthErrorMjs.isFatalNativeAuthError)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    return silentIframeClient.acquireToken(validRequest);
                }
                throw e;
            });
        } else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, response);
            if (isLoggingIn) this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGIN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, response.account);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromPlatformBroker,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length
            }, undefined, response.account);
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw e;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0ch6ga", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenByCode), correlationId);
        preflightCheck(this.initialized, atbcMeasurement, this.config, request);
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.spaCodeAndNativeAccountIdPresent), correlationId);
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("06eh73", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        }, undefined, result.account);
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("0qgp28", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUsePlatformBroker(request, request.nativeAccountId)) {
                    atbcMeasurement.add({
                        isPlatformBrokerRequest: true
                    });
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId
                    }, (0, _browserConstantsMjs.ApiId).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        atbcMeasurement.add({
                            brokerErrorName: e.name,
                            brokerErrorCode: e.errorCode
                        });
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, _nativeAuthErrorMjs.NativeAuthError) && (0, _nativeAuthErrorMjs.isFatalNativeAuthError)(e)) this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        success: true
                    }, undefined, result.account);
                    return result;
                } else throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.unableToAcquireTokenFromNativePlatform), correlationId);
            } else throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.authCodeOrNativeAccountIdRequired), correlationId);
        } catch (e) {
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("10d9hy", correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, _browserPerformanceEventsMjs.AcquireTokenByCodeAsync), correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case (0, _browserConstantsMjs.CacheLookupPolicy).Default:
            case (0, _browserConstantsMjs.CacheLookupPolicy).AccessToken:
            case (0, _browserConstantsMjs.CacheLookupPolicy).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, _browser.invokeAsync)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, _browserPerformanceEventsMjs.SilentCacheClientAcquireToken), this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case (0, _browserConstantsMjs.CacheLookupPolicy).Default:
            case (0, _browserConstantsMjs.CacheLookupPolicy).AccessTokenAndRefreshToken:
            case (0, _browserConstantsMjs.CacheLookupPolicy).RefreshToken:
            case (0, _browserConstantsMjs.CacheLookupPolicy).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, _browser.invokeAsync)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, _browserPerformanceEventsMjs.SilentRefreshClientAcquireToken), this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, _browser.invokeAsync)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, _browserPerformanceEventsMjs.SilentIframeClientAcquireToken), this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, _browserUtilsMjs.redirectPreflightCheck)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNOUT);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, _browserUtilsMjs.preflightCheck)(this.initialized);
            this.browserStorage.setInteractionInProgress(true, (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNOUT);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest).finally(()=>{
                this.browserStorage.setInteractionInProgress(false);
            });
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) return;
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, _accountManagerMjs.getAllAccounts)(this.logger, this.browserStorage, this.isBrowserEnvironment, this.getRequestCorrelationId(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, _accountManagerMjs.getAccount)(accountFilter, this.logger, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        (0, _accountManagerMjs.setActiveAccount)(account, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, _accountManagerMjs.getActiveAccount)(this.browserStorage, this.getRequestCorrelationId());
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, _browser.AccountEntityUtils).createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, _browser.AuthToken).isKmsi(result.idTokenClaims), (0, _browserConstantsMjs.ApiId).hydrateCache);
        if (result.fromPlatformBroker) {
            this.logger.verbose("1i5atf", result.correlationId);
            // Create idToken entity and store in browser storage
            const idTokenEntity = (0, _browser.CacheHelpers).createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.config.auth.clientId, result.tenantId);
            // Create accessToken entity and store in native internal storage
            const accessTokenEntity = (0, _browser.CacheHelpers).createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.config.auth.clientId, result.tenantId, result.scopes.join(" "), result.expiresOn ? (0, _browser.TimeUtils).toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? (0, _browser.TimeUtils).toSecondsFromDate(result.extExpiresOn) : 0, (0, _base64DecodeMjs.base64Decode), request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid);
            if (request.resource) accessTokenEntity.resource = request.resource;
            const kmsi = (0, _browser.AuthToken).isKmsi(result.idTokenClaims);
            // Store idToken in browser storage
            await this.browserStorage.setIdTokenCredential(idTokenEntity, result.correlationId, kmsi);
            // Store accessToken in native internal storage
            await this.nativeInternalStorage.setAccessTokenCredential(accessTokenEntity, result.correlationId, kmsi);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId, cacheLookupPolicy) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0b9y3p", correlationId);
        if (!this.platformAuthProvider) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.nativeConnectionNotEstablished), correlationId);
        const nativeClient = new (0, _platformAuthInteractionClientMjs.PlatformAuthInteractionClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.platformAuthProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
        return (0, _browser.invokeAsync)(nativeClient.acquireToken.bind(nativeClient), (0, _browserPerformanceEventsMjs.NativeInteractionClientAcquireToken), this.logger, this.performanceClient, correlationId)(request, cacheLookupPolicy);
    }
    /**
     * Returns boolean indicating if this request can use the platform broker
     * @param request
     */ canUsePlatformBroker(request, accountId) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1n9lbl", correlationId);
        if (!this.platformAuthProvider) {
            this.logger.trace("0vnu11", correlationId);
            return false;
        }
        if (!(0, _platformAuthProviderMjs.isPlatformAuthAllowed)(this.config, this.logger, correlationId, this.platformAuthProvider, request.authenticationScheme)) {
            this.logger.trace("0yoy1g", correlationId);
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, _browser.Constants).PromptValue.NONE:
            case (0, _browser.Constants).PromptValue.CONSENT:
            case (0, _browser.Constants).PromptValue.LOGIN:
                this.logger.trace("0vdv8e", correlationId);
                break;
            default:
                this.logger.trace(`0pdzw6 ${request.prompt}`, correlationId);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("16lbtk", correlationId);
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || (!request.loginHint && !request.sid ? this.getActiveAccount() : null);
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, _popupClientMjs.PopupClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForPopupResponse);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, _redirectClientMjs.RedirectClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, _silentIframeClientMjs.SilentIframeClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, _browserConstantsMjs.ApiId).ssoSilent, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForIframeResponse);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, _silentCacheClientMjs.SilentCacheClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, _silentRefreshClientMjs.SilentRefreshClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, _silentAuthCodeClientMjs.SilentAuthCodeClient)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, _browserConstantsMjs.ApiId).acquireTokenByCode, this.performanceClient, correlationId, this.platformAuthProvider);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, _browserUtilsMjs.blockNonBrowserEnvironment)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, _browserCryptoMjs.createNewGuid)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return "";
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0lz9hf", correlationId);
        return this.acquireTokenRedirect({
            correlationId,
            ...request || (0, _browserConstantsMjs.DEFAULT_REQUEST)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0qw7v5", correlationId);
        return this.acquireTokenPopup({
            correlationId,
            ...request || (0, _browserConstantsMjs.DEFAULT_REQUEST)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenSilent), correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        preflightCheck(this.initialized, atsMeasurement, this.config, request);
        this.logger.verbose("0x1c4s", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.noAccountError), correlationId);
        return this.acquireTokenSilentDeduped(request, account, correlationId).then((result)=>{
            atsMeasurement.end({
                success: true,
                fromCache: result.fromCache,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            return {
                ...result,
                state: request.state,
                correlationId: correlationId
            };
        }).catch((error)=>{
            if (error instanceof (0, _browser.AuthError)) // Ensures PWB scenarios can correctly match request to response
            error.correlationId = correlationId;
            atsMeasurement.end({
                success: false
            }, error, account);
            throw error;
        });
    }
    /**
     * Checks if identical request is already in flight and returns reference to the existing promise or fires off a new one if this is the first
     * @param request
     * @param account
     * @param correlationId
     * @returns
     */ async acquireTokenSilentDeduped(request, account, correlationId) {
        const thumbprint = (0, _browser.getRequestThumbprint)(this.config.auth.clientId, {
            ...request,
            authority: request.authority || this.config.auth.authority,
            correlationId: correlationId
        }, account.homeAccountId);
        const silentRequestKey = JSON.stringify(thumbprint);
        const inProgressRequest = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof inProgressRequest === "undefined") {
            this.logger.verbose("0fcjbk", correlationId);
            this.performanceClient.addFields({
                deduped: false
            }, correlationId);
            const activeRequest = (0, _browser.invokeAsync)(this.acquireTokenSilentAsync.bind(this), (0, _browserPerformanceEventsMjs.AcquireTokenSilentAsync), this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId
            }, account);
            this.activeSilentTokenRequests.set(silentRequestKey, activeRequest);
            return activeRequest.finally(()=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
            });
        } else {
            this.logger.verbose("1yq7nb", correlationId);
            this.performanceClient.addFields({
                deduped: true
            }, correlationId);
            return inProgressRequest;
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackStateChange = (event)=>this.trackStateChange(request.correlationId, event);
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START, request.correlationId, (0, _browserConstantsMjs.InteractionType).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        }, request.correlationId);
        this.addStateChangeListeners(trackStateChange);
        const silentRequest = await (0, _browser.invokeAsync)((0, _requestHelpersMjs.initializeSilentRequest), (0, _browserPerformanceEventsMjs.InitializeSilentRequest), this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, _browserConstantsMjs.CacheLookupPolicy).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                const silentRefreshReason = `${refreshTokenError.errorCode}${refreshTokenError.subError ? `|${refreshTokenError.subError}` : ""}`;
                this.performanceClient.addFields({
                    silentRefreshReason
                }, request.correlationId);
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("0rh08z", silentRequest.correlationId);
                    return (0, _browser.invokeAsync)(this.acquireTokenBySilentIframe.bind(this), (0, _browserPerformanceEventsMjs.AcquireTokenBySilentIframe), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, _browserConstantsMjs.CacheLookupPolicy).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`1w8fso ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, _browserPerformanceEventsMjs.AwaitConcurrentIframe), silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`0ywzzi ${activeCorrelationId}`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`17y14q ${activeCorrelationId}`, silentRequest.correlationId);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("1bd4p8", silentRequest.correlationId);
                    return (0, _browser.invokeAsync)(this.acquireTokenBySilentIframe.bind(this), (0, _browserPerformanceEventsMjs.AcquireTokenBySilentIframe), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, request.correlationId, (0, _browserConstantsMjs.InteractionType).Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromPlatformBroker
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, request.correlationId, (0, _browserConstantsMjs.InteractionType).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(trackStateChange);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        // if the cache policy is set to access_token only, we should not be hitting the native layer yet
        if ((0, _platformAuthProviderMjs.isPlatformAuthAllowed)(this.config, this.logger, silentRequest.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("0sczo4", silentRequest.correlationId);
            this.performanceClient.addFields({
                isPlatformBrokerRequest: true
            }, silentRequest.correlationId);
            return this.acquireTokenNative(silentRequest, (0, _browserConstantsMjs.ApiId).acquireTokenSilent_silentFlow, silentRequest.account.nativeAccountId, cacheLookupPolicy).catch(async (e)=>{
                this.performanceClient.addFields({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                }, silentRequest.correlationId);
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, _nativeAuthErrorMjs.NativeAuthError) && (0, _nativeAuthErrorMjs.isFatalNativeAuthError)(e)) {
                    this.logger.verbose("07rkmb", silentRequest.correlationId);
                    this.platformAuthProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).tokenRefreshRequired, silentRequest.correlationId);
                }
                throw e;
            });
        } else {
            this.logger.verbose("0ox81t", silentRequest.correlationId);
            // add logs to identify embedded cache retrieval
            if (cacheLookupPolicy === (0, _browserConstantsMjs.CacheLookupPolicy).AccessToken) this.logger.verbose("0fvwxe", silentRequest.correlationId);
            return (0, _browser.invokeAsync)(this.acquireTokenFromCache.bind(this), (0, _browserPerformanceEventsMjs.AcquireTokenFromCache), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, _browserConstantsMjs.CacheLookupPolicy).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_NETWORK_START, silentRequest.correlationId, (0, _browserConstantsMjs.InteractionType).Silent, silentRequest);
                return (0, _browser.invokeAsync)(this.acquireTokenByRefreshToken.bind(this), (0, _browserPerformanceEventsMjs.AcquireTokenByRefreshToken), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
    /**
     * Pre-generates PKCE codes and stores it in local variable
     * @param correlationId
     */ async preGeneratePkceCodes(correlationId) {
        this.logger.verbose("1x6uj6", correlationId);
        this.pkceCode = await (0, _browser.invokeAsync)((0, _pkceGeneratorMjs.generatePkceCodes), (0, _browserPerformanceEventsMjs.GeneratePkceCodes), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        return Promise.resolve();
    }
    /**
     * Provides pre-generated PKCE codes, if any
     * @param correlationId
     */ getPreGeneratedPkceCodes(correlationId) {
        const res = this.pkceCode ? {
            ...this.pkceCode
        } : undefined;
        this.pkceCode = undefined;
        if (res) this.logger.verbose("12js1o", correlationId);
        else this.logger.verbose("1oe9ci", correlationId);
        this.performanceClient.addFields({
            usePreGeneratedPkce: !!res
        }, correlationId);
        return res;
    }
    logMultipleInstances(performanceEvent, correlationId) {
        const clientId = this.config.auth.clientId;
        if (!window) return;
        // @ts-ignore
        window.msal = window.msal || {};
        // @ts-ignore
        window.msal.clientIds = window.msal.clientIds || [];
        // @ts-ignore
        const clientIds = window.msal.clientIds;
        if (clientIds.length > 0) this.logger.verbose("1qtz3l", correlationId);
        // @ts-ignore
        window.msal.clientIds.push(clientId);
        (0, _msalFrameStatsUtilsMjs.collectInstanceStats)(clientId, performanceEvent, this.logger, correlationId);
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, _browser.InteractionRequiredAuthError) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, _browser.InteractionRequiredAuthErrorCodes).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, _browserConstantsMjs.BrowserConstants).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, _browser.ClientAuthErrorCodes).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, _browser.InteractionRequiredAuthErrorCodes).noTokensFound || refreshTokenError.errorCode === (0, _browser.InteractionRequiredAuthErrorCodes).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, _browserConstantsMjs.iFrameRenewalPolicies).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}

},{"../crypto/CryptoOps.mjs":"kQH8V","@azure/msal-common/browser":[["AccountEntityUtils","kwYyZ","*"],["AuthError","8TWYe"],["AuthToken","l1q48","*"],["buildStaticAuthorityOptions","iOR3f"],["CacheHelpers","61GoB","*"],["ClientAuthErrorCodes","8keAa","*"],["Constants","5eRZy","*"],["createClientAuthError","e8Ku4"],["DEFAULT_CRYPTO_IMPLEMENTATION","l3pFH"],["enforceResourceParameter","aeuO6"],["getRequestThumbprint","dg9GN"],["InteractionRequiredAuthError","jiVlC"],["InteractionRequiredAuthErrorCodes","9FSE5","*"],["invokeAsync","4kFBF"],["TimeUtils","6CLZ0","*"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../telemetry/BrowserRootPerformanceEvents.mjs":"cD5vH","../cache/BrowserCacheManager.mjs":"UC4Vw","../cache/CacheKeys.mjs":"gsAy0","../cache/AccountManager.mjs":"21SSU","../utils/BrowserConstants.mjs":"5kHn0","../utils/BrowserUtils.mjs":"eyRWO","../event/EventType.mjs":"gVLUh","../event/EventHandler.mjs":"5hEJZ","../encode/Base64Decode.mjs":"evkpn","../interaction_client/PopupClient.mjs":"kRkU6","../interaction_client/RedirectClient.mjs":"pMbft","../interaction_client/SilentIframeClient.mjs":"4f0mG","../interaction_client/SilentRefreshClient.mjs":"khMrN","../interaction_client/PlatformAuthInteractionClient.mjs":"9OO2K","../error/NativeAuthError.mjs":"iAojo","../interaction_client/SilentCacheClient.mjs":"fRXRu","../interaction_client/SilentAuthCodeClient.mjs":"46Kmi","../error/BrowserAuthError.mjs":"k9YIy","../crypto/BrowserCrypto.mjs":"a5L0H","../request/RequestHelpers.mjs":"dxJze","../crypto/PkceGenerator.mjs":"dJjs5","../broker/nativeBroker/PlatformAuthProvider.mjs":"80VhX","../utils/MsalFrameStatsUtils.mjs":"c8njp","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kQH8V":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CryptoOps", ()=>CryptoOps);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _base64EncodeMjs = require("../encode/Base64Encode.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _browserCryptoMjs = require("./BrowserCrypto.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _asyncMemoryStorageMjs = require("../cache/AsyncMemoryStorage.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class CryptoOps {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, _browserCryptoMjs.validateCryptoAvailable)(skipValidateSubtleCrypto ?? false);
        this.cache = new (0, _asyncMemoryStorageMjs.AsyncMemoryStorage)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, _browserCryptoMjs.createNewGuid)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, _base64EncodeMjs.base64Encode)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, _base64DecodeMjs.base64Decode)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, _base64EncodeMjs.urlEncode)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, _browserPerformanceEventsMjs.CryptoOptsGetPublicKeyThumbprint), request.correlationId);
        // Generate Keypair
        const keyPair = await (0, _browserCryptoMjs.generateKeyPair)(CryptoOps.EXTRACTABLE, CryptoOps.POP_KEY_USAGES, (0, _browserCryptoMjs.RSA_KEYGEN_ALGORITHM_OPTIONS));
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, _browserCryptoMjs.exportJwk)(keyPair.publicKey);
        const publicJwkHash = await (0, _browserCryptoMjs.computeJwkThumbprint)(publicKeyJwk);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, _browserCryptoMjs.exportJwk)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, _browserCryptoMjs.importJwk)(privateKeyJwk, false, [
            "sign"
        ], (0, _browserCryptoMjs.RSA_KEYGEN_ALGORITHM_OPTIONS));
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        }, request.correlationId);
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     * @param correlationId
     */ async removeTokenBindingKey(kid, correlationId) {
        await this.cache.removeItem(kid, correlationId);
        const keyFound = await this.cache.containsKey(kid, correlationId);
        if (keyFound) throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).bindingKeyNotRemoved, correlationId);
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     * @param correlationId
     */ async clearKeystore(correlationId) {
        // Delete in-memory keystores
        this.cache.clearInMemory(correlationId);
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent(correlationId);
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`1owpn8 ${e.message}`, correlationId);
            else this.logger.error("0yrmwo", correlationId);
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, _browserPerformanceEventsMjs.CryptoOptsSignJwt), correlationId);
        const cachedKeyPair = await this.cache.getItem(kid, correlationId || "");
        if (!cachedKeyPair) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.cryptoKeyNotFound), correlationId || "");
        // Get public key as JWK
        const publicKeyJwk = await (0, _browserCryptoMjs.exportJwk)(cachedKeyPair.publicKey);
        const publicKeyJwkString = getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, _base64EncodeMjs.urlEncode)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, _browser.JoseHeader).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, _base64EncodeMjs.urlEncode)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, _base64EncodeMjs.urlEncode)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, _browserCryptoMjs.sign)(cachedKeyPair.privateKey, tokenBuffer, (0, _browserCryptoMjs.RSA_SIGN_ALGORITHM_OPTIONS));
        const encodedSignature = (0, _base64EncodeMjs.urlEncodeArr)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, _browserCryptoMjs.hashString)(plainText);
    }
}
CryptoOps.POP_KEY_USAGES = [
    "sign",
    "verify"
];
CryptoOps.EXTRACTABLE = true;
function getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}

},{"@azure/msal-common/browser":[["ClientAuthErrorCodes","8keAa","*"],["createClientAuthError","e8Ku4"],["JoseHeader","6NwJV"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../encode/Base64Encode.mjs":"b1HK9","../encode/Base64Decode.mjs":"evkpn","./BrowserCrypto.mjs":"a5L0H","../error/BrowserAuthError.mjs":"k9YIy","../cache/AsyncMemoryStorage.mjs":"eyuMS","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6NwJV":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JoseHeader", ()=>JoseHeader);
var _joseHeaderErrorMjs = require("../error/JoseHeaderError.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _joseHeaderErrorCodesMjs = require("../error/JoseHeaderErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class JoseHeader {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, _joseHeaderErrorMjs.createJoseHeaderError)((0, _joseHeaderErrorCodesMjs.missingKidError), "");
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, _joseHeaderErrorMjs.createJoseHeaderError)((0, _joseHeaderErrorCodesMjs.missingAlgError), "");
        const shrHeader = new JoseHeader({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, _constantsMjs.JsonWebTokenTypes).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}

},{"../error/JoseHeaderError.mjs":"kum9e","../utils/Constants.mjs":"5eRZy","../error/JoseHeaderErrorCodes.mjs":"2vtQH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kum9e":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JoseHeaderError", ()=>JoseHeaderError);
parcelHelpers.export(exports, "createJoseHeaderError", ()=>createJoseHeaderError);
var _authErrorMjs = require("./AuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class JoseHeaderError extends (0, _authErrorMjs.AuthError) {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, JoseHeaderError.prototype);
    }
}
/** Returns JoseHeaderError object */ function createJoseHeaderError(code, correlationId) {
    return new JoseHeaderError(code, correlationId);
}

},{"./AuthError.mjs":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2vtQH":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "missingAlgError", ()=>missingAlgError);
parcelHelpers.export(exports, "missingKidError", ()=>missingKidError);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const missingKidError = "missing_kid_error";
const missingAlgError = "missing_alg_error";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eyuMS":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncMemoryStorage", ()=>AsyncMemoryStorage);
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _databaseStorageMjs = require("./DatabaseStorage.mjs");
var _memoryStorageMjs = require("./MemoryStorage.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class AsyncMemoryStorage {
    constructor(logger){
        this.inMemoryCache = new (0, _memoryStorageMjs.MemoryStorage)();
        this.indexedDBCache = new (0, _databaseStorageMjs.DatabaseStorage)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error, correlationId) {
        if (error instanceof (0, _browserAuthErrorMjs.BrowserAuthError) && error.errorCode === (0, _browserAuthErrorCodesMjs.databaseUnavailable)) this.logger.error("1wx7zz", correlationId);
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     * @param correlationId
     */ async getItem(key, correlationId) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("0naxpl", correlationId);
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     * @param correlationId
     */ async setItem(key, value, correlationId) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     * @param correlationId
     */ async removeItem(key, correlationId) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     * @param correlationId
     */ async getKeys(correlationId) {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("1iqrbq", correlationId);
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     * @param correlationId
     */ async containsKey(key, correlationId) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("03zl2j", correlationId);
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     * @param correlationId
     */ clearInMemory(correlationId) {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose("03r21p", correlationId);
        this.inMemoryCache.clear();
        this.logger.verbose("0uksk1", correlationId);
    }
    /**
     * Tries to delete the IndexedDB database
     * @param correlationId
     * @returns
     */ async clearPersistent(correlationId) {
        try {
            this.logger.verbose("0rdqut", correlationId);
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("149ouc", correlationId);
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
            return false;
        }
    }
}

},{"../error/BrowserAuthError.mjs":"k9YIy","./DatabaseStorage.mjs":"hM8K0","./MemoryStorage.mjs":"a1m3z","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hM8K0":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatabaseStorage", ()=>DatabaseStorage);
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class DatabaseStorage {
    constructor(){
        this.dbName = (0, _browserConstantsMjs.DB_NAME);
        this.version = (0, _browserConstantsMjs.DB_VERSION);
        this.tableName = (0, _browserConstantsMjs.DB_TABLE_NAME);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.databaseUnavailable), "")));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.databaseNotOpen), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.databaseNotOpen), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.databaseNotOpen), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.databaseNotOpen), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.databaseNotOpen), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, _browserConstantsMjs.DB_NAME));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}

},{"../error/BrowserAuthError.mjs":"k9YIy","../utils/BrowserConstants.mjs":"5kHn0","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"a1m3z":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", ()=>MemoryStorage);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class MemoryStorage {
    constructor(){
        this.cache = new Map();
    }
    async initialize() {
    // Memory storage does not require initialization
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
    decryptData() {
        // Memory storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kwYyZ":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAccountEntity", ()=>createAccountEntity);
parcelHelpers.export(exports, "createAccountEntityFromAccountInfo", ()=>createAccountEntityFromAccountInfo);
parcelHelpers.export(exports, "generateAccountId", ()=>generateAccountId);
parcelHelpers.export(exports, "generateHomeAccountId", ()=>generateHomeAccountId);
parcelHelpers.export(exports, "getAccountInfo", ()=>getAccountInfo);
parcelHelpers.export(exports, "isAccountEntity", ()=>isAccountEntity);
parcelHelpers.export(exports, "isSingleTenant", ()=>isSingleTenant);
var _constantsMjs = require("../../utils/Constants.mjs");
var _clientInfoMjs = require("../../account/ClientInfo.mjs");
var _accountInfoMjs = require("../../account/AccountInfo.mjs");
var _clientAuthErrorMjs = require("../../error/ClientAuthError.mjs");
var _authorityTypeMjs = require("../../authority/AuthorityType.mjs");
var _tokenClaimsMjs = require("../../account/TokenClaims.mjs");
var _protocolModeMjs = require("../../authority/ProtocolMode.mjs");
var _clientAuthErrorCodesMjs = require("../../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Generate Account Id key component as per the schema: <home_account_id>-<environment>
 * @internal
 */ function generateAccountId(accountEntity) {
    const accountId = [
        accountEntity.homeAccountId,
        accountEntity.environment
    ];
    return accountId.join((0, _constantsMjs.CACHE_KEY_SEPARATOR)).toLowerCase();
}
/**
 * Returns the AccountInfo interface for this account.
 * @internal
 */ function getAccountInfo(accountEntity) {
    const tenantProfiles = accountEntity.tenantProfiles || [];
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountEntity.realm && accountEntity.localAccountId) tenantProfiles.push((0, _accountInfoMjs.buildTenantProfile)(accountEntity.homeAccountId, accountEntity.localAccountId, accountEntity.realm, accountEntity.nativeAccountId));
    // Resolve nativeAccountId from the home tenant profile first, fall back to top-level (deprecated) for old cache entries
    const homeTenantProfile = tenantProfiles.find((tp)=>tp.tenantId === accountEntity.realm);
    const nativeAccountId = homeTenantProfile?.nativeAccountId || accountEntity.nativeAccountId;
    return {
        homeAccountId: accountEntity.homeAccountId,
        environment: accountEntity.environment,
        tenantId: accountEntity.realm,
        username: accountEntity.username,
        localAccountId: accountEntity.localAccountId,
        loginHint: accountEntity.loginHint,
        name: accountEntity.name,
        nativeAccountId: nativeAccountId,
        authorityType: accountEntity.authorityType,
        // Deserialize tenant profiles array into a Map
        tenantProfiles: new Map(tenantProfiles.map((tenantProfile)=>{
            return [
                tenantProfile.tenantId,
                tenantProfile
            ];
        })),
        dataBoundary: accountEntity.dataBoundary
    };
}
/**
 * Returns true if the account entity is in single tenant format (outdated), false otherwise
 * @internal
 */ function isSingleTenant(accountEntity) {
    return !accountEntity.tenantProfiles;
}
/**
 * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
 * @param accountDetails
 * @internal
 */ function createAccountEntity(accountDetails, authority, correlationId, base64Decode) {
    let authorityType;
    if (authority.authorityType === (0, _authorityTypeMjs.AuthorityType).Adfs) authorityType = (0, _constantsMjs.CACHE_ACCOUNT_TYPE_ADFS);
    else if (authority.protocolMode === (0, _protocolModeMjs.ProtocolMode).OIDC) authorityType = (0, _constantsMjs.CACHE_ACCOUNT_TYPE_GENERIC);
    else authorityType = (0, _constantsMjs.CACHE_ACCOUNT_TYPE_MSSTS);
    let clientInfo;
    let dataBoundary;
    if (accountDetails.clientInfo && base64Decode) {
        clientInfo = (0, _clientInfoMjs.buildClientInfo)(accountDetails.clientInfo, base64Decode);
        if (clientInfo.xms_tdbr) dataBoundary = clientInfo.xms_tdbr === "EU" ? "EU" : "None";
    }
    const env = accountDetails.environment || authority && authority.getPreferredCache();
    if (!env) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.invalidCacheEnvironment), correlationId);
    /*
     * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
     * In most cases it will contain a single email. This field should not be relied upon if a custom
     * policy is configured to return more than 1 email.
     */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
    const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
    const username = preferredUsername || email || "";
    const loginHint = accountDetails.idTokenClaims?.login_hint;
    const realm = clientInfo?.utid || (0, _tokenClaimsMjs.getTenantIdFromIdTokenClaims)(accountDetails.idTokenClaims) || ""; // non-AAD scenarios can have empty realm
    // How do you account for MSA CID here?
    const localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
    let tenantProfiles;
    if (accountDetails.tenantProfiles) tenantProfiles = accountDetails.tenantProfiles;
    else {
        const tenantProfile = (0, _accountInfoMjs.buildTenantProfile)(accountDetails.homeAccountId, localAccountId, realm, accountDetails.nativeAccountId, accountDetails.idTokenClaims);
        tenantProfiles = [
            tenantProfile
        ];
    }
    return {
        homeAccountId: accountDetails.homeAccountId,
        environment: env,
        realm: realm,
        localAccountId: localAccountId,
        username: username,
        authorityType: authorityType,
        loginHint: loginHint,
        clientInfo: accountDetails.clientInfo,
        name: accountDetails.idTokenClaims?.name || "",
        lastModificationTime: undefined,
        lastModificationApp: undefined,
        cloudGraphHostName: accountDetails.cloudGraphHostName,
        msGraphHost: accountDetails.msGraphHost,
        nativeAccountId: accountDetails.nativeAccountId,
        tenantProfiles: tenantProfiles,
        dataBoundary
    };
}
/**
 * Creates an AccountEntity object from AccountInfo
 * @param accountInfo
 * @param cloudGraphHostName
 * @param msGraphHost
 * @returns
 * @internal
 */ function createAccountEntityFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
    // Serialize tenant profiles map into an array
    const tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountInfo.tenantId && accountInfo.localAccountId) tenantProfiles.push((0, _accountInfoMjs.buildTenantProfile)(accountInfo.homeAccountId, accountInfo.localAccountId, accountInfo.tenantId, accountInfo.nativeAccountId, accountInfo.idTokenClaims));
    else if (accountInfo.nativeAccountId) {
        // Ensure nativeAccountId is set on the matching tenant profile
        const matchingProfile = tenantProfiles.find((tp)=>tp.tenantId === accountInfo.tenantId);
        if (matchingProfile && !matchingProfile.nativeAccountId) matchingProfile.nativeAccountId = accountInfo.nativeAccountId;
    }
    return {
        authorityType: accountInfo.authorityType || (0, _constantsMjs.CACHE_ACCOUNT_TYPE_GENERIC),
        homeAccountId: accountInfo.homeAccountId,
        localAccountId: accountInfo.localAccountId,
        nativeAccountId: accountInfo.nativeAccountId,
        realm: accountInfo.tenantId,
        environment: accountInfo.environment,
        username: accountInfo.username,
        loginHint: accountInfo.loginHint,
        name: accountInfo.name,
        cloudGraphHostName: cloudGraphHostName,
        msGraphHost: msGraphHost,
        tenantProfiles: tenantProfiles,
        dataBoundary: accountInfo.dataBoundary
    };
}
/**
 * Generate HomeAccountId from server response
 * @param serverClientInfo
 * @param authType
 */ function generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, correlationId, idTokenClaims) {
    // since ADFS/DSTS do not have tid and does not set client_info
    if (!(authType === (0, _authorityTypeMjs.AuthorityType).Adfs || authType === (0, _authorityTypeMjs.AuthorityType).Dsts)) {
        // for cases where there is clientInfo
        if (serverClientInfo) try {
            const clientInfo = (0, _clientInfoMjs.buildClientInfo)(serverClientInfo, cryptoObj.base64Decode);
            if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
        } catch (e) {}
        logger.warning("1ub6wv", correlationId);
    }
    // default to "sub" claim
    return idTokenClaims?.sub || "";
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 * @internal
 */ function isAccountEntity(entity) {
    if (!entity) return false;
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
}

},{"../../utils/Constants.mjs":"5eRZy","../../account/ClientInfo.mjs":"98dT9","../../account/AccountInfo.mjs":"glI6y","../../error/ClientAuthError.mjs":"e8Ku4","../../authority/AuthorityType.mjs":"g1AZM","../../account/TokenClaims.mjs":"dKH9k","../../authority/ProtocolMode.mjs":"8zD57","../../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"98dT9":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildClientInfo", ()=>buildClientInfo);
parcelHelpers.export(exports, "buildClientInfoFromHomeAccountId", ()=>buildClientInfoFromHomeAccountId);
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function buildClientInfo(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.clientInfoEmptyError), "");
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.clientInfoDecodingError), "");
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function buildClientInfoFromHomeAccountId(homeAccountId) {
    if (!homeAccountId) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.clientInfoDecodingError), "");
    const clientInfoParts = homeAccountId.split((0, _constantsMjs.CLIENT_INFO_SEPARATOR), 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? "" : clientInfoParts[1]
    };
}

},{"../error/ClientAuthError.mjs":"e8Ku4","../utils/Constants.mjs":"5eRZy","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"glI6y":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTenantProfile", ()=>buildTenantProfile);
parcelHelpers.export(exports, "tenantIdMatchesHomeTenant", ()=>tenantIdMatchesHomeTenant);
parcelHelpers.export(exports, "updateAccountTenantProfileData", ()=>updateAccountTenantProfileData);
var _authTokenMjs = require("./AuthToken.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function tenantIdMatchesHomeTenant(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param nativeAccountId - Native account identifier for this tenant
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function buildTenantProfile(homeAccountId, localAccountId, tenantId, nativeAccountId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid, sub, tid, name, tfp, acr, preferred_username, upn, login_hint } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            username: preferred_username || upn || "",
            loginHint: login_hint,
            isHomeTenant: tenantIdMatchesHomeTenant(tenantId, homeAccountId),
            upn: upn,
            ...nativeAccountId && {
                nativeAccountId
            }
        };
    } else return {
        tenantId,
        localAccountId,
        username: "",
        isHomeTenant: tenantIdMatchesHomeTenant(tenantId, homeAccountId),
        ...nativeAccountId && {
            nativeAccountId
        }
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function updateAccountTenantProfileData(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant which is a utility property of tenant profile but not required in base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant, ...claimsSourcedTenantProfile } = buildTenantProfile(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, updatedAccountInfo.nativeAccountId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret,
            kmsi: (0, _authTokenMjs.isKmsi)(idTokenClaims)
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}

},{"./AuthToken.mjs":"l1q48","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"l1q48":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractTokenClaims", ()=>extractTokenClaims);
parcelHelpers.export(exports, "getJWSPayload", ()=>getJWSPayload);
parcelHelpers.export(exports, "isKmsi", ()=>isKmsi);
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function extractTokenClaims(encodedToken, base64Decode, correlationId) {
    const jswPayload = getJWSPayload(encodedToken, correlationId);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.tokenParsingError), correlationId);
    }
}
/**
 * Check if the signin_state claim contains "kmsi"
 * @param idTokenClaims
 * @returns
 */ function isKmsi(idTokenClaims) {
    if (!idTokenClaims.signin_state) return false;
    /**
     * Signin_state claim known values:
     * dvc_mngd - device is managed
     * dvc_dmjd - device is domain joined
     * kmsi - user opted to "keep me signed in"
     * inknownntwk - Request made inside a known network. Don't use this, use CAE instead.
     */ const kmsiClaims = [
        "kmsi",
        "dvc_dmjd"
    ]; // There are some cases where kmsi may not be returned but persistent storage is still OK - allow dvc_dmjd as well
    return idTokenClaims.signin_state.some((value)=>kmsiClaims.includes(value.trim().toLowerCase()));
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function getJWSPayload(authToken, correlationId) {
    if (!authToken) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.nullOrEmptyToken), correlationId);
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.tokenParsingError), correlationId);
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}

},{"../error/ClientAuthError.mjs":"e8Ku4","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"g1AZM":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthorityType", ()=>AuthorityType);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const AuthorityType = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dKH9k":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTenantIdFromIdTokenClaims", ()=>getTenantIdFromIdTokenClaims);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function getTenantIdFromIdTokenClaims(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iOR3f":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Authority", ()=>Authority);
parcelHelpers.export(exports, "buildStaticAuthorityOptions", ()=>buildStaticAuthorityOptions);
parcelHelpers.export(exports, "formatAuthorityUri", ()=>formatAuthorityUri);
parcelHelpers.export(exports, "getTenantFromAuthorityString", ()=>getTenantFromAuthorityString);
var _authorityTypeMjs = require("./AuthorityType.mjs");
var _openIdConfigResponseMjs = require("./OpenIdConfigResponse.mjs");
var _urlStringMjs = require("../url/UrlString.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _authorityMetadataMjs = require("./AuthorityMetadata.mjs");
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _protocolModeMjs = require("./ProtocolMode.mjs");
var _authorityOptionsMjs = require("./AuthorityOptions.mjs");
var _cloudInstanceDiscoveryResponseMjs = require("./CloudInstanceDiscoveryResponse.mjs");
var _cloudInstanceDiscoveryErrorResponseMjs = require("./CloudInstanceDiscoveryErrorResponse.mjs");
var _regionDiscoveryMjs = require("./RegionDiscovery.mjs");
var _authErrorMjs = require("../error/AuthError.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
var _cacheHelpersMjs = require("../cache/utils/CacheHelpers.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class Authority {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, _regionDiscoveryMjs.RegionDiscovery)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType:type}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, _constantsMjs.CIAM_AUTH_URL))) return (0, _authorityTypeMjs.AuthorityType).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case 0, _constantsMjs.ADFS:
                return (0, _authorityTypeMjs.AuthorityType).Adfs;
            case 0, _constantsMjs.DSTS:
                return (0, _authorityTypeMjs.AuthorityType).Dsts;
        }
        return (0, _authorityTypeMjs.AuthorityType).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, _urlStringMjs.UrlString)(url, this.correlationId);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), this.correlationId);
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), this.correlationId);
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), this.correlationId);
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endSessionEndpointNotSupported), this.correlationId);
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), this.correlationId);
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), this.correlationId);
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), this.correlationId);
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !Authority.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, _authorityTypeMjs.AuthorityType).Default && this.protocolMode !== (0, _protocolModeMjs.ProtocolMode).OIDC;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, _urlStringMjs.UrlString)(this.metadata.canonical_authority, this.correlationId);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, _urlStringMjs.UrlString)(this.metadata.authorization_endpoint, this.correlationId).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`1q3g2x ${cachedPart} ${tenantId}`, this.correlationId);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, _authorityTypeMjs.AuthorityType).Adfs || this.protocolMode === (0, _protocolModeMjs.ProtocolMode).OIDC && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, _functionWrappersMjs.invokeAsync)(this.updateCloudDiscoveryMetadata.bind(this), (0, _performanceEventsMjs.AuthorityUpdateCloudDiscoveryMetadata), this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, _functionWrappersMjs.invokeAsync)(this.updateEndpointMetadata.bind(this), (0, _performanceEventsMjs.AuthorityUpdateEndpointMetadata), this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwise returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort, this.correlationId);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, _cacheHelpersMjs.generateAuthorityMetadataExpiresAt)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, _constantsMjs.AuthorityMetadataSource).CACHE && endpointMetadataResult?.source !== (0, _constantsMjs.AuthorityMetadataSource).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, _cacheHelpersMjs.generateAuthorityMetadataExpiresAt)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache, this.correlationId);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity, this.correlationId);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, _constantsMjs.AuthorityMetadataSource).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, _functionWrappersMjs.invokeAsync)(this.updateMetadataWithRegionalInformation.bind(this), (0, _performanceEventsMjs.AuthorityUpdateMetadataWithRegionalInformation), this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, _cacheHelpersMjs.updateAuthorityEndpointMetadata)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, _functionWrappersMjs.invokeAsync)(this.getEndpointMetadataFromNetwork.bind(this), (0, _performanceEventsMjs.AuthorityGetEndpointMetadataFromNetwork), this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // Validate the issuer returned by the OIDC discovery document.
            this.validateIssuer(metadata.issuer);
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, _functionWrappersMjs.invokeAsync)(this.updateMetadataWithRegionalInformation.bind(this), (0, _performanceEventsMjs.AuthorityUpdateMetadataWithRegionalInformation), this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, _cacheHelpersMjs.updateAuthorityEndpointMetadata)(metadataEntity, metadata, true);
            return (0, _constantsMjs.AuthorityMetadataSource).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.openIdConfigError), this.defaultOpenIdConfigurationEndpoint, this.correlationId);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("1fi0kc", this.correlationId);
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("06t0uj", this.correlationId);
            (0, _cacheHelpersMjs.updateAuthorityEndpointMetadata)(metadataEntity, configMetadata, false);
            return {
                source: (0, _constantsMjs.AuthorityMetadataSource).CONFIG
            };
        }
        this.logger.verbose("151k0p", this.correlationId);
        const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
        if (hardcodedMetadata) {
            (0, _cacheHelpersMjs.updateAuthorityEndpointMetadata)(metadataEntity, hardcodedMetadata, false);
            return {
                source: (0, _constantsMjs.AuthorityMetadataSource).HARDCODED_VALUES,
                metadata: hardcodedMetadata
            };
        } else this.logger.verbose("1imop5", this.correlationId);
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, _cacheHelpersMjs.isAuthorityMetadataExpired)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("16uq31", "");
            return {
                source: (0, _constantsMjs.AuthorityMetadataSource).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("0uoibc", "");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, _urlStringMjs.UrlString)(metadataEntity.canonical_authority, this.correlationId);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.invalidAuthorityMetadata), this.correlationId);
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`1y65x6 ${openIdConfigurationEndpoint}`, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, _openIdConfigResponseMjs.isOpenIdConfigResponse)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose("1koyv8", this.correlationId);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`0a9wik ${e}`, this.correlationId);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, _authorityMetadataMjs.EndpointMetadata)) return (0, _authorityMetadataMjs.EndpointMetadata)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, _constantsMjs.AZURE_REGION_AUTO_DISCOVER_FLAG)) {
                this.regionDiscoveryMetadata.region_outcome = (0, _constantsMjs.RegionDiscoveryOutcomes).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return Authority.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion, this.correlationId);
            }
            const autodetectedRegionName = await (0, _functionWrappersMjs.invokeAsync)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, _performanceEventsMjs.RegionDiscoveryDetectRegion), this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, _constantsMjs.RegionDiscoveryOutcomes).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return Authority.replaceWithRegionalInformation(metadata, autodetectedRegionName, this.correlationId);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, _constantsMjs.RegionDiscoveryOutcomes).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, _functionWrappersMjs.invokeAsync)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, _performanceEventsMjs.AuthorityGetCloudDiscoveryMetadataFromNetwork), this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, _cacheHelpersMjs.updateCloudDiscoveryMetadata)(metadataEntity, metadata, true);
            return (0, _constantsMjs.AuthorityMetadataSource).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.untrustedAuthority), this.correlationId);
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("1tpqlr", this.correlationId);
        this.logger.verbosePii(`1fy7uz ${this.authorityOptions.knownAuthorities || (0, _constantsMjs.NOT_APPLICABLE)}`, this.correlationId);
        this.logger.verbosePii(`08zabj ${this.authorityOptions.authorityMetadata || (0, _constantsMjs.NOT_APPLICABLE)}`, this.correlationId);
        this.logger.verbosePii(`1o1kv3 ${metadataEntity.canonical_authority || (0, _constantsMjs.NOT_APPLICABLE)}`, this.correlationId);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("1nakio", this.correlationId);
            (0, _cacheHelpersMjs.updateCloudDiscoveryMetadata)(metadataEntity, metadata, false);
            return (0, _constantsMjs.AuthorityMetadataSource).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("1x74aj", this.correlationId);
        const hardcodedMetadata = (0, _authorityMetadataMjs.getCloudDiscoveryMetadataFromHardcodedValues)(this.hostnameAndPort);
        if (hardcodedMetadata) {
            this.logger.verbose("0by47c", this.correlationId);
            (0, _cacheHelpersMjs.updateCloudDiscoveryMetadata)(metadataEntity, hardcodedMetadata, false);
            return (0, _constantsMjs.AuthorityMetadataSource).HARDCODED_VALUES;
        }
        this.logger.verbose("0r2fzy", this.correlationId);
        const metadataEntityExpired = (0, _cacheHelpersMjs.isAuthorityMetadataExpired)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("1uffgh", "");
            // No need to update
            return (0, _constantsMjs.AuthorityMetadataSource).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("0uoibc", "");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, _authorityTypeMjs.AuthorityType).Ciam) {
            this.logger.verbose("04y84h", this.correlationId);
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("0gszr3", this.correlationId);
            try {
                this.logger.verbose("1iifkx", this.correlationId);
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, _authorityMetadataMjs.getCloudDiscoveryMetadataFromNetworkResponse)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("0q67e3", "");
                if (metadata) {
                    this.logger.verbose("0hzfao", this.correlationId);
                    return metadata;
                } else this.logger.verbose("1ajz3u", this.correlationId);
            } catch (e) {
                this.logger.verbose("1wq5tu", this.correlationId);
                throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.invalidCloudDiscoveryMetadata), this.correlationId);
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities(this.hostnameAndPort)) {
            this.logger.verbose("0mt9al", this.correlationId);
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        const instanceDiscoveryEndpoint = `${(0, _constantsMjs.AAD_INSTANCE_DISCOVERY_ENDPT)}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, _cloudInstanceDiscoveryResponseMjs.isCloudInstanceDiscoveryResponse)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`1vglyt ${typedResponseBody.tenant_discovery_endpoint}`, this.correlationId);
            } else if ((0, _cloudInstanceDiscoveryErrorResponseMjs.isCloudInstanceDiscoveryErrorResponse)(response.body)) {
                this.logger.warning(`062uto ${response.status}`, this.correlationId);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, _constantsMjs.INVALID_INSTANCE)) {
                    this.logger.error("1x90tm", this.correlationId);
                    return null;
                }
                this.logger.warning(`0wchdm ${typedResponseBody.error}`, this.correlationId);
                this.logger.warning(`1s5mpv ${typedResponseBody.error_description}`, this.correlationId);
                this.logger.warning("1yhqpw", this.correlationId);
                metadata = [];
            } else {
                this.logger.error("0768g0", this.correlationId);
                return null;
            }
            this.logger.verbose("1lrobr", this.correlationId);
            match = (0, _authorityMetadataMjs.getCloudDiscoveryMetadataFromNetworkResponse)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, _authErrorMjs.AuthError)) this.logger.error(`0vwhc7 ${error.errorCode} ${error.errorMessage}`, this.correlationId);
            else {
                const typedError = error;
                this.logger.error(`0s2z41 ${typedError.name} ${typedError.message}`, this.correlationId);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("0jp28q", this.correlationId);
            this.logger.verbose("130sd8", this.correlationId);
            match = Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if a host is included in the knownAuthorities config option.
     */ isInKnownAuthorities(host) {
        const normalizedHost = host.toLowerCase();
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, _urlStringMjs.UrlString).getDomainFromUrl(authority, this.correlationId).toLowerCase() === normalizedHost;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, _authorityOptionsMjs.AzureCloudInstance).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, _constantsMjs.DEFAULT_COMMON_TENANT);
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return 0, _constantsMjs.DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), this.correlationId);
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, _authorityMetadataMjs.InstanceDiscoveryMetadataAliases).has(host);
    }
    /**
     * Validates the `issuer` returned by an OIDC discovery document against
     * this authority, per
     * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationValidation
     *
     * The issuer is accepted when ANY of the following holds:
     *  1. The issuer scheme + host + port match the authority's (path may
     *     differ). Applies to all authorities.
     *  2. The authority is a Microsoft cloud authority (public, sovereign,
     *     or CIAM), the issuer is HTTPS, and the issuer host is in the known
     *     Microsoft authority host set.
     *  3. Same as (2), but the issuer host is a single-label regional variant
     *     of a known Microsoft host (e.g. `westus.login.microsoftonline.com`).
     *  4. Same as (2), but the issuer host matches the CIAM tenant pattern
     *     `{tenant}.ciamlogin.com` with an optional `/{tenant}[.onmicrosoft.com][/v2.0]`
     *     path.
     *  5. The issuer host is HTTPS and is explicitly listed in the
     *     developer-configured `knownAuthorities`. This covers scenarios where
     *     the OIDC discovery document returns an issuer host that differs from
     *     the authority (e.g., a GUID-based issuer for a name-based CIAM authority).
     *
     * @param issuer The `issuer` value returned in the OIDC discovery document.
     * @throws ClientConfigurationError("issuer_validation_failed") on failure.
     */ validateIssuer(issuer) {
        if (!issuer) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.issuerValidationFailed), this.correlationId);
        // Parse with the WHATWG URL API. URL normalizes scheme + host to lowercase per RFC 3986.
        let issuerUrl;
        try {
            issuerUrl = new URL(issuer);
        } catch  {
            throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.issuerValidationFailed), this.correlationId);
        }
        const issuerScheme = issuerUrl.protocol;
        const issuerHost = issuerUrl.host;
        const authorityScheme = (this.canonicalAuthorityUrlComponents.Protocol || "").toLowerCase();
        const authorityHost = (this.canonicalAuthorityUrlComponents.HostNameAndPort || "").toLowerCase();
        // Rule 1: Same scheme and host
        const matchesAuthorityOrigin = this.matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost);
        // Rule 2: The issuer host is a well-known Microsoft authority host (HTTPS only)
        const matchesKnownMicrosoftHost = issuerScheme === "https:" && this.isAliasOfKnownMicrosoftAuthority(issuerHost);
        /*
         * Rule 3: The issuer host is a regional variant ({region}.{host}) of a well-known host
         * (HTTPS only). E.g. westus2.login.microsoft.com
         */ const matchesRegionalMicrosoftHost = issuerScheme === "https:" && this.matchesRegionalMicrosoftHost(issuerHost);
        /*
         * Rule 4: CIAM-specific validation. In a CIAM scenario the issuer is expected to
         * have "{tenant}.ciamlogin.com" as the host, even when using a custom domain.
         */ const matchesCiamTenantPattern = this.matchesCiamTenantPattern(issuerUrl, authorityHost, this.canonicalAuthorityUrlComponents.PathSegments);
        /*
         * Rule 5: The issuer host is explicitly listed in the developer-configured
         * knownAuthorities. This covers scenarios where the OIDC discovery document
         * returns an issuer with a different host than the authority
         * (e.g., a GUID-based issuer for a name-based authority).
         */ const matchesKnownAuthority = issuerScheme === "https:" && this.isInKnownAuthorities(issuerHost);
        // Each rule is an independent boolean; the issuer is valid if ANY rule matches.
        if (matchesAuthorityOrigin || matchesKnownMicrosoftHost || matchesRegionalMicrosoftHost || matchesCiamTenantPattern || matchesKnownAuthority) return;
        // issuer validation fails if none of the above rules are satisfied
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.issuerValidationFailed), this.correlationId);
    }
    /**
     * Rule 1: The issuer scheme + host (and port) match the authority's. Path
     * may differ. Applies to all authorities.
     */ matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost) {
        return issuerScheme === authorityScheme && issuerHost === authorityHost;
    }
    /**
     * Rule 3: The issuer host is a regional variant
     * (`{region}.{host}`) of a known Microsoft authority host.
     * E.g. `westus2.login.microsoft.com`.
     */ matchesRegionalMicrosoftHost(issuerHost) {
        const firstDot = issuerHost.indexOf(".");
        if (firstDot > 0 && firstDot < issuerHost.length - 1) {
            const hostWithoutRegion = issuerHost.substring(firstDot + 1);
            return this.isAliasOfKnownMicrosoftAuthority(hostWithoutRegion);
        }
        return false;
    }
    /**
     * Rule 4: The issuer matches one of the well-known CIAM tenant patterns
     * (`https://{tenant}.ciamlogin.com[/{tenant}[.onmicrosoft.com][/v2.0]]`).
     *
     * The bare tenant name is extracted from the authority's first path segment
     * when available (stripping the `.onmicrosoft.com` suffix that
     * `transformCIAMAuthority` adds), or otherwise from the leftmost label of
     * the authority host (to support CIAM custom domain scenarios).
     *
     * Both `/{tenant}` and `/{tenant}.onmicrosoft.com` path forms are accepted
     * because the OIDC issuer may use either form depending on the authority URL
     * that was used to trigger discovery.
     */ matchesCiamTenantPattern(issuerUrl, authorityHost, authorityPathSegments) {
        /*
         * authorityPathSegments[0] is the first path segment of the *authority
         * URL* after transformCIAMAuthority runs (e.g. "contoso.onmicrosoft.com").
         * Additional CIAM issuer path segments such as "/v2.0" are part of the
         * issuer string, not the authority URL's PathSegments.
         */ const pathSegment = authorityPathSegments[0];
        /*
         * Extract the bare tenant name: strip the .onmicrosoft.com suffix when
         * present (introduced by transformCIAMAuthority), or fall back to the
         * first label of the authority hostname for non-transformed/custom-domain
         * CIAM authorities.
         */ const tenantName = pathSegment ? pathSegment.endsWith((0, _constantsMjs.AAD_TENANT_DOMAIN_SUFFIX)) ? pathSegment.slice(0, -(0, _constantsMjs.AAD_TENANT_DOMAIN_SUFFIX).length) : pathSegment : authorityHost.split(".")[0];
        if (!tenantName) return false;
        const ciamBaseURL = `https://${tenantName}${(0, _constantsMjs.CIAM_AUTH_URL)}`;
        const validCiamPatterns = [
            ciamBaseURL,
            `${ciamBaseURL}/${tenantName}`,
            `${ciamBaseURL}/${tenantName}/v2.0`,
            `${ciamBaseURL}/${tenantName}${(0, _constantsMjs.AAD_TENANT_DOMAIN_SUFFIX)}`,
            `${ciamBaseURL}/${tenantName}${(0, _constantsMjs.AAD_TENANT_DOMAIN_SUFFIX)}/v2.0`
        ];
        /*
         * Compose the canonical issuer string from URL components and strip any
         * trailing slashes from the path so it can be compared to the pattern set.
         */ const issuerPath = issuerUrl.pathname.replace(/\/+$/, "");
        const normalizedIssuer = `${issuerUrl.protocol}//${issuerUrl.host}${issuerPath}`;
        return validCiamPatterns.some((pattern)=>pattern === normalizedIssuer);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, _constantsMjs.KNOWN_PUBLIC_CLOUDS).indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, correlationId, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, _urlStringMjs.UrlString)(host, correlationId);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${0, _constantsMjs.REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = (0, _urlStringMjs.UrlString).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }, correlationId).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion, correlationId) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = Authority.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion, correlationId);
        regionalMetadata.token_endpoint = Authority.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion, correlationId);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = Authority.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion, correlationId);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority, correlationId) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, _urlStringMjs.UrlString)(authority, correlationId);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, _constantsMjs.CIAM_AUTH_URL))) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${0, _constantsMjs.AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
Authority.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, _constantsMjs.AADAuthority).COMMON,
    (0, _constantsMjs.AADAuthority).CONSUMERS,
    (0, _constantsMjs.AADAuthority).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function getTenantFromAuthorityString(authority, correlationId) {
    const authorityUrl = new (0, _urlStringMjs.UrlString)(authority, correlationId);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, _constantsMjs.AADAuthority).COMMON:
        case (0, _constantsMjs.AADAuthority).ORGANIZATIONS:
        case (0, _constantsMjs.AADAuthority).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function formatAuthorityUri(authorityUri) {
    return authorityUri.endsWith((0, _constantsMjs.FORWARD_SLASH)) ? authorityUri : `${authorityUri}${0, _constantsMjs.FORWARD_SLASH}`;
}
function buildStaticAuthorityOptions(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.invalidCloudDiscoveryMetadata), "");
    }
    return {
        canonicalAuthority: authOptions.authority ? formatAuthorityUri(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}

},{"./AuthorityType.mjs":"g1AZM","./OpenIdConfigResponse.mjs":"fu7S2","../url/UrlString.mjs":"9Z8Lm","../error/ClientAuthError.mjs":"e8Ku4","../utils/Constants.mjs":"5eRZy","./AuthorityMetadata.mjs":"4P5NR","../error/ClientConfigurationError.mjs":"ebyn4","./ProtocolMode.mjs":"8zD57","./AuthorityOptions.mjs":"9DjNg","./CloudInstanceDiscoveryResponse.mjs":"hhXoa","./CloudInstanceDiscoveryErrorResponse.mjs":"hqMvO","./RegionDiscovery.mjs":"dBIKh","../error/AuthError.mjs":"8TWYe","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../utils/FunctionWrappers.mjs":"4kFBF","../cache/utils/CacheHelpers.mjs":"61GoB","../error/ClientAuthErrorCodes.mjs":"8keAa","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fu7S2":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOpenIdConfigResponse", ()=>isOpenIdConfigResponse);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function isOpenIdConfigResponse(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4P5NR":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EndpointMetadata", ()=>EndpointMetadata);
parcelHelpers.export(exports, "InstanceDiscoveryMetadata", ()=>InstanceDiscoveryMetadata);
parcelHelpers.export(exports, "InstanceDiscoveryMetadataAliases", ()=>InstanceDiscoveryMetadataAliases);
parcelHelpers.export(exports, "getAliasesFromMetadata", ()=>getAliasesFromMetadata);
parcelHelpers.export(exports, "getAliasesFromStaticSources", ()=>getAliasesFromStaticSources);
parcelHelpers.export(exports, "getCloudDiscoveryMetadataFromHardcodedValues", ()=>getCloudDiscoveryMetadataFromHardcodedValues);
parcelHelpers.export(exports, "getCloudDiscoveryMetadataFromNetworkResponse", ()=>getCloudDiscoveryMetadataFromNetworkResponse);
parcelHelpers.export(exports, "rawMetdataJSON", ()=>rawMetdataJSON);
var _urlStringMjs = require("../url/UrlString.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Build endpoint metadata dynamically to avoid string duplication
const endpointHosts = [
    {
        host: "login.microsoftonline.com"
    },
    {
        host: "login.chinacloudapi.cn",
        issuerHost: "login.partner.microsoftonline.cn"
    },
    {
        host: "login.microsoftonline.us"
    },
    {
        host: "login.sovcloud-identity.fr"
    },
    {
        host: "login.sovcloud-identity.de"
    },
    {
        host: "login.sovcloud-identity.sg"
    }
];
function buildOpenIdConfig(host, issuerHost) {
    return {
        token_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/token`,
        jwks_uri: `https://${host}/{tenantid}/discovery/v2.0/keys`,
        issuer: `https://${issuerHost}/{tenantid}/v2.0`,
        authorization_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/authorize`,
        end_session_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/logout`
    };
}
const dynamicEndpointMetadata = endpointHosts.reduce((acc, { host, issuerHost })=>{
    acc[host] = buildOpenIdConfig(host, issuerHost || host);
    return acc;
}, {});
const rawMetdataJSON = {
    endpointMetadata: dynamicEndpointMetadata,
    instanceDiscoveryMetadata: {
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.fr",
                preferred_cache: "login.sovcloud-identity.fr",
                aliases: [
                    "login.sovcloud-identity.fr"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.de",
                preferred_cache: "login.sovcloud-identity.de",
                aliases: [
                    "login.sovcloud-identity.de"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.sg",
                preferred_cache: "login.sovcloud-identity.sg",
                aliases: [
                    "login.sovcloud-identity.sg"
                ]
            },
            {
                preferred_network: "login.windows-ppe.net",
                preferred_cache: "login.windows-ppe.net",
                aliases: [
                    "login.windows-ppe.net",
                    "sts.windows-ppe.net",
                    "login.microsoft-ppe.com"
                ]
            }
        ]
    }
};
const EndpointMetadata = rawMetdataJSON.endpointMetadata;
const InstanceDiscoveryMetadata = rawMetdataJSON.instanceDiscoveryMetadata;
const InstanceDiscoveryMetadataAliases = new Set();
InstanceDiscoveryMetadata.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        InstanceDiscoveryMetadataAliases.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function getAliasesFromStaticSources(staticAuthorityOptions, logger, correlationId) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, _urlStringMjs.UrlString)(canonicalAuthority, correlationId).getUrlComponents().HostNameAndPort;
        staticAliases = getAliasesFromMetadata(logger, correlationId, authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, _constantsMjs.AuthorityMetadataSource).CONFIG) || getAliasesFromMetadata(logger, correlationId, authorityHost, InstanceDiscoveryMetadata.metadata, (0, _constantsMjs.AuthorityMetadataSource).HARDCODED_VALUES) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function getAliasesFromMetadata(logger, correlationId, authorityHost, cloudDiscoveryMetadata, source) {
    logger.trace(`1bmquz ${source}`, correlationId);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = getCloudDiscoveryMetadataFromNetworkResponse(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger.trace(`1fotbt ${source}`, correlationId);
            return metadata.aliases;
        } else logger.trace(`14avvj ${source}`, correlationId);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function getCloudDiscoveryMetadataFromHardcodedValues(authorityHost) {
    const metadata = getCloudDiscoveryMetadataFromNetworkResponse(InstanceDiscoveryMetadata.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function getCloudDiscoveryMetadataFromNetworkResponse(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}

},{"../url/UrlString.mjs":"9Z8Lm","../utils/Constants.mjs":"5eRZy","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hhXoa":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCloudInstanceDiscoveryResponse", ()=>isCloudInstanceDiscoveryResponse);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function isCloudInstanceDiscoveryResponse(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hqMvO":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCloudInstanceDiscoveryErrorResponse", ()=>isCloudInstanceDiscoveryErrorResponse);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function isCloudInstanceDiscoveryErrorResponse(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dBIKh":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegionDiscovery", ()=>RegionDiscovery);
var _constantsMjs = require("../utils/Constants.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class RegionDiscovery {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = RegionDiscovery.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, _functionWrappersMjs.invokeAsync)(this.getRegionFromIMDS.bind(this), (0, _performanceEventsMjs.RegionDiscoveryGetRegionFromIMDS), this.logger, this.performanceClient, this.correlationId)((0, _constantsMjs.IMDS_VERSION), options);
                if (localIMDSVersionResponse.status === (0, _constantsMjs.HTTP_SUCCESS)) {
                    autodetectedRegionName = localIMDSVersionResponse.body?.location;
                    if (autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, _constantsMjs.RegionDiscoverySources).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, _constantsMjs.HTTP_BAD_REQUEST)) {
                    const currentIMDSVersion = await (0, _functionWrappersMjs.invokeAsync)(this.getCurrentVersion.bind(this), (0, _performanceEventsMjs.RegionDiscoveryGetCurrentVersion), this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, _constantsMjs.RegionDiscoverySources).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, _functionWrappersMjs.invokeAsync)(this.getRegionFromIMDS.bind(this), (0, _performanceEventsMjs.RegionDiscoveryGetRegionFromIMDS), this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, _constantsMjs.HTTP_SUCCESS)) {
                        autodetectedRegionName = currentIMDSVersionResponse.body?.location;
                        if (autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, _constantsMjs.RegionDiscoverySources).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, _constantsMjs.RegionDiscoverySources).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, _constantsMjs.RegionDiscoverySources).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, _constantsMjs.RegionDiscoverySources).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param version
     * @param options
     * @returns Promise<NetworkResponse<ImdsComputeResponse>>
     */ async getRegionFromIMDS(version, options) {
        return this.networkInterface.sendGetRequestAsync(`${(0, _constantsMjs.IMDS_ENDPOINT)}?api-version=${version}`, options, (0, _constantsMjs.IMDS_TIMEOUT));
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, _constantsMjs.IMDS_ENDPOINT)}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, _constantsMjs.HTTP_BAD_REQUEST) && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
RegionDiscovery.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};

},{"../utils/Constants.mjs":"5eRZy","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../utils/FunctionWrappers.mjs":"4kFBF","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kxZTv":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthClientCreateTokenRequestBody", ()=>AuthClientCreateTokenRequestBody);
parcelHelpers.export(exports, "AuthClientExecuteTokenRequest", ()=>AuthClientExecuteTokenRequest);
parcelHelpers.export(exports, "AuthorityGetCloudDiscoveryMetadataFromNetwork", ()=>AuthorityGetCloudDiscoveryMetadataFromNetwork);
parcelHelpers.export(exports, "AuthorityGetEndpointMetadataFromNetwork", ()=>AuthorityGetEndpointMetadataFromNetwork);
parcelHelpers.export(exports, "AuthorityResolveEndpointsAsync", ()=>AuthorityResolveEndpointsAsync);
parcelHelpers.export(exports, "AuthorityUpdateCloudDiscoveryMetadata", ()=>AuthorityUpdateCloudDiscoveryMetadata);
parcelHelpers.export(exports, "AuthorityUpdateEndpointMetadata", ()=>AuthorityUpdateEndpointMetadata);
parcelHelpers.export(exports, "AuthorityUpdateMetadataWithRegionalInformation", ()=>AuthorityUpdateMetadataWithRegionalInformation);
parcelHelpers.export(exports, "AuthorizationCodeClientExecutePostToTokenEndpoint", ()=>AuthorizationCodeClientExecutePostToTokenEndpoint);
parcelHelpers.export(exports, "CacheManagerGetRefreshToken", ()=>CacheManagerGetRefreshToken);
parcelHelpers.export(exports, "GetAuthCodeUrl", ()=>GetAuthCodeUrl);
parcelHelpers.export(exports, "HandleCodeResponseFromServer", ()=>HandleCodeResponseFromServer);
parcelHelpers.export(exports, "HandleServerTokenResponse", ()=>HandleServerTokenResponse);
parcelHelpers.export(exports, "NetworkClientSendPostRequestAsync", ()=>NetworkClientSendPostRequestAsync);
parcelHelpers.export(exports, "PopTokenGenerateCnf", ()=>PopTokenGenerateCnf);
parcelHelpers.export(exports, "RefreshTokenClientAcquireToken", ()=>RefreshTokenClientAcquireToken);
parcelHelpers.export(exports, "RefreshTokenClientAcquireTokenWithCachedRefreshToken", ()=>RefreshTokenClientAcquireTokenWithCachedRefreshToken);
parcelHelpers.export(exports, "RefreshTokenClientCreateTokenRequestBody", ()=>RefreshTokenClientCreateTokenRequestBody);
parcelHelpers.export(exports, "RefreshTokenClientExecutePostToTokenEndpoint", ()=>RefreshTokenClientExecutePostToTokenEndpoint);
parcelHelpers.export(exports, "RefreshTokenClientExecuteTokenRequest", ()=>RefreshTokenClientExecuteTokenRequest);
parcelHelpers.export(exports, "RegionDiscoveryDetectRegion", ()=>RegionDiscoveryDetectRegion);
parcelHelpers.export(exports, "RegionDiscoveryGetCurrentVersion", ()=>RegionDiscoveryGetCurrentVersion);
parcelHelpers.export(exports, "RegionDiscoveryGetRegionFromIMDS", ()=>RegionDiscoveryGetRegionFromIMDS);
parcelHelpers.export(exports, "SetUserData", ()=>SetUserData);
parcelHelpers.export(exports, "SilentFlowClientGenerateResultFromCacheRecord", ()=>SilentFlowClientGenerateResultFromCacheRecord);
parcelHelpers.export(exports, "UpdateTokenEndpointAuthority", ()=>UpdateTokenEndpointAuthority);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Time spent sending/waiting for the response of a request to the token endpoint
 */ const NetworkClientSendPostRequestAsync = "networkClientSendPostRequestAsync";
const RefreshTokenClientExecutePostToTokenEndpoint = "refreshTokenClientExecutePostToTokenEndpoint";
const AuthorizationCodeClientExecutePostToTokenEndpoint = "authorizationCodeClientExecutePostToTokenEndpoint";
/**
 * Time spent on the network for refresh token acquisition
 */ const RefreshTokenClientExecuteTokenRequest = "refreshTokenClientExecuteTokenRequest";
/**
 * Time taken for acquiring refresh token , records RT size
 */ const RefreshTokenClientAcquireToken = "refreshTokenClientAcquireToken";
/**
 * Time taken for acquiring cached refresh token
 */ const RefreshTokenClientAcquireTokenWithCachedRefreshToken = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
/**
 * Helper function to create token request body in RefreshTokenClient (msal-common).
 */ const RefreshTokenClientCreateTokenRequestBody = "refreshTokenClientCreateTokenRequestBody";
const SilentFlowClientGenerateResultFromCacheRecord = "silentFlowClientGenerateResultFromCacheRecord";
/**
 * getAuthCodeUrl API (msal-browser and msal-node).
 */ const GetAuthCodeUrl = "getAuthCodeUrl";
/**
 * Functions from InteractionHandler (msal-browser)
 */ const HandleCodeResponseFromServer = "handleCodeResponseFromServer";
/**
 * APIs in Authorization Code Client (msal-common)
 */ const AuthClientExecuteTokenRequest = "authClientExecuteTokenRequest";
const AuthClientCreateTokenRequestBody = "authClientCreateTokenRequestBody";
const UpdateTokenEndpointAuthority = "updateTokenEndpointAuthority";
/**
 * Generate functions in PopTokenGenerator (msal-common)
 */ const PopTokenGenerateCnf = "popTokenGenerateCnf";
/**
 * handleServerTokenResponse API in ResponseHandler (msal-common)
 */ const HandleServerTokenResponse = "handleServerTokenResponse";
/**
 * Authority functions
 */ const AuthorityResolveEndpointsAsync = "authorityResolveEndpointsAsync";
const AuthorityGetCloudDiscoveryMetadataFromNetwork = "authorityGetCloudDiscoveryMetadataFromNetwork";
const AuthorityUpdateCloudDiscoveryMetadata = "authorityUpdateCloudDiscoveryMetadata";
const AuthorityGetEndpointMetadataFromNetwork = "authorityGetEndpointMetadataFromNetwork";
const AuthorityUpdateEndpointMetadata = "authorityUpdateEndpointMetadata";
const AuthorityUpdateMetadataWithRegionalInformation = "authorityUpdateMetadataWithRegionalInformation";
/**
 * Region Discovery functions
 */ const RegionDiscoveryDetectRegion = "regionDiscoveryDetectRegion";
const RegionDiscoveryGetRegionFromIMDS = "regionDiscoveryGetRegionFromIMDS";
const RegionDiscoveryGetCurrentVersion = "regionDiscoveryGetCurrentVersion";
/**
 * Cache operations
 */ const CacheManagerGetRefreshToken = "cacheManagerGetRefreshToken";
const SetUserData = "setUserData";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"61GoB":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAccessTokenEntity", ()=>createAccessTokenEntity);
parcelHelpers.export(exports, "createIdTokenEntity", ()=>createIdTokenEntity);
parcelHelpers.export(exports, "createRefreshTokenEntity", ()=>createRefreshTokenEntity);
parcelHelpers.export(exports, "generateAppMetadataKey", ()=>generateAppMetadataKey);
parcelHelpers.export(exports, "generateAuthorityMetadataExpiresAt", ()=>generateAuthorityMetadataExpiresAt);
parcelHelpers.export(exports, "isAccessTokenEntity", ()=>isAccessTokenEntity);
parcelHelpers.export(exports, "isAppMetadataEntity", ()=>isAppMetadataEntity);
parcelHelpers.export(exports, "isAuthorityMetadataEntity", ()=>isAuthorityMetadataEntity);
parcelHelpers.export(exports, "isAuthorityMetadataExpired", ()=>isAuthorityMetadataExpired);
parcelHelpers.export(exports, "isCredentialEntity", ()=>isCredentialEntity);
parcelHelpers.export(exports, "isIdTokenEntity", ()=>isIdTokenEntity);
parcelHelpers.export(exports, "isRefreshTokenEntity", ()=>isRefreshTokenEntity);
parcelHelpers.export(exports, "isServerTelemetryEntity", ()=>isServerTelemetryEntity);
parcelHelpers.export(exports, "isThrottlingEntity", ()=>isThrottlingEntity);
parcelHelpers.export(exports, "updateAuthorityEndpointMetadata", ()=>updateAuthorityEndpointMetadata);
parcelHelpers.export(exports, "updateCloudDiscoveryMetadata", ()=>updateCloudDiscoveryMetadata);
var _authTokenMjs = require("../../account/AuthToken.mjs");
var _clientAuthErrorMjs = require("../../error/ClientAuthError.mjs");
var _constantsMjs = require("../../utils/Constants.mjs");
var _timeUtilsMjs = require("../../utils/TimeUtils.mjs");
var _clientAuthErrorCodesMjs = require("../../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function createIdTokenEntity(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, _constantsMjs.CredentialType).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId,
        lastUpdatedAt: Date.now().toString()
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function createAccessTokenEntity(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, correlationId, refreshOn, tokenType, userAssertionHash, keyId, additionalCacheKeyComponents) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, _constantsMjs.CredentialType).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, _timeUtilsMjs.nowSeconds)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, _constantsMjs.AuthenticationScheme).BEARER,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, _constantsMjs.AuthenticationScheme).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, _constantsMjs.CredentialType).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, _constantsMjs.AuthenticationScheme).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, _authTokenMjs.extractTokenClaims)(accessToken, base64Decode, correlationId);
                if (!tokenClaims?.cnf?.kid) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.tokenClaimsCnfRequiredForSignedJwt), correlationId);
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, _constantsMjs.AuthenticationScheme).SSH:
                atEntity.keyId = keyId;
        }
    }
    /* Additional cache key components for cache isolation (e.g., FMI path) */ if (additionalCacheKeyComponents && Object.keys(additionalCacheKeyComponents).length > 0) atEntity.additionalCacheKeyComponents = additionalCacheKeyComponents;
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function createRefreshTokenEntity(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, _constantsMjs.CredentialType).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function isCredentialEntity(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function isAccessTokenEntity(entity) {
    if (!entity) return false;
    return isCredentialEntity(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, _constantsMjs.CredentialType).ACCESS_TOKEN || entity["credentialType"] === (0, _constantsMjs.CredentialType).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function isIdTokenEntity(entity) {
    if (!entity) return false;
    return isCredentialEntity(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, _constantsMjs.CredentialType).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function isRefreshTokenEntity(entity) {
    if (!entity) return false;
    return isCredentialEntity(entity) && entity["credentialType"] === (0, _constantsMjs.CredentialType).REFRESH_TOKEN;
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function isServerTelemetryEntity(key, entity) {
    const validateKey = key.indexOf((0, _constantsMjs.SERVER_TELEM_CACHE_KEY)) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function isThrottlingEntity(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, _constantsMjs.THROTTLING_PREFIX)) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function generateAppMetadataKey({ environment, clientId }) {
    const appMetaDataKeyArray = [
        (0, _constantsMjs.APP_METADATA),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, _constantsMjs.CACHE_KEY_SEPARATOR)).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function isAppMetadataEntity(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, _constantsMjs.APP_METADATA)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function isAuthorityMetadataEntity(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, _constantsMjs.AUTHORITY_METADATA_CACHE_KEY)) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function generateAuthorityMetadataExpiresAt() {
    return (0, _timeUtilsMjs.nowSeconds)() + (0, _constantsMjs.AUTHORITY_METADATA_REFRESH_TIME_SECONDS);
}
/** @internal */ function updateAuthorityEndpointMetadata(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
/** @internal */ function updateCloudDiscoveryMetadata(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 * @internal
 */ function isAuthorityMetadataExpired(metadata) {
    return metadata.expiresAt <= (0, _timeUtilsMjs.nowSeconds)();
}

},{"../../account/AuthToken.mjs":"l1q48","../../error/ClientAuthError.mjs":"e8Ku4","../../utils/Constants.mjs":"5eRZy","../../utils/TimeUtils.mjs":"6CLZ0","../../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6CLZ0":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "isCacheExpired", ()=>isCacheExpired);
parcelHelpers.export(exports, "isTokenExpired", ()=>isTokenExpired);
parcelHelpers.export(exports, "nowSeconds", ()=>nowSeconds);
parcelHelpers.export(exports, "toDateFromSeconds", ()=>toDateFromSeconds);
parcelHelpers.export(exports, "toSecondsFromDate", ()=>toSecondsFromDate);
parcelHelpers.export(exports, "wasClockTurnedBack", ()=>wasClockTurnedBack);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function nowSeconds() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * Converts JS Date object to seconds
 * @param date Date
 */ function toSecondsFromDate(date) {
    // Convert date to seconds
    return date.getTime() / 1000;
}
/**
 * Convert seconds to JS Date object. Seconds can be in a number or string format or undefined (will still return a date).
 * @param seconds
 */ function toDateFromSeconds(seconds) {
    if (seconds) return new Date(Number(seconds) * 1000);
    return new Date();
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function isTokenExpired(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = nowSeconds() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * Checks if a cache entry is expired based on the last updated time and cache retention days.
 * @param lastUpdatedAt
 * @param cacheRetentionDays
 * @returns
 */ function isCacheExpired(lastUpdatedAt, cacheRetentionDays) {
    const cacheExpirationTimestamp = Number(lastUpdatedAt) + cacheRetentionDays * 86400000;
    return Date.now() > cacheExpirationTimestamp;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function wasClockTurnedBack(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > nowSeconds();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function delay(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"l3pFH":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_CRYPTO_IMPLEMENTATION", ()=>DEFAULT_CRYPTO_IMPLEMENTATION);
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Default crypto implementation used when a platform-specific implementation has
 * not been provided.
 */ const DEFAULT_CRYPTO_IMPLEMENTATION = {
    createNewGuid: ()=>{
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    base64Decode: ()=>{
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    base64Encode: ()=>{
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    base64UrlEncode: ()=>{
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    encodeKid: ()=>{
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    async getPublicKeyThumbprint () {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    async removeTokenBindingKey () {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    async clearKeystore () {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    async signJwt () {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    async hashString () {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
};

},{"../error/ClientAuthError.mjs":"e8Ku4","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dg9GN":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRequestThumbprint", ()=>getRequestThumbprint);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function getRequestThumbprint(clientId, request, homeAccountId) {
    return {
        clientId: clientId,
        authority: request.authority,
        scopes: request.scopes,
        homeAccountIdentifier: homeAccountId,
        claims: request.claims,
        authenticationScheme: request.authenticationScheme,
        resourceRequestMethod: request.resourceRequestMethod,
        resourceRequestUri: request.resourceRequestUri,
        shrClaims: request.shrClaims,
        sshKid: request.sshKid,
        embeddedClientId: request.embeddedClientId || request.extraParameters?.clientId,
        resource: request.resource
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cD5vH":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcquireTokenByCode", ()=>AcquireTokenByCode);
parcelHelpers.export(exports, "AcquireTokenPopup", ()=>AcquireTokenPopup);
parcelHelpers.export(exports, "AcquireTokenPreRedirect", ()=>AcquireTokenPreRedirect);
parcelHelpers.export(exports, "AcquireTokenRedirect", ()=>AcquireTokenRedirect);
parcelHelpers.export(exports, "AcquireTokenSilent", ()=>AcquireTokenSilent);
parcelHelpers.export(exports, "InitializeClientApplication", ()=>InitializeClientApplication);
parcelHelpers.export(exports, "LoadExternalTokens", ()=>LoadExternalTokens);
parcelHelpers.export(exports, "LocalStorageUpdated", ()=>LocalStorageUpdated);
parcelHelpers.export(exports, "SsoCapable", ()=>SsoCapable);
parcelHelpers.export(exports, "SsoSilent", ()=>SsoSilent);
parcelHelpers.export(exports, "WaitForBridgeLateResponse", ()=>WaitForBridgeLateResponse);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenSilent API (msal-browser and msal-node).
 * Used to silently acquire a new access token (from the cache or the network).
 */ const AcquireTokenSilent = "acquireTokenSilent";
/**
 * acquireTokenByCode API (msal-browser and msal-node).
 * Used to acquire tokens by trading an authorization code against the token endpoint.
 */ const AcquireTokenByCode = "acquireTokenByCode";
/**
 * acquireTokenPopup (msal-browser).
 * Used to acquire a new access token interactively through pop ups
 */ const AcquireTokenPopup = "acquireTokenPopup";
/**
 * acquireTokenPreRedirect (msal-browser).
 * First part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const AcquireTokenPreRedirect = "acquireTokenPreRedirect";
/**
 * acquireTokenRedirect (msal-browser).
 * Second part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const AcquireTokenRedirect = "acquireTokenRedirect";
/**
 * ssoSilent API (msal-browser).
 * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
 */ const SsoSilent = "ssoSilent";
// Initialize client application
const InitializeClientApplication = "initializeClientApplication";
// Update cache storage
const LocalStorageUpdated = "localStorageUpdated";
// Load external tokens
const LoadExternalTokens = "loadExternalTokens";
/**
 * SSO capability verification call (msal-browser).
 * Fire-and-forget SSO verification call made after interactive authentication completes.
 */ const SsoCapable = "ssoCapable";
// Wait for late response from bridge after timeout has already occurred
const WaitForBridgeLateResponse = "waitForBridgeLateResponse";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"UC4Vw":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserCacheManager", ()=>BrowserCacheManager);
parcelHelpers.export(exports, "DEFAULT_BROWSER_CACHE_MANAGER", ()=>DEFAULT_BROWSER_CACHE_MANAGER);
var _browser = require("@azure/msal-common/browser");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _cacheKeysMjs = require("./CacheKeys.mjs");
var _localStorageMjs = require("./LocalStorage.mjs");
var _sessionStorageMjs = require("./SessionStorage.mjs");
var _memoryStorageMjs = require("./MemoryStorage.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _base64EncodeMjs = require("../encode/Base64Encode.mjs");
var _cookieStorageMjs = require("./CookieStorage.mjs");
var _cacheHelpersMjs = require("./CacheHelpers.mjs");
var _eventTypeMjs = require("../event/EventType.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _helpersMjs = require("../utils/Helpers.mjs");
var _encryptedDataMjs = require("./EncryptedData.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Reason an old-schema cache entry was removed during migration.
 */ const MigrationRemovalReason = {
    Invalid: "invalid",
    TtlExpired: "ttlExpired",
    DecryptFailed: "decryptFailed",
    Expired: "expired"
};
/**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 */ class BrowserCacheManager extends (0, _browser.CacheManager) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, performanceClient, eventHandler, staticAuthorityOptions){
        super(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, _memoryStorageMjs.MemoryStorage)();
        this.browserStorage = getStorageImplementation(clientId, cacheConfig.cacheLocation, logger, performanceClient);
        this.temporaryCacheStorage = getStorageImplementation(clientId, (0, _browserConstantsMjs.BrowserCacheLocation).SessionStorage, logger, performanceClient);
        this.cookieStorage = new (0, _cookieStorageMjs.CookieStorage)();
        this.eventHandler = eventHandler;
    }
    async initialize(correlationId) {
        this.performanceClient.addFields({
            cacheLocation: this.cacheConfig.cacheLocation,
            cacheRetentionDays: this.cacheConfig.cacheRetentionDays
        }, correlationId);
        await this.browserStorage.initialize(correlationId);
        await this.migrateExistingCache(correlationId);
        this.trackVersionChanges(correlationId);
    }
    /**
     * Migrates any existing cache data from previous versions of MSAL.js into the current cache structure.
     */ async migrateExistingCache(correlationId) {
        let accountKeys = (0, _cacheHelpersMjs.getAccountKeys)(this.browserStorage);
        let tokenKeys = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            preMigrateAcntCount: accountKeys.length,
            preMigrateATCount: tokenKeys.accessToken.length,
            preMigrateITCount: tokenKeys.idToken.length,
            preMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
        for(let i = 0; i < (0, _cacheKeysMjs.ACCOUNT_SCHEMA_VERSION); i++){
            const credentialSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.removeStaleAccounts(i, credentialSchema, correlationId);
        }
        // Must migrate idTokens first to ensure we have KMSI info for the rest
        for(let i = 0; i < (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION); i++){
            const accountSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.migrateIdTokens(i, accountSchema, correlationId);
        }
        const kmsiMap = this.getKMSIValues();
        for(let i = 0; i < (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION); i++){
            await this.migrateAccessTokens(i, kmsiMap, correlationId);
            await this.migrateRefreshTokens(i, kmsiMap, correlationId);
        }
        accountKeys = (0, _cacheHelpersMjs.getAccountKeys)(this.browserStorage);
        tokenKeys = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            postMigrateAcntCount: accountKeys.length,
            postMigrateATCount: tokenKeys.accessToken.length,
            postMigrateITCount: tokenKeys.idToken.length,
            postMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
    }
    /**
     * Parses entry, adds lastUpdatedAt if it doesn't exist, removes entry if expired or invalid
     * @param key
     * @param correlationId
     * @returns
     */ async updateOldEntry(key, correlationId) {
        const rawValue = this.browserStorage.getItem(key);
        const parsedValue = this.validateAndParseJson(rawValue || "");
        if (!parsedValue) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: MigrationRemovalReason.Invalid
            };
        }
        if (!parsedValue.lastUpdatedAt) {
            // Add lastUpdatedAt to the existing v0 entry if it doesnt exist so we know when it's safe to remove it
            parsedValue.lastUpdatedAt = Date.now().toString();
            this.setItem(key, JSON.stringify(parsedValue), correlationId);
        } else if ((0, _browser.TimeUtils).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: MigrationRemovalReason.TtlExpired
            };
        }
        const wasEncrypted = (0, _encryptedDataMjs.isEncrypted)(parsedValue);
        const decryptedData = wasEncrypted ? await this.browserStorage.decryptData(key, parsedValue, correlationId) : parsedValue;
        if (!decryptedData) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: wasEncrypted ? MigrationRemovalReason.DecryptFailed : MigrationRemovalReason.Invalid
            };
        }
        if (!(0, _browser.CacheHelpers).isCredentialEntity(decryptedData)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: MigrationRemovalReason.Invalid
            };
        }
        if (((0, _browser.CacheHelpers).isAccessTokenEntity(decryptedData) || (0, _browser.CacheHelpers).isRefreshTokenEntity(decryptedData)) && decryptedData.expiresOn && (0, _browser.TimeUtils).isTokenExpired(decryptedData.expiresOn, (0, _browser.Constants).DEFAULT_TOKEN_RENEWAL_OFFSET_SEC)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: MigrationRemovalReason.Expired
            };
        }
        return {
            entry: decryptedData
        };
    }
    /**
     * Remove accounts from the cache for older schema versions if they have not been updated in the last cacheRetentionDays
     * @param accountSchema
     * @param credentialSchema
     * @param correlationId
     * @returns
     */ async removeStaleAccounts(accountSchema, credentialSchema, correlationId) {
        const accountKeysToCheck = (0, _cacheHelpersMjs.getAccountKeys)(this.browserStorage, accountSchema);
        if (accountKeysToCheck.length === 0) return;
        for (const accountKey of [
            ...accountKeysToCheck
        ]){
            this.performanceClient.incrementFields({
                oldAcntCount: 1
            }, correlationId);
            const rawValue = this.browserStorage.getItem(accountKey);
            const parsedValue = this.validateAndParseJson(rawValue || "");
            if (!parsedValue) {
                this.browserStorage.removeItem(accountKey);
                this.performanceClient.incrementFields({
                    invalidAcntCount: 1
                }, correlationId);
                (0, _helpersMjs.removeElementFromArray)(accountKeysToCheck, accountKey);
                continue;
            }
            if (!parsedValue.lastUpdatedAt) {
                // Add lastUpdatedAt to the existing entry if it doesnt exist so we know when it's safe to remove it
                parsedValue.lastUpdatedAt = Date.now().toString();
                this.setItem(accountKey, JSON.stringify(parsedValue), correlationId);
                continue;
            } else if ((0, _browser.TimeUtils).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
                // Cache expired remove account and associated tokens
                await this.removeAccountOldSchema(accountKey, parsedValue, credentialSchema, correlationId);
                this.performanceClient.incrementFields({
                    ttlExpiredAcntCount: 1
                }, correlationId);
                (0, _helpersMjs.removeElementFromArray)(accountKeysToCheck, accountKey);
            } else if ((0, _encryptedDataMjs.isEncrypted)(parsedValue)) {
                // Remove accounts encrypted with a different key (session cookie expired/changed)
                const decrypted = await this.browserStorage.decryptData(accountKey, parsedValue, correlationId);
                if (!decrypted) {
                    this.browserStorage.removeItem(accountKey);
                    this.performanceClient.incrementFields({
                        decryptFailedAcntCount: 1
                    }, correlationId);
                    (0, _helpersMjs.removeElementFromArray)(accountKeysToCheck, accountKey);
                }
            }
        }
        this.setAccountKeys(accountKeysToCheck, correlationId, accountSchema);
    }
    /**
     * Remove the given account and all associated tokens from the cache
     * @param accountKey
     * @param rawObject
     * @param credentialSchema
     * @param correlationId
     */ async removeAccountOldSchema(accountKey, rawObject, credentialSchema, correlationId) {
        const decryptedData = (0, _encryptedDataMjs.isEncrypted)(rawObject) ? await this.browserStorage.decryptData(accountKey, rawObject, correlationId) : rawObject;
        const homeAccountId = decryptedData?.homeAccountId;
        if (homeAccountId) {
            const tokenKeys = this.getTokenKeys(credentialSchema);
            [
                ...tokenKeys.idToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, _helpersMjs.removeElementFromArray)(tokenKeys.idToken, key);
            });
            [
                ...tokenKeys.accessToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, _helpersMjs.removeElementFromArray)(tokenKeys.accessToken, key);
            });
            [
                ...tokenKeys.refreshToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, _helpersMjs.removeElementFromArray)(tokenKeys.refreshToken, key);
            });
            this.setTokenKeys(tokenKeys, correlationId, credentialSchema);
        }
        this.browserStorage.removeItem(accountKey);
    }
    /**
     * Gets key value pair mapping homeAccountId to KMSI value
     * @returns
     */ getKMSIValues() {
        const kmsiMap = {};
        const tokenKeys = this.getTokenKeys().idToken;
        for (const key of tokenKeys){
            const rawValue = this.browserStorage.getUserData(key);
            if (rawValue) {
                const idToken = JSON.parse(rawValue);
                const claims = (0, _browser.AuthToken).extractTokenClaims(idToken.secret, (0, _base64DecodeMjs.base64Decode), "");
                if (claims) kmsiMap[idToken.homeAccountId] = (0, _browser.AuthToken).isKmsi(claims);
            }
        }
        return kmsiMap;
    }
    /**
     * Migrates id tokens from the old schema to the new schema, also migrates associated account object if it doesn't already exist in the new schema
     * @param credentialSchema
     * @param accountSchema
     * @param correlationId
     * @returns
     */ async migrateIdTokens(credentialSchema, accountSchema, correlationId) {
        const credentialKeysToMigrate = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.idToken.length === 0) return;
        const currentCredentialKeys = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage, (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION));
        const currentAccountKeys = (0, _cacheHelpersMjs.getAccountKeys)(this.browserStorage);
        const previousAccountKeys = (0, _cacheHelpersMjs.getAccountKeys)(this.browserStorage, accountSchema);
        for (const idTokenKey of [
            ...credentialKeysToMigrate.idToken
        ]){
            this.performanceClient.incrementFields({
                oldITCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(idTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredITCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedITCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidITCount: 1
                        }, correlationId);
                        break;
                }
                (0, _helpersMjs.removeElementFromArray)(credentialKeysToMigrate.idToken, idTokenKey);
                continue;
            }
            const currentAccountKey = currentAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            const previousAccountKey = previousAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            let account = null;
            if (currentAccountKey) account = this.getAccount(currentAccountKey, correlationId);
            else if (previousAccountKey) {
                const rawValue = this.browserStorage.getItem(previousAccountKey);
                const parsedValue = this.validateAndParseJson(rawValue || "");
                account = parsedValue && (0, _encryptedDataMjs.isEncrypted)(parsedValue) ? await this.browserStorage.decryptData(previousAccountKey, parsedValue, correlationId) : parsedValue;
            }
            if (!account) {
                // Don't migrate idToken if we don't have an account for it
                this.performanceClient.incrementFields({
                    skipITMigrateCount: 1
                }, correlationId);
                continue;
            }
            const claims = (0, _browser.AuthToken).extractTokenClaims(oldSchemaData.secret, (0, _base64DecodeMjs.base64Decode), correlationId);
            const newIdTokenKey = this.generateCredentialKey(oldSchemaData);
            const currentIdToken = this.getIdTokenCredential(newIdTokenKey, correlationId);
            const oldTokenHasSignInState = Object.keys(claims).includes("signin_state");
            const currentTokenHasSignInState = currentIdToken && Object.keys((0, _browser.AuthToken).extractTokenClaims(currentIdToken.secret, (0, _base64DecodeMjs.base64Decode), correlationId) || {}).includes("signin_state");
            /**
             * Only migrate if:
             * 1. Token doesn't yet exist in current schema
             * 2. Old schema token has been updated more recently than the current one AND migrating it won't result in loss of KMSI state
             */ if (!currentIdToken || oldSchemaData.lastUpdatedAt > currentIdToken.lastUpdatedAt && (oldTokenHasSignInState || !currentTokenHasSignInState)) {
                const tenantProfiles = account.tenantProfiles || [];
                const tenantId = (0, _browser.getTenantIdFromIdTokenClaims)(claims) || account.realm;
                if (tenantId && !tenantProfiles.find((tenantProfile)=>{
                    return tenantProfile.tenantId === tenantId;
                })) {
                    const newTenantProfile = (0, _browser.buildTenantProfile)(account.homeAccountId, account.localAccountId, tenantId, account.nativeAccountId, claims);
                    tenantProfiles.push(newTenantProfile);
                }
                account.tenantProfiles = tenantProfiles;
                const newAccountKey = this.generateAccountKey((0, _browser.AccountEntityUtils).getAccountInfo(account));
                const kmsi = (0, _browser.AuthToken).isKmsi(claims);
                await this.setUserData(newAccountKey, JSON.stringify(account), correlationId, account.lastUpdatedAt, kmsi);
                if (!currentAccountKeys.includes(newAccountKey)) currentAccountKeys.push(newAccountKey);
                await this.setUserData(newIdTokenKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedITCount: 1
                }, correlationId);
                if (!currentCredentialKeys.idToken.includes(newIdTokenKey)) currentCredentialKeys.idToken.push(newIdTokenKey);
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
        this.setAccountKeys(currentAccountKeys, correlationId);
    }
    /**
     * Migrates access tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateAccessTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.accessToken.length === 0) return;
        const currentCredentialKeys = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage, (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION));
        for (const accessTokenKey of [
            ...credentialKeysToMigrate.accessToken
        ]){
            this.performanceClient.incrementFields({
                oldATCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(accessTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredATCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedATCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredATCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidATCount: 1
                        }, correlationId);
                        break;
                }
                (0, _helpersMjs.removeElementFromArray)(credentialKeysToMigrate.accessToken, accessTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipATMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.accessToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedATCount: 1
                }, correlationId);
                currentCredentialKeys.accessToken.push(newKey);
            } else {
                const currentToken = this.getAccessTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedATCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Migrates refresh tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateRefreshTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.refreshToken.length === 0) return;
        const currentCredentialKeys = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage, (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION));
        for (const refreshTokenKey of [
            ...credentialKeysToMigrate.refreshToken
        ]){
            this.performanceClient.incrementFields({
                oldRTCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(refreshTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredRTCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedRTCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredRTCount: 1
                        }, correlationId);
                        break;
                    case MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidRTCount: 1
                        }, correlationId);
                        break;
                }
                (0, _helpersMjs.removeElementFromArray)(credentialKeysToMigrate.refreshToken, refreshTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipRTMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.refreshToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedRTCount: 1
                }, correlationId);
                currentCredentialKeys.refreshToken.push(newKey);
            } else {
                const currentToken = this.getRefreshTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedRTCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Tracks upgrades and downgrades for telemetry and debugging purposes
     */ trackVersionChanges(correlationId) {
        const previousVersion = this.browserStorage.getItem((0, _cacheKeysMjs.VERSION_CACHE_KEY));
        if (previousVersion) {
            this.logger.info(`1wuc87 ${previousVersion}`, correlationId);
            this.performanceClient.addGlobalFields({
                previousLibraryVersion: previousVersion
            });
        }
        if (previousVersion !== (0, _packageMetadataMjs.version)) this.setItem((0, _cacheKeysMjs.VERSION_CACHE_KEY), (0, _packageMetadataMjs.version), correlationId);
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        if (!jsonValue) return null;
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * Helper to setItem in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        const tokenKeysCount = new Array((0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)// Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
        try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, _browser.createCacheError)(e);
            if (cacheError.errorCode === (0, _browser.CacheErrorCodes).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    // If we are currently trying to set the token keys, use the value we're trying to set
                    for(let i = 0; i <= (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION); i++)if (key === (0, _cacheKeysMjs.getTokenKeysCacheKey)(this.clientId, i)) {
                        const tokenKeys = JSON.parse(value).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    } else {
                        const tokenKeys = this.getTokenKeys(i).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    }
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Helper to setUserData in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     * @param correlationId
     */ async setUserData(key, value, correlationId, timestamp, kmsi) {
        const tokenKeysCount = new Array((0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            // Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
            await (0, _browser.invokeAsync)(this.browserStorage.setUserData.bind(this.browserStorage), (0, _browser.PerformanceEvents).SetUserData, this.logger, this.performanceClient, correlationId)(key, value, correlationId, timestamp, kmsi);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, _browser.createCacheError)(e);
            if (cacheError.errorCode === (0, _browser.CacheErrorCodes).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) // If we are currently trying to set the token keys, use the value we're trying to set
                for(let i = 0; i <= (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION); i++){
                    const tokenKeys = this.getTokenKeys(i).accessToken;
                    accessTokenKeys.push(...tokenKeys);
                    tokenKeysCount[i] = tokenKeys.length;
                }
                if (accessTokenKeys.length <= i) // Nothing left to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getAccount(accountKey, correlationId) {
        this.logger.trace("1lfvm6", correlationId);
        const serializedAccount = this.browserStorage.getUserData(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, _browser.AccountEntityUtils).isAccountEntity(parsedAccount)) return null;
        const account = (0, _browser.CacheManager).toObject({}, parsedAccount);
        this.performanceClient.addFields({
            accountCachedBy: (0, _browserConstantsMjs.apiIdToName)(account.cachedByApiId)
        }, correlationId);
        return account;
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ async setAccount(account, correlationId, kmsi, apiId) {
        this.logger.trace("1bz3wr", correlationId);
        const key = this.generateAccountKey((0, _browser.AccountEntityUtils).getAccountInfo(account));
        const timestamp = Date.now().toString();
        account.lastUpdatedAt = timestamp;
        account.cachedByApiId = apiId;
        await this.setUserData(key, JSON.stringify(account), correlationId, timestamp, kmsi);
        this.addAccountKeyToMap(key, correlationId);
        this.performanceClient.addFields({
            kmsi: kmsi
        }, correlationId);
    }
    setAccountKeys(accountKeys, correlationId, schemaVersion = (0, _cacheKeysMjs.ACCOUNT_SCHEMA_VERSION)) {
        if (accountKeys.length === 0) this.removeItem((0, _cacheKeysMjs.getAccountKeysCacheKey)(schemaVersion));
        else this.setItem((0, _cacheKeysMjs.getAccountKeysCacheKey)(schemaVersion), JSON.stringify(accountKeys), correlationId);
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        return (0, _cacheHelpersMjs.getAccountKeys)(this.browserStorage);
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("0rb85k", correlationId);
        this.logger.tracePii(`1l9bdo ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, _cacheKeysMjs.getAccountKeysCacheKey)(), JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("0xia39", correlationId);
            return true;
        } else {
            this.logger.verbose("0161kk", correlationId);
            return false;
        }
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("1jpigu", correlationId);
        this.logger.tracePii(`1xzspl ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setAccountKeys(accountKeys, correlationId);
        } else this.logger.trace("1dytu2", correlationId);
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ removeAccount(account, correlationId) {
        const activeAccount = this.getActiveAccount(correlationId);
        if (activeAccount?.homeAccountId === account.homeAccountId && activeAccount?.environment === account.environment) this.setActiveAccount(null, correlationId);
        super.removeAccount(account, correlationId);
        this.removeAccountKeyFromMap(this.generateAccountKey(account), correlationId);
        // Remove all other associated cache items
        this.browserStorage.getKeys().forEach((key)=>{
            if (key.includes(account.homeAccountId) && key.includes(account.environment)) this.browserStorage.removeItem(key);
        });
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const idRemoval = tokenKeys.idToken.indexOf(key);
        if (idRemoval > -1) {
            this.logger.info("05udv9", correlationId);
            tokenKeys.idToken.splice(idRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        updateTokenKeys && this.removeAccessTokenKeys([
            key
        ], correlationId);
    }
    /**
     * Remove access token key from the key map
     * @param key
     * @param correlationId
     * @param tokenKeys
     */ removeAccessTokenKeys(keys, correlationId, schemaVersion = (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION)) {
        this.logger.trace("17o18n", correlationId);
        const tokenKeys = this.getTokenKeys(schemaVersion);
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`15i5d5 ${keysRemoved}`, correlationId);
            this.setTokenKeys(tokenKeys, correlationId, schemaVersion);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
        if (refreshRemoval > -1) {
            this.logger.info("1f4fq3", correlationId);
            tokenKeys.refreshToken.splice(refreshRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys(schemaVersion = (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION)) {
        return (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this.browserStorage, schemaVersion);
    }
    /**
     * Sets the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId, schemaVersion = (0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION)) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem((0, _cacheKeysMjs.getTokenKeysCacheKey)(this.clientId, schemaVersion));
            return;
        } else this.setItem((0, _cacheKeysMjs.getTokenKeysCacheKey)(this.clientId, schemaVersion), JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(idTokenKey);
        if (!value) {
            this.logger.trace("1jukz6", correlationId);
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, _browser.CacheHelpers).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("1jukz6", correlationId);
            return null;
        }
        this.logger.trace("01ju66", correlationId);
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ async setIdTokenCredential(idToken, correlationId, kmsi) {
        this.logger.trace("13hjll", correlationId);
        const idTokenKey = this.generateCredentialKey(idToken);
        const timestamp = Date.now().toString();
        idToken.lastUpdatedAt = timestamp;
        await this.setUserData(idTokenKey, JSON.stringify(idToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.idToken.indexOf(idTokenKey) === -1) {
            this.logger.info("07jy92", correlationId);
            tokenKeys.idToken.push(idTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(accessTokenKey);
        if (!value) {
            this.logger.trace("0bqvx8", correlationId);
            this.removeAccessTokenKeys([
                accessTokenKey
            ], correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, _browser.CacheHelpers).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("0bqvx8", correlationId);
            return null;
        }
        this.logger.trace("1o81rl", correlationId);
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ async setAccessTokenCredential(accessToken, correlationId, kmsi) {
        this.logger.trace("1pondb", correlationId);
        const accessTokenKey = this.generateCredentialKey(accessToken);
        const timestamp = Date.now().toString();
        accessToken.lastUpdatedAt = timestamp;
        await this.setUserData(accessTokenKey, JSON.stringify(accessToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        const index = tokenKeys.accessToken.indexOf(accessTokenKey);
        if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
        this.logger.trace(`1onhey ${index === -1 ? "added to" : "updated in"}`, correlationId);
        tokenKeys.accessToken.push(accessTokenKey);
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(refreshTokenKey);
        if (!value) {
            this.logger.trace("0jlizt", correlationId);
            this.removeRefreshToken(refreshTokenKey, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, _browser.CacheHelpers).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("0jlizt", correlationId);
            return null;
        }
        this.logger.trace("0nokxi", correlationId);
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ async setRefreshTokenCredential(refreshToken, correlationId, kmsi) {
        this.logger.trace("0tcg8d", correlationId);
        const refreshTokenKey = this.generateCredentialKey(refreshToken);
        const timestamp = Date.now().toString();
        refreshToken.lastUpdatedAt = timestamp;
        await this.setUserData(refreshTokenKey, JSON.stringify(refreshToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.refreshToken.indexOf(refreshTokenKey) === -1) {
            this.logger.info("0eckjs", correlationId);
            tokenKeys.refreshToken.push(refreshTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     * @param correlationId
     */ getAppMetadata(appMetadataKey, correlationId) {
        const value = this.browserStorage.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, _browser.CacheHelpers).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        this.logger.trace("19pvg2", correlationId);
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     * @param correlationId
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("0cyma6", correlationId);
        const appMetadataKey = (0, _browser.CacheHelpers).generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     * @param correlationId
     */ getServerTelemetry(serverTelemetryKey, correlationId) {
        const value = this.browserStorage.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, _browser.CacheHelpers).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        this.logger.trace("12jguk", correlationId);
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("1poh61", correlationId);
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key, correlationId) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("1r39oe", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, _browser.CacheHelpers).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("1ohvk3", correlationId);
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, _browserConstantsMjs.InMemoryCacheKeys).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, _browserConstantsMjs.InMemoryCacheKeys).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, _browserConstantsMjs.InMemoryCacheKeys).WRAPPER_SKU) || "";
        const version = this.internalStorage.getItem((0, _browserConstantsMjs.InMemoryCacheKeys).WRAPPER_VER) || "";
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param key
     * @param entity
     * @param correlationId
     */ setAuthorityMetadata(key, entity, correlationId) {
        this.logger.trace("07w8n2", correlationId);
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey((0, _browser.Constants).PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.browserStorage.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            this.logger.trace("08gw0e", correlationId);
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("1t3ch7", correlationId);
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("0me1up", correlationId);
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey((0, _browser.Constants).PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        if (account) {
            this.logger.verbose("0rsj80", correlationId);
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
        } else {
            this.logger.verbose("1bp5z5", correlationId);
            this.browserStorage.removeItem(activeAccountKey);
        }
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACTIVE_ACCOUNT_CHANGED, correlationId);
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     * @param correlationId
     */ getThrottlingCache(throttlingCacheKey, correlationId) {
        const value = this.browserStorage.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, _browser.CacheHelpers).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        this.logger.trace("0of6n8", correlationId);
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("0wfgh6", correlationId);
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * @param cacheKey
     * @param correlationId
     * @param generateKey
     */ getTemporaryCache(cacheKey, correlationId, generateKey) {
        this.logger.trace("1ordf8", correlationId);
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        return this.temporaryCacheStorage.getItem(key);
    }
    /**
     * Sets the cache item with the key and value given.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ clear(correlationId) {
        // Removes all accounts and their credentials
        this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, _cacheKeysMjs.PREFIX)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, _cacheKeysMjs.PREFIX)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Prepend msal.<client-id> to each key
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        if ((0, _browser.StringUtils).startsWith(key, (0, _cacheKeysMjs.PREFIX))) return key;
        return `${0, _cacheKeysMjs.PREFIX}.${this.clientId}.${key}`;
    }
    /**
     * Generate Credential Key. All changes to the key REQUIRE a schema version update.
     * Cache Key: msal.<schema_version>|<home_account_id>|<environment>|<credential_type>|<client_id or familyId>|<realm>|<scopes>|<scheme>
     * @param credentialEntity
     * @returns
     */ generateCredentialKey(credential) {
        const familyId = credential.credentialType === (0, _browser.Constants).CredentialType.REFRESH_TOKEN && credential.familyId || credential.clientId;
        const scheme = credential.tokenType && credential.tokenType.toLowerCase() !== (0, _browser.Constants).AuthenticationScheme.BEARER.toLowerCase() ? credential.tokenType.toLowerCase() : "";
        const credentialKey = [
            `${(0, _cacheKeysMjs.PREFIX)}.${(0, _cacheKeysMjs.CREDENTIAL_SCHEMA_VERSION)}`,
            credential.homeAccountId,
            credential.environment,
            credential.credentialType,
            familyId,
            credential.realm || "",
            credential.target || "",
            scheme
        ];
        return credentialKey.join((0, _cacheKeysMjs.CACHE_KEY_SEPARATOR)).toLowerCase();
    }
    /**
     * Cache Key: msal.<schema_version>.<home_account_id>.<environment>.<tenant_id>
     * @param account
     * @returns
     */ generateAccountKey(account) {
        const homeTenantId = account.homeAccountId.split(".")[1];
        const accountKey = [
            `${(0, _cacheKeysMjs.PREFIX)}.${(0, _cacheKeysMjs.ACCOUNT_SCHEMA_VERSION)}`,
            account.homeAccountId,
            account.environment,
            homeTenantId || account.tenantId || ""
        ];
        return accountKey.join((0, _cacheKeysMjs.CACHE_KEY_SEPARATOR)).toLowerCase();
    }
    /**
     * Reset all temporary cache items
     * @param correlationId
     */ resetRequestCache(correlationId) {
        this.logger.trace("0h0ynu", correlationId);
        this.removeTemporaryItem(this.generateCacheKey((0, _browserConstantsMjs.TemporaryCacheKeys).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, _browserConstantsMjs.TemporaryCacheKeys).VERIFIER));
        this.removeTemporaryItem(this.generateCacheKey((0, _browserConstantsMjs.TemporaryCacheKeys).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, _browserConstantsMjs.TemporaryCacheKeys).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, _browserConstantsMjs.TemporaryCacheKeys).NATIVE_REQUEST));
        this.setInteractionInProgress(false, undefined);
    }
    cacheAuthorizeRequest(authCodeRequest, correlationId, codeVerifier) {
        this.logger.trace("1tzef5", correlationId);
        const encodedValue = (0, _base64EncodeMjs.base64Encode)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).REQUEST_PARAMS, encodedValue, true);
        if (codeVerifier) {
            const encodedVerifier = (0, _base64EncodeMjs.base64Encode)(codeVerifier);
            this.setTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).VERIFIER, encodedVerifier, true);
        }
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     * @param correlationId
     */ getCachedRequest(correlationId) {
        this.logger.trace("0uen20", correlationId);
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).REQUEST_PARAMS, correlationId, true);
        if (!encodedTokenRequest) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.noTokenRequestCacheError), "");
        const encodedVerifier = this.getTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).VERIFIER, correlationId, true);
        let parsedRequest;
        let verifier = "";
        try {
            parsedRequest = JSON.parse((0, _base64DecodeMjs.base64Decode)(encodedTokenRequest));
            if (encodedVerifier) verifier = (0, _base64DecodeMjs.base64Decode)(encodedVerifier);
        } catch (e) {
            this.logger.errorPii(`0ewsey ${encodedTokenRequest}`, correlationId);
            this.logger.error(`0tvdic ${e}`, correlationId);
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.unableToParseTokenRequestCacheError), "");
        }
        return [
            parsedRequest,
            verifier
        ];
    }
    /**
     * Gets cached native request for redirect flows
     * @param correlationId
     */ getCachedNativeRequest() {
        this.logger.trace("1yxcdm", "");
        const cachedRequest = this.getTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).NATIVE_REQUEST, "", true);
        if (!cachedRequest) {
            this.logger.trace("0mnxd4", "");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("0rrkip", "");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress()?.clientId;
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, _cacheKeysMjs.PREFIX)}.${(0, _browserConstantsMjs.TemporaryCacheKeys).INTERACTION_STATUS_KEY}`;
        const value = this.getTemporaryCache(key, "", false);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            // Remove interaction and other temp keys if interaction status can't be parsed
            this.logger.error("0jjyys", "");
            this.removeTemporaryItem(key);
            this.resetRequestCache("");
            (0, _browserUtilsMjs.clearHash)(window);
            return null;
        }
    }
    setInteractionInProgress(inProgress, type = (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNIN, allowOverride = false, correlationId = "") {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, _cacheKeysMjs.PREFIX)}.${(0, _browserConstantsMjs.TemporaryCacheKeys).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            const existingInteraction = this.getInteractionInProgress();
            if (existingInteraction) {
                if (allowOverride) {
                    this.logger.warning(`1pmscr ${existingInteraction.clientId} ${existingInteraction.type}`, correlationId);
                    // Cancel any active bridge monitor from the previous interaction
                    (0, _browserUtilsMjs.cancelPendingBridgeResponse)(this.logger, correlationId);
                    // Clear existing interaction to allow new one
                    this.removeTemporaryItem(key);
                } else throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.interactionInProgress), "");
            }
            // Set new interaction
            this.setTemporaryCache(key, JSON.stringify({
                clientId: this.clientId,
                type
            }), false);
        } else if (!inProgress && this.getInteractionInProgress()?.clientId === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, _browser.CacheHelpers).createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.clientId, result.tenantId);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, _browser.CacheHelpers).createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), // Access token expiresOn stored in seconds, converting from AuthenticationResult expiresOn stored as Date
        result.expiresOn ? (0, _browser.TimeUtils).toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? (0, _browser.TimeUtils).toSecondsFromDate(result.extExpiresOn) : 0, (0, _base64DecodeMjs.base64Decode), request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid);
        if (request.resource) accessTokenEntity.resource = request.resource;
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId, (0, _browser.AuthToken).isKmsi((0, _browser.AuthToken).extractTokenClaims(result.idToken, (0, _base64DecodeMjs.base64Decode), result.correlationId)), (0, _browserConstantsMjs.ApiId).hydrateCache);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache);
        } catch (e) {
            if (e instanceof (0, _browser.CacheError) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
/**
 * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
 * @param cacheLocation
 */ function getStorageImplementation(clientId, cacheLocation, logger, performanceClient) {
    try {
        switch(cacheLocation){
            case (0, _browserConstantsMjs.BrowserCacheLocation).LocalStorage:
                return new (0, _localStorageMjs.LocalStorage)(clientId, logger, performanceClient);
            case (0, _browserConstantsMjs.BrowserCacheLocation).SessionStorage:
                return new (0, _sessionStorageMjs.SessionStorage)();
            case (0, _browserConstantsMjs.BrowserCacheLocation).MemoryStorage:
            default:
                break;
        }
    } catch (e) {
        logger.error(e, "");
    }
    return new (0, _memoryStorageMjs.MemoryStorage)();
}
const DEFAULT_BROWSER_CACHE_MANAGER = (clientId, logger, performanceClient, eventHandler)=>{
    const cacheOptions = {
        cacheLocation: (0, _browserConstantsMjs.BrowserCacheLocation).MemoryStorage,
        cacheRetentionDays: 5
    };
    return new BrowserCacheManager(clientId, cacheOptions, (0, _browser.DEFAULT_CRYPTO_IMPLEMENTATION), logger, performanceClient, eventHandler);
};

},{"@azure/msal-common/browser":[["AccountEntityUtils","kwYyZ","*"],["AuthToken","l1q48","*"],["buildTenantProfile","glI6y"],["CacheError","bGBk6"],["createCacheError","bGBk6"],["CacheErrorCodes","fM0KW","*"],["CacheHelpers","61GoB","*"],["CacheManager","iTtoF"],["Constants","5eRZy","*"],["DEFAULT_CRYPTO_IMPLEMENTATION","l3pFH"],["getTenantIdFromIdTokenClaims","dKH9k"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"],["StringUtils","d70Cd"],["TimeUtils","6CLZ0","*"]],"../error/BrowserAuthError.mjs":"k9YIy","../utils/BrowserConstants.mjs":"5kHn0","./CacheKeys.mjs":"gsAy0","./LocalStorage.mjs":"diYxJ","./SessionStorage.mjs":"j6Bc1","./MemoryStorage.mjs":"a1m3z","../encode/Base64Decode.mjs":"evkpn","../encode/Base64Encode.mjs":"b1HK9","./CookieStorage.mjs":"iGzYs","./CacheHelpers.mjs":"4zYVG","../event/EventType.mjs":"gVLUh","../utils/BrowserUtils.mjs":"eyRWO","../packageMetadata.mjs":"7kVpA","../utils/Helpers.mjs":"eUwZu","./EncryptedData.mjs":"4Aoo5","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bGBk6":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheErrorCodes", ()=>_cacheErrorCodesMjs);
parcelHelpers.export(exports, "CacheError", ()=>CacheError);
parcelHelpers.export(exports, "createCacheError", ()=>createCacheError);
var _cacheErrorCodesMjs = require("./CacheErrorCodes.mjs");
var _authErrorMjs = require("./AuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the cache
 */ class CacheError extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || (0, _authErrorMjs.getDefaultErrorMessage)(errorCode);
        super(message);
        Object.setPrototypeOf(this, CacheError.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function createCacheError(e) {
    if (!(e instanceof Error)) return new CacheError((0, _cacheErrorCodesMjs.cacheErrorUnknown));
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new CacheError((0, _cacheErrorCodesMjs.cacheQuotaExceeded));
    else return new CacheError(e.name, e.message);
}

},{"./CacheErrorCodes.mjs":"fM0KW","./AuthError.mjs":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fM0KW":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cacheErrorUnknown", ()=>cacheErrorUnknown);
parcelHelpers.export(exports, "cacheQuotaExceeded", ()=>cacheQuotaExceeded);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const cacheQuotaExceeded = "cache_quota_exceeded";
const cacheErrorUnknown = "cache_error_unknown";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iTtoF":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheManager", ()=>CacheManager);
parcelHelpers.export(exports, "DefaultStorageClass", ()=>DefaultStorageClass);
var _accountInfoMjs = require("../account/AccountInfo.mjs");
var _authTokenMjs = require("../account/AuthToken.mjs");
var _authorityMetadataMjs = require("../authority/AuthorityMetadata.mjs");
var _authErrorMjs = require("../error/AuthError.mjs");
var _cacheErrorMjs = require("../error/CacheError.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _scopeSetMjs = require("../request/ScopeSet.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _accountEntityUtilsMjs = require("./utils/AccountEntityUtils.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class CacheManager {
    constructor(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        this.staticAuthorityOptions = staticAuthorityOptions;
        this.performanceClient = performanceClient;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter = {}, correlationId) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        if (Object.keys(accountFilter).length === 0 || Object.values(accountFilter).every((value)=>value === null || value === undefined || value === "")) {
            this.commonLogger.warning("1skb02", correlationId);
            return null;
        }
        const allAccounts = this.getAllAccounts(accountFilter, correlationId);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((a, b)=>{
                const aHasClaims = a.idTokenClaims ? 1 : 0;
                const bHasClaims = b.idTokenClaims ? 1 : 0;
                return bHasClaims - aHasClaims;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return (0, _accountEntityUtilsMjs.getAccountInfo)(accountEntities[0]);
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, _authTokenMjs.extractTokenClaims)(idToken.secret, this.cryptoImpl.base64Decode, correlationId);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, _accountInfoMjs.updateAccountTenantProfileData)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = (0, _accountEntityUtilsMjs.getAccountInfo)(accountEntity);
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        if (!!tenantProfileFilter.username && !this.matchUsername(tenantProfile.username, tenantProfileFilter.username) && !this.matchUsername(tenantProfile.upn, tenantProfileFilter.username)) return false;
        if (!!tenantProfileFilter.loginHint && !this.matchLoginHintWithTenantProfile(tenantProfile, tenantProfileFilter.loginHint)) return false;
        if (!!tenantProfileFilter.upn && !(tenantProfile.upn === tenantProfileFilter.upn)) return false;
        if (!!tenantProfileFilter.nativeAccountId && tenantProfile.nativeAccountId !== tenantProfileFilter.nativeAccountId) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username) && !this.matchUsername(idTokenClaims.upn, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        if (!cacheRecord) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.invalidCacheRecord), correlationId);
        try {
            if (!!cacheRecord.account) await this.setAccount(cacheRecord.account, correlationId, kmsi, apiId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) await this.setIdTokenCredential(cacheRecord.idToken, correlationId, kmsi);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId, kmsi);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) await this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId, kmsi);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error("0j476p", correlationId);
            if (e instanceof (0, _authErrorMjs.AuthError)) throw e;
            else throw (0, _cacheErrorMjs.createCacheError)(e);
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential, correlationId, kmsi) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, _scopeSetMjs.ScopeSet).fromString(credential.target, correlationId);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter, correlationId)) {
                const tokenScopeSet = (0, _scopeSetMjs.ScopeSet).fromString(tokenEntity.target, correlationId);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        await this.setAccessTokenCredential(credential, correlationId, kmsi);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            const entity = this.getAccount(cacheKey, correlationId);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment, correlationId)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name,
                username: accountFilter?.username,
                loginHint: accountFilter?.loginHint,
                upn: accountFilter?.upn,
                nativeAccountId: accountFilter?.nativeAccountId
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @param correlationId
     * @returns
     */ credentialMatchesFilter(entity, filter, correlationId) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target, correlationId)) return false;
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, _constantsMjs.CredentialType).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, _constantsMjs.AuthenticationScheme).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        // Additional cache key components matching (bidirectional isolation)
        const entityComponents = entity.additionalCacheKeyComponents;
        const filterComponents = filter.additionalCacheKeyComponents;
        const entityHasComponents = !!entityComponents && Object.keys(entityComponents).length > 0;
        const filterHasComponents = !!filterComponents && Object.keys(filterComponents).length > 0;
        if (entityHasComponents !== filterHasComponents) return false;
        if (entityHasComponents && filterHasComponents) {
            const entityKeys = Object.keys(entityComponents).sort();
            const filterKeys = Object.keys(filterComponents).sort();
            if (entityKeys.length !== filterKeys.length) return false;
            for(let i = 0; i < entityKeys.length; i++){
                if (entityKeys[i] !== filterKeys[i] || entityComponents[entityKeys[i]] !== filterComponents[filterKeys[i]]) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     * @param correlationId
     */ getAppMetadataFilteredBy(filter, correlationId) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param host
     * @param correlationId
     */ getAuthorityMetadataByAlias(host, correlationId) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ removeAllAccounts(correlationId) {
        const accounts = this.getAllAccounts({}, correlationId);
        accounts.forEach((account)=>{
            this.removeAccount(account, correlationId);
        });
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ removeAccount(account, correlationId) {
        this.removeAccountContext(account, correlationId);
        const accountKeys = this.getAccountKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        accountKeys.filter(keyFilter).forEach((key)=>{
            this.removeItem(key, correlationId);
            this.performanceClient.incrementFields({
                accountsRemoved: 1
            }, correlationId);
        });
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        allTokenKeys.idToken.filter(keyFilter).forEach((key)=>{
            this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.filter(keyFilter).forEach((key)=>{
            this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.filter(keyFilter).forEach((key)=>{
            this.removeRefreshToken(key, correlationId);
        });
    }
    /**
     * returns a boolean if the given credential is removed
     * @param key
     * @param correlationId
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        if (!credential) return;
        this.removeItem(key, correlationId);
        this.performanceClient.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        if (credential.credentialType.toLowerCase() === (0, _constantsMjs.CredentialType).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) {
            if (credential.tokenType === (0, _constantsMjs.AuthenticationScheme).POP) {
                const accessTokenWithAuthSchemeEntity = credential;
                const kid = accessTokenWithAuthSchemeEntity.keyId;
                if (kid) this.cryptoImpl.removeTokenBindingKey(kid, correlationId).catch(()=>{
                    this.commonLogger.error(`0cx291 ${kid}`, correlationId);
                    this.performanceClient?.incrementFields({
                        removeTokenBindingKeyFailure: 1
                    }, correlationId);
                });
            }
        }
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm) {
        this.commonLogger.trace("1drz22", correlationId);
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, _constantsMjs.CredentialType).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("1atvtd", correlationId);
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("0ooalx", correlationId);
                    return idTokenMap.values().next().value ?? null;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("1eq2vc", correlationId);
                    return homeIdTokenMap.values().next().value ?? null;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("1ws328", correlationId);
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("1sm769", correlationId);
        return idTokenMap.values().next().value ?? null;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter, correlationId)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getAccessToken(account, request, tokenKeys, targetRealm) {
        const correlationId = request.correlationId;
        this.commonLogger.trace("1t7hz1", correlationId);
        const scopes = (0, _scopeSetMjs.ScopeSet).createSearchScopes(request.scopes, correlationId);
        const authScheme = request.authenticationScheme || (0, _constantsMjs.AuthenticationScheme).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, _constantsMjs.AuthenticationScheme).BEARER.toLowerCase() ? (0, _constantsMjs.CredentialType).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, _constantsMjs.CredentialType).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter, correlationId)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("1nckna", correlationId);
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("1wkfwp", correlationId);
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken(this.generateCredentialKey(accessToken), correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("06yt98", correlationId);
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter, correlationId)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys) {
        this.commonLogger.trace("0x53vi", correlationId);
        const id = familyRT ? (0, _constantsMjs.THE_FAMILY_ID) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, _constantsMjs.CredentialType).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter, correlationId)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("0dlw11", correlationId);
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1) this.performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("0wcnep", correlationId);
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment, correlationId) {
        const appMetadataFilter = {
            environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter, correlationId);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.multipleMatchingAppMetadata), correlationId);
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment, correlationId) {
        const appMetadata = this.readAppMetadataFromCache(environment, correlationId);
        return !!(appMetadata && appMetadata.familyId === (0, _constantsMjs.THE_FAMILY_ID));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match loginhints
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintWithTenantProfile(tenantProfile, loginHintFilter) {
        return tenantProfile.loginHint === loginHintFilter || tenantProfile.username === loginHintFilter || tenantProfile.upn === loginHintFilter;
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment, correlationId) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, _authorityMetadataMjs.getAliasesFromStaticSources)(this.staticAuthorityOptions, this.commonLogger, correlationId);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment, correlationId);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        // check login hint against list of emails in token claims
        if (tokenClaims.emails && tokenClaims.emails.includes(loginHint)) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target, correlationId) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, _constantsMjs.CredentialType).ACCESS_TOKEN && entity.credentialType !== (0, _constantsMjs.CredentialType).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, _scopeSetMjs.ScopeSet).fromString(entity.target, correlationId);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, _constantsMjs.APP_METADATA)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, _constantsMjs.AUTHORITY_METADATA_CACHE_KEY)) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${0, _constantsMjs.AUTHORITY_METADATA_CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class DefaultStorageClass extends CacheManager {
    async setAccount() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getAccount() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    async setIdTokenCredential() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getIdTokenCredential() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    async setAccessTokenCredential() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getAccessTokenCredential() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    async setRefreshTokenCredential() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getRefreshTokenCredential() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    setAppMetadata() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getAppMetadata() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    setServerTelemetry() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getServerTelemetry() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    setAuthorityMetadata() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getAuthorityMetadata() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getAuthorityMetadataKeys() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    setThrottlingCache() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getThrottlingCache() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    removeItem() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getKeys() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getAccountKeys() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    getTokenKeys() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    generateCredentialKey() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
    generateAccountKey() {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
}

},{"../account/AccountInfo.mjs":"glI6y","../account/AuthToken.mjs":"l1q48","../authority/AuthorityMetadata.mjs":"4P5NR","../error/AuthError.mjs":"8TWYe","../error/CacheError.mjs":"bGBk6","../error/ClientAuthError.mjs":"e8Ku4","../packageMetadata.mjs":"ftCED","../request/ScopeSet.mjs":"7niwa","../utils/Constants.mjs":"5eRZy","./utils/AccountEntityUtils.mjs":"kwYyZ","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ftCED":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "version", ()=>version);
'use strict';
/* eslint-disable header/header */ const name = "@azure/msal-common";
const version = "16.11.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gsAy0":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCOUNT_KEYS", ()=>ACCOUNT_KEYS);
parcelHelpers.export(exports, "ACCOUNT_SCHEMA_VERSION", ()=>ACCOUNT_SCHEMA_VERSION);
parcelHelpers.export(exports, "BROWSER_PERF_ENABLED_KEY", ()=>BROWSER_PERF_ENABLED_KEY);
parcelHelpers.export(exports, "CACHE_KEY_SEPARATOR", ()=>CACHE_KEY_SEPARATOR);
parcelHelpers.export(exports, "CREDENTIAL_SCHEMA_VERSION", ()=>CREDENTIAL_SCHEMA_VERSION);
parcelHelpers.export(exports, "LOG_LEVEL_CACHE_KEY", ()=>LOG_LEVEL_CACHE_KEY);
parcelHelpers.export(exports, "LOG_PII_CACHE_KEY", ()=>LOG_PII_CACHE_KEY);
parcelHelpers.export(exports, "PREFIX", ()=>PREFIX);
parcelHelpers.export(exports, "SSO_CAPABLE", ()=>SSO_CAPABLE);
parcelHelpers.export(exports, "TOKEN_KEYS", ()=>TOKEN_KEYS);
parcelHelpers.export(exports, "VERSION_CACHE_KEY", ()=>VERSION_CACHE_KEY);
parcelHelpers.export(exports, "getAccountKeysCacheKey", ()=>getAccountKeysCacheKey);
parcelHelpers.export(exports, "getTokenKeysCacheKey", ()=>getTokenKeysCacheKey);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const PREFIX = "msal";
const BROWSER_PREFIX = "browser";
const CACHE_KEY_SEPARATOR = "|";
const CREDENTIAL_SCHEMA_VERSION = 3;
const ACCOUNT_SCHEMA_VERSION = 3;
const LOG_LEVEL_CACHE_KEY = `${PREFIX}.${BROWSER_PREFIX}.log.level`;
const LOG_PII_CACHE_KEY = `${PREFIX}.${BROWSER_PREFIX}.log.pii`;
const BROWSER_PERF_ENABLED_KEY = `${PREFIX}.${BROWSER_PREFIX}.performance.enabled`;
const VERSION_CACHE_KEY = `${PREFIX}.version`;
const ACCOUNT_KEYS = "account.keys";
const TOKEN_KEYS = "token.keys";
const SSO_CAPABLE = `${PREFIX}.${BROWSER_PREFIX}.sso.capable`;
function getAccountKeysCacheKey(schema = ACCOUNT_SCHEMA_VERSION) {
    if (schema < 1) return `${PREFIX}.${ACCOUNT_KEYS}`;
    return `${PREFIX}.${schema}.${ACCOUNT_KEYS}`;
}
function getTokenKeysCacheKey(clientId, schema = CREDENTIAL_SCHEMA_VERSION) {
    if (schema < 1) return `${PREFIX}.${TOKEN_KEYS}.${clientId}`;
    return `${PREFIX}.${schema}.${TOKEN_KEYS}.${clientId}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"diYxJ":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalStorage", ()=>LocalStorage);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserRootPerformanceEventsMjs = require("../telemetry/BrowserRootPerformanceEvents.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _base64EncodeMjs = require("../encode/Base64Encode.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserConfigurationAuthErrorMjs = require("../error/BrowserConfigurationAuthError.mjs");
var _cookieStorageMjs = require("./CookieStorage.mjs");
var _memoryStorageMjs = require("./MemoryStorage.mjs");
var _cacheHelpersMjs = require("./CacheHelpers.mjs");
var _cacheKeysMjs = require("./CacheKeys.mjs");
var _encryptedDataMjs = require("./EncryptedData.mjs");
var _browserConfigurationAuthErrorCodesMjs = require("../error/BrowserConfigurationAuthErrorCodes.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const ENCRYPTION_KEY = "msal.cache.encryption";
const BROADCAST_CHANNEL_NAME = "msal.broadcast.cache";
class LocalStorage {
    constructor(clientId, logger, performanceClient){
        if (!window.localStorage) throw (0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.storageNotSupported), "");
        this.memoryStorage = new (0, _memoryStorageMjs.MemoryStorage)();
        this.initialized = false;
        this.clientId = clientId;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.broadcast = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
    }
    async initialize(correlationId) {
        const cookies = new (0, _cookieStorageMjs.CookieStorage)();
        const cookieString = cookies.getItem(ENCRYPTION_KEY);
        let parsedCookie = {
            key: "",
            id: ""
        };
        if (cookieString) try {
            parsedCookie = JSON.parse(cookieString);
        } catch (e) {}
        if (parsedCookie.key && parsedCookie.id) {
            // Encryption key already exists, import
            const baseKey = (0, _browser.invoke)((0, _base64DecodeMjs.base64DecToArr), (0, _browserPerformanceEventsMjs.Base64Decode), this.logger, this.performanceClient, correlationId)(parsedCookie.key);
            this.encryptionCookie = {
                id: parsedCookie.id,
                key: await (0, _browser.invokeAsync)((0, _browserCryptoMjs.generateHKDF), (0, _browserPerformanceEventsMjs.GenerateHKDF), this.logger, this.performanceClient, correlationId)(baseKey)
            };
        } else {
            // Encryption key doesn't exist or is invalid, generate a new one
            const id = (0, _browserCryptoMjs.createNewGuid)();
            const baseKey = await (0, _browser.invokeAsync)((0, _browserCryptoMjs.generateBaseKey), (0, _browserPerformanceEventsMjs.GenerateBaseKey), this.logger, this.performanceClient, correlationId)();
            const keyStr = (0, _browser.invoke)((0, _base64EncodeMjs.urlEncodeArr), (0, _browserPerformanceEventsMjs.UrlEncodeArr), this.logger, this.performanceClient, correlationId)(new Uint8Array(baseKey));
            this.encryptionCookie = {
                id: id,
                key: await (0, _browser.invokeAsync)((0, _browserCryptoMjs.generateHKDF), (0, _browserPerformanceEventsMjs.GenerateHKDF), this.logger, this.performanceClient, correlationId)(baseKey)
            };
            const cookieData = {
                id: id,
                key: keyStr
            };
            cookies.setItem(ENCRYPTION_KEY, JSON.stringify(cookieData), 0, true, (0, _cookieStorageMjs.SameSiteOptions).None // SameSite must be None to support iframed apps
            );
        }
        await (0, _browser.invokeAsync)(this.importExistingCache.bind(this), (0, _browserPerformanceEventsMjs.ImportExistingCache), this.logger, this.performanceClient, correlationId)(correlationId);
        // Register listener for cache updates in other tabs
        this.broadcast.addEventListener("message", (event)=>{
            this.updateCache(event, correlationId);
        });
        this.initialized = true;
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    getUserData(key) {
        if (!this.initialized) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.uninitializedPublicClientApplication), "");
        return this.memoryStorage.getItem(key);
    }
    async decryptData(key, data, correlationId) {
        if (!this.initialized || !this.encryptionCookie) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.uninitializedPublicClientApplication), "");
        if (data.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = await (0, _browser.invokeAsync)((0, _browserCryptoMjs.decrypt), (0, _browserPerformanceEventsMjs.Decrypt), this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, data.nonce, this.getContext(key), data.data);
        if (!decryptedData) return null;
        try {
            return {
                ...JSON.parse(decryptedData),
                lastUpdatedAt: data.lastUpdatedAt
            };
        } catch (e) {
            this.performanceClient.incrementFields({
                encryptedCacheCorruptionCount: 1
            }, correlationId);
            return null;
        }
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    async setUserData(key, value, correlationId, timestamp, kmsi) {
        if (!this.initialized || !this.encryptionCookie) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.uninitializedPublicClientApplication), "");
        if (kmsi) this.setItem(key, value);
        else {
            const { data, nonce } = await (0, _browser.invokeAsync)((0, _browserCryptoMjs.encrypt), (0, _browserPerformanceEventsMjs.Encrypt), this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, value, this.getContext(key));
            const encryptedData = {
                id: this.encryptionCookie.id,
                nonce: nonce,
                data: data,
                lastUpdatedAt: timestamp
            };
            this.setItem(key, JSON.stringify(encryptedData));
        }
        this.memoryStorage.setItem(key, value);
        // Notify other frames to update their in-memory cache
        this.broadcast.postMessage({
            key: key,
            value: value,
            context: this.getContext(key)
        });
    }
    removeItem(key) {
        if (this.memoryStorage.containsKey(key)) {
            this.memoryStorage.removeItem(key);
            this.broadcast.postMessage({
                key: key,
                value: null,
                context: this.getContext(key)
            });
        }
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
    /**
     * Removes all known MSAL keys from the cache
     */ clear() {
        // Removes all remaining MSAL cache items
        this.memoryStorage.clear();
        const accountKeys = (0, _cacheHelpersMjs.getAccountKeys)(this);
        accountKeys.forEach((key)=>this.removeItem(key));
        const tokenKeys = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this);
        tokenKeys.idToken.forEach((key)=>this.removeItem(key));
        tokenKeys.accessToken.forEach((key)=>this.removeItem(key));
        tokenKeys.refreshToken.forEach((key)=>this.removeItem(key));
        // Clean up anything left
        this.getKeys().forEach((cacheKey)=>{
            if (cacheKey.startsWith((0, _cacheKeysMjs.PREFIX)) || cacheKey.indexOf(this.clientId) !== -1) this.removeItem(cacheKey);
        });
    }
    /**
     * Helper to decrypt all known MSAL keys in localStorage and save them to inMemory storage
     * @returns
     */ async importExistingCache(correlationId) {
        if (!this.encryptionCookie) return;
        let accountKeys = (0, _cacheHelpersMjs.getAccountKeys)(this);
        accountKeys = await this.importArray(accountKeys, correlationId);
        // Write valid account keys back to map
        if (accountKeys.length) this.setItem((0, _cacheKeysMjs.getAccountKeysCacheKey)(), JSON.stringify(accountKeys));
        else this.removeItem((0, _cacheKeysMjs.getAccountKeysCacheKey)());
        const tokenKeys = (0, _cacheHelpersMjs.getTokenKeys)(this.clientId, this);
        tokenKeys.idToken = await this.importArray(tokenKeys.idToken, correlationId);
        tokenKeys.accessToken = await this.importArray(tokenKeys.accessToken, correlationId);
        tokenKeys.refreshToken = await this.importArray(tokenKeys.refreshToken, correlationId);
        // Write valid token keys back to map
        if (tokenKeys.idToken.length || tokenKeys.accessToken.length || tokenKeys.refreshToken.length) this.setItem((0, _cacheKeysMjs.getTokenKeysCacheKey)(this.clientId), JSON.stringify(tokenKeys));
        else this.removeItem((0, _cacheKeysMjs.getTokenKeysCacheKey)(this.clientId));
    }
    /**
     * Helper to decrypt and save cache entries
     * @param key
     * @returns
     */ async getItemFromEncryptedCache(key, correlationId) {
        if (!this.encryptionCookie) return null;
        const rawCache = this.getItem(key);
        if (!rawCache) return null;
        let encObj;
        try {
            encObj = JSON.parse(rawCache);
        } catch (e) {
            // Not a valid encrypted object, remove
            return null;
        }
        if (!(0, _encryptedDataMjs.isEncrypted)(encObj)) {
            // Data is not encrypted
            this.performanceClient.incrementFields({
                unencryptedCacheCount: 1
            }, correlationId);
            return rawCache;
        }
        if (encObj.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        this.performanceClient.incrementFields({
            encryptedCacheCount: 1
        }, correlationId);
        return (0, _browser.invokeAsync)((0, _browserCryptoMjs.decrypt), (0, _browserPerformanceEventsMjs.Decrypt), this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, encObj.nonce, this.getContext(key), encObj.data);
    }
    /**
     * Helper to decrypt and save an array of cache keys
     * @param arr
     * @returns Array of keys successfully imported
     */ async importArray(arr, correlationId) {
        const importedArr = [];
        const promiseArr = [];
        arr.forEach((key)=>{
            const promise = this.getItemFromEncryptedCache(key, correlationId).then((value)=>{
                if (value) {
                    this.memoryStorage.setItem(key, value);
                    importedArr.push(key);
                } else // If value is empty, unencrypted or expired remove
                this.removeItem(key);
            });
            promiseArr.push(promise);
        });
        await Promise.all(promiseArr);
        return importedArr;
    }
    /**
     * Gets encryption context for a given cache entry. This is clientId for app specific entries, empty string for shared entries
     * @param key
     * @returns
     */ getContext(key) {
        let context = "";
        if (key.includes(this.clientId)) context = this.clientId; // Used to bind encryption key to this appId
        return context;
    }
    updateCache(event, correlationId) {
        this.logger.trace("17cxcm", correlationId);
        const perfMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.LocalStorageUpdated));
        perfMeasurement.add({
            isBackground: true
        });
        const { key, value, context } = event.data;
        if (!key) {
            this.logger.error("0e10qr", correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "noKey"
            });
            return;
        }
        if (context && context !== this.clientId) {
            this.logger.trace(`04rtdy ${context}`, correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "contextMismatch"
            });
            return;
        }
        if (!value) {
            this.memoryStorage.removeItem(key);
            this.logger.verbose("04ypih", correlationId);
        } else {
            this.memoryStorage.setItem(key, value);
            this.logger.verbose("1vzsgt", correlationId);
        }
        perfMeasurement.end({
            success: true
        });
    }
}

},{"@azure/msal-common/browser":"4kFBF","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../telemetry/BrowserRootPerformanceEvents.mjs":"cD5vH","../crypto/BrowserCrypto.mjs":"a5L0H","../encode/Base64Decode.mjs":"evkpn","../encode/Base64Encode.mjs":"b1HK9","../error/BrowserAuthError.mjs":"k9YIy","../error/BrowserConfigurationAuthError.mjs":"401zU","./CookieStorage.mjs":"iGzYs","./MemoryStorage.mjs":"a1m3z","./CacheHelpers.mjs":"4zYVG","./CacheKeys.mjs":"gsAy0","./EncryptedData.mjs":"4Aoo5","../error/BrowserConfigurationAuthErrorCodes.mjs":"f0n3B","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iGzYs":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CookieStorage", ()=>CookieStorage);
parcelHelpers.export(exports, "SameSiteOptions", ()=>SameSiteOptions);
parcelHelpers.export(exports, "getCookieExpirationTime", ()=>getCookieExpirationTime);
var _browser = require("@azure/msal-common/browser");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const COOKIE_LIFE_MULTIPLIER = 86400000;
const SameSiteOptions = {
    Lax: "Lax",
    None: "None"
};
class CookieStorage {
    initialize() {
        return Promise.resolve();
    }
    getItem(key) {
        const name = encodeURIComponent(key);
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i].trim();
            const eqIndex = cookie.indexOf("=");
            const rawKey = eqIndex === -1 ? cookie : cookie.substring(0, eqIndex);
            if (rawKey === name) {
                const rawValue = eqIndex === -1 ? "" : cookie.substring(eqIndex + 1);
                try {
                    return decodeURIComponent(rawValue);
                } catch  {
                    return rawValue;
                }
            }
        }
        return "";
    }
    getUserData() {
        throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).methodNotImplemented, "");
    }
    setItem(key, value, cookieLifeDays, secure = true, sameSite = SameSiteOptions.Lax) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=${sameSite};`;
        if (cookieLifeDays) {
            const expireTime = getCookieExpirationTime(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure || sameSite === SameSiteOptions.None) // SameSite None requires Secure flag
        cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    async setUserData(_key, _value, correlationId) {
        return Promise.reject((0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).methodNotImplemented, correlationId));
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const trimmed = cookie.trim();
            const eqIndex = trimmed.indexOf("=");
            const rawKey = eqIndex === -1 ? trimmed : trimmed.substring(0, eqIndex);
            try {
                keys.push(decodeURIComponent(rawKey));
            } catch  {
            // Skip cookies with malformed percent-encoded sequences in the key
            }
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
    decryptData() {
        // Cookie storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function getCookieExpirationTime(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}

},{"@azure/msal-common/browser":[["ClientAuthErrorCodes","8keAa","*"],["createClientAuthError","e8Ku4"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4zYVG":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccountKeys", ()=>getAccountKeys);
parcelHelpers.export(exports, "getTokenKeys", ()=>getTokenKeys);
var _cacheKeysMjs = require("./CacheKeys.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns a list of cache keys for all known accounts
 * @param storage
 * @returns
 */ function getAccountKeys(storage, schemaVersion) {
    const accountKeys = storage.getItem((0, _cacheKeysMjs.getAccountKeysCacheKey)(schemaVersion));
    if (accountKeys) return JSON.parse(accountKeys);
    return [];
}
/**
 * Returns a list of cache keys for all known tokens
 * @param clientId
 * @param storage
 * @returns
 */ function getTokenKeys(clientId, storage, schemaVersion) {
    const item = storage.getItem((0, _cacheKeysMjs.getTokenKeysCacheKey)(clientId, schemaVersion));
    if (item) {
        const tokenKeys = JSON.parse(item);
        if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
    }
    return {
        idToken: [],
        accessToken: [],
        refreshToken: []
    };
}

},{"./CacheKeys.mjs":"gsAy0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4Aoo5":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEncrypted", ()=>isEncrypted);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function isEncrypted(data) {
    return data.hasOwnProperty("id") && data.hasOwnProperty("nonce") && data.hasOwnProperty("data");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"j6Bc1":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionStorage", ()=>SessionStorage);
var _browserConfigurationAuthErrorMjs = require("../error/BrowserConfigurationAuthError.mjs");
var _browserConfigurationAuthErrorCodesMjs = require("../error/BrowserConfigurationAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class SessionStorage {
    constructor(){
        if (!window.sessionStorage) throw (0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.storageNotSupported), "");
    }
    async initialize() {
    // Session storage does not require initialization
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
    decryptData() {
        // Session storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}

},{"../error/BrowserConfigurationAuthError.mjs":"401zU","../error/BrowserConfigurationAuthErrorCodes.mjs":"f0n3B","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gVLUh":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventType", ()=>EventType);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const EventType = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_SUCCESS: "msal:loginSuccess",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    BROKERED_REQUEST_START: "msal:brokeredRequestStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    BROKERED_REQUEST_SUCCESS: "msal:brokeredRequestSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    BROKERED_REQUEST_FAILURE: "msal:brokeredRequestFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
    BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7kVpA":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "version", ()=>version);
'use strict';
/* eslint-disable header/header */ const name = "@azure/msal-browser";
const version = "5.17.1";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eUwZu":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeElementFromArray", ()=>removeElementFromArray);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility function to remove an element from an array in place.
 * @param array - The array from which to remove the element.
 * @param element - The element to remove from the array.
 */ function removeElementFromArray(array, element) {
    const index = array.indexOf(element);
    if (index > -1) array.splice(index, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"21SSU":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccount", ()=>getAccount);
parcelHelpers.export(exports, "getActiveAccount", ()=>getActiveAccount);
parcelHelpers.export(exports, "getAllAccounts", ()=>getAllAccounts);
parcelHelpers.export(exports, "setActiveAccount", ()=>setActiveAccount);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function getAllAccounts(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("1yd030", correlationId);
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter, correlationId) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function getAccount(accountFilter, logger, browserStorage, correlationId) {
    logger.trace("0u7b90", correlationId);
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("0btgll", correlationId);
        return account;
    } else {
        logger.verbose("0ltaj5", correlationId);
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function setActiveAccount(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function getActiveAccount(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5hEJZ":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventHandler", ()=>EventHandler);
var _browser = require("@azure/msal-common/browser");
var _eventTypeMjs = require("./EventType.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const BROADCAST_CHANNEL_NAME = "msal.broadcast.event";
class EventHandler {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, _browser.Logger)({}, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        if (typeof BroadcastChannel !== "undefined") this.broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
        this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, _browserUtilsMjs.createGuid)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`1578i0 ${id}`, "");
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`1cnec4 ${id}`, "");
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`12zotd ${callbackId}`, "");
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, correlationId, interactionType, payload, error) {
        const message = {
            eventType: eventType,
            interactionType: interactionType || null,
            payload: payload || null,
            error: error || null,
            correlationId: correlationId,
            timestamp: Date.now()
        };
        switch(eventType){
            case (0, _eventTypeMjs.EventType).LOGIN_SUCCESS:
            case (0, _eventTypeMjs.EventType).LOGOUT_SUCCESS:
            case (0, _eventTypeMjs.EventType).ACTIVE_ACCOUNT_CHANGED:
                // Send event to other open tabs / MSAL instances on same domain
                this.broadcastChannel?.postMessage(message);
        }
        // Emit event to callbacks registered in this instance
        this.invokeCallbacks(message);
    }
    /**
     * Invoke registered callbacks
     * @param message
     */ invokeCallbacks(message) {
        this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
            if (eventTypes.length === 0 || eventTypes.includes(message.eventType)) {
                this.logger.verbose(`15jpwk ${callbackId} ${message.eventType}`, "");
                callback.apply(null, [
                    message
                ]);
            }
        });
    }
    /**
     * Wrapper around invokeCallbacks to handle broadcast events received from other tabs/instances
     * @param event
     */ invokeCrossTabCallbacks(event) {
        const message = event.data;
        this.invokeCallbacks(message);
    }
    /**
     * Listen for events broadcasted from other tabs/instances
     */ subscribeCrossTab() {
        this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
    }
    /**
     * Unsubscribe from broadcast events
     */ unsubscribeCrossTab() {
        this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
    }
}

},{"@azure/msal-common/browser":"9bvcp","./EventType.mjs":"gVLUh","../utils/BrowserUtils.mjs":"eyRWO","../packageMetadata.mjs":"7kVpA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kRkU6":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopupClient", ()=>PopupClient);
var _browser = require("@azure/msal-common/browser");
var _standardInteractionClientMjs = require("./StandardInteractionClient.mjs");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _eventTypeMjs = require("../event/EventType.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _relayClientMjs = require("../popup_relay/relayClient.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _responseHandlerMjs = require("../response/ResponseHandler.mjs");
var _authorizeMjs = require("../protocol/Authorize.mjs");
var _pkceGeneratorMjs = require("../crypto/PkceGenerator.mjs");
var _platformAuthProviderMjs = require("../broker/nativeBroker/PlatformAuthProvider.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _requestHelpersMjs = require("../request/RequestHelpers.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class PopupClient extends (0, _standardInteractionClientMjs.StandardInteractionClient) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler, waitForPopupResponseHook){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler);
        this.nativeStorage = nativeStorageImpl;
        this.eventHandler = eventHandler;
        this.waitForPopupResponseHook = waitForPopupResponseHook;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     * @param pkceCodes
     */ acquireToken(request, pkceCodes) {
        let popupParams = undefined;
        try {
            const popupName = this.generatePopupName(request.scopes || (0, _browser.Constants).OIDC_DEFAULT_SCOPES, request.authority || this.config.auth.authority);
            popupParams = {
                popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            this.performanceClient.addFields({
                isAsyncPopup: !this.config.system.navigatePopups
            }, this.correlationId);
            // navigatePopups flag is false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("162h4u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            } else {
                // navigatePopups flag is set to true. Opens popup before acquiring token.
                // Pre-validate request method to avoid opening popup if the request is invalid
                const validatedRequest = {
                    ...request,
                    httpMethod: (0, _requestHelpersMjs.validateRequestMethod)(request, this.config.system.protocolMode)
                };
                this.logger.verbose("1f9ok3", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(validatedRequest, popupParams, pkceCodes);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("068rup", this.correlationId);
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // navigatePopups flag set to false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("1phd8u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // navigatePopups flag is set to true. Opens popup before logging out.
                this.logger.verbose("1a28da", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param request
     * @param popupParams
     * @param pkceCodes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams, pkceCodes) {
        this.logger.verbose("1g77pg", this.correlationId);
        const validRequest = await (0, _browser.invokeAsync)((0, _standardInteractionClientMjs.initializeAuthorizationRequest), (0, _browserPerformanceEventsMjs.StandardInteractionClientInitializeAuthorizationRequest), this.logger, this.performanceClient, this.correlationId)(request, (0, _browserConstantsMjs.InteractionType).Popup, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        /*
         * Skip pre-connect for async popups to reduce time between user interaction and popup window creation to avoid
         * popup from being blocked by browsers with shorter popup timers
         */ if (popupParams.popup) (0, _browserUtilsMjs.preconnect)(validRequest.authority);
        const isPlatformBroker = (0, _platformAuthProviderMjs.isPlatformAuthAllowed)(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        validRequest.platformBroker = isPlatformBroker;
        if (this.config.system.protocolMode === (0, _browser.ProtocolMode).EAR) return this.executeEarFlow(validRequest, popupParams, pkceCodes);
        else return this.executeCodeFlow(validRequest, popupParams, pkceCodes);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @param popupParams
     * @param pkceCodes
     * @returns
     */ async executeCodeFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).acquireTokenPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkce = pkceCodes || await (0, _browser.invokeAsync)((0, _pkceGeneratorMjs.generatePkceCodes), (0, _browserPerformanceEventsMjs.GeneratePkceCodes), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            codeChallenge: pkce.challenge
        };
        try {
            // Initialize the client
            const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager,
                requestAuthority: popupRequest.authority,
                requestAzureCloudOptions: popupRequest.azureCloudOptions,
                requestExtraQueryParameters: popupRequest.extraQueryParameters,
                account: popupRequest.account
            });
            if (popupRequest.httpMethod === (0, _browser.Constants).HttpMethod.POST) return await this.executeCodeFlowWithPost(popupRequest, popupParams, authClient, pkce.verifier);
            else {
                // Create acquire token url.
                const navigateUrl = await (0, _browser.invokeAsync)((0, _authorizeMjs.getAuthCodeRequestUrl), (0, _browser.PerformanceEvents).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, popupRequest, this.logger, this.performanceClient);
                /*
                 * When a popup-relay page is configured, open it top-level
                 * (same first-party origin) instead of navigating the popup
                 * straight to the IdP, and carry the /authorize URL in its hash.
                 * The relay page opens the IdP child popup and relays the
                 * response back via postMessage (see waitForPopupResponse).
                 */ const popupRelayUri = this.config.auth.popupRelayUri;
                const popupNavigateUrl = popupRelayUri ? (0, _relayClientMjs.buildPopupRelayUrl)(popupRelayUri, this.getRelayStateId(request.state, correlationId), {
                    method: "GET",
                    url: navigateUrl
                }, correlationId) : navigateUrl;
                // Show the UI once the url has been created. Get the window handle for the popup.
                const popupWindow = this.initiateAuthRequest(popupNavigateUrl, popupParams);
                this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).POPUP_OPENED, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, {
                    popupWindow
                }, null);
                // Wait for the redirect bridge response
                const responseString = await this.waitForPopupResponse(request, popupWindow, popupParams.popupWindowParent);
                const serverParams = (0, _browser.invoke)((0, _responseHandlerMjs.deserializeResponse), (0, _browserPerformanceEventsMjs.DeserializeResponse), this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
                return await (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseCode), (0, _browserPerformanceEventsMjs.HandleResponseCode), this.logger, this.performanceClient, correlationId)(request, serverParams, pkce.verifier, (0, _browserConstantsMjs.ApiId).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
            }
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, _browser.AuthError)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request, popupParams, pkceCodes) {
        const { correlationId, authority, azureCloudOptions, extraQueryParameters, account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, _browser.invokeAsync)((0, _baseInteractionClientMjs.getDiscoveredAuthority), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetDiscoveredAuthority), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await (0, _browser.invokeAsync)((0, _browserCryptoMjs.generateEarKey), (0, _browserPerformanceEventsMjs.GenerateEarKey), this.logger, this.performanceClient, correlationId)();
        const pkce = pkceCodes || await (0, _browser.invokeAsync)((0, _pkceGeneratorMjs.generatePkceCodes), (0, _browserPerformanceEventsMjs.GeneratePkceCodes), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkce.challenge
        };
        const popupWindow = await this.openPostFormPopup(popupRequest, discoveredAuthority, popupParams, correlationId, true);
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, _browser.invokeAsync)(this.waitForPopupResponse.bind(this), (0, _browserPerformanceEventsMjs.SilentHandlerMonitorIframeForHash), this.logger, this.performanceClient, correlationId)(popupRequest, popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, _browser.invoke)((0, _responseHandlerMjs.deserializeResponse), (0, _browserPerformanceEventsMjs.DeserializeResponse), this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).acquireTokenPopup, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseCode), (0, _browserPerformanceEventsMjs.HandleResponseCode), this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, (0, _browserConstantsMjs.ApiId).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseEAR), (0, _browserPerformanceEventsMjs.HandleResponseEar), this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, (0, _browserConstantsMjs.ApiId).acquireTokenPopup, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async executeCodeFlowWithPost(request, popupParams, authClient, pkceVerifier) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, _browser.invokeAsync)((0, _baseInteractionClientMjs.getDiscoveredAuthority), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetDiscoveredAuthority), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        const popupWindow = await this.openPostFormPopup(request, discoveredAuthority, popupParams, correlationId, false);
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, _browser.invokeAsync)(this.waitForPopupResponse.bind(this), (0, _browserPerformanceEventsMjs.SilentHandlerMonitorIframeForHash), this.logger, this.performanceClient, correlationId)(request, popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, _browser.invoke)((0, _responseHandlerMjs.deserializeResponse), (0, _browserPerformanceEventsMjs.DeserializeResponse), this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseCode), (0, _browserPerformanceEventsMjs.HandleResponseCode), this.logger, this.performanceClient, correlationId)(request, serverParams, pkceVerifier, (0, _browserConstantsMjs.ApiId).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("0b7yrk", this.correlationId);
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_START, this.correlationId, (0, _browserConstantsMjs.InteractionType).Popup, validRequest);
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).logoutPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Clear cache on logout
            await (0, _baseInteractionClientMjs.clearCacheOnLogout)(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validRequest.account);
            // Initialize the client
            const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, _browser.ProtocolMode).OIDC) {
                    this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_SUCCESS, validRequest.correlationId, (0, _browserConstantsMjs.InteractionType).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, _browserConstantsMjs.ApiId).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, _browser.UrlString).getAbsoluteUrl(mainWindowRedirectUri, (0, _browserUtilsMjs.getCurrentUri)(), this.correlationId);
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validRequest.state = (0, _browser.ProtocolUtils).setRequestState(this.browserCrypto, validRequest.state || "", {
                interactionType: (0, _browserConstantsMjs.InteractionType).Popup
            }, validRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_SUCCESS, validRequest.correlationId, (0, _browserConstantsMjs.InteractionType).Popup, validRequest);
            /*
             * When a popup-relay page is configured, open it top-level (same
             * first-party origin) and carry the end-session URL in its hash,
             * exactly like the login flow. The relay page opens the IdP child
             * popup and the post-logout redirect page (running the redirect
             * bridge) relays completion back via postMessage — so logout works
             * from an embedded, cross-origin iframe where a direct popup to the
             * IdP cannot. See runPopupRelay / waitForPopupResponse.
             */ const popupRelayUri = this.config.auth.popupRelayUri;
            const popupNavigateUrl = popupRelayUri ? (0, _relayClientMjs.buildPopupRelayUrl)(popupRelayUri, this.getRelayStateId(validRequest.state || "", this.correlationId), {
                method: "GET",
                url: logoutUri
            }, this.correlationId) : logoutUri;
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(popupNavigateUrl, popupParams);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).POPUP_OPENED, validRequest.correlationId, (0, _browserConstantsMjs.InteractionType).Popup, {
                popupWindow
            }, null);
            await this.waitForPopupResponse(validRequest, popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, _browserConstantsMjs.ApiId).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, _browser.UrlString).getAbsoluteUrl(mainWindowRedirectUri, (0, _browserUtilsMjs.getCurrentUri)(), this.correlationId);
                this.logger.verbose("0qcur2", this.correlationId);
                this.logger.verbosePii(`0oj7lk ${absoluteUrl}`, this.correlationId);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("03zgcf", this.correlationId);
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, _browser.AuthError)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_FAILURE, this.correlationId, (0, _browserConstantsMjs.InteractionType).Popup, null, e);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_END, this.correlationId, (0, _browserConstantsMjs.InteractionType).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_END, this.correlationId, (0, _browserConstantsMjs.InteractionType).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`1kcr9k ${requestUrl}`, this.correlationId);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("1l7hyp", this.correlationId);
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.emptyNavigateUri), this.correlationId);
        }
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`0cgeo7 ${urlNavigate}`, this.correlationId);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`0c2awd ${urlNavigate}`, this.correlationId);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.emptyWindowError), this.correlationId);
            try {
                popupWindow.document.title = "Microsoft Authentication";
            } catch (e) {
                if (typeof DOMException !== "undefined" && e instanceof DOMException && e.name === "SecurityError") ;
                else this.logger.verbose("1s1yfs", this.correlationId);
            }
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            return popupWindow;
        } catch (e) {
            this.logger.error(`0dxfb9 ${e.message}`, this.correlationId);
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.popupWindowError), this.correlationId);
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName, popupWindowAttributes, popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("08vfmo", this.correlationId);
            width = (0, _browserConstantsMjs.BrowserConstants).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("09cxa0", this.correlationId);
            height = (0, _browserConstantsMjs.BrowserConstants).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("1qh4wo", this.correlationId);
            top = Math.max(0, winHeight / 2 - (0, _browserConstantsMjs.BrowserConstants).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("1sz3en", this.correlationId);
            left = Math.max(0, winWidth / 2 - (0, _browserConstantsMjs.BrowserConstants).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, _browserConstantsMjs.BrowserConstants).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, _browserConstantsMjs.BrowserConstants).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
    /**
     * Decodes the per-request library-state id from the encoded request state.
     */ getRelayStateId(state, correlationId) {
        return (0, _browser.ProtocolUtils).parseRequestState((0, _base64DecodeMjs.base64Decode), state, correlationId).libraryState.id;
    }
    /**
     * Opens the interactive popup for a POST-form /authorize request. Shared by
     * the auth-code POST and EAR flows, which are identical apart from the form
     * builder (`isEAR` selects the EAR vs auth-code builders). When a
     * popup-relay page is configured the form is carried to the relay page
     * (which opens the IdP child popup); otherwise the form is submitted
     * directly into the popup.
     */ async openPostFormPopup(request, discoveredAuthority, popupParams, correlationId, isEAR) {
        const popupRelayUri = this.config.auth.popupRelayUri;
        if (popupRelayUri) {
            const getFormData = isEAR ? (0, _authorizeMjs.getEARFormData) : (0, _authorizeMjs.getCodeFormData);
            const formData = await getFormData(this.config, discoveredAuthority, request, this.logger, this.performanceClient);
            const relayUrl = (0, _relayClientMjs.buildPopupRelayUrl)(popupRelayUri, this.getRelayStateId(request.state, correlationId), {
                method: "POST",
                action: formData.action,
                fields: formData.fields
            }, correlationId);
            return this.initiateAuthRequest(relayUrl, popupParams);
        }
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const getForm = isEAR ? (0, _authorizeMjs.getEARForm) : (0, _authorizeMjs.getCodeForm);
        const form = await getForm(popupWindow.document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return popupWindow;
    }
    async waitForPopupResponse(request, popupWindow, popupWindowParent) {
        /*
         * When a popup-relay page is configured the response is relayed back to
         * this frame by the relay page via postMessage, and the relay popup's
         * lifecycle (including the user dismissing it before signing in) must be
         * tracked here. This takes precedence over the default bridge response
         * hook, whose BroadcastChannel cannot reach a partitioned cross-site
         * frame and which does not track the relay popup.
         */ if (this.config.auth.popupRelayUri) return (0, _relayClientMjs.waitForPopupRelayResponse)(this.config.system.popupBridgeTimeout, this.logger, request, popupWindow, this.performanceClient);
        if (this.waitForPopupResponseHook) return this.waitForPopupResponseHook(request, popupWindow, popupWindowParent);
        return (0, _browserUtilsMjs.waitForBridgeResponse)(this.config.system.popupBridgeTimeout, this.logger, request, this.performanceClient);
    }
}

},{"@azure/msal-common/browser":[["AuthError","8TWYe"],["Constants","5eRZy","*"],["invoke","4kFBF"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"],["ProtocolMode","8zD57"],["ProtocolUtils","ipQ3L","*"],["UrlString","9Z8Lm"]],"./StandardInteractionClient.mjs":"2tYFp","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../event/EventType.mjs":"gVLUh","../utils/BrowserConstants.mjs":"5kHn0","../utils/BrowserUtils.mjs":"eyRWO","../popup_relay/relayClient.mjs":"e4quj","../encode/Base64Decode.mjs":"evkpn","../error/BrowserAuthError.mjs":"k9YIy","../response/ResponseHandler.mjs":"1kcwc","../protocol/Authorize.mjs":"7dpy6","../crypto/PkceGenerator.mjs":"dJjs5","../broker/nativeBroker/PlatformAuthProvider.mjs":"80VhX","../crypto/BrowserCrypto.mjs":"a5L0H","./BaseInteractionClient.mjs":"9bVY8","../request/RequestHelpers.mjs":"dxJze","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2tYFp":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardInteractionClient", ()=>StandardInteractionClient);
parcelHelpers.export(exports, "initializeAuthorizationRequest", ()=>initializeAuthorizationRequest);
var _browser = require("@azure/msal-common/browser");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _requestHelpersMjs = require("../request/RequestHelpers.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class StandardInteractionClient extends (0, _baseInteractionClientMjs.BaseInteractionClient) {
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("0546u4", this.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId,
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from account loginHint or ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = logoutRequest.account.loginHint || this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("0d7s8p", this.correlationId);
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("0pdtc3", this.correlationId);
            } else this.logger.verbose("12k4l4", this.correlationId);
        } else this.logger.verbose("07ndze", this.correlationId);
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("1vamm6", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, _browser.UrlString).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, _browserUtilsMjs.getCurrentUri)(), validLogoutRequest.correlationId);
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("15m5g7", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("1f4xlz", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, _browser.UrlString).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, _browserUtilsMjs.getCurrentUri)(), validLogoutRequest.correlationId);
            } else {
                this.logger.verbose("17s5rf", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, _browser.UrlString).getAbsoluteUrl((0, _browserUtilsMjs.getCurrentUri)(), (0, _browserUtilsMjs.getCurrentUri)(), validLogoutRequest.correlationId);
            }
        } else this.logger.verbose("0ljv63", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) {
                this.logger.verbose("0u5bmc", this.correlationId);
                return idTokenClaims.login_hint;
            } else this.logger.verbose("0mvp54", this.correlationId);
        } else this.logger.verbose("1e7bdp", this.correlationId);
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        // Create auth module.
        const clientConfig = await (0, _browser.invokeAsync)(this.getClientConfiguration.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetClientConfiguration), this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, _browser.AuthorizationCodeClient)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account } = params;
        const discoveredAuthority = params.authority || await (0, _browser.invokeAsync)((0, _baseInteractionClientMjs.getDiscoveredAuthority), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetDiscoveredAuthority), this.logger, this.performanceClient, this.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account);
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri,
                isMcp: this.config.auth.isMcp
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, _browserConstantsMjs.BrowserConstants).MSAL_SKU,
                version: (0, _packageMetadataMjs.version),
                cpu: "",
                os: ""
            },
            telemetry: this.config.telemetry
        };
    }
}
/**
 * Helper to initialize required request parameters for interactive APIs and ssoSilent().
 *
 * @param request - The authentication request object (RedirectRequest, PopupRequest, or SsoSilentRequest).
 * @param interactionType - The type of interaction (e.g., redirect, popup, silent).
 * @param config - The browser configuration object.
 * @param browserCrypto - The cryptographic interface for browser operations.
 * @param browserStorage - The browser storage manager instance.
 * @param logger - The logger instance for logging messages.
 * @param performanceClient - The performance client for telemetry.
 * @param correlationId - The correlation ID for the request.
 * @returns A promise that resolves to a CommonAuthorizationUrlRequest object with initialized parameters.
 */ async function initializeAuthorizationRequest(request, interactionType, config, browserCrypto, browserStorage, logger, performanceClient, correlationId) {
    const redirectUri = (0, _baseInteractionClientMjs.getRedirectUri)(request.redirectUri, config.auth.redirectUri, logger, correlationId);
    if (new URL(redirectUri).origin !== new URL(window.location.href).origin) {
        logger.warning("08qbvw", correlationId);
        performanceClient.addFields({
            isRedirectUriCrossOrigin: true
        }, correlationId);
    }
    const browserState = {
        interactionType: interactionType
    };
    const state = (0, _browser.ProtocolUtils).setRequestState(browserCrypto, request && request.state || "", browserState, correlationId);
    const baseRequest = await (0, _browser.invokeAsync)((0, _requestHelpersMjs.initializeBaseRequest), (0, _browserPerformanceEventsMjs.InitializeBaseRequest), logger, performanceClient, correlationId)({
        ...request,
        correlationId: correlationId
    }, config, performanceClient, logger, correlationId);
    const interactionRequest = {
        ...baseRequest,
        redirectUri: redirectUri,
        state: state,
        nonce: request.nonce || (0, _browserCryptoMjs.createNewGuid)(),
        responseMode: config.auth.OIDCOptions.responseMode
    };
    const validatedRequest = {
        ...interactionRequest,
        httpMethod: (0, _requestHelpersMjs.validateRequestMethod)(interactionRequest, config.system.protocolMode)
    };
    // Skip active account lookup if either login hint or session id is set
    if (request.loginHint || request.sid) return validatedRequest;
    const account = request.account || browserStorage.getActiveAccount(correlationId);
    if (account) {
        logger.verbose("1eqlb3", correlationId);
        logger.verbosePii(`0tf99t ${account.homeAccountId}`, correlationId);
        validatedRequest.account = account;
    }
    return validatedRequest;
}

},{"@azure/msal-common/browser":[["AuthorizationCodeClient","hovgR"],["invokeAsync","4kFBF"],["ProtocolUtils","ipQ3L","*"],["UrlString","9Z8Lm"]],"./BaseInteractionClient.mjs":"9bVY8","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../utils/BrowserConstants.mjs":"5kHn0","../packageMetadata.mjs":"7kVpA","../utils/BrowserUtils.mjs":"eyRWO","../crypto/BrowserCrypto.mjs":"a5L0H","../request/RequestHelpers.mjs":"dxJze","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hovgR":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthorizationCodeClient", ()=>AuthorizationCodeClient);
var _requestParameterBuilderMjs = require("../request/RequestParameterBuilder.mjs");
var _urlUtilsMjs = require("../utils/UrlUtils.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _aadserverParamKeysMjs = require("../constants/AADServerParamKeys.mjs");
var _clientConfigurationMjs = require("../config/ClientConfiguration.mjs");
var _responseHandlerMjs = require("../response/ResponseHandler.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _urlStringMjs = require("../url/UrlString.mjs");
var _popTokenGeneratorMjs = require("../crypto/PopTokenGenerator.mjs");
var _timeUtilsMjs = require("../utils/TimeUtils.mjs");
var _clientInfoMjs = require("../account/ClientInfo.mjs");
var _ccsCredentialMjs = require("../account/CcsCredential.mjs");
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
var _clientAssertionUtilsMjs = require("../utils/ClientAssertionUtils.mjs");
var _requestThumbprintMjs = require("../network/RequestThumbprint.mjs");
var _tokenMjs = require("../protocol/Token.mjs");
var _authorityFactoryMjs = require("../authority/AuthorityFactory.mjs");
var _loggerMjs = require("../logger/Logger.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class AuthorizationCodeClient {
    constructor(configuration, performanceClient){
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        // Set the configuration
        this.config = (0, _clientConfigurationMjs.buildClientConfiguration)(configuration);
        // Initialize the logger
        this.logger = new (0, _loggerMjs.Logger)(this.config.loggerOptions, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, apiId, authCodePayload) {
        if (!request.code) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.requestCannotBeMade), request.correlationId);
        // Check for new cloud instance
        if (authCodePayload && authCodePayload.cloud_instance_host_name) await (0, _functionWrappersMjs.invokeAsync)(this.updateTokenEndpointAuthority.bind(this), (0, _performanceEventsMjs.UpdateTokenEndpointAuthority), this.logger, this.performanceClient, request.correlationId)(authCodePayload.cloud_instance_host_name, request.correlationId);
        const reqTimestamp = (0, _timeUtilsMjs.nowSeconds)();
        const response = await (0, _functionWrappersMjs.invokeAsync)(this.executeTokenRequest.bind(this), (0, _performanceEventsMjs.AuthClientExecuteTokenRequest), this.logger, this.performanceClient, request.correlationId)(this.authority, request, this.serverTelemetryManager);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, _constantsMjs.HeaderNames).X_MS_REQUEST_ID];
        const responseHandler = new (0, _responseHandlerMjs.ResponseHandler)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return (0, _functionWrappersMjs.invokeAsync)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, _performanceEventsMjs.HandleServerTokenResponse), this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.logoutRequestEmpty), "");
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, _urlStringMjs.UrlString).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request, serverTelemetryManager) {
        const queryParametersString = (0, _tokenMjs.createTokenQueryParameters)(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = (0, _urlStringMjs.UrlString).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, _functionWrappersMjs.invokeAsync)(this.createTokenRequestBody.bind(this), (0, _performanceEventsMjs.AuthClientCreateTokenRequestBody), this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, _clientInfoMjs.buildClientInfo)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${0, _constantsMjs.CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, _ccsCredentialMjs.CcsCredentialType).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`0wznt3 ${e}`, request.correlationId);
        }
        const headers = (0, _tokenMjs.createTokenRequestHeaders)(this.logger, this.config.systemOptions.preventCorsPreflight, ccsCredential || request.ccsCredential);
        const thumbprint = (0, _requestThumbprintMjs.getRequestThumbprint)(this.config.authOptions.clientId, request);
        return (0, _functionWrappersMjs.invokeAsync)((0, _tokenMjs.executePostToTokenEndpoint), (0, _performanceEventsMjs.AuthorizationCodeClientExecutePostToTokenEndpoint), this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, serverTelemetryManager);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        (0, _requestParameterBuilderMjs.addClientId)(parameters, request.embeddedClientId || request.extraParameters?.[0, _aadserverParamKeysMjs.CLIENT_ID] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) {
            // Just validate
            if (!request.redirectUri) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.redirectUriEmpty), request.correlationId);
        } else // Validate and include redirect uri
        (0, _requestParameterBuilderMjs.addRedirectUri)(parameters, request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        (0, _requestParameterBuilderMjs.addScopes)(parameters, request.scopes, request.correlationId, true, this.oidcDefaultScopes);
        (0, _requestParameterBuilderMjs.addResource)(parameters, request.resource);
        // add code: user set, not validated
        (0, _requestParameterBuilderMjs.addAuthorizationCode)(parameters, request.code);
        // Add library metadata
        (0, _requestParameterBuilderMjs.addLibraryInfo)(parameters, this.config.libraryInfo);
        (0, _requestParameterBuilderMjs.addApplicationTelemetry)(parameters, this.config.telemetry.application);
        (0, _requestParameterBuilderMjs.addThrottling)(parameters);
        if (this.serverTelemetryManager && !(0, _clientConfigurationMjs.isOidcProtocolMode)(this.config)) (0, _requestParameterBuilderMjs.addServerTelemetry)(parameters, this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) (0, _requestParameterBuilderMjs.addCodeVerifier)(parameters, request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) (0, _requestParameterBuilderMjs.addClientSecret)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, _requestParameterBuilderMjs.addClientAssertion)(parameters, await (0, _clientAssertionUtilsMjs.getClientAssertion)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, _requestParameterBuilderMjs.addClientAssertionType)(parameters, clientAssertion.assertionType);
        }
        (0, _requestParameterBuilderMjs.addGrantType)(parameters, (0, _constantsMjs.GrantType).AUTHORIZATION_CODE_GRANT);
        (0, _requestParameterBuilderMjs.addClientInfo)(parameters);
        if (request.authenticationScheme === (0, _constantsMjs.AuthenticationScheme).POP) {
            const popTokenGenerator = new (0, _popTokenGeneratorMjs.PopTokenGenerator)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, _functionWrappersMjs.invokeAsync)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, _performanceEventsMjs.PopTokenGenerateCnf), this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, _requestParameterBuilderMjs.addPopToken)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, _constantsMjs.AuthenticationScheme).SSH) {
            if (request.sshJwk) (0, _requestParameterBuilderMjs.addSshJwk)(parameters, request.sshJwk);
            else throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.missingSshJwk), request.correlationId);
        }
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, _clientInfoMjs.buildClientInfo)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${0, _constantsMjs.CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, _ccsCredentialMjs.CcsCredentialType).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`0wznt3 ${e}`, request.correlationId);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, _ccsCredentialMjs.CcsCredentialType).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, _clientInfoMjs.buildClientInfoFromHomeAccountId)(ccsCred.credential);
                    (0, _requestParameterBuilderMjs.addCcsOid)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`1qhtee ${e}`, request.correlationId);
                }
                break;
            case (0, _ccsCredentialMjs.CcsCredentialType).UPN:
                (0, _requestParameterBuilderMjs.addCcsUpn)(parameters, ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) (0, _requestParameterBuilderMjs.addBrokerParameters)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) (0, _requestParameterBuilderMjs.addExtraParameters)(parameters, request.extraParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.extraParameters || !request.extraParameters[0, _aadserverParamKeysMjs.RETURN_SPA_CODE])) (0, _requestParameterBuilderMjs.addExtraParameters)(parameters, {
            [(0, _aadserverParamKeysMjs.RETURN_SPA_CODE)]: "1"
        });
        (0, _requestParameterBuilderMjs.instrumentBrokerParams)(parameters, request.correlationId, this.performanceClient);
        (0, _requestParameterBuilderMjs.addClaims)(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return (0, _urlUtilsMjs.mapToQueryString)(parameters);
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameters = new Map();
        if (request.postLogoutRedirectUri) (0, _requestParameterBuilderMjs.addPostLogoutRedirectUri)(parameters, request.postLogoutRedirectUri);
        if (request.correlationId) (0, _requestParameterBuilderMjs.addCorrelationId)(parameters, request.correlationId);
        if (request.idTokenHint) (0, _requestParameterBuilderMjs.addIdTokenHint)(parameters, request.idTokenHint);
        if (request.state) (0, _requestParameterBuilderMjs.addState)(parameters, request.state);
        if (request.logoutHint) (0, _requestParameterBuilderMjs.addLogoutHint)(parameters, request.logoutHint);
        if (request.extraQueryParameters) (0, _requestParameterBuilderMjs.addExtraParameters)(parameters, request.extraQueryParameters);
        if (this.config.authOptions.instanceAware) (0, _requestParameterBuilderMjs.addInstanceAware)(parameters);
        return (0, _urlUtilsMjs.mapToQueryString)(parameters);
    }
    /**
     * Updates the authority to the cloud instance provided in the authorization response
     * @param cloudInstanceHostName - cloud instance host name from authorization code payload
     * @param correlationId - request correlation id
     */ async updateTokenEndpointAuthority(cloudInstanceHostName, correlationId) {
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostName}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, _authorityFactoryMjs.createDiscoveredInstance)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
}

},{"../request/RequestParameterBuilder.mjs":"lAS2Y","../utils/UrlUtils.mjs":"2SeAw","../utils/Constants.mjs":"5eRZy","../constants/AADServerParamKeys.mjs":"kjH8Y","../config/ClientConfiguration.mjs":"66gK3","../response/ResponseHandler.mjs":"7Ytwn","../error/ClientAuthError.mjs":"e8Ku4","../url/UrlString.mjs":"9Z8Lm","../crypto/PopTokenGenerator.mjs":"bnqqV","../utils/TimeUtils.mjs":"6CLZ0","../account/ClientInfo.mjs":"98dT9","../account/CcsCredential.mjs":"iEcz2","../error/ClientConfigurationError.mjs":"ebyn4","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../utils/FunctionWrappers.mjs":"4kFBF","../utils/ClientAssertionUtils.mjs":"jl7q2","../network/RequestThumbprint.mjs":"dg9GN","../protocol/Token.mjs":"dDGfh","../authority/AuthorityFactory.mjs":"gymGK","../logger/Logger.mjs":"9bvcp","../packageMetadata.mjs":"ftCED","../error/ClientAuthErrorCodes.mjs":"8keAa","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"66gK3":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SYSTEM_OPTIONS", ()=>DEFAULT_SYSTEM_OPTIONS);
parcelHelpers.export(exports, "buildClientConfiguration", ()=>buildClientConfiguration);
parcelHelpers.export(exports, "isOidcProtocolMode", ()=>isOidcProtocolMode);
var _icryptoMjs = require("../crypto/ICrypto.mjs");
var _loggerMjs = require("../logger/Logger.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _authorityOptionsMjs = require("../authority/AuthorityOptions.mjs");
var _cacheManagerMjs = require("../cache/CacheManager.mjs");
var _protocolModeMjs = require("../authority/ProtocolMode.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _stubPerformanceClientMjs = require("../telemetry/performance/StubPerformanceClient.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const DEFAULT_SYSTEM_OPTIONS = {
    tokenRenewalOffsetSeconds: (0, _constantsMjs.DEFAULT_TOKEN_RENEWAL_OFFSET_SEC),
    preventCorsPreflight: false
};
const DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, _loggerMjs.LogLevel).Info,
    correlationId: ""
};
const DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    },
    async sendPostRequestAsync () {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), "");
    }
};
const DEFAULT_LIBRARY_INFO = {
    sku: (0, _constantsMjs.SKU),
    version: (0, _packageMetadataMjs.version),
    cpu: "",
    os: ""
};
const DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: "",
    clientAssertion: undefined
};
const DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, _authorityOptionsMjs.AzureCloudInstance).None,
    tenant: `${(0, _constantsMjs.DEFAULT_COMMON_TENANT)}`
};
const DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 * @internal
 */ function buildClientConfiguration({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...DEFAULT_SYSTEM_OPTIONS,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        storageInterface: storageImplementation || new (0, _cacheManagerMjs.DefaultStorageClass)(userAuthOptions.clientId, (0, _icryptoMjs.DEFAULT_CRYPTO_IMPLEMENTATION), new (0, _loggerMjs.Logger)(loggerOptions, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version)), new (0, _stubPerformanceClientMjs.StubPerformanceClient)()),
        networkInterface: networkImplementation || DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, _icryptoMjs.DEFAULT_CRYPTO_IMPLEMENTATION),
        clientCredentials: clientCredentials || DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: DEFAULT_AZURE_CLOUD_OPTIONS,
        instanceAware: false,
        isMcp: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function isOidcProtocolMode(config) {
    return config.authOptions.authority.options.protocolMode === (0, _protocolModeMjs.ProtocolMode).OIDC;
}

},{"../crypto/ICrypto.mjs":"l3pFH","../logger/Logger.mjs":"9bvcp","../utils/Constants.mjs":"5eRZy","../packageMetadata.mjs":"ftCED","../authority/AuthorityOptions.mjs":"9DjNg","../cache/CacheManager.mjs":"iTtoF","../authority/ProtocolMode.mjs":"8zD57","../error/ClientAuthError.mjs":"e8Ku4","../telemetry/performance/StubPerformanceClient.mjs":"9VScD","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7Ytwn":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponseHandler", ()=>ResponseHandler);
parcelHelpers.export(exports, "buildAccountToCache", ()=>buildAccountToCache);
var _accountInfoMjs = require("../account/AccountInfo.mjs");
var _authTokenMjs = require("../account/AuthToken.mjs");
var _tokenClaimsMjs = require("../account/TokenClaims.mjs");
var _tokenCacheContextMjs = require("../cache/persistence/TokenCacheContext.mjs");
var _accountEntityUtilsMjs = require("../cache/utils/AccountEntityUtils.mjs");
var _cacheHelpersMjs = require("../cache/utils/CacheHelpers.mjs");
var _popTokenGeneratorMjs = require("../crypto/PopTokenGenerator.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _interactionRequiredAuthErrorMjs = require("../error/InteractionRequiredAuthError.mjs");
var _serverErrorMjs = require("../error/ServerError.mjs");
var _scopeSetMjs = require("../request/ScopeSet.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _protocolUtilsMjs = require("../utils/ProtocolUtils.mjs");
var _timeUtilsMjs = require("../utils/TimeUtils.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 * @internal
 */ class ResponseHandler {
    constructor(clientId, cacheStorage, cryptoObj, logger, performanceClient, serializableCache, persistencePlugin){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param correlationId
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, correlationId, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, _constantsMjs.NOT_AVAILABLE)} - Timestamp: ${serverResponse.timestamp || (0, _constantsMjs.NOT_AVAILABLE)} - Description: ${serverResponse.error_description || (0, _constantsMjs.NOT_AVAILABLE)} - Correlation ID: ${serverResponse.correlation_id || (0, _constantsMjs.NOT_AVAILABLE)} - Trace ID: ${serverResponse.trace_id || (0, _constantsMjs.NOT_AVAILABLE)}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, _serverErrorMjs.ServerError)(serverResponse.error || "", serverResponse.correlation_id || "", errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, _constantsMjs.HTTP_SERVER_ERROR_RANGE_START) && serverResponse.status <= (0, _constantsMjs.HTTP_SERVER_ERROR_RANGE_END)) {
                this.logger.warning(`16ks7j ${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, _constantsMjs.HTTP_CLIENT_ERROR_RANGE_START) && serverResponse.status <= (0, _constantsMjs.HTTP_CLIENT_ERROR_RANGE_END)) {
                this.logger.warning(`0g61x3 ${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, _interactionRequiredAuthErrorMjs.isInteractionRequiredError)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, _interactionRequiredAuthErrorMjs.InteractionRequiredAuthError)(serverResponse.error || "", serverResponse.correlation_id || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, apiId, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId, additionalCacheKeyComponents) {
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, _authTokenMjs.extractTokenClaims)(serverTokenResponse.id_token || "", this.cryptoObj.base64Decode, request.correlationId);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.nonceMismatch), request.correlationId);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, _accountEntityUtilsMjs.generateHomeAccountId)(serverTokenResponse.client_info || "", authority.authorityType, this.logger, this.cryptoObj, request.correlationId, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, _protocolUtilsMjs.parseRequestState)(this.cryptoObj.base64Decode, authCodePayload.state, request.correlationId);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, additionalCacheKeyComponents);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("0jbz5k", request.correlationId);
                cacheContext = new (0, _tokenCacheContextMjs.TokenCacheContext)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const cachedAccounts = this.cacheStorage.getAllAccounts({
                    homeAccountId: cacheRecord.account.homeAccountId,
                    environment: cacheRecord.account.environment
                }, request.correlationId);
                if (cachedAccounts.length < 1) {
                    this.logger.warning("1gmt66", request.correlationId);
                    this.performanceClient?.addFields({
                        acntLoggedOut: true
                    }, request.correlationId);
                    return await ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, (0, _authTokenMjs.isKmsi)(idTokenClaims || {}), apiId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("1bh17u", request.correlationId);
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, additionalCacheKeyComponents) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.invalidCacheEnvironment), request.correlationId);
        const claimsTenantId = (0, _tokenClaimsMjs.getTenantIdFromIdTokenClaims)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, _cacheHelpersMjs.createIdTokenEntity)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = buildAccountToCache(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger, this.performanceClient);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, _scopeSetMjs.ScopeSet).fromString(serverTokenResponse.scope, request.correlationId) : new (0, _scopeSetMjs.ScopeSet)(request.scopes || [], request.correlationId);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, _cacheHelpersMjs.createAccessTokenEntity)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, request.correlationId, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, additionalCacheKeyComponents);
            // Set resource (to be used for MCP scenarios)
            const resource = request.resource || null;
            if (resource) cachedAccessToken.resource = resource;
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
                this.performanceClient?.addFields({
                    ntwkRtExpiresOnSeconds: rtExpiresOn
                }, request.correlationId);
            }
            cachedRefreshToken = (0, _cacheHelpersMjs.createRefreshTokenEntity)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, performanceClient, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = "";
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, _constantsMjs.AuthenticationScheme).POP && !request.popKid) {
                const popTokenGenerator = new (0, _popTokenGeneratorMjs.PopTokenGenerator)(cryptoObj, performanceClient);
                const { secret, keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.keyIdMissing), request.correlationId);
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, _scopeSetMjs.ScopeSet).fromString(cacheRecord.accessToken.target, request.correlationId).asArray();
            // Access token expiresOn cached in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, _timeUtilsMjs.toDateFromSeconds)(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, _timeUtilsMjs.toDateFromSeconds)(cacheRecord.accessToken.extendedExpiresOn);
            if (cacheRecord.accessToken.refreshOn) refreshOn = (0, _timeUtilsMjs.toDateFromSeconds)(cacheRecord.accessToken.refreshOn);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, _constantsMjs.THE_FAMILY_ID) ? (0, _constantsMjs.THE_FAMILY_ID) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) {
            // Set on deprecated top-level for downgrade compat
            cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
            // Set on the matching tenant profile (source of truth)
            const targetTenantId = tid || cacheRecord.account.realm;
            if (cacheRecord.account.tenantProfiles) {
                const matchingProfile = cacheRecord.account.tenantProfiles.find((tp)=>tp.tenantId === targetTenantId);
                if (matchingProfile) matchingProfile.nativeAccountId = serverTokenResponse.spa_accountid;
            }
        }
        const accountInfo = cacheRecord.account ? (0, _accountInfoMjs.updateAccountTenantProfileData)((0, _accountEntityUtilsMjs.getAccountInfo)(cacheRecord.account), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || "",
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || "",
            state: requestState ? requestState.userRequestState : "",
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || "",
            msGraphHost: cacheRecord.account?.msGraphHost || "",
            code: serverTokenResponse?.spa_code,
            fromPlatformBroker: false
        };
    }
}
/** @internal */ function buildAccountToCache(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger, performanceClient) {
    logger?.verbose("09jz0t", correlationId);
    /*
     * Check if base account is already cached. Filter by homeAccountId (identifies
     * the user's home identity) and environment (identifies the cloud) — the two
     * tenant-agnostic properties that uniquely locate a base AccountEntity.
     */ const accountEnvironment = environment || authority.getPreferredCache();
    const matchedAccounts = cacheStorage.getAccountsFilteredBy({
        homeAccountId,
        environment: accountEnvironment
    }, correlationId);
    performanceClient?.addFields({
        cacheMatchedAccounts: matchedAccounts.length
    }, correlationId);
    if (matchedAccounts.length > 1) /*
         * Base accounts are expected to be unique for a given homeAccountId in normal cache usage.
         * If multiple matches exist, ignore the cache hit rather than arbitrarily choosing one.
         */ logger?.warning("0x7ad1", correlationId);
    const cachedAccount = matchedAccounts.length === 1 ? matchedAccounts[0] : null;
    const baseAccount = cachedAccount || (0, _accountEntityUtilsMjs.createAccountEntity)({
        homeAccountId,
        idTokenClaims,
        clientInfo,
        environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, correlationId, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, _accountInfoMjs.buildTenantProfile)(homeAccountId, baseAccount.localAccountId, tenantId, nativeAccountId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}

},{"../account/AccountInfo.mjs":"glI6y","../account/AuthToken.mjs":"l1q48","../account/TokenClaims.mjs":"dKH9k","../cache/persistence/TokenCacheContext.mjs":"4Qnba","../cache/utils/AccountEntityUtils.mjs":"kwYyZ","../cache/utils/CacheHelpers.mjs":"61GoB","../crypto/PopTokenGenerator.mjs":"bnqqV","../error/ClientAuthError.mjs":"e8Ku4","../error/InteractionRequiredAuthError.mjs":"jiVlC","../error/ServerError.mjs":"dvxy4","../request/ScopeSet.mjs":"7niwa","../utils/Constants.mjs":"5eRZy","../utils/ProtocolUtils.mjs":"ipQ3L","../utils/TimeUtils.mjs":"6CLZ0","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4Qnba":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenCacheContext", ()=>TokenCacheContext);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class TokenCacheContext {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bnqqV":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopTokenGenerator", ()=>PopTokenGenerator);
var _timeUtilsMjs = require("../utils/TimeUtils.mjs");
var _urlStringMjs = require("../url/UrlString.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const KeyLocation = {
    SW: "sw"
};
/** @internal */ class PopTokenGenerator {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        const reqCnf = await (0, _functionWrappersMjs.invokeAsync)(this.generateKid.bind(this), (0, _performanceEventsMjs.PopTokenGenerateCnf), logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod, resourceRequestUri, shrClaims, shrNonce, shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, _urlStringMjs.UrlString)(resourceRequestUri, request.correlationId) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, _timeUtilsMjs.nowSeconds)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}

},{"../utils/TimeUtils.mjs":"6CLZ0","../url/UrlString.mjs":"9Z8Lm","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../utils/FunctionWrappers.mjs":"4kFBF","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iEcz2":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CcsCredentialType", ()=>CcsCredentialType);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const CcsCredentialType = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jl7q2":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClientAssertion", ()=>getClientAssertion);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function getClientAssertion(clientAssertion, clientId, tokenEndpoint, fmiPath) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            fmiPath: fmiPath
        };
        return clientAssertion(config);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dDGfh":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTokenQueryParameters", ()=>createTokenQueryParameters);
parcelHelpers.export(exports, "createTokenRequestHeaders", ()=>createTokenRequestHeaders);
parcelHelpers.export(exports, "executePostToTokenEndpoint", ()=>executePostToTokenEndpoint);
parcelHelpers.export(exports, "sendPostRequest", ()=>sendPostRequest);
var _ccsCredentialMjs = require("../account/CcsCredential.mjs");
var _clientInfoMjs = require("../account/ClientInfo.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _requestParameterBuilderMjs = require("../request/RequestParameterBuilder.mjs");
var _urlUtilsMjs = require("../utils/UrlUtils.mjs");
var _throttlingUtilsMjs = require("../network/ThrottlingUtils.mjs");
var _networkErrorMjs = require("../error/NetworkError.mjs");
var _authErrorMjs = require("../error/AuthError.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates default headers for requests to token endpoint
 */ function createTokenRequestHeaders(logger, preventCorsPreflight, ccsCred) {
    const headers = {};
    headers[(0, _constantsMjs.HeaderNames).CONTENT_TYPE] = (0, _constantsMjs.URL_FORM_CONTENT_TYPE);
    if (!preventCorsPreflight && ccsCred) switch(ccsCred.type){
        case (0, _ccsCredentialMjs.CcsCredentialType).HOME_ACCOUNT_ID:
            try {
                const clientInfo = (0, _clientInfoMjs.buildClientInfoFromHomeAccountId)(ccsCred.credential);
                headers[(0, _constantsMjs.HeaderNames).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
            } catch (e) {
                logger.verbose(`1qhtee ${e}`, "");
            }
            break;
        case (0, _ccsCredentialMjs.CcsCredentialType).UPN:
            headers[(0, _constantsMjs.HeaderNames).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
            break;
    }
    return headers;
}
/**
 * Creates query string for the /token request
 * @param request
 */ function createTokenQueryParameters(request, clientId, redirectUri, performanceClient) {
    const parameters = new Map();
    if (request.embeddedClientId) (0, _requestParameterBuilderMjs.addBrokerParameters)(parameters, clientId, redirectUri);
    if (request.extraQueryParameters) (0, _requestParameterBuilderMjs.addExtraParameters)(parameters, request.extraQueryParameters);
    (0, _requestParameterBuilderMjs.addCorrelationId)(parameters, request.correlationId);
    (0, _requestParameterBuilderMjs.instrumentBrokerParams)(parameters, request.correlationId, performanceClient);
    return (0, _urlUtilsMjs.mapToQueryString)(parameters);
}
/**
 * Http post to token endpoint
 * @param tokenEndpoint
 * @param queryString
 * @param headers
 * @param thumbprint
 * @internal
 */ async function executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, cacheManager, networkClient, logger, performanceClient, serverTelemetryManager) {
    const response = await sendPostRequest(thumbprint, tokenEndpoint, {
        body: queryString,
        headers: headers
    }, correlationId, cacheManager, networkClient, logger, performanceClient);
    if (serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
    serverTelemetryManager.clearTelemetryCache();
    return response;
}
/**
 * Wraps sendPostRequestAsync with necessary preflight and postflight logic
 * @param thumbprint - Request thumbprint for throttling
 * @param tokenEndpoint - Endpoint to make the POST to
 * @param options - Body and Headers to include on the POST request
 * @param correlationId - CorrelationId for telemetry
 * @param cacheManager - Cache manager instance
 * @param networkClient - Network module instance
 * @param logger - Logger instance
 * @param performanceClient - Performance client instance
 * @internal
 */ async function sendPostRequest(thumbprint, tokenEndpoint, options, correlationId, cacheManager, networkClient, logger, performanceClient) {
    (0, _throttlingUtilsMjs.ThrottlingUtils).preProcess(cacheManager, thumbprint, correlationId);
    let response;
    try {
        response = await (0, _functionWrappersMjs.invokeAsync)(networkClient.sendPostRequestAsync.bind(networkClient), (0, _performanceEventsMjs.NetworkClientSendPostRequestAsync), logger, performanceClient, correlationId)(tokenEndpoint, options);
        const responseHeaders = response.headers || {};
        performanceClient?.addFields({
            refreshTokenSize: response.body.refresh_token?.length || 0,
            httpVerToken: responseHeaders[(0, _constantsMjs.HeaderNames).X_MS_HTTP_VERSION] || "",
            requestId: responseHeaders[(0, _constantsMjs.HeaderNames).X_MS_REQUEST_ID] || ""
        }, correlationId);
    } catch (e) {
        if (e instanceof (0, _networkErrorMjs.NetworkError)) {
            const responseHeaders = e.responseHeaders;
            if (responseHeaders) performanceClient?.addFields({
                httpVerToken: responseHeaders[(0, _constantsMjs.HeaderNames).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, _constantsMjs.HeaderNames).X_MS_REQUEST_ID] || "",
                contentTypeHeader: responseHeaders[(0, _constantsMjs.HeaderNames).CONTENT_TYPE] || undefined,
                contentLengthHeader: responseHeaders[(0, _constantsMjs.HeaderNames).CONTENT_LENGTH] || undefined,
                httpStatus: e.httpStatus
            }, correlationId);
            throw e.error;
        }
        if (e instanceof (0, _authErrorMjs.AuthError)) throw e;
        else throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.networkError), correlationId);
    }
    (0, _throttlingUtilsMjs.ThrottlingUtils).postProcess(cacheManager, thumbprint, response, correlationId);
    return response;
}

},{"../account/CcsCredential.mjs":"iEcz2","../account/ClientInfo.mjs":"98dT9","../utils/Constants.mjs":"5eRZy","../request/RequestParameterBuilder.mjs":"lAS2Y","../utils/UrlUtils.mjs":"2SeAw","../network/ThrottlingUtils.mjs":"4haCt","../error/NetworkError.mjs":"8fCiR","../error/AuthError.mjs":"8TWYe","../error/ClientAuthError.mjs":"e8Ku4","../utils/FunctionWrappers.mjs":"4kFBF","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4haCt":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThrottlingUtils", ()=>ThrottlingUtils);
var _constantsMjs = require("../utils/Constants.mjs");
var _serverErrorMjs = require("../error/ServerError.mjs");
var _requestThumbprintMjs = require("./RequestThumbprint.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class ThrottlingUtils {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${0, _constantsMjs.THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key, correlationId);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new (0, _serverErrorMjs.ServerError)(value.errorCodes?.join(" ") || "", correlationId, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        if (ThrottlingUtils.checkResponseStatus(response) || ThrottlingUtils.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: ThrottlingUtils.calculateThrottleTime(parseInt(response.headers[(0, _constantsMjs.HeaderNames).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache(ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, _constantsMjs.HeaderNames).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, _constantsMjs.DEFAULT_THROTTLE_TIME_SECONDS)), currentSeconds + (0, _constantsMjs.DEFAULT_MAX_THROTTLE_TIME_SECONDS)) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = (0, _requestThumbprintMjs.getRequestThumbprint)(clientId, request, homeAccountIdentifier);
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}

},{"../utils/Constants.mjs":"5eRZy","../error/ServerError.mjs":"dvxy4","./RequestThumbprint.mjs":"dg9GN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8fCiR":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkError", ()=>NetworkError);
parcelHelpers.export(exports, "createNetworkError", ()=>createNetworkError);
var _authErrorMjs = require("./AuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class NetworkError extends (0, _authErrorMjs.AuthError) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.correlationId, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, NetworkError.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function createNetworkError(error, httpStatus, responseHeaders, additionalError) {
    error.errorMessage = `${error.errorMessage}, additionalErrorInfo: error.name:${additionalError?.name}, error.message:${additionalError?.message}`;
    return new NetworkError(error, httpStatus, responseHeaders);
}

},{"./AuthError.mjs":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gymGK":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDiscoveredInstance", ()=>createDiscoveredInstance);
var _authorityMjs = require("./Authority.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param cacheManager
 * @param authorityOptions
 * @param logger
 * @param correlationId
 * @param performanceClient
 * @internal
 */ async function createDiscoveredInstance(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    const authorityUriFinal = (0, _authorityMjs.Authority).transformCIAMAuthority((0, _authorityMjs.formatAuthorityUri)(authorityUri), correlationId);
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, _authorityMjs.Authority)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, _functionWrappersMjs.invokeAsync)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, _performanceEventsMjs.AuthorityResolveEndpointsAsync), logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.endpointResolutionError), correlationId);
    }
}

},{"./Authority.mjs":"iOR3f","../error/ClientAuthError.mjs":"e8Ku4","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../utils/FunctionWrappers.mjs":"4kFBF","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9bVY8":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseInteractionClient", ()=>BaseInteractionClient);
parcelHelpers.export(exports, "clearCacheOnLogout", ()=>clearCacheOnLogout);
parcelHelpers.export(exports, "getDiscoveredAuthority", ()=>getDiscoveredAuthority);
parcelHelpers.export(exports, "getRedirectUri", ()=>getRedirectUri);
parcelHelpers.export(exports, "initializeServerTelemetryManager", ()=>initializeServerTelemetryManager);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class BaseInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.platformAuthProvider = platformAuthProvider;
        this.correlationId = correlationId;
        this.logger = logger.clone((0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        this.performanceClient = performanceClient;
    }
}
/**
 * Use to get the redirect URI configured in MSAL or construct one from the current page.
 * @param requestRedirectUri - Redirect URI from the request or undefined if not configured
 * @param clientConfigRedirectUri - Redirect URI from the client configuration or undefined if not configured
 * @param logger - Logger instance from the calling client
 * @param correlationId
 * @returns Absolute redirect URL constructed from the provided URI, config, or current page
 */ function getRedirectUri(requestRedirectUri, clientConfigRedirectUri, logger, correlationId) {
    logger.verbose("0bd1la", correlationId);
    const redirectUri = requestRedirectUri || clientConfigRedirectUri || "";
    return (0, _browser.UrlString).getAbsoluteUrl(redirectUri, (0, _browserUtilsMjs.getCurrentUri)(), correlationId);
}
/**
 * Initializes and returns a ServerTelemetryManager with the provided telemetry configuration.
 * @param apiId - The API identifier for telemetry tracking
 * @param clientId - The client application identifier
 * @param correlationId - Unique identifier for correlating requests
 * @param browserStorage - Browser cache manager instance for storing telemetry data
 * @param logger - Optional logger instance for verbose logging
 * @param forceRefresh - Optional flag to force refresh of telemetry data
 * @param enabled - Optional flag to enable or disable server telemetry (default: true for custom_auth flows, false for standard flows)
 * @returns Configured ServerTelemetryManager instance
 */ function initializeServerTelemetryManager(apiId, clientId, correlationId, browserStorage, logger, forceRefresh, enabled = true) {
    logger.verbose("1p12tq", correlationId);
    if (!enabled) {
        logger.verbose("0tajnr", correlationId);
        return new (0, _browser.StubServerTelemetryManager)();
    }
    const telemetryPayload = {
        clientId: clientId,
        correlationId: correlationId,
        apiId: apiId,
        forceRefresh: forceRefresh || false,
        wrapperSKU: browserStorage.getWrapperMetadata()[0],
        wrapperVer: browserStorage.getWrapperMetadata()[1]
    };
    return new (0, _browser.ServerTelemetryManager)(telemetryPayload, browserStorage);
}
/**
 * Used to get a discovered version of the default authority.
 * @param params - Configuration object containing authority and cloud options
 * @param params.requestAuthority - Optional specific authority URL to use
 * @param params.requestAzureCloudOptions - Optional Azure cloud configuration options
 * @param params.requestExtraQueryParameters - Optional additional query parameters
 * @param params.account - Optional account info for instance-aware scenarios
 * @param config - Browser configuration containing auth settings
 * @param correlationId - Unique identifier for correlating requests
 * @param performanceClient - Performance monitoring client instance
 * @param browserStorage - Browser cache manager instance
 * @param logger - Logger instance for tracking operations
 * @returns Promise that resolves to a discovered Authority instance
 */ async function getDiscoveredAuthority(config, correlationId, performanceClient, browserStorage, logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account) {
    const instanceAwareEQ = requestExtraQueryParameters && requestExtraQueryParameters.hasOwnProperty("instance_aware") ? requestExtraQueryParameters["instance_aware"] : undefined;
    const authorityOptions = {
        protocolMode: config.system.protocolMode,
        OIDCOptions: config.auth.OIDCOptions,
        knownAuthorities: config.auth.knownAuthorities,
        cloudDiscoveryMetadata: config.auth.cloudDiscoveryMetadata,
        authorityMetadata: config.auth.authorityMetadata
    };
    // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
    const resolvedAuthority = requestAuthority || config.auth.authority;
    const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : config.auth.instanceAware;
    const userAuthority = account && resolvedInstanceAware ? config.auth.authority.replace((0, _browser.UrlString).getDomainFromUrl(resolvedAuthority, correlationId), account.environment) : resolvedAuthority;
    // fall back to the authority from config
    const builtAuthority = (0, _browser.Authority).generateAuthority(userAuthority, requestAzureCloudOptions || config.auth.azureCloudOptions);
    const discoveredAuthority = await (0, _browser.invokeAsync)((0, _browser.AuthorityFactory).createDiscoveredInstance, (0, _browserPerformanceEventsMjs.AuthorityFactoryCreateDiscoveredInstance), logger, performanceClient, correlationId)(builtAuthority, config.system.networkClient, browserStorage, authorityOptions, logger, correlationId, performanceClient);
    if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).authorityMismatch, correlationId);
    return discoveredAuthority;
}
/**
 * Clears cache and account information during logout.
 *
 * If an account is provided, removes the account from cache and, if it is the active account, sets the active account to null.
 * If no account is provided, clears all accounts and tokens from cache.
 *
 * @param browserStorage - The browser cache manager instance used to manage cache.
 * @param browserCrypto - The crypto interface for cache operations.
 * @param logger - Logger instance for logging operations.
 * @param correlationId - Correlation ID for the logout operation.
 * @param account - (Optional) The account to clear from cache. If not provided, all accounts are cleared.
 * @returns A promise that resolves when the cache has been cleared.
 */ async function clearCacheOnLogout(browserStorage, browserCrypto, logger, correlationId, account) {
    if (account) // Clear given account.
    try {
        browserStorage.removeAccount(account, correlationId);
        logger.verbose("0s4z6h", correlationId);
    } catch (error) {
        logger.error("0mgg1d", correlationId);
    }
    else try {
        logger.verbose("0zj631", correlationId);
        // Clear all accounts and tokens
        browserStorage.clear(correlationId);
        // Clear any stray keys from IndexedDB
        await browserCrypto.clearKeystore(correlationId);
    } catch (e) {
        logger.error("12ih0c", correlationId);
    }
}

},{"@azure/msal-common/browser":[["Authority","iOR3f"],["AuthorityFactory","gymGK","*"],["ClientConfigurationErrorCodes","iMtlX","*"],["createClientConfigurationError","ebyn4"],["invokeAsync","4kFBF"],["ServerTelemetryManager","cqiOT"],["StubServerTelemetryManager","cqiOT"],["UrlString","9Z8Lm"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../packageMetadata.mjs":"7kVpA","../utils/BrowserUtils.mjs":"eyRWO","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cqiOT":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerTelemetryManager", ()=>ServerTelemetryManager);
parcelHelpers.export(exports, "StubServerTelemetryManager", ()=>StubServerTelemetryManager);
var _constantsMjs = require("../../utils/Constants.mjs");
var _authErrorMjs = require("../../error/AuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const skuGroupSeparator = ",";
const skuValueSeparator = "|";
function makeExtraSkuString(params) {
    const { skus, libraryName, libraryVersion, extensionName, extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split(skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) setSku({
            skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join(skuGroupSeparator);
}
function setSku(params) {
    const { skuArr, index, skuName, skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join(skuValueSeparator);
}
/** @internal */ class ServerTelemetryManager {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, _constantsMjs.CacheOutcome).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || "";
        this.wrapperVer = telemetryRequest.wrapperVer || "";
        this.telemetryCacheKey = (0, _constantsMjs.SERVER_TELEM_CACHE_KEY) + (0, _constantsMjs.CACHE_KEY_SEPARATOR) + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, _constantsMjs.SERVER_TELEM_VALUE_SEPARATOR)}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, _constantsMjs.SERVER_TELEM_VALUE_SEPARATOR));
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, _constantsMjs.SERVER_TELEM_VALUE_SEPARATOR));
        return [
            (0, _constantsMjs.SERVER_TELEM_SCHEMA_VERSION),
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, _constantsMjs.SERVER_TELEM_CATEGORY_SEPARATOR));
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, _constantsMjs.SERVER_TELEM_VALUE_SEPARATOR));
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, _constantsMjs.SERVER_TELEM_VALUE_SEPARATOR));
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, _constantsMjs.SERVER_TELEM_OVERFLOW_TRUE) : (0, _constantsMjs.SERVER_TELEM_OVERFLOW_FALSE);
        const platformFields = [
            errorCount,
            overflow
        ].join((0, _constantsMjs.SERVER_TELEM_VALUE_SEPARATOR));
        return [
            (0, _constantsMjs.SERVER_TELEM_SCHEMA_VERSION),
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, _constantsMjs.SERVER_TELEM_CATEGORY_SEPARATOR));
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        try {
            const lastRequests = this.getLastRequests();
            if (lastRequests.errors.length >= (0, _constantsMjs.SERVER_TELEM_MAX_CACHED_ERRORS)) {
                // Remove a cached error to make room, first in first out
                lastRequests.failedRequests.shift(); // apiId
                lastRequests.failedRequests.shift(); // correlationId
                lastRequests.errors.shift();
            }
            lastRequests.failedRequests.push(this.apiId, this.correlationId);
            if (error instanceof Error && !!error && error.toString()) {
                if (error instanceof (0, _authErrorMjs.AuthError)) {
                    if (error.subError) lastRequests.errors.push(error.subError);
                    else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                    else lastRequests.errors.push(error.toString());
                } else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push((0, _constantsMjs.SERVER_TELEM_UNKNOWN_ERROR));
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        } catch  {
        // Ignore telemetry cache failures to avoid masking the original auth error path.
        }
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey, this.correlationId);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || "";
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || "";
            const errorCode = serverTelemetryEntity.errors[i] || "";
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, _constantsMjs.SERVER_TELEM_MAX_LAST_HEADER_BYTES)) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || "");
        regionDiscoveryFields.push(this.regionSource || "");
        regionDiscoveryFields.push(this.regionOutcome || "");
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return makeExtraSkuString(params);
    }
}
/** @internal */ class StubServerTelemetryManager extends ServerTelemetryManager {
    constructor(){
        super({
            clientId: "",
            apiId: 0,
            correlationId: "",
            forceRefresh: false
        }, {});
    }
    generateCurrentRequestHeaderValue() {
        return "";
    }
    generateLastRequestHeaderValue() {
        return "";
    }
    cacheFailedRequest() {}
    incrementCacheHits() {
        return 0;
    }
    clearTelemetryCache() {}
    getRegionDiscoveryFields() {
        return "";
    }
    updateRegionDiscoveryMetadata() {}
    setCacheOutcome() {}
    setNativeBrokerErrorCode() {}
    getNativeBrokerErrorCode() {
        return undefined;
    }
    clearNativeBrokerErrorCode() {}
}

},{"../../utils/Constants.mjs":"5eRZy","../../error/AuthError.mjs":"8TWYe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dxJze":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeBaseRequest", ()=>initializeBaseRequest);
parcelHelpers.export(exports, "initializeSilentRequest", ()=>initializeSilentRequest);
parcelHelpers.export(exports, "validateRequestMethod", ()=>validateRequestMethod);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 * @param config
 * @param performanceClient
 * @param logger
 * @param correlationId
 */ async function initializeBaseRequest(request, config, performanceClient, logger, correlationId) {
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority,
        scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, _browser.Constants).AuthenticationScheme.BEARER;
        logger.verbose("1l4fwv", correlationId);
    } else {
        if (validatedRequest.authenticationScheme === (0, _browser.Constants).AuthenticationScheme.SSH) {
            if (!request.sshJwk) throw (0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).missingSshJwk, "");
            if (!request.sshKid) throw (0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).missingSshKid, "");
        }
        logger.verbose(`1ecmns ${validatedRequest.authenticationScheme}`, correlationId);
    }
    return validatedRequest;
}
async function initializeSilentRequest(request, account, config, performanceClient, logger) {
    const baseRequest = await (0, _browser.invokeAsync)(initializeBaseRequest, (0, _browserPerformanceEventsMjs.InitializeBaseRequest), logger, performanceClient, request.correlationId)(request, config, performanceClient, logger, request.correlationId);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}
/**
 * Validates that the combination of request method, protocol mode and authorize body parameters is correct.
 * Returns the validated or defaulted HTTP method or throws if the configured combination is invalid.
 * @param interactionRequest
 * @param protocolMode
 * @returns
 */ function validateRequestMethod(interactionRequest, protocolMode) {
    let httpMethod;
    const requestMethod = interactionRequest.httpMethod;
    if (protocolMode === (0, _browser.ProtocolMode).EAR) {
        // Validate that method can only be POST when protocol mode is EAR
        if (requestMethod && requestMethod !== (0, _browser.Constants).HttpMethod.POST) throw (0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).invalidRequestMethodForEAR, "");
        else httpMethod = (0, _browser.Constants).HttpMethod.POST;
    } else // For non-EAR protocol modes, default to GET if httpMethod is not set
    httpMethod = requestMethod || (0, _browser.Constants).HttpMethod.GET;
    return httpMethod;
}

},{"@azure/msal-common/browser":[["ClientConfigurationErrorCodes","iMtlX","*"],["Constants","5eRZy","*"],["createClientConfigurationError","ebyn4"],["invokeAsync","4kFBF"],["ProtocolMode","8zD57"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e4quj":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildPopupRelayUrl", ()=>buildPopupRelayUrl);
parcelHelpers.export(exports, "waitForPopupRelayResponse", ()=>waitForPopupRelayResponse);
var _browser = require("@azure/msal-common/browser");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
var _constantsMjs = require("./constants.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Builds the URL of the popup-relay page to open. The action the relay page
 * must perform (GET navigation or POST form) is carried in the page's hash
 * (client-side only, never sent to a server), keyed by the per-request
 * library-state `id` so the relay page can listen on the right BroadcastChannel
 * and echo the id back. The relay URI is resolved against the app origin, so it
 * must be same-origin as the embedded frame. See `runPopupRelay`.
 *
 * @internal
 */ function buildPopupRelayUrl(popupRelayUri, id, action, correlationId) {
    const req = {
        id,
        ...action
    };
    const target = new URL(popupRelayUri, window.location.origin);
    /*
     * The relay page must be same-origin as the embedded frame: the response is
     * relayed back via postMessage and only accepted from this origin, and a
     * cross-origin page would also receive the relayed /authorize request. Fail
     * fast with a clear error instead of silently relaying to (and timing out
     * against) the wrong origin.
     */ if (target.origin !== window.location.origin) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.popupRelayUnsupportedFlow), correlationId, "popup_relay_cross_origin");
    const hashParams = new URLSearchParams();
    hashParams.set("req", JSON.stringify(req));
    target.hash = hashParams.toString();
    return target.toString();
}
/**
 * Waits for the popup-relay page to relay the raw auth response back to the
 * embedded frame via postMessage. Used in place of `waitForBridgeResponse`
 * when `auth.popupRelayUri` is configured, because third-party storage
 * partitioning blocks the BroadcastChannel the redirect bridge uses from
 * reaching the embedded frame.
 *
 * The response is accepted only from the popup window we opened, on our own
 * origin (the relay page is same-origin as the embedded frame), and only when
 * it carries the matching per-request library-state id.
 *
 * @internal
 */ async function waitForPopupRelayResponse(timeoutMs, logger, request, popupWindow, performanceClient) {
    return new Promise((resolve, reject)=>{
        const correlationId = request.correlationId;
        logger.verbose("1d05g9", correlationId);
        performanceClient.addFields({
            redirectBridgeTimeoutMs: timeoutMs
        }, correlationId);
        const { libraryState } = (0, _browser.ProtocolUtils).parseRequestState((0, _base64DecodeMjs.base64Decode), request.state || "", correlationId);
        const expectedId = libraryState.id;
        const expectedOrigin = window.location.origin;
        let settled = false;
        const cleanup = ()=>{
            window.removeEventListener("message", onMessage);
            clearTimeout(timeoutId);
            clearInterval(closedPoll);
        };
        const onMessage = (event)=>{
            if (event.origin !== expectedOrigin || event.source !== popupWindow) return;
            const data = event.data;
            if (!data || data.type !== (0, _constantsMjs.POPUP_RELAY_RESPONSE_TYPE) || data.id !== expectedId) return;
            if (settled) return;
            settled = true;
            cleanup();
            if (data.error) reject((0, _browserAuthErrorMjs.createBrowserAuthError)(data.error, correlationId));
            else if (data.payload) resolve(data.payload);
            else reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.redirectBridgeEmptyResponse), correlationId));
        };
        window.addEventListener("message", onMessage);
        const timeoutId = window.setTimeout(()=>{
            if (settled) return;
            settled = true;
            cleanup();
            reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.timedOut), correlationId, "popup_relay_timeout"));
        }, timeoutMs);
        const closedPoll = window.setInterval(()=>{
            if (popupWindow.closed && !settled) {
                settled = true;
                cleanup();
                reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.userCancelled), correlationId));
            }
        }, 500);
    });
}

},{"@azure/msal-common/browser":[["ProtocolUtils","ipQ3L","*"]],"../encode/Base64Decode.mjs":"evkpn","../error/BrowserAuthError.mjs":"k9YIy","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","./constants.mjs":"dyfq8","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dyfq8":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "POPUP_RELAY_RESPONSE_TYPE", ()=>POPUP_RELAY_RESPONSE_TYPE);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * postMessage envelope type used to relay an auth response from a popup-relay
 * page (see `runPopupRelay`) back to the embedded frame that opened it. See
 * {@link BrowserAuthOptions.popupRelayUri}.
 *
 * Kept dependency-free so both the relay-page entry (`./index.js`) and the
 * client-side helpers (`./relayClient.js`) can import it without either bundle
 * pulling in the other's dependencies.
 *
 * @internal
 */ const POPUP_RELAY_RESPONSE_TYPE = "msal:popup-relay-response:v1";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1kcwc":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializeResponse", ()=>deserializeResponse);
parcelHelpers.export(exports, "validateInteractionType", ()=>validateInteractionType);
var _browser = require("@azure/msal-common/browser");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserProtocolUtilsMjs = require("../utils/BrowserProtocolUtils.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function deserializeResponse(responseString, responseLocation, logger, correlationId) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, _browser.UrlUtils).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, _browser.UrlUtils).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`18h0l1 ${responseLocation} ${responseLocation}`, correlationId);
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.hashEmptyError), correlationId);
        } else {
            logger.error(`13pl0s ${responseLocation} ${responseLocation}`, correlationId);
            logger.errorPii(`1097vx ${responseLocation} ${responseString}`, correlationId);
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.hashDoesNotContainKnownProperties), correlationId);
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function validateInteractionType(response, browserCrypto, interactionType, correlationId) {
    if (!response.state) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.noStateInHash), correlationId);
    const platformStateObj = (0, _browserProtocolUtilsMjs.extractBrowserRequestState)(browserCrypto, response.state, correlationId);
    if (!platformStateObj) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.unableToParseState), correlationId);
    if (platformStateObj.interactionType !== interactionType) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.stateInteractionTypeMismatch), correlationId);
}

},{"@azure/msal-common/browser":[["UrlUtils","2SeAw","*"]],"../error/BrowserAuthError.mjs":"k9YIy","../utils/BrowserProtocolUtils.mjs":"6UH55","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6UH55":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractBrowserRequestState", ()=>extractBrowserRequestState);
var _browser = require("@azure/msal-common/browser");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function extractBrowserRequestState(browserCrypto, state, correlationId) {
    if (!state) return null;
    try {
        const requestStateObj = (0, _browser.ProtocolUtils).parseRequestState(browserCrypto.base64Decode, state, correlationId);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).invalidState, correlationId);
    }
}

},{"@azure/msal-common/browser":[["ClientAuthErrorCodes","8keAa","*"],["createClientAuthError","e8Ku4"],["ProtocolUtils","ipQ3L","*"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7dpy6":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createForm", ()=>createForm);
parcelHelpers.export(exports, "getAuthCodeRequestUrl", ()=>getAuthCodeRequestUrl);
parcelHelpers.export(exports, "getCodeForm", ()=>getCodeForm);
parcelHelpers.export(exports, "getCodeFormData", ()=>getCodeFormData);
parcelHelpers.export(exports, "getEARForm", ()=>getEARForm);
parcelHelpers.export(exports, "getEARFormData", ()=>getEARFormData);
parcelHelpers.export(exports, "handleResponseCode", ()=>handleResponseCode);
parcelHelpers.export(exports, "handleResponseEAR", ()=>handleResponseEAR);
parcelHelpers.export(exports, "handleResponsePlatformBroker", ()=>handleResponsePlatformBroker);
parcelHelpers.export(exports, "parseClientData", ()=>parseClientData);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _cryptoOpsMjs = require("../crypto/CryptoOps.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _interactionHandlerMjs = require("../interaction_handler/InteractionHandler.mjs");
var _platformAuthInteractionClientMjs = require("../interaction_client/PlatformAuthInteractionClient.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const clientDataAccountTypeMapping = new Map([
    [
        "e",
        "AAD"
    ],
    [
        "m",
        "MSA"
    ]
]);
/**
 * Parses the clientdata response parameter from the /authorize endpoint.
 *
 * Logically, the clientdata value is URL-encoded and pipe-delimited:
 *   urlencoded(account_type | error | sub_error | cloud_instance | caller_data_boundary)
 *
 * In normal browser flows, this value may already have been URL-decoded
 * (e.g. by URLSearchParams). This function will only apply decodeURIComponent
 * when the string appears to contain percent-encoded sequences to avoid
 * double-decoding.
 *
 * @param clientdata - The raw clientdata string from the authorize response
 * @returns Parsed ClientData object, or null if the input is empty/invalid
 */ function parseClientData(clientdata) {
    if (!clientdata) return null;
    try {
        // Only decode when the string appears to contain percent-encoded sequences
        const shouldDecode = /%(?:[0-9A-Fa-f]{2})/.test(clientdata);
        const decoded = shouldDecode ? decodeURIComponent(clientdata) : clientdata;
        const parts = decoded.split("|");
        if (parts.length < 5) return null;
        return {
            accountType: clientDataAccountTypeMapping.get(parts[0]?.trim() || "") || "",
            error: parts[1]?.trim() || "",
            subError: parts[2]?.trim() || "",
            cloudInstance: parts[3]?.trim() || "",
            callerDataBoundary: parts[4]?.trim() || ""
        };
    } catch  {
        return null;
    }
}
/**
 * Instruments account type, error, and suberror from clientdata
 */ function instrumentClientData(response, correlationId, performanceClient) {
    const parsed = parseClientData(response.clientdata);
    parsed?.accountType && performanceClient.addFields({
        accountType: parsed.accountType
    }, correlationId);
    parsed?.error && performanceClient.addFields({
        serverErrorNo: parsed.error
    }, correlationId);
    parsed?.subError && performanceClient.addFields({
        serverSubErrorNo: parsed.subError
    }, correlationId);
}
/**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function getStandardParameters(config, authority, request, logger, performanceClient) {
    const parameters = (0, _browser.AuthorizeProtocol).getStandardAuthorizeRequestParameters({
        ...config.auth,
        authority: authority
    }, request, logger, performanceClient);
    (0, _browser.RequestParameterBuilder).addLibraryInfo(parameters, {
        sku: (0, _browserConstantsMjs.BrowserConstants).MSAL_SKU,
        version: (0, _packageMetadataMjs.version),
        os: "",
        cpu: ""
    });
    if (config.system.protocolMode !== (0, _browser.ProtocolMode).OIDC) (0, _browser.RequestParameterBuilder).addApplicationTelemetry(parameters, config.telemetry.application);
    if (request.platformBroker) {
        // signal ests that this is a WAM call
        (0, _browser.RequestParameterBuilder).addNativeBroker(parameters);
        // instrument JS-platform bridge specific fields
        performanceClient.addFields({
            isPlatformAuthorizeRequest: true
        }, request.correlationId);
        // pass the req_cnf for POP
        if (request.authenticationScheme === (0, _browser.Constants).AuthenticationScheme.POP) {
            const cryptoOps = new (0, _cryptoOpsMjs.CryptoOps)(logger, performanceClient);
            const popTokenGenerator = new (0, _browser.PopTokenGenerator)(cryptoOps, performanceClient);
            // req_cnf is always sent as a string for SPAs
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, _browser.invokeAsync)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, _browser.PerformanceEvents).PopTokenGenerateCnf, logger, performanceClient, request.correlationId)(request, logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = cryptoOps.encodeKid(request.popKid);
            (0, _browser.RequestParameterBuilder).addPopToken(parameters, reqCnfData);
        }
    }
    (0, _browser.RequestParameterBuilder).instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return parameters;
}
/**
 * Gets the full /authorize URL with request parameters when using Auth Code + PKCE
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function getAuthCodeRequestUrl(config, authority, request, logger, performanceClient) {
    if (!request.codeChallenge) throw (0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).pkceParamsMissing, request.correlationId);
    const parameters = await (0, _browser.invokeAsync)(getStandardParameters, (0, _browserPerformanceEventsMjs.GetStandardParams), logger, performanceClient, request.correlationId)(config, authority, request, logger, performanceClient);
    (0, _browser.RequestParameterBuilder).addResponseType(parameters, (0, _browser.Constants).OAuthResponseType.CODE);
    (0, _browser.RequestParameterBuilder).addCodeChallengeParams(parameters, request.codeChallenge, (0, _browser.Constants).S256_CODE_CHALLENGE_METHOD);
    // Merge extraQueryParameters and extraParameters to be appended to request URL
    (0, _browser.RequestParameterBuilder).addExtraParameters(parameters, {
        ...request.extraQueryParameters,
        ...request.extraParameters
    });
    return (0, _browser.AuthorizeProtocol).getAuthorizeUrl(authority, parameters);
}
/**
 * Builds the action URL + POST-body fields for the EAR /authorize form.
 */ async function getEARFormData(config, authority, request, logger, performanceClient) {
    if (!request.earJwk) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.earJwkEmpty), request.correlationId);
    const parameters = await getStandardParameters(config, authority, request, logger, performanceClient);
    (0, _browser.RequestParameterBuilder).addResponseType(parameters, (0, _browser.Constants).OAuthResponseType.IDTOKEN_TOKEN_REFRESHTOKEN);
    (0, _browser.RequestParameterBuilder).addEARParameters(parameters, request.earJwk);
    // Also add codeChallenge as backup in case EAR is not supported
    (0, _browser.RequestParameterBuilder).addCodeChallengeParams(parameters, request.codeChallenge, (0, _browser.Constants).S256_CODE_CHALLENGE_METHOD);
    (0, _browser.RequestParameterBuilder).addExtraParameters(parameters, {
        ...request.extraParameters
    });
    const queryParams = new Map();
    (0, _browser.RequestParameterBuilder).addExtraParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    (0, _browser.RequestParameterBuilder).addCorrelationId(queryParams, request.correlationId);
    const action = (0, _browser.AuthorizeProtocol).getAuthorizeUrl(authority, queryParams);
    return {
        action,
        fields: Object.fromEntries(parameters)
    };
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using EAR
 */ async function getEARForm(frame, config, authority, request, logger, performanceClient) {
    const { action, fields } = await getEARFormData(config, authority, request, logger, performanceClient);
    return createForm(frame, action, fields);
}
/**
 * Builds the action URL + POST-body fields for the auth-code /authorize form.
 */ async function getCodeFormData(config, authority, request, logger, performanceClient) {
    const parameters = await getStandardParameters(config, authority, request, logger, performanceClient);
    (0, _browser.RequestParameterBuilder).addResponseType(parameters, (0, _browser.Constants).OAuthResponseType.CODE);
    (0, _browser.RequestParameterBuilder).addCodeChallengeParams(parameters, request.codeChallenge, request.codeChallengeMethod || (0, _browser.Constants).S256_CODE_CHALLENGE_METHOD);
    // Add extraParameters to the request body
    (0, _browser.RequestParameterBuilder).addExtraParameters(parameters, {
        ...request.extraParameters
    });
    // Add extraQueryParameters to be appended to request URL
    const queryParams = new Map();
    (0, _browser.RequestParameterBuilder).addExtraParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    (0, _browser.RequestParameterBuilder).addCorrelationId(queryParams, request.correlationId);
    const action = (0, _browser.AuthorizeProtocol).getAuthorizeUrl(authority, queryParams);
    return {
        action,
        fields: Object.fromEntries(parameters)
    };
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using POST method
 */ async function getCodeForm(frame, config, authority, request, logger, performanceClient) {
    const { action, fields } = await getCodeFormData(config, authority, request, logger, performanceClient);
    return createForm(frame, action, fields);
}
/**
 * Creates a POST `<form>` in the provided document with the given auth
 * parameters as hidden inputs, targeting `action`. Shared by the popup auth
 * flows (`getEARForm` / `getCodeForm`) and the popup-relay page
 * (`runPopupRelay`) so the form is built one way only.
 *
 * @param frame - document to create the form in
 * @param action - form action (the /authorize URL)
 * @param fields - POST-body fields
 * @internal
 */ function createForm(frame, action, fields) {
    const form = frame.createElement("form");
    form.method = "post";
    form.action = action;
    Object.keys(fields).forEach((name)=>{
        const input = frame.createElement("input");
        input.hidden = true;
        input.name = name;
        input.value = fields[name];
        form.appendChild(input);
    });
    frame.body.appendChild(form);
    return form;
}
/**
 * Response handler when server returns accountId on the /authorize request
 * @param request
 * @param accountId
 * @param apiId
 * @param config
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function handleResponsePlatformBroker(request, accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    logger.verbose("11qcow", request.correlationId);
    if (!platformAuthProvider) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.nativeConnectionNotEstablished), request.correlationId);
    const browserCrypto = new (0, _cryptoOpsMjs.CryptoOps)(logger, performanceClient);
    const nativeInteractionClient = new (0, _platformAuthInteractionClientMjs.PlatformAuthInteractionClient)(config, browserStorage, browserCrypto, logger, eventHandler, config.system.navigationClient, apiId, performanceClient, platformAuthProvider, accountId, nativeStorage, request.correlationId);
    const { userRequestState } = (0, _browser.ProtocolUtils).parseRequestState(browserCrypto.base64Decode, request.state, request.correlationId);
    return (0, _browser.invokeAsync)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, _browserPerformanceEventsMjs.NativeInteractionClientAcquireToken), logger, performanceClient, request.correlationId)({
        ...request,
        state: userRequestState,
        prompt: undefined
    });
}
/**
 * Response handler when server returns code on the /authorize request
 * @param request
 * @param response
 * @param codeVerifier
 * @param authClient
 * @param browserStorage
 * @param logger
 * @param performanceClient
 * @returns
 */ async function handleResponseCode(request, response, codeVerifier, apiId, config, authClient, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, _browser.ThrottlingUtils).removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    instrumentClientData(response, request.correlationId, performanceClient);
    if (response.accountId) return (0, _browser.invokeAsync)(handleResponsePlatformBroker, (0, _browserPerformanceEventsMjs.HandleResponsePlatformBroker), logger, performanceClient, request.correlationId)(request, response.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const authCodeRequest = {
        ...request,
        code: response.code || "",
        codeVerifier: codeVerifier
    };
    // Create popup interaction handler.
    const interactionHandler = new (0, _interactionHandlerMjs.InteractionHandler)(authClient, browserStorage, authCodeRequest, logger, performanceClient);
    // Handle response from hash string.
    const result = await (0, _browser.invokeAsync)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, _browserPerformanceEventsMjs.HandleCodeResponse), logger, performanceClient, request.correlationId)(response, request, apiId);
    return result;
}
/**
 * Response handler when server returns ear_jwe on the /authorize request
 * @param request
 * @param response
 * @param apiId
 * @param config
 * @param authority
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function handleResponseEAR(request, response, apiId, config, authority, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, _browser.ThrottlingUtils).removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    instrumentClientData(response, request.correlationId, performanceClient);
    // Validate state & check response for errors
    (0, _browser.AuthorizeProtocol).validateAuthorizationResponse(response, request.state, request.correlationId);
    if (!response.ear_jwe) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.earJweEmpty), request.correlationId);
    if (!request.earJwk) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.earJwkEmpty), request.correlationId);
    const decryptedData = JSON.parse(await (0, _browser.invokeAsync)((0, _browserCryptoMjs.decryptEarResponse), (0, _browserPerformanceEventsMjs.DecryptEarResponse), logger, performanceClient, request.correlationId)(request.earJwk, response.ear_jwe));
    if (decryptedData.accountId) return (0, _browser.invokeAsync)(handleResponsePlatformBroker, (0, _browserPerformanceEventsMjs.HandleResponsePlatformBroker), logger, performanceClient, request.correlationId)(request, decryptedData.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const responseHandler = new (0, _browser.ResponseHandler)(config.auth.clientId, browserStorage, new (0, _cryptoOpsMjs.CryptoOps)(logger, performanceClient), logger, performanceClient, null, null);
    // Validate response. This function throws a server error if an error is returned by the server.
    responseHandler.validateTokenResponse(decryptedData, request.correlationId);
    // Temporary until response handler is refactored to be more flow agnostic.
    const additionalData = {
        code: "",
        state: request.state,
        nonce: request.nonce,
        client_info: decryptedData.client_info,
        cloud_graph_host_name: decryptedData.cloud_graph_host_name,
        cloud_instance_host_name: decryptedData.cloud_instance_host_name,
        cloud_instance_name: decryptedData.cloud_instance_name,
        msgraph_host: decryptedData.msgraph_host
    };
    return await (0, _browser.invokeAsync)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, _browser.PerformanceEvents).HandleServerTokenResponse, logger, performanceClient, request.correlationId)(decryptedData, authority, (0, _browser.TimeUtils).nowSeconds(), request, apiId, additionalData, undefined, undefined, undefined, undefined);
}

},{"@azure/msal-common/browser":[["AuthorizeProtocol","iuOjG","*"],["ClientConfigurationErrorCodes","iMtlX","*"],["Constants","5eRZy","*"],["createClientConfigurationError","ebyn4"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"],["PopTokenGenerator","bnqqV"],["ProtocolMode","8zD57"],["ProtocolUtils","ipQ3L","*"],["RequestParameterBuilder","lAS2Y","*"],["ResponseHandler","7Ytwn"],["ThrottlingUtils","4haCt"],["TimeUtils","6CLZ0","*"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../utils/BrowserConstants.mjs":"5kHn0","../packageMetadata.mjs":"7kVpA","../crypto/CryptoOps.mjs":"kQH8V","../error/BrowserAuthError.mjs":"k9YIy","../interaction_handler/InteractionHandler.mjs":"7Hteg","../interaction_client/PlatformAuthInteractionClient.mjs":"9OO2K","../crypto/BrowserCrypto.mjs":"a5L0H","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iuOjG":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthorizationCodePayload", ()=>getAuthorizationCodePayload);
parcelHelpers.export(exports, "getAuthorizeUrl", ()=>getAuthorizeUrl);
parcelHelpers.export(exports, "getStandardAuthorizeRequestParameters", ()=>getStandardAuthorizeRequestParameters);
parcelHelpers.export(exports, "validateAuthorizationResponse", ()=>validateAuthorizationResponse);
var _requestParameterBuilderMjs = require("../request/RequestParameterBuilder.mjs");
var _aadserverParamKeysMjs = require("../constants/AADServerParamKeys.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _clientInfoMjs = require("../account/ClientInfo.mjs");
var _urlUtilsMjs = require("../utils/UrlUtils.mjs");
var _urlStringMjs = require("../url/UrlString.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _interactionRequiredAuthErrorMjs = require("../error/InteractionRequiredAuthError.mjs");
var _serverErrorMjs = require("../error/ServerError.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 * @internal
 */ function getStandardAuthorizeRequestParameters(authOptions, request, logger, performanceClient) {
    // generate the correlationId if not set by the user and add
    const correlationId = request.correlationId;
    const parameters = new Map();
    (0, _requestParameterBuilderMjs.addClientId)(parameters, request.embeddedClientId || request.extraQueryParameters?.[0, _aadserverParamKeysMjs.CLIENT_ID] || authOptions.clientId);
    const requestScopes = [
        ...request.scopes || [],
        ...request.extraScopesToConsent || []
    ];
    (0, _requestParameterBuilderMjs.addScopes)(parameters, requestScopes, request.correlationId, true, authOptions.authority.options.OIDCOptions?.defaultScopes);
    (0, _requestParameterBuilderMjs.addResource)(parameters, request.resource);
    (0, _requestParameterBuilderMjs.addRedirectUri)(parameters, request.redirectUri);
    (0, _requestParameterBuilderMjs.addCorrelationId)(parameters, correlationId);
    // add response_mode. If not passed in it defaults to query.
    (0, _requestParameterBuilderMjs.addResponseMode)(parameters, request.responseMode);
    // add client_info=1
    (0, _requestParameterBuilderMjs.addClientInfo)(parameters);
    // add clidata=1
    (0, _requestParameterBuilderMjs.addCliData)(parameters);
    if (request.prompt) {
        (0, _requestParameterBuilderMjs.addPrompt)(parameters, request.prompt);
        performanceClient?.addFields({
            prompt: request.prompt
        }, correlationId);
    }
    if (request.domainHint) {
        (0, _requestParameterBuilderMjs.addDomainHint)(parameters, request.domainHint);
        performanceClient?.addFields({
            domainHintFromRequest: true
        }, correlationId);
    }
    // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
    if (request.prompt !== (0, _constantsMjs.PromptValue).SELECT_ACCOUNT) {
        // AAD will throw if prompt=select_account is passed with an account hint
        if (request.sid && request.prompt === (0, _constantsMjs.PromptValue).NONE) {
            // SessionID is only used in silent calls
            logger.verbose("1tvqyx", request.correlationId);
            (0, _requestParameterBuilderMjs.addSid)(parameters, request.sid);
            performanceClient?.addFields({
                sidFromRequest: true
            }, correlationId);
        } else if (request.account) {
            const accountSid = extractAccountSid(request.account);
            let accountLoginHintClaim = extractLoginHint(request.account);
            if (accountLoginHintClaim && request.domainHint) {
                logger.warning("0wkg3v", request.correlationId);
                accountLoginHintClaim = null;
            }
            // If login_hint claim is present, use it over sid/username
            if (accountLoginHintClaim) {
                logger.verbose("1eyfsw", request.correlationId);
                (0, _requestParameterBuilderMjs.addLoginHint)(parameters, accountLoginHintClaim);
                performanceClient?.addFields({
                    loginHintFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, _clientInfoMjs.buildClientInfoFromHomeAccountId)(request.account.homeAccountId);
                    (0, _requestParameterBuilderMjs.addCcsOid)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            } else if (accountSid && request.prompt === (0, _constantsMjs.PromptValue).NONE) {
                /*
                 * If account and loginHint are provided, we will check account first for sid before adding loginHint
                 * SessionId is only used in silent calls
                 */ logger.verbose("1rmd8s", request.correlationId);
                (0, _requestParameterBuilderMjs.addSid)(parameters, accountSid);
                performanceClient?.addFields({
                    sidFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, _clientInfoMjs.buildClientInfoFromHomeAccountId)(request.account.homeAccountId);
                    (0, _requestParameterBuilderMjs.addCcsOid)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            } else if (request.loginHint) {
                logger.verbose("0y3007", request.correlationId);
                (0, _requestParameterBuilderMjs.addLoginHint)(parameters, request.loginHint);
                (0, _requestParameterBuilderMjs.addCcsUpn)(parameters, request.loginHint);
                performanceClient?.addFields({
                    loginHintFromRequest: true
                }, correlationId);
            } else if (request.account.username) {
                // Fallback to account username if provided
                logger.verbose("02f507", request.correlationId);
                (0, _requestParameterBuilderMjs.addLoginHint)(parameters, request.account.username);
                performanceClient?.addFields({
                    loginHintFromUpn: true
                }, correlationId);
                try {
                    const clientInfo = (0, _clientInfoMjs.buildClientInfoFromHomeAccountId)(request.account.homeAccountId);
                    (0, _requestParameterBuilderMjs.addCcsOid)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            }
        } else if (request.loginHint) {
            logger.verbose("0g01ey", request.correlationId);
            (0, _requestParameterBuilderMjs.addLoginHint)(parameters, request.loginHint);
            (0, _requestParameterBuilderMjs.addCcsUpn)(parameters, request.loginHint);
            performanceClient?.addFields({
                loginHintFromRequest: true
            }, correlationId);
        }
    } else logger.verbose("169k9v", request.correlationId);
    if (request.nonce) (0, _requestParameterBuilderMjs.addNonce)(parameters, request.nonce);
    if (request.state) (0, _requestParameterBuilderMjs.addState)(parameters, request.state);
    if (request.embeddedClientId) (0, _requestParameterBuilderMjs.addBrokerParameters)(parameters, authOptions.clientId, authOptions.redirectUri);
    (0, _requestParameterBuilderMjs.addClaims)(parameters, request.correlationId, request.claims, authOptions.clientCapabilities, request.skipBrokerClaims);
    // If extraQueryParameters includes instance_aware its value will be added when extraQueryParameters are added
    if (authOptions.instanceAware && (!request.extraQueryParameters || !Object.keys(request.extraQueryParameters).includes((0, _aadserverParamKeysMjs.INSTANCE_AWARE)))) (0, _requestParameterBuilderMjs.addInstanceAware)(parameters);
    return parameters;
}
/**
 * Returns authorize endpoint with given request parameters in the query string
 * @param authority
 * @param requestParameters
 * @returns
 * @internal
 */ function getAuthorizeUrl(authority, requestParameters) {
    const queryString = (0, _urlUtilsMjs.mapToQueryString)(requestParameters);
    return (0, _urlStringMjs.UrlString).appendQueryString(authority.authorizationEndpoint, queryString);
}
/**
 * Handles the hash fragment response from public client code request. Returns a code response used by
 * the client to exchange for a token in acquireToken.
 * @param serverParams
 * @param cachedState
 * @param correlationId
 */ function getAuthorizationCodePayload(serverParams, cachedState, correlationId) {
    // Get code response
    validateAuthorizationResponse(serverParams, cachedState, correlationId);
    // throw when there is no auth code in the response
    if (!serverParams.code) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.authorizationCodeMissingFromServerResponse), correlationId);
    return serverParams;
}
/**
 * Function which validates server authorization code response.
 * @param serverResponseHash
 * @param requestState
 * @param correlationId
 */ function validateAuthorizationResponse(serverResponse, requestState, correlationId) {
    if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.stateNotFound), correlationId, "Cached State") : (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.stateNotFound), correlationId, "Server State");
    let decodedServerResponseState;
    let decodedRequestState;
    try {
        decodedServerResponseState = decodeURIComponent(serverResponse.state);
    } catch (e) {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.invalidState), correlationId, serverResponse.state);
    }
    try {
        decodedRequestState = decodeURIComponent(requestState);
    } catch (e) {
        throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.invalidState), correlationId, serverResponse.state);
    }
    if (decodedServerResponseState !== decodedRequestState) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.stateMismatch), correlationId);
    // Check for error
    if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
        const serverErrorNo = parseServerErrorNo(serverResponse);
        if ((0, _interactionRequiredAuthErrorMjs.isInteractionRequiredError)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, _interactionRequiredAuthErrorMjs.InteractionRequiredAuthError)(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
        throw new (0, _serverErrorMjs.ServerError)(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverErrorNo);
    }
}
/**
 * Get server error No from the error_uri
 * @param serverResponse
 * @returns
 */ function parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
 * @param account
 */ function extractAccountSid(account) {
    return account.idTokenClaims?.sid || null;
}
function extractLoginHint(account) {
    return account.loginHint || account.idTokenClaims?.login_hint || null;
}

},{"../request/RequestParameterBuilder.mjs":"lAS2Y","../constants/AADServerParamKeys.mjs":"kjH8Y","../utils/Constants.mjs":"5eRZy","../account/ClientInfo.mjs":"98dT9","../utils/UrlUtils.mjs":"2SeAw","../url/UrlString.mjs":"9Z8Lm","../error/ClientAuthError.mjs":"e8Ku4","../error/InteractionRequiredAuthError.mjs":"jiVlC","../error/ServerError.mjs":"dvxy4","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7Hteg":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InteractionHandler", ()=>InteractionHandler);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class InteractionHandler {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request, apiId) {
        let authCodeResponse;
        try {
            authCodeResponse = (0, _browser.AuthorizeProtocol).getAuthorizationCodePayload(response, request.state, request.correlationId);
        } catch (e) {
            if (e instanceof (0, _browser.ServerError) && e.subError === (0, _browserAuthErrorCodesMjs.userCancelled)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.userCancelled), request.correlationId);
            else throw e;
        }
        return (0, _browser.invokeAsync)(this.handleCodeResponseFromServer.bind(this), (0, _browser.PerformanceEvents).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request, apiId);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param request
     * @param validateNonce
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, apiId, validateNonce = true) {
        this.logger.trace("0mf2hb", request.correlationId);
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, _browser.invokeAsync)(this.authModule.acquireToken.bind(this.authModule), (0, _browserPerformanceEventsMjs.AuthClientAcquireToken), this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, apiId, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, _browser.CcsCredentialType).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, _browser.CcsCredentialType).UPN
        };
        return null;
    }
}

},{"@azure/msal-common/browser":[["AuthorizeProtocol","iuOjG","*"],["CcsCredentialType","iEcz2"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"],["ServerError","dvxy4"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../error/BrowserAuthError.mjs":"k9YIy","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9OO2K":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlatformAuthInteractionClient", ()=>PlatformAuthInteractionClient);
var _browser = require("@azure/msal-common/browser");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _nativeAuthErrorMjs = require("../error/NativeAuthError.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _silentCacheClientMjs = require("./SilentCacheClient.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
var _nativeAuthErrorCodesMjs = require("../error/NativeAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class PlatformAuthInteractionClient extends (0, _baseInteractionClientMjs.BaseInteractionClient) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider);
        this.apiId = apiId;
        this.accountId = accountId;
        this.platformAuthProvider = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, _silentCacheClientMjs.SilentCacheClient)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider);
        const extensionName = this.platformAuthProvider.getExtensionName();
        this.skus = (0, _browser.ServerTelemetryManager).makeExtraSkuString({
            libraryName: (0, _browserConstantsMjs.BrowserConstants).MSAL_SKU,
            libraryVersion: (0, _packageMetadataMjs.version),
            extensionName: extensionName,
            extensionVersion: this.platformAuthProvider.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, _browser.AADServerParamKeys).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request, cacheLookupPolicy) {
        this.logger.trace("03qeos", this.correlationId);
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, _browserPerformanceEventsMjs.NativeInteractionClientAcquireToken), this.correlationId);
        const reqTimestamp = (0, _browser.TimeUtils).nowSeconds();
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // initialize native request
            const nativeRequest = await this.initializePlatformRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                if (cacheLookupPolicy === (0, _browserConstantsMjs.CacheLookupPolicy).AccessToken) {
                    this.logger.info("0eitbc", this.correlationId);
                    nativeATMeasurement.end({
                        success: false,
                        brokerErrorCode: "cache_request_failed"
                    });
                    throw e;
                }
                // continue with a native call for any and all errors
                this.logger.info("0957j1", this.correlationId);
            }
            const validatedResponse = await this.platformAuthProvider.sendMessage(nativeRequest);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, _nativeAuthErrorMjs.NativeAuthError)) serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            nativeATMeasurement.end({
                success: false
            });
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, _browser.ScopeSet).fromString(request.scope, this.correlationId).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("1ndf3e", this.correlationId);
            throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).noAccountFound, this.correlationId);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId
        }, this.correlationId);
        if (!account) throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).noAccountFound, this.correlationId);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const idToken = this.browserStorage.getIdToken(account, this.correlationId, this.browserStorage.getTokenKeys(), account.tenantId);
            const idTokenClaims = (0, _browser.AuthToken).extractTokenClaims(idToken?.secret || "", (0, _base64DecodeMjs.base64Decode), this.correlationId);
            const fullAccount = (0, _browser.updateAccountTenantProfileData)(account, undefined, idTokenClaims, idToken?.secret);
            return {
                ...result,
                idToken: idToken?.secret || "",
                idTokenClaims: idTokenClaims,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     * @param {HandleRedirectPromiseOptions} options
     */ async acquireTokenRedirect(request, rootMeasurement, options) {
        this.logger.trace("0luikq", this.correlationId);
        const nativeRequest = await this.initializePlatformRequest(request);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            await this.platformAuthProvider.sendMessage(nativeRequest);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, _nativeAuthErrorMjs.NativeAuthError)) {
                const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
                serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, _nativeAuthErrorMjs.isFatalNativeAuthError)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, _browserConstantsMjs.ApiId).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = navigateToLoginRequestUrl ? (0, _browser.UrlString).getAbsoluteUrl(request.redirectStartPage || window.location.href, (0, _browserUtilsMjs.getCurrentUri)(), this.correlationId) : (0, _baseInteractionClientMjs.getRedirectUri)(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise() {
        this.logger.trace("1c5lhw", this.correlationId);
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("0le6uv", this.correlationId);
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("0a6zjb", this.correlationId);
            this.performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, this.correlationId);
            return null;
        }
        const { prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("0ac34v", this.correlationId);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, _browserConstantsMjs.TemporaryCacheKeys).NATIVE_REQUEST));
        const reqTimestamp = (0, _browser.TimeUtils).nowSeconds();
        try {
            this.logger.verbose("003x5a", this.correlationId);
            const response = await this.platformAuthProvider.sendMessage(request);
            const authResult = await this.handleNativeResponse(response, request, reqTimestamp);
            const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
            serverTelemetryManager.clearNativeBrokerErrorCode();
            this.performanceClient?.addFields({
                isNativeBroker: true
            }, this.correlationId);
            return authResult;
        } catch (e) {
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("0u2sjm", this.correlationId);
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("1bojln", this.correlationId);
        // generate identifiers
        const idTokenClaims = (0, _browser.AuthToken).extractTokenClaims(response.id_token, (0, _base64DecodeMjs.base64Decode), this.correlationId);
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        // add exception for double brokering, please note this is temporary and will be fortified in future
        if (request.extraParameters?.child_client_id && response.account.id !== request.accountId) this.logger.info("1ub1in", this.correlationId);
        else if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, _nativeAuthErrorMjs.createNativeAuthError)((0, _nativeAuthErrorCodesMjs.userSwitch), this.correlationId);
        // Get the preferred_cache domain for the given authority
        const authority = await (0, _baseInteractionClientMjs.getDiscoveredAuthority)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, request.authority);
        const baseAccount = (0, _browser.buildAccountToCache)(this.browserStorage, authority, homeAccountIdentifier, (0, _base64DecodeMjs.base64Decode), this.correlationId, idTokenClaims, response.client_info, authority.getPreferredCache(), idTokenClaims.tid, undefined, response.account.id, this.logger, this.performanceClient);
        // Ensure expires_in is in number format
        response.expires_in = Number(response.expires_in);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        await this.cacheAccount(baseAccount, (0, _browser.AuthToken).isKmsi(idTokenClaims));
        await this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, result.tenantId, reqTimestamp, authority.getPreferredCache() // environment
        );
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, _browser.AccountEntityUtils).generateHomeAccountId(response.client_info || "", (0, _browser.AuthorityType).Default, this.logger, this.browserCrypto, this.correlationId, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(requestScopes, responseScopes) {
        return responseScopes ? (0, _browser.ScopeSet).fromString(responseScopes, this.correlationId) : (0, _browser.ScopeSet).fromString(requestScopes, this.correlationId);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, _browser.Constants).AuthenticationScheme.POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("0coqhu", this.correlationId);
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, _browser.PopTokenGenerator)(this.browserCrypto, this.performanceClient);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).keyIdMissing, this.correlationId);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response.properties.MATS);
        // If scopes not returned in server response, use request scopes
        const responseScopes = this.generateScopes(request.scope, response.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || "";
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || "";
        const accountInfo = (0, _browser.updateAccountTenantProfileData)((0, _browser.AccountEntityUtils).getAccountInfo(accountEntity), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) {
            accountInfo.nativeAccountId = response.account.id;
            // Also update the matching tenant profile (source of truth)
            const targetTenantId = tid || accountInfo.tenantId;
            const tenantProfile = accountInfo.tenantProfiles?.get(targetTenantId);
            if (tenantProfile) tenantProfile.nativeAccountId = response.account.id;
        }
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, _browser.Constants).AuthenticationScheme.POP ? (0, _browser.Constants).AuthenticationScheme.POP : (0, _browser.Constants).AuthenticationScheme.BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            // Request timestamp and NativeResponse expires_in are in seconds, converting to Date for AuthenticationResult
            expiresOn: (0, _browser.TimeUtils).toDateFromSeconds(reqTimestamp + response.expires_in),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromPlatformBroker: true,
            ...request.resource && {
                resource: request.resource
            }
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ async cacheAccount(accountEntity, kmsi) {
        // Store the account info and hence `nativeAccountId` in browser cache
        await this.browserStorage.setAccount(accountEntity, this.correlationId, kmsi, this.apiId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext((0, _browser.AccountEntityUtils).getAccountInfo(accountEntity), this.correlationId);
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ async cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, tenantId, reqTimestamp, environment) {
        const cachedIdToken = (0, _browser.CacheHelpers).createIdTokenEntity(homeAccountIdentifier, environment, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, _browser.Constants).AuthenticationScheme.POP ? (0, _browser.Constants).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response.scope, request.scope);
        const cachedAccessToken = (0, _browser.CacheHelpers).createAccessTokenEntity(homeAccountIdentifier, environment, response.access_token, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, _base64DecodeMjs.base64Decode), request.correlationId, undefined, request.tokenType, undefined, request.keyId);
        // save idtoken credential in configured browser storage
        if (!!cachedIdToken && request.storeInCache?.idToken !== false) await this.browserStorage.setIdTokenCredential(cachedIdToken, this.correlationId, (0, _browser.AuthToken).isKmsi(idTokenClaims));
        // save access token credential in memory storage
        const nativeCacheRecord = {
            accessToken: cachedAccessToken
        };
        return this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, this.correlationId, (0, _browser.AuthToken).isKmsi(idTokenClaims), this.apiId, request.storeInCache);
    }
    getExpiresInValue(tokenType, expiresIn) {
        return tokenType === (0, _browser.Constants).AuthenticationScheme.POP ? (0, _browser.Constants).SHR_NONCE_VALIDITY : (typeof expiresIn === "string" ? parseInt(expiresIn, 10) : expiresIn) || 0;
    }
    addTelemetryFromNativeResponse(matsResponse) {
        const mats = this.getMATSFromResponse(matsResponse);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.platformAuthProvider.getExtensionId(),
            extensionVersion: this.platformAuthProvider.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(matsResponse) {
        if (matsResponse) try {
            return JSON.parse(matsResponse);
        } catch (e) {
            this.logger.error("0b3l57", this.correlationId);
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("1okqev", this.correlationId);
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializePlatformRequest(request) {
        this.logger.trace("1xdm2a", this.correlationId);
        const canonicalAuthority = await this.getCanonicalAuthority(request);
        // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
        const configClaims = request.skipBrokerClaims && !!request.embeddedClientId ? undefined : this.config.auth.clientCapabilities;
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes, claims, ...remainingProperties } = request;
        const scopeSet = new (0, _browser.ScopeSet)(scopes || [], this.correlationId);
        scopeSet.appendScopes((0, _browser.Constants).OIDC_DEFAULT_SCOPES);
        const mergedClaims = (0, _browser.RequestParameterBuilder).buildMergedClaims(claims, configClaims?.length ? configClaims : undefined);
        const validatedRequest = {
            ...remainingProperties,
            claims: mergedClaims,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: (0, _baseInteractionClientMjs.getRedirectUri)(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId),
            prompt: this.getPrompt(request.prompt),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.invalidPopTokenRequest), this.correlationId);
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, _browserConstantsMjs.PlatformAuthConstants).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, _browser.Constants).AuthenticationScheme.POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            const popTokenGenerator = new (0, _browser.PopTokenGenerator)(this.browserCrypto, this.performanceClient);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, _browser.invokeAsync)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, _browser.PerformanceEvents).PopTokenGenerateCnf, this.logger, this.performanceClient, this.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    async getCanonicalAuthority(request) {
        const requestAuthority = request.authority || this.config.auth.authority;
        const { azureCloudOptions, account } = request;
        if (account) // validate authority
        await (0, _baseInteractionClientMjs.getDiscoveredAuthority)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, azureCloudOptions, undefined, account);
        const canonicalAuthority = new (0, _browser.UrlString)(requestAuthority, this.correlationId);
        canonicalAuthority.validateAsUri();
        return canonicalAuthority;
    }
    getPrompt(prompt) {
        // If request is silent, prompt is always none
        switch(this.apiId){
            case (0, _browserConstantsMjs.ApiId).ssoSilent:
            case (0, _browserConstantsMjs.ApiId).acquireTokenSilent_silentFlow:
                this.logger.trace("12n1y2", this.correlationId);
                return (0, _browser.Constants).PromptValue.NONE;
        }
        // Prompt not provided, request may proceed and native broker decides if it needs to prompt
        if (!prompt) {
            this.logger.trace("0uid1p", this.correlationId);
            return undefined;
        }
        // If request is interactive, check if prompt provided is allowed to go directly to native broker
        switch(prompt){
            case (0, _browser.Constants).PromptValue.NONE:
            case (0, _browser.Constants).PromptValue.CONSENT:
            case (0, _browser.Constants).PromptValue.LOGIN:
                this.logger.trace("0i0hco", this.correlationId);
                return prompt;
            default:
                this.logger.trace(`0w3tpw ${prompt}`, this.correlationId);
                throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.nativePromptNotSupported), this.correlationId);
        }
    }
    /**
     * Handles extra broker request parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, _browser.AADServerParamKeys).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, _browser.AADServerParamKeys).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, _browser.AADServerParamKeys).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, _browser.AADServerParamKeys).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, _browser.AADServerParamKeys).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id,
            child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, this.correlationId);
    }
}

},{"@azure/msal-common/browser":[["AADServerParamKeys","kjH8Y","*"],["AccountEntityUtils","kwYyZ","*"],["AuthorityType","g1AZM"],["AuthToken","l1q48","*"],["buildAccountToCache","7Ytwn"],["CacheHelpers","61GoB","*"],["ClientAuthErrorCodes","8keAa","*"],["Constants","5eRZy","*"],["createClientAuthError","e8Ku4"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"],["PopTokenGenerator","bnqqV"],["RequestParameterBuilder","lAS2Y","*"],["ScopeSet","7niwa"],["ServerTelemetryManager","cqiOT"],["TimeUtils","6CLZ0","*"],["updateAccountTenantProfileData","glI6y"],["UrlString","9Z8Lm"]],"../encode/Base64Decode.mjs":"evkpn","../error/BrowserAuthError.mjs":"k9YIy","../error/NativeAuthError.mjs":"iAojo","../packageMetadata.mjs":"7kVpA","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../utils/BrowserConstants.mjs":"5kHn0","../utils/BrowserUtils.mjs":"eyRWO","./BaseInteractionClient.mjs":"9bVY8","./SilentCacheClient.mjs":"fRXRu","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","../error/NativeAuthErrorCodes.mjs":"60SIe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iAojo":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAuthError", ()=>NativeAuthError);
parcelHelpers.export(exports, "createNativeAuthError", ()=>createNativeAuthError);
parcelHelpers.export(exports, "isFatalNativeAuthError", ()=>isFatalNativeAuthError);
var _browser = require("@azure/msal-common/browser");
var _browserAuthErrorMjs = require("./BrowserAuthError.mjs");
var _nativeAuthErrorCodesMjs = require("./NativeAuthErrorCodes.mjs");
var _nativeStatusCodesMjs = require("../broker/nativeBroker/NativeStatusCodes.mjs");
var _browserAuthErrorCodesMjs = require("./BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const INVALID_METHOD_ERROR = -2147186943;
class NativeAuthError extends (0, _browser.AuthError) {
    constructor(errorCode, correlationId, description, ext){
        super(errorCode, correlationId, description || (0, _browserAuthErrorMjs.getDefaultErrorMessage)(errorCode));
        Object.setPrototypeOf(this, NativeAuthError.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function isFatalNativeAuthError(error) {
    if (error.ext && error.ext.status && error.ext.status === (0, _nativeStatusCodesMjs.DISABLED)) return true;
    if (error.ext && error.ext.error && error.ext.error === INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, _nativeAuthErrorCodesMjs.contentError:
        case 0, _nativeAuthErrorCodesMjs.pageException:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function createNativeAuthError(code, correlationId, description, ext) {
    let error;
    if (ext && ext.status) {
        switch(ext.status){
            case 0, _nativeStatusCodesMjs.ACCOUNT_UNAVAILABLE:
                error = (0, _browser.createInteractionRequiredAuthError)((0, _browser.InteractionRequiredAuthErrorCodes).nativeAccountUnavailable, correlationId, (0, _browserAuthErrorMjs.getDefaultErrorMessage)(code));
                break;
            case 0, _nativeStatusCodesMjs.USER_INTERACTION_REQUIRED:
                error = new (0, _browser.InteractionRequiredAuthError)(code, correlationId, description);
                break;
            case 0, _nativeStatusCodesMjs.USER_CANCEL:
                error = (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.userCancelled), correlationId);
                break;
            case 0, _nativeStatusCodesMjs.NO_NETWORK:
                error = (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.noNetworkConnectivity), correlationId);
                break;
            case 0, _nativeStatusCodesMjs.UI_NOT_ALLOWED:
                error = (0, _browser.createInteractionRequiredAuthError)((0, _browser.InteractionRequiredAuthErrorCodes).uiNotAllowed, correlationId);
                break;
            default:
                error = new NativeAuthError(code, correlationId, description, ext);
        }
        return error;
    }
    error = new NativeAuthError(code, correlationId, description, ext);
    return error;
}

},{"@azure/msal-common/browser":[["AuthError","8TWYe"],["createInteractionRequiredAuthError","jiVlC"],["InteractionRequiredAuthError","jiVlC"],["InteractionRequiredAuthErrorCodes","9FSE5","*"]],"./BrowserAuthError.mjs":"k9YIy","./NativeAuthErrorCodes.mjs":"60SIe","../broker/nativeBroker/NativeStatusCodes.mjs":"ehtYt","./BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"60SIe":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentError", ()=>contentError);
parcelHelpers.export(exports, "pageException", ()=>pageException);
parcelHelpers.export(exports, "unsupportedMethod", ()=>unsupportedMethod);
parcelHelpers.export(exports, "userSwitch", ()=>userSwitch);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const contentError = "ContentError";
const pageException = "PageException";
const userSwitch = "user_switch";
const unsupportedMethod = "unsupported_method";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ehtYt":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCOUNT_UNAVAILABLE", ()=>ACCOUNT_UNAVAILABLE);
parcelHelpers.export(exports, "DISABLED", ()=>DISABLED);
parcelHelpers.export(exports, "NO_NETWORK", ()=>NO_NETWORK);
parcelHelpers.export(exports, "UI_NOT_ALLOWED", ()=>UI_NOT_ALLOWED);
parcelHelpers.export(exports, "USER_CANCEL", ()=>USER_CANCEL);
parcelHelpers.export(exports, "USER_INTERACTION_REQUIRED", ()=>USER_INTERACTION_REQUIRED);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const USER_INTERACTION_REQUIRED = "USER_INTERACTION_REQUIRED";
const USER_CANCEL = "USER_CANCEL";
const NO_NETWORK = "NO_NETWORK";
const DISABLED = "DISABLED";
const ACCOUNT_UNAVAILABLE = "ACCOUNT_UNAVAILABLE";
const UI_NOT_ALLOWED = "UI_NOT_ALLOWED";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fRXRu":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SilentCacheClient", ()=>SilentCacheClient);
var _standardInteractionClientMjs = require("./StandardInteractionClient.mjs");
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class SilentCacheClient extends (0, _standardInteractionClientMjs.StandardInteractionClient) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const clientConfig = await (0, _browser.invokeAsync)(this.getClientConfiguration.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetClientConfiguration), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, _browser.SilentFlowClient)(clientConfig, this.performanceClient);
        this.logger.verbose("0wa871", this.correlationId);
        try {
            const response = await (0, _browser.invokeAsync)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, _browserPerformanceEventsMjs.SilentFlowClientAcquireCachedToken), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, _browserAuthErrorMjs.BrowserAuthError) && error.errorCode === (0, _browserAuthErrorCodesMjs.cryptoKeyNotFound)) this.logger.verbose("06wena", this.correlationId);
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return (0, _baseInteractionClientMjs.clearCacheOnLogout)(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
    }
}

},{"./StandardInteractionClient.mjs":"2tYFp","@azure/msal-common/browser":[["invokeAsync","4kFBF"],["SilentFlowClient","9CExn"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../utils/BrowserConstants.mjs":"5kHn0","../error/BrowserAuthError.mjs":"k9YIy","./BaseInteractionClient.mjs":"9bVY8","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9CExn":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SilentFlowClient", ()=>SilentFlowClient);
var _clientConfigurationMjs = require("../config/ClientConfiguration.mjs");
var _timeUtilsMjs = require("../utils/TimeUtils.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _responseHandlerMjs = require("../response/ResponseHandler.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _stringUtilsMjs = require("../utils/StringUtils.mjs");
var _authTokenMjs = require("../account/AuthToken.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
var _authorityMjs = require("../authority/Authority.mjs");
var _loggerMjs = require("../logger/Logger.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class SilentFlowClient {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, _clientConfigurationMjs.buildClientConfiguration)(configuration);
        // Initialize the logger
        this.logger = new (0, _loggerMjs.Logger)(this.config.loggerOptions, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        let lastCacheOutcome = (0, _constantsMjs.CacheOutcome).NOT_APPLICABLE;
        if (request.forceRefresh || !(0, _stringUtilsMjs.StringUtils).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, _constantsMjs.CacheOutcome).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.tokenRefreshRequired), request.correlationId);
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.noAccountInSilentRequest), request.correlationId);
        const requestTenantId = request.account.tenantId || (0, _authorityMjs.getTenantFromAuthorityString)(request.authority, request.correlationId);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, _constantsMjs.CacheOutcome).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.tokenRefreshRequired), request.correlationId);
        } else if ((0, _timeUtilsMjs.wasClockTurnedBack)(cachedAccessToken.cachedAt) || (0, _timeUtilsMjs.isTokenExpired)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, _constantsMjs.CacheOutcome).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.tokenRefreshRequired), request.correlationId);
        } else if (request.resource) // cached access token must have a resource that matches the request resource for MCP scenarios
        {
            if (cachedAccessToken.resource !== request.resource) {
                this.setCacheOutcome((0, _constantsMjs.CacheOutcome).NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.tokenRefreshRequired), request.correlationId);
            }
        } else if (cachedAccessToken.refreshOn && (0, _timeUtilsMjs.isTokenExpired)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, _constantsMjs.CacheOutcome).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(request.account), request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment, request.correlationId)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, _functionWrappersMjs.invokeAsync)(this.generateResultFromCacheRecord.bind(this), (0, _performanceEventsMjs.SilentFlowClientGenerateResultFromCacheRecord), this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, _constantsMjs.CacheOutcome).NOT_APPLICABLE) this.logger.info(`09ingz ${cacheOutcome}`, correlationId);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, _authTokenMjs.extractTokenClaims)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode, request.correlationId);
        return (0, _responseHandlerMjs.ResponseHandler).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, this.performanceClient, idTokenClaims);
    }
}

},{"../config/ClientConfiguration.mjs":"66gK3","../utils/TimeUtils.mjs":"6CLZ0","../error/ClientAuthError.mjs":"e8Ku4","../response/ResponseHandler.mjs":"7Ytwn","../utils/Constants.mjs":"5eRZy","../utils/StringUtils.mjs":"d70Cd","../account/AuthToken.mjs":"l1q48","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../utils/FunctionWrappers.mjs":"4kFBF","../authority/Authority.mjs":"iOR3f","../logger/Logger.mjs":"9bvcp","../packageMetadata.mjs":"ftCED","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dJjs5":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generatePkceCodes", ()=>generatePkceCodes);
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _base64EncodeMjs = require("../encode/Base64Encode.mjs");
var _browserCryptoMjs = require("./BrowserCrypto.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function generatePkceCodes(performanceClient, logger, correlationId) {
    const codeVerifier = (0, _browser.invoke)(generateCodeVerifier, (0, _browserPerformanceEventsMjs.GenerateCodeVerifier), logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, _browser.invokeAsync)(generateCodeChallengeFromVerifier, (0, _browserPerformanceEventsMjs.GenerateCodeChallengeFromVerifier), logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array(RANDOM_BYTE_ARR_LENGTH);
        (0, _browser.invoke)((0, _browserCryptoMjs.getRandomValues), (0, _browserPerformanceEventsMjs.GetRandomValues), logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, _base64EncodeMjs.urlEncodeArr)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.pkceNotCreated), correlationId);
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, _browser.invokeAsync)((0, _browserCryptoMjs.sha256Digest), (0, _browserPerformanceEventsMjs.Sha256Digest), logger, performanceClient, correlationId)(pkceCodeVerifier);
        // encode hash as base64
        return (0, _base64EncodeMjs.urlEncodeArr)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.pkceNotCreated), correlationId);
    }
}

},{"@azure/msal-common/browser":"4kFBF","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../error/BrowserAuthError.mjs":"k9YIy","../encode/Base64Encode.mjs":"b1HK9","./BrowserCrypto.mjs":"a5L0H","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"80VhX":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlatformAuthProvider", ()=>getPlatformAuthProvider);
parcelHelpers.export(exports, "isPlatformAuthAllowed", ()=>isPlatformAuthAllowed);
parcelHelpers.export(exports, "isPlatformBrokerAvailable", ()=>isPlatformBrokerAvailable);
var _browser = require("@azure/msal-common/browser");
var _packageMetadataMjs = require("../../packageMetadata.mjs");
var _configurationMjs = require("../../config/Configuration.mjs");
var _platformAuthExtensionHandlerMjs = require("./PlatformAuthExtensionHandler.mjs");
var _platformAuthDOMHandlerMjs = require("./PlatformAuthDOMHandler.mjs");
var _browserCryptoMjs = require("../../crypto/BrowserCrypto.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks if the platform broker is available in the current environment.
 * @param domConfig - Whether to enable platform broker DOM API support (required)
 * @param loggerOptions - Optional logger options
 * @param perfClient - Optional performance client
 * @param correlationId - Optional correlation ID
 * @returns Promise<boolean> indicating if platform broker is available
 */ async function isPlatformBrokerAvailable(domConfig, loggerOptions, perfClient, correlationId) {
    const logger = new (0, _browser.Logger)(loggerOptions || {}, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
    const performanceClient = perfClient || new (0, _browser.StubPerformanceClient)();
    if (typeof window === "undefined") {
        logger.trace("082ed3", correlationId || (0, _browserCryptoMjs.createNewGuid)());
        return false;
    }
    return !!await getPlatformAuthProvider(logger, performanceClient, correlationId || (0, _browserCryptoMjs.createNewGuid)(), undefined, domConfig);
}
async function getPlatformAuthProvider(logger, performanceClient, correlationId, nativeBrokerHandshakeTimeout, enablePlatformBrokerDOMSupport) {
    logger.trace("134j0v", correlationId);
    logger.trace(`04c81g ${enablePlatformBrokerDOMSupport}`, correlationId);
    let platformAuthProvider;
    try {
        if (enablePlatformBrokerDOMSupport) // Check if DOM platform API is supported first
        platformAuthProvider = await (0, _platformAuthDOMHandlerMjs.PlatformAuthDOMHandler).createProvider(logger, performanceClient, correlationId);
        if (!platformAuthProvider) {
            logger.trace("0l3na8", correlationId);
            /*
             * If DOM APIs are not available, check if browser extension is available.
             * Platform authentication via DOM APIs is preferred over extension APIs.
             */ platformAuthProvider = await (0, _platformAuthExtensionHandlerMjs.PlatformAuthExtensionHandler).createProvider(logger, nativeBrokerHandshakeTimeout || (0, _configurationMjs.DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS), performanceClient, correlationId);
        }
    } catch (e) {
        logger.trace("0icbd7", e);
    }
    return platformAuthProvider;
}
/**
 * Returns boolean indicating whether or not the request should attempt to use platform broker
 * @param logger
 * @param config
 * @param correlationId
 * @param platformAuthProvider
 * @param authenticationScheme
 */ function isPlatformAuthAllowed(config, logger, correlationId, platformAuthProvider, authenticationScheme) {
    logger.trace("0uko3r", correlationId);
    // throw an error if allowPlatformBroker is not enabled and allowPlatformBrokerWithDOM is enabled
    if (!config.system.allowPlatformBroker && config.experimental.allowPlatformBrokerWithDOM) throw (0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).invalidPlatformBrokerConfiguration, "");
    if (!config.system.allowPlatformBroker) {
        logger.trace("04hozs", correlationId);
        // Developer disabled WAM
        return false;
    }
    if (!platformAuthProvider) {
        logger.trace("0kvv1r", correlationId);
        // Platform broker auth providers are not available
        return false;
    }
    if (authenticationScheme) switch(authenticationScheme){
        case (0, _browser.Constants).AuthenticationScheme.BEARER:
        case (0, _browser.Constants).AuthenticationScheme.POP:
            logger.trace("18tev1", correlationId);
            return true;
        default:
            logger.trace("1dd2nh", correlationId);
            return false;
    }
    return true;
}

},{"@azure/msal-common/browser":[["ClientConfigurationErrorCodes","iMtlX","*"],["Constants","5eRZy","*"],["createClientConfigurationError","ebyn4"],["Logger","9bvcp"],["StubPerformanceClient","9VScD"]],"../../packageMetadata.mjs":"7kVpA","../../config/Configuration.mjs":"iuw8A","./PlatformAuthExtensionHandler.mjs":"eCteP","./PlatformAuthDOMHandler.mjs":"ecB1s","../../crypto/BrowserCrypto.mjs":"a5L0H","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iuw8A":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_IFRAME_TIMEOUT_MS", ()=>DEFAULT_IFRAME_TIMEOUT_MS);
parcelHelpers.export(exports, "DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS", ()=>DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS);
parcelHelpers.export(exports, "DEFAULT_POPUP_TIMEOUT_MS", ()=>DEFAULT_POPUP_TIMEOUT_MS);
parcelHelpers.export(exports, "DEFAULT_REDIRECT_TIMEOUT_MS", ()=>DEFAULT_REDIRECT_TIMEOUT_MS);
parcelHelpers.export(exports, "buildConfiguration", ()=>buildConfiguration);
var _browser = require("@azure/msal-common/browser");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _navigationClientMjs = require("../navigation/NavigationClient.mjs");
var _fetchClientMjs = require("../network/FetchClient.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const DEFAULT_POPUP_TIMEOUT_MS = 60000;
const DEFAULT_IFRAME_TIMEOUT_MS = 10000;
const DEFAULT_REDIRECT_TIMEOUT_MS = 30000;
const DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function buildConfiguration({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, experimental: userInputExperimental, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: "",
        authority: `${(0, _browser.Constants).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: "",
        authorityMetadata: "",
        redirectUri: typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "",
        postLogoutRedirectUri: "",
        popupRelayUri: "",
        clientCapabilities: [],
        OIDCOptions: {
            responseMode: (0, _browser.Constants).ResponseMode.FRAGMENT,
            defaultScopes: [
                (0, _browser.Constants).OPENID_SCOPE,
                (0, _browser.Constants).PROFILE_SCOPE,
                (0, _browser.Constants).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, _browser.AzureCloudInstance).None,
            tenant: ""
        },
        instanceAware: false,
        isMcp: false,
        verifySSO: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, _browserConstantsMjs.BrowserCacheLocation).SessionStorage,
        cacheRetentionDays: 5
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, _browser.LogLevel).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, _browser.DEFAULT_SYSTEM_OPTIONS),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, _fetchClientMjs.FetchClient)() : (0, _browser.StubbedNetworkModule),
        navigationClient: new (0, _navigationClientMjs.NavigationClient)(),
        popupBridgeTimeout: userInputSystem?.popupBridgeTimeout || DEFAULT_POPUP_TIMEOUT_MS,
        iframeBridgeTimeout: userInputSystem?.iframeBridgeTimeout || DEFAULT_IFRAME_TIMEOUT_MS,
        redirectNavigationTimeout: DEFAULT_REDIRECT_TIMEOUT_MS,
        allowRedirectInIframe: false,
        navigatePopups: true,
        allowPlatformBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS,
        protocolMode: (0, _browser.ProtocolMode).AAD,
        serverTelemetryEnabled: false
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: "",
            appVersion: ""
        },
        client: new (0, _browser.StubPerformanceClient)()
    };
    const DEFAULT_EXPERIMENTAL_OPTIONS = {
        iframeTimeoutTelemetry: false,
        allowPlatformBrokerWithDOM: false
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputSystem?.protocolMode !== (0, _browser.ProtocolMode).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, _browser.Logger)(providedSystemOptions.loggerOptions, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        logger.warning(JSON.stringify((0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).cannotSetOIDCOptions, "")), "");
    }
    // Throw an error if user has set allowPlatformBroker to true with OIDC protocol mode
    if (userInputSystem?.protocolMode && userInputSystem.protocolMode === (0, _browser.ProtocolMode).OIDC && providedSystemOptions?.allowPlatformBroker) throw (0, _browser.createClientConfigurationError)((0, _browser.ClientConfigurationErrorCodes).cannotAllowPlatformBroker, "");
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        experimental: {
            ...DEFAULT_EXPERIMENTAL_OPTIONS,
            ...userInputExperimental
        },
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}

},{"@azure/msal-common/browser":[["AzureCloudInstance","9DjNg"],["ClientConfigurationErrorCodes","iMtlX","*"],["Constants","5eRZy","*"],["createClientConfigurationError","ebyn4"],["DEFAULT_SYSTEM_OPTIONS","66gK3"],["Logger","9bvcp"],["LogLevel","9bvcp"],["ProtocolMode","8zD57"],["StubbedNetworkModule","6Vrxj"],["StubPerformanceClient","9VScD"]],"../utils/BrowserConstants.mjs":"5kHn0","../navigation/NavigationClient.mjs":"67Dgq","../network/FetchClient.mjs":"hKfQc","../packageMetadata.mjs":"7kVpA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6Vrxj":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StubbedNetworkModule", ()=>StubbedNetworkModule);
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const StubbedNetworkModule = {
    // Module-level singleton: no per-request correlationId available
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), ""));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.methodNotImplemented), ""));
    }
};

},{"../error/ClientAuthError.mjs":"e8Ku4","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"67Dgq":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavigationClient", ()=>NavigationClient);
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class NavigationClient {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        else window.location.assign(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.timedOut), "", "failed_to_redirect"));
            }, options.timeout);
        });
    }
}

},{"../error/BrowserAuthError.mjs":"k9YIy","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hKfQc":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchClient", ()=>FetchClient);
var _browser = require("@azure/msal-common/browser");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class FetchClient {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, _browserConstantsMjs.HTTP_REQUEST_TYPE).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, _browser.createNetworkError)((0, _browserAuthErrorMjs.createBrowserAuthError)(window.navigator.onLine ? (0, _browserAuthErrorCodesMjs.getRequestFailed) : (0, _browserAuthErrorCodesMjs.noNetworkConnectivity), ""), undefined, undefined, e);
        }
        responseHeaders = getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, _browser.createNetworkError)((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.failedToParseResponse), ""), responseStatus, responseHeaders, e);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, _browserConstantsMjs.HTTP_REQUEST_TYPE).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, _browser.createNetworkError)((0, _browserAuthErrorMjs.createBrowserAuthError)(window.navigator.onLine ? (0, _browserAuthErrorCodesMjs.postRequestFailed) : (0, _browserAuthErrorCodesMjs.noNetworkConnectivity), ""), undefined, undefined, e);
        }
        responseHeaders = getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, _browser.createNetworkError)((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.failedToParseResponse), ""), responseStatus, responseHeaders, e);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, _browser.createNetworkError)((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.failedToBuildHeaders), ""), undefined, undefined, e);
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.failedToParseHeaders), "");
    }
}

},{"@azure/msal-common/browser":"8fCiR","../error/BrowserAuthError.mjs":"k9YIy","../utils/BrowserConstants.mjs":"5kHn0","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eCteP":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlatformAuthExtensionHandler", ()=>PlatformAuthExtensionHandler);
var _browserConstantsMjs = require("../../utils/BrowserConstants.mjs");
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../../telemetry/BrowserPerformanceEvents.mjs");
var _nativeAuthErrorMjs = require("../../error/NativeAuthError.mjs");
var _browserAuthErrorMjs = require("../../error/BrowserAuthError.mjs");
var _browserCryptoMjs = require("../../crypto/BrowserCrypto.mjs");
var _browserUtilsMjs = require("../../utils/BrowserUtils.mjs");
var _browserAuthErrorCodesMjs = require("../../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class PlatformAuthExtensionHandler {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = this.performanceClient.startMeasurement((0, _browserPerformanceEventsMjs.NativeMessageHandlerHandshake));
        this.platformAuthType = (0, _browserConstantsMjs.PlatformAuthConstants).PLATFORM_EXTENSION_PROVIDER;
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param request
     */ async sendMessage(request) {
        this.logger.trace(`0on4p2 ${this.platformAuthType}`, request.correlationId);
        // fall back to native calls
        const messageBody = {
            method: (0, _browserConstantsMjs.NativeExtensionMethod).GetToken,
            request: request
        };
        const req = {
            channel: (0, _browserConstantsMjs.PlatformAuthConstants).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, _browserCryptoMjs.createNewGuid)(),
            body: messageBody
        };
        this.logger.trace(`1qadfi ${this.platformAuthType}`, request.correlationId);
        this.logger.tracePii(`1xm533 ${this.platformAuthType} ${JSON.stringify(req)}`, request.correlationId);
        this.messageChannel.port1.postMessage(req);
        const response = await new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve,
                reject
            });
        });
        const validatedResponse = this.validatePlatformBrokerResponse(response);
        return validatedResponse;
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient, correlationId) {
        logger.trace("15zfnw", correlationId);
        try {
            const preferredProvider = new PlatformAuthExtensionHandler(logger, handshakeTimeoutMs, performanceClient, (0, _browserConstantsMjs.PlatformAuthConstants).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest(correlationId);
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new PlatformAuthExtensionHandler(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest(correlationId);
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest(correlationId) {
        this.logger.trace(`1dpg9o ${this.platformAuthType}`, correlationId);
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, _browserConstantsMjs.PlatformAuthConstants).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, _browserCryptoMjs.createNewGuid)(),
            body: {
                method: (0, _browserConstantsMjs.NativeExtensionMethod).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve,
                reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.nativeHandshakeTimeout), ""));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        const correlationId = (0, _browserUtilsMjs.createGuid)();
        this.logger.trace(`0jpn5u ${this.platformAuthType}`, correlationId);
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, _browserConstantsMjs.PlatformAuthConstants).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, _browserConstantsMjs.NativeExtensionMethod).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(`07buhm ${this.platformAuthType} ${request.responseId}`, correlationId);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `0xrkug ${request.extensionId}` : "No extension installed", correlationId);
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.nativeExtensionNotInstalled), ""));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        const correlationId = (0, _browserUtilsMjs.createGuid)();
        this.logger.trace(`1py8yf ${this.platformAuthType}`, correlationId);
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, _browserConstantsMjs.NativeExtensionMethod).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace(`19hpgm ${this.platformAuthType}`, correlationId);
                this.logger.tracePii(`179a24 ${this.platformAuthType} ${JSON.stringify(response)}`, correlationId);
                if (response.status !== "Success") resolver.reject((0, _nativeAuthErrorMjs.createNativeAuthError)(response.code, correlationId, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, _nativeAuthErrorMjs.createNativeAuthError)(response.result["code"], correlationId, response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, _browser.createAuthError)((0, _browser.AuthErrorCodes).unexpectedError, correlationId, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, _browserConstantsMjs.NativeExtensionMethod).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(`082qnt ${this.platformAuthType} ${request.responseId}`, correlationId);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(`0yf5ib ${this.platformAuthType} ${this.extensionId}`, correlationId);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("0xf978", correlationId);
            this.logger.errorPii(`04i99o ${err}`, correlationId);
            this.logger.errorPii(`0xdvsy ${event}`, correlationId);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, _browser.createAuthError)((0, _browser.AuthErrorCodes).unexpectedError, "", "Response missing expected properties.");
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    getExtensionName() {
        return this.getExtensionId() === (0, _browserConstantsMjs.PlatformAuthConstants).PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : undefined;
    }
}

},{"../../utils/BrowserConstants.mjs":"5kHn0","@azure/msal-common/browser":[["AuthErrorCodes","hf916","*"],["createAuthError","8TWYe"]],"../../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../../error/NativeAuthError.mjs":"iAojo","../../error/BrowserAuthError.mjs":"k9YIy","../../crypto/BrowserCrypto.mjs":"a5L0H","../../utils/BrowserUtils.mjs":"eyRWO","../../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ecB1s":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlatformAuthDOMHandler", ()=>PlatformAuthDOMHandler);
var _browser = require("@azure/msal-common/browser");
var _browserConstantsMjs = require("../../utils/BrowserConstants.mjs");
var _nativeAuthErrorMjs = require("../../error/NativeAuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class PlatformAuthDOMHandler {
    constructor(logger, performanceClient, correlationId){
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.platformAuthType = (0, _browserConstantsMjs.PlatformAuthConstants).PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(logger, performanceClient, correlationId) {
        logger.trace("12mj4a", correlationId);
        // @ts-ignore
        if (window.navigator?.platformAuthentication) {
            const supportedContracts = // @ts-ignore
            await window.navigator.platformAuthentication.getSupportedContracts((0, _browserConstantsMjs.PlatformAuthConstants).MICROSOFT_ENTRA_BROKERID);
            if (supportedContracts?.includes((0, _browserConstantsMjs.PlatformAuthConstants).PLATFORM_DOM_APIS)) {
                logger.trace("1h5q1r", correlationId);
                return new PlatformAuthDOMHandler(logger, performanceClient, correlationId);
            }
        }
        return undefined;
    }
    /**
     * Returns the Id for the broker extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return (0, _browserConstantsMjs.PlatformAuthConstants).MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
        return "";
    }
    getExtensionName() {
        return (0, _browserConstantsMjs.PlatformAuthConstants).DOM_API_NAME;
    }
    /**
     * Send token request to platform broker via browser DOM API
     * @param request
     * @returns
     */ async sendMessage(request) {
        this.logger.trace(`02bcil ${this.platformAuthType}`, request.correlationId);
        try {
            const platformDOMRequest = this.initializePlatformDOMRequest(request);
            const response = // @ts-ignore
            await window.navigator.platformAuthentication.executeGetToken(platformDOMRequest);
            return this.validatePlatformBrokerResponse(response, request.correlationId);
        } catch (e) {
            this.logger.error(`11im7g ${this.platformAuthType}`, request.correlationId);
            throw e;
        }
    }
    initializePlatformDOMRequest(request) {
        this.logger.trace(`15d6yv ${this.platformAuthType}`, request.correlationId);
        const { accountId, clientId, authority, scope, redirectUri, correlationId, state, storeInCache, embeddedClientId, extraParameters, ...remainingProperties } = request;
        const validExtraParameters = this.getDOMExtraParams(remainingProperties, correlationId);
        const platformDOMRequest = {
            accountId: accountId,
            brokerId: this.getExtensionId(),
            authority: authority,
            clientId: clientId,
            correlationId: correlationId || this.correlationId,
            extraParameters: {
                ...extraParameters,
                ...validExtraParameters
            },
            isSecurityTokenService: false,
            redirectUri: redirectUri,
            scope: scope,
            state: state,
            storeInCache: storeInCache,
            embeddedClientId: embeddedClientId
        };
        return platformDOMRequest;
    }
    validatePlatformBrokerResponse(response, correlationId) {
        if (response.hasOwnProperty("isSuccess")) {
            if (response.hasOwnProperty("accessToken") && response.hasOwnProperty("idToken") && response.hasOwnProperty("clientInfo") && response.hasOwnProperty("account") && response.hasOwnProperty("scopes") && response.hasOwnProperty("expiresIn")) {
                this.logger.trace(`0h4vei ${this.platformAuthType}`, correlationId);
                return this.convertToPlatformBrokerResponse(response, correlationId);
            } else if (response.hasOwnProperty("error")) {
                const errorResponse = response;
                if (errorResponse.isSuccess === false && errorResponse.error && errorResponse.error.code) {
                    this.logger.trace(`0g92vm ${this.platformAuthType}`, correlationId);
                    throw (0, _nativeAuthErrorMjs.createNativeAuthError)(errorResponse.error.code, correlationId, errorResponse.error.description, {
                        error: parseInt(errorResponse.error.errorCode),
                        protocol_error: errorResponse.error.protocolError,
                        status: errorResponse.error.status,
                        properties: errorResponse.error.properties
                    });
                }
            }
        }
        throw (0, _browser.createAuthError)((0, _browser.AuthErrorCodes).unexpectedError, correlationId, "Response missing expected properties.");
    }
    convertToPlatformBrokerResponse(response, correlationId) {
        this.logger.trace(`14913t ${this.platformAuthType}`, correlationId);
        const nativeResponse = {
            access_token: response.accessToken,
            id_token: response.idToken,
            client_info: response.clientInfo,
            account: response.account,
            expires_in: response.expiresIn,
            scope: response.scopes,
            state: response.state || "",
            properties: response.properties || {},
            extendedLifetimeToken: response.extendedLifetimeToken ?? false,
            shr: response.proofOfPossessionPayload
        };
        return nativeResponse;
    }
    getDOMExtraParams(extraParameters, correlationId) {
        try {
            const stringifiedProperties = {};
            for (const [key, value] of Object.entries(extraParameters)){
                if (!value) continue;
                if (typeof value === "object") stringifiedProperties[key] = JSON.stringify(value);
                else stringifiedProperties[key] = String(value);
            }
            return stringifiedProperties;
        } catch (e) {
            this.logger.error(`0eu9o3 ${this.platformAuthType}`, correlationId);
            this.logger.errorPii(`17rpl5 ${this.platformAuthType} ${e}`, correlationId);
            return {};
        }
    }
}

},{"@azure/msal-common/browser":[["AuthErrorCodes","hf916","*"],["createAuthError","8TWYe"]],"../../utils/BrowserConstants.mjs":"5kHn0","../../error/NativeAuthError.mjs":"iAojo","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"pMbft":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RedirectClient", ()=>RedirectClient);
var _browser = require("@azure/msal-common/browser");
var _standardInteractionClientMjs = require("./StandardInteractionClient.mjs");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _eventTypeMjs = require("../event/EventType.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _responseHandlerMjs = require("../response/ResponseHandler.mjs");
var _authorizeMjs = require("../protocol/Authorize.mjs");
var _pkceGeneratorMjs = require("../crypto/PkceGenerator.mjs");
var _platformAuthProviderMjs = require("../broker/nativeBroker/PlatformAuthProvider.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class RedirectClient extends (0, _standardInteractionClientMjs.StandardInteractionClient) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, _browser.invokeAsync)((0, _standardInteractionClientMjs.initializeAuthorizationRequest), (0, _browserPerformanceEventsMjs.StandardInteractionClientInitializeAuthorizationRequest), this.logger, this.performanceClient, this.correlationId)(request, (0, _browserConstantsMjs.InteractionType).Redirect, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        validRequest.platformBroker = (0, _platformAuthProviderMjs.isPlatformAuthAllowed)(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("0udvtt", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).RESTORE_FROM_BFCACHE, this.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect);
            }
        };
        const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
        this.logger.verbosePii(`0zao0a ${redirectStartPage}`, this.correlationId);
        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
        this.browserStorage.setTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).ORIGIN_URI, redirectStartPage, true);
        // Clear temporary cache if the back button is clicked during the redirect flow.
        window.addEventListener("pageshow", handleBackButton);
        try {
            if (this.config.system.protocolMode === (0, _browser.ProtocolMode).EAR) await this.executeEarFlow(validRequest);
            else await this.executeCodeFlow(validRequest);
        } catch (e) {
            if (e instanceof (0, _browser.AuthError)) e.correlationId = this.correlationId;
            window.removeEventListener("pageshow", handleBackButton);
            throw e;
        }
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).acquireTokenRedirect, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkceCodes = await (0, _browser.invokeAsync)((0, _pkceGeneratorMjs.generatePkceCodes), (0, _browserPerformanceEventsMjs.GeneratePkceCodes), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        try {
            if (redirectRequest.httpMethod === (0, _browser.Constants).HttpMethod.POST) return await this.executeCodeFlowWithPost(redirectRequest);
            else {
                // Initialize the client
                const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, this.correlationId)({
                    serverTelemetryManager,
                    requestAuthority: redirectRequest.authority,
                    requestAzureCloudOptions: redirectRequest.azureCloudOptions,
                    requestExtraQueryParameters: redirectRequest.extraQueryParameters,
                    account: redirectRequest.account
                });
                // Create acquire token url.
                const navigateUrl = await (0, _browser.invokeAsync)((0, _authorizeMjs.getAuthCodeRequestUrl), (0, _browser.PerformanceEvents).GetAuthCodeUrl, this.logger, this.performanceClient, request.correlationId)(this.config, authClient.authority, redirectRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                return await this.initiateAuthRequest(navigateUrl);
            }
        } catch (e) {
            if (e instanceof (0, _browser.AuthError)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId, authority, azureCloudOptions, extraQueryParameters, account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, _browser.invokeAsync)((0, _baseInteractionClientMjs.getDiscoveredAuthority), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetDiscoveredAuthority), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await (0, _browser.invokeAsync)((0, _browserCryptoMjs.generateEarKey), (0, _browserPerformanceEventsMjs.GenerateEarKey), this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, _browser.invokeAsync)((0, _pkceGeneratorMjs.generatePkceCodes), (0, _browserPerformanceEventsMjs.GeneratePkceCodes), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        const form = await (0, _authorizeMjs.getEARForm)(document, this.config, discoveredAuthority, redirectRequest, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.timedOut), "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Executes classic Authorization Code flow with a POST request.
     * @param request
     */ async executeCodeFlowWithPost(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, _browser.invokeAsync)((0, _baseInteractionClientMjs.getDiscoveredAuthority), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetDiscoveredAuthority), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        this.browserStorage.cacheAuthorizeRequest(request, this.correlationId);
        const form = await (0, _authorizeMjs.getCodeForm)(document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.timedOut), "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     * @param request {CommonAuthorizationUrlRequest} request object
     * @param pkceVerifier {string} PKCE verifier
     * @param options {HandleRedirectPromiseOptions} options for handling redirect promise
     */ async handleRedirectPromise(request, pkceVerifier, parentMeasurement, options) {
        const originalTitle = document.title;
        document.title = "Microsoft Authentication";
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).handleRedirectPromise, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            const [serverParams, responseString] = this.getRedirectResponse(options?.hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("1qmv0q", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                // Do not instrument "no_server_response" if user clicked back button
                if (getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("1eqegq", this.correlationId);
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).ORIGIN_URI, this.correlationId, true) || "";
            const loginRequestUrlNormalized = (0, _browser.UrlUtils).normalizeUrlForComparison(loginRequestUrl, this.logger, this.correlationId);
            const currentUrlNormalized = (0, _browser.UrlUtils).normalizeUrlForComparison(window.location.href, this.logger, this.correlationId);
            if (loginRequestUrlNormalized === currentUrlNormalized && navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("11yred", this.correlationId);
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, _browserUtilsMjs.replaceHash)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
                return handleHashResult;
            } else if (!navigateToLoginRequestUrl) {
                this.logger.verbose("0v4sdv", this.correlationId);
                return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            } else if (!(0, _browserUtilsMjs.isInIframe)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, _browserConstantsMjs.ApiId).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl) {
                    // Redirect to home page if login request url is empty
                    const homepage = (0, _browserUtilsMjs.getHomepage)(this.correlationId);
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).ORIGIN_URI, homepage, true);
                    this.logger.warning("1dutq1", this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`08jpy1 ${loginRequestUrl}`, this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, _browser.AuthError)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        } finally{
            document.title = originalTitle;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("1c5i8m", this.correlationId);
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.responseMode === (0, _browser.Constants).ResponseMode.QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, _browser.UrlUtils).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, _responseHandlerMjs.validateInteractionType)(response, this.browserCrypto, (0, _browserConstantsMjs.InteractionType).Redirect, this.correlationId);
            } catch (e) {
                if (e instanceof (0, _browser.AuthError)) this.logger.error(`0bkq6p ${e.errorCode} ${e.errorMessage}`, this.correlationId);
                return [
                    null,
                    ""
                ];
            }
            (0, _browserUtilsMjs.clearHash)(window);
            this.logger.verbose("00uvho", this.correlationId);
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, _browserConstantsMjs.TemporaryCacheKeys).URL_HASH, this.correlationId, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, _browserConstantsMjs.TemporaryCacheKeys).URL_HASH));
        if (cachedHash) {
            response = (0, _browser.UrlUtils).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("001671", this.correlationId);
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, request, codeVerifier, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.noStateInHash), request.correlationId);
        const { authority, azureCloudOptions, extraQueryParameters, account } = request;
        if (serverParams.ear_jwe) {
            const discoveredAuthority = await (0, _browser.invokeAsync)((0, _baseInteractionClientMjs.getDiscoveredAuthority), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetDiscoveredAuthority), this.logger, this.performanceClient, request.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
            return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseEAR), (0, _browserPerformanceEventsMjs.HandleResponseEar), this.logger, this.performanceClient, request.correlationId)(request, serverParams, (0, _browserConstantsMjs.ApiId).acquireTokenRedirect, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        }
        const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager,
            requestAuthority: request.authority
        });
        return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseCode), (0, _browserPerformanceEventsMjs.HandleResponseCode), this.logger, this.performanceClient, request.correlationId)(request, serverParams, codeVerifier, (0, _browserConstantsMjs.ApiId).acquireTokenRedirect, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     * @param onRedirectNavigateRequest - onRedirectNavigate callback provided on the request
     */ async initiateAuthRequest(requestUrl) {
        this.logger.verbose("0yaw2e", this.correlationId);
        // Navigate if valid URL
        if (requestUrl) {
            this.logger.infoPii(`1luf83 ${requestUrl}`, this.correlationId);
            const navigationOptions = {
                apiId: (0, _browserConstantsMjs.ApiId).acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof onRedirectNavigate === "function") {
                this.logger.verbose("1nehvl", this.correlationId);
                const navigate = onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("1a0jxh", this.correlationId);
                    await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("09k5h5", this.correlationId);
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("0klwf7", this.correlationId);
                await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("0rlh4e", this.correlationId);
            throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.emptyNavigateUri), this.correlationId);
        }
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).logout, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_START, this.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, logoutRequest);
            // Clear cache on logout
            await (0, _baseInteractionClientMjs.clearCacheOnLogout)(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, _browserConstantsMjs.ApiId).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, _browser.ProtocolMode).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_SUCCESS, this.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validLogoutRequest.state = (0, _browser.ProtocolUtils).setRequestState(this.browserCrypto, validLogoutRequest.state || "", {
                interactionType: (0, _browserConstantsMjs.InteractionType).Redirect
            }, validLogoutRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            if (validLogoutRequest.account?.homeAccountId) this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_SUCCESS, this.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            if (typeof onRedirectNavigate === "function") {
                const navigate = onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("06v57e", this.correlationId);
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNOUT);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("0xqes1", this.correlationId);
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, _browserConstantsMjs.INTERACTION_TYPE).SIGNOUT);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, _browser.AuthError)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_FAILURE, this.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect, null, e);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_END, this.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).LOGOUT_END, this.correlationId, (0, _browserConstantsMjs.InteractionType).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        const absoluteRedirectStartPage = (0, _browser.UrlString).getAbsoluteUrl(redirectStartPage, (0, _browserUtilsMjs.getCurrentUri)(), this.correlationId);
        // Sanity check the URL before it is cached so we never persist a malformed value (e.g. the literal string "null")
        (0, _browser.UrlUtils).validateUrl(absoluteRedirectStartPage, this.logger, this.correlationId);
        return absoluteRedirectStartPage;
    }
}

},{"@azure/msal-common/browser":[["AuthError","8TWYe"],["Constants","5eRZy","*"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"],["ProtocolMode","8zD57"],["ProtocolUtils","ipQ3L","*"],["UrlString","9Z8Lm"],["UrlUtils","2SeAw","*"]],"./StandardInteractionClient.mjs":"2tYFp","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../utils/BrowserConstants.mjs":"5kHn0","../utils/BrowserUtils.mjs":"eyRWO","../event/EventType.mjs":"gVLUh","../error/BrowserAuthError.mjs":"k9YIy","../response/ResponseHandler.mjs":"1kcwc","../protocol/Authorize.mjs":"7dpy6","../crypto/PkceGenerator.mjs":"dJjs5","../broker/nativeBroker/PlatformAuthProvider.mjs":"80VhX","../crypto/BrowserCrypto.mjs":"a5L0H","./BaseInteractionClient.mjs":"9bVY8","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4f0mG":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SilentIframeClient", ()=>SilentIframeClient);
var _browser = require("@azure/msal-common/browser");
var _standardInteractionClientMjs = require("./StandardInteractionClient.mjs");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _silentHandlerMjs = require("../interaction_handler/SilentHandler.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _responseHandlerMjs = require("../response/ResponseHandler.mjs");
var _authorizeMjs = require("../protocol/Authorize.mjs");
var _pkceGeneratorMjs = require("../crypto/PkceGenerator.mjs");
var _platformAuthProviderMjs = require("../broker/nativeBroker/PlatformAuthProvider.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class SilentIframeClient extends (0, _standardInteractionClientMjs.StandardInteractionClient) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, correlationId, platformAuthProvider, waitForIframeResponseHook){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
        this.waitForIframeResponseHook = waitForIframeResponseHook;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("1kl318", this.correlationId);
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, _browser.Constants).PromptValue.NONE && inputRequest.prompt !== (0, _browser.Constants).PromptValue.NO_SESSION) {
                this.logger.warning(`0bmctg ${inputRequest.prompt} ${(0, _browser.Constants).PromptValue.NONE}`, this.correlationId);
                inputRequest.prompt = (0, _browser.Constants).PromptValue.NONE;
            }
        } else inputRequest.prompt = (0, _browser.Constants).PromptValue.NONE;
        // Create silent request
        const silentRequest = await (0, _browser.invokeAsync)((0, _standardInteractionClientMjs.initializeAuthorizationRequest), (0, _browserPerformanceEventsMjs.StandardInteractionClientInitializeAuthorizationRequest), this.logger, this.performanceClient, this.correlationId)(inputRequest, (0, _browserConstantsMjs.InteractionType).Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        silentRequest.platformBroker = (0, _platformAuthProviderMjs.isPlatformAuthAllowed)(this.config, this.logger, this.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme);
        (0, _browserUtilsMjs.preconnect)(silentRequest.authority);
        if (this.config.system.protocolMode === (0, _browser.ProtocolMode).EAR) return this.executeEarFlow(silentRequest);
        else return this.executeCodeFlow(silentRequest);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        let authClient;
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Initialize the client
            authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager,
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return await (0, _browser.invokeAsync)(this.silentTokenHelper.bind(this), (0, _browserPerformanceEventsMjs.SilentIframeClientTokenHelper), this.logger, this.performanceClient, request.correlationId)(authClient, request);
        } catch (e) {
            if (e instanceof (0, _browser.AuthError)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, _browser.AuthError)) || e.errorCode !== (0, _browserConstantsMjs.BrowserConstants).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            return await (0, _browser.invokeAsync)(this.silentTokenHelper.bind(this), (0, _browserPerformanceEventsMjs.SilentIframeClientTokenHelper), this.logger, this.performanceClient, this.correlationId)(authClient, request);
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId, authority, azureCloudOptions, extraQueryParameters, account } = request;
        const discoveredAuthority = await (0, _browser.invokeAsync)((0, _baseInteractionClientMjs.getDiscoveredAuthority), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetDiscoveredAuthority), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await (0, _browser.invokeAsync)((0, _browserCryptoMjs.generateEarKey), (0, _browserPerformanceEventsMjs.GenerateEarKey), this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, _browser.invokeAsync)((0, _pkceGeneratorMjs.generatePkceCodes), (0, _browserPerformanceEventsMjs.GeneratePkceCodes), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = (0, _silentHandlerMjs.createHiddenIframe)();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        let responseString;
        try {
            const responsePromise = (0, _browser.invokeAsync)(this.waitForIframeResponse.bind(this), (0, _browserPerformanceEventsMjs.SilentHandlerMonitorIframeForHash), this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If navigation below throws before responsePromise is awaited,
                 * the listener still rejects on timeout. Swallow it here so it
                 * does not surface as an unhandled rejection; the navigation
                 * error is propagated instead.
                 */ });
            await (0, _browser.invokeAsync)((0, _silentHandlerMjs.initiateEarRequest), (0, _browserPerformanceEventsMjs.SilentHandlerInitiateAuthRequest), this.logger, this.performanceClient, correlationId)(iframe, this.config, discoveredAuthority, silentRequest, this.logger, this.performanceClient);
            responseString = await responsePromise;
        } finally{
            (0, _browser.invoke)((0, _silentHandlerMjs.removeHiddenIframe), (0, _browserPerformanceEventsMjs.RemoveHiddenIframe), this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = (0, _browser.invoke)((0, _responseHandlerMjs.deserializeResponse), (0, _browserPerformanceEventsMjs.DeserializeResponse), this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            // If server doesn't support EAR, they may fallback to auth code flow instead
            const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: (0, _baseInteractionClientMjs.initializeServerTelemetryManager)(this.apiId, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseCode), (0, _browserPerformanceEventsMjs.HandleResponseCode), this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseEAR), (0, _browserPerformanceEventsMjs.HandleResponseEar), this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, this.apiId, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Verifies SSO capability by making an iframe request to /authorize without exchanging the code for tokens.
     * This is useful for verifying SSO capability in the background without the overhead of a full token exchange.
     * @param request - The SSO silent request
     * @returns true if SSO verification was successful with a valid authorization code, false otherwise
     */ async verifySso(request) {
        const inputRequest = {
            ...request
        };
        if (!inputRequest.prompt) inputRequest.prompt = (0, _browser.Constants).PromptValue.NONE;
        // Create silent request
        const silentRequest = await (0, _browser.invokeAsync)((0, _standardInteractionClientMjs.initializeAuthorizationRequest), (0, _browserPerformanceEventsMjs.StandardInteractionClientInitializeAuthorizationRequest), this.logger, this.performanceClient, this.correlationId)(inputRequest, (0, _browserConstantsMjs.InteractionType).Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        const authClient = await (0, _browser.invokeAsync)(this.createAuthCodeClient.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientCreateAuthCodeClient), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: (0, _baseInteractionClientMjs.initializeServerTelemetryManager)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            requestExtraQueryParameters: silentRequest.extraQueryParameters,
            account: silentRequest.account
        });
        const { serverParams } = await this.silentAuthorizeHelper(authClient, silentRequest);
        const correlationId = silentRequest.correlationId;
        // Validate the response - this checks for errors and validates state
        (0, _browser.AuthorizeProtocol).validateAuthorizationResponse(serverParams, silentRequest.state, correlationId);
        // Verify a valid authorization code is present
        if (!serverParams.code) {
            this.logger.warning("0y34ti", correlationId);
            return false;
        }
        this.logger.verbose("0kkkcj", correlationId);
        return true;
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.silentLogoutUnsupported), ""));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, request) {
        const { serverParams, pkceCodes } = await this.silentAuthorizeHelper(authClient, request);
        return (0, _browser.invokeAsync)((0, _authorizeMjs.handleResponseCode), (0, _browserPerformanceEventsMjs.HandleResponseCode), this.logger, this.performanceClient, request.correlationId)(request, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Shared helper that generates PKCE codes, builds the /authorize URL,
     * loads it in a hidden iframe, waits for the redirect-bridge response,
     * and returns the deserialized server parameters along with the PKCE codes
     * and the request that was sent.
     */ async silentAuthorizeHelper(authClient, request) {
        const correlationId = request.correlationId;
        const pkceCodes = await (0, _browser.invokeAsync)((0, _pkceGeneratorMjs.generatePkceCodes), (0, _browserPerformanceEventsMjs.GeneratePkceCodes), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = (0, _silentHandlerMjs.createHiddenIframe)();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        // Wait for response from the redirect bridge.
        let responseString;
        try {
            const responsePromise = (0, _browser.invokeAsync)(this.waitForIframeResponse.bind(this), (0, _browserPerformanceEventsMjs.SilentHandlerMonitorIframeForHash), this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If URL creation or navigation below throws before
                 * responsePromise is awaited, the listener still rejects on
                 * timeout. Swallow it here so it does not surface as an
                 * unhandled rejection; the navigation error is propagated
                 * instead.
                 */ });
            if (request.httpMethod === (0, _browser.Constants).HttpMethod.POST) await (0, _browser.invokeAsync)((0, _silentHandlerMjs.initiateCodeFlowWithPost), (0, _browserPerformanceEventsMjs.SilentHandlerInitiateAuthRequest), this.logger, this.performanceClient, correlationId)(iframe, this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
            else {
                // Create authorize request url
                const navigateUrl = await (0, _browser.invokeAsync)((0, _authorizeMjs.getAuthCodeRequestUrl), (0, _browser.PerformanceEvents).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
                // Navigate the iframe to the authorize request url
                await (0, _browser.invokeAsync)((0, _silentHandlerMjs.initiateCodeRequest), (0, _browserPerformanceEventsMjs.SilentHandlerInitiateAuthRequest), this.logger, this.performanceClient, correlationId)(iframe, navigateUrl, this.logger, correlationId);
            }
            responseString = await responsePromise;
        } finally{
            (0, _browser.invoke)((0, _silentHandlerMjs.removeHiddenIframe), (0, _browserPerformanceEventsMjs.RemoveHiddenIframe), this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = (0, _browser.invoke)((0, _responseHandlerMjs.deserializeResponse), (0, _browserPerformanceEventsMjs.DeserializeResponse), this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        return {
            serverParams,
            pkceCodes,
            silentRequest
        };
    }
    async waitForIframeResponse(iframe, request) {
        if (this.waitForIframeResponseHook) return this.waitForIframeResponseHook(iframe, request);
        return (0, _browserUtilsMjs.waitForBridgeResponse)(this.config.system.iframeBridgeTimeout, this.logger, request, this.performanceClient, this.config.experimental);
    }
}

},{"@azure/msal-common/browser":[["AuthError","8TWYe"],["AuthorizeProtocol","iuOjG","*"],["Constants","5eRZy","*"],["invoke","4kFBF"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"],["ProtocolMode","8zD57"]],"./StandardInteractionClient.mjs":"2tYFp","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../error/BrowserAuthError.mjs":"k9YIy","../utils/BrowserConstants.mjs":"5kHn0","../interaction_handler/SilentHandler.mjs":"fuC1I","../utils/BrowserUtils.mjs":"eyRWO","../response/ResponseHandler.mjs":"1kcwc","../protocol/Authorize.mjs":"7dpy6","../crypto/PkceGenerator.mjs":"dJjs5","../broker/nativeBroker/PlatformAuthProvider.mjs":"80VhX","../crypto/BrowserCrypto.mjs":"a5L0H","./BaseInteractionClient.mjs":"9bVY8","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fuC1I":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHiddenIframe", ()=>createHiddenIframe);
parcelHelpers.export(exports, "initiateCodeFlowWithPost", ()=>initiateCodeFlowWithPost);
parcelHelpers.export(exports, "initiateCodeRequest", ()=>initiateCodeRequest);
parcelHelpers.export(exports, "initiateEarRequest", ()=>initiateEarRequest);
parcelHelpers.export(exports, "removeHiddenIframe", ()=>removeHiddenIframe);
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _authorizeMjs = require("../protocol/Authorize.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Navigates the given hidden iframe to the provided URL.
 * @param frame
 * @param requestUrl
 */ async function initiateCodeRequest(frame, requestUrl, logger, correlationId) {
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("1l7hyp", correlationId);
        throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.emptyNavigateUri), correlationId);
    }
    frame.src = requestUrl;
    return frame;
}
async function initiateCodeFlowWithPost(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, _authorizeMjs.getCodeForm)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
async function initiateEarRequest(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, _authorizeMjs.getEARForm)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
/**
 * @hidden
 * Creates a new hidden iframe for silent token renewal. Callers navigate it
 * (set `src` or submit a form) after registering the response listener.
 * @ignore
 */ function createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.title = "Microsoft Authentication";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    authFrame.setAttribute("allow", "local-network-access *");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from `document.body` if it is a direct child.
 * @param iframe - The iframe element to remove.
 */ function removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}

},{"../error/BrowserAuthError.mjs":"k9YIy","../protocol/Authorize.mjs":"7dpy6","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"khMrN":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SilentRefreshClient", ()=>SilentRefreshClient);
var _standardInteractionClientMjs = require("./StandardInteractionClient.mjs");
var _browser = require("@azure/msal-common/browser");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _requestHelpersMjs = require("../request/RequestHelpers.mjs");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class SilentRefreshClient extends (0, _standardInteractionClientMjs.StandardInteractionClient) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        const baseRequest = await (0, _browser.invokeAsync)((0, _requestHelpersMjs.initializeBaseRequest), (0, _browserPerformanceEventsMjs.InitializeBaseRequest), this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger, this.correlationId);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = (0, _baseInteractionClientMjs.getRedirectUri)(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)((0, _browserConstantsMjs.ApiId).acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, _browser.invokeAsync)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, _browserPerformanceEventsMjs.RefreshTokenClientAcquireTokenByRefreshToken), this.logger, this.performanceClient, request.correlationId)(silentRequest, (0, _browserConstantsMjs.ApiId).acquireTokenSilent_silentFlow).catch((e)=>{
            e.correlationId = this.correlationId;
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.silentLogoutUnsupported), ""));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, _browser.invokeAsync)(this.getClientConfiguration.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetClientConfiguration), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, _browser.RefreshTokenClient)(clientConfig, this.performanceClient);
    }
}

},{"./StandardInteractionClient.mjs":"2tYFp","@azure/msal-common/browser":[["invokeAsync","4kFBF"],["RefreshTokenClient","2stam"]],"../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../utils/BrowserConstants.mjs":"5kHn0","../error/BrowserAuthError.mjs":"k9YIy","../request/RequestHelpers.mjs":"dxJze","./BaseInteractionClient.mjs":"9bVY8","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2stam":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RefreshTokenClient", ()=>RefreshTokenClient);
var _clientConfigurationMjs = require("../config/ClientConfiguration.mjs");
var _requestParameterBuilderMjs = require("../request/RequestParameterBuilder.mjs");
var _urlUtilsMjs = require("../utils/UrlUtils.mjs");
var _constantsMjs = require("../utils/Constants.mjs");
var _aadserverParamKeysMjs = require("../constants/AADServerParamKeys.mjs");
var _responseHandlerMjs = require("../response/ResponseHandler.mjs");
var _popTokenGeneratorMjs = require("../crypto/PopTokenGenerator.mjs");
var _clientConfigurationErrorMjs = require("../error/ClientConfigurationError.mjs");
var _clientAuthErrorMjs = require("../error/ClientAuthError.mjs");
var _serverErrorMjs = require("../error/ServerError.mjs");
var _timeUtilsMjs = require("../utils/TimeUtils.mjs");
var _urlStringMjs = require("../url/UrlString.mjs");
var _ccsCredentialMjs = require("../account/CcsCredential.mjs");
var _clientInfoMjs = require("../account/ClientInfo.mjs");
var _interactionRequiredAuthErrorMjs = require("../error/InteractionRequiredAuthError.mjs");
var _performanceEventsMjs = require("../telemetry/performance/PerformanceEvents.mjs");
var _functionWrappersMjs = require("../utils/FunctionWrappers.mjs");
var _clientAssertionUtilsMjs = require("../utils/ClientAssertionUtils.mjs");
var _requestThumbprintMjs = require("../network/RequestThumbprint.mjs");
var _tokenMjs = require("../protocol/Token.mjs");
var _loggerMjs = require("../logger/Logger.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _interactionRequiredAuthErrorCodesMjs = require("../error/InteractionRequiredAuthErrorCodes.mjs");
var _clientConfigurationErrorCodesMjs = require("../error/ClientConfigurationErrorCodes.mjs");
var _clientAuthErrorCodesMjs = require("../error/ClientAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class RefreshTokenClient {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, _clientConfigurationMjs.buildClientConfiguration)(configuration);
        // Initialize the logger
        this.logger = new (0, _loggerMjs.Logger)(this.config.loggerOptions, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    async acquireToken(request, apiId) {
        const reqTimestamp = (0, _timeUtilsMjs.nowSeconds)();
        const response = await (0, _functionWrappersMjs.invokeAsync)(this.executeTokenRequest.bind(this), (0, _performanceEventsMjs.RefreshTokenClientExecuteTokenRequest), this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, _constantsMjs.HeaderNames).X_MS_REQUEST_ID];
        const responseHandler = new (0, _responseHandlerMjs.ResponseHandler)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return (0, _functionWrappersMjs.invokeAsync)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, _performanceEventsMjs.HandleServerTokenResponse), this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request, apiId) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.tokenRequestEmpty), "");
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, _clientAuthErrorMjs.createClientAuthError)((0, _clientAuthErrorCodesMjs.noAccountInSilentRequest), request.correlationId);
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment, request.correlationId);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, _functionWrappersMjs.invokeAsync)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, _performanceEventsMjs.RefreshTokenClientAcquireTokenWithCachedRefreshToken), this.logger, this.performanceClient, request.correlationId)(request, true, apiId);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, _interactionRequiredAuthErrorMjs.InteractionRequiredAuthError) && e.errorCode === (0, _interactionRequiredAuthErrorCodesMjs.noTokensFound);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, _serverErrorMjs.ServerError) && e.errorCode === (0, _constantsMjs.INVALID_GRANT_ERROR) && e.subError === (0, _constantsMjs.CLIENT_MISMATCH_ERROR);
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, _functionWrappersMjs.invokeAsync)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, _performanceEventsMjs.RefreshTokenClientAcquireTokenWithCachedRefreshToken), this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, _functionWrappersMjs.invokeAsync)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, _performanceEventsMjs.RefreshTokenClientAcquireTokenWithCachedRefreshToken), this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci, apiId) {
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, _functionWrappersMjs.invoke)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, _performanceEventsMjs.CacheManagerGetRefreshToken), this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined);
        if (!refreshToken) throw (0, _interactionRequiredAuthErrorMjs.createInteractionRequiredAuthError)((0, _interactionRequiredAuthErrorCodesMjs.noTokensFound), request.correlationId);
        if (refreshToken.expiresOn) {
            const offset = request.refreshTokenExpirationOffsetSeconds || DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS;
            this.performanceClient?.addFields({
                cacheRtExpiresOnSeconds: Number(refreshToken.expiresOn),
                rtOffsetSeconds: offset
            }, request.correlationId);
            if ((0, _timeUtilsMjs.isTokenExpired)(refreshToken.expiresOn, offset)) throw (0, _interactionRequiredAuthErrorMjs.createInteractionRequiredAuthError)((0, _interactionRequiredAuthErrorCodesMjs.refreshTokenExpired), request.correlationId);
        }
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, _constantsMjs.AuthenticationScheme).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, _ccsCredentialMjs.CcsCredentialType).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, _functionWrappersMjs.invokeAsync)(this.acquireToken.bind(this), (0, _performanceEventsMjs.RefreshTokenClientAcquireToken), this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest, apiId);
        } catch (e) {
            if (e instanceof (0, _interactionRequiredAuthErrorMjs.InteractionRequiredAuthError)) {
                if (e.subError === (0, _interactionRequiredAuthErrorCodesMjs.badToken)) {
                    // Remove bad refresh token from cache
                    this.logger.verbose("1pg3ap", request.correlationId);
                    const badRefreshTokenKey = this.cacheManager.generateCredentialKey(refreshToken);
                    this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
                }
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        const queryParametersString = (0, _tokenMjs.createTokenQueryParameters)(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = (0, _urlStringMjs.UrlString).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, _functionWrappersMjs.invokeAsync)(this.createTokenRequestBody.bind(this), (0, _performanceEventsMjs.RefreshTokenClientCreateTokenRequestBody), this.logger, this.performanceClient, request.correlationId)(request);
        const headers = (0, _tokenMjs.createTokenRequestHeaders)(this.logger, this.config.systemOptions.preventCorsPreflight, request.ccsCredential);
        const thumbprint = (0, _requestThumbprintMjs.getRequestThumbprint)(this.config.authOptions.clientId, request);
        return (0, _functionWrappersMjs.invokeAsync)((0, _tokenMjs.executePostToTokenEndpoint), (0, _performanceEventsMjs.RefreshTokenClientExecutePostToTokenEndpoint), this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, this.serverTelemetryManager);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        (0, _requestParameterBuilderMjs.addClientId)(parameters, request.embeddedClientId || request.extraParameters?.[0, _aadserverParamKeysMjs.CLIENT_ID] || this.config.authOptions.clientId);
        if (request.redirectUri) (0, _requestParameterBuilderMjs.addRedirectUri)(parameters, request.redirectUri);
        (0, _requestParameterBuilderMjs.addScopes)(parameters, request.scopes, request.correlationId, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        (0, _requestParameterBuilderMjs.addGrantType)(parameters, (0, _constantsMjs.GrantType).REFRESH_TOKEN_GRANT);
        (0, _requestParameterBuilderMjs.addClientInfo)(parameters);
        (0, _requestParameterBuilderMjs.addLibraryInfo)(parameters, this.config.libraryInfo);
        (0, _requestParameterBuilderMjs.addApplicationTelemetry)(parameters, this.config.telemetry.application);
        (0, _requestParameterBuilderMjs.addThrottling)(parameters);
        if (this.serverTelemetryManager && !(0, _clientConfigurationMjs.isOidcProtocolMode)(this.config)) (0, _requestParameterBuilderMjs.addServerTelemetry)(parameters, this.serverTelemetryManager);
        (0, _requestParameterBuilderMjs.addRefreshToken)(parameters, request.refreshToken);
        if (this.config.clientCredentials.clientSecret) (0, _requestParameterBuilderMjs.addClientSecret)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, _requestParameterBuilderMjs.addClientAssertion)(parameters, await (0, _clientAssertionUtilsMjs.getClientAssertion)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, _requestParameterBuilderMjs.addClientAssertionType)(parameters, clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, _constantsMjs.AuthenticationScheme).POP) {
            const popTokenGenerator = new (0, _popTokenGeneratorMjs.PopTokenGenerator)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, _functionWrappersMjs.invokeAsync)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, _performanceEventsMjs.PopTokenGenerateCnf), this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, _requestParameterBuilderMjs.addPopToken)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, _constantsMjs.AuthenticationScheme).SSH) {
            if (request.sshJwk) (0, _requestParameterBuilderMjs.addSshJwk)(parameters, request.sshJwk);
            else throw (0, _clientConfigurationErrorMjs.createClientConfigurationError)((0, _clientConfigurationErrorCodesMjs.missingSshJwk), request.correlationId);
        }
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, _ccsCredentialMjs.CcsCredentialType).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, _clientInfoMjs.buildClientInfoFromHomeAccountId)(request.ccsCredential.credential);
                    (0, _requestParameterBuilderMjs.addCcsOid)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`1qhtee ${e}`, request.correlationId);
                }
                break;
            case (0, _ccsCredentialMjs.CcsCredentialType).UPN:
                (0, _requestParameterBuilderMjs.addCcsUpn)(parameters, request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) (0, _requestParameterBuilderMjs.addBrokerParameters)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) (0, _requestParameterBuilderMjs.addExtraParameters)(parameters, {
            ...request.extraParameters
        });
        (0, _requestParameterBuilderMjs.instrumentBrokerParams)(parameters, request.correlationId, this.performanceClient);
        (0, _requestParameterBuilderMjs.addClaims)(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return (0, _urlUtilsMjs.mapToQueryString)(parameters);
    }
}

},{"../config/ClientConfiguration.mjs":"66gK3","../request/RequestParameterBuilder.mjs":"lAS2Y","../utils/UrlUtils.mjs":"2SeAw","../utils/Constants.mjs":"5eRZy","../constants/AADServerParamKeys.mjs":"kjH8Y","../response/ResponseHandler.mjs":"7Ytwn","../crypto/PopTokenGenerator.mjs":"bnqqV","../error/ClientConfigurationError.mjs":"ebyn4","../error/ClientAuthError.mjs":"e8Ku4","../error/ServerError.mjs":"dvxy4","../utils/TimeUtils.mjs":"6CLZ0","../url/UrlString.mjs":"9Z8Lm","../account/CcsCredential.mjs":"iEcz2","../account/ClientInfo.mjs":"98dT9","../error/InteractionRequiredAuthError.mjs":"jiVlC","../telemetry/performance/PerformanceEvents.mjs":"kxZTv","../utils/FunctionWrappers.mjs":"4kFBF","../utils/ClientAssertionUtils.mjs":"jl7q2","../network/RequestThumbprint.mjs":"dg9GN","../protocol/Token.mjs":"dDGfh","../logger/Logger.mjs":"9bvcp","../packageMetadata.mjs":"ftCED","../error/InteractionRequiredAuthErrorCodes.mjs":"9FSE5","../error/ClientConfigurationErrorCodes.mjs":"iMtlX","../error/ClientAuthErrorCodes.mjs":"8keAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"46Kmi":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SilentAuthCodeClient", ()=>SilentAuthCodeClient);
var _browser = require("@azure/msal-common/browser");
var _standardInteractionClientMjs = require("./StandardInteractionClient.mjs");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _hybridSpaAuthorizationCodeClientMjs = require("./HybridSpaAuthorizationCodeClient.mjs");
var _interactionHandlerMjs = require("../interaction_handler/InteractionHandler.mjs");
var _baseInteractionClientMjs = require("./BaseInteractionClient.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class SilentAuthCodeClient extends (0, _standardInteractionClientMjs.StandardInteractionClient) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, correlationId, platformAuthProvider){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.authCodeRequired), this.correlationId);
        // Create silent request
        const silentRequest = await (0, _browser.invokeAsync)((0, _standardInteractionClientMjs.initializeAuthorizationRequest), (0, _browserPerformanceEventsMjs.StandardInteractionClientInitializeAuthorizationRequest), this.logger, this.performanceClient, this.correlationId)(request, (0, _browserConstantsMjs.InteractionType).Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, /*
         * correlationId is optional in request payload, while this.correlationId is always instantiated as request.correlationId || createGuid().
         * Each auth request creates a new instance of *Client so we can safely use this.correlationId.
         */ this.correlationId);
        const serverTelemetryManager = (0, _baseInteractionClientMjs.initializeServerTelemetryManager)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, _browser.invokeAsync)(this.getClientConfiguration.bind(this), (0, _browserPerformanceEventsMjs.StandardInteractionClientGetClientConfiguration), this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, _hybridSpaAuthorizationCodeClientMjs.HybridSpaAuthorizationCodeClient)(clientConfig, this.performanceClient);
            this.logger.verbose("1uic5e", this.correlationId);
            // Create silent handler
            const interactionHandler = new (0, _interactionHandlerMjs.InteractionHandler)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, _browser.invokeAsync)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, _browser.PerformanceEvents).HandleCodeResponseFromServer, this.logger, this.performanceClient, this.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, this.apiId, false);
        } catch (e) {
            if (e instanceof (0, _browser.AuthError)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.silentLogoutUnsupported), ""));
    }
}

},{"@azure/msal-common/browser":[["AuthError","8TWYe"],["invokeAsync","4kFBF"],["PerformanceEvents","kxZTv","*"]],"./StandardInteractionClient.mjs":"2tYFp","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../error/BrowserAuthError.mjs":"k9YIy","../utils/BrowserConstants.mjs":"5kHn0","./HybridSpaAuthorizationCodeClient.mjs":"8bKMw","../interaction_handler/InteractionHandler.mjs":"7Hteg","./BaseInteractionClient.mjs":"9bVY8","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8bKMw":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HybridSpaAuthorizationCodeClient", ()=>HybridSpaAuthorizationCodeClient);
var _browser = require("@azure/msal-common/browser");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class HybridSpaAuthorizationCodeClient extends (0, _browser.AuthorizationCodeClient) {
    constructor(config, performanceClient){
        super(config, performanceClient);
        this.includeRedirectUri = false;
    }
}

},{"@azure/msal-common/browser":"hovgR","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"c8njp":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "collectInstanceStats", ()=>collectInstanceStats);
parcelHelpers.export(exports, "getNetworkInfo", ()=>getNetworkInfo);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Get network information for telemetry purposes. This is only supported in Chromium-based browsers.
 * @returns Network connection information, or an empty object if not available.
 */ function getNetworkInfo() {
    if (typeof window === "undefined" || !window.navigator) return {};
    const connection = "connection" in window.navigator ? window.navigator.connection : undefined;
    return {
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt
    };
}
function collectInstanceStats(currentClientId, performanceEvent, logger, correlationId) {
    const frameInstances = // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i)=>i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) logger.warning("1e88vg", correlationId);
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eMGN5":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardOperatingContext", ()=>StandardOperatingContext);
var _baseOperatingContextMjs = require("./BaseOperatingContext.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class StandardOperatingContext extends (0, _baseOperatingContextMjs.BaseOperatingContext) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return StandardOperatingContext.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return StandardOperatingContext.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async initialize(correlationId) {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ StandardOperatingContext.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ StandardOperatingContext.ID = "StandardOperatingContext";

},{"./BaseOperatingContext.mjs":"7j7jo","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7j7jo":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseOperatingContext", ()=>BaseOperatingContext);
var _browser = require("@azure/msal-common/browser");
var _configurationMjs = require("../config/Configuration.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _cacheKeysMjs = require("../cache/CacheKeys.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class BaseOperatingContext {
    static loggerCallback(level, message) {
        switch(level){
            case (0, _browser.LogLevel).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, _browser.LogLevel).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, _browser.LogLevel).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, _browser.LogLevel).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config, responseHandlers){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, _configurationMjs.buildConfiguration)(config, this.browserEnvironment);
        this.responseHandlers = responseHandlers;
        let sessionStorage;
        try {
            sessionStorage = window[(0, _browserConstantsMjs.BrowserCacheLocation).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, _cacheKeysMjs.LOG_LEVEL_CACHE_KEY));
        const piiLoggingKey = sessionStorage?.getItem((0, _cacheKeysMjs.LOG_PII_CACHE_KEY))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, _browser.LogLevel)).includes(logLevelKey) ? (0, _browser.LogLevel)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = BaseOperatingContext.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, _browser.Logger)(loggerOptions, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the internal response handlers supplied by PublicClientApplication, if any.
     * @returns AuthResponseHandlers | undefined
     */ getResponseHandlers() {
        return this.responseHandlers;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}

},{"@azure/msal-common/browser":"9bvcp","../config/Configuration.mjs":"iuw8A","../packageMetadata.mjs":"7kVpA","../utils/BrowserConstants.mjs":"5kHn0","../cache/CacheKeys.mjs":"gsAy0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fxZ9g":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NestedAppAuthController", ()=>NestedAppAuthController);
var _browser = require("@azure/msal-common/browser");
var _browserRootPerformanceEventsMjs = require("../telemetry/BrowserRootPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _cryptoOpsMjs = require("../crypto/CryptoOps.mjs");
var _nestedAppAuthAdapterMjs = require("../naa/mapping/NestedAppAuthAdapter.mjs");
var _nestedAppAuthErrorMjs = require("../error/NestedAppAuthError.mjs");
var _eventHandlerMjs = require("../event/EventHandler.mjs");
var _eventTypeMjs = require("../event/EventType.mjs");
var _browserCacheManagerMjs = require("../cache/BrowserCacheManager.mjs");
var _accountManagerMjs = require("../cache/AccountManager.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class NestedAppAuthController {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, _cryptoOpsMjs.CryptoOps)(this.logger, this.performanceClient, true) : (0, _browser.DEFAULT_CRYPTO_IMPLEMENTATION);
        this.eventHandler = new (0, _eventHandlerMjs.EventHandler)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, _browserCacheManagerMjs.BrowserCacheManager)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, _browser.buildStaticAuthorityOptions)(this.config.auth)) : (0, _browserCacheManagerMjs.DEFAULT_BROWSER_CACHE_MANAGER)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        this.nestedAppAuthAdapter = new (0, _nestedAppAuthAdapterMjs.NestedAppAuthAdapter)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        this.currentAccountContext = accountContext ? accountContext : null;
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new NestedAppAuthController(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ async initialize(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isBroker) {
        const initCorrelationId = request?.correlationId || (0, _browserCryptoMjs.createNewGuid)();
        await this.browserStorage.initialize(initCorrelationId);
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || (0, _browserCryptoMjs.createNewGuid)();
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenPopup), correlationId);
        atPopupMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            (0, _browser.enforceResourceParameter)(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, _browser.TimeUtils).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, _browser.AuthError) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || (0, _browserCryptoMjs.createNewGuid)();
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.SsoSilent), correlationId);
        ssoSilentMeasurement.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            (0, _browser.enforceResourceParameter)(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            naaRequest.forceRefresh = validRequest.forceRefresh;
            const reqTimestamp = (0, _browser.TimeUtils).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, _browser.AuthError) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const correlationId = request.correlationId || (0, _browserCryptoMjs.createNewGuid)();
        const atsMeasurement = this.performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.AcquireTokenSilent), correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("11t57w", correlationId);
            return null;
        }
        // if the request has forceRefresh, we cannot look up in the cache
        if (request.forceRefresh) {
            this.logger.verbose("1ovnmo", correlationId);
            return null;
        }
        // respect cache lookup policy
        let result = null;
        if (!request.cacheLookupPolicy) request.cacheLookupPolicy = (0, _browserConstantsMjs.CacheLookupPolicy).Default;
        switch(request.cacheLookupPolicy){
            case (0, _browserConstantsMjs.CacheLookupPolicy).Default:
            case (0, _browserConstantsMjs.CacheLookupPolicy).AccessToken:
            case (0, _browserConstantsMjs.CacheLookupPolicy).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, result);
            atsMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atsMeasurement.end({
                success: true
            }, undefined, result.account);
            return result;
        }
        this.logger.warning("1yb4fi", correlationId);
        this.eventHandler.emitEvent((0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE, correlationId, (0, _browserConstantsMjs.InteractionType).Silent, null);
        atsMeasurement.end({
            success: false
        }, undefined, request.account);
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        // always prioritize the account context from the bridge
        const accountContext = this.bridgeProxy.getAccountContext() || this.currentAccountContext;
        const correlationId = request.correlationId || (0, _browserCryptoMjs.createNewGuid)();
        let currentAccount = null;
        if (accountContext) currentAccount = (0, _accountManagerMjs.getAccount)(accountContext, this.logger, this.browserStorage, correlationId);
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("10qnr0", correlationId);
            return Promise.resolve(null);
        }
        this.logger.verbose("1u7hux", correlationId);
        const authRequest = {
            ...request,
            correlationId: correlationId,
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, _browser.Constants).OIDC_DEFAULT_SCOPES
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("03vm49", correlationId);
            return Promise.resolve(null);
        } else if ((0, _browser.TimeUtils).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, _browser.TimeUtils).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("18egye", correlationId);
            return Promise.resolve(null);
        } else if (authRequest.resource) {
            const requestedResource = authRequest.resource;
            const cachedResource = cachedAccessToken.resource;
            if (!cachedResource || cachedResource !== requestedResource) {
                this.logger.verbose("0qraxd", correlationId);
                return Promise.resolve(null);
            }
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId);
        if (!cachedIdToken) {
            this.logger.verbose("0d68kd", correlationId);
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ acquireTokenRedirect(request) {
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError(request?.correlationId);
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ acquireTokenByCode(request) {
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError(request?.correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        // No request context: callback registration is not per-request
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        // No request context: callback registration is not per-request
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, _accountManagerMjs.getAllAccounts)(this.logger, this.browserStorage, this.isBrowserEnv(), (0, _browserCryptoMjs.createNewGuid)(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, _accountManagerMjs.getAccount)(accountFilter, this.logger, this.browserStorage, (0, _browserCryptoMjs.createNewGuid)());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ return (0, _accountManagerMjs.setActiveAccount)(account, this.browserStorage, (0, _browserCryptoMjs.createNewGuid)());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, _accountManagerMjs.getActiveAccount)(this.browserStorage, (0, _browserCryptoMjs.createNewGuid)());
    }
    // #endregion
    handleRedirectPromise(options // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, _browserConstantsMjs.DEFAULT_REQUEST));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError(request?.correlationId);
    }
    logoutRedirect(logoutRequest) {
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError(logoutRequest?.correlationId);
    }
    logoutPopup(logoutRequest) {
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError(logoutRequest?.correlationId);
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("1k8729", "");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        // Accessor stub with no request context
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError();
    }
    getRedirectResponse() {
        // Accessor stub with no request context
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, _nestedAppAuthErrorMjs.NestedAppAuthError).createUnsupportedError(logoutRequest?.correlationId);
    }
    async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        const accountEntity = (0, _browser.AccountEntityUtils).createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, _browser.AuthToken).isKmsi(result.idTokenClaims), (0, _browserConstantsMjs.ApiId).hydrateCache);
        return this.browserStorage.hydrateCache(result, request);
    }
}

},{"@azure/msal-common/browser":[["AccountEntityUtils","kwYyZ","*"],["AuthError","8TWYe"],["AuthToken","l1q48","*"],["buildStaticAuthorityOptions","iOR3f"],["Constants","5eRZy","*"],["DEFAULT_CRYPTO_IMPLEMENTATION","l3pFH"],["enforceResourceParameter","aeuO6"],["TimeUtils","6CLZ0","*"]],"../telemetry/BrowserRootPerformanceEvents.mjs":"cD5vH","../utils/BrowserConstants.mjs":"5kHn0","../crypto/CryptoOps.mjs":"kQH8V","../naa/mapping/NestedAppAuthAdapter.mjs":"fkJ1y","../error/NestedAppAuthError.mjs":"oIPbX","../event/EventHandler.mjs":"5hEJZ","../event/EventType.mjs":"gVLUh","../cache/BrowserCacheManager.mjs":"UC4Vw","../cache/AccountManager.mjs":"21SSU","../crypto/BrowserCrypto.mjs":"a5L0H","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fkJ1y":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NestedAppAuthAdapter", ()=>NestedAppAuthAdapter);
var _browser = require("@azure/msal-common/browser");
var _bridgeErrorMjs = require("../BridgeError.mjs");
var _bridgeStatusCodeMjs = require("../BridgeStatusCode.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class NestedAppAuthAdapter {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const claims = (0, _browser.RequestParameterBuilder).buildMergedClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, _browser.Constants).OIDC_DEFAULT_SCOPES;
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            resource: request.resource,
            scope: scopes.join(" "),
            correlationId,
            claims: !(0, _browser.StringUtils).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, _browser.Constants).AuthenticationScheme.BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).nullOrEmptyToken, request.correlationId);
        // Request timestamp and AuthResult expires_in are in seconds, converting to Date for AuthenticationResult
        const expiresOn = (0, _browser.TimeUtils).toDateFromSeconds(reqTimestamp + (response.token.expires_in || 0));
        const idTokenClaims = (0, _browser.AuthToken).extractTokenClaims(response.token.id_token, this.crypto.base64Decode, request.correlationId);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account,
            idToken: response.token.id_token,
            idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, _browser.Constants).AuthenticationScheme.BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        /*
         * In B2C scenarios tid may not be present, use getTenantIdFromIdTokenClaims
         * which handles tid, tfp (modern B2C), and acr (legacy B2C) claims
         */ const tenantId = fromAccount.tenantId || (0, _browser.getTenantIdFromIdTokenClaims)(effectiveIdTokenClaims) || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        // Validate environment - required field
        const environment = fromAccount.environment;
        if (!environment) throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).invalidCacheEnvironment, "");
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = effectiveIdTokenClaims?.preferred_username || effectiveIdTokenClaims?.upn;
        const email = effectiveIdTokenClaims?.emails?.[0] || null;
        const username = fromAccount.username || preferredUsername || email || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name || "";
        const loginHint = fromAccount.loginHint || effectiveIdTokenClaims?.login_hint;
        const tenantProfiles = new Map();
        const tenantProfile = (0, _browser.buildTenantProfile)(homeAccountId, localAccountId, tenantId, fromAccount.platformBrokerId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId,
            environment,
            tenantId,
            username,
            localAccountId,
            name,
            loginHint,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            nativeAccountId: fromAccount.platformBrokerId,
            tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, _bridgeErrorMjs.isBridgeError)(error)) switch(error.status){
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).UserCancel:
                return new (0, _browser.ClientAuthError)((0, _browser.ClientAuthErrorCodes).userCanceled, "");
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).NoNetwork:
                return new (0, _browser.ClientAuthError)((0, _browser.ClientAuthErrorCodes).noNetworkConnectivity, "");
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).AccountUnavailable:
                return new (0, _browser.ClientAuthError)((0, _browser.ClientAuthErrorCodes).noAccountFound, "");
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).Disabled:
                return new (0, _browser.ClientAuthError)((0, _browser.ClientAuthErrorCodes).nestedAppAuthBridgeDisabled, "");
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).NestedAppAuthUnavailable:
                return new (0, _browser.ClientAuthError)(error.code || (0, _browser.ClientAuthErrorCodes).nestedAppAuthBridgeDisabled, "", error.description);
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).TransientError:
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).PersistentError:
                return new (0, _browser.ServerError)(error.code || "", "", error.description);
            case (0, _bridgeStatusCodeMjs.BridgeStatusCode).UserInteractionRequired:
                return new (0, _browser.InteractionRequiredAuthError)(error.code || "", "", error.description);
            default:
                return new (0, _browser.AuthError)(error.code || "", "", error.description);
        }
        else return new (0, _browser.AuthError)("unknown_error", "", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, _browser.createClientAuthError)((0, _browser.ClientAuthErrorCodes).nullOrEmptyToken, correlationId);
        const idTokenClaims = (0, _browser.AuthToken).extractTokenClaims(idToken.secret, this.crypto.base64Decode, correlationId);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: (0, _browser.TimeUtils).toDateFromSeconds(accessToken.expiresOn),
            extExpiresOn: (0, _browser.TimeUtils).toDateFromSeconds(accessToken.extendedExpiresOn),
            tokenType: request.authenticationScheme || (0, _browser.Constants).AuthenticationScheme.BEARER,
            correlationId,
            state: request.state
        };
        return authenticationResult;
    }
}

},{"@azure/msal-common/browser":[["AuthError","8TWYe"],["AuthToken","l1q48","*"],["buildTenantProfile","glI6y"],["ClientAuthError","e8Ku4"],["createClientAuthError","e8Ku4"],["ClientAuthErrorCodes","8keAa","*"],["Constants","5eRZy","*"],["getTenantIdFromIdTokenClaims","dKH9k"],["InteractionRequiredAuthError","jiVlC"],["RequestParameterBuilder","lAS2Y","*"],["ServerError","dvxy4"],["StringUtils","d70Cd"],["TimeUtils","6CLZ0","*"]],"../BridgeError.mjs":"2OPkv","../BridgeStatusCode.mjs":"a2nDO","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2OPkv":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBridgeError", ()=>isBridgeError);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function isBridgeError(error) {
    return error.status !== undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"a2nDO":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BridgeStatusCode", ()=>BridgeStatusCode);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const BridgeStatusCode = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"oIPbX":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NestedAppAuthError", ()=>NestedAppAuthError);
var _browser = require("@azure/msal-common/browser");
var _nativeAuthErrorCodesMjs = require("./NativeAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class NestedAppAuthError extends (0, _browser.AuthError) {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        Object.setPrototypeOf(this, NestedAppAuthError.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError(correlationId) {
        /*
         * Some controller stubs (perf callbacks, getPerformanceClient, getRedirectResponse)
         * have no request param and thus no correlationId to forward
         */ return new NestedAppAuthError((0, _nativeAuthErrorCodesMjs.unsupportedMethod), correlationId || "");
    }
}

},{"@azure/msal-common/browser":"8TWYe","./NativeAuthErrorCodes.mjs":"60SIe","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"g2g5x":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NestedAppOperatingContext", ()=>NestedAppOperatingContext);
var _baseOperatingContextMjs = require("./BaseOperatingContext.mjs");
var _bridgeProxyMjs = require("../naa/BridgeProxy.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class NestedAppOperatingContext extends (0, _baseOperatingContextMjs.BaseOperatingContext) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return NestedAppOperatingContext.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return NestedAppOperatingContext.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @param correlationId
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize(correlationId) {
        const cid = correlationId || "";
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, _bridgeProxyMjs.BridgeProxy).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`1mdxyj ${ex}`, cid);
        }
        this.logger.info(`12jy9a ${this.available}`, cid);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ NestedAppOperatingContext.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ NestedAppOperatingContext.ID = "NestedAppOperatingContext";

},{"./BaseOperatingContext.mjs":"7j7jo","../naa/BridgeProxy.mjs":"e1QG9","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e1QG9":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BridgeProxy", ()=>BridgeProxy);
var _bridgeStatusCodeMjs = require("./BridgeStatusCode.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class BridgeProxy {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = BridgeProxy.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    BridgeProxy.bridgeRequests.splice(BridgeProxy.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = BridgeProxy.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                BridgeProxy.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return BridgeProxy.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: BridgeProxy.validateBridgeResultOrThrow(result.token),
            account: BridgeProxy.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, _browserCryptoMjs.createNewGuid)(),
            sendTime: Date.now(),
            clientLibrary: (0, _browserConstantsMjs.BrowserConstants).MSAL_SKU,
            clientLibraryVersion: (0, _packageMetadataMjs.version),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = BridgeProxy.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            BridgeProxy.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, _bridgeStatusCodeMjs.BridgeStatusCode).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await BridgeProxy.initializeNestedAppAuthBridge();
        return new BridgeProxy(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
BridgeProxy.bridgeRequests = [];

},{"./BridgeStatusCode.mjs":"a2nDO","../crypto/BrowserCrypto.mjs":"a5L0H","../utils/BrowserConstants.mjs":"5kHn0","../packageMetadata.mjs":"7kVpA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"immww":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stubbedPublicClientApplication", ()=>stubbedPublicClientApplication);
var _browserConfigurationAuthErrorMjs = require("../error/BrowserConfigurationAuthError.mjs");
var _browserConfigurationAuthErrorCodesMjs = require("../error/BrowserConfigurationAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const stubbedPublicClientApplication = {
    initialize: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    loginPopup: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    loginRedirect: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    logoutRedirect: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    logoutPopup: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    ssoSilent: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    getLogger: ()=>{
        throw (0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), "");
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw (0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), "");
    },
    hydrateCache: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    },
    clearCache: ()=>{
        return Promise.reject((0, _browserConfigurationAuthErrorMjs.createBrowserConfigurationAuthError)((0, _browserConfigurationAuthErrorCodesMjs.stubbedPublicClientApplicationCalled), ""));
    }
};

},{"../error/BrowserConfigurationAuthError.mjs":"401zU","../error/BrowserConfigurationAuthErrorCodes.mjs":"f0n3B","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2kbCw":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadExternalTokens", ()=>loadExternalTokens);
var _browser = require("@azure/msal-common/browser");
var _configurationMjs = require("../config/Configuration.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _cryptoOpsMjs = require("../crypto/CryptoOps.mjs");
var _base64DecodeMjs = require("../encode/Base64Decode.mjs");
var _browserAuthErrorMjs = require("../error/BrowserAuthError.mjs");
var _eventHandlerMjs = require("../event/EventHandler.mjs");
var _browserPerformanceEventsMjs = require("../telemetry/BrowserPerformanceEvents.mjs");
var _browserRootPerformanceEventsMjs = require("../telemetry/BrowserRootPerformanceEvents.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserUtilsMjs = require("../utils/BrowserUtils.mjs");
var _browserCacheManagerMjs = require("./BrowserCacheManager.mjs");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _browserAuthErrorCodesMjs = require("../error/BrowserAuthErrorCodes.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * API to load tokens to msal-browser cache.
 * @param config - Object to configure the MSAL app.
 * @param request - Silent request containing authority, scopes, and account.
 * @param response - External token response to load into the cache.
 * @param options - Options controlling how tokens are loaded into the cache.
 * @param performanceClient - Optional performance client used for telemetry measurements.
 * @returns `AuthenticationResult` for the response that was loaded.
 */ async function loadExternalTokens(config, request, response, options, performanceClient = new (0, _browser.StubPerformanceClient)()) {
    (0, _browserUtilsMjs.blockNonBrowserEnvironment)();
    const browserConfig = (0, _configurationMjs.buildConfiguration)(config, true);
    const correlationId = request.correlationId || (0, _browserCryptoMjs.createNewGuid)();
    const rootMeasurement = performanceClient.startMeasurement((0, _browserRootPerformanceEventsMjs.LoadExternalTokens), correlationId);
    try {
        const idTokenClaims = response.id_token ? (0, _browser.AuthToken).extractTokenClaims(response.id_token, (0, _base64DecodeMjs.base64Decode), correlationId) : undefined;
        const kmsi = (0, _browser.AuthToken).isKmsi(idTokenClaims || {});
        const authorityOptions = {
            protocolMode: browserConfig.system.protocolMode,
            knownAuthorities: browserConfig.auth.knownAuthorities,
            cloudDiscoveryMetadata: browserConfig.auth.cloudDiscoveryMetadata,
            authorityMetadata: browserConfig.auth.authorityMetadata
        };
        const logger = new (0, _browser.Logger)(browserConfig.system.loggerOptions || {}, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        const cryptoOps = new (0, _cryptoOpsMjs.CryptoOps)(logger, browserConfig.telemetry.client);
        const storage = new (0, _browserCacheManagerMjs.BrowserCacheManager)(browserConfig.auth.clientId, browserConfig.cache, cryptoOps, logger, browserConfig.telemetry.client, new (0, _eventHandlerMjs.EventHandler)(logger), (0, _browser.buildStaticAuthorityOptions)(browserConfig.auth));
        await storage.initialize(correlationId);
        const authorityString = request.authority || browserConfig.auth.authority;
        const authority = await (0, _browser.AuthorityFactory).createDiscoveredInstance((0, _browser.Authority).generateAuthority(authorityString, request.azureCloudOptions), browserConfig.system.networkClient, storage, authorityOptions, logger, correlationId, performanceClient);
        const cacheRecordAccount = await (0, _browser.invokeAsync)(loadAccount, (0, _browserPerformanceEventsMjs.LoadAccount), logger, performanceClient, correlationId)(request, options.clientInfo || response.client_info || "", correlationId, storage, logger, cryptoOps, authority, idTokenClaims, performanceClient);
        const idToken = await (0, _browser.invokeAsync)(loadIdToken, (0, _browserPerformanceEventsMjs.LoadIdToken), logger, performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, kmsi, correlationId, storage, logger, config.auth.clientId);
        const accessToken = await (0, _browser.invokeAsync)(loadAccessToken, (0, _browserPerformanceEventsMjs.LoadAccessToken), logger, performanceClient, correlationId)(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, kmsi, options, correlationId, storage, logger, config.auth.clientId);
        const refreshToken = await (0, _browser.invokeAsync)(loadRefreshToken, (0, _browserPerformanceEventsMjs.LoadRefreshToken), logger, performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, kmsi, correlationId, storage, logger, config.auth.clientId, performanceClient);
        rootMeasurement.end({
            success: true
        }, undefined, (0, _browser.AccountEntityUtils).getAccountInfo(cacheRecordAccount));
        return generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken,
            accessToken,
            refreshToken
        }, authority, idTokenClaims);
    } catch (error) {
        rootMeasurement.end({
            success: false
        }, error);
        throw error;
    }
}
/**
 * Helper function to load account to msal-browser cache
 * @param idToken
 * @param environment
 * @param clientInfo
 * @param authorityType
 * @param requestHomeAccountId
 * @returns `AccountEntity`
 */ async function loadAccount(request, clientInfo, correlationId, storage, logger, cryptoObj, authority, idTokenClaims, performanceClient) {
    logger.verbose("0ke46k", correlationId);
    if (request.account) {
        const accountEntity = (0, _browser.AccountEntityUtils).createAccountEntityFromAccountInfo(request.account);
        await storage.setAccount(accountEntity, correlationId, (0, _browser.AuthToken).isKmsi(idTokenClaims || {}), (0, _browserConstantsMjs.ApiId).loadExternalTokens);
        return accountEntity;
    } else if (!clientInfo && !idTokenClaims) {
        logger.error("0hzcn4", correlationId);
        throw (0, _browserAuthErrorMjs.createBrowserAuthError)((0, _browserAuthErrorCodesMjs.unableToLoadToken), "");
    }
    const homeAccountId = (0, _browser.AccountEntityUtils).generateHomeAccountId(clientInfo, authority.authorityType, logger, cryptoObj, correlationId, idTokenClaims);
    const claimsTenantId = idTokenClaims?.tid;
    const cachedAccount = (0, _browser.buildAccountToCache)(storage, authority, homeAccountId, (0, _base64DecodeMjs.base64Decode), correlationId, idTokenClaims, clientInfo, authority.getPreferredCache(), claimsTenantId, undefined, undefined, logger, performanceClient);
    await storage.setAccount(cachedAccount, correlationId, (0, _browser.AuthToken).isKmsi(idTokenClaims || {}), (0, _browserConstantsMjs.ApiId).loadExternalTokens);
    return cachedAccount;
}
/**
 * Helper function to load id tokens to msal-browser cache
 * @param idToken
 * @param homeAccountId
 * @param environment
 * @param tenantId
 * @returns `IdTokenEntity`
 */ async function loadIdToken(response, homeAccountId, environment, tenantId, kmsi, correlationId, storage, logger, clientId) {
    if (!response.id_token) {
        logger.verbose("1pm7g1", correlationId);
        return null;
    }
    logger.verbose("168lyi", correlationId);
    const idTokenEntity = (0, _browser.CacheHelpers).createIdTokenEntity(homeAccountId, environment, response.id_token, clientId, tenantId);
    await storage.setIdTokenCredential(idTokenEntity, correlationId, kmsi);
    return idTokenEntity;
}
/**
 * Helper function to load access tokens to msal-browser cache
 * @param request
 * @param response
 * @param homeAccountId
 * @param environment
 * @param tenantId
 * @returns `AccessTokenEntity`
 */ async function loadAccessToken(request, response, homeAccountId, environment, tenantId, kmsi, options, correlationId, storage, logger, clientId) {
    if (!response.access_token) {
        logger.verbose("1ckp9e", correlationId);
        return null;
    } else if (!response.expires_in) {
        logger.error("15mzx8", correlationId);
        return null;
    } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
        logger.error("1h7xse", correlationId);
        return null;
    }
    logger.verbose("01kmxb", correlationId);
    const scopes = response.scope ? (0, _browser.ScopeSet).fromString(response.scope, correlationId) : new (0, _browser.ScopeSet)(request.scopes, correlationId);
    const expiresOn = options.expiresOn || response.expires_in + (0, _browser.TimeUtils).nowSeconds();
    const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + (0, _browser.TimeUtils).nowSeconds();
    const accessTokenEntity = (0, _browser.CacheHelpers).createAccessTokenEntity(homeAccountId, environment, response.access_token, clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, (0, _base64DecodeMjs.base64Decode), correlationId);
    await storage.setAccessTokenCredential(accessTokenEntity, correlationId, kmsi);
    return accessTokenEntity;
}
/**
 * Helper function to load refresh tokens to msal-browser cache
 * @param request
 * @param response
 * @param homeAccountId
 * @param environment
 * @returns `RefreshTokenEntity`
 */ async function loadRefreshToken(response, homeAccountId, environment, kmsi, correlationId, storage, logger, clientId, performanceClient) {
    if (!response.refresh_token) {
        logger.verbose("1l7um5", correlationId);
        return null;
    }
    const expiresOn = response.refresh_token_expires_in ? response.refresh_token_expires_in + (0, _browser.TimeUtils).nowSeconds() : undefined;
    performanceClient.addFields({
        extRtExpiresOnSeconds: expiresOn
    }, correlationId);
    logger.verbose("0qy8ev", correlationId);
    const refreshTokenEntity = (0, _browser.CacheHelpers).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, clientId, response.foci, undefined, expiresOn);
    await storage.setRefreshTokenCredential(refreshTokenEntity, correlationId, kmsi);
    return refreshTokenEntity;
}
/**
 * Helper function to generate an `AuthenticationResult` for the result.
 * @param request
 * @param idTokenObj
 * @param cacheRecord
 * @param authority
 * @returns `AuthenticationResult`
 */ function generateAuthenticationResult(request, cacheRecord, authority, idTokenClaims) {
    let accessToken = "";
    let responseScopes = [];
    let expiresOn = null;
    let extExpiresOn;
    if (cacheRecord?.accessToken) {
        accessToken = cacheRecord.accessToken.secret;
        responseScopes = (0, _browser.ScopeSet).fromString(cacheRecord.accessToken.target, request.correlationId || "").asArray();
        // Access token expiresOn stored in seconds, converting to Date for AuthenticationResult
        expiresOn = (0, _browser.TimeUtils).toDateFromSeconds(cacheRecord.accessToken.expiresOn);
        extExpiresOn = (0, _browser.TimeUtils).toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
    }
    const accountEntity = cacheRecord.account;
    return {
        authority: authority.canonicalAuthority,
        uniqueId: cacheRecord.account.localAccountId,
        tenantId: cacheRecord.account.realm,
        scopes: responseScopes,
        account: (0, _browser.AccountEntityUtils).getAccountInfo(accountEntity),
        idToken: cacheRecord.idToken?.secret || "",
        idTokenClaims: idTokenClaims || {},
        accessToken: accessToken,
        fromCache: true,
        expiresOn: expiresOn,
        correlationId: request.correlationId || "",
        requestId: "",
        extExpiresOn: extExpiresOn,
        familyId: cacheRecord.refreshToken?.familyId || "",
        tokenType: cacheRecord?.accessToken?.tokenType || "",
        state: request.state || "",
        cloudGraphHostName: accountEntity.cloudGraphHostName || "",
        msGraphHost: accountEntity.msGraphHost || "",
        fromPlatformBroker: false
    };
}

},{"@azure/msal-common/browser":[["AccountEntityUtils","kwYyZ","*"],["Authority","iOR3f"],["buildStaticAuthorityOptions","iOR3f"],["AuthorityFactory","gymGK","*"],["AuthToken","l1q48","*"],["buildAccountToCache","7Ytwn"],["CacheHelpers","61GoB","*"],["invokeAsync","4kFBF"],["Logger","9bvcp"],["ScopeSet","7niwa"],["StubPerformanceClient","9VScD"],["TimeUtils","6CLZ0","*"]],"../config/Configuration.mjs":"iuw8A","../crypto/BrowserCrypto.mjs":"a5L0H","../crypto/CryptoOps.mjs":"kQH8V","../encode/Base64Decode.mjs":"evkpn","../error/BrowserAuthError.mjs":"k9YIy","../event/EventHandler.mjs":"5hEJZ","../telemetry/BrowserPerformanceEvents.mjs":"bwxx0","../telemetry/BrowserRootPerformanceEvents.mjs":"cD5vH","../utils/BrowserConstants.mjs":"5kHn0","../utils/BrowserUtils.mjs":"eyRWO","./BrowserCacheManager.mjs":"UC4Vw","../packageMetadata.mjs":"7kVpA","../error/BrowserAuthErrorCodes.mjs":"c0BSJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"efjbW":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventMessageUtils", ()=>EventMessageUtils);
var _eventTypeMjs = require("./EventType.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class EventMessageUtils {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case (0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_START:
                if (message.interactionType === (0, _browserConstantsMjs.InteractionType).Redirect || message.interactionType === (0, _browserConstantsMjs.InteractionType).Popup) return (0, _browserConstantsMjs.InteractionStatus).AcquireToken;
                break;
            case (0, _eventTypeMjs.EventType).HANDLE_REDIRECT_START:
                return (0, _browserConstantsMjs.InteractionStatus).HandleRedirect;
            case (0, _eventTypeMjs.EventType).LOGOUT_START:
                return (0, _browserConstantsMjs.InteractionStatus).Logout;
            case (0, _eventTypeMjs.EventType).LOGOUT_END:
                if (currentStatus && currentStatus !== (0, _browserConstantsMjs.InteractionStatus).Logout) break;
                return (0, _browserConstantsMjs.InteractionStatus).None;
            case (0, _eventTypeMjs.EventType).HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== (0, _browserConstantsMjs.InteractionStatus).HandleRedirect) break;
                return (0, _browserConstantsMjs.InteractionStatus).None;
            case (0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_SUCCESS:
            case (0, _eventTypeMjs.EventType).ACQUIRE_TOKEN_FAILURE:
            case (0, _eventTypeMjs.EventType).RESTORE_FROM_BFCACHE:
                if (message.interactionType === (0, _browserConstantsMjs.InteractionType).Redirect || message.interactionType === (0, _browserConstantsMjs.InteractionType).Popup) {
                    if (currentStatus && currentStatus !== (0, _browserConstantsMjs.InteractionStatus).AcquireToken) break;
                    return (0, _browserConstantsMjs.InteractionStatus).None;
                }
                break;
        }
        return null;
    }
}

},{"./EventType.mjs":"gVLUh","../utils/BrowserConstants.mjs":"5kHn0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e5ix7":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignedHttpRequest", ()=>SignedHttpRequest);
var _cryptoOpsMjs = require("./CryptoOps.mjs");
var _browser = require("@azure/msal-common/browser");
var _packageMetadataMjs = require("../packageMetadata.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class SignedHttpRequest {
    constructor(shrParameters, shrOptions){
        const loggerOptions = shrOptions && shrOptions.loggerOptions || {};
        this.logger = new (0, _browser.Logger)(loggerOptions, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version));
        this.cryptoOps = new (0, _cryptoOpsMjs.CryptoOps)(this.logger);
        this.popTokenGenerator = new (0, _browser.PopTokenGenerator)(this.cryptoOps, new (0, _browser.StubPerformanceClient)());
        this.shrParameters = shrParameters;
    }
    /**
     * Generates and caches a keypair for the given request options.
     * @returns Public key digest, which should be sent to the token issuer.
     */ async generatePublicKeyThumbprint() {
        const { kid } = await this.popTokenGenerator.generateKid(this.shrParameters);
        return kid;
    }
    /**
     * Generates a signed http request for the given payload with the given key.
     * @param payload Payload to sign (e.g. access token)
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @param claims Additional claims to include/override in the signed JWT
     * @returns Pop token signed with the corresponding private key
     */ async signRequest(payload, publicKeyThumbprint, claims) {
        return this.popTokenGenerator.signPayload(payload, publicKeyThumbprint, this.shrParameters, claims);
    }
    /**
     * Removes cached keys from browser for given public key thumbprint
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @param correlationId
     * @returns If keys are properly deleted
     */ async removeKeys(publicKeyThumbprint, correlationId) {
        return this.cryptoOps.removeTokenBindingKey(publicKeyThumbprint, correlationId);
    }
}

},{"./CryptoOps.mjs":"kQH8V","@azure/msal-common/browser":[["Logger","9bvcp"],["PopTokenGenerator","bnqqV"],["StubPerformanceClient","9VScD"]],"../packageMetadata.mjs":"7kVpA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bZJ5C":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserPerformanceClient", ()=>BrowserPerformanceClient);
var _browser = require("@azure/msal-common/browser");
var _packageMetadataMjs = require("../packageMetadata.mjs");
var _browserConstantsMjs = require("../utils/BrowserConstants.mjs");
var _browserCryptoMjs = require("../crypto/BrowserCrypto.mjs");
var _cacheKeysMjs = require("../cache/CacheKeys.mjs");
var _msalFrameStatsUtilsMjs = require("../utils/MsalFrameStatsUtils.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns browser performance measurement module if session flag is enabled. Returns undefined otherwise.
 */ function getPerfMeasurementModule() {
    let sessionStorage;
    try {
        sessionStorage = window[(0, _browserConstantsMjs.BrowserCacheLocation).SessionStorage];
        const perfEnabled = sessionStorage?.getItem((0, _cacheKeysMjs.BROWSER_PERF_ENABLED_KEY));
        if (Number(perfEnabled) === 1) return require("d5d7ed9bdc4870ff");
    // Mute errors if it's a non-browser environment or cookies are blocked.
    } catch (e) {}
    return undefined;
}
/**
 * Returns boolean, indicating whether browser supports window.performance.now() function.
 */ function supportsBrowserPerformanceNow() {
    return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.now === "function";
}
/**
 * Returns event duration in milliseconds using window performance API if available. Returns undefined otherwise.
 * @param startTime {DOMHighResTimeStamp | undefined}
 * @returns {number | undefined}
 */ function getPerfDurationMs(startTime) {
    if (!startTime || !supportsBrowserPerformanceNow()) return undefined;
    return Math.round(window.performance.now() - startTime);
}
class BrowserPerformanceClient extends (0, _browser.PerformanceClient) {
    constructor(configuration, intFields){
        super(configuration.auth.clientId, configuration.auth.authority || `${(0, _browser.Constants).DEFAULT_AUTHORITY}`, new (0, _browser.Logger)(configuration.system?.loggerOptions || {}, (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version)), (0, _packageMetadataMjs.name), (0, _packageMetadataMjs.version), configuration.telemetry?.application || {
            appName: "",
            appVersion: ""
        }, intFields);
    }
    generateId() {
        return (0, _browserCryptoMjs.createNewGuid)();
    }
    getPageVisibility() {
        return document.visibilityState?.toString() || null;
    }
    getOnlineStatus() {
        return typeof navigator !== "undefined" ? navigator.onLine : null;
    }
    deleteIncompleteSubMeasurements(inProgressEvent) {
        getPerfMeasurementModule()?.then((module)=>{
            const rootEvent = this.eventsByCorrelationId.get(inProgressEvent.event.correlationId);
            const isRootEvent = rootEvent && rootEvent.eventId === inProgressEvent.event.eventId;
            const incompleteMeasurements = [];
            if (isRootEvent && rootEvent?.incompleteSubMeasurements) rootEvent.incompleteSubMeasurements.forEach((subMeasurement)=>{
                incompleteMeasurements.push({
                    ...subMeasurement
                });
            });
            // Clean up remaining marks for incomplete sub-measurements
            module.BrowserPerformanceMeasurement.flushMeasurements(inProgressEvent.event.correlationId, incompleteMeasurements);
        });
    }
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     * Also captures browser page visibilityState.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {((event?: Partial<PerformanceEvent>) => PerformanceEvent| null)}
     */ startMeasurement(measureName, correlationId) {
        // Capture page visibilityState and then invoke start/end measurement
        const startPageVisibility = this.getPageVisibility();
        const startOnlineStatus = this.getOnlineStatus();
        const inProgressEvent = super.startMeasurement(measureName, correlationId);
        const startTime = supportsBrowserPerformanceNow() ? window.performance.now() : undefined;
        const browserMeasurement = getPerfMeasurementModule()?.then((module)=>{
            return new module.BrowserPerformanceMeasurement(measureName, inProgressEvent.event.correlationId);
        });
        browserMeasurement?.then((measurement)=>measurement.startMeasurement());
        return {
            ...inProgressEvent,
            end: (event, error, account)=>{
                const networkInfo = (0, _msalFrameStatsUtilsMjs.getNetworkInfo)();
                const res = inProgressEvent.end({
                    ...event,
                    startPageVisibility,
                    startOnlineStatus,
                    endPageVisibility: this.getPageVisibility(),
                    durationMs: getPerfDurationMs(startTime),
                    networkEffectiveType: networkInfo.effectiveType,
                    networkRtt: networkInfo.rtt
                }, error, account);
                browserMeasurement?.then((measurement)=>measurement.endMeasurement());
                this.deleteIncompleteSubMeasurements(inProgressEvent);
                return res;
            },
            discard: ()=>{
                inProgressEvent.discard();
                browserMeasurement?.then((measurement)=>measurement.flushMeasurement());
                this.deleteIncompleteSubMeasurements(inProgressEvent);
            }
        };
    }
}

},{"@azure/msal-common/browser":[["Constants","5eRZy","*"],["Logger","9bvcp"],["PerformanceClient","lIG2r"]],"../packageMetadata.mjs":"7kVpA","../utils/BrowserConstants.mjs":"5kHn0","../crypto/BrowserCrypto.mjs":"a5L0H","../cache/CacheKeys.mjs":"gsAy0","../utils/MsalFrameStatsUtils.mjs":"c8njp","d5d7ed9bdc4870ff":"lCJCD","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lIG2r":[function(require,module,exports,__globalThis) {
/*! @azure/msal-common v16.11.2 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PerformanceClient", ()=>PerformanceClient);
parcelHelpers.export(exports, "addError", ()=>addError);
parcelHelpers.export(exports, "compactStack", ()=>compactStack);
parcelHelpers.export(exports, "compactStackLine", ()=>compactStackLine);
parcelHelpers.export(exports, "endContext", ()=>endContext);
parcelHelpers.export(exports, "getAccountType", ()=>getAccountType);
parcelHelpers.export(exports, "startContext", ()=>startContext);
var _loggerMjs = require("../../logger/Logger.mjs");
var _performanceEventMjs = require("./PerformanceEvent.mjs");
var _authErrorMjs = require("../../error/AuthError.mjs");
var _cacheErrorMjs = require("../../error/CacheError.mjs");
var _serverErrorMjs = require("../../error/ServerError.mjs");
var _interactionRequiredAuthErrorMjs = require("../../error/InteractionRequiredAuthError.mjs");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Starts context by adding payload to the stack
 * @param event {PerformanceEvent}
 * @param stack {?PerformanceEventStackedContext[]} stack
 */ function startContext(event, stack) {
    if (!stack) return;
    stack.push({
        name: event.name
    });
}
/**
 * Ends context by removing payload from the stack and returning parent or self, if stack is empty, payload
 *
 * @param event {PerformanceEvent}
 * @param stack {?PerformanceEventStackedContext[]} stack
 * @param error {?unknown} error
 */ function endContext(event, stack, error) {
    if (!stack?.length) return;
    const peek = (stack)=>{
        return stack.length ? stack[stack.length - 1] : undefined;
    };
    const abbrEventName = event.name;
    const top = peek(stack);
    if (top?.name !== abbrEventName) return;
    const current = stack?.pop();
    if (!current) return;
    const errorCode = error instanceof (0, _authErrorMjs.AuthError) ? error.errorCode : error instanceof Error ? error.name : undefined;
    const subErr = error instanceof (0, _authErrorMjs.AuthError) ? error.subError : undefined;
    if (errorCode && current.childErr !== errorCode) {
        current.err = errorCode;
        if (subErr) current.subErr = subErr;
    }
    delete current.name;
    delete current.childErr;
    const context = {
        ...current,
        dur: event.durationMs
    };
    if (!event.success) context.fail = 1;
    const parent = peek(stack);
    if (!parent) return {
        [abbrEventName]: context
    };
    if (errorCode) parent.childErr = errorCode;
    let childName;
    if (!parent[abbrEventName]) childName = abbrEventName;
    else {
        const siblings = Object.keys(parent).filter((key)=>key.startsWith(abbrEventName)).length;
        childName = `${abbrEventName}_${siblings + 1}`;
    }
    parent[childName] = context;
    return parent;
}
/**
 * Adds error name and stack trace to the telemetry event
 * @param error {Error}
 * @param logger {Logger}
 * @param event {PerformanceEvent}
 * @param stackMaxSize {number} max error stack size to capture
 */ function addError(error, logger, event, stackMaxSize = 5) {
    if (!(error instanceof Error)) {
        logger.trace("0gcyox", event.correlationId);
        return;
    } else if (error instanceof (0, _authErrorMjs.AuthError)) {
        event.errorCode = error.errorCode;
        event.subErrorCode = error.subError;
        if (!event.serverErrorNo && (error instanceof (0, _serverErrorMjs.ServerError) || error instanceof (0, _interactionRequiredAuthErrorMjs.InteractionRequiredAuthError)) && error.errorNo) event.serverErrorNo = error.errorNo;
        return;
    } else if (error instanceof (0, _cacheErrorMjs.CacheError)) {
        event.errorCode = error.errorCode;
        return;
    } else if (event.errorStack?.length) {
        logger.trace("0lmqrh", event.correlationId);
        return;
    } else if (!error.stack?.length) {
        logger.trace("1cnpwa", event.correlationId);
        return;
    }
    if (error.stack) event.errorStack = compactStack(error.stack, stackMaxSize);
    event.errorName = error.name;
}
/**
 * Compacts error stack into array by fetching N first entries
 * @param stack {string} error stack
 * @param stackMaxSize {number} max error stack size to capture
 * @returns {string[]}
 */ function compactStack(stack, stackMaxSize) {
    if (stackMaxSize < 0) return [];
    const stackArr = stack.split("\n") || [];
    const res = [];
    // Check for a handful of known, common runtime errors and log them (with redaction where applicable).
    const firstLine = stackArr[0];
    if (firstLine.startsWith("TypeError: Cannot read property") || firstLine.startsWith("TypeError: Cannot read properties of") || firstLine.startsWith("TypeError: Cannot set property") || firstLine.startsWith("TypeError: Cannot set properties of") || firstLine.endsWith("is not a function")) // These types of errors are not at risk of leaking PII. They will indicate unavailable APIs
    res.push(compactStackLine(firstLine));
    else if (firstLine.startsWith("SyntaxError") || firstLine.startsWith("TypeError")) // Prevent unintentional leaking of arbitrary info by redacting contents between both single and double quotes
    res.push(compactStackLine(// Example: SyntaxError: Unexpected token 'e', "test" is not valid JSON -> SyntaxError: Unexpected token <redacted>, <redacted> is not valid JSON
    firstLine.replace(/['].*[']|["].*["]/g, "<redacted>")));
    // Get top N stack lines
    for(let ix = 1; ix < stackArr.length; ix++){
        if (res.length >= stackMaxSize) break;
        const line = stackArr[ix];
        res.push(compactStackLine(line));
    }
    return res;
}
/**
 * Compacts error stack line by shortening file path
 * Example: https://localhost/msal-common/src/authority/Authority.js:100:1 -> Authority.js:100:1
 * @param line {string} stack line
 * @returns {string}
 */ function compactStackLine(line) {
    const filePathIx = line.lastIndexOf(" ") + 1;
    if (filePathIx < 1) return line;
    const filePath = line.substring(filePathIx);
    let fileNameIx = filePath.lastIndexOf("/");
    fileNameIx = fileNameIx < 0 ? filePath.lastIndexOf("\\") : fileNameIx;
    if (fileNameIx >= 0) return (line.substring(0, filePathIx) + "(" + filePath.substring(fileNameIx + 1) + (filePath.charAt(filePath.length - 1) === ")" ? "" : ")")).trimStart();
    return line.trimStart();
}
function getAccountType(account) {
    const idTokenClaims = account?.idTokenClaims;
    if (idTokenClaims?.tfp || idTokenClaims?.acr) return "B2C";
    if (!idTokenClaims?.tid) return undefined;
    else if (idTokenClaims?.tid === "9188040d-6c67-4c5b-b112-36a304b66dad") return "MSA";
    return "AAD";
}
class PerformanceClient {
    /**
     * Creates an instance of PerformanceClient,
     * an abstract class containing core performance telemetry logic.
     *
     * @constructor
     * @param {string} clientId Client ID of the application
     * @param {string} authority Authority used by the application
     * @param {Logger} logger Logger used by the application
     * @param {string} libraryName Name of the library
     * @param {string} libraryVersion Version of the library
     * @param {ApplicationTelemetry} applicationTelemetry application name and version
     * @param {Set<String>} intFields integer fields to be truncated
     */ constructor(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry, intFields){
        this.authority = authority;
        this.libraryName = libraryName;
        this.libraryVersion = libraryVersion;
        this.globalFields = {};
        this.applicationTelemetry = applicationTelemetry;
        this.clientId = clientId;
        this.logger = logger;
        this.callbacks = new Map();
        this.eventsByCorrelationId = new Map();
        this.eventStack = new Map();
        this.intFields = intFields || new Set();
        for (const item of (0, _performanceEventMjs.IntFields))this.intFields.add(item);
    }
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {InProgressPerformanceEvent}
     */ startMeasurement(measureName, correlationId) {
        // Generate a placeholder correlation if the request does not provide one
        const eventCorrelationId = correlationId || this.generateId();
        const inProgressEvent = {
            eventId: this.generateId(),
            status: (0, _performanceEventMjs.PerformanceEventStatus).InProgress,
            authority: this.authority,
            libraryName: this.libraryName,
            libraryVersion: this.libraryVersion,
            clientId: this.clientId,
            name: measureName,
            startTimeMs: Date.now(),
            correlationId: eventCorrelationId,
            appName: this.applicationTelemetry?.appName,
            appVersion: this.applicationTelemetry?.appVersion
        };
        // Store in progress events so they can be discarded if not ended properly
        this.cacheEventByCorrelationId(inProgressEvent);
        startContext(inProgressEvent, this.eventStack.get(eventCorrelationId));
        // Return the event and functions the caller can use to properly end/flush the measurement
        return {
            end: (event, error, account)=>{
                return this.endMeasurement({
                    // Initial set of event properties
                    ...inProgressEvent,
                    // Properties set when event ends
                    ...event
                }, error, account);
            },
            discard: ()=>{
                return this.discardMeasurements(inProgressEvent.correlationId);
            },
            add: (fields)=>{
                return this.addFields(fields, inProgressEvent.correlationId);
            },
            increment: (fields)=>{
                return this.incrementFields(fields, inProgressEvent.correlationId);
            },
            event: inProgressEvent
        };
    }
    /**
     * Stops measuring the performance for an operation. Should only be called directly by PerformanceClient classes,
     * as consumers should instead use the function returned by startMeasurement.
     * Adds a new field named as "[event name]DurationMs" for sub-measurements, completes and emits an event
     * otherwise.
     *
     * @param {PerformanceEvent} event
     * @param {unknown} error
     * @param {AccountInfo?} account
     * @returns {(PerformanceEvent | null)}
     */ endMeasurement(event, error, account) {
        const rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (!rootEvent) {
            this.logger.trace(`0k9ti8 ${event.eventId}`, event.correlationId);
            return null;
        }
        const isRoot = event.eventId === rootEvent.eventId;
        event.durationMs = Math.round(event.durationMs || this.getDurationMs(event.startTimeMs));
        const context = JSON.stringify(endContext(event, this.eventStack.get(rootEvent.correlationId), error));
        if (isRoot) this.discardMeasurements(rootEvent.correlationId);
        else rootEvent.incompleteSubMeasurements?.delete(event.eventId);
        if (error) addError(error, this.logger, rootEvent);
        // Add sub-measurement attribute to root event's ext field.
        if (!isRoot) {
            rootEvent.ext = {
                ...rootEvent.ext,
                ...event.ext
            };
            rootEvent.ext[event.name + "DurationMs"] = Math.floor(event.durationMs);
            return {
                ...rootEvent
            };
        }
        if (isRoot && !error && (rootEvent.errorCode || rootEvent.subErrorCode)) {
            this.logger.trace(`1fm1tm ${event.name}`, event.correlationId);
            rootEvent.errorCode = undefined;
            rootEvent.subErrorCode = undefined;
        }
        let finalEvent = {
            ...rootEvent,
            ...event
        };
        let incompleteSubsCount = 0;
        // Incomplete sub-measurements are discarded. They are likely an instrumentation bug that should be fixed.
        finalEvent.incompleteSubMeasurements?.forEach((subMeasurement)=>{
            this.logger.trace(`0nxk52 ${subMeasurement.name} ${event.name}`, finalEvent.correlationId);
            incompleteSubsCount++;
        });
        finalEvent.incompleteSubMeasurements = undefined;
        const logs = (0, _loggerMjs.getAndFlushLogsFromCache)(event.correlationId);
        // Format logs: [millis1,hash1;millis2,hash2;...]
        const formattedLogs = logs.map((logMessage)=>`${logMessage.milliseconds},${logMessage.hash}`).join(";");
        finalEvent = {
            ...finalEvent,
            status: (0, _performanceEventMjs.PerformanceEventStatus).Completed,
            incompleteSubsCount,
            context,
            logs: formattedLogs,
            /*
             * Global fields are spread last so they are always present on the
             * emitted event and never overridden, even when registered after
             * the measurement started.
             */ ...this.globalFields
        };
        if (account) {
            finalEvent.accountType = getAccountType(account);
            finalEvent.dataBoundary = account.dataBoundary;
        }
        this.truncateIntegralFields(finalEvent);
        this.emitEvents([
            finalEvent
        ], event.correlationId);
        return finalEvent;
    }
    /**
     * Saves extra information to be emitted when the measurements are flushed
     * @param fields
     * @param correlationId
     */ addFields(fields, correlationId) {
        const event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            const staticFields = {};
            const dynamicFields = {};
            for(const key in fields)if (key.startsWith((0, _performanceEventMjs.EXT_FIELD_PREFIX))) {
                const dynamicKey = key.slice((0, _performanceEventMjs.EXT_FIELD_PREFIX).length);
                const value = fields[key];
                if (typeof value === "string" || typeof value === "number") dynamicFields[dynamicKey] = value;
            } else staticFields[key] = fields[key];
            const updatedEvent = {
                ...event,
                ...staticFields
            };
            if (Object.keys(dynamicFields).length) updatedEvent.ext = {
                ...updatedEvent.ext,
                ...dynamicFields
            };
            this.eventsByCorrelationId.set(correlationId, updatedEvent);
        } else this.logger.trace("0thl6s", correlationId);
    }
    /**
     * Saves fields to be emitted on every event measured by this client.
     * Unlike addFields, these are not scoped to a single correlationId and persist for the
     * lifetime of the client (e.g. previousLibraryVersion for upgrade/downgrade telemetry).
     * @param fields
     */ addGlobalFields(fields) {
        this.globalFields = {
            ...this.globalFields,
            ...fields
        };
    }
    /**
     * Increment counters to be emitted when the measurements are flushed
     * @param fields {string[]}
     * @param correlationId {string} correlation identifier
     */ incrementFields(fields, correlationId) {
        const event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            for(const counter in fields)if (counter.startsWith((0, _performanceEventMjs.EXT_FIELD_PREFIX))) {
                event.ext = event.ext || {};
                // Route to ext sub-object
                const dynamicKey = counter.slice((0, _performanceEventMjs.EXT_FIELD_PREFIX).length);
                const currentValue = event.ext[dynamicKey];
                if (currentValue === undefined) event.ext[dynamicKey] = 0;
                else if (isNaN(Number(currentValue))) return;
                event.ext[dynamicKey] = (Number(event.ext[dynamicKey]) || 0) + (fields[counter] ?? 0);
            } else {
                /* eslint-disable custom-msal/no-dynamic-telemetry-fields -- internal dispatching of static fields by name */ if (!event.hasOwnProperty(counter)) event[counter] = 0;
                else if (isNaN(Number(event[counter]))) return;
                event[counter] += fields[counter];
            /* eslint-enable custom-msal/no-dynamic-telemetry-fields */ }
        } else this.logger.trace("0thl6s", correlationId);
    }
    /**
     * Upserts event into event cache.
     * First key is the correlation id, second key is the event id.
     * Allows for events to be grouped by correlation id,
     * and to easily allow for properties on them to be updated.
     *
     * @private
     * @param {PerformanceEvent} event
     */ cacheEventByCorrelationId(event) {
        const rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (rootEvent) {
            rootEvent.incompleteSubMeasurements = rootEvent.incompleteSubMeasurements || new Map();
            rootEvent.incompleteSubMeasurements.set(event.eventId, {
                name: event.name,
                startTimeMs: event.startTimeMs
            });
        } else {
            this.eventsByCorrelationId.set(event.correlationId, {
                ...event
            });
            this.eventStack.set(event.correlationId, []);
        }
    }
    /**
     * Removes measurements and aux data for a given correlation id.
     *
     * @param {string} correlationId
     */ discardMeasurements(correlationId) {
        this.eventsByCorrelationId.delete(correlationId);
        this.eventStack.delete(correlationId);
    }
    /**
     * Registers a callback function to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        for (const [id, cb] of this.callbacks)if (cb.toString() === callback.toString()) {
            this.logger.warning(`1eap5p ${id}`, "");
            return id;
        }
        const callbackId = this.generateId();
        this.callbacks.set(callbackId, callback);
        this.logger.verbose(`0c9ujz ${callbackId}`, "");
        return callbackId;
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        const result = this.callbacks.delete(callbackId);
        if (result) this.logger.verbose(`0253if ${callbackId}`, "");
        else this.logger.verbose(`0iqk07 ${callbackId}`, "");
        return result;
    }
    /**
     * Emits events to all registered callbacks.
     *
     * @param {PerformanceEvent[]} events
     * @param {?string} [correlationId]
     */ emitEvents(events, correlationId) {
        this.logger.verbose("11jb1y", correlationId);
        this.callbacks.forEach((callback, callbackId)=>{
            this.logger.trace(`0p2pjl ${callbackId}`, correlationId);
            callback.apply(null, [
                events
            ]);
        });
    }
    /**
     * Enforce truncation of integral fields in performance event.
     * @param {PerformanceEvent} event performance event to update.
     */ truncateIntegralFields(event) {
        this.intFields.forEach((key)=>{
            /* eslint-disable custom-msal/no-dynamic-telemetry-fields -- internal truncation of known integer fields */ if (key in event && typeof event[key] === "number") event[key] = Math.floor(event[key]);
        /* eslint-enable custom-msal/no-dynamic-telemetry-fields */ });
    }
    /**
     * Returns event duration in milliseconds
     * @param startTimeMs {number}
     * @returns {number}
     */ getDurationMs(startTimeMs) {
        const durationMs = Date.now() - startTimeMs;
        // Handle clock skew
        return durationMs < 0 ? durationMs : 0;
    }
}

},{"../../logger/Logger.mjs":"9bvcp","./PerformanceEvent.mjs":"1zWJT","../../error/AuthError.mjs":"8TWYe","../../error/CacheError.mjs":"bGBk6","../../error/ServerError.mjs":"dvxy4","../../error/InteractionRequiredAuthError.mjs":"jiVlC","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lCJCD":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("9orQb"));

},{}],"9orQb":[function(require,module,exports,__globalThis) {
/*! @azure/msal-browser v5.17.1 2026-07-15 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserPerformanceMeasurement", ()=>BrowserPerformanceMeasurement);
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class BrowserPerformanceMeasurement {
    constructor(name, correlationId){
        this.correlationId = correlationId;
        this.measureName = BrowserPerformanceMeasurement.makeMeasureName(name, correlationId);
        this.startMark = BrowserPerformanceMeasurement.makeStartMark(name, correlationId);
        this.endMark = BrowserPerformanceMeasurement.makeEndMark(name, correlationId);
    }
    static makeMeasureName(name, correlationId) {
        return `msal.measure.${name}.${correlationId}`;
    }
    static makeStartMark(name, correlationId) {
        return `msal.start.${name}.${correlationId}`;
    }
    static makeEndMark(name, correlationId) {
        return `msal.end.${name}.${correlationId}`;
    }
    static supportsBrowserPerformance() {
        return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.mark === "function" && typeof window.performance.measure === "function" && typeof window.performance.clearMarks === "function" && typeof window.performance.clearMeasures === "function" && typeof window.performance.getEntriesByName === "function";
    }
    /**
     * Flush browser marks and measurements.
     * @param {string} correlationId
     * @param {SubMeasurement} measurements
     */ static flushMeasurements(correlationId, measurements) {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            measurements.forEach((measurement)=>{
                const measureName = BrowserPerformanceMeasurement.makeMeasureName(measurement.name, correlationId);
                const entriesForMeasurement = window.performance.getEntriesByName(measureName, "measure");
                if (entriesForMeasurement.length > 0) {
                    window.performance.clearMeasures(measureName);
                    window.performance.clearMarks(BrowserPerformanceMeasurement.makeStartMark(measureName, correlationId));
                    window.performance.clearMarks(BrowserPerformanceMeasurement.makeEndMark(measureName, correlationId));
                }
            });
        } catch (e) {
        // Silently catch and return null
        }
    }
    startMeasurement() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.startMark);
        } catch (e) {
        // Silently catch
        }
    }
    endMeasurement() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.endMark);
            window.performance.measure(this.measureName, this.startMark, this.endMark);
        } catch (e) {
        // Silently catch
        }
    }
    flushMeasurement() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            const entriesForMeasurement = window.performance.getEntriesByName(this.measureName, "measure");
            if (entriesForMeasurement.length > 0) {
                const durationMs = entriesForMeasurement[0].duration;
                window.performance.clearMeasures(this.measureName);
                window.performance.clearMarks(this.startMark);
                window.performance.clearMarks(this.endMark);
                return durationMs;
            }
        } catch (e) {
        // Silently catch and return null
        }
        return null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hTW2R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMsalObjPromise", ()=>getMsalObjPromise);
var _msalBrowser = require("@azure/msal-browser");
const config = {
    msal: {
        auth: {
            clientId: "018227ee-f84f-43f9-9382-a38ac8146659",
            authority: "https://login.microsoftonline.com/374f8026-7b54-4a3a-b87d-328fa26ec10d/oauth2/authorize",
            knownAuthorities: [
                "374f8026-7b54-4a3a-b87d-328fa26ec10d.b2clogin.com"
            ],
            redirectUri: window.location.hostname === "localhost" ? window.location.origin + "/index.html" : window.location.href.replace(window.location.search, "")
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false
        }
    }
};
let msalObj = undefined;
async function getMsalObjPromise() {
    if (msalObj === undefined) msalObj = new _msalBrowser.PublicClientApplication(config.msal);
    await msalObj.initialize();
    await msalObj.handleRedirectPromise();
    return msalObj;
}

},{"@azure/msal-browser":"kSeZg","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iVSSP":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Feature
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert the provided object into a feature style function.  Functions passed
 * through unchanged.  Arrays of Style or single style objects wrapped
 * in a new feature style function.
 * @param {!import("./style/Style.js").StyleFunction|!Array<import("./style/Style.js").default>|!import("./style/Style.js").default} obj
 *     A feature style function, a single style, or an array of styles.
 * @return {import("./style/Style.js").StyleFunction} A style function.
 */ parcelHelpers.export(exports, "createStyleFunction", ()=>createStyleFunction);
var _objectJs = require("./Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _assertsJs = require("./asserts.js");
var _eventsJs = require("./events.js");
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable.js").OnSignature<import("./ObjectEventType.js").Types|'change:geometry', import("./Object.js").ObjectEvent, Return> &
 *   import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|import("./ObjectEventType.js").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Properties & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties>>}
 */ class Feature extends (0, _objectJsDefault.default) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry, NoInfer<Properties>>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = 'geometry';
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === 'function') {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {?} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new Feature();
        const geometryName = this.geometryName_;
        clone.setGeometryName(geometryName);
        const properties = this.getPropertiesInternal();
        if (properties) {
            const geometry = this.getGeometry();
            for(const key in properties)if (key === geometryName && geometry) clone.set(key, geometry.clone());
            else clone.set(key, properties[key], true);
        }
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, _eventsJs.unlistenByKey)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, _eventsJs.listen)(geometry, (0, _eventTypeJsDefault.default).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : createStyleFunction(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        if (name === this.geometryName_) return;
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function createStyleFunction(obj) {
    if (typeof obj === 'function') return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, _assertsJs.assert)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `ol/style/Style` or an array of `ol/style/Style.js`');
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
exports.default = Feature;

},{"./Object.js":"lFhbz","./asserts.js":"csqTx","./events.js":"Vqr1Z","./events/EventType.js":"79Bvl","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7ga2c":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Vector
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vectorLayerJs = require("../renderer/canvas/VectorLayer.js");
var _vectorLayerJsDefault = parcelHelpers.interopDefault(_vectorLayerJs);
var _baseVectorJs = require("./BaseVector.js");
var _baseVectorJsDefault = parcelHelpers.interopDefault(_baseVectorJs);
/**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class VectorLayer extends (0, _baseVectorJsDefault.default) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, _vectorLayerJsDefault.default)(this);
    }
}
exports.default = VectorLayer;

},{"../renderer/canvas/VectorLayer.js":"40P2x","./BaseVector.js":"1iN2T","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"40P2x":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/canvas/VectorLayer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewHintJs = require("../../ViewHint.js");
var _viewHintJsDefault = parcelHelpers.interopDefault(_viewHintJs);
var _arrayJs = require("../../array.js");
var _coordinateJs = require("../../coordinate.js");
var _domJs = require("../../dom.js");
var _extentJs = require("../../extent.js");
var _projJs = require("../../proj.js");
var _eventTypeJs = require("../../render/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _builderGroupJs = require("../../render/canvas/BuilderGroup.js");
var _builderGroupJsDefault = parcelHelpers.interopDefault(_builderGroupJs);
var _executorGroupJs = require("../../render/canvas/ExecutorGroup.js");
var _executorGroupJsDefault = parcelHelpers.interopDefault(_executorGroupJs);
var _hitdetectJs = require("../../render/canvas/hitdetect.js");
var _utilJs = require("../../util.js");
var _vectorJs = require("../vector.js");
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class CanvasVectorLayerRenderer extends (0, _layerJsDefault.default) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.clipExtent_ = null;
        /**
     * Do we need to extend the rendered area on the x-axis to handle
     * features that cross the antimeridian?
     * @private
     * @type {boolean}
     */ this.extendX_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, _extentJs.createEmpty)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, _extentJs.createEmpty)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection.js").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {import("../../render.js").OrderFunction|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup.js").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, _viewHintJsDefault.default).ANIMATING] || viewHints[(0, _viewHintJsDefault.default).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, _extentJs.getWidth)(extent) / resolution * pixelRatio);
        const height = Math.round((0, _extentJs.getHeight)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, _extentJs.getWidth)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + (this.extendX_ ? 2 : 1) : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) - (this.extendX_ ? 1 : 0) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, _executorGroupJs.ALL) : declutterable ? (0, _executorGroupJs.DECLUTTER) : (0, _executorGroupJs.NON_DECLUTTER), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, _domJs.createCanvasContext2D)(this.context.canvas.width, this.context.canvas.height, (0, _layerJs.canvasPool));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1 && this.targetContext_) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, _domJs.releaseCanvas)(this.context);
            (0, _layerJs.canvasPool).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        if (this.clipExtent_) this.clipUnrotated(this.context, frameState, this.clipExtent_);
        this.replayGroup_.renderDeferred();
        if (this.clipExtent_) {
            this.context.restore();
            this.clipExtent_ = null;
        }
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, _eventTypeJsDefault.default).PRERENDER) || this.getLayer().hasListener((0, _eventTypeJsDefault.default).POSTRENDER);
            if (!hasRenderListeners) return this.container;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipExtent_ = null;
        let clipped = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, _projJs.fromUserExtent)(layerState.extent, projection);
            render = (0, _extentJs.intersects)(layerExtent, frameState.extent);
            const needsClip = render && !(0, _extentJs.containsExtent)(layerExtent, frameState.extent);
            if (needsClip) {
                if (frameState.declutter) // Store extent for deferred clipping
                this.clipExtent_ = layerExtent;
                else {
                    // Apply clipping immediately for non-declutter rendering
                    this.clipUnrotated(context, frameState, layerExtent);
                    clipped = true;
                }
            }
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (clipped) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature.js").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, _hitdetectJs.HIT_DETECT_RESOLUTION);
                const height = size[1] * (0, _hitdetectJs.HIT_DETECT_RESOLUTION);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, _hitdetectJs.HIT_DETECT_RESOLUTION), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, _extentJs.containsExtent)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, _extentJs.getWidth)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, _hitdetectJs.HIT_DETECT_RESOLUTION), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, _hitdetectJs.HIT_DETECT_RESOLUTION), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, _projJs.getUserProjection)();
                this.hitDetectionImageData_ = (0, _hitdetectJs.createHitDetectionImageData)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, _vectorJs.getSquaredTolerance)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, _hitdetectJs.hitDetect)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, _utilJs.getUid)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const declutter = this.getLayer().getDeclutter();
        return this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null);
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, _viewHintJsDefault.default).ANIMATING];
        const interacting = frameState.viewHints[(0, _viewHintJsDefault.default).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, _vectorJs.defaultOrder);
        const center = viewState.center.slice();
        const extent = (0, _extentJs.buffer)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        const canWrapX = vectorSource.getWrapX() && projection.canWrapX();
        this.extendX_ = false;
        if (canWrapX) {
            const sourceExtent = vectorSource.getExtent();
            if (sourceExtent && !(0, _extentJs.isEmpty)(sourceExtent)) this.extendX_ = sourceExtent[0] < projectionExtent[0] || sourceExtent[2] > projectionExtent[2];
        }
        if (canWrapX && (!(0, _extentJs.containsExtent)(projectionExtent, frameState.extent) || this.extendX_)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, _extentJs.getWidth)(projectionExtent);
            const gutter = Math.max((0, _extentJs.getWidth)(extent) / 2, worldWidth);
            let projMinX = projectionExtent[0];
            let projMaxX = projectionExtent[2];
            if (this.extendX_) {
                projMinX -= worldWidth;
                projMaxX += worldWidth;
            }
            extent[0] = projMinX - gutter;
            extent[2] = projMaxX + gutter;
            (0, _coordinateJs.wrapX)(center, projection);
            const loadExtent = (0, _extentJs.wrapX)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedPixelRatio_ === pixelRatio && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, _extentJs.containsExtent)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, _arrayJs.equals)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, _builderGroupJsDefault.default)((0, _vectorJs.getTolerance)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, _projJs.getUserProjection)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, _projJs.toUserExtent)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, _projJs.toUserResolution)(resolution, projection), userProjection);
            }
            userTransform = (0, _projJs.getTransformFromProjections)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, _vectorJs.getSquaredTolerance)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, _projJs.toUserExtent)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, _executorGroupJsDefault.default)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, _vectorJs.renderFeature)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, _vectorJs.renderFeature)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
exports.default = CanvasVectorLayerRenderer;

},{"../../ViewHint.js":"fb2qR","../../array.js":"2IuG2","../../coordinate.js":"9bcSP","../../dom.js":"gfuif","../../extent.js":"MPjK5","../../proj.js":"gN0IK","../../render/EventType.js":"5YHp5","../../render/canvas/BuilderGroup.js":"cbeVL","../../render/canvas/ExecutorGroup.js":"7KLwV","../../render/canvas/hitdetect.js":"e6viX","../../util.js":"9Y20j","../vector.js":"fFxjb","./Layer.js":"h3JnK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cbeVL":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/BuilderGroup
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _builderJs = require("./Builder.js");
var _builderJsDefault = parcelHelpers.interopDefault(_builderJs);
var _imageBuilderJs = require("./ImageBuilder.js");
var _imageBuilderJsDefault = parcelHelpers.interopDefault(_imageBuilderJs);
var _lineStringBuilderJs = require("./LineStringBuilder.js");
var _lineStringBuilderJsDefault = parcelHelpers.interopDefault(_lineStringBuilderJs);
var _polygonBuilderJs = require("./PolygonBuilder.js");
var _polygonBuilderJsDefault = parcelHelpers.interopDefault(_polygonBuilderJs);
var _textBuilderJs = require("./TextBuilder.js");
var _textBuilderJsDefault = parcelHelpers.interopDefault(_textBuilderJs);
/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const BATCH_CONSTRUCTORS = {
    'Circle': (0, _polygonBuilderJsDefault.default),
    'Default': (0, _builderJsDefault.default),
    'Image': (0, _imageBuilderJsDefault.default),
    'LineString': (0, _lineStringBuilderJsDefault.default),
    'Polygon': (0, _polygonBuilderJsDefault.default),
    'Text': (0, _textBuilderJsDefault.default)
};
class BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
exports.default = BuilderGroup;

},{"./Builder.js":"grCUR","./ImageBuilder.js":"5TK9n","./LineStringBuilder.js":"eUXbz","./PolygonBuilder.js":"dLRro","./TextBuilder.js":"2nZk3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"grCUR":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/Builder
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../../array.js");
var _colorlikeJs = require("../../colorlike.js");
var _extentJs = require("../../extent.js");
var _relationshipJs = require("../../extent/Relationship.js");
var _relationshipJsDefault = parcelHelpers.interopDefault(_relationshipJs);
var _inflateJs = require("../../geom/flat/inflate.js");
var _vectorContextJs = require("../VectorContext.js");
var _vectorContextJsDefault = parcelHelpers.interopDefault(_vectorContextJs);
var _canvasJs = require("../canvas.js");
var _instructionJs = require("./Instruction.js");
var _instructionJsDefault = parcelHelpers.interopDefault(_instructionJs);
class CanvasBuilder extends (0, _vectorContextJsDefault.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, _extentJs.containsCoordinate)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, _extentJs.coordinateRelationship)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, _relationshipJsDefault.default).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, _inflateJs.inflateMultiCoordinatesArray),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, _inflateJs.inflateMultiCoordinatesArray),
                    index
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, _inflateJs.inflateCoordinatesArray),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, _inflateJs.inflateCoordinatesArray),
                    index
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, _inflateJs.inflateCoordinates),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, _inflateJs.inflateCoordinates),
                    index
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, _instructionJsDefault.default).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, _inflateJs.inflateCoordinates),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, _instructionJsDefault.default).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, _inflateJs.inflateCoordinates),
                        index
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, _instructionJsDefault.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, _instructionJsDefault.default).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, _instructionJsDefault.default).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, _instructionJsDefault.default).END_GEOMETRY) begin = i;
            else if (type == (0, _instructionJsDefault.default).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, _arrayJs.reverseSubArray)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import('../canvas.js').FillStrokeState} [state] State.
   * @return {import('../canvas.js').FillStrokeState} State.
   */ fillStyleToState(fillStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === 'object' && 'src' in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, _colorlikeJs.asColorLike)(fillStyleColor ? fillStyleColor : (0, _canvasJs.defaultFillStyle)) ?? undefined;
        } else state.fillStyle = undefined;
        return state;
    }
    /**
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {import("../canvas.js").FillStrokeState} State.
   */ strokeStyleToState(strokeStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, _colorlikeJs.asColorLike)(strokeStyleColor ? strokeStyleColor : (0, _canvasJs.defaultStrokeStyle));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, _canvasJs.defaultLineCap);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, _canvasJs.defaultLineDash);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, _canvasJs.defaultLineDashOffset);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, _canvasJs.defaultLineJoin);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, _canvasJs.defaultLineWidth);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, _canvasJs.defaultMiterLimit);
            const strokeStyleOffset = strokeStyle.getOffset();
            state.strokeOffset = strokeStyleOffset ?? (0, _canvasJs.defaultStrokeOffset);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
            state.strokeOffset = undefined;
        }
        return state;
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        this.fillStyleToState(fillStyle, state);
        this.strokeStyleToState(strokeStyle, state);
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, _instructionJsDefault.default).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, _instructionJsDefault.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash ? this.applyPixelRatio(state.lineDash) : null,
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (fillStyle !== undefined && typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        const strokeOffset = state.strokeOffset;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, _arrayJs.equals)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit || state.currentStrokeOffset != strokeOffset) {
            applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
            state.currentStrokeOffset = strokeOffset;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, _instructionJsDefault.default).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, _extentJs.clone)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, _extentJs.buffer)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
exports.default = CanvasBuilder;

},{"../../array.js":"2IuG2","../../colorlike.js":"8r5Mb","../../extent.js":"MPjK5","../../extent/Relationship.js":"e46UI","../../geom/flat/inflate.js":"ainGz","../VectorContext.js":"izlth","../canvas.js":"8UJXP","./Instruction.js":"kbDHR","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"izlth":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
exports.default = VectorContext;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kbDHR":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillInstruction", ()=>fillInstruction);
parcelHelpers.export(exports, "strokeInstruction", ()=>strokeInstruction);
parcelHelpers.export(exports, "beginPathInstruction", ()=>beginPathInstruction);
parcelHelpers.export(exports, "closePathInstruction", ()=>closePathInstruction);
const Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const fillInstruction = [
    Instruction.FILL
];
const strokeInstruction = [
    Instruction.STROKE
];
const beginPathInstruction = [
    Instruction.BEGIN_PATH
];
const closePathInstruction = [
    Instruction.CLOSE_PATH
];
exports.default = Instruction;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5TK9n":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/ImageBuilder
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extentJs = require("../../extent.js");
var _builderJs = require("./Builder.js");
var _builderJsDefault = parcelHelpers.interopDefault(_builderJs);
var _instructionJs = require("./Instruction.js");
var _instructionJsDefault = parcelHelpers.interopDefault(_instructionJs);
class CanvasImageBuilder extends (0, _builderJsDefault.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, _extentJs.containsCoordinate)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, _instructionJsDefault.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, _extentJs.containsCoordinate)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, _instructionJsDefault.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
exports.default = CanvasImageBuilder;

},{"../../extent.js":"MPjK5","./Builder.js":"grCUR","./Instruction.js":"kbDHR","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eUXbz":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/LineStringBuilder
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canvasJs = require("../canvas.js");
var _builderJs = require("./Builder.js");
var _builderJsDefault = parcelHelpers.interopDefault(_builderJs);
var _instructionJs = require("./Instruction.js");
var _instructionJsDefault = parcelHelpers.interopDefault(_instructionJs);
class CanvasLineStringBuilder extends (0, _builderJsDefault.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride, strokeOffset) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        this.instructions.push([
            (0, _instructionJsDefault.default).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset * this.pixelRatio
        ]);
        this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset
        ]);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_STROKE_STYLE,
            (0, _canvasJs.defaultStrokeStyle),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, _canvasJs.defaultLineDash),
            (0, _canvasJs.defaultLineDashOffset)
        ], (0, _instructionJs.beginPathInstruction));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride, strokeOffset);
        this.hitDetectionInstructions.push((0, _instructionJs.strokeInstruction));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_STROKE_STYLE,
            (0, _canvasJs.defaultStrokeStyle),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, _canvasJs.defaultLineDash),
            (0, _canvasJs.defaultLineDashOffset)
        ], (0, _instructionJs.beginPathInstruction));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride, strokeOffset);
        this.hitDetectionInstructions.push((0, _instructionJs.strokeInstruction));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, _instructionJs.strokeInstruction));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, _instructionJs.strokeInstruction));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, _instructionJs.beginPathInstruction));
    }
}
exports.default = CanvasLineStringBuilder;

},{"../canvas.js":"8UJXP","./Builder.js":"grCUR","./Instruction.js":"kbDHR","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dLRro":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/PolygonBuilder
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _simplifyJs = require("../../geom/flat/simplify.js");
var _canvasJs = require("../canvas.js");
var _builderJs = require("./Builder.js");
var _builderJsDefault = parcelHelpers.interopDefault(_builderJs);
var _instructionJs = require("./Instruction.js");
var _instructionJsDefault = parcelHelpers.interopDefault(_instructionJs);
class CanvasPolygonBuilder extends (0, _builderJsDefault.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride, strokeOffset) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, _instructionJs.beginPathInstruction));
        this.hitDetectionInstructions.push((0, _instructionJs.beginPathInstruction));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            this.instructions.push([
                (0, _instructionJsDefault.default).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset * this.pixelRatio,
                true
            ]);
            this.hitDetectionInstructions.push([
                (0, _instructionJsDefault.default).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset,
                true
            ]);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, _instructionJs.closePathInstruction));
                this.hitDetectionInstructions.push((0, _instructionJs.closePathInstruction));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, _instructionJs.fillInstruction));
            this.hitDetectionInstructions.push((0, _instructionJs.fillInstruction));
        }
        if (stroke) {
            this.instructions.push((0, _instructionJs.strokeInstruction));
            this.hitDetectionInstructions.push((0, _instructionJs.strokeInstruction));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawCircle(circleGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_FILL_STYLE,
            (0, _canvasJs.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_STROKE_STYLE,
            (0, _canvasJs.defaultStrokeStyle),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, _canvasJs.defaultLineDash),
            (0, _canvasJs.defaultLineDashOffset)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, _instructionJsDefault.default).CIRCLE,
            myBegin,
            strokeOffset
        ];
        this.instructions.push((0, _instructionJs.beginPathInstruction), circleInstruction);
        this.hitDetectionInstructions.push((0, _instructionJs.beginPathInstruction), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, _instructionJs.fillInstruction));
            this.hitDetectionInstructions.push((0, _instructionJs.fillInstruction));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, _instructionJs.strokeInstruction));
            this.hitDetectionInstructions.push((0, _instructionJs.strokeInstruction));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawPolygon(polygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_FILL_STYLE,
            (0, _canvasJs.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_STROKE_STYLE,
            (0, _canvasJs.defaultStrokeStyle),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, _canvasJs.defaultLineDash),
            (0, _canvasJs.defaultLineDashOffset)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawMultiPolygon(multiPolygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_FILL_STYLE,
            (0, _canvasJs.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).SET_STROKE_STYLE,
            (0, _canvasJs.defaultStrokeStyle),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, _canvasJs.defaultLineDash),
            (0, _canvasJs.defaultLineDashOffset)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, _simplifyJs.snap)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        this.updateFillStyle(state, this.createFill);
        this.updateStrokeStyle(state, this.applyStroke);
    }
    handleStrokeOffset_(drawGeometryCallback) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        // In case both fill style and stroke style are defined and the stroke style has an offset,
        // the stroke and fill should be done in separate steps, because offset stroke shape will
        // be different from the original shape used for the fill.
        if (Math.abs(strokeOffset) > 0 && fillStyle !== undefined && strokeStyle !== undefined) {
            // First do only fill
            state.strokeStyle = undefined;
            state.strokeOffset = 0;
            drawGeometryCallback();
            // Now separately do the stroke
            state.fillStyle = undefined;
            state.strokeStyle = strokeStyle;
            state.strokeOffset = strokeOffset;
            drawGeometryCallback();
            // Reset the state to the original
            state.fillStyle = fillStyle;
            return true;
        }
        return false;
    }
}
exports.default = CanvasPolygonBuilder;

},{"../../geom/flat/simplify.js":"5VJXL","../canvas.js":"8UJXP","./Builder.js":"grCUR","./Instruction.js":"kbDHR","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2nZk3":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/TextBuilder
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TEXT_ALIGN", ()=>TEXT_ALIGN);
var _colorlikeJs = require("../../colorlike.js");
var _extentJs = require("../../extent.js");
var _clipJs = require("../../geom/flat/clip.js");
var _linechunkJs = require("../../geom/flat/linechunk.js");
var _straightchunkJs = require("../../geom/flat/straightchunk.js");
var _utilJs = require("../../util.js");
var _canvasJs = require("../canvas.js");
var _builderJs = require("./Builder.js");
var _builderJsDefault = parcelHelpers.interopDefault(_builderJs);
var _instructionJs = require("./Instruction.js");
var _instructionJsDefault = parcelHelpers.interopDefault(_instructionJs);
const TEXT_ALIGN = {
    'left': 0,
    'center': 0.5,
    'right': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
class CanvasTextBuilder extends (0, _builderJsDefault.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textKeepUpright_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, _canvasJs.defaultFillStyle] = {
            fillStyle: (0, _canvasJs.defaultFillStyle)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = '';
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === 'line' && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            const geometryExtent = geometry.getExtent();
            if (!(0, _extentJs.intersects)(this.maxExtent, geometryExtent)) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            if ((geometryType == 'LineString' || geometryType == 'MultiLineString') && !(0, _extentJs.containsExtent)(this.getBufferedMaxExtent(), geometryExtent)) {
                // Clip the line to the rendered extent so the label is anchored within
                // the rendered area instead of along the full geometry, whose center
                // can lie outside it.
                const clipped = (0, _clipJs.clipFlatLineStrings)(flatCoordinates, ends, stride, this.getBufferedMaxExtent());
                flatCoordinates = clipped.flatCoordinates;
                ends = clipped.ends;
                stride = 2;
                if (ends.length === 0) return;
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, _linechunkJs.lineChunk)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, _straightchunkJs.matchingChunk)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            const backgroundFill = textState.backgroundFill ? this.createFill(this.fillStyleToState(textState.backgroundFill)) : null;
            const backgroundStroke = textState.backgroundStroke ? this.createStroke(this.strokeStyleToState(textState.backgroundStroke)) : null;
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, _canvasJs.defaultPadding) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, _instructionJsDefault.default).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, _canvasJs.defaultPadding) ? (0, _canvasJs.defaultPadding) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                backgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const hitDetectionBackgroundFill = backgroundFill ? backgroundFill.slice(0) : null;
            if (hitDetectionBackgroundFill) hitDetectionBackgroundFill[1] = (0, _canvasJs.defaultFillStyle);
            this.hitDetectionInstructions.push([
                (0, _instructionJsDefault.default).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                hitDetectionBackgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, _canvasJs.defaultFillStyle) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, _canvasJs.defaultTextAlign),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, _canvasJs.defaultTextBaseline),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = TEXT_ALIGN[textState.textBaseline];
        const offsetX = this.textOffsetX_ * pixelRatio;
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, _instructionJsDefault.default).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_,
            this.textKeepUpright_,
            offsetX
        ]);
        this.hitDetectionInstructions.push([
            (0, _instructionJsDefault.default).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, _canvasJs.defaultFillStyle) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_,
            this.textKeepUpright_,
            offsetX
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, _colorlikeJs.asColorLike)(textFillStyle.getColor() || (0, _canvasJs.defaultFillStyle));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, _canvasJs.defaultLineCap);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, _canvasJs.defaultLineDash);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, _canvasJs.defaultLineDashOffset) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, _canvasJs.defaultLineJoin);
                strokeState.lineWidth = lineWidth === undefined ? (0, _canvasJs.defaultLineWidth) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, _canvasJs.defaultMiterLimit) : miterLimit;
                strokeState.strokeStyle = (0, _colorlikeJs.asColorLike)(textStrokeStyle.getColor() || (0, _canvasJs.defaultStrokeStyle));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, _canvasJs.defaultFont);
            (0, _canvasJs.registerFont)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, _canvasJs.defaultTextBaseline);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, _canvasJs.defaultPadding);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textKeepUpright = textStyle.getKeepUpright();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textKeepUpright_ = textKeepUpright === undefined ? true : textKeepUpright;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, _utilJs.getUid)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.repeat || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, _utilJs.getUid)(fillState.fillStyle) : '';
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
exports.default = CanvasTextBuilder;

},{"../../colorlike.js":"8r5Mb","../../extent.js":"MPjK5","../../geom/flat/clip.js":"5qAmb","../../geom/flat/linechunk.js":"gdwec","../../geom/flat/straightchunk.js":"9QAAC","../../util.js":"9Y20j","../canvas.js":"8UJXP","./Builder.js":"grCUR","./Instruction.js":"kbDHR","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5qAmb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/clip
 */ /**
 * Start parameter of the portion of the last clipped segment that is inside the
 * extent. Set by {@link clipSegment}, read right after a `true` return to avoid
 * allocating a result array per segment.
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Clip flat line strings to the given extent. Parts outside the extent are
 * dropped and a vertex is inserted where a segment crosses the boundary. A line
 * that leaves and re-enters the extent is split into separate parts so that
 * positions derived from the result (e.g. labels placed along the line) stay
 * within the extent. Output coordinates have a stride of 2.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent to clip to.
 * @return {{flatCoordinates: Array<number>, ends: Array<number>}} Clipped flat
 *     coordinates and ends.
 */ parcelHelpers.export(exports, "clipFlatLineStrings", ()=>clipFlatLineStrings);
let clipSegmentStart = 0;
/**
 * End parameter of the portion of the last clipped segment that is inside the
 * extent. See {@link clipSegmentStart}.
 * @type {number}
 */ let clipSegmentEnd = 1;
/**
 * Clip a segment to a rectangular extent. On a `true` return, the inside
 * portion is `[clipSegmentStart, clipSegmentEnd]` in segment parameters. No
 * allocations are made, so the result globals must be read before the next
 * call.
 * @param {number} minX Minimum X.
 * @param {number} minY Minimum Y.
 * @param {number} maxX Maximum X.
 * @param {number} maxY Maximum Y.
 * @param {number} x0 Segment start X.
 * @param {number} y0 Segment start Y.
 * @param {number} x1 Segment end X.
 * @param {number} y1 Segment end Y.
 * @return {boolean} The segment intersects the extent.
 */ function clipSegment(minX, minY, maxX, maxY, x0, y0, x1, y1) {
    const dx = x1 - x0;
    const dy = y1 - y0;
    let t0 = 0;
    let t1 = 1;
    // X slab.
    if (dx === 0) {
        if (x0 < minX || x0 > maxX) return false;
    } else {
        let ta = (minX - x0) / dx;
        let tb = (maxX - x0) / dx;
        if (ta > tb) {
            const tmp = ta;
            ta = tb;
            tb = tmp;
        }
        if (ta > t0) t0 = ta;
        if (tb < t1) t1 = tb;
        if (t0 > t1) return false;
    }
    // Y slab.
    if (dy === 0) {
        if (y0 < minY || y0 > maxY) return false;
    } else {
        let ta = (minY - y0) / dy;
        let tb = (maxY - y0) / dy;
        if (ta > tb) {
            const tmp = ta;
            ta = tb;
            tb = tmp;
        }
        if (ta > t0) t0 = ta;
        if (tb < t1) t1 = tb;
        if (t0 > t1) return false;
    }
    clipSegmentStart = t0;
    clipSegmentEnd = t1;
    return true;
}
function clipFlatLineStrings(flatCoordinates, ends, stride, extent) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const dest = [];
    const destEnds = [];
    let open = false;
    let lastX, lastY;
    let offset = 0;
    for(let e = 0, ee = ends.length; e < ee; ++e){
        const end = ends[e];
        let prevX = flatCoordinates[offset];
        let prevY = flatCoordinates[offset + 1];
        let lineHasLast = false;
        for(let i = offset + stride; i < end; i += stride){
            const curX = flatCoordinates[i];
            const curY = flatCoordinates[i + 1];
            if (clipSegment(minX, minY, maxX, maxY, prevX, prevY, curX, curY)) {
                const dx = curX - prevX;
                const dy = curY - prevY;
                const ax = prevX + clipSegmentStart * dx;
                const ay = prevY + clipSegmentStart * dy;
                const bx = prevX + clipSegmentEnd * dx;
                const by = prevY + clipSegmentEnd * dy;
                if (open && lineHasLast && ax === lastX && ay === lastY) dest.push(bx, by);
                else {
                    if (open) destEnds.push(dest.length);
                    dest.push(ax, ay, bx, by);
                    open = true;
                }
                lastX = bx;
                lastY = by;
                lineHasLast = true;
            }
            prevX = curX;
            prevY = curY;
        }
        offset = end;
    }
    if (open) destEnds.push(dest.length);
    return {
        flatCoordinates: dest,
        ends: destEnds
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gdwec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates chunks of equal length from a linestring
 * @param {number} chunkLength Length of each chunk.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Start offset of the `flatCoordinates`.
 * @param {number} end End offset of the `flatCoordinates`.
 * @param {number} stride Stride.
 * @return {Array<Array<number>>} Chunks of linestrings with stride 2.
 */ parcelHelpers.export(exports, "lineChunk", ()=>lineChunk);
var _mathJs = require("../../math.js");
function lineChunk(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, _mathJs.lerp)(x1, x2, m);
            const y = (0, _mathJs.lerp)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, _mathJs.lerp)(x1, x2, missing / segmentLength);
            const y = (0, _mathJs.lerp)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}

},{"../../math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9QAAC":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchingChunk", ()=>matchingChunk);
function matchingChunk(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7KLwV":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/ExecutorGroup
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL", ()=>ALL);
parcelHelpers.export(exports, "DECLUTTER", ()=>DECLUTTER);
parcelHelpers.export(exports, "NON_DECLUTTER", ()=>NON_DECLUTTER);
/**
 * This methods creates an array with indexes of all pixels within a circle,
 * ordered by how close they are to the center.
 * A cache is used to increase performance.
 * @param {number} radius Radius.
 * @return {Array<number>} An array with indexes within a circle.
 */ parcelHelpers.export(exports, "getPixelIndexArray", ()=>getPixelIndexArray);
var _arrayJs = require("../../array.js");
var _domJs = require("../../dom.js");
var _extentJs = require("../../extent.js");
var _transformJs = require("../../geom/flat/transform.js");
var _objJs = require("../../obj.js");
var _transformJs1 = require("../../transform.js");
var _executorJs = require("./Executor.js");
var _executorJsDefault = parcelHelpers.interopDefault(_executorJs);
const ALL = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
const DECLUTTER = [
    'Image',
    'Text'
];
const NON_DECLUTTER = ALL.filter((builderType)=>!DECLUTTER.includes(builderType));
/** @type {boolean|undefined} */ let willReadFrequently = false;
/** @type {boolean|undefined} */ let canvasReadsBenchmarked = false;
/** Determine if canvas read operations are faster with willReadFrequently set to true or false */ function benchmarkCanvasReads() {
    let bestResult = 0;
    /**
   * @param {boolean} willReadFrequently Will read frequently.
   * @return {number} Operation count.
   */ const measure = (willReadFrequently)=>{
        const context = (0, _domJs.createCanvasContext2D)(1, 1, null, {
            willReadFrequently
        });
        let count = 0;
        const start = performance.now();
        for(; performance.now() - start < 50; ++count){
            context.fillStyle = `rgba(255,0,${count % 256},1)`;
            context.fillRect(0, 0, 1, 1);
            context.getImageData(0, 0, 1, 1);
        }
        bestResult = count > bestResult ? count : bestResult;
        return count;
    };
    const measures = {
        [measure(true)]: true,
        [measure(false)]: false,
        [measure(undefined)]: undefined
    };
    willReadFrequently = measures[bestResult];
    canvasReadsBenchmarked = true;
}
class ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor.js").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, _transformJs1.create)();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, _executorJsDefault.default)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        if (canvasReadsBenchmarked === false) benchmarkCanvasReads();
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, _transformJs1.compose)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, _domJs.createCanvasContext2D)(contextSize, contextSize, null, {
            willReadFrequently
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /** @type {import("../../extent.js").Extent|undefined} */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, _extentJs.createEmpty)();
            (0, _extentJs.extendCoordinate)(hitExtent, coordinate);
            (0, _extentJs.buffer)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = getPixelIndexArray(hitTolerance);
        /** @type {import("../canvas.js").BuilderType} */ let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === 'none' || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, _arrayJs.ascending));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = ALL.length - 1; j >= 0; --j){
                builderType = ALL[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, _transformJs.transform2D)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, _objJs.isEmpty)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(declutterTree ? (0, _arrayJs.descending) : (0, _arrayJs.ascending));
        builderTypes = builderTypes ? builderTypes : ALL;
        const maxBuilderTypes = ALL.length;
        for(let i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            const replays = this.executorsByZIndex_[zIndexKey];
            for(let j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== 'Image' && builderType !== 'Text';
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === 'Text' || builderType === 'Image') replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + ALL.indexOf(builderType);
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, _arrayJs.ascending));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const circlePixelIndexArrayCache = {};
function getPixelIndexArray(radius) {
    if (circlePixelIndexArrayCache[radius] !== undefined) return circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
exports.default = ExecutorGroup;

},{"../../array.js":"2IuG2","../../dom.js":"gfuif","../../extent.js":"MPjK5","../../geom/flat/transform.js":"ahZFf","../../obj.js":"GxveT","../../transform.js":"7TqcG","./Executor.js":"gosRb","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gosRb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/Executor
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../../array.js");
var _extentJs = require("../../extent.js");
var _lengthJs = require("../../geom/flat/length.js");
var _lineoffsetJs = require("../../geom/flat/lineoffset.js");
var _textpathJs = require("../../geom/flat/textpath.js");
var _transformJs = require("../../geom/flat/transform.js");
var _transformJs1 = require("../../transform.js");
var _canvasJs = require("../canvas.js");
var _zindexContextJs = require("../canvas/ZIndexContext.js");
var _zindexContextJsDefault = parcelHelpers.interopDefault(_zindexContextJs);
var _instructionJs = require("./Instruction.js");
var _instructionJsDefault = parcelHelpers.interopDefault(_instructionJs);
var _textBuilderJs = require("./TextBuilder.js");
/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const tmpExtent = (0, _extentJs.createEmpty)();
/** @type {import("../../coordinate.js").Coordinate} */ const p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function horizontalTextAlign(text, align) {
    if (align === 'start') align = rtlRegEx.test(text) ? 'right' : 'left';
    else if (align === 'end') align = rtlRegEx.test(text) ? 'left' : 'right';
    return (0, _textBuilderJs.TEXT_ALIGN)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
/**
 * Converts rich text to plain text for text along lines.
 * @param {string} result The resulting plain text.
 * @param {string} part Item of the rich text array.
 * @param {number} index Index of the item in the rich text array.
 * @return {string} The resulting plain text.
 */ function richTextToPlainText(result, part, index) {
    if (index % 2 === 0) result += part;
    return result;
}
class Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, _transformJs1.create)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, _zindexContextJsDefault.default)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, _textBuilderJs.TEXT_ALIGN)[textState.justify] : horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, _canvasJs.defaultTextAlign));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split('\n').reduce(createTextChunks, []);
        const { width, height, widths, heights, lineWidths } = (0, _canvasJs.getTextDimensions)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            contextInstructions.push('setLineDash', [
                strokeState.lineDash
            ]);
            contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            context.fillStyle = /** @type {string} */ fillInstruction[1];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            p1[0] = boxX;
            p4[0] = boxX;
            p1[1] = boxY;
            p2[1] = boxY;
            p2[0] = boxX + boxW;
            p3[0] = p2[0];
            p3[1] = boxY + boxH;
            p4[1] = p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, _transformJs1.compose)((0, _transformJs1.create)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, _transformJs1.apply)(transform, p1);
            (0, _transformJs1.apply)(transform, p2);
            (0, _transformJs1.apply)(transform, p3);
            (0, _transformJs1.apply)(transform, p4);
            (0, _extentJs.createOrUpdate)(Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1]), tmpExtent);
        } else (0, _extentJs.createOrUpdate)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: tmpExtent[0],
                minY: tmpExtent[1],
                maxX: tmpExtent[2],
                maxY: tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, p1, p2, p3, p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, _canvasJs.drawImageOrLabel)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, _transformJs1.apply)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        if (!instruction[1]) return;
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, _canvasJs.defaultTextAlign));
        const baseline = (0, _textBuilderJs.TEXT_ALIGN)[textState.textBaseline || (0, _canvasJs.defaultTextBaseline)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, _arrayJs.equals)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, _transformJs.transform2D)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, _transformJs1.setFromArray)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        const offsetCoords = [];
        let anchorX, anchorY, lineOffsetPx, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, _instructionJsDefault.default).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, _extentJs.intersects)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, _instructionJsDefault.default).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    lineOffsetPx = /** @type {number} */ instruction[2] ?? 0;
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2] - lineOffsetPx;
                    const y2 = pixelCoordinates[d + 3] - lineOffsetPx;
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || 'declutter';
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFillInstruction, backgroundStrokeInstruction;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFillInstruction = /** @type {Array<*>} */ instruction[17];
                        backgroundStrokeInstruction = /** @type {Array<*>} */ instruction[18];
                    } else {
                        padding = (0, _canvasJs.defaultPadding);
                        backgroundFillInstruction = null;
                        backgroundStrokeInstruction = null;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, !!backgroundFillInstruction || !!backgroundStrokeInstruction, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFillInstruction,
                            backgroundStrokeInstruction
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args,
                                        declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== 'declutter' || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== 'declutter' || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === 'declutter' && declutterMode === 'declutter') {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== 'none') declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== 'none') declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string|Array<string>} */ instruction[11];
                    if (Array.isArray(text)) //FIXME Add support for rich text along lines
                    text = text.reduce(richTextToPlainText, '');
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || 'declutter';
                    const textKeepUpright = /** @type {boolean} */ instruction[15];
                    const offsetX = /** @type {number} */ instruction[16];
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, _lengthJs.lineStringLength)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, _canvasJs.measureAndCacheTextWidth)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * horizontalTextAlign(text, textAlign);
                        const parts = (0, _textpathJs.drawTextOnPath)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, _canvasJs.measureAndCacheTextWidth), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_, textKeepUpright);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth) - offsetX;
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, _canvasJs.defaultPadding), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2] - offsetX;
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, _canvasJs.defaultPadding), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== 'none') declutterTree.load(replayImageOrLabelArgs.map(getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    lineOffsetPx = /** @type {number|undefined} */ instruction[3];
                    let lineCoords, lineStart, lineEnd;
                    if (lineOffsetPx) {
                        const isClosedRing = /** @type {boolean|undefined} */ instruction[4] ?? false;
                        const isClosedLine = isClosedRing || Math.abs(pixelCoordinates[d] - pixelCoordinates[dd - 2]) < 1e-6 && Math.abs(pixelCoordinates[d + 1] - pixelCoordinates[dd - 1]) < 1e-6;
                        (0, _lineoffsetJs.offsetLineString)(pixelCoordinates, d, dd, 2, lineOffsetPx, isClosedLine, offsetCoords);
                        (0, _lineoffsetJs.removeOffsetCycles)(offsetCoords, 2, isClosedLine);
                        lineCoords = offsetCoords;
                        lineStart = 0;
                        lineEnd = lineCoords.length;
                    } else {
                        lineCoords = pixelCoordinates;
                        lineStart = d;
                        lineEnd = dd;
                    }
                    x = lineCoords[lineStart];
                    y = lineCoords[lineStart + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(let k = lineStart + 2; k < lineEnd; k += 2){
                        x = lineCoords[k];
                        y = lineCoords[k + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (k == lineEnd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).SET_FILL_STYLE:
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    } else if (pendingStroke && instruction[1]) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).SET_STROKE_STYLE:
                    if (pendingFill && instruction[1]) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, _instructionJsDefault.default).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
exports.default = Executor;

},{"../../array.js":"2IuG2","../../extent.js":"MPjK5","../../geom/flat/length.js":"dcv40","../../geom/flat/lineoffset.js":"iQKkV","../../geom/flat/textpath.js":"aHNOO","../../geom/flat/transform.js":"ahZFf","../../transform.js":"7TqcG","../canvas.js":"8UJXP","../canvas/ZIndexContext.js":"67cK6","./Instruction.js":"kbDHR","./TextBuilder.js":"2nZk3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dcv40":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineStringLength", ()=>lineStringLength);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Perimeter.
 */ parcelHelpers.export(exports, "linearRingLength", ()=>linearRingLength);
function lineStringLength(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function linearRingLength(flatCoordinates, offset, end, stride) {
    let perimeter = lineStringLength(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iQKkV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Offsets a line string to the left / right along its segments direction.
 * Offset is applied to each segment of the line in the direciton of the segment normal (positive offset goes "right" relative to the line direction).
 * For very sharp angles between segments, the function falls back to offsetting along the segment normal direction to avoid excessively long miters.
 *
 * Coordinates and the offset should be in the same units — either pixels or the same spatial reference system as the input line coordinates.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} start Start index.
 * @param {number} end End index.
 * @param {number} stride Stride.
 * @param {number} offset Offset distance along the segment normal direction.
 *   Positive values offset to the right relative to the direction of the line.
 *   Negative values offset to the left.
 * @param {boolean} isClosedRing If coordinates build a closed circle (in this the first and the last coordinate offsets will consider previous / next ring coordinate)
 * @param {Array<number>} [dest] Destination coordinate array. If not provided a new one will be created
 * @param {number} [destinationStride] Stride of destination coordinates. If unspecified, assumed to be same as the source coordinates stride.
 * @return {Array<number>} Result flat coordinates of the offset line.
 */ parcelHelpers.export(exports, "offsetLineString", ()=>offsetLineString);
/**
 * Removes self-intersection loops (cycles) from an offset line.
 * When a polyline is offset, sharp turns can create self-intersecting loops.
 * This function detects those crossings and splices out the looped portions,
 * replacing them with the intersection point.
 *
 * @param {Array<number>} coords Flat offset coordinates (modified in-place).
 * @param {number} stride Coordinate stride (typically 2).
 * @param {boolean} [closedLine] Whether the original line is closed (first vertex === last vertex).
 *   When true, the first and last offset segments are not compared against each other to avoid
 *   false loop detection at the closure point.
 * @return {Array<number>} The cleaned coordinate array.
 */ parcelHelpers.export(exports, "removeOffsetCycles", ()=>removeOffsetCycles);
var _coordinateJs = require("../../coordinate.js");
function offsetLineString(flatCoordinates, start, end, stride, offset, isClosedRing, dest, destinationStride) {
    dest = dest ?? [];
    destinationStride = destinationStride ?? stride;
    const secondPointX = flatCoordinates[start + stride];
    const secondPointY = flatCoordinates[start + stride + 1];
    const secondToLastPointX = flatCoordinates[end - 2 * stride];
    const secondToLastPointY = flatCoordinates[end - 2 * stride + 1];
    let x, y, prevX, prevY, nextX, nextY, offsetX, offsetY;
    let i = 0;
    for(let j = start; j < end; j += stride){
        // 1. Detect previous and next coordinates of a current vertex
        prevX = x;
        prevY = y;
        nextX = undefined;
        nextY = undefined;
        if (j + stride < end) {
            nextX = flatCoordinates[j + stride];
            nextY = flatCoordinates[j + stride + 1];
        }
        // First coordinate of a closed ring -> previous coordinate is the second to last one
        if (isClosedRing && j === start) {
            prevX = secondToLastPointX;
            prevY = secondToLastPointY;
        }
        // Last coordinate of a closed ring -> next coordinate is the second vertex of a line string (the last one is same as the first one for a closed ring)
        if (isClosedRing && j === end - stride) {
            nextX = secondPointX;
            nextY = secondPointY;
        }
        // 2. Current vertex to offset
        x = flatCoordinates[j];
        y = flatCoordinates[j + 1];
        // 3. Offset the vertex
        [offsetX, offsetY] = offsetLineVertex(x, y, prevX, prevY, nextX, nextY, offset);
        dest[i++] = offsetX;
        dest[i++] = offsetY;
        // 4. Copy over other dimension values if any
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest.length != i) dest.length = i;
    return dest;
}
/**
 * Computes the offset of a single vertex of a line string.
 *
 * The function calculates a new vertex coordinate offset along the normal/miter direction of the line at this vertex.
 * Offset is applied along the segment normal (positive offset goes "right" relative to the line direction).
 * It handles first and last vertices (caps) as well as joins between two segments (mitering).
 * For very sharp angles, the function falls back to offsetting along the segment normal direction to avoid excessively long miters.
 *
 * Coordinates and the offset should be in the same units — either pixels or the same spatial reference system as the input line coordinates.
 *
 * @param {number} x Vertex x-coordinate.
 * @param {number} y Vertex y-coordinate.
 * @param {number|undefined} prevX Previous vertex x-coordinate.
 *   Pass undefined if computing the offset for the first vertex (no previous vertex).
 * @param {number|undefined} prevY Previous vertex y-coordinate.
 *   Pass undefined if computing the offset for the first vertex (no previous vertex).
 * @param {number|undefined} nextX Next vertex x-coordinate.
 *   Pass undefined if computing the offset for the last vertex (no next vertex).
 * @param {number|undefined} nextY Next vertex y-coordinate.
 *   Pass undefined if computing the offset for the last vertex (no next vertex).
 * @param {number} offset Offset distance along the segment normal direction.
 *   Positive values offset to the right relative to the direction from previous to next vertex.
 *   Negative values offset to the left.
 * @return {import("../../coordinate.js").Coordinate} Offset vertex coordinate as `[x, y]`.
 */ function offsetLineVertex(x, y, prevX, prevY, nextX, nextY, offset) {
    // Compute segment direction
    let nx, ny;
    if (prevX !== undefined && prevY !== undefined) {
        nx = x - prevX;
        ny = y - prevY;
    } else if (nextX !== undefined && nextY !== undefined) {
        nx = nextX - x;
        ny = nextY - y;
    } else {
        // no next, no previous point given -> just assume some default (horizontal) direction
        nx = 1;
        ny = 0;
    }
    // Normalize -> tangent
    const len = Math.hypot(nx, ny);
    const tx = nx / len;
    const ty = ny / len;
    // Rotate tangent 90° -> normal
    nx = -ty;
    ny = tx;
    // First / last vertex -> offset the point in the direction of the normal vector
    if (prevX === undefined || prevY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    if (nextX === undefined || nextY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    // Compute join angle - angle between 2 segments of the vertex.
    const joinAngle = (0, _coordinateJs.angleBetween)([
        x,
        y
    ], [
        prevX,
        prevY
    ], [
        nextX,
        nextY
    ]);
    // Avoid huge or infinite miter joins for very sharp angles, offset in the segment direction in this case.
    if (Math.cos(joinAngle) > 0.998) return [
        x + tx * offset,
        y + ty * offset
    ];
    // Compute join offset direction.
    // We rotate the normal vector by half of the join angle.
    // This gives the direction of the miter at the vertex.
    const cos = Math.cos(joinAngle / 2);
    const sin = Math.sin(joinAngle / 2);
    // Rotate the normal vector (nx, ny) by half of the join angle.
    // bx/by = bisector direction before normalization
    const bx = sin * nx + cos * ny;
    const by = -cos * nx + sin * ny;
    // Scale the bisector so that moving along it preserves the correct offset distance.
    // Dividing by sin(half of angle) converts the bisector into the true miter vector.
    // (This expands the miter for sharp angles and shortens it for wide ones.)
    const dx = bx * (1 / sin);
    const dy = by * (1 / sin);
    // Offset final vertex along miter direction
    return [
        x + dx * offset,
        y + dy * offset
    ];
}
function removeOffsetCycles(coords, stride, closedLine = false) {
    for(let i = 0, ii = coords.length - 2; i < ii; i += stride){
        const jMax = closedLine && i === 0 ? coords.length - 3 * stride : coords.length - 2 * stride;
        for(let j = jMax; j > i + stride; j -= stride){
            const p1x = coords[i];
            const p1y = coords[i + 1];
            const p2x = coords[i + stride];
            const p2y = coords[i + stride + 1];
            const p3x = coords[j];
            const p3y = coords[j + 1];
            const p4x = coords[j + stride];
            const p4y = coords[j + stride + 1];
            const d = (p4y - p3y) * (p2x - p1x) - (p4x - p3x) * (p2y - p1y);
            if (d === 0) continue;
            const t = ((p4x - p3x) * (p1y - p3y) - (p4y - p3y) * (p1x - p3x)) / d;
            const u = ((p2x - p1x) * (p1y - p3y) - (p2y - p1y) * (p1x - p3x)) / d;
            if (t > 0 && t < 1 && u > 0 && u < 1) {
                const ix = p1x + t * (p2x - p1x);
                const iy = p1y + t * (p2y - p1y);
                coords[i + stride] = ix;
                coords[i + stride + 1] = iy;
                coords.splice(i + 2 * stride, j - i - stride);
                break;
            }
        }
    }
    return coords;
}

},{"../../coordinate.js":"9bcSP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aHNOO":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/textpath
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<number>} flatCoordinates Path to put text on.
 * @param {number} offset Start offset of the `flatCoordinates`.
 * @param {number} end End offset of the `flatCoordinates`.
 * @param {number} stride Stride.
 * @param {string} text Text to place on the path.
 * @param {number} startM m along the path where the text starts.
 * @param {number} maxAngle Max angle between adjacent chars in radians.
 * @param {number} scale The product of the text scale and the device pixel ratio.
 * @param {function(string, string, Object<string, number>):number} measureAndCacheTextWidth Measure and cache text width.
 * @param {string} font The font.
 * @param {Object<string, number>} cache A cache of measured widths.
 * @param {number} rotation Rotation to apply to the flatCoordinates to determine whether text needs to be reversed.
 * @param {boolean} keepUpright Whether the text needs to be kept upright
 * @return {Array<Array<*>>|null} The result array (or null if `maxAngle` was
 * exceeded). Entries of the array are x, y, anchorX, angle, chunk.
 */ parcelHelpers.export(exports, "drawTextOnPath", ()=>drawTextOnPath);
var _mathJs = require("../../math.js");
var _transformJs = require("./transform.js");
let segmenter;
/**
 * @return {Intl.Segmenter} A grapheme segmenter.
 */ function getSegmenter() {
    if (!segmenter) segmenter = new Intl.Segmenter(undefined, {
        granularity: 'grapheme'
    });
    return segmenter;
}
function drawTextOnPath(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation, keepUpright = true) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, _mathJs.lerp)(x1, x2, interpolate);
    const beginY = (0, _mathJs.lerp)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, _mathJs.lerp)(x1, x2, interpolate);
    const endY = (0, _mathJs.lerp)(y1, y2, interpolate);
    // Keep text upright if the option is selected
    let reverse = false;
    if (keepUpright) {
        if (rotation) {
            const flat = [
                beginX,
                beginY,
                endX,
                endY
            ];
            (0, _transformJs.rotate)(flat, 0, 4, 2, rotation, flat, flat);
            reverse = flat[0] > flat[2];
        } else reverse = beginX > endX;
    }
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    const segments = Array.from(getSegmenter().segment(text), (s)=>s.segment);
    for(let i = 0, ii = segments.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, segments[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = (reverse ? segments.slice(ii - i, ii - iStart) : segments.slice(iStart, i)).join('');
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, _mathJs.lerp)(x1, x2, interpolate);
        const y = (0, _mathJs.lerp)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}

},{"../../math.js":"b3dOZ","./transform.js":"ahZFf","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"67cK6":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/ZIndexContext
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../dom.js");
/** @typedef {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * Name of the method last accessed on the proxy, pushed together with its
     * arguments when the method is actually called.
     * @private
     * @type {string|symbol}
     */ this.pendingMethod_;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, _domJs.getSharedCanvasContext2D)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ target[property] !== 'function') // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                this.pendingMethod_ = property;
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                this.push_(property, value);
                return true;
            }
        });
    }
    /**
   * @param {...*} args Arguments to push to the instructions array.
   * @private
   */ push_(...args) {
        const instructions = this.instructions_;
        const index = this.zIndex + this.offset_;
        if (!instructions[index]) instructions[index] = [];
        instructions[index].push(...args);
    }
    /**
   * Pushes the method name captured at access time together with the arguments
   * passed at call time. Reused across all proxied method calls.
   * @param {...*} args Args.
   * @private
   */ pushMethodArgs_ = (...args)=>{
        this.push_(this.pendingMethod_, args);
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.push_(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === 'function') {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === 'function') /** @type {*} */ context[property](...instructionAtIndex);
                else if (typeof instructionAtIndex === 'function') /** @type {*} */ context[property] = instructionAtIndex(context);
                else /** @type {*} */ context[property] = instructionAtIndex;
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
exports.default = ZIndexContext;

},{"../../dom.js":"gfuif","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e6viX":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/hitdetect
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HIT_DETECT_RESOLUTION", ()=>HIT_DETECT_RESOLUTION);
/**
 * @param {import("../../size.js").Size} size Canvas size in css pixels.
 * @param {Array<import("../../transform.js").Transform>} transforms Transforms
 * for rendering features to all worlds of the viewport, from coordinates to css
 * pixels.
 * @param {Array<import("../../Feature.js").FeatureLike>} features
 * Features to consider for hit detection.
 * @param {import("../../style/Style.js").StyleFunction|undefined} styleFunction
 * Layer style function.
 * @param {import("../../extent.js").Extent} extent Extent in render projection.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @param {number} [squaredTolerance] Squared tolerance.
 * @param {import("../../proj/Projection.js").default} [projection] Render projection.
 * @return {ImageData} Hit detection image data.
 */ parcelHelpers.export(exports, "createHitDetectionImageData", ()=>createHitDetectionImageData);
/**
 * @param {import("../../pixel.js").Pixel} pixel Pixel coordinate on the hit
 * detection canvas in css pixels.
 * @param {Array<F>} features Features. Has to
 * match the `features` array that was passed to `createHitDetectionImageData()`.
 * @param {ImageData} imageData Hit detection image data generated by
 * `createHitDetectionImageData()`.
 * @return {Array<F>} Features.
 * @template {import("../../Feature.js").FeatureLike} F
 */ parcelHelpers.export(exports, "hitDetect", ()=>hitDetect);
var _arrayJs = require("../../array.js");
var _domJs = require("../../dom.js");
var _extentJs = require("../../extent.js");
var _mathJs = require("../../math.js");
var _projJs = require("../../proj.js");
var _iconJs = require("../../style/Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
var _immediateJs = require("./Immediate.js");
var _immediateJsDefault = parcelHelpers.interopDefault(_immediateJs);
const HIT_DETECT_RESOLUTION = 0.5;
function createHitDetectionImageData(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, _projJs.toUserExtent)(extent, projection) : extent;
    const width = size[0] * HIT_DETECT_RESOLUTION;
    const height = size[1] * HIT_DETECT_RESOLUTION;
    const context = (0, _domJs.createCanvasContext2D)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, _immediateJsDefault.default)(context, HIT_DETECT_RESOLUTION, extent, null, rotation, squaredTolerance, projection ? (0, _projJs.getTransformFromProjections)((0, _projJs.getUserProjection)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, '#00000');
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, _extentJs.intersects)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, _domJs.createCanvasContext2D)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, _iconJsDefault.default)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            const type = geometry.getType();
            if (type === 'GeometryCollection') {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
                }
            } else byGeometryType[type.replace('Multi', '')].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, _arrayJs.ascending));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function hitDetect(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * HIT_DETECT_RESOLUTION);
        const y = Math.floor(Math.round(pixel[1]) * HIT_DETECT_RESOLUTION);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, _mathJs.clamp)(x, 0, imageData.width - 1) + (0, _mathJs.clamp)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}

},{"../../array.js":"2IuG2","../../dom.js":"gfuif","../../extent.js":"MPjK5","../../math.js":"b3dOZ","../../proj.js":"gN0IK","../../style/Icon.js":"ib4Ft","./Immediate.js":"fx7AZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fx7AZ":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../../array.js");
var _colorlikeJs = require("../../colorlike.js");
var _extentJs = require("../../extent.js");
var _simpleGeometryJs = require("../../geom/SimpleGeometry.js");
var _lineoffsetJs = require("../../geom/flat/lineoffset.js");
var _transformJs = require("../../geom/flat/transform.js");
var _mathJs = require("../../math.js");
var _transformJs1 = require("../../transform.js");
var _vectorContextJs = require("../VectorContext.js");
var _vectorContextJsDefault = parcelHelpers.interopDefault(_vectorContextJs);
var _canvasJs = require("../canvas.js");
/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class CanvasImmediateRenderer extends (0, _vectorContextJsDefault.default) {
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, _mathJs.toFixed)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, _transformJs1.create)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, _transformJs.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, _transformJs1.compose)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, _transformJs.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close, strokeOffset) {
        const context = this.context_;
        let pixelCoordinates = (0, _transformJs.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        if (Math.abs(strokeOffset) > 0) {
            const n = pixelCoordinates.length;
            const isClosedLine = close || Math.abs(pixelCoordinates[0] - pixelCoordinates[n - 2]) < 1e-6 && Math.abs(pixelCoordinates[1] - pixelCoordinates[n - 1]) < 1e-6;
            pixelCoordinates = (0, _lineoffsetJs.offsetLineString)(pixelCoordinates, 0, n, 2, strokeOffset, isClosedLine, pixelCoordinates);
            (0, _lineoffsetJs.removeOffsetCycles)(pixelCoordinates, 2, isClosedLine);
        }
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride, strokeOffset) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true, strokeOffset);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, _extentJs.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, _simpleGeometryJs.transformGeom2D)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, _extentJs.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, _extentJs.intersects)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, _extentJs.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride(), this.strokeState_?.strokeOffset);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, _extentJs.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride, this.strokeState_?.strokeOffset);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, _arrayJs.equals)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, _canvasJs.defaultTextAlign);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, _colorlikeJs.asColorLike)(fillStyleColor ? fillStyleColor : (0, _canvasJs.defaultFillStyle))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, _canvasJs.defaultLineDash);
            const strokeOffset = strokeStyle.getOffset();
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, _canvasJs.defaultLineCap),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, _canvasJs.defaultLineDashOffset)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, _canvasJs.defaultLineJoin),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, _canvasJs.defaultLineWidth)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, _canvasJs.defaultMiterLimit),
                strokeStyle: (0, _colorlikeJs.asColorLike)(strokeStyleColor ? strokeStyleColor : (0, _canvasJs.defaultStrokeStyle)),
                strokeOffset: (strokeOffset ?? 0) * this.pixelRatio_
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, _colorlikeJs.asColorLike)(textFillStyleColor ? textFillStyleColor : (0, _canvasJs.defaultFillStyle))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, _canvasJs.defaultLineCap),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, _canvasJs.defaultLineDash),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, _canvasJs.defaultLineDashOffset),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, _canvasJs.defaultLineJoin),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, _canvasJs.defaultLineWidth),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, _canvasJs.defaultMiterLimit),
                    strokeStyle: (0, _colorlikeJs.asColorLike)(textStrokeStyleColor ? textStrokeStyleColor : (0, _canvasJs.defaultStrokeStyle))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, _canvasJs.defaultFont),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, _canvasJs.defaultTextAlign),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, _canvasJs.defaultTextBaseline)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? ' ' : t, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
exports.default = CanvasImmediateRenderer;

},{"../../array.js":"2IuG2","../../colorlike.js":"8r5Mb","../../extent.js":"MPjK5","../../geom/SimpleGeometry.js":"5Lm1Z","../../geom/flat/lineoffset.js":"iQKkV","../../geom/flat/transform.js":"ahZFf","../../math.js":"b3dOZ","../../transform.js":"7TqcG","../VectorContext.js":"izlth","../canvas.js":"8UJXP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fFxjb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/vector
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {import("../Feature.js").FeatureLike} feature1 Feature 1.
 * @param {import("../Feature.js").FeatureLike} feature2 Feature 2.
 * @return {number} Order.
 */ parcelHelpers.export(exports, "defaultOrder", ()=>defaultOrder);
/**
 * @param {number} resolution Resolution.
 * @param {number} pixelRatio Pixel ratio.
 * @return {number} Squared pixel tolerance.
 */ parcelHelpers.export(exports, "getSquaredTolerance", ()=>getSquaredTolerance);
/**
 * @param {number} resolution Resolution.
 * @param {number} pixelRatio Pixel ratio.
 * @return {number} Pixel tolerance.
 */ parcelHelpers.export(exports, "getTolerance", ()=>getTolerance);
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {function(import("../events/Event.js").default): void} listener Listener function.
 * @param {import("../proj.js").TransformFunction} [transform] Transform from user to view projection.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 * @return {boolean} `true` if style is loading.
 */ parcelHelpers.export(exports, "renderFeature", ()=>renderFeature);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _utilJs = require("../util.js");
/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source.js").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const GEOMETRY_RENDERERS = {
    'Point': renderPointGeometry,
    'LineString': renderLineStringGeometry,
    'Polygon': renderPolygonGeometry,
    'MultiPoint': renderMultiPointGeometry,
    'MultiLineString': renderMultiLineStringGeometry,
    'MultiPolygon': renderMultiPolygonGeometry,
    'GeometryCollection': renderGeometryCollectionGeometry,
    'Circle': renderCircleGeometry
};
function defaultOrder(feature1, feature2) {
    return parseInt((0, _utilJs.getUid)(feature1), 10) - parseInt((0, _utilJs.getUid)(feature2), 10);
}
function getSquaredTolerance(resolution, pixelRatio) {
    const tolerance = getTolerance(resolution, pixelRatio);
    return tolerance * tolerance;
}
function getTolerance(resolution, pixelRatio) {
    return SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
function renderFeature(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, _imageStateJsDefault.default).LOADED || imageState == (0, _imageStateJsDefault.default).ERROR) loading = false;
        else if (imageState == (0, _imageStateJsDefault.default).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == 'GeometryCollection') {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, _imageStateJsDefault.default).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, _imageStateJsDefault.default).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}

},{"../ImageState.js":"7kySV","../util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"h3JnK":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/canvas/Layer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canvasPool", ()=>canvasPool);
var _arrayJs = require("../../array.js");
var _colorJs = require("../../color.js");
var _domJs = require("../../dom.js");
var _extentJs = require("../../extent.js");
var _hasJs = require("../../has.js");
var _eventJs = require("../../render/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _eventTypeJs = require("../../render/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _zindexContextJs = require("../../render/canvas/ZIndexContext.js");
var _zindexContextJsDefault = parcelHelpers.interopDefault(_zindexContextJs);
var _transformJs = require("../../transform.js");
var _layerJs = require("../Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
const canvasPool = [];
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let pixelContext = null;
function createPixelContext() {
    pixelContext = (0, _domJs.createCanvasContext2D)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class CanvasLayerRenderer extends (0, _layerJsDefault.default) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * HTMLElement container for the layer to be rendered in.
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, _transformJs.create)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, _transformJs.create)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, _transformJs.create)();
        /**
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * true if the container has been reused from the previous renderer
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!pixelContext) createPixelContext();
        pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = pixelContext.getImageData(0, 0, 1, 1).data;
        } catch  {
            pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS transform matrix.
   * @param {string} [backgroundColor] Background color.
   * @param {number} [width] Physical pixel width of the rendering canvas.
   * @param {number} [height] Physical pixel height of the rendering canvas.
   */ useContainer(target, transform, backgroundColor, width, height) {
        // Render directly into the target canvas when there is no rotation or
        // offset (no CSS transform needed) and the physical dimensions match.
        if ((0, _domJs.isCanvas)(target) && this.pixelTransform[1] === 0 && this.pixelTransform[2] === 0 && this.pixelTransform[4] === 0 && this.pixelTransform[5] === 0 && target.width === width && target.height === height) {
            const targetCanvas = /** @type {HTMLCanvasElement} */ target;
            const context = targetCanvas.getContext('2d');
            if (context) {
                this.container = target;
                this.context = context;
                this.containerReused = true;
                if (backgroundColor) {
                    context.fillStyle = backgroundColor;
                    context.fillRect(0, 0, targetCanvas.width, targetCanvas.height);
                }
                return;
            }
        }
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, _arrayJs.equals)((0, _colorJs.asArray)(target.style.backgroundColor), (0, _colorJs.asArray)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if ((0, _domJs.isCanvas)(canvas)) context = canvas.getContext('2d');
        }
        if (context && (0, _transformJs.equivalent)(context.canvas.style.transform, transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = (0, _hasJs.WORKER_OFFSCREEN_CANVAS) ? (0, _domJs.createMockDiv)() : document.createElement('div');
            container.className = layerClassName;
            let style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, _domJs.createCanvasContext2D)();
            const canvas = /** @type {HTMLCanvasElement} */ context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, _extentJs.getTopLeft)(extent);
        const topRight = (0, _extentJs.getTopRight)(extent);
        const bottomRight = (0, _extentJs.getBottomRight)(extent);
        const bottomLeft = (0, _extentJs.getBottomLeft)(extent);
        (0, _transformJs.apply)(frameState.coordinateToPixelTransform, topLeft);
        (0, _transformJs.apply)(frameState.coordinateToPixelTransform, topRight);
        (0, _transformJs.apply)(frameState.coordinateToPixelTransform, bottomRight);
        (0, _transformJs.apply)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, _transformJs.apply)(inverted, topLeft);
        (0, _transformJs.apply)(inverted, topRight);
        (0, _transformJs.apply)(inverted, bottomRight);
        (0, _transformJs.apply)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, _extentJs.getWidth)(extent) / resolution * pixelRatio);
        const height = Math.round((0, _extentJs.getHeight)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, _transformJs.compose)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, _transformJs.makeInverse)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, _transformJs.toString)(this.pixelTransform);
        const backgroundColor = this.getBackground(frameState);
        this.useContainer(target, canvasTransform, backgroundColor, width, height);
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== /** @type {HTMLCanvasElement} */ canvas.style.transform) /** @type {HTMLCanvasElement} */ canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, _eventJsDefault.default)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, _eventTypeJsDefault.default).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, _eventTypeJsDefault.default).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, _zindexContextJsDefault.default)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, _eventTypeJsDefault.default).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, _eventTypeJsDefault.default).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, _transformJs.compose)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
exports.default = CanvasLayerRenderer;

},{"../../array.js":"2IuG2","../../color.js":"jC16r","../../dom.js":"gfuif","../../extent.js":"MPjK5","../../has.js":"hbGE6","../../render/Event.js":"3wbs1","../../render/EventType.js":"5YHp5","../../render/canvas/ZIndexContext.js":"67cK6","../../transform.js":"7TqcG","../Layer.js":"b9nVb","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b9nVb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/Layer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _observableJs = require("../Observable.js");
var _observableJsDefault = parcelHelpers.interopDefault(_observableJs);
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _utilJs = require("../util.js");
const maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class LayerRenderer extends (0, _observableJsDefault.default) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = maxStaleKeys;
        /**
     * @type {string}
     * @protected
     */ this.renderedSourceKey_;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Remember the previous source key as stale when the key changes.
   * @param {string} sourceKey The current source key.
   * @protected
   */ updateStaleKeys(sourceKey) {
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature.js").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, _utilJs.abstract)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, _utilJs.abstract)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, _imageStateJsDefault.default).LOADED || image.getState() === (0, _imageStateJsDefault.default).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, _imageStateJsDefault.default).LOADED && imageState != (0, _imageStateJsDefault.default).ERROR) image.addEventListener((0, _eventTypeJsDefault.default).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, _imageStateJsDefault.default).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, _imageStateJsDefault.default).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
exports.default = LayerRenderer;

},{"../ImageState.js":"7kySV","../Observable.js":"jiDvm","../events/EventType.js":"79Bvl","../util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7zHxp":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/Vector
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A function that takes an {@link module:ol/extent~Extent} and a resolution as arguments, and
 * returns an array of {@link module:ol/extent~Extent} with the extents to load. Usually this
 * is one of the standard {@link module:ol/loadingstrategy} strategies.
 *
 * @typedef {function(import("../extent.js").Extent, number, import("../proj/Projection.js").default): Array<import("../extent.js").Extent>} LoadingStrategy
 * @api
 */ /**
 * @classdesc
 * Events emitted by {@link module:ol/source/Vector~VectorSource} instances are instances of this
 * type.
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ parcelHelpers.export(exports, "VectorSourceEvent", ()=>VectorSourceEvent);
var _collectionJs = require("../Collection.js");
var _collectionJsDefault = parcelHelpers.interopDefault(_collectionJs);
var _collectionEventTypeJs = require("../CollectionEventType.js");
var _collectionEventTypeJsDefault = parcelHelpers.interopDefault(_collectionEventTypeJs);
var _objectEventTypeJs = require("../ObjectEventType.js");
var _objectEventTypeJsDefault = parcelHelpers.interopDefault(_objectEventTypeJs);
var _arrayJs = require("../array.js");
var _assertsJs = require("../asserts.js");
var _eventsJs = require("../events.js");
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("../extent.js");
var _featureloaderJs = require("../featureloader.js");
var _functionsJs = require("../functions.js");
var _loadingstrategyJs = require("../loadingstrategy.js");
var _objJs = require("../obj.js");
var _featureJs = require("../render/Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _rbushJs = require("../structs/RBush.js");
var _rbushJsDefault = parcelHelpers.interopDefault(_rbushJs);
var _utilJs = require("../util.js");
var _sourceJs = require("./Source.js");
var _sourceJsDefault = parcelHelpers.interopDefault(_sourceJs);
var _vectorEventTypeJs = require("./VectorEventType.js");
var _vectorEventTypeJsDefault = parcelHelpers.interopDefault(_vectorEventTypeJs);
class VectorSourceEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("./VectorEventType.js").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     import("./VectorEventType.js").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   loader: async (extent, resolution, projection) => {
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json' +
 *          'bbox=' + extent.join(',') + ',' + projection.getCode();
 *      const response = await fetch(url);
 *      if (!response.ok) {
 *        throw new Error('Network response was not ok');
 *      }
 *      const json = await response.json();
 *      const features = new GeoJSON().readFeatures(json, {
 *        featureProjection: projection,
 *      });
 *      return features;
 *    },
 *    strategy: bbox,
 *  });
 * ```
 *
 * When you want to retry a failed request, use
 * ```js
 * vectorSource.removeLoadedExtent(extent);
 * vectorSource.changed();
 * ```
 *
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class VectorSource extends (0, _sourceJsDefault.default) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events.js").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events.js").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<import("../Feature.js").FeatureLike>}
     */ this.loader_ = (0, _functionsJs.VOID);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, _assertsJs.assert)(this.format_, '`format` must be set when `url` is set');
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, _featureloaderJs.xhr)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, _loadingstrategyJs.all);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, _rbushJsDefault.default)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, _rbushJsDefault.default)();
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, _collectionJsDefault.default)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, _utilJs.getUid)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, _featureJsDefault.default)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, _eventsJs.listen)(feature, (0, _eventTypeJsDefault.default).CHANGE, this.handleFeatureChange_, this),
            (0, _eventsJs.listen)(feature, (0, _objectEventTypeJsDefault.default).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, _featureJsDefault.default)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, _featureJsDefault.default))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, _assertsJs.assert)(!(featureKey in this.uidIndex_), 'The passed `feature` was already added to the source');
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, _utilJs.getUid)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, _utilJs.getUid)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, _vectorEventTypeJsDefault.default).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, _vectorEventTypeJsDefault.default).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, _vectorEventTypeJsDefault.default).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, _collectionEventTypeJsDefault.default).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, _eventsJs.unlistenByKey));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach((feature)=>{
                this.removeFeatureInternal(feature);
            });
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, _featureJsDefault.default) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, _featureJsDefault.default) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, _objJs.isEmpty)(this.nullGeometryFeatures_)) (0, _arrayJs.extend)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        /** @type {Array<FeatureType>} */ const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, _extentJs.wrapAndSliceX)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType|null} Closest feature (or `null` if none found).
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, _functionsJs.TRUE);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, _featureJsDefault.default) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This will return `null` when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent | null} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_?.getExtent(extent) ?? null;
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, _utilJs.getUid)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) {
            const indexed = this.idIndex_[String(id)];
            if (Array.isArray(indexed)) return indexed.includes(feature);
            return indexed === feature;
        }
        return (0, _utilJs.getUid)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, _objJs.isEmpty)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, _extentJs.containsExtent)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                this.loading = Number(this.loading) + 1;
                this.dispatchEvent(new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).FEATURESLOADSTART));
                /**
         * @param {Array<FeatureType>} features Loaded features
         */ const success = (features)=>{
                    this.loading = Number(this.loading) - 1;
                    this.dispatchEvent(new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).FEATURESLOADEND, undefined, features));
                };
                const failure = ()=>{
                    this.changed();
                    this.loading = Number(this.loading) - 1;
                    this.dispatchEvent(new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).FEATURESLOADERROR));
                };
                //TODO Remove this when the deprecatedsuccess and failure arguments are removed
                let disableCallbacks = false;
                const loaded = this.loader_.call(this, extentToLoad, resolution, projection, (features)=>disableCallbacks || success(features), ()=>disableCallbacks || failure());
                if (loaded instanceof Promise) {
                    //TODO Remove this when the deprecatedsuccess and failure arguments are removed
                    disableCallbacks = true;
                    loaded.then((features)=>{
                        this.addFeatures(features);
                        success(features);
                    }).catch(failure);
                } else if (this.loader_.length < 4) this.loading = false;
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Marks an extent as not loaded, preserving any loaded areas outside it.
   *
   * Any previously loaded extent overlapping the given extent is split into its
   * remaining non-overlapping parts using {@link module:ol/extent~getDifference getDifference()},
   * which are then re-inserted into the tree.
   *
   * @param {import("../extent.js").Extent} extent Extent to mark as not loaded.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const intersectingExtents = [];
        loadedExtentsRtree.forEachInExtent(extent, function(object) {
            intersectingExtents.push(object);
        });
        intersectingExtents.forEach((intersectingExtent)=>{
            loadedExtentsRtree.remove(intersectingExtent);
            const remainders = (0, _extentJs.getDifference)(intersectingExtent.extent, extent);
            for (const remainder of remainders)loadedExtentsRtree.insert(remainder, {
                extent: remainder
            });
        });
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, _utilJs.getUid)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, _eventsJs.unlistenByKey));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, _vectorEventTypeJsDefault.default).REMOVEFEATURE)) this.dispatchEvent(new VectorSourceEvent((0, _vectorEventTypeJsDefault.default).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, _assertsJs.assert)(this.format_, '`format` must be set when `url` is set');
        this.url_ = url;
        this.setLoader((0, _featureloaderJs.xhr)(url, this.format_));
    }
    /**
   * @param {boolean} overlaps The source can have overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
exports.default = VectorSource;

},{"../Collection.js":"8dtMA","../CollectionEventType.js":"jVYia","../ObjectEventType.js":"i5oT2","../array.js":"2IuG2","../asserts.js":"csqTx","../events.js":"Vqr1Z","../events/Event.js":"5kI1G","../events/EventType.js":"79Bvl","../extent.js":"MPjK5","../featureloader.js":"gVvEy","../functions.js":"5nAKV","../loadingstrategy.js":"6eznf","../obj.js":"GxveT","../render/Feature.js":"THre5","../structs/RBush.js":"gnDNr","../util.js":"9Y20j","./Source.js":"aSp7S","./VectorEventType.js":"dUE26","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gVvEy":[function(require,module,exports,__globalThis) {
/**
 * @module ol/featureloader
 */ /**
 *
 * @type {boolean}
 * @private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * {@link module:ol/source/Vector~VectorSource} sources use a function of this type to
 * load features.
 *
 * This function takes 3 arguments: an {@link module:ol/extent~Extent} representing
 * the area to be loaded, a `{number}` representing the resolution (map units per pixel), and a
 * {@link module:ol/proj/Projection~Projection} for the projection. The function is expeced to return
 * a promise that resolves to an array of features.
 *
 * There are also a deprecated signature, with `void` as
 * return, and two additional arguments: an optional success callback that should get
 * the loaded features passed as an argument and an optional failure callback with no arguments.
 *
 * The function is responsible for loading the features and adding them to the
 * source.
 *
 * @template {import("./Feature.js").FeatureLike} [FeatureType=import("./Feature.js").FeatureLike]
 * @typedef {(
 *           extent: import("./extent.js").Extent,
 *           resolution: number,
 *           projection: import("./proj/Projection.js").default,
 *           success?: (features: Array<FeatureType>) => void,
 *           failure?: () => void) => void|Promise<Array<FeatureType>>} FeatureLoader
 * @api
 */ /**
 * {@link module:ol/source/Vector~VectorSource} sources use a function of this type to
 * get the url to load features from.
 *
 * This function takes an {@link module:ol/extent~Extent} representing the area
 * to be loaded, a `{number}` representing the resolution (map units per pixel)
 * and an {@link module:ol/proj/Projection~Projection} for the projection  as
 * arguments and returns a `{string}` representing the URL.
 * @typedef {function(import("./extent.js").Extent, number, import("./proj/Projection.js").default): string} FeatureUrlFunction
 * @api
 */ /**
 * @template {import("./Feature.js").FeatureLike} [FeatureType=import("./Feature.js").default]
 * @param {string|FeatureUrlFunction} url Feature URL service.
 * @param {import("./format/Feature.js").default<FeatureType>} format Feature format.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @param {function(Array<FeatureType>, import("./proj/Projection.js").default): void} success Success
 *      Function called with the loaded features and optionally with the data projection.
 * @param {function(): void} failure Failure
 *      Function called when loading failed.
 */ parcelHelpers.export(exports, "loadFeaturesXhr", ()=>loadFeaturesXhr);
/**
 * Create an XHR feature loader for a `url` and `format`. The feature loader
 * loads features (with XHR), parses the features, and adds them to the
 * vector source.
 *
 * @template {import("./Feature.js").FeatureLike} [FeatureType=import("./Feature.js").default]
 * @param {string|FeatureUrlFunction} url Feature URL service.
 * @param {import("./format/Feature.js").default<FeatureType>} format Feature format.
 * @return {FeatureLoader<FeatureType>} The feature loader.
 * @api
 */ parcelHelpers.export(exports, "xhr", ()=>xhr);
/**
 * Setter for the withCredentials configuration for the XHR.
 *
 * @param {boolean} xhrWithCredentials The value of withCredentials to set.
 * Compare https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/
 * @api
 */ parcelHelpers.export(exports, "setWithCredentials", ()=>setWithCredentials);
let withCredentials = false;
function loadFeaturesXhr(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == 'text' || type == 'json') source = xhr.responseText;
                else if (type == 'xml') source = xhr.responseXML || xhr.responseText;
                else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function xhr(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   * @this {import("./source/Vector.js").default<FeatureType>}
   */ return function(extent, resolution, projection, success, failure) {
        loadFeaturesXhr(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ (features, dataProjection)=>{
            this.addFeatures(features);
            if (success !== undefined) success(features);
        }, ()=>{
            this.changed();
            if (failure !== undefined) failure();
        });
    };
}
function setWithCredentials(xhrWithCredentials) {
    withCredentials = xhrWithCredentials;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6eznf":[function(require,module,exports,__globalThis) {
/**
 * @module ol/loadingstrategy
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Strategy function for loading all features with a single request.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */ parcelHelpers.export(exports, "all", ()=>all);
/**
 * Strategy function for loading features based on the view's extent and
 * resolution.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */ parcelHelpers.export(exports, "bbox", ()=>bbox);
/**
 * Creates a strategy function for loading features based on a tile grid.
 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {function(import("./extent.js").Extent, number, import("./proj.js").Projection): Array<import("./extent.js").Extent>} Loading strategy.
 * @api
 */ parcelHelpers.export(exports, "tile", ()=>tile);
var _projJs = require("./proj.js");
function all(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function bbox(extent, resolution) {
    return [
        extent
    ];
}
function tile(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, _projJs.fromUserResolution)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, _projJs.fromUserExtent)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, _projJs.toUserExtent)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}

},{"./proj.js":"gN0IK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"THre5":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render/Feature
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a geometry from an `ol/render/Feature`
 * @param {RenderFeature} renderFeature
 * Render Feature
 * @return {Point|MultiPoint|LineString|MultiLineString|Polygon|MultiPolygon}
 * New geometry instance.
 * @api
 */ parcelHelpers.export(exports, "toGeometry", ()=>toGeometry);
/**
 * Create an `ol/Feature` from an `ol/render/Feature`
 * @param {RenderFeature} renderFeature RenderFeature
 * @param {string} [geometryName] Geometry name to use
 * when creating the Feature.
 * @return {Feature} Newly constructed `ol/Feature` with properties,
 * geometry, and id copied over.
 * @api
 */ parcelHelpers.export(exports, "toFeature", ()=>toFeature);
var _featureJs = require("../Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _arrayJs = require("../array.js");
var _extentJs = require("../extent.js");
var _functionsJs = require("../functions.js");
var _lineStringJs = require("../geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _multiLineStringJs = require("../geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPointJs = require("../geom/MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _multiPolygonJs = require("../geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _pointJs = require("../geom/Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _polygonJs = require("../geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _centerJs = require("../geom/flat/center.js");
var _interiorpointJs = require("../geom/flat/interiorpoint.js");
var _interpolateJs = require("../geom/flat/interpolate.js");
var _orientJs = require("../geom/flat/orient.js");
var _simplifyJs = require("../geom/flat/simplify.js");
var _transformJs = require("../geom/flat/transform.js");
var _projJs = require("../proj.js");
var _transformJs1 = require("../transform.js");
/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const tmpTransform = (0, _transformJs1.create)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === 'Point' ? (0, _extentJs.createOrUpdateFromCoordinate)(this.flatCoordinates_) : (0, _extentJs.createOrUpdateFromFlatCoordinates)(this.flatCoordinates_, 0, this.flatCoordinates_.length, this.stride_);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, _extentJs.getCenter)(this.getExtent());
            this.flatInteriorPoints_ = (0, _interiorpointJs.getInteriorPointOfArray)(this.flatCoordinates_, 0, this.ends_, this.stride_, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, _orientJs.inflateEnds)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, _centerJs.linearRingss)(this.flatCoordinates_, 0, ends, this.stride_);
            this.flatInteriorPoints_ = (0, _interiorpointJs.getInteriorPointsOfMultiArray)(this.flatCoordinates_, 0, ends, this.stride_, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, _interpolateJs.interpolatePoint)(this.flatCoordinates_, 0, this.flatCoordinates_.length, this.stride_, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, _interpolateJs.interpolatePoint)(flatCoordinates, offset, end, this.stride_, 0.5);
                (0, _arrayJs.extend)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, _projJs.get)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, _extentJs.getHeight)(projectedExtent) / (0, _extentJs.getHeight)(pixelExtent);
            (0, _transformJs1.compose)(tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, _transformJs.transform2D)(this.flatCoordinates_, 0, this.flatCoordinates_.length, this.stride_, tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, _functionsJs.memoizeOne)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case 'LineString':
                    simplifiedFlatCoordinates.length = (0, _simplifyJs.douglasPeucker)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case 'MultiLineString':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, _simplifyJs.douglasPeuckerArray)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case 'Polygon':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, _simplifyJs.quantizeArray)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, this.stride_, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ RenderFeature.prototype.getFlatCoordinates = RenderFeature.prototype.getOrientedFlatCoordinates;
function toGeometry(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case 'Point':
            return new (0, _pointJsDefault.default)(renderFeature.getFlatCoordinates());
        case 'MultiPoint':
            return new (0, _multiPointJsDefault.default)(renderFeature.getFlatCoordinates(), 'XY');
        case 'LineString':
            return new (0, _lineStringJsDefault.default)(renderFeature.getFlatCoordinates(), 'XY');
        case 'MultiLineString':
            return new (0, _multiLineStringJsDefault.default)(renderFeature.getFlatCoordinates(), 'XY', /** @type {Array<number>} */ renderFeature.getEnds());
        case 'Polygon':
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, _orientJs.inflateEnds)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, _multiPolygonJsDefault.default)(flatCoordinates, 'XY', endss) : new (0, _polygonJsDefault.default)(flatCoordinates, 'XY', ends);
        default:
            throw new Error('Invalid geometry type:' + geometryType);
    }
}
function toFeature(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = toGeometry(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, _featureJsDefault.default)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
exports.default = RenderFeature;

},{"../Feature.js":"iVSSP","../array.js":"2IuG2","../extent.js":"MPjK5","../functions.js":"5nAKV","../geom/LineString.js":"223qD","../geom/MultiLineString.js":"5Cre5","../geom/MultiPoint.js":"jiQtb","../geom/MultiPolygon.js":"6i4VN","../geom/Point.js":"95T6m","../geom/Polygon.js":"3zws5","../geom/flat/center.js":"hNF1U","../geom/flat/interiorpoint.js":"jo2rT","../geom/flat/interpolate.js":"l0YUT","../geom/flat/orient.js":"1iFdH","../geom/flat/simplify.js":"5VJXL","../geom/flat/transform.js":"ahZFf","../proj.js":"gN0IK","../transform.js":"7TqcG","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"223qD":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/LineString
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../array.js");
var _extentJs = require("../extent.js");
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _closestJs = require("./flat/closest.js");
var _deflateJs = require("./flat/deflate.js");
var _inflateJs = require("./flat/inflate.js");
var _interpolateJs = require("./flat/interpolate.js");
var _intersectsextentJs = require("./flat/intersectsextent.js");
var _lengthJs = require("./flat/length.js");
var _segmentsJs = require("./flat/segments.js");
var _simplifyJs = require("./flat/simplify.js");
/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class LineString extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, _arrayJs.extend)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, _extentJs.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, _closestJs.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, _closestJs.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, _segmentsJs.forEach)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM') return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, _interpolateJs.lineStringCoordinateAtM)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, _inflateJs.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, _interpolateJs.interpolatePoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, _lengthJs.lineStringLength)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, _simplifyJs.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LineString(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, _intersectsextentJs.intersectsLineString)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent, this.getExtent());
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, _deflateJs.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
exports.default = LineString;

},{"../array.js":"2IuG2","../extent.js":"MPjK5","./SimpleGeometry.js":"5Lm1Z","./flat/closest.js":"jFnaY","./flat/deflate.js":"8nFry","./flat/inflate.js":"ainGz","./flat/interpolate.js":"l0YUT","./flat/intersectsextent.js":"9jzv1","./flat/length.js":"dcv40","./flat/segments.js":"bEawF","./flat/simplify.js":"5VJXL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"l0YUT":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/interpolate
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} fraction Fraction.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [dimension] Destination dimension (default is `2`)
 * @return {Array<number>} Destination.
 */ parcelHelpers.export(exports, "interpolatePoint", ()=>interpolatePoint);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} m M.
 * @param {boolean} extrapolate Extrapolate.
 * @return {import("../../coordinate.js").Coordinate|null} Coordinate.
 */ parcelHelpers.export(exports, "lineStringCoordinateAtM", ()=>lineStringCoordinateAtM);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} m M.
 * @param {boolean} extrapolate Extrapolate.
 * @param {boolean} interpolate Interpolate.
 * @return {import("../../coordinate.js").Coordinate|null} Coordinate.
 */ parcelHelpers.export(exports, "lineStringsCoordinateAtM", ()=>lineStringsCoordinateAtM);
var _arrayJs = require("../../array.js");
var _mathJs = require("../../math.js");
function interpolatePoint(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, _arrayJs.binarySearch)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, _mathJs.lerp)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function lineStringCoordinateAtM(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, _mathJs.lerp)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function lineStringsCoordinateAtM(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return lineStringCoordinateAtM(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return lineStringCoordinateAtM(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}

},{"../../array.js":"2IuG2","../../math.js":"b3dOZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5Cre5":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/MultiLineString
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../array.js");
var _extentJs = require("../extent.js");
var _lineStringJs = require("./LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _closestJs = require("./flat/closest.js");
var _deflateJs = require("./flat/deflate.js");
var _inflateJs = require("./flat/inflate.js");
var _interpolateJs = require("./flat/interpolate.js");
var _intersectsextentJs = require("./flat/intersectsextent.js");
var _lengthJs = require("./flat/length.js");
var _simplifyJs = require("./flat/simplify.js");
/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class MultiLineString extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, _arrayJs.extend)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, _arrayJs.extend)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, _extentJs.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, _closestJs.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, _closestJs.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM' || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, _interpolateJs.lineStringsCoordinateAtM)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, _inflateJs.inflateCoordinatesArray)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, _lineStringJsDefault.default)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, _lineStringJsDefault.default)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * Return the sum of all line string lengths
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        const ends = this.ends_;
        let start = 0;
        let length = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            length += (0, _lengthJs.lineStringLength)(this.flatCoordinates, start, ends[i], this.stride);
            start = ends[i];
        }
        return length;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, _interpolateJs.interpolatePoint)(flatCoordinates, offset, end, stride, 0.5);
            (0, _arrayJs.extend)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, _simplifyJs.douglasPeuckerArray)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new MultiLineString(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiLineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, _intersectsextentJs.intersectsLineStringArray)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, _deflateJs.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
exports.default = MultiLineString;

},{"../array.js":"2IuG2","../extent.js":"MPjK5","./LineString.js":"223qD","./SimpleGeometry.js":"5Lm1Z","./flat/closest.js":"jFnaY","./flat/deflate.js":"8nFry","./flat/inflate.js":"ainGz","./flat/interpolate.js":"l0YUT","./flat/intersectsextent.js":"9jzv1","./flat/length.js":"dcv40","./flat/simplify.js":"5VJXL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jiQtb":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/MultiPoint
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../array.js");
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _pointJs = require("./Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _deflateJs = require("./flat/deflate.js");
var _inflateJs = require("./flat/inflate.js");
/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class MultiPoint extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, _arrayJs.extend)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, _extentJs.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, _mathJs.squaredDistance)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, _inflateJs.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, _pointJsDefault.default)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, _pointJsDefault.default)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPoint';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, _extentJs.containsXY)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, _deflateJs.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
exports.default = MultiPoint;

},{"../array.js":"2IuG2","../extent.js":"MPjK5","../math.js":"b3dOZ","./Point.js":"95T6m","./SimpleGeometry.js":"5Lm1Z","./flat/deflate.js":"8nFry","./flat/inflate.js":"ainGz","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6i4VN":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/MultiPolygon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayJs = require("../array.js");
var _extentJs = require("../extent.js");
var _multiPointJs = require("./MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _polygonJs = require("./Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _areaJs = require("./flat/area.js");
var _centerJs = require("./flat/center.js");
var _closestJs = require("./flat/closest.js");
var _containsJs = require("./flat/contains.js");
var _deflateJs = require("./flat/deflate.js");
var _inflateJs = require("./flat/inflate.js");
var _interiorpointJs = require("./flat/interiorpoint.js");
var _intersectsextentJs = require("./flat/intersectsextent.js");
var _orientJs = require("./flat/orient.js");
var _simplifyJs = require("./flat/simplify.js");
/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class MultiPolygon extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, _arrayJs.extend)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, _arrayJs.extend)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, _extentJs.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, _closestJs.multiArrayMaxSquaredDelta)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, _closestJs.assignClosestMultiArrayPoint)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, _containsJs.linearRingssContainsXY)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, _areaJs.linearRingss)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, _orientJs.orientLinearRingsArray)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, _inflateJs.inflateMultiCoordinatesArray)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, _centerJs.linearRingss)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, _interiorpointJs.getInteriorPointsOfMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, _multiPointJsDefault.default)(this.getFlatInteriorPoints().slice(), 'XYM');
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, _orientJs.linearRingssAreOriented)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, _orientJs.orientLinearRingsArray)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, _simplifyJs.quantizeMultiArray)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new MultiPolygon(simplifiedFlatCoordinates, 'XY', simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, _polygonJsDefault.default)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, _polygonJsDefault.default)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPolygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, _intersectsextentJs.intersectsLinearRingMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, _deflateJs.deflateMultiCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
exports.default = MultiPolygon;

},{"../array.js":"2IuG2","../extent.js":"MPjK5","./MultiPoint.js":"jiQtb","./Polygon.js":"3zws5","./SimpleGeometry.js":"5Lm1Z","./flat/area.js":"2VE1b","./flat/center.js":"hNF1U","./flat/closest.js":"jFnaY","./flat/contains.js":"5TUtI","./flat/deflate.js":"8nFry","./flat/inflate.js":"ainGz","./flat/interiorpoint.js":"jo2rT","./flat/intersectsextent.js":"9jzv1","./flat/orient.js":"1iFdH","./flat/simplify.js":"5VJXL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hNF1U":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/flat/center
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @return {Array<number>} Flat centers.
 */ parcelHelpers.export(exports, "linearRingss", ()=>linearRingss);
var _extentJs = require("../../extent.js");
function linearRingss(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, _extentJs.createEmpty)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, _extentJs.createOrUpdateFromFlatCoordinates)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}

},{"../../extent.js":"MPjK5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gnDNr":[function(require,module,exports,__globalThis) {
/**
 * @module ol/structs/RBush
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rbush = require("rbush");
var _rbushDefault = parcelHelpers.interopDefault(_rbush);
var _extentJs = require("../extent.js");
var _objJs = require("../obj.js");
var _utilJs = require("../util.js");
/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, _rbushDefault.default)(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, _utilJs.getUid)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, _utilJs.getUid)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, _utilJs.getUid)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, _utilJs.getUid)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, _extentJs.equals)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   * @private
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, _objJs.isEmpty)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, _extentJs.createOrUpdate)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
exports.default = RBush;

},{"rbush":"Ksj8v","../extent.js":"MPjK5","../obj.js":"GxveT","../util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aSp7S":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/Source
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectJs = require("../Object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _projJs = require("../proj.js");
/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * a simple string (e.g. `'© Acme Inc.'`)
 * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class Source extends (0, _objectJsDefault.default) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, _projJs.get)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to a `truthy` value.
     * @type {boolean|number}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Resolve once the source is ready to be used (its state is `ready`), or
   * reject if it fails to load (its state is `error`). Sources that configure
   * asynchronously can use this to expose data (e.g. dimensions) through a
   * promise instead of the `change` event.
   * @return {Promise<void>} Resolves when the source is ready.
   * @protected
   */ ready() {
        const state = this.getState();
        if (state === 'ready') return Promise.resolve();
        if (state === 'error') return Promise.reject(new Error('Source failed to load'));
        return new Promise((resolve, reject)=>{
            const onChange = ()=>{
                const changedState = this.getState();
                if (changedState === 'ready') {
                    this.un('change', onChange);
                    resolve();
                } else if (changedState === 'error') {
                    this.un('change', onChange);
                    reject(new Error('Source failed to load'));
                }
            };
            this.on('change', onChange);
        });
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === 'function') return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
exports.default = Source;

},{"../Object.js":"lFhbz","../proj.js":"gN0IK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dUE26":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: 'addfeature',
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: 'changefeature',
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: 'clear',
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: 'removefeature',
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: 'featuresloadstart',
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: 'featuresloadend',
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: 'featuresloaderror'
}; /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7Lluw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startSync", ()=>startSync);
parcelHelpers.export(exports, "registerMap", ()=>registerMap);
parcelHelpers.export(exports, "registerBasemapLayers", ()=>registerBasemapLayers);
parcelHelpers.export(exports, "registerLayerControl", ()=>registerLayerControl);
parcelHelpers.export(exports, "registerRevisionControl", ()=>registerRevisionControl);
parcelHelpers.export(exports, "getRevisionControls", ()=>getRevisionControls);
parcelHelpers.export(exports, "registerWKTControl", ()=>registerWKTControl);
parcelHelpers.export(exports, "registerDateControl", ()=>registerDateControl);
parcelHelpers.export(exports, "registerHeatmapControl", ()=>registerHeatmapControl);
parcelHelpers.export(exports, "registerDataSourceControl", ()=>registerDataSourceControl);
// ── Slug helpers ──────────────────────────────────────────────────────────────
parcelHelpers.export(exports, "getLayerSlug", ()=>getLayerSlug);
// Given the base-layer names and the slug from the URL, return the name to show
// exclusively, or null to fall back to the default (all-visible) behaviour.
parcelHelpers.export(exports, "resolveInitialBasemap", ()=>resolveInitialBasemap);
// ── Push to address bar ───────────────────────────────────────────────────────
parcelHelpers.export(exports, "pushState", ()=>pushState);
parcelHelpers.export(exports, "debouncedPushState", ()=>debouncedPushState);
// ── Deserialize (always reads from the cached initial URL) ────────────────────
parcelHelpers.export(exports, "getLayersFromURL", ()=>getLayersFromURL);
parcelHelpers.export(exports, "getBasemapFromURL", ()=>getBasemapFromURL);
// Pure parser — returns `{ center, zoom }` or null. Accepts a
// URLSearchParams or anything URLSearchParams-compatible (i.e. `.get()`).
// Extracted so entries that don't use the full URLStateManager registry
// (e.g. caj-editor.js) can share the center/zoom parsing.
parcelHelpers.export(exports, "parseViewFromParams", ()=>parseViewFromParams);
parcelHelpers.export(exports, "getViewFromURL", ()=>getViewFromURL);
parcelHelpers.export(exports, "getRevisionsFromURL", ()=>getRevisionsFromURL);
parcelHelpers.export(exports, "setProductState", ()=>setProductState);
parcelHelpers.export(exports, "getInitialProductState", ()=>getInitialProductState);
parcelHelpers.export(exports, "getWKTToggleFromURL", ()=>getWKTToggleFromURL);
parcelHelpers.export(exports, "getFCDToggleFromURL", ()=>getFCDToggleFromURL);
parcelHelpers.export(exports, "getFCDModeFromURL", ()=>getFCDModeFromURL);
parcelHelpers.export(exports, "getFCDDirectionsFromURL", ()=>getFCDDirectionsFromURL);
parcelHelpers.export(exports, "getFCDDataSourceFromURL", ()=>getFCDDataSourceFromURL);
var _proj = require("ol/proj");
// ── Cached initial URL params (captured once at module load, before any
//    pushState call can overwrite the address bar) ─────────────────────────────
const _initialParams = new URLSearchParams(window.location.search);
// ── Initialization gate ───────────────────────────────────────────────────────
// pushState is a no-op until startSync() is called, preventing premature URL
// overwrites during the async auth + layer registration phase.
let _syncing = false;
function startSync() {
    _syncing = true;
    // Wire map view changes
    if (_map) _map.on("moveend", debouncedPushState);
    // Wire layer toggle changes
    _layerControls.forEach((ctrl)=>{
        ctrl.on("propertychange", function(e) {
            if (e.key === "vectorToggle") debouncedPushState();
        });
    });
    // Wire revision changes
    _revisionControls.forEach((rc)=>{
        rc.on("propertychange", function(e) {
            if (e.key === "selectedRevisions") debouncedPushState();
        });
    });
    // Wire WKT changes
    if (_wktControl) _wktControl.on("propertychange", function(e) {
        if (e.key === "wkt" || e.key === "wktToggle") debouncedPushState();
    });
    // Wire date changes
    if (_dateControl) _dateControl.on("propertychange", function(e) {
        if (e.key === "startDate" || e.key === "endDate") debouncedPushState();
    });
    // Wire heatmap control changes
    if (_heatmapControl) _heatmapControl.on("propertychange", function(e) {
        if (e.key === "heatmapToggle" || e.key === "displayMode" || e.key === "activeDirections") debouncedPushState();
    });
    // Wire data source control changes
    if (_dataSourceControl) _dataSourceControl.on("propertychange", function(e) {
        if (e.key === "dataSource") debouncedPushState();
    });
    // Wire basemap (base layer) selection changes
    if (_basemapLayers) _basemapLayers.forEach(({ layer })=>{
        layer.on("change:visible", debouncedPushState);
    });
    // Defer the first URL write to the next event loop tick so that any
    // synchronous processing that follows the caller (e.g. idTokenClaims
    // role checks) has completed before we serialize.
    setTimeout(pushState, 0);
    // Expand any collapsible (<details>) that contains a checked layer
    _layerControls.forEach((ctrl)=>{
        if (ctrl.get("vectorToggle") === true) {
            const details = ctrl.element.closest("details");
            if (details) details.open = true;
        }
    });
}
// ── Registry ──────────────────────────────────────────────────────────────────
let _map = null;
let _wktControl = null;
let _dateControl = null;
let _heatmapControl = null;
let _dataSourceControl = null;
let _productState = null;
let _basemapLayers = null; // [{ name, layer }] — base layers for basemap= param
const _layerControls = new Map(); // slug → VectorFeatureControl
const _revisionControls = new Map(); // slug → RevisionControl
function registerMap(map) {
    _map = map;
}
function registerBasemapLayers(layers) {
    _basemapLayers = layers;
}
function registerLayerControl(slug, control) {
    _layerControls.set(slug, control);
}
function registerRevisionControl(slug, revisionControl) {
    _revisionControls.set(slug, revisionControl);
}
function getRevisionControls() {
    // returns Array<{ slug, control }> for fan-out
    return Array.from(_revisionControls.entries()).map(([slug, control])=>({
            slug,
            control
        }));
}
function registerWKTControl(control) {
    _wktControl = control;
}
function registerDateControl(control) {
    _dateControl = control;
}
function registerHeatmapControl(control) {
    _heatmapControl = control;
}
function registerDataSourceControl(control) {
    _dataSourceControl = control;
}
function getLayerSlug(layerName) {
    return layerName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
function resolveInitialBasemap(names, urlSlug) {
    if (!urlSlug) return null;
    return names.find((name)=>getLayerSlug(name) === urlSlug) || null;
}
// Slug of the currently-visible base layer (for serialization), or null.
function visibleBasemapSlug(basemapLayers) {
    const entry = basemapLayers.find(({ layer })=>layer.getVisible());
    return entry ? getLayerSlug(entry.name) : null;
}
// ── Serialize ─────────────────────────────────────────────────────────────────
function serializeState() {
    const params = new URLSearchParams();
    if (_map) {
        const view = _map.getView();
        const center = view.getCenter();
        if (center) {
            const [lon, lat] = (0, _proj.toLonLat)(center);
            params.set("center", `${lon.toFixed(6)},${lat.toFixed(6)}`);
        }
        const zoom = view.getZoom();
        if (zoom != null) params.set("zoom", zoom.toFixed(4));
    }
    if (_basemapLayers) {
        const basemap = visibleBasemapSlug(_basemapLayers);
        if (basemap) params.set("basemap", basemap);
    }
    const activeSlugs = [];
    _layerControls.forEach((ctrl, slug)=>{
        if (ctrl.get("vectorToggle") === true) activeSlugs.push(slug);
    });
    if (activeSlugs.length > 0) params.set("layers", activeSlugs.join(","));
    // Only include revisions for layers that are currently visible, scoped by slug
    const allRevisions = [];
    _revisionControls.forEach((rc, slug)=>{
        const layerCtrl = _layerControls.get(slug);
        if (layerCtrl && layerCtrl.get("vectorToggle") === true) {
            const revisions = rc.get("selectedRevisions");
            if (revisions) revisions.forEach(({ layerId, revision })=>{
                allRevisions.push(`${slug}~${layerId}:${revision}`);
            });
        }
    });
    if (allRevisions.length > 0) params.set("revisions", allRevisions.join(","));
    if (_productState && _productState.scope) {
        params.set("product", _productState.scope);
        if (_productState.version) params.set("version", _productState.version);
    }
    if (_wktControl) {
        const wkt = _wktControl.get("wkt");
        if (wkt) params.set("wkt", wkt);
        if (_wktControl.get("wktToggle") === false) params.set("wktToggle", "0");
    }
    if (_dateControl) {
        const startDate = _dateControl.get("startDate");
        const endDate = _dateControl.get("endDate");
        if (startDate) params.set("startDate", startDate);
        if (endDate) params.set("endDate", endDate);
    }
    if (_heatmapControl) {
        if (_heatmapControl.get("heatmapToggle") === true) params.set("fcd", "1");
        const mode = _heatmapControl.get("displayMode");
        if (mode && mode !== "density") params.set("fcdMode", mode);
        const dirs = _heatmapControl.get("activeDirections");
        if (dirs != null && dirs !== "1,2,3,4,5,6,7,8,9,10,11,12") params.set("fcdDirs", dirs);
    }
    if (_dataSourceControl) {
        const ds = _dataSourceControl.get("dataSource");
        if (ds != null && ds !== 4) params.set("fcdSrc", ds);
    }
    return params;
}
function pushState() {
    if (!_syncing) return;
    const params = serializeState();
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState(null, "", newUrl);
}
let _debounceTimer = null;
function debouncedPushState() {
    if (!_syncing) return;
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(pushState, 300);
}
function getLayersFromURL() {
    const raw = _initialParams.get("layers") || "";
    return raw.split(",").filter(Boolean);
}
function getBasemapFromURL() {
    return _initialParams.get("basemap");
}
function parseViewFromParams(params) {
    const centerStr = params.get("center");
    const zoomStr = params.get("zoom");
    if (!centerStr || !zoomStr) return null;
    const [lon, lat] = centerStr.split(",").map(parseFloat);
    if (isNaN(lon) || isNaN(lat)) return null;
    const zoom = parseFloat(zoomStr);
    if (isNaN(zoom)) return null;
    return {
        center: (0, _proj.fromLonLat)([
            lon,
            lat
        ]),
        zoom
    };
}
function getViewFromURL() {
    return parseViewFromParams(_initialParams);
}
function getRevisionsFromURL() {
    const raw = _initialParams.get("revisions") || "";
    // Returns a Map of slug → [{layerId, revision}] so each OL layer only
    // restores its own revisions even if WFS layer IDs overlap across endpoints.
    const result = new Map();
    raw.split(",").filter(Boolean).forEach((entry)=>{
        const tildeIdx = entry.lastIndexOf("~");
        if (tildeIdx === -1) return;
        const slug = entry.substring(0, tildeIdx);
        const [layerId, revision] = entry.substring(tildeIdx + 1).split(":").map(Number);
        if (isNaN(layerId) || isNaN(revision)) return;
        if (!result.has(slug)) result.set(slug, []);
        result.get(slug).push({
            layerId,
            revision
        });
    });
    return result;
}
function setProductState(scope, version) {
    // version may be null when a product is selected but no report is applied.
    _productState = scope ? {
        scope,
        version: version || null
    } : null;
    debouncedPushState();
}
function getInitialProductState() {
    const scope = _initialParams.get("product");
    const version = _initialParams.get("version");
    return scope ? {
        scope,
        version: version || null
    } : null;
}
function getWKTToggleFromURL() {
    const raw = _initialParams.get("wktToggle");
    return raw !== "0"; // default true
}
function getFCDToggleFromURL() {
    return _initialParams.get("fcd") === "1";
}
function getFCDModeFromURL() {
    return _initialParams.get("fcdMode") || "density";
}
function getFCDDirectionsFromURL() {
    const raw = _initialParams.get("fcdDirs");
    if (!raw) return null;
    return raw.split(",").filter(Boolean);
}
function getFCDDataSourceFromURL() {
    const raw = _initialParams.get("fcdSrc");
    if (raw == null) return null;
    const n = Number(raw);
    return isNaN(n) ? null : n;
}

},{"ol/proj":"gN0IK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3M9kW":[function(require,module,exports,__globalThis) {
/**
 * @module ol/reproj
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canvasPool", ()=>canvasPool);
/**
 * Calculates ideal resolution to use from the source in order to achieve
 * pixel mapping as close as possible to 1:1 during reprojection.
 * The resolution is calculated regardless of what resolutions
 * are actually available in the dataset (TileGrid, Image, ...).
 *
 * @param {import("./proj/Projection.js").default} sourceProj Source projection.
 * @param {import("./proj/Projection.js").default} targetProj Target projection.
 * @param {import("./coordinate.js").Coordinate} targetCenter Target center.
 * @param {number} targetResolution Target resolution.
 * @return {number} The best resolution to use. Can be +-Infinity, NaN or 0.
 */ parcelHelpers.export(exports, "calculateSourceResolution", ()=>calculateSourceResolution);
/**
 * Calculates ideal resolution to use from the source in order to achieve
 * pixel mapping as close as possible to 1:1 during reprojection.
 * The resolution is calculated regardless of what resolutions
 * are actually available in the dataset (TileGrid, Image, ...).
 *
 * @param {import("./proj/Projection.js").default} sourceProj Source projection.
 * @param {import("./proj/Projection.js").default} targetProj Target projection.
 * @param {import("./extent.js").Extent} targetExtent Target extent
 * @param {number} targetResolution Target resolution.
 * @return {number} The best resolution to use. Can be +-Infinity, NaN or 0.
 */ parcelHelpers.export(exports, "calculateSourceExtentResolution", ()=>calculateSourceExtentResolution);
/**
 * @typedef {Object} ImageExtent
 * @property {import("./extent.js").Extent} extent Extent.
 * @property {import("./extent.js").Extent} [clipExtent] Clip extent.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Renders the source data into new canvas based on the triangulation.
 *
 * @param {number} width Width of the canvas.
 * @param {number} height Height of the canvas.
 * @param {number} pixelRatio Pixel ratio.
 * @param {number} sourceResolution Source resolution.
 * @param {import("./extent.js").Extent} sourceExtent Extent of the data source.
 * @param {number} targetResolution Target resolution.
 * @param {import("./extent.js").Extent} targetExtent Target extent.
 * @param {import("./reproj/Triangulation.js").default} triangulation Calculated triangulation.
 * @param {Array<ImageExtent>} sources Array of sources.
 * @param {number} gutter Gutter of the sources.
 * @param {boolean} [renderEdges] Render reprojection edges.
 * @param {boolean} [interpolate] Use linear interpolation when resampling.
 * @param {boolean} [drawSingle] Draw single source images directly without stitchContext.
 * @param {boolean} [clipExtent] Clip stitchContext to sourceExtent.
 * @return {HTMLCanvasElement|OffscreenCanvas} Canvas with reprojected data.
 */ parcelHelpers.export(exports, "render", ()=>render);
var _domJs = require("./dom.js");
var _extentJs = require("./extent.js");
var _mathJs = require("./math.js");
var _projJs = require("./proj.js");
let brokenDiagonalRendering_;
const canvasPool = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function isBrokenDiagonalRendering() {
    if (brokenDiagonalRendering_ === undefined) {
        const ctx = (0, _domJs.createCanvasContext2D)(6, 6, canvasPool);
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        drawTestTriangle(ctx, 4, 5, 4, 0);
        drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        brokenDiagonalRendering_ = verifyBrokenDiagonalRendering(data, 0) || verifyBrokenDiagonalRendering(data, 4) || verifyBrokenDiagonalRendering(data, 8);
        (0, _domJs.releaseCanvas)(ctx);
        canvasPool.push(ctx.canvas);
    }
    return brokenDiagonalRendering_;
}
function calculateSourceResolution(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, _projJs.transform)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, _projJs.getPointResolution)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, _extentJs.containsCoordinate)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, _projJs.getPointResolution)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function calculateSourceExtentResolution(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, _extentJs.getCenter)(targetExtent);
    let sourceResolution = calculateSourceResolution(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, _extentJs.forEachCorner)(targetExtent, function(corner) {
        sourceResolution = calculateSourceResolution(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function render(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, _domJs.createCanvasContext2D)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), canvasPool);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    const sourceDataExtent = (0, _extentJs.createEmpty)();
    sources.forEach(function(src, i, arr) {
        (0, _extentJs.extend)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, _domJs.createCanvasContext2D)(Math.round((0, _extentJs.getWidth)(sourceDataExtent) * stitchScale), Math.round((0, _extentJs.getHeight)(sourceDataExtent) * stitchScale), canvasPool);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, _extentJs.getWidth)(sourceExtent) * stitchScale;
            const height = (0, _extentJs.getHeight)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, _extentJs.getWidth)(src.clipExtent) * stitchScale;
                    const height = (0, _extentJs.getHeight)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, _extentJs.getWidth)(src.extent) * stitchScale;
                const srcHeight = (0, _extentJs.getHeight)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, _extentJs.getTopLeft)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, _mathJs.solveLinearSystem)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if (isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, _extentJs.getWidth)(extent) / image.width, -(0, _extentJs.getHeight)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, _domJs.releaseCanvas)(stitchContext);
        canvasPool.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}

},{"./dom.js":"gfuif","./extent.js":"MPjK5","./math.js":"b3dOZ","./proj.js":"gN0IK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"enYGk":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/Image
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageSourceEventType", ()=>ImageSourceEventType);
/**
 * @typedef {'imageloadend'|'imageloaderror'|'imageloadstart'} ImageSourceEventTypes
 */ /**
 * @classdesc
 * Events emitted by {@link module:ol/source/Image~ImageSource} instances are instances of this
 * type.
 */ parcelHelpers.export(exports, "ImageSourceEvent", ()=>ImageSourceEvent);
/**
 * Default image load function for image sources that use import("../Image.js").Image image
 * instances.
 * @param {import("../Image.js").default} image Image.
 * @param {string} src Source.
 */ parcelHelpers.export(exports, "defaultImageLoadFunction", ()=>defaultImageLoadFunction);
/**
 * Adjusts the extent so it aligns with pixel boundaries.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {number} resolution Reolution.
 * @param {number} pixelRatio Pixel ratio.
 * @param {number} ratio Ratio between request size and view size.
 * @return {import("../extent.js").Extent} Request extent.
 */ parcelHelpers.export(exports, "getRequestExtent", ()=>getRequestExtent);
var _imageJs = require("../Image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _arrayJs = require("../array.js");
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _projJs = require("../proj.js");
var _imageJs1 = require("../reproj/Image.js");
var _imageJsDefault1 = parcelHelpers.interopDefault(_imageJs1);
var _resolutionJs = require("../resolution.js");
var _sourceJs = require("./Source.js");
var _sourceJsDefault = parcelHelpers.interopDefault(_sourceJs);
var _commonJs = require("./common.js");
const ImageSourceEventType = {
    /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */ IMAGELOADSTART: 'imageloadstart',
    /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */ IMAGELOADEND: 'imageloadend',
    /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */ IMAGELOADERROR: 'imageloaderror'
};
class ImageSourceEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */ constructor(type, image){
        super(type);
        /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */ this.image = image;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */ /**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class ImageSource extends (0, _sourceJsDefault.default) {
    /**
   * @param {Options} options Single image source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
            interpolate: options.interpolate !== undefined ? options.interpolate : true
        });
        /***
     * @type {ImageSourceOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {ImageSourceOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {ImageSourceOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {import("../Image.js").Loader}
     */ this.loader = options.loader || null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;
        /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */ this.reprojectedImage_ = null;
        /**
     * @private
     * @type {number}
     */ this.reprojectedRevision_ = 0;
        /**
     * @protected
     * @type {import("../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.wantedExtent_;
        /**
     * @private
     * @type {number}
     */ this.wantedResolution_;
        /**
     * @private
     * @type {boolean}
     */ this.static_ = options.loader ? options.loader.length === 0 : false;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.wantedProjection_ = null;
    }
    /**
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {Array<number>|null} resolutions Resolutions.
   */ setResolutions(resolutions) {
        this.resolutions_ = resolutions;
    }
    /**
   * @protected
   * @param {number} resolution Resolution.
   * @return {number} Resolution.
   */ findNearestResolution(resolution) {
        const resolutions = this.getResolutions();
        if (resolutions) {
            const idx = (0, _arrayJs.linearFindNearest)(resolutions, resolution, 0);
            resolution = resolutions[idx];
        }
        return resolution;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   */ getImage(extent, resolution, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, _projJs.equivalent)(sourceProjection, projection)) {
            if (sourceProjection) projection = sourceProjection;
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        if (this.reprojectedImage_) {
            if (this.reprojectedRevision_ == this.getRevision() && (0, _projJs.equivalent)(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && (0, _extentJs.equals)(this.reprojectedImage_.getExtent(), extent)) return this.reprojectedImage_;
            this.reprojectedImage_.dispose();
            this.reprojectedImage_ = null;
        }
        this.reprojectedImage_ = new (0, _imageJsDefault1.default)(sourceProjection, projection, extent, resolution, pixelRatio, (extent, resolution, pixelRatio)=>this.getImageInternal(extent, resolution, pixelRatio, sourceProjection), this.getInterpolate());
        this.reprojectedRevision_ = this.getRevision();
        return this.reprojectedImage_;
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @protected
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.loader) {
            const requestExtent = getRequestExtent(extent, resolution, pixelRatio, 1);
            const requestResolution = this.findNearestResolution(resolution);
            if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && (0, _extentJs.containsExtent)(this.wantedExtent_, requestExtent) || (0, _extentJs.containsExtent)(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && (0, _resolutionJs.fromResolutionLike)(this.wantedResolution_) === requestResolution || (0, _resolutionJs.fromResolutionLike)(this.image.getResolution()) === requestResolution))) return this.image;
            this.wantedProjection_ = projection;
            this.wantedExtent_ = requestExtent;
            this.wantedResolution_ = requestResolution;
            this.image = new (0, _imageJsDefault.default)(requestExtent, requestResolution, pixelRatio, this.loader);
            this.image.addEventListener((0, _eventTypeJsDefault.default).CHANGE, this.handleImageChange.bind(this));
        }
        return this.image;
    }
    /**
   * Handle image change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleImageChange(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        let type;
        switch(image.getState()){
            case (0, _imageStateJsDefault.default).LOADING:
                this.loading = true;
                type = ImageSourceEventType.IMAGELOADSTART;
                break;
            case (0, _imageStateJsDefault.default).LOADED:
                this.loading = false;
                type = ImageSourceEventType.IMAGELOADEND;
                break;
            case (0, _imageStateJsDefault.default).ERROR:
                this.loading = false;
                type = ImageSourceEventType.IMAGELOADERROR;
                break;
            default:
                return;
        }
        if (this.hasListener(type)) this.dispatchEvent(new ImageSourceEvent(type, image));
    }
}
function defaultImageLoadFunction(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ image.getImage().src = src;
}
function getRequestExtent(extent, resolution, pixelRatio, ratio) {
    const imageResolution = resolution / pixelRatio;
    const center = (0, _extentJs.getCenter)(extent);
    const viewWidth = (0, _mathJs.ceil)((0, _extentJs.getWidth)(extent) / imageResolution, (0, _commonJs.DECIMALS));
    const viewHeight = (0, _mathJs.ceil)((0, _extentJs.getHeight)(extent) / imageResolution, (0, _commonJs.DECIMALS));
    const marginWidth = (0, _mathJs.ceil)((ratio - 1) * viewWidth / 2, (0, _commonJs.DECIMALS));
    const requestWidth = viewWidth + 2 * marginWidth;
    const marginHeight = (0, _mathJs.ceil)((ratio - 1) * viewHeight / 2, (0, _commonJs.DECIMALS));
    const requestHeight = viewHeight + 2 * marginHeight;
    return (0, _extentJs.getForViewAndSize)(center, imageResolution, 0, [
        requestWidth,
        requestHeight
    ]);
}
exports.default = ImageSource;

},{"../Image.js":"dfn7g","../ImageState.js":"7kySV","../array.js":"2IuG2","../events/Event.js":"5kI1G","../events/EventType.js":"79Bvl","../extent.js":"MPjK5","../math.js":"b3dOZ","../proj.js":"gN0IK","../reproj/Image.js":"87rqi","../resolution.js":"aLxf3","./Source.js":"aSp7S","./common.js":"eDS8y","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"87rqi":[function(require,module,exports,__globalThis) {
/**
 * @module ol/reproj/Image
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageJs = require("../Image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _imageStateJs = require("../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _eventsJs = require("../events.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("../extent.js");
var _reprojJs = require("../reproj.js");
var _resolutionJs = require("../resolution.js");
var _triangulationJs = require("./Triangulation.js");
var _triangulationJsDefault = parcelHelpers.interopDefault(_triangulationJs);
var _commonJs = require("./common.js");
/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../Image.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */ class ReprojImage extends (0, _imageJsDefault.default) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent.
   * @param {number} targetResolution Target resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {FunctionType} getImageFunction
   *     Function returning source images (extent, resolution, pixelRatio).
   * @param {boolean} interpolate Use linear interpolation when resampling.
   */ constructor(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, interpolate){
        let maxSourceExtent = sourceProj.getExtent();
        if (maxSourceExtent && sourceProj.canWrapX()) {
            maxSourceExtent = maxSourceExtent.slice();
            maxSourceExtent[0] = -Infinity;
            maxSourceExtent[2] = Infinity;
        }
        let maxTargetExtent = targetProj.getExtent();
        if (maxTargetExtent && targetProj.canWrapX()) {
            maxTargetExtent = maxTargetExtent.slice();
            maxTargetExtent[0] = -Infinity;
            maxTargetExtent[2] = Infinity;
        }
        const limitedTargetExtent = maxTargetExtent ? (0, _extentJs.getIntersection)(targetExtent, maxTargetExtent) : targetExtent;
        const targetCenter = (0, _extentJs.getCenter)(limitedTargetExtent);
        const sourceResolution = (0, _reprojJs.calculateSourceResolution)(sourceProj, targetProj, targetCenter, targetResolution);
        const errorThresholdInPixels = (0, _commonJs.ERROR_THRESHOLD);
        const triangulation = new (0, _triangulationJsDefault.default)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        const sourceExtent = triangulation.calculateSourceExtent();
        const sourceImage = (0, _extentJs.isEmpty)(sourceExtent) ? null : getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        const state = sourceImage ? (0, _imageStateJsDefault.default).IDLE : (0, _imageStateJsDefault.default).EMPTY;
        const sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        super(targetExtent, targetResolution, sourcePixelRatio, state);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.targetProj_ = targetProj;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = triangulation;
        /**
     * @private
     * @type {number}
     */ this.targetResolution_ = targetResolution;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.targetExtent_ = targetExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.sourceImage_ = sourceImage;
        /**
     * @private
     * @type {number}
     */ this.sourcePixelRatio_ = sourcePixelRatio;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = interpolate;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceListenerKey_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state == (0, _imageStateJsDefault.default).LOADING) this.unlistenSource_();
        super.disposeInternal();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image.
   * @override
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @return {import("../proj/Projection.js").default} Projection.
   */ getProjection() {
        return this.targetProj_;
    }
    /**
   * @private
   */ reproject_() {
        const sourceState = this.sourceImage_.getState();
        if (sourceState == (0, _imageStateJsDefault.default).LOADED) {
            const width = (0, _extentJs.getWidth)(this.targetExtent_) / this.targetResolution_;
            const height = (0, _extentJs.getHeight)(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = (0, _reprojJs.render)(width, height, this.sourcePixelRatio_, (0, _resolutionJs.fromResolutionLike)(this.sourceImage_.getResolution()), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage()
                }
            ], 0, undefined, this.interpolate_, true);
        }
        this.state = sourceState;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, _imageStateJsDefault.default).IDLE) {
            this.state = (0, _imageStateJsDefault.default).LOADING;
            this.changed();
            const sourceState = this.sourceImage_.getState();
            if (sourceState == (0, _imageStateJsDefault.default).LOADED || sourceState == (0, _imageStateJsDefault.default).ERROR) this.reproject_();
            else {
                this.sourceListenerKey_ = (0, _eventsJs.listen)(this.sourceImage_, (0, _eventTypeJsDefault.default).CHANGE, (e)=>{
                    const sourceState = this.sourceImage_.getState();
                    if (sourceState == (0, _imageStateJsDefault.default).LOADED || sourceState == (0, _imageStateJsDefault.default).ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                });
                this.sourceImage_.load();
            }
        }
    }
    /**
   * @private
   */ unlistenSource_() {
        (0, _eventsJs.unlistenByKey)(/** @type {!import("../events.js").EventsKey} */ this.sourceListenerKey_);
        this.sourceListenerKey_ = null;
    }
}
exports.default = ReprojImage;

},{"../Image.js":"dfn7g","../ImageState.js":"7kySV","../events.js":"Vqr1Z","../events/EventType.js":"79Bvl","../extent.js":"MPjK5","../reproj.js":"3M9kW","../resolution.js":"aLxf3","./Triangulation.js":"bUDS8","./common.js":"7kxSn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aLxf3":[function(require,module,exports,__globalThis) {
/**
 * @module ol/resolution
 */ /**
 * @typedef {number|Array<number>} ResolutionLike
 */ /**
 * @param {ResolutionLike} resolution Resolution.
 * @return {number} Resolution.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromResolutionLike", ()=>fromResolutionLike);
function fromResolutionLike(resolution) {
    if (Array.isArray(resolution)) return Math.min(...resolution);
    return resolution;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bUDS8":[function(require,module,exports,__globalThis) {
/**
 * @module ol/reproj/Triangulation
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _projJs = require("../proj.js");
var _transformJs = require("../transform.js");
/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   * @param {import("../transform.js").Transform} [sourceMatrix] Source transform matrix.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution, sourceMatrix){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = sourceMatrix ? (0, _projJs.createTransformFromCoordinateTransform)((input)=>(0, _transformJs.apply)(sourceMatrix, (0, _projJs.transform)(input, this.targetProj_, this.sourceProj_))) : (0, _projJs.getTransform)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, _extentJs.getWidth)(maxSourceExtent) >= (0, _extentJs.getWidth)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, _extentJs.getWidth)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, _extentJs.getWidth)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, _extentJs.getTopLeft)(targetExtent);
        const destinationTopRight = (0, _extentJs.getTopRight)(targetExtent);
        const destinationBottomRight = (0, _extentJs.getBottomRight)(targetExtent);
        const destinationBottomLeft = (0, _extentJs.getBottomLeft)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, _extentJs.getArea)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, _extentJs.boundingExtent)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, _extentJs.getWidth)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, _extentJs.boundingExtent)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, _extentJs.getWidth)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, _extentJs.intersects)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, _mathJs.modulo)(aSrc[0], sourceWorldWidth) + (0, _mathJs.modulo)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, _mathJs.modulo)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, _extentJs.createEmpty)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, _extentJs.extendCoordinate)(extent, src[0]);
            (0, _extentJs.extendCoordinate)(extent, src[1]);
            (0, _extentJs.extendCoordinate)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
exports.default = Triangulation;

},{"../extent.js":"MPjK5","../math.js":"b3dOZ","../proj.js":"gN0IK","../transform.js":"7TqcG","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7kxSn":[function(require,module,exports,__globalThis) {
/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_THRESHOLD", ()=>ERROR_THRESHOLD);
const ERROR_THRESHOLD = 0.5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eDS8y":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_WMS_VERSION", ()=>DEFAULT_WMS_VERSION);
parcelHelpers.export(exports, "DECIMALS", ()=>DECIMALS);
const DEFAULT_WMS_VERSION = '1.3.0';
const DECIMALS = 4;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4bdXc":[function(require,module,exports,__globalThis) {
/**
 * @module ol/uri
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Appends query parameters to a URI.
 *
 * @param {string} uri The original URI, which may already have query data.
 * @param {!Object} params An object where keys are URI-encoded parameter keys,
 *     and the values are arbitrary types or arrays.
 * @return {string} The new URI.
 */ parcelHelpers.export(exports, "appendParams", ()=>appendParams);
/**
 * @param {string} template The URL template.  Should have `{x}`, `{y}`, and `{z}` placeholders.  If
 * the template has a `{-y}` placeholder, the `maxY` parameter must be supplied.
 * @param {number} z The tile z coordinate.
 * @param {number} x The tile x coordinate.
 * @param {number} y The tile y coordinate.
 * @param {number} [maxY] The maximum y coordinate at the given z level.
 * @return {string} The URL.
 */ parcelHelpers.export(exports, "renderXYZTemplate", ()=>renderXYZTemplate);
/**
 * @param {Array<string>} urls List of URLs.
 * @param {number} z The tile z coordinate.
 * @param {number} x The tile x coordinate.
 * @param {number} y The tile y coordinate.
 * @return {string} The chosen URL.
 */ parcelHelpers.export(exports, "pickUrl", ()=>pickUrl);
/**
 * @param {string} url URL.
 * @return {Array<string>} Array of urls.
 */ parcelHelpers.export(exports, "expandUrl", ()=>expandUrl);
var _mathJs = require("./math.js");
var _tilecoordJs = require("./tilecoord.js");
function appendParams(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + '=' + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes('?') ? '&' : '?';
    return uri + qs;
}
const zRegEx = /\{z\}/g;
const xRegEx = /\{x\}/g;
const yRegEx = /\{y\}/g;
const dashYRegEx = /\{-y\}/g;
function renderXYZTemplate(template, z, x, y, maxY) {
    return template.replace(zRegEx, z.toString()).replace(xRegEx, x.toString()).replace(yRegEx, y.toString()).replace(dashYRegEx, function() {
        if (maxY === undefined) throw new Error('If the URL template has a {-y} placeholder, the grid extent must be known');
        return (maxY - y).toString();
    });
}
function pickUrl(urls, z, x, y) {
    const hash = (0, _tilecoordJs.hashZXY)(z, x, y);
    const index = (0, _mathJs.modulo)(hash, urls.length);
    return urls[index];
}
function expandUrl(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}

},{"./math.js":"b3dOZ","./tilecoord.js":"hRq5G","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hRq5G":[function(require,module,exports,__globalThis) {
/**
 * @module ol/tilecoord
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ parcelHelpers.export(exports, "createOrUpdate", ()=>createOrUpdate);
/**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {string} Key.
 */ parcelHelpers.export(exports, "getKeyZXY", ()=>getKeyZXY);
/**
 * Get the key for a tile coord.
 * @param {TileCoord} tileCoord The tile coord.
 * @return {string} Key.
 */ parcelHelpers.export(exports, "getKey", ()=>getKey);
/**
 * Get the tile cache key for a tile key obtained through `tile.getKey()`.
 * @param {string} tileKey The tile key.
 * @return {string} The cache key.
 */ parcelHelpers.export(exports, "getCacheKeyForTileKey", ()=>getCacheKeyForTileKey);
/**
 * @param {import("./source/Tile.js").default} source The tile source.
 * @param {string} sourceKey The source key.
 * @param {number} z The tile z level.
 * @param {number} x The tile x level.
 * @param {number} y The tile y level.
 * @return {string} The cache key.
 */ parcelHelpers.export(exports, "getCacheKey", ()=>getCacheKey);
/**
 * Get a tile coord given a key.
 * @param {string} key The tile coord key.
 * @return {TileCoord} The tile coord.
 */ parcelHelpers.export(exports, "fromKey", ()=>fromKey);
/**
 * @param {TileCoord} tileCoord Tile coord.
 * @return {number} Hash.
 */ parcelHelpers.export(exports, "hash", ()=>hash);
/**
 * @param {number} z The tile z coordinate.
 * @param {number} x The tile x coordinate.
 * @param {number} y The tile y coordinate.
 * @return {number} Hash.
 */ parcelHelpers.export(exports, "hashZXY", ()=>hashZXY);
/**
 * @param {TileCoord} tileCoord Tile coordinate.
 * @param {!import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {boolean} Tile coordinate is within extent and zoom level range.
 */ parcelHelpers.export(exports, "withinExtentAndZ", ()=>withinExtentAndZ);
var _utilJs = require("./util.js");
function createOrUpdate(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function getKeyZXY(z, x, y) {
    return z + '/' + x + '/' + y;
}
function getKey(tileCoord) {
    return getKeyZXY(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function getCacheKeyForTileKey(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number);
    return getKeyZXY(z, x, y);
}
function getCacheKey(source, sourceKey, z, x, y) {
    return `${(0, _utilJs.getUid)(source)},${sourceKey},${getKeyZXY(z, x, y)}`;
}
function fromKey(key) {
    return key.split('/').map(Number);
}
function hash(tileCoord) {
    return hashZXY(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function hashZXY(z, x, y) {
    return (x << z) + y;
}
function withinExtentAndZ(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}

},{"./util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dOPOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Returns [r, g, b] for a normalized value t in [0, 1].
// 0 = violet (low/slow), 1 = dark red (high/fast).
parcelHelpers.export(exports, "spectralColor", ()=>spectralColor);
parcelHelpers.export(exports, "MAX_SPEED_KMH", ()=>MAX_SPEED_KMH);
parcelHelpers.export(exports, "speedToT", ()=>speedToT);
parcelHelpers.export(exports, "colorForSpeed", ()=>colorForSpeed);
// CSS linear-gradient with stops positioned at each breakpoint's relative
// speed (not evenly along the spectrum), so it matches what the WMS renders.
parcelHelpers.export(exports, "speedGradient", ()=>speedGradient);
// WMS SPEED_STYLE parameter value for given speed breakpoints.
// Format: steps,R1,G1,B1,speed1,R2,G2,B2,speed2,...
parcelHelpers.export(exports, "wmsSpeedStyle", ()=>wmsSpeedStyle);
// Inverse of the FCD WMS speed renderer (trace-render SpeedColorScale): the
// server linearly interpolates RGB between adjacent breakpoint colors across
// integer speeds, so we recover speed by finding the breakpoint segment whose
// RGB segment passes closest to the sample, and lerping the speed by the same
// fraction.
parcelHelpers.export(exports, "interpolatedSpeedFromColor", ()=>interpolatedSpeedFromColor);
const SPECTRAL_REV = [
    [
        13,
        27,
        110
    ],
    [
        26,
        58,
        158
    ],
    [
        21,
        101,
        192
    ],
    [
        0,
        151,
        167
    ],
    [
        0,
        137,
        123
    ],
    [
        56,
        142,
        60
    ],
    [
        130,
        119,
        23
    ],
    [
        230,
        81,
        0
    ],
    [
        191,
        54,
        12
    ],
    [
        142,
        0,
        0
    ],
    [
        106,
        27,
        154
    ],
    [
        136,
        14,
        79
    ]
];
function spectralColor(t) {
    return interpolate(SPECTRAL_REV, t);
}
function interpolate(palette, t) {
    // Clamp to [0, 1]; coerce non-finite (NaN/Infinity) to 0 so a bad input can never
    // index the palette out of bounds (Math.min(1, NaN) is NaN, not 1).
    t = Number.isFinite(t) ? Math.max(0, Math.min(1, t)) : 0;
    const idx = t * (palette.length - 1);
    const lo = Math.floor(idx);
    const hi = Math.min(lo + 1, palette.length - 1);
    const frac = idx - lo;
    return [
        Math.round(palette[lo][0] + (palette[hi][0] - palette[lo][0]) * frac),
        Math.round(palette[lo][1] + (palette[hi][1] - palette[lo][1]) * frac),
        Math.round(palette[lo][2] + (palette[hi][2] - palette[lo][2]) * frac)
    ];
}
const MAX_SPEED_KMH = 130;
function speedToT(speed) {
    return Math.max(0, Math.min(1, Math.sqrt(speed / MAX_SPEED_KMH)));
}
function colorForSpeed(speed) {
    return spectralColor(speedToT(speed));
}
function speedGradient(direction, speeds) {
    const minSpeed = speeds[0];
    const maxSpeed = speeds[speeds.length - 1];
    const range = maxSpeed - minSpeed;
    const stops = speeds.map((speed)=>{
        const [r, g, b] = colorForSpeed(speed);
        const pos = range === 0 ? 0 : (speed - minSpeed) / range * 100;
        return `rgb(${r},${g},${b}) ${pos.toFixed(2)}%`;
    });
    return `linear-gradient(${direction}, ${stops.join(", ")})`;
}
function wmsSpeedStyle(speeds) {
    const parts = [
        speeds.length
    ];
    for (const speed of speeds){
        const [r, g, b] = colorForSpeed(speed);
        parts.push(r, g, b, speed);
    }
    return parts.join(",");
}
const _paletteCache = new WeakMap();
function paletteFor(breakpoints) {
    let palette = _paletteCache.get(breakpoints);
    if (!palette) {
        palette = breakpoints.map((speed)=>{
            const [r, g, b] = colorForSpeed(speed);
            return {
                speed,
                r,
                g,
                b
            };
        });
        _paletteCache.set(breakpoints, palette);
    }
    return palette;
}
function interpolatedSpeedFromColor(rgb, breakpoints) {
    const palette = paletteFor(breakpoints);
    let minDist = Infinity;
    let bestSpeed = null;
    for(let i = 0; i < palette.length - 1; i++){
        const a = palette[i];
        const b = palette[i + 1];
        const dr = b.r - a.r;
        const dg = b.g - a.g;
        const db = b.b - a.b;
        const segLenSq = dr * dr + dg * dg + db * db;
        const sr = rgb[0] - a.r;
        const sg = rgb[1] - a.g;
        const sb = rgb[2] - a.b;
        const t = segLenSq === 0 ? 0 : Math.max(0, Math.min(1, (sr * dr + sg * dg + sb * db) / segLenSq));
        const projDr = sr - t * dr;
        const projDg = sg - t * dg;
        const projDb = sb - t * db;
        const dist = projDr * projDr + projDg * projDg + projDb * projDb;
        if (dist < minDist) {
            minDist = dist;
            bestSpeed = a.speed + t * (b.speed - a.speed);
        }
    }
    return Math.round(bestSpeed);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3mhEo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The five basemap tile layers shared by the WKT viewer and CaJ editor:
 * OSM (no auth), Hillshade (ArcGIS, no auth), Satellite (Google, no auth),
 * Genesis (TomTom, Bearer), Orbis (TomTom, Bearer). Returned as
 * `[{ name, layer }, ...]` so each app can build its own UI (layerswitcher
 * vs. custom radio panel).
 */ parcelHelpers.export(exports, "createBasemapTileLayers", ()=>createBasemapTileLayers);
var _tile = require("ol/layer/Tile");
var _tileDefault = parcelHelpers.interopDefault(_tile);
var _osm = require("ol/source/OSM");
var _osmDefault = parcelHelpers.interopDefault(_osm);
var _source = require("ol/source");
var _tileLoader = require("./tileLoader");
// Google satellite is sharded across mt0–mt3 (matching Google's own clients) so
// tile requests aren't funnelled through a single host.
const GOOGLE_SATELLITE_URLS = [
    0,
    1,
    2,
    3
].map((i)=>`https://mt${i}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}`);
// Builds a Tile layer over an XYZ source whose requests are managed by
// `createManagedTileLoader` (retry + Bearer auth + abort-on-hide). The
// `change:visible` hook cancels in-flight tiles when the basemap is switched
// away and re-fetches on return; it fires identically under the main viewer's
// ol-layerswitcher and the CaJ editor's radio control (both toggle visibility).
function createManagedXYZLayer({ url, urls, getToken }) {
    const loader = (0, _tileLoader.createManagedTileLoader)(getToken ? {
        getToken
    } : {});
    const source = new (0, _source.XYZ)({
        tileLoadFunction: loader.tileLoadFunction,
        ...urls ? {
            urls
        } : {
            url
        }
    });
    const layer = new (0, _tileDefault.default)({
        source
    });
    layer.on("change:visible", ()=>loader.handleVisibility(layer.getVisible(), source));
    return layer;
}
function createBasemapTileLayers(azureLoginControl) {
    const getToken = ()=>azureLoginControl.get("idToken");
    // Order matters — the WKT viewer's ol-layerswitcher renders radios in this
    // array order. Preserve [Hillshade, Satellite, Genesis, OSM, Orbis] to
    // match the layout the main viewer has shipped for a long time.
    return [
        {
            name: "Hillshade",
            layer: new (0, _tileDefault.default)({
                source: new (0, _source.TileArcGISRest)({
                    url: "https://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
                })
            })
        },
        {
            name: "Satellite",
            layer: createManagedXYZLayer({
                urls: GOOGLE_SATELLITE_URLS
            })
        },
        {
            name: "Genesis",
            layer: createManagedXYZLayer({
                url: "/genesis-basemap/map/1/tile/basic/main/{z}/{x}/{y}.png",
                getToken
            })
        },
        {
            name: "OSM",
            layer: new (0, _tileDefault.default)({
                source: new (0, _osmDefault.default)()
            })
        },
        {
            name: "Orbis",
            layer: createManagedXYZLayer({
                url: "/genesis-basemap/maps/orbis/map-display/tile/{z}/{x}/{y}.png?apiVersion=1&tileSize=512",
                getToken
            })
        }
    ];
}

},{"ol/layer/Tile":"bby6q","ol/source/OSM":"gdYlp","ol/source":[["TileArcGISRest","enJpG","default"],["XYZ","fj0UH","default"]],"./tileLoader":"lj1FK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bby6q":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Tile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tileLayerJs = require("../renderer/canvas/TileLayer.js");
var _tileLayerJsDefault = parcelHelpers.interopDefault(_tileLayerJs);
var _baseTileJs = require("./BaseTile.js");
var _baseTileJsDefault = parcelHelpers.interopDefault(_baseTileJs);
/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class TileLayer extends (0, _baseTileJsDefault.default) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, _tileLayerJsDefault.default)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
exports.default = TileLayer;

},{"../renderer/canvas/TileLayer.js":"4t17Q","./BaseTile.js":"6trjI","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4t17Q":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/canvas/TileLayer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataTileJs = require("../../DataTile.js");
var _dataTileJsDefault = parcelHelpers.interopDefault(_dataTileJs);
var _imageTileJs = require("../../ImageTile.js");
var _imageTileJsDefault = parcelHelpers.interopDefault(_imageTileJs);
var _tileRangeJs = require("../../TileRange.js");
var _tileRangeJsDefault = parcelHelpers.interopDefault(_tileRangeJs);
var _tileStateJs = require("../../TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _arrayJs = require("../../array.js");
var _extentJs = require("../../extent.js");
var _projJs = require("../../proj.js");
var _tileJs = require("../../reproj/Tile.js");
var _tileJsDefault = parcelHelpers.interopDefault(_tileJs);
var _sizeJs = require("../../size.js");
var _lrucacheJs = require("../../structs/LRUCache.js");
var _lrucacheJsDefault = parcelHelpers.interopDefault(_lrucacheJs);
var _tilecoordJs = require("../../tilecoord.js");
var _transformJs = require("../../transform.js");
var _utilJs = require("../../util.js");
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, _extentJs.getIntersection)(extent, (0, _projJs.fromUserExtent)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, _extentJs.getIntersection)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class CanvasTileLayerRenderer extends (0, _layerJsDefault.default) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default|null}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, _extentJs.createEmpty)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, _tileRangeJsDefault.default)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, _tilecoordJs.createOrUpdate)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, _lrucacheJsDefault.default)(cacheSize);
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default|null>}
     * @private
     */ this.sourceTileCache_ = null;
        /**
     * @protected
     * @type {import("../../extent.js").Extent|null}
     */ this.layerExtent = null;
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getSourceTileCache() {
        if (!this.sourceTileCache_) this.sourceTileCache_ = new (0, _lrucacheJsDefault.default)(512);
        return this.sourceTileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = (0, _tilecoordJs.getCacheKey)(tileSource, tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            const projection = frameState.viewState.projection;
            const sourceProjection = tileSource.getProjection();
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, projection, !sourceProjection || (0, _projJs.equivalent)(sourceProjection, projection) ? undefined : this.getSourceTileCache());
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, _transformJs.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, _extentJs.containsCoordinate)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, _tileStateJsDefault.default).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, _sizeJs.toSize)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, _imageTileJsDefault.default) || tile instanceof (0, _tileJsDefault.default)) image = tile.getImage();
            else if (tile instanceof (0, _dataTileJsDefault.default)) {
                image = (0, _dataTileJs.asImageLike)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        if (!this.renderedProjection) this.renderedProjection = frameState.viewState.projection;
        else if (frameState.viewState.projection !== this.renderedProjection) {
            this.tileCache_.clear();
            this.renderedProjection = frameState.viewState.projection;
        }
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedSourceRevision_) this.renderedSourceRevision_ = sourceRevision;
        else if (this.renderedSourceRevision_ !== sourceRevision) {
            this.renderedSourceRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) {
                this.tileCache_.clear();
                this.sourceTileCache_?.clear();
            }
        }
        return true;
    }
    /**
   * Determine whether tiles for next extent should be enqueued for rendering.
   * @return {boolean} Rendering tiles for next extent is supported.
   * @protected
   */ enqueueTilesForNextExtent() {
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, _utilJs.getUid)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        const rotation = viewState.rotation;
        const viewport = rotation ? (0, _extentJs.getRotatedViewport)(viewState.center, viewState.resolution, rotation, frameState.size) : undefined;
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, _tileStateJsDefault.default).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, _tilecoordJs.createOrUpdate)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = (0, _tilecoordJs.getCacheKey)(this.getLayer().getSource(), staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, _tileStateJsDefault.default).LOADED) {
                    tile.endTransition((0, _utilJs.getUid)(this));
                    addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = (0, _tilecoordJs.getCacheKey)(source, sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, _tileStateJsDefault.default).LOADED) {
                    addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        this.renderComplete = true;
        /**
     * TODO:
     *  maybe skip transition when not fully opaque
     *  decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        this.updateStaleKeys(tileSource.getKey());
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        this.layerExtent = layerState.extent ? (0, _projJs.fromUserExtent)(layerState.extent, projection) : null;
        if (this.layerExtent) frameExtent = (0, _extentJs.getIntersection)(frameExtent, this.layerExtent);
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent && this.enqueueTilesForNextExtent()) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, _utilJs.getUid)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if (tileState === (0, _tileStateJsDefault.default).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, _tileStateJsDefault.default).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            if (tileState !== (0, _tileStateJsDefault.default).ERROR) this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, _transformJs.compose)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (this.layerExtent) this.clipUnrotated(context, frameState, this.layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, _arrayJs.ascending));
        /** @type {Array<import("../../extent.js").Extent>} */ const clips = [];
        /** @type {Array<number>} */ const clipZs = [];
        // Tiles at the target zoom that are still fading in. They are drawn in a
        // second pass on top of the (fully drawn) lower-z fallback, so the fade
        // reads as a coarse-to-fine sharpen instead of revealing the background.
        /** @type {Array<{tile: import("../../Tile.js").default, x: number, y: number, w: number, h: number, gutter: number}>} */ const fadingTiles = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, _extentJs.getTopLeft)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, _transformJs.apply)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, _tileStateJsDefault.default).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                // Only the target zoom tiles fade in; lower-z fallback tiles are just
                // gap fillers and must not animate. `inTransition` is false when
                // transitions are disabled, so this whole path is skipped then.
                const transition = currentZ === z;
                if (transition && tile.inTransition(uid)) {
                    // Still fading in - defer to the second pass and keep the fallback
                    // beneath it by not adding it to the clips.
                    fadingTiles.push({
                        tile,
                        x,
                        y,
                        w,
                        h,
                        gutter: tileGutter
                    });
                    this.renderedTiles.unshift(tile);
                    this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
                    continue;
                }
                // Draw only the parts of this tile that are not already covered by a
                // higher-z tile.
                const currentRect = [
                    x,
                    y,
                    x + w,
                    y + h
                ];
                /** @type {Array<import("../../extent.js").Extent>} */ const covered = [];
                for(let j = 0, jj = clips.length; j < jj; ++j)if (currentZ < clipZs[j] && (0, _extentJs.intersects)(currentRect, clips[j])) covered.push(clips[j]);
                let clipRects;
                if (covered.length > 0) clipRects = (0, _extentJs.subtractExtents)(currentRect, covered);
                clips.push(currentRect);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition, clipRects);
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        // Second pass: draw the fading target zoom tiles on top of the fallback.
        for(let i = 0, ii = fadingTiles.length; i < ii; ++i){
            const { tile, x, y, w, h, gutter } = fadingTiles[i];
            this.drawTile(tile, frameState, x, y, w, h, gutter, true, undefined);
        }
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, _extentJs.equals)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.postRender(this.context, frameState);
        if (this.layerExtent) context.restore();
        context.imageSmoothingEnabled = true;
        if (this.renderComplete) {
            /**
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (map, frameState)=>{
                const tileSourceKey = (0, _utilJs.getUid)(tileSource);
                const wantedTiles = frameState.wantedTiles[tileSourceKey];
                const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
                this.updateCacheSize(tilesCount);
                this.tileCache_.expireCache();
                this.sourceTileCache_?.expireCache();
            };
            frameState.postRenderFunctions.push(postRenderFunction);
        }
        // this normally is `div.ol-layer` and is a mocked div in worker
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @param {Array<import("../../extent.js").Extent>} [clipRects] Sub-rectangles
   *     of the tile to draw. When not provided, the whole tile is drawn; when an
   *     empty array is provided, nothing is drawn (the tile is fully covered by
   *     higher-z tiles).
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition, clipRects) {
        let image;
        if (tile instanceof (0, _dataTileJsDefault.default)) {
            image = (0, _dataTileJs.asImageLike)(tile.getData());
            if (!image) throw new Error('Rendering array data is not yet supported');
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, _utilJs.getUid)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        const imageWidth = image.width - 2 * gutter;
        const imageHeight = image.height - 2 * gutter;
        if (clipRects) {
            const scaleX = imageWidth / w;
            const scaleY = imageHeight / h;
            for(let i = 0, ii = clipRects.length; i < ii; ++i){
                const rect = clipRects[i];
                const rx = rect[0];
                const ry = rect[1];
                const rw = rect[2] - rect[0];
                const rh = rect[3] - rect[1];
                context.drawImage(image, gutter + (rx - x) * scaleX, gutter + (ry - y) * scaleY, rw * scaleX, rh * scaleY, rx, ry, rw, rh);
            }
        } else context.drawImage(image, gutter, gutter, imageWidth, imageHeight, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, _utilJs.getUid)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
exports.default = CanvasTileLayerRenderer;

},{"../../DataTile.js":"kfmqC","../../ImageTile.js":"iV22Q","../../TileRange.js":"4tyM4","../../TileState.js":"8OlGt","../../array.js":"2IuG2","../../extent.js":"MPjK5","../../proj.js":"gN0IK","../../reproj/Tile.js":"dDzxw","../../size.js":"8DeXL","../../structs/LRUCache.js":"au47x","../../tilecoord.js":"hRq5G","../../transform.js":"7TqcG","../../util.js":"9Y20j","./Layer.js":"h3JnK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kfmqC":[function(require,module,exports,__globalThis) {
/**
 * @module ol/DataTile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|HTMLVideoElement|ImageBitmap} ImageLike
 */ /**
 * @typedef {Uint8Array|Uint8ClampedArray|Float32Array|DataView} ArrayLike
 */ /**
 * Data that can be used with a DataTile.
 * @typedef {ArrayLike|ImageLike} Data
 */ /**
 * @param {Data} data Tile data.
 * @return {ImageLike|null} The image-like data.
 */ parcelHelpers.export(exports, "asImageLike", ()=>asImageLike);
/**
 * @param {Data} data Tile data.
 * @return {ArrayLike|null} The array-like data.
 */ parcelHelpers.export(exports, "asArrayLike", ()=>asArrayLike);
parcelHelpers.export(exports, "disposedError", ()=>disposedError);
/**
 * @param {ImageLike} image The image.
 * @return {Uint8ClampedArray} The data.
 */ parcelHelpers.export(exports, "toArray", ()=>toArray);
var _tileJs = require("./Tile.js");
var _tileJsDefault = parcelHelpers.interopDefault(_tileJs);
var _tileStateJs = require("./TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _domJs = require("./dom.js");
function asImageLike(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function asArrayLike(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const disposedError = new Error('disposed');
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|null}
 */ let sharedContext = null;
function toArray(image) {
    if (!sharedContext) sharedContext = (0, _domJs.createCanvasContext2D)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    sharedContext.clearRect(0, 0, width, height);
    sharedContext.drawImage(image, 0, 0);
    return sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class DataTile extends (0, _tileJsDefault.default) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, _tileStateJsDefault.default).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = asImageLike(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, _tileStateJsDefault.default).IDLE && this.state !== (0, _tileStateJsDefault.default).ERROR) return;
        this.state = (0, _tileStateJsDefault.default).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, _tileStateJsDefault.default).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, _tileStateJsDefault.default).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort(disposedError);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
exports.default = DataTile;

},{"./Tile.js":"gAcab","./TileState.js":"8OlGt","./dom.js":"gfuif","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gAcab":[function(require,module,exports,__globalThis) {
/**
 * @module ol/Tile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tileStateJs = require("./TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _easingJs = require("./easing.js");
var _eventTypeJs = require("./events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _targetJs = require("./events/Target.js");
var _targetJsDefault = parcelHelpers.interopDefault(_targetJs);
var _utilJs = require("./util.js");
/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class Tile extends (0, _targetJsDefault.default) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = '';
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, _eventTypeJsDefault.default).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, _tileStateJsDefault.default).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + '/' + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state === (0, _tileStateJsDefault.default).EMPTY) // no more state changes
        return;
        if (this.state !== (0, _tileStateJsDefault.default).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, _utilJs.abstract)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, _easingJs.easeIn)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
    /**
   * @override
   */ disposeInternal() {
        this.release();
        super.disposeInternal();
    }
}
exports.default = Tile;

},{"./TileState.js":"8OlGt","./easing.js":"1AzsJ","./events/EventType.js":"79Bvl","./events/Target.js":"cPkjL","./util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iV22Q":[function(require,module,exports,__globalThis) {
/**
 * @module ol/ImageTile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageJs = require("./Image.js");
var _tileJs = require("./Tile.js");
var _tileJsDefault = parcelHelpers.interopDefault(_tileJs);
var _tileStateJs = require("./TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _domJs = require("./dom.js");
var _hasJs = require("./has.js");
class ImageTile extends (0, _tileJsDefault.default) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {import('./dom.js').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, imageAttributes, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas}
     */ this.image_;
        if (0, _hasJs.WORKER_OFFSCREEN_CANVAS) this.image_ = new OffscreenCanvas(1, 1);
        else {
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, OffscreenCanvas, Image, or Video).
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, _tileStateJsDefault.default).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Get the cross origin of the ImageTile.
   * @return {string} Cross origin.
   */ getCrossOrigin() {
        return this.crossOrigin_;
    }
    /**
   * Get the referrer policy of the ImageTile.
   * @return {ReferrerPolicy} Referrer policy.
   */ getReferrerPolicy() {
        return this.referrerPolicy_;
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, _tileStateJsDefault.default).ERROR;
        this.unlistenImage_();
        this.image_ = getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        if (0, _hasJs.WORKER_OFFSCREEN_CANVAS) // OffscreenCanvas does not have naturalWidth and naturalHeight
        this.state = (0, _tileStateJsDefault.default).LOADED;
        else {
            const image = /** @type {HTMLImageElement} */ this.image_;
            if (image.naturalWidth && image.naturalHeight) this.state = (0, _tileStateJsDefault.default).LOADED;
            else this.state = (0, _tileStateJsDefault.default).EMPTY;
        }
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, _tileStateJsDefault.default).ERROR) {
            this.state = (0, _tileStateJsDefault.default).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        if (this.state == (0, _tileStateJsDefault.default).IDLE) {
            this.state = (0, _tileStateJsDefault.default).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, _imageJs.listenImage)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
    /**
   * @override
   */ disposeInternal() {
        this.unlistenImage_();
        this.image_ = null;
        super.disposeInternal();
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement|OffscreenCanvas} Blank image.
 */ function getBlankImage() {
    const ctx = (0, _domJs.createCanvasContext2D)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
exports.default = ImageTile;

},{"./Image.js":"dfn7g","./Tile.js":"gAcab","./TileState.js":"8OlGt","./dom.js":"gfuif","./has.js":"hbGE6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4tyM4":[function(require,module,exports,__globalThis) {
/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {number} minX Minimum X.
 * @param {number} maxX Maximum X.
 * @param {number} minY Minimum Y.
 * @param {number} maxY Maximum Y.
 * @param {TileRange} [tileRange] TileRange.
 * @return {TileRange} Tile range.
 */ parcelHelpers.export(exports, "createOrUpdate", ()=>createOrUpdate);
class TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function createOrUpdate(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new TileRange(minX, maxX, minY, maxY);
}
exports.default = TileRange;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dDzxw":[function(require,module,exports,__globalThis) {
/**
 * @module ol/reproj/Tile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tileJs = require("../Tile.js");
var _tileJsDefault = parcelHelpers.interopDefault(_tileJs);
var _tileStateJs = require("../TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _domJs = require("../dom.js");
var _eventsJs = require("../events.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _reprojJs = require("../reproj.js");
var _triangulationJs = require("./Triangulation.js");
var _triangulationJsDefault = parcelHelpers.interopDefault(_triangulationJs);
var _commonJs = require("./common.js");
/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} [tile] Tile.
 * @property {function(): import("../ImageTile.js").default} getTile Tile getter.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class ReprojTile extends (0, _tileJsDefault.default) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, _tileStateJsDefault.default).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, _extentJs.getIntersection)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, _extentJs.getArea)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, _tileStateJsDefault.default).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, _extentJs.getIntersection)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, _reprojJs.calculateSourceExtentResolution)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, _tileStateJsDefault.default).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, _commonJs.ERROR_THRESHOLD);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, _triangulationJsDefault.default)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, _tileStateJsDefault.default).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, _mathJs.clamp)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, _mathJs.clamp)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, _extentJs.getIntersection)(sourceExtent, maxSourceExtent);
        }
        if (!(0, _extentJs.getArea)(sourceExtent)) this.state = (0, _tileStateJsDefault.default).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, _extentJs.getWidth)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, _extentJs.wrapAndSliceX)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const offset = worldsAway * worldWidth;
                    this.sourceTiles_.push({
                        getTile: ()=>getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio),
                        offset
                    });
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, _tileStateJsDefault.default).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, _tileStateJsDefault.default).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, _tileStateJsDefault.default).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === 'number' ? size : size[0];
            const height = typeof size === 'number' ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, _reprojJs.render)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, _tileStateJsDefault.default).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        for (const sourceTile of this.sourceTiles_)sourceTile.tile = sourceTile.getTile();
        if (this.state == (0, _tileStateJsDefault.default).IDLE) {
            this.state = (0, _tileStateJsDefault.default).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile })=>{
                const state = tile.getState();
                if (state == (0, _tileStateJsDefault.default).IDLE || state == (0, _tileStateJsDefault.default).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, _eventsJs.listen)(tile, (0, _eventTypeJsDefault.default).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, _tileStateJsDefault.default).LOADED || state == (0, _tileStateJsDefault.default).ERROR || state == (0, _tileStateJsDefault.default).EMPTY) {
                            (0, _eventsJs.unlistenByKey)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, _tileStateJsDefault.default).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, _eventsJs.unlistenByKey));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, _domJs.releaseCanvas)(/** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ this.canvas_.getContext('2d'));
            (0, _reprojJs.canvasPool).push(this.canvas_);
            this.canvas_ = null;
        }
        this.sourceTiles_.length = 0;
        super.release();
    }
}
exports.default = ReprojTile;

},{"../Tile.js":"gAcab","../TileState.js":"8OlGt","../dom.js":"gfuif","../events.js":"Vqr1Z","../events/EventType.js":"79Bvl","../extent.js":"MPjK5","../math.js":"b3dOZ","../reproj.js":"3M9kW","./Triangulation.js":"bUDS8","./common.js":"7kxSn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"au47x":[function(require,module,exports,__globalThis) {
/**
 * @module ol/structs/LRUCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _disposableJs = require("../Disposable.js");
var _disposableJsDefault = parcelHelpers.interopDefault(_disposableJs);
var _assertsJs = require("../asserts.js");
/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    deleteOldest() {
        const entry = this.pop();
        if (entry instanceof (0, _disposableJsDefault.default)) entry.dispose();
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache. When the cache entry is a {@link module:ol/Disposable~Disposable},
   * the entry will be disposed.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.deleteOldest();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        while(this.oldest_)this.deleteOldest();
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, _assertsJs.assert)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, _assertsJs.assert)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, _assertsJs.assert)(!(key in this.entries_), 'Tried to set a value for a key that is used already');
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
exports.default = LRUCache;

},{"../Disposable.js":"7LWtn","../asserts.js":"csqTx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6trjI":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/BaseTile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
var _tilePropertyJs = require("./TileProperty.js");
var _tilePropertyJsDefault = parcelHelpers.interopDefault(_tilePropertyJs);
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("./Base.js").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("../render/EventType.js").LayerRenderEventTypes, import("../render/Event.js").default, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("./Base.js").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType.js").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class BaseTileLayer extends (0, _layerJsDefault.default) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, _tilePropertyJsDefault.default).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, _tilePropertyJsDefault.default).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, _tilePropertyJsDefault.default).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, _tilePropertyJsDefault.default).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
exports.default = BaseTileLayer;

},{"./Layer.js":"aZQOw","./TileProperty.js":"b0JWk","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b0JWk":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gdYlp":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/OSM
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATTRIBUTION", ()=>ATTRIBUTION);
var _xyzJs = require("./XYZ.js");
var _xyzJsDefault = parcelHelpers.interopDefault(_xyzJs);
const ATTRIBUTION = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy='origin-when-cross-origin'] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class OSM extends (0, _xyzJsDefault.default) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            ATTRIBUTION
        ];
        const url = options.url !== undefined ? options.url : 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous',
            referrerPolicy: options.referrerPolicy || 'origin-when-cross-origin',
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
exports.default = OSM;

},{"./XYZ.js":"fj0UH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fj0UH":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/XYZ
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tilegridJs = require("../tilegrid.js");
var _tileImageJs = require("./TileImage.js");
var _tileImageJsDefault = parcelHelpers.interopDefault(_tileImageJs);
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Deprecated.  Use an ImageTile source with a loader
 * instead.  Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] Deprecated.  Use an ImageTile source and provide an array of URLs for the
 * url option instead.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class XYZ extends (0, _tileImageJsDefault.default) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, _tilegridJs.createXYZ)({
            extent: (0, _tilegridJs.extentFromProjection)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            referrerPolicy: options.referrerPolicy,
            interpolate: options.interpolate,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
}
exports.default = XYZ;

},{"../tilegrid.js":"b2o08","./TileImage.js":"4cANx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b2o08":[function(require,module,exports,__globalThis) {
/**
 * @module ol/tilegrid
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WMTS", ()=>(0, _wmtsJsDefault.default));
parcelHelpers.export(exports, "TileGrid", ()=>(0, _tileGridJsDefault.default));
/**
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {!TileGrid} Default tile grid for the
 * passed projection.
 */ parcelHelpers.export(exports, "getForProjection", ()=>getForProjection);
/**
 * @param {TileGrid} tileGrid Tile grid.
 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {import("./tilecoord.js").TileCoord} Tile coordinate.
 */ parcelHelpers.export(exports, "wrapX", ()=>wrapX);
/**
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {import("./extent.js").Corner} [corner] Extent corner (default is `'top-left'`).
 * @return {!TileGrid} TileGrid instance.
 */ parcelHelpers.export(exports, "createForExtent", ()=>createForExtent);
/**
 * @typedef {Object} XYZOptions
 * @property {import("./extent.js").Extent} [extent] Extent for the tile grid. The origin for an XYZ tile grid is the
 * top-left corner of the extent. If `maxResolution` is not provided the zero level of the grid is defined by the resolution
 * at which one tile fits in the provided extent. If not provided, the extent of the EPSG:3857 projection is used.
 * @property {number} [maxResolution] Resolution at level zero.
 * @property {number} [maxZoom] Maximum zoom. The default is `42`. This determines the number of levels
 * in the grid set. For example, a `maxZoom` of 21 means there are 22 levels in the grid set.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {number|import("./size.js").Size} [tileSize=[256, 256]] Tile size in pixels.
 */ /**
 * Creates a tile grid with a standard XYZ tiling scheme.
 * @param {XYZOptions} [options] Tile grid options.
 * @return {!TileGrid} Tile grid instance.
 * @api
 */ parcelHelpers.export(exports, "createXYZ", ()=>createXYZ);
/**
 * @param {import("./proj.js").ProjectionLike} projection Projection.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {import("./extent.js").Corner} [corner] Extent corner (default is `'top-left'`).
 * @return {!TileGrid} TileGrid instance.
 */ parcelHelpers.export(exports, "createForProjection", ()=>createForProjection);
/**
 * Generate a tile grid extent from a projection.  If the projection has an
 * extent, it is used.  If not, a global extent is assumed.
 * @param {import("./proj.js").ProjectionLike} projection Projection.
 * @return {import("./extent.js").Extent} Extent.
 */ parcelHelpers.export(exports, "extentFromProjection", ()=>extentFromProjection);
var _extentJs = require("./extent.js");
var _projJs = require("./proj.js");
var _sizeJs = require("./size.js");
var _tileGridJs = require("./tilegrid/TileGrid.js");
var _tileGridJsDefault = parcelHelpers.interopDefault(_tileGridJs);
var _commonJs = require("./tilegrid/common.js");
var _wmtsJs = require("./tilegrid/WMTS.js");
var _wmtsJsDefault = parcelHelpers.interopDefault(_wmtsJs);
function getForProjection(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = createForProjection(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function wrapX(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = extentFromProjection(projection);
    if (!(0, _extentJs.containsCoordinate)(projectionExtent, center)) {
        const worldWidth = (0, _extentJs.getWidth)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function createForExtent(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : 'top-left';
    const resolutions = resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, _tileGridJsDefault.default)({
        extent: extent,
        origin: (0, _extentJs.getCorner)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function createXYZ(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, _projJs.get)('EPSG:3857').getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, _tileGridJsDefault.default)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, _commonJs.DEFAULT_MAX_ZOOM);
    tileSize = (0, _sizeJs.toSize)(tileSize !== undefined ? tileSize : (0, _commonJs.DEFAULT_TILE_SIZE));
    const height = (0, _extentJs.getHeight)(extent);
    const width = (0, _extentJs.getWidth)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function createForProjection(projection, maxZoom, tileSize, corner) {
    const extent = extentFromProjection(projection);
    return createForExtent(extent, maxZoom, tileSize, corner);
}
function extentFromProjection(projection) {
    projection = (0, _projJs.get)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, _projJs.METERS_PER_UNIT).degrees / projection.getMetersPerUnit();
        extent = (0, _extentJs.createOrUpdate)(-half, -half, half, half);
    }
    return extent;
}

},{"./extent.js":"MPjK5","./proj.js":"gN0IK","./size.js":"8DeXL","./tilegrid/TileGrid.js":"lCKXg","./tilegrid/common.js":"bFvtm","./tilegrid/WMTS.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lCKXg":[function(require,module,exports,__globalThis) {
/**
 * @module ol/tilegrid/TileGrid
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tileRangeJs = require("../TileRange.js");
var _tileRangeJsDefault = parcelHelpers.interopDefault(_tileRangeJs);
var _arrayJs = require("../array.js");
var _assertsJs = require("../asserts.js");
var _extentJs = require("../extent.js");
var _intersectsextentJs = require("../geom/flat/intersectsextent.js");
var _mathJs = require("../math.js");
var _sizeJs = require("../size.js");
var _tilecoordJs = require("../tilecoord.js");
var _commonJs = require("./common.js");
/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {Array<import("../TileRange.js").default>} [tileRanges] Pre-built tile ranges for each
 * zoom level. When provided, these are used directly as the full tile ranges instead of computing
 * them from `sizes`. Useful for setting per-level tile index bounds (e.g. from WMTS `TileMatrixSetLimits`).
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        let minZoom = options.minZoom;
        const resolutions = options.resolutions;
        if (minZoom === undefined && resolutions) minZoom = resolutions.findIndex((resolution)=>resolution !== undefined);
        /**
     * @protected
     * @type {number}
     */ this.minZoom = minZoom !== undefined ? minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = resolutions;
        (0, _assertsJs.assert)((0, _arrayJs.isSorted)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), '`resolutions` must be sorted in descending order');
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, _assertsJs.assert)(this.origins_.length == this.resolutions_.length, 'Number of `origins` and `resolutions` must be equal');
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, _extentJs.getTopLeft)(extent);
        (0, _assertsJs.assert)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 'Either `origin` or `origins` must be configured, never both');
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, _assertsJs.assert)(this.tileSizes_.length == this.resolutions_.length, 'Number of `tileSizes` and `resolutions` must be equal');
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, _commonJs.DEFAULT_TILE_SIZE) : null;
        (0, _assertsJs.assert)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 'Either `tileSize` or `tileSizes` must be configured, never both');
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.tileRanges !== undefined) this.fullTileRanges_ = options.tileRanges;
        else if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, _tileRangeJsDefault.default)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, _tileRangeJs.createOrUpdate)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the list of origins for the grid.
   * @return {Array<import("../coordinate.js").Coordinate>|null} Origin.
   */ getOrigins() {
        return this.origins_;
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, _tileRangeJs.createOrUpdate)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, _tileRangeJs.createOrUpdate)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, _tileRangeJs.createOrUpdate)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, _tileRangeJs.createOrUpdate)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, tmpTileCoord);
        const minX = tmpTileCoord[1];
        const minY = tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, tmpTileCoord);
        const maxX = tmpTileCoord[1];
        const maxY = tmpTileCoord[2];
        return (0, _tileRangeJs.createOrUpdate)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, _sizeJs.toSize)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, _sizeJs.toSize)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, _extentJs.createOrUpdate)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, _sizeJs.toSize)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, _mathJs.ceil)(tileCoordX, DECIMALS) - 1;
            tileCoordY = (0, _mathJs.ceil)(tileCoordY, DECIMALS) - 1;
        } else {
            tileCoordX = (0, _mathJs.floor)(tileCoordX, DECIMALS);
            tileCoordY = (0, _mathJs.floor)(tileCoordY, DECIMALS);
        }
        return (0, _tilecoordJs.createOrUpdate)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, _sizeJs.toSize)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, _mathJs.ceil)(tileCoordX, DECIMALS) - 1;
            tileCoordY = (0, _mathJs.ceil)(tileCoordY, DECIMALS) - 1;
        } else {
            tileCoordX = (0, _mathJs.floor)(tileCoordX, DECIMALS);
            tileCoordY = (0, _mathJs.floor)(tileCoordY, DECIMALS);
        }
        return (0, _tilecoordJs.createOrUpdate)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, _arrayJs.linearFindNearest)(this.resolutions_, resolution, opt_direction || 0);
        return (0, _mathJs.clamp)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, _intersectsextentJs.intersectsLinearRing)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
exports.default = TileGrid;

},{"../TileRange.js":"4tyM4","../array.js":"2IuG2","../asserts.js":"csqTx","../extent.js":"MPjK5","../geom/flat/intersectsextent.js":"9jzv1","../math.js":"b3dOZ","../size.js":"8DeXL","../tilecoord.js":"hRq5G","./common.js":"bFvtm","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4cANx":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/TileImage
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ parcelHelpers.export(exports, "defaultTileLoadFunction", ()=>defaultTileLoadFunction);
var _imageTileJs = require("../ImageTile.js");
var _imageTileJsDefault = parcelHelpers.interopDefault(_imageTileJs);
var _tileStateJs = require("../TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _hasJs = require("../has.js");
var _projJs = require("../proj.js");
var _tileJs = require("../reproj/Tile.js");
var _tileJsDefault = parcelHelpers.interopDefault(_tileJs);
var _tilecoordJs = require("../tilecoord.js");
var _tilegridJs = require("../tilegrid.js");
var _utilJs = require("../util.js");
var _urlTileJs = require("./UrlTile.js");
var _urlTileJsDefault = parcelHelpers.interopDefault(_urlTileJs);
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class TileImage extends (0, _urlTileJsDefault.default) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {ReferrerPolicy}
     */ this.referrerPolicy = options.referrerPolicy;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, _imageTileJsDefault.default);
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, _projJs.equivalent)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, _projJs.equivalent)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, _utilJs.getUid)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, _tilegridJs.getForProjection)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, _tileStateJsDefault.default).IDLE : (0, _tileStateJsDefault.default).EMPTY, tileUrl !== undefined ? tileUrl : '', {
            crossOrigin: this.crossOrigin,
            referrerPolicy: this.referrerPolicy
        }, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, _eventTypeJsDefault.default).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, _projJs.equivalent)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        const key = this.getKey();
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tile = new (0, _tileJsDefault.default)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection, tileCache), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        tile.key = key;
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection, tileCache) {
        const key = this.getKey();
        const cacheKey = (0, _tilecoordJs.getCacheKey)(this, key, z, x, y);
        if (tileCache && tileCache.containsKey(cacheKey)) {
            const tile = /** @type {!ImageTile} */ tileCache.get(cacheKey);
            return tile;
        }
        const tile = this.createTile_(z, x, y, pixelRatio, projection, key);
        tileCache?.set(cacheKey, tile);
        return tile;
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, _projJs.get)(projection);
        if (proj) {
            const projKey = (0, _utilJs.getUid)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
}
function defaultTileLoadFunction(imageTile, src) {
    if (0, _hasJs.WORKER_OFFSCREEN_CANVAS) {
        // special treatment for offscreen canvas
        const crossOrigin = imageTile.getCrossOrigin();
        /** @type {RequestMode} */ let mode = 'same-origin';
        /** @type {RequestCredentials} */ let credentials = 'same-origin';
        if (crossOrigin === 'anonymous' || crossOrigin === '') {
            mode = 'cors';
            credentials = 'omit';
        } else if (crossOrigin === 'use-credentials') {
            mode = 'cors';
            credentials = 'include';
        }
        const options = {
            mode,
            credentials,
            referrerPolicy: imageTile.getReferrerPolicy()
        };
        fetch(src, options).then((response)=>{
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.blob();
        }).then((blob)=>{
            return createImageBitmap(blob);
        }).then((imageBitmap)=>{
            const canvas = imageTile.getImage();
            canvas.width = imageBitmap.width;
            canvas.height = imageBitmap.height;
            const ctx = /** @type {OffscreenCanvas} */ canvas.getContext('2d');
            ctx.drawImage(imageBitmap, 0, 0);
            imageBitmap.close?.();
            // mock the image 'load' event
            canvas.dispatchEvent(new Event('load'));
        }).catch(()=>{
            const canvas = imageTile.getImage();
            canvas.dispatchEvent(new Event('error'));
        });
        return;
    }
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
exports.default = TileImage;

},{"../ImageTile.js":"iV22Q","../TileState.js":"8OlGt","../events/EventType.js":"79Bvl","../has.js":"hbGE6","../proj.js":"gN0IK","../reproj/Tile.js":"dDzxw","../tilecoord.js":"hRq5G","../tilegrid.js":"b2o08","../util.js":"9Y20j","./UrlTile.js":"1xl7v","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1xl7v":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/UrlTile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tileStateJs = require("../TileState.js");
var _tileStateJsDefault = parcelHelpers.interopDefault(_tileStateJs);
var _tileurlfunctionJs = require("../tileurlfunction.js");
var _uriJs = require("../uri.js");
var _utilJs = require("../util.js");
var _tileJs = require("./Tile.js");
var _tileJsDefault = parcelHelpers.interopDefault(_tileJs);
var _tileEventTypeJs = require("./TileEventType.js");
var _tileEventTypeJsDefault = parcelHelpers.interopDefault(_tileEventTypeJs);
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class UrlTile extends (0, _tileJsDefault.default) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, _utilJs.getUid)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, _tileStateJsDefault.default).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, _tileEventTypeJsDefault.default).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, _tileStateJsDefault.default).ERROR ? (0, _tileEventTypeJsDefault.default).TILELOADERROR : tileState == (0, _tileStateJsDefault.default).LOADED ? (0, _tileEventTypeJsDefault.default).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, _tileJs.TileSourceEvent)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, _uriJs.expandUrl)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, _tileurlfunctionJs.createFromTemplates)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
}
exports.default = UrlTile;

},{"../TileState.js":"8OlGt","../tileurlfunction.js":"8Rq6R","../uri.js":"4bdXc","../util.js":"9Y20j","./Tile.js":"gtmVJ","./TileEventType.js":"oTV6Q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8Rq6R":[function(require,module,exports,__globalThis) {
/**
 * @module ol/tileurlfunction
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} template Template.
 * @param {import("./tilegrid/TileGrid.js").default|null} tileGrid Tile grid.
 * @return {import("./Tile.js").UrlFunction} Tile URL function.
 */ parcelHelpers.export(exports, "createFromTemplate", ()=>createFromTemplate);
/**
 * @param {Array<string>} templates Templates.
 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {import("./Tile.js").UrlFunction} Tile URL function.
 */ parcelHelpers.export(exports, "createFromTemplates", ()=>createFromTemplates);
/**
 * @param {Array<import("./Tile.js").UrlFunction>} tileUrlFunctions Tile URL Functions.
 * @return {import("./Tile.js").UrlFunction} Tile URL function.
 */ parcelHelpers.export(exports, "createFromTileUrlFunctions", ()=>createFromTileUrlFunctions);
/**
 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @param {number} pixelRatio Pixel ratio.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {string|undefined} Tile URL.
 */ parcelHelpers.export(exports, "nullTileUrlFunction", ()=>nullTileUrlFunction);
var _mathJs = require("./math.js");
var _tilecoordJs = require("./tilecoord.js");
var _uriJs = require("./uri.js");
function createFromTemplate(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, _uriJs.renderXYZTemplate)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function createFromTemplates(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = createFromTemplate(templates[i], tileGrid);
    return createFromTileUrlFunctions(tileUrlFunctions);
}
function createFromTileUrlFunctions(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, _tilecoordJs.hash)(tileCoord);
        const index = (0, _mathJs.modulo)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function nullTileUrlFunction(tileCoord, pixelRatio, projection) {
    return undefined;
}

},{"./math.js":"b3dOZ","./tilecoord.js":"hRq5G","./uri.js":"4bdXc","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gtmVJ":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/Tile
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Tile~TileSource} instances are instances of this
 * type.
 */ parcelHelpers.export(exports, "TileSourceEvent", ()=>TileSourceEvent);
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _sizeJs = require("../size.js");
var _tilecoordJs = require("../tilecoord.js");
var _tilegridJs = require("../tilegrid.js");
var _utilJs = require("../util.js");
var _sourceJs = require("./Source.js");
var _sourceJsDefault = parcelHelpers.interopDefault(_sourceJs);
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("./TileEventType.js").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     import("./TileEventType.js").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class TileSource extends (0, _sourceJsDefault.default) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     * @protected
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, _sizeJs.toSize)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || (0, _utilJs.getUid)(this);
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, _tilegridJs.getForProjection)(projection);
        return this.tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, _sizeJs.toSize)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, _sizeJs.scale)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        const gridProjection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = projection !== undefined ? this.getTileGridForProjection(gridProjection) : this.tileGrid || this.getTileGridForProjection(gridProjection);
        if (this.getWrapX() && gridProjection.isGlobal()) tileCoord = (0, _tilegridJs.wrapX)(tileGrid, tileCoord, gridProjection);
        return (0, _tilecoordJs.withinExtentAndZ)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached reprojected tiles from the source. The next render cycle will create new tiles.
   * @api
   */ clear() {}
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
}
class TileSourceEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
exports.default = TileSource;

},{"../events/Event.js":"5kI1G","../size.js":"8DeXL","../tilecoord.js":"hRq5G","../tilegrid.js":"b2o08","../util.js":"9Y20j","./Source.js":"aSp7S","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"oTV6Q":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: 'tileloadstart',
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: 'tileloadend',
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: 'tileloaderror'
}; /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"enJpG":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/TileArcGISRest
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _sizeJs = require("../size.js");
var _tilecoordJs = require("../tilecoord.js");
var _tileImageJs = require("./TileImage.js");
var _tileImageJsDefault = parcelHelpers.interopDefault(_tileImageJs);
var _arcgisRestJs = require("./arcgisRest.js");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} [params] ArcGIS Rest parameters. This field is optional. Service defaults will be
 * used for any fields not specified. `format` is `png32` by default. `f` is `image` by
 * default. `transparent` is `true` by default.  `bbox`, `size`, `bboxSR`,
 * and `imageSR` will be set dynamically. Set `layers` to
 * override the default service layer visibility. See
 * https://developers.arcgis.com/rest/services-reference/export-map.htm
 * for further reference.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * The projection code must contain a numeric end portion separated by :
 * or the entire code must form a valid ArcGIS SpatialReference definition.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL.
 * The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] ArcGIS Rest service URL for a Map Service or Image Service. The
 * url should include /MapServer or /ImageServer.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.  To disable the opacity
 * transition, pass `transition: 0`.
 * @property {Array<string>} [urls] ArcGIS Rest service urls. Use this instead of `url` when the ArcGIS
 * Service supports multiple urls for export requests.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data from ArcGIS Rest services. Map and Image
 * Services are supported.
 *
 * For cached ArcGIS services, better performance is available using the
 * {@link module:ol/source/XYZ~XYZ} data source.
 * @api
 */ class TileArcGISRest extends (0, _tileImageJsDefault.default) {
    /**
   * @param {Options} [options] Tile ArcGIS Rest options.
   */ constructor(options){
        options = options ? options : {};
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            referrerPolicy: options.referrerPolicy,
            interpolate: options.interpolate,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {!Object}
     */ this.params_ = Object.assign({}, options.params);
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = (0, _extentJs.createEmpty)();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * @private
   * @return {string} The key for the current params.
   */ getKeyForParams_() {
        let i = 0;
        const res = [];
        for(const key in this.params_)res[i++] = key + '-' + this.params_[key];
        return res.join('/');
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../size.js").Size} tileSize Tile size.
   * @param {import("../extent.js").Extent} tileExtent Tile extent.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {Object} params Params.
   * @return {string|undefined} Request URL.
   * @private
   */ getRequestUrl_(tileCoord, tileSize, tileExtent, pixelRatio, projection, params) {
        const urls = this.urls;
        if (!urls) return undefined;
        let url;
        if (urls.length == 1) url = urls[0];
        else {
            const index = (0, _mathJs.modulo)((0, _tilecoordJs.hash)(tileCoord), urls.length);
            url = urls[index];
        }
        return (0, _arcgisRestJs.getRequestUrl)(url, tileExtent, (this.tileGrid || this.getTileGridForProjection(projection)).getResolution(tileCoord[0]), pixelRatio, projection, params);
    }
    /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   * @override
   */ getTilePixelRatio(pixelRatio) {
        return this.hidpi_ ? pixelRatio : 1;
    }
    /**
   * Set the user-provided params.
   * @param {Object} params Params.
   * @api
   */ setParams(params) {
        this.params_ = Object.assign({}, params);
        this.setKey(this.getKeyForParams_());
    }
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ updateParams(params) {
        Object.assign(this.params_, params);
        this.setKey(this.getKeyForParams_());
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
   * @param {number} pixelRatio The pixel ratio
   * @param {import("../proj/Projection.js").default} projection The projection
   * @return {string|undefined} The tile URL
   * @override
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(projection);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        if (pixelRatio != 1 && !this.hidpi_) pixelRatio = 1;
        const tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        let tileSize = (0, _sizeJs.toSize)(tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
        if (pixelRatio != 1) tileSize = (0, _sizeJs.scale)(tileSize, pixelRatio, this.tmpSize);
        // Apply default params and override with user specified values.
        const baseParams = {
            'f': 'image',
            'format': 'png32',
            'transparent': true
        };
        Object.assign(baseParams, this.params_);
        return this.getRequestUrl_(tileCoord, tileSize, tileExtent, pixelRatio, projection, baseParams);
    }
}
exports.default = TileArcGISRest;

},{"../extent.js":"MPjK5","../math.js":"b3dOZ","../size.js":"8DeXL","../tilecoord.js":"hRq5G","./TileImage.js":"4cANx","./arcgisRest.js":"jH6HH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jH6HH":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/arcgisRest
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} baseUrl Base URL for the ArcGIS Rest service.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @param {number} pixelRatio Pixel ratio.
 * @param {import("../proj/Projection.js").default} projection Projection.
 * @param {Object} params Params.
 * @return {string} Request URL.
 */ parcelHelpers.export(exports, "getRequestUrl", ()=>getRequestUrl);
/**
 * @typedef {Object} LoaderOptions
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting the image from
 * the remote server.
 * @property {Object<string,*>} [params] ArcGIS Rest parameters. This field is optional. Service
 * defaults will be used for any fields not specified. `format` is `png32` by default. `f` is
 * `image` by default. `transparent` is `true` by default.  `bbox`, `size`, `bboxSR`, and `imageSR`
 * will be set dynamically. Set `layers` to override the default service layer visibility. See
 * https://developers.arcgis.com/rest/services-reference/export-map.htm
 * for further reference.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is 'EPSG:3857'.
 * The projection code must contain a numeric end portion separated by :
 * or the entire code must form a valid ArcGIS SpatialReference definition.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport,
 * `2` means twice the size of the map viewport, and so on.
 * @property {string} url ArcGIS Rest service URL for a Map Service or Image Service. The url
 * should include /MapServer or /ImageServer.
 * @property {function(HTMLImageElement, string): Promise<import('../DataTile.js').ImageLike>} [load] Function
 * to perform loading of the image. Receives the created `HTMLImageElement` and the desired `src` as argument and
 * returns a promise resolving to the loaded or decoded image. Default is {@link module:ol/Image.decode}.
 */ /**
 * Creates a loader for ArcGIS Rest images.
 * @param {LoaderOptions} options Image ArcGIS Rest Options.
 * @return {import('../Image.js').ImageObjectPromiseLoader} ArcGIS Rest image.
 * @api
 */ parcelHelpers.export(exports, "createLoader", ()=>createLoader);
var _imageJs = require("../Image.js");
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _projJs = require("../proj.js");
var _uriJs = require("../uri.js");
var _imageJs1 = require("./Image.js");
var _commonJs = require("./common.js");
function getRequestUrl(baseUrl, extent, resolution, pixelRatio, projection, params) {
    // ArcGIS Server only wants the numeric portion of the projection ID.
    // (if there is no numeric portion the entire projection code must
    // form a valid ArcGIS SpatialReference definition).
    const srid = projection.getCode().split(/:(?=\d+$)/).pop();
    const imageResolution = resolution / pixelRatio;
    const imageSize = [
        (0, _mathJs.round)((0, _extentJs.getWidth)(extent) / imageResolution, (0, _commonJs.DECIMALS)),
        (0, _mathJs.round)((0, _extentJs.getHeight)(extent) / imageResolution, (0, _commonJs.DECIMALS))
    ];
    params['size'] = imageSize[0] + ',' + imageSize[1];
    params['bbox'] = extent.join(',');
    params['bboxSR'] = srid;
    params['imageSR'] = srid;
    params['dpi'] = Math.round(params['dpi'] ? params['dpi'] * pixelRatio : 90 * pixelRatio);
    const modifiedUrl = baseUrl.replace(/MapServer\/?$/, 'MapServer/export').replace(/ImageServer\/?$/, 'ImageServer/exportImage');
    return (0, _uriJs.appendParams)(modifiedUrl, params);
}
function createLoader(options) {
    const load = options.load ? options.load : (0, _imageJs.decode);
    const projection = (0, _projJs.get)(options.projection || 'EPSG:3857');
    const ratio = options.ratio ?? 1.5;
    const crossOrigin = options.crossOrigin ?? null;
    const referrerPolicy = options.referrerPolicy;
    return function(extent, resolution, pixelRatio) {
        pixelRatio = options.hidpi ? pixelRatio : 1;
        const params = {
            'f': 'image',
            'format': 'png32',
            'transparent': true
        };
        Object.assign(params, options.params);
        extent = (0, _imageJs1.getRequestExtent)(extent, resolution, pixelRatio, ratio);
        const src = getRequestUrl(options.url, extent, resolution, pixelRatio, projection, params);
        const image = new Image();
        image.crossOrigin = crossOrigin;
        if (referrerPolicy !== undefined) image.referrerPolicy = referrerPolicy;
        return load(image, src).then((image)=>{
            // Update resolution, because the server may return a smaller size than requested
            const resolution = (0, _extentJs.getWidth)(extent) / image.width * pixelRatio;
            return {
                image,
                extent,
                resolution,
                pixelRatio
            };
        });
    };
}

},{"../Image.js":"dfn7g","../extent.js":"MPjK5","../math.js":"b3dOZ","../proj.js":"gN0IK","../uri.js":"4bdXc","./Image.js":"enYGk","./common.js":"eDS8y","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lj1FK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Builds a `fetch`-based OpenLayers `tileLoadFunction` for one XYZ tile source,
 * plus a `handleVisibility` hook to wire to the layer's `change:visible`:
 * - injects an optional `Authorization: Bearer <token>` header (via `getToken`),
 * - retries a transient HTTP failure once,
 * - cancels every in-flight request when the layer is hidden (so a basemap you
 *   switched away from stops loading) and re-fetches on return via
 *   `source.refresh()` — but only if requests were actually aborted, so a
 *   fully-loaded layer keeps its cached tiles.
 */ parcelHelpers.export(exports, "createManagedTileLoader", ()=>createManagedTileLoader);
var _tileState = require("ol/TileState");
var _tileStateDefault = parcelHelpers.interopDefault(_tileState);
// Retry a transient tile failure once, with a short backoff. Kept deliberately
// small: the retry is awaited inside tileLoadFunction, so the tile holds one of
// OL's concurrent tile-queue slots (maxTilesLoading, default 16) until it
// settles. 429 is excluded — retrying a rate-limiter on a 1s backoff just earns
// another 429.
const RETRY_STATUSES = [
    408,
    500,
    502,
    503,
    504
];
const MAX_RETRIES = 1;
const RETRY_BACKOFF_MS = 1000;
function createManagedTileLoader({ getToken = ()=>null } = {}) {
    let controller = new AbortController();
    let inflight = 0;
    let wasAborted = false;
    function tileLoadFunction(tile, src) {
        const signal = controller.signal;
        inflight++;
        (async ()=>{
            try {
                for(let attempt = 0;; attempt++){
                    if (signal.aborted) throw new Error("aborted");
                    const response = await fetch(src, buildInit(getToken(), signal));
                    if (RETRY_STATUSES.includes(response.status) && attempt < MAX_RETRIES && !signal.aborted) {
                        await sleep(RETRY_BACKOFF_MS);
                        continue;
                    }
                    if (!response.ok) throw new Error("HTTP " + response.status);
                    const blob = await response.blob();
                    if (signal.aborted) throw new Error("aborted");
                    const url = URL.createObjectURL(blob);
                    const image = tile.getImage();
                    image.src = url;
                    const revoke = ()=>URL.revokeObjectURL(url);
                    image.addEventListener("load", revoke, {
                        once: true
                    });
                    image.addEventListener("error", revoke, {
                        once: true
                    });
                    return;
                }
            } catch  {
                tile.setState((0, _tileStateDefault.default).ERROR);
            } finally{
                inflight--;
            }
        })();
    }
    function handleVisibility(visible, source) {
        if (!visible) // Only abort (and flag a reload) if requests were actually in flight — a
        // layer that finished loading before being hidden keeps its cache.
        {
            if (inflight > 0) {
                controller.abort();
                controller = new AbortController();
                wasAborted = true;
            }
        } else if (wasAborted) {
            wasAborted = false;
            if (source) source.refresh();
        }
    }
    return {
        tileLoadFunction,
        handleVisibility
    };
}
function buildInit(token, signal) {
    const init = {
        signal
    };
    if (token) init.headers = {
        Authorization: "Bearer " + token
    };
    return init;
}
function sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}

},{"ol/TileState":"8OlGt","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"34shs":[function(require,module,exports,__globalThis) {
/**
 * @module ol/format/WKT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _featureJs = require("../Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _geometryCollectionJs = require("../geom/GeometryCollection.js");
var _geometryCollectionJsDefault = parcelHelpers.interopDefault(_geometryCollectionJs);
var _lineStringJs = require("../geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _multiLineStringJs = require("../geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPointJs = require("../geom/MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _multiPolygonJs = require("../geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _pointJs = require("../geom/Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _polygonJs = require("../geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _featureJs1 = require("./Feature.js");
var _textFeatureJs = require("./TextFeature.js");
var _textFeatureJsDefault = parcelHelpers.interopDefault(_textFeatureJs);
/**
 * Geometry constructors
 * @enum {function (new:import("../geom/Geometry.js").default, Array, import("../geom/Geometry.js").GeometryLayout)}
 */ const GeometryConstructor = {
    'POINT': (0, _pointJsDefault.default),
    'LINESTRING': (0, _lineStringJsDefault.default),
    'POLYGON': (0, _polygonJsDefault.default),
    'MULTIPOINT': (0, _multiPointJsDefault.default),
    'MULTILINESTRING': (0, _multiLineStringJsDefault.default),
    'MULTIPOLYGON': (0, _multiPolygonJsDefault.default)
};
/**
 * @typedef {Object} Options
 * @property {boolean} [splitCollection=false] Whether to split GeometryCollections into
 * multiple features on reading.
 */ /**
 * @typedef {Object} Token
 * @property {number} type Type.
 * @property {number|string} [value] Value.
 * @property {number} position Position.
 */ /**
 * @const
 * @type {string}
 */ const EMPTY = 'EMPTY';
/**
 * @const
 * @type {string}
 */ const Z = 'Z';
/**
 * @const
 * @type {string}
 */ const M = 'M';
/**
 * @const
 * @type {string}
 */ const ZM = 'ZM';
/**
 * @const
 * @enum {number}
 */ const TokenType = {
    START: 0,
    TEXT: 1,
    LEFT_PAREN: 2,
    RIGHT_PAREN: 3,
    NUMBER: 4,
    COMMA: 5,
    EOF: 6
};
/**
 * @type {Object<import("../geom/Geometry.js").Type, string>}
 */ const wktTypeLookup = {
    Point: 'POINT',
    LineString: 'LINESTRING',
    Polygon: 'POLYGON',
    MultiPoint: 'MULTIPOINT',
    MultiLineString: 'MULTILINESTRING',
    MultiPolygon: 'MULTIPOLYGON',
    GeometryCollection: 'GEOMETRYCOLLECTION',
    Circle: 'CIRCLE'
};
/**
 * Class to tokenize a WKT string.
 */ class Lexer {
    /**
   * @param {string} wkt WKT string.
   */ constructor(wkt){
        /**
     * @type {string}
     */ this.wkt = wkt;
        /**
     * @type {number}
     * @private
     */ this.index_ = -1;
    }
    /**
   * @param {string} c Character.
   * @return {boolean} Whether the character is alphabetic.
   * @private
   */ isAlpha_(c) {
        return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z';
    }
    /**
   * @param {string} c Character.
   * @param {boolean} [decimal] Whether the string number
   *     contains a dot, i.e. is a decimal number.
   * @return {boolean} Whether the character is numeric.
   * @private
   */ isNumeric_(c, decimal) {
        decimal = decimal !== undefined ? decimal : false;
        return c >= '0' && c <= '9' || c == '.' && !decimal;
    }
    /**
   * @param {string} c Character.
   * @return {boolean} Whether the character is whitespace.
   * @private
   */ isWhiteSpace_(c) {
        return c == ' ' || c == '\t' || c == '\r' || c == '\n';
    }
    /**
   * @return {string} Next string character.
   * @private
   */ nextChar_() {
        return this.wkt.charAt(++this.index_);
    }
    /**
   * Fetch and return the next token.
   * @return {Token} Next string token.
   */ nextToken() {
        const c = this.nextChar_();
        const position = this.index_;
        /** @type {number|string} */ let value = c;
        let type;
        if (c == '(') type = TokenType.LEFT_PAREN;
        else if (c == ',') type = TokenType.COMMA;
        else if (c == ')') type = TokenType.RIGHT_PAREN;
        else if (this.isNumeric_(c) || c == '-') {
            type = TokenType.NUMBER;
            value = this.readNumber_();
        } else if (this.isAlpha_(c)) {
            type = TokenType.TEXT;
            value = this.readText_();
        } else if (this.isWhiteSpace_(c)) return this.nextToken();
        else if (c === '') type = TokenType.EOF;
        else throw new Error('Unexpected character: ' + c);
        return {
            position: position,
            value: value,
            type: type
        };
    }
    /**
   * @return {number} Numeric token value.
   * @private
   */ readNumber_() {
        let c;
        const index = this.index_;
        let decimal = false;
        let scientificNotation = false;
        do {
            if (c == '.') decimal = true;
            else if (c == 'e' || c == 'E') scientificNotation = true;
            c = this.nextChar_();
        }while (this.isNumeric_(c, decimal) || // if we haven't detected a scientific number before, 'e' or 'E'
        // hint that we should continue to read
        !scientificNotation && (c == 'e' || c == 'E') || // once we know that we have a scientific number, both '-' and '+'
        // are allowed
        scientificNotation && (c == '-' || c == '+'));
        return parseFloat(this.wkt.substring(index, this.index_--));
    }
    /**
   * @return {string} String token value.
   * @private
   */ readText_() {
        let c;
        const index = this.index_;
        do c = this.nextChar_();
        while (this.isAlpha_(c));
        return this.wkt.substring(index, this.index_--).toUpperCase();
    }
}
/**
 * Class to parse the tokens from the WKT string.
 */ class Parser {
    /**
   * @param {Lexer} lexer The lexer.
   */ constructor(lexer){
        /**
     * @type {Lexer}
     * @private
     */ this.lexer_ = lexer;
        /**
     * @type {Token}
     * @private
     */ this.token_ = {
            position: 0,
            type: TokenType.START
        };
        /**
     * @type {import("../geom/Geometry.js").GeometryLayout}
     * @private
     */ this.layout_ = 'XY';
    }
    /**
   * Fetch the next token form the lexer and replace the active token.
   * @private
   */ consume_() {
        this.token_ = this.lexer_.nextToken();
    }
    /**
   * Tests if the given type matches the type of the current token.
   * @param {TokenType} type Token type.
   * @return {boolean} Whether the token matches the given type.
   */ isTokenType(type) {
        return this.token_.type == type;
    }
    /**
   * If the given type matches the current token, consume it.
   * @param {TokenType} type Token type.
   * @return {boolean} Whether the token matches the given type.
   */ match(type) {
        const isMatch = this.isTokenType(type);
        if (isMatch) this.consume_();
        return isMatch;
    }
    /**
   * Try to parse the tokens provided by the lexer.
   * @return {import("../geom/Geometry.js").default} The geometry.
   */ parse() {
        this.consume_();
        return this.parseGeometry_();
    }
    /**
   * Try to parse the dimensional info.
   * @return {import("../geom/Geometry.js").GeometryLayout} The layout.
   * @private
   */ parseGeometryLayout_() {
        /** @type {import("../geom/Geometry.js").GeometryLayout} */ let layout = 'XY';
        const dimToken = this.token_;
        if (this.isTokenType(TokenType.TEXT)) {
            const dimInfo = dimToken.value;
            if (dimInfo === Z) layout = 'XYZ';
            else if (dimInfo === M) layout = 'XYM';
            else if (dimInfo === ZM) layout = 'XYZM';
            if (layout !== 'XY') this.consume_();
        }
        return layout;
    }
    /**
   * @return {Array<import("../geom/Geometry.js").default>} A collection of geometries.
   * @private
   */ parseGeometryCollectionText_() {
        if (this.match(TokenType.LEFT_PAREN)) {
            const geometries = [];
            do geometries.push(this.parseGeometry_());
            while (this.match(TokenType.COMMA));
            if (this.match(TokenType.RIGHT_PAREN)) return geometries;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<number>} All values in a point.
   * @private
   */ parsePointText_() {
        if (this.match(TokenType.LEFT_PAREN)) {
            const coordinates = this.parsePoint_();
            if (this.match(TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<number>>} All points in a linestring.
   * @private
   */ parseLineStringText_() {
        if (this.match(TokenType.LEFT_PAREN)) {
            const coordinates = this.parsePointList_();
            if (this.match(TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<Array<number>>>} All points in a polygon.
   * @private
   */ parsePolygonText_() {
        if (this.match(TokenType.LEFT_PAREN)) {
            const coordinates = this.parseLineStringTextList_();
            if (this.match(TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<number>>} All points in a multipoint.
   * @private
   */ parseMultiPointText_() {
        if (this.match(TokenType.LEFT_PAREN)) {
            let coordinates;
            if (this.token_.type == TokenType.LEFT_PAREN) coordinates = this.parsePointTextList_();
            else coordinates = this.parsePointList_();
            if (this.match(TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<Array<number>>>} All linestring points
   *                                          in a multilinestring.
   * @private
   */ parseMultiLineStringText_() {
        if (this.match(TokenType.LEFT_PAREN)) {
            const coordinates = this.parseLineStringTextList_();
            if (this.match(TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<Array<Array<number>>>>} All polygon points in a multipolygon.
   * @private
   */ parseMultiPolygonText_() {
        if (this.match(TokenType.LEFT_PAREN)) {
            const coordinates = this.parsePolygonTextList_();
            if (this.match(TokenType.RIGHT_PAREN)) return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<number>} A point.
   * @private
   */ parsePoint_() {
        const coordinates = [];
        const dimensions = this.layout_.length;
        for(let i = 0; i < dimensions; ++i){
            const token = this.token_;
            if (this.match(TokenType.NUMBER)) coordinates.push(/** @type {number} */ token.value);
            else break;
        }
        if (coordinates.length == dimensions) return coordinates;
        throw new Error(this.formatErrorMessage_());
    }
    /**
   * @return {Array<Array<number>>} An array of points.
   * @private
   */ parsePointList_() {
        const coordinates = [
            this.parsePoint_()
        ];
        while(this.match(TokenType.COMMA))coordinates.push(this.parsePoint_());
        return coordinates;
    }
    /**
   * @return {Array<Array<number>>} An array of points.
   * @private
   */ parsePointTextList_() {
        const coordinates = [
            this.parsePointText_()
        ];
        while(this.match(TokenType.COMMA))coordinates.push(this.parsePointText_());
        return coordinates;
    }
    /**
   * @return {Array<Array<Array<number>>>} An array of points.
   * @private
   */ parseLineStringTextList_() {
        const coordinates = [
            this.parseLineStringText_()
        ];
        while(this.match(TokenType.COMMA))coordinates.push(this.parseLineStringText_());
        return coordinates;
    }
    /**
   * @return {Array<Array<Array<Array<number>>>>} An array of points.
   * @private
   */ parsePolygonTextList_() {
        const coordinates = [
            this.parsePolygonText_()
        ];
        while(this.match(TokenType.COMMA))coordinates.push(this.parsePolygonText_());
        return coordinates;
    }
    /**
   * @return {boolean} Whether the token implies an empty geometry.
   * @private
   */ isEmptyGeometry_() {
        const isEmpty = this.isTokenType(TokenType.TEXT) && this.token_.value == EMPTY;
        if (isEmpty) this.consume_();
        return isEmpty;
    }
    /**
   * Create an error message for an unexpected token error.
   * @return {string} Error message.
   * @private
   */ formatErrorMessage_() {
        return 'Unexpected `' + this.token_.value + '` at position ' + this.token_.position + ' in `' + this.lexer_.wkt + '`';
    }
    /**
   * @return {import("../geom/Geometry.js").default} The geometry.
   * @private
   */ parseGeometry_() {
        const token = this.token_;
        if (this.match(TokenType.TEXT)) {
            const geomType = /** @type {string} */ token.value;
            this.layout_ = this.parseGeometryLayout_();
            const isEmpty = this.isEmptyGeometry_();
            if (geomType == 'GEOMETRYCOLLECTION') {
                if (isEmpty) return new (0, _geometryCollectionJsDefault.default)([]);
                const geometries = this.parseGeometryCollectionText_();
                return new (0, _geometryCollectionJsDefault.default)(geometries);
            }
            const ctor = GeometryConstructor[geomType];
            if (!ctor) throw new Error('Invalid geometry type: ' + geomType);
            let coordinates;
            if (isEmpty) {
                if (geomType == 'POINT') coordinates = [
                    NaN,
                    NaN
                ];
                else coordinates = [];
            } else switch(geomType){
                case 'POINT':
                    coordinates = this.parsePointText_();
                    break;
                case 'LINESTRING':
                    coordinates = this.parseLineStringText_();
                    break;
                case 'POLYGON':
                    coordinates = this.parsePolygonText_();
                    break;
                case 'MULTIPOINT':
                    coordinates = this.parseMultiPointText_();
                    break;
                case 'MULTILINESTRING':
                    coordinates = this.parseMultiLineStringText_();
                    break;
                case 'MULTIPOLYGON':
                    coordinates = this.parseMultiPolygonText_();
                    break;
                default:
                    break;
            }
            return new ctor(coordinates, this.layout_);
        }
        throw new Error(this.formatErrorMessage_());
    }
}
/**
 * @classdesc
 * Geometry format for reading and writing data in the `WellKnownText` (WKT)
 * format.
 *
 * @api
 */ class WKT extends (0, _textFeatureJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * Split GeometryCollection into multiple features.
     * @type {boolean}
     * @private
     */ this.splitCollection_ = options.splitCollection !== undefined ? options.splitCollection : false;
    }
    /**
   * Parse a WKT string.
   * @param {string} wkt WKT string.
   * @return {import("../geom/Geometry.js").default}
   *     The geometry created.
   * @private
   */ parse_(wkt) {
        const lexer = new Lexer(wkt);
        const parser = new Parser(lexer);
        return parser.parse();
    }
    /**
   * @protected
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @override
   */ readFeatureFromText(text, options) {
        const geom = this.readGeometryFromText(text, options);
        const feature = new (0, _featureJsDefault.default)();
        feature.setGeometry(geom);
        return feature;
    }
    /**
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<Feature>} Features.
   * @override
   */ readFeaturesFromText(text, options) {
        let geometries = [];
        const geometry = this.readGeometryFromText(text, options);
        if (this.splitCollection_ && geometry.getType() == 'GeometryCollection') geometries = /** @type {GeometryCollection} */ geometry.getGeometriesArray();
        else geometries = [
            geometry
        ];
        const features = [];
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const feature = new (0, _featureJsDefault.default)();
            feature.setGeometry(geometries[i]);
            features.push(feature);
        }
        return features;
    }
    /**
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromText(text, options) {
        const geometry = this.parse_(text);
        return (0, _featureJs1.transformGeometryWithOptions)(geometry, false, options);
    }
    /**
   * @param {import("../Feature.js").default} feature Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   * @override
   */ writeFeatureText(feature, options) {
        const geometry = feature.getGeometry();
        if (geometry) return this.writeGeometryText(geometry, options);
        return '';
    }
    /**
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   * @override
   */ writeFeaturesText(features, options) {
        if (features.length == 1) return this.writeFeatureText(features[0], options);
        const geometries = [];
        for(let i = 0, ii = features.length; i < ii; ++i)geometries.push(features[i].getGeometry());
        const collection = new (0, _geometryCollectionJsDefault.default)(geometries);
        return this.writeGeometryText(collection, options);
    }
    /**
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   * @override
   */ writeGeometryText(geometry, options) {
        return encode((0, _featureJs1.transformGeometryWithOptions)(geometry, true, options));
    }
}
/**
 * @param {Point} geom Point geometry.
 * @return {string} Coordinates part of Point as WKT.
 */ function encodePointGeometry(geom) {
    const coordinates = geom.getCoordinates();
    if (coordinates.length === 0) return '';
    return coordinates.join(' ');
}
/**
 * @param {MultiPoint} geom MultiPoint geometry.
 * @return {string} Coordinates part of MultiPoint as WKT.
 */ function encodeMultiPointGeometry(geom) {
    const array = [];
    const components = geom.getPoints();
    for(let i = 0, ii = components.length; i < ii; ++i)array.push('(' + encodePointGeometry(components[i]) + ')');
    return array.join(',');
}
/**
 * @param {GeometryCollection} geom GeometryCollection geometry.
 * @return {string} Coordinates part of GeometryCollection as WKT.
 */ function encodeGeometryCollectionGeometry(geom) {
    const array = [];
    const geoms = geom.getGeometries();
    for(let i = 0, ii = geoms.length; i < ii; ++i)array.push(encode(geoms[i]));
    return array.join(',');
}
/**
 * @param {LineString|import("../geom/LinearRing.js").default} geom LineString geometry.
 * @return {string} Coordinates part of LineString as WKT.
 */ function encodeLineStringGeometry(geom) {
    const coordinates = geom.getCoordinates();
    const array = [];
    for(let i = 0, ii = coordinates.length; i < ii; ++i)array.push(coordinates[i].join(' '));
    return array.join(',');
}
/**
 * @param {MultiLineString} geom MultiLineString geometry.
 * @return {string} Coordinates part of MultiLineString as WKT.
 */ function encodeMultiLineStringGeometry(geom) {
    const array = [];
    const components = geom.getLineStrings();
    for(let i = 0, ii = components.length; i < ii; ++i)array.push('(' + encodeLineStringGeometry(components[i]) + ')');
    return array.join(',');
}
/**
 * @param {Polygon} geom Polygon geometry.
 * @return {string} Coordinates part of Polygon as WKT.
 */ function encodePolygonGeometry(geom) {
    const array = [];
    const rings = geom.getLinearRings();
    for(let i = 0, ii = rings.length; i < ii; ++i)array.push('(' + encodeLineStringGeometry(rings[i]) + ')');
    return array.join(',');
}
/**
 * @param {MultiPolygon} geom MultiPolygon geometry.
 * @return {string} Coordinates part of MultiPolygon as WKT.
 */ function encodeMultiPolygonGeometry(geom) {
    const array = [];
    const components = geom.getPolygons();
    for(let i = 0, ii = components.length; i < ii; ++i)array.push('(' + encodePolygonGeometry(components[i]) + ')');
    return array.join(',');
}
/**
 * @param {import("../geom/SimpleGeometry.js").default} geom SimpleGeometry geometry.
 * @return {string} Potential dimensional information for WKT type.
 */ function encodeGeometryLayout(geom) {
    const layout = geom.getLayout();
    let dimInfo = '';
    if (layout === 'XYZ' || layout === 'XYZM') dimInfo += Z;
    if (layout === 'XYM' || layout === 'XYZM') dimInfo += M;
    return dimInfo;
}
/**
 * @const
 * @type {Object<string, function(import("../geom/Geometry.js").default): string>}
 */ const GeometryEncoder = {
    'Point': encodePointGeometry,
    'LineString': encodeLineStringGeometry,
    'Polygon': encodePolygonGeometry,
    'MultiPoint': encodeMultiPointGeometry,
    'MultiLineString': encodeMultiLineStringGeometry,
    'MultiPolygon': encodeMultiPolygonGeometry,
    'GeometryCollection': encodeGeometryCollectionGeometry
};
/**
 * Encode a geometry as WKT.
 * @param {import("../geom/Geometry.js").default} geom The geometry to encode.
 * @return {string} WKT string for the geometry.
 */ function encode(geom) {
    const type = geom.getType();
    const geometryEncoder = GeometryEncoder[type];
    const enc = geometryEncoder(geom);
    let wktType = wktTypeLookup[type];
    if (typeof /** @type {?} */ geom.getFlatCoordinates === 'function') {
        const dimInfo = encodeGeometryLayout(/** @type {import("../geom/SimpleGeometry.js").default} */ geom);
        if (dimInfo.length > 0) wktType += ' ' + dimInfo;
    }
    if (enc.length === 0) return wktType + ' ' + EMPTY;
    return wktType + '(' + enc + ')';
}
exports.default = WKT;

},{"../Feature.js":"iVSSP","../geom/GeometryCollection.js":"aO2BB","../geom/LineString.js":"223qD","../geom/MultiLineString.js":"5Cre5","../geom/MultiPoint.js":"jiQtb","../geom/MultiPolygon.js":"6i4VN","../geom/Point.js":"95T6m","../geom/Polygon.js":"3zws5","./Feature.js":"lq6wN","./TextFeature.js":"4lUCi","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aO2BB":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/GeometryCollection
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventsJs = require("../events.js");
var _eventTypeJs = require("../events/EventType.js");
var _eventTypeJsDefault = parcelHelpers.interopDefault(_eventTypeJs);
var _extentJs = require("../extent.js");
var _geometryJs = require("./Geometry.js");
var _geometryJsDefault = parcelHelpers.interopDefault(_geometryJs);
/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class GeometryCollection extends (0, _geometryJsDefault.default) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, _eventsJs.unlistenByKey));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, _eventsJs.listen)(geometries[i], (0, _eventTypeJsDefault.default).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */ clone() {
        const geometryCollection = new GeometryCollection(cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, _extentJs.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        (0, _extentJs.createOrUpdateEmpty)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, _extentJs.extend)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'GeometryCollection';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, _extentJs.getCenter)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray(cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
exports.default = GeometryCollection;

},{"../events.js":"Vqr1Z","../events/EventType.js":"79Bvl","../extent.js":"MPjK5","./Geometry.js":"2pFcG","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lq6wN":[function(require,module,exports,__globalThis) {
/**
 * @module ol/format/Feature
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @template {import("../geom/Geometry.js").default|RenderFeature} T
 * @param {T} geometry Geometry.
 * @param {boolean} write Set to true for writing, false for reading.
 * @param {WriteOptions|ReadOptions} [options] Options.
 * @return {T} Transformed geometry.
 */ parcelHelpers.export(exports, "transformGeometryWithOptions", ()=>transformGeometryWithOptions);
/**
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {ReadOptions} [options] Read options.
 * @return {import("../extent.js").Extent} Transformed extent.
 */ parcelHelpers.export(exports, "transformExtentWithOptions", ()=>transformExtentWithOptions);
/**
 * @param {FeatureObject} object Feature object.
 * @param {WriteOptions|ReadOptions} [options] Options.
 * @return {RenderFeature|Array<RenderFeature>} Render feature.
 */ parcelHelpers.export(exports, "createRenderFeature", ()=>createRenderFeature);
/**
 * @param {GeometryObject|null} object Geometry object.
 * @param {WriteOptions|ReadOptions} [options] Options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ parcelHelpers.export(exports, "createGeometry", ()=>createGeometry);
var _featureJs = require("../Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _geometryCollectionJs = require("../geom/GeometryCollection.js");
var _geometryCollectionJsDefault = parcelHelpers.interopDefault(_geometryCollectionJs);
var _lineStringJs = require("../geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _multiLineStringJs = require("../geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPointJs = require("../geom/MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _multiPolygonJs = require("../geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _pointJs = require("../geom/Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _polygonJs = require("../geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _orientJs = require("../geom/flat/orient.js");
var _projJs = require("../proj.js");
var _featureJs1 = require("../render/Feature.js");
var _featureJsDefault1 = parcelHelpers.interopDefault(_featureJs1);
var _utilJs = require("../util.js");
/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {import('../Feature.js').FeatureLike} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @abstract
 * @api
 */ class FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {FeatureToFeatureClass<FeatureType>}
     */ this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */ (0, _featureJsDefault.default);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, _projJs.get)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === 'tile-pixels') {
                dataProjection = (0, _projJs.get)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeature(source, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */ readFeatures(source, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, _utilJs.abstract)();
    }
}
exports.default = FeatureFormat;
function transformGeometryWithOptions(geometry, write, options) {
    const featureProjection = options ? (0, _projJs.get)(options.featureProjection) : null;
    const dataProjection = options ? (0, _projJs.get)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, _projJs.equivalent)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === 'tile-pixels') transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, _projJs.getTransform)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function transformExtentWithOptions(extent, options) {
    const featureProjection = options ? (0, _projJs.get)(options.featureProjection) : null;
    const dataProjection = options ? (0, _projJs.get)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, _projJs.equivalent)(featureProjection, dataProjection)) return (0, _projJs.transformExtent)(extent, dataProjection, featureProjection);
    return extent;
}
const GeometryConstructor = {
    Point: (0, _pointJsDefault.default),
    LineString: (0, _lineStringJsDefault.default),
    Polygon: (0, _polygonJsDefault.default),
    MultiPoint: (0, _multiPointJsDefault.default),
    MultiLineString: (0, _multiLineStringJsDefault.default),
    MultiPolygon: (0, _multiPolygonJsDefault.default)
};
function orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, _orientJs.linearRingssAreOriented)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, _orientJs.orientLinearRingsArray)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, _orientJs.linearRingsAreOriented)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, _orientJs.orientLinearRings)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function createRenderFeature(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>createRenderFeature({
            ...object,
            geometry
        })).flat();
    const geometryType = geometry.type === 'MultiPolygon' ? 'Polygon' : geometry.type;
    if (geometryType === 'GeometryCollection' || geometryType === 'Circle') throw new Error('Unsupported geometry type: ' + geometryType);
    const stride = geometry.layout.length;
    return transformGeometryWithOptions(new (0, _featureJsDefault1.default)(geometryType, geometryType === 'Polygon' ? orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function createGeometry(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>createGeometry(geometry, options));
        return new (0, _geometryCollectionJsDefault.default)(geometries);
    }
    const Geometry = GeometryConstructor[object.type];
    return transformGeometryWithOptions(new Geometry(object.flatCoordinates, object.layout || 'XY', object.ends), false, options);
}

},{"../Feature.js":"iVSSP","../geom/GeometryCollection.js":"aO2BB","../geom/LineString.js":"223qD","../geom/MultiLineString.js":"5Cre5","../geom/MultiPoint.js":"jiQtb","../geom/MultiPolygon.js":"6i4VN","../geom/Point.js":"95T6m","../geom/Polygon.js":"3zws5","../geom/flat/orient.js":"1iFdH","../proj.js":"gN0IK","../render/Feature.js":"THre5","../util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4lUCi":[function(require,module,exports,__globalThis) {
/**
 * @module ol/format/TextFeature
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _featureJs = require("../format/Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _utilJs = require("../util.js");
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for text feature formats.
 *
 * @abstract
 */ class TextFeature extends (0, _featureJsDefault.default) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'text';
    }
    /**
   * Read the feature from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromText(getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromText(text, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read the features from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromText(getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromText(text, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read the geometry from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromText(getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromText(text, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromText(getText(source));
    }
    /**
   * @param {string} text Text.
   * @protected
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjectionFromText(text) {
        return this.dataProjection;
    }
    /**
   * Encode a feature as a string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return this.writeFeatureText(feature, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeFeatureText(feature, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return this.writeFeaturesText(features, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeFeaturesText(features, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Write a single geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return this.writeGeometryText(geometry, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeGeometryText(geometry, options) {
        return (0, _utilJs.abstract)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {string} Text.
 */ function getText(source) {
    if (typeof source === 'string') return source;
    return '';
}
exports.default = TextFeature;

},{"../format/Feature.js":"lq6wN","../util.js":"9Y20j","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"13EZt":[function(require,module,exports,__globalThis) {
/**
 * @module ol/geom/Circle
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extentJs = require("../extent.js");
var _simpleGeometryJs = require("./SimpleGeometry.js");
var _simpleGeometryJsDefault = parcelHelpers.interopDefault(_simpleGeometryJs);
var _deflateJs = require("./flat/deflate.js");
var _transformJs = require("./flat/transform.js");
/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class Circle extends (0, _simpleGeometryJsDefault.default) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   * @override
   */ clone() {
        const circle = new Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, _extentJs.createOrUpdate)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Circle';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, _extentJs.intersects)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, _extentJs.forEachCorner)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, _deflateJs.deflateCoordinate)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    /**
   * @override
   */ getCoordinates() {
        return null;
    }
    /**
   * @override
   */ setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, _transformJs.rotate)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ Circle.prototype.transform;
exports.default = Circle;

},{"../extent.js":"MPjK5","./SimpleGeometry.js":"5Lm1Z","./flat/deflate.js":"8nFry","./flat/transform.js":"ahZFf","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"90HT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAVIGABILITY_HIGHWAY_TYPES", ()=>NAVIGABILITY_HIGHWAY_TYPES);
parcelHelpers.export(exports, "ONEWAY_HIGHWAY_TYPES", ()=>ONEWAY_HIGHWAY_TYPES);
parcelHelpers.export(exports, "CURVATURE_HIGHWAY_TYPES", ()=>CURVATURE_HIGHWAY_TYPES);
parcelHelpers.export(exports, "GRADIENT_HIGHWAY_TYPES", ()=>GRADIENT_HIGHWAY_TYPES);
parcelHelpers.export(exports, "DUAL_CARRIAGEWAY_HIGHWAY_TYPES", ()=>DUAL_CARRIAGEWAY_HIGHWAY_TYPES);
parcelHelpers.export(exports, "EMISSION_REGULATION_HIGHWAY_TYPES", ()=>EMISSION_REGULATION_HIGHWAY_TYPES);
parcelHelpers.export(exports, "RAMP_HIGHWAY_TYPES", ()=>RAMP_HIGHWAY_TYPES);
parcelHelpers.export(exports, "CONTROLLED_ACCESS_HIGHWAY_TYPES", ()=>CONTROLLED_ACCESS_HIGHWAY_TYPES);
const MAJOR_HIGHWAY_TYPES = [
    "living_street",
    "motorway",
    "motorway_link",
    "primary",
    "primary_link",
    "residential",
    "road",
    "secondary",
    "secondary_link",
    "tertiary",
    "tertiary_link",
    "track",
    "trunk",
    "trunk_link",
    "unclassified",
    "construction"
];
const MINOR_HIGHWAY_TYPES = [
    "bridleway",
    "cycleway",
    "footway",
    "path",
    "pedestrian",
    "service",
    "steps",
    "track",
    "road"
];
const NAVIGABILITY_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES + MINOR_HIGHWAY_TYPES;
const ONEWAY_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES + MINOR_HIGHWAY_TYPES;
const CURVATURE_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
const GRADIENT_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
const DUAL_CARRIAGEWAY_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
const EMISSION_REGULATION_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES + [
    "pedestrian",
    "service",
    "track"
];
const RAMP_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
const CONTROLLED_ACCESS_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"i6VX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProperty", ()=>getProperty);
parcelHelpers.export(exports, "getPropertyEndingWith", ()=>getPropertyEndingWith);
parcelHelpers.export(exports, "getPropertyEndingWithExcludingLayer7", ()=>getPropertyEndingWithExcludingLayer7);
parcelHelpers.export(exports, "getPropertyMatching", ()=>getPropertyMatching);
/**
 * @typedef {Object} Tags
 * @property {ReturnType<typeof getPropertyEndingWith>} hdMap
 * @property {ReturnType<typeof getPropertyEndingWith>} laneDirection
 * @property {ReturnType<typeof getPropertyEndingWith>} laneFunction
 * @property {ReturnType<typeof getPropertyEndingWith>} hovLane
 * @property {ReturnType<typeof getPropertyEndingWith>} hov
 * @property {ReturnType<typeof getPropertyEndingWith>} vehicleRestrictionBus
 * @property {ReturnType<typeof getPropertyEndingWith>} vehicleRestrictionHGV
 * @property {ReturnType<typeof getPropertyEndingWith>} vehicleRestrictionMotorVehicle
 * @property {ReturnType<typeof getPropertyEndingWith>} vehicleRestrictionMotorcar
 * @property {ReturnType<typeof getPropertyEndingWith>} vehicleRestrictionPSV
 * @property {ReturnType<typeof getPropertyEndingWith>} vehicleRestrictionTaxi
 * @property {ReturnType<typeof getPropertyEndingWith>} laneBorder
 * @property {ReturnType<typeof getPropertyMatching>} lanesNormMotorVehicle
 * @property {ReturnType<typeof getPropertyMatching>} lanesNormMotorCar
 * @property {ReturnType<typeof getPropertyMatching>} lanesNormHgv
 * @property {ReturnType<typeof getPropertyMatching>} lanesNormPsv
 * @property {ReturnType<typeof getPropertyMatching>} lanesNormBus
 * @property {ReturnType<typeof getPropertyMatching>} lanesNormTaxi
 * @property {ReturnType<typeof getPropertyMatching>} lanesNormHov
 */ /**
 * Extracts properties from a feature.
 * @param {any} feature - The feature object.
 * @returns {Tags} The extracted tag properties.
 */ parcelHelpers.export(exports, "extractTags", ()=>extractTags);
function getProperty(feature, key) {
    return feature.get(key) || getPropertyEndingWith(feature, "-" + key);
}
function getPropertyEndingWith(feature, keySuffix) {
    const key = feature.getKeys().filter((key)=>key.endsWith(keySuffix)).filter((key)=>!key.startsWith("revision-"))[0];
    return feature.get(key);
}
function getPropertyEndingWithExcludingLayer7(feature, keySuffix) {
    const key = feature.getKeys().filter((key)=>!key.startsWith("7-")).filter((key)=>!key.startsWith("osm-")).filter((key)=>!key.startsWith("revision-")).filter((key)=>key.endsWith(keySuffix))[0];
    return feature.get(key);
}
function getPropertyMatching(feature, regExpString) {
    const regExp = new RegExp(regExpString);
    const key = feature.getKeys().filter((key)=>regExp.test(key))[0];
    return feature.get(key);
}
function extractTags(feature) {
    /** @type {Tags} */ const tags = {
        hdMap: getProperty(feature, "hdmap"),
        laneDirection: getProperty(feature, "lane_direction"),
        laneFunction: getProperty(feature, "lane_function"),
        rm_hovLanes: getPropertyMatching(feature, "^\\d+-hov:lanes.*"),
        rm_vehicleAccessBus: getPropertyMatching(feature, "^\\d+-lanes:vehicle_access:bus.*"),
        rm_vehicleAccessTaxi: getPropertyMatching(feature, "^\\d+-lanes:vehicle_access:taxi.*"),
        rm_vehicleAccessMotorcar: getPropertyMatching(feature, "^\\d+-lanes:vehicle_access:motorcar.*"),
        rm_vehicleAccessHgv: getPropertyMatching(feature, "^\\d+-lanes:vehicle_access:hgv.*"),
        hovLane: getProperty(feature, "hov_lane"),
        hov: getProperty(feature, "hov"),
        vehicleRestrictionBus: getProperty(feature, "vehicle_restriction:bus"),
        vehicleRestrictionHGV: getProperty(feature, "vehicle_restriction:hgv"),
        vehicleRestrictionMotorVehicle: getProperty(feature, "vehicle_restriction:motor_vehicle"),
        vehicleRestrictionMotorcar: getProperty(feature, "vehicle_restriction:motorcar"),
        vehicleRestrictionPSV: getProperty(feature, "vehicle_restriction:psv"),
        vehicleRestrictionTaxi: getProperty(feature, "vehicle_restriction:taxi"),
        laneBorder: getProperty(feature, "lane_border") || getProperty(feature, "lane_border:step"),
        lanesNormMotorVehicle: getPropertyMatching(feature, "^(?!7-|osm-|revision-).*-lanes:motor_vehicle"),
        lanesNormMotorCar: getPropertyMatching(feature, "^(?!7-|osm-|revision-).*-lanes:motor_car"),
        lanesNormHgv: getPropertyMatching(feature, "^(?!7-|osm-|revision-).*-lanes:hgv"),
        lanesNormPsv: getPropertyMatching(feature, "^(?!7-|osm-|revision-).*-lanes:psv"),
        lanesNormBus: getPropertyMatching(feature, "^(?!7-|osm-|revision-).*-lanes:bus"),
        lanesNormTaxi: getPropertyMatching(feature, "^(?!7-|osm-|revision-).*-lanes:taxi"),
        lanesNormHov: getPropertyMatching(feature, "^(?!7-|osm-|revision-).*-lanes:hov")
    };
    return tags;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1P32G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lrDecode", ()=>(0, _lrDecoding.lrDecode));
parcelHelpers.export(exports, "lrDecodeRelation", ()=>(0, _lrDecoding.lrDecodeRelation));
parcelHelpers.export(exports, "getLengthCm", ()=>getLengthCm);
parcelHelpers.export(exports, "getLinearTagFlowStyle", ()=>getLinearTagFlowStyle);
var _flowLine = require("ol-ext/style/FlowLine");
var _flowLineDefault = parcelHelpers.interopDefault(_flowLine);
var _d3Scale = require("d3-scale");
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _util = require("../../util");
var _curvature = require("./curvature");
var _linearInterpolation = require("./util/linearInterpolation");
var _colorScale = require("./util/colorScale");
var _lrDecoding = require("./util/lrDecoding");
function getLengthCm(feature) {
    const geometry = (0, _util.featureTo4326Geometry)(feature);
    const lengthCm = (0, _orbisLrSdk.lengthOnPlaneCm)(geometry);
    return lengthCm;
}
function getLinearTagFlowStyle(linearTag, width, feature, colorInterpolator, linearKey = "curvature", zIndex) {
    const lengthCm = getLengthCm(feature);
    const lrChain = (0, _lrDecoding.lrDecode)("bla:linear", linearTag);
    const dataPoints = lrChain.elements.map((element)=>({
            distance: element.getStartDistance() / lengthCm,
            value: parseInt(element.getValue())
        }));
    const interpolate = (0, _linearInterpolation.createLinearInterpolator)(dataPoints);
    const offsetToLinearTag = function wrapper(offset) {
        if (lengthCm === 0) return 0;
        else return interpolate(offset);
    };
    var normalizeLinearTagPositive;
    if (linearKey === "laneWidth") normalizeLinearTagPositive = (0, _d3Scale.scaleLog)([
        230,
        450
    ], [
        1,
        0
    ]);
    else if (linearKey === "curvature") // Convert curvature to a lateral-acceleration-derived speed, then map to
    // the shared FCD spectrum t so high speed (gentle curve) → 1 (red) and
    // low speed (sharp curve) → 0 (violet).
    normalizeLinearTagPositive = (curvature)=>(0, _colorScale.speedToT)((0, _curvature.maxSpeedFromCurvature)(curvature));
    else normalizeLinearTagPositive = (0, _d3Scale.scaleLog)([
        1,
        350
    ], [
        0,
        1
    ]);
    const normalizeLinearTag = function(linearTag) {
        if (linearKey !== "curvature" && linearTag < 1 && linearTag > -1) return 0;
        if (linearTag > 0) return normalizeLinearTagPositive(linearTag);
        return normalizeLinearTagPositive(-linearTag);
    };
    const flowStyle = new (0, _flowLineDefault.default)({
        zIndex: zIndex,
        color: function(f, step) {
            const linearTag = offsetToLinearTag(step);
            if (isNaN(linearTag)) return "rgb(128, 128, 128)";
            const linearTagNormalized = normalizeLinearTag(linearTag);
            const color = colorInterpolator(linearTagNormalized);
            if (color === "rgb(0, 0, 0)") return "rgb(255, 255, 255)";
            return color;
        },
        width: width,
        visible: false
    });
    return flowStyle;
}

},{"ol-ext/style/FlowLine":"eEU3h","d3-scale":[["scaleLog","fLW0o","default"]],"@orbis-lr-sdk/orbis-lr-sdk":"04bfk","../../util":"4IC9E","./curvature":"dM5mO","./util/linearInterpolation":"dzt22","./util/colorScale":"dOPOB","./util/lrDecoding":"elFsF","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eEU3h":[function(require,module,exports,__globalThis) {
/*	Copyright (c) 2019 Jean-Marc VIGLINO, 
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styleJs = require("ol/style/Style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _colorJs = require("ol/color.js");
var _geomUtilsJs = require("../geom/GeomUtils.js");
/** Flow line style
 * Draw LineString with a variable color / width
 * NB: the FlowLine style doesn't impress the hit-detection.
 * If you want your lines to be sectionable you have to add your own style to handle this.
 * (with transparent line: stroke color opacity to .1 or zero width)
 * @constructor
 * @extends {ol_style_Style}
 * @param {Object} options
 *  @param {boolean} options.visible draw only the visible part of the line, default true
 *  @param {number|function} options.width Stroke width or a function that gets a feature and the position (beetween [0,1]) and returns current width
 *  @param {number} options.width2 Final stroke width (if width is not a function)
 *  @param {number} options.arrow Arrow at start (-1), at end (1), at both (2), none (0), default geta
 *  @param {ol.colorLike|function} options.color Stroke color or a function that gets a feature and the position (beetween [0,1]) and returns current color
 *  @param {ol.colorLike} options.color2 Final sroke color if color is nor a function
 *  @param {ol.colorLike} options.arrowColor Color of arrows, if not defined used color or color2
 *  @param {string} options.lineCap CanvasRenderingContext2D.lineCap 'butt' | 'round' | 'square', default 'butt'
 *  @param {number|ol.size} options.arrowSize height and width of the arrow, default 16
 *  @param {boolean} [options.noOverlap=false] prevent segments overlaping
 *  @param {number} options.offset0 offset at line start
 *  @param {number} options.offset1 offset at line end
 */ var ol_style_FlowLine = class olstyleFlowLine extends (0, _styleJsDefault.default) {
    constructor(options){
        options = options || {};
        super({
            stroke: options.stroke,
            text: options.text,
            zIndex: options.zIndex,
            geometry: options.geometry
        });
        this.setRenderer(this._render.bind(this));
        // Draw only visible
        this._visible = options.visible !== false;
        // Width
        if (typeof options.width === 'function') this._widthFn = options.width;
        else this.setWidth(options.width);
        this.setWidth2(options.width2);
        // Color
        if (typeof options.color === 'function') this._colorFn = options.color;
        else this.setColor(options.color);
        this.setColor2(options.color2);
        // LineCap
        this.setLineCap(options.lineCap);
        // Arrow
        this.setArrow(options.arrow);
        this.setArrowSize(options.arrowSize);
        this.setArrowColor(options.arrowColor);
        // Offset
        this._offset = [
            0,
            0
        ];
        this.setOffset(options.offset0, 0);
        this.setOffset(options.offset1, 1);
        // Overlap
        this._noOverlap = options.noOverlap;
    }
    /** Set the initial width
   * @param {number} width width, default 0
   */ setWidth(width) {
        this._width = width || 0;
    }
    /** Set the final width
   * @param {number} width width, default 0
   */ setWidth2(width) {
        this._width2 = width;
    }
    /** Get offset at start or end
   * @param {number} where 0=start, 1=end
   * @return {number} width
   */ getOffset(where) {
        return this._offset[where];
    }
    /** Add an offset at start or end
   * @param {number} width
   * @param {number} where 0=start, 1=end
   */ setOffset(width, where) {
        width = Math.max(0, parseFloat(width));
        switch(where){
            case 0:
                this._offset[0] = width;
                break;
            case 1:
                this._offset[1] = width;
                break;
        }
    }
    /** Set the LineCap
   * @param {steing} cap LineCap (round or butt), default butt
   */ setLineCap(cap) {
        this._lineCap = cap === 'round' ? 'round' : 'butt';
    }
    /** Get the current width at step
   * @param {ol.feature} feature
   * @param {number} step current drawing step beetween [0,1]
   * @return {number}
   */ getWidth(feature, step) {
        if (this._widthFn) return this._widthFn(feature, step);
        var w2 = typeof this._width2 === 'number' ? this._width2 : this._width;
        return this._width + (w2 - this._width) * step;
    }
    /** Set the initial color
   * @param {ol.colorLike} color
   */ setColor(color) {
        try {
            this._color = (0, _colorJs.asArray)(color);
        } catch (e) {
            this._color = [
                0,
                0,
                0,
                1
            ];
        }
    }
    /** Set the final color
   * @param {ol.colorLike} color
   */ setColor2(color) {
        try {
            this._color2 = (0, _colorJs.asArray)(color);
        } catch (e) {
            this._color2 = null;
        }
    }
    /** Set the arrow color
   * @param {ol.colorLike} color
   */ setArrowColor(color) {
        try {
            this._acolor = (0, _colorJs.asString)(color);
        } catch (e) {
            this._acolor = null;
        }
    }
    /** Get the current color at step
   * @param {ol.feature} feature
   * @param {number} step current drawing step beetween [0,1]
   * @return {string}
   */ getColor(feature, step) {
        if (this._colorFn) return (0, _colorJs.asString)(this._colorFn(feature, step));
        var color = this._color;
        var color2 = this._color2 || this._color;
        return 'rgba(' + +Math.round(color[0] + (color2[0] - color[0]) * step) + ',' + Math.round(color[1] + (color2[1] - color[1]) * step) + ',' + Math.round(color[2] + (color2[2] - color[2]) * step) + ',' + (color[3] + (color2[3] - color[3]) * step) + ')';
    }
    /** Get arrow
   */ getArrow() {
        return this._arrow;
    }
    /** Set arrow
   * @param {number} n -1 | 0 | 1 | 2, default: 0
   */ setArrow(n) {
        this._arrow = parseInt(n);
        if (this._arrow < -1 || this._arrow > 2) this._arrow = 0;
    }
    /** getArrowSize
   * @return {ol.size}
   */ getArrowSize() {
        return this._arrowSize || [
            16,
            16
        ];
    }
    /** setArrowSize
   * @param {number|ol.size} size
   */ setArrowSize(size) {
        if (Array.isArray(size)) this._arrowSize = size;
        else if (typeof size === 'number') this._arrowSize = [
            size,
            size
        ];
    }
    /** drawArrow
   * @param {CanvasRenderingContext2D} ctx
   * @param {ol.coordinate} p0
   * @param ol.coordinate} p1
   * @param {number} width
   * @param {number} ratio pixelratio
   * @private
   */ drawArrow(ctx, p0, p1, width, ratio) {
        var asize = this.getArrowSize()[0] * ratio;
        var l = (0, _geomUtilsJs.ol_coordinate_dist2d)(p0, p1);
        var dx = (p0[0] - p1[0]) / l;
        var dy = (p0[1] - p1[1]) / l;
        width = Math.max(this.getArrowSize()[1] / 2, width / 2) * ratio;
        ctx.beginPath();
        ctx.moveTo(p0[0], p0[1]);
        ctx.lineTo(p0[0] - asize * dx + width * dy, p0[1] - asize * dy - width * dx);
        ctx.lineTo(p0[0] - asize * dx - width * dy, p0[1] - asize * dy + width * dx);
        ctx.lineTo(p0[0], p0[1]);
        ctx.fill();
    }
    /** Renderer function
   * @param {Array<ol.coordinate>} geom The pixel coordinates of the geometry in GeoJSON notation
   * @param {ol.render.State} e The olx.render.State of the layer renderer
   */ _render(geom, e) {
        if (e.geometry.getType() === 'LineString') {
            var i, g, p, ctx = e.context;
            // Get geometry used at drawing
            if (!this._visible) {
                var a = e.pixelRatio / e.resolution;
                var cos = Math.cos(e.rotation);
                var sin = Math.sin(e.rotation);
                g = e.geometry.getCoordinates();
                var dx = geom[0][0] - g[0][0] * a * cos - g[0][1] * a * sin;
                var dy = geom[0][1] - g[0][0] * a * sin + g[0][1] * a * cos;
                geom = [];
                for(i = 0; p = g[i]; i++)geom[i] = [
                    dx + p[0] * a * cos + p[1] * a * sin,
                    dy + p[0] * a * sin - p[1] * a * cos,
                    p[2]
                ];
            }
            var asize = this.getArrowSize()[0] * e.pixelRatio;
            ctx.save();
            // Offsets
            if (this.getOffset(0)) this._splitAsize(geom, this.getOffset(0) * e.pixelRatio);
            if (this.getOffset(1)) this._splitAsize(geom, this.getOffset(1) * e.pixelRatio, true);
            // Arrow 1
            if (geom.length > 1 && (this.getArrow() === -1 || this.getArrow() === 2)) {
                p = this._splitAsize(geom, asize);
                if (this._acolor) ctx.fillStyle = this._acolor;
                else ctx.fillStyle = this.getColor(e.feature, 0);
                this.drawArrow(ctx, p[0], p[1], this.getWidth(e.feature, 0), e.pixelRatio);
            }
            // Arrow 2 
            if (geom.length > 1 && this.getArrow() > 0) {
                p = this._splitAsize(geom, asize, true);
                if (this._acolor) ctx.fillStyle = this._acolor;
                else ctx.fillStyle = this.getColor(e.feature, 1);
                this.drawArrow(ctx, p[0], p[1], this.getWidth(e.feature, 1), e.pixelRatio);
            }
            // Split into
            var geoms = this._splitInto(geom, 255, 2);
            var k = 0;
            var nb = geoms.length;
            // Draw
            ctx.lineJoin = 'round';
            ctx.lineCap = this._lineCap || 'butt';
            if (geoms.length > 1) for(k = 0; k < geoms.length; k++){
                var step = k / nb;
                g = geoms[k];
                ctx.lineWidth = this.getWidth(e.feature, step) * e.pixelRatio;
                ctx.strokeStyle = this.getColor(e.feature, step);
                ctx.beginPath();
                ctx.moveTo(g[0][0], g[0][1]);
                for(i = 1; p = g[i]; i++)ctx.lineTo(p[0], p[1]);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    /** Split extremity at
   * @param {ol.geom.LineString} geom
   * @param {number} asize
   * @param {boolean} end start=false or end=true, default false (start)
   */ _splitAsize(geom, asize, end) {
        var p, p1, p0;
        var dl, d = 0;
        if (end) p0 = geom.pop();
        else p0 = geom.shift();
        p = p0;
        while(geom.length){
            if (end) p1 = geom.pop();
            else p1 = geom.shift();
            dl = (0, _geomUtilsJs.ol_coordinate_dist2d)(p, p1);
            if (d + dl > asize) {
                p = [
                    p[0] + (p1[0] - p[0]) * (asize - d) / dl,
                    p[1] + (p1[1] - p[1]) * (asize - d) / dl
                ];
                dl = (0, _geomUtilsJs.ol_coordinate_dist2d)(p, p0);
                if (end) {
                    geom.push(p1);
                    geom.push(p);
                    geom.push([
                        p[0] + (p0[0] - p[0]) / dl,
                        p[1] + (p0[1] - p[1]) / dl
                    ]);
                } else {
                    geom.unshift(p1);
                    geom.unshift(p);
                    geom.unshift([
                        p[0] + (p0[0] - p[0]) / dl,
                        p[1] + (p0[1] - p[1]) / dl
                    ]);
                }
                break;
            }
            d += dl;
            p = p1;
        }
        return [
            p0,
            p
        ];
    }
    /** Split line geometry into equal length geometries
   * @param {Array<ol.coordinate>} geom
   * @param {number} nb number of resulting geometries, default 255
   * @param {number} nim minimum length of the resulting geometries, default 1
   */ _splitInto(geom, nb, min) {
        var i, p;
        var dt = this._noOverlap ? 1 : .9;
        // Split geom into equal length geoms
        var geoms = [];
        var dl, l = 0;
        for(i = 1; p = geom[i]; i++)l += (0, _geomUtilsJs.ol_coordinate_dist2d)(geom[i - 1], p);
        var length = Math.max(min || 2, l / (nb || 255));
        var p0 = geom[0];
        l = 0;
        var g = [
            p0
        ];
        i = 1;
        p = geom[1];
        while(i < geom.length){
            var dx = p[0] - p0[0];
            var dy = p[1] - p0[1];
            dl = Math.sqrt(dx * dx + dy * dy);
            if (l + dl > length) {
                var d = (length - l) / dl;
                g.push([
                    p0[0] + dx * d,
                    p0[1] + dy * d
                ]);
                geoms.push(g);
                p0 = [
                    p0[0] + dx * d * dt,
                    p0[1] + dy * d * dt
                ];
                g = [
                    p0
                ];
                l = 0;
            } else {
                l += dl;
                p0 = p;
                g.push(p0);
                i++;
                p = geom[i];
            }
        }
        geoms.push(g);
        return geoms;
    }
};
exports.default = ol_style_FlowLine;

},{"ol/style/Style.js":"gqpPW","ol/color.js":"jC16r","../geom/GeomUtils.js":"kUivd","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kUivd":[function(require,module,exports,__globalThis) {
/*	Copyright (c) 2016 Jean-Marc VIGLINO, 
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).

  Usefull function to handle geometric operations
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ol_geom_createFromType", ()=>ol_geom_createFromType);
parcelHelpers.export(exports, "ol_coordinate_dist2d", ()=>ol_coordinate_dist2d);
parcelHelpers.export(exports, "ol_coordinate_equal", ()=>ol_coordinate_equal);
parcelHelpers.export(exports, "ol_coordinate_findSegment", ()=>ol_coordinate_findSegment);
parcelHelpers.export(exports, "ol_coordinate_getFeatureCenter", ()=>ol_coordinate_getFeatureCenter);
parcelHelpers.export(exports, "ol_coordinate_getGeomCenter", ()=>ol_coordinate_getGeomCenter);
parcelHelpers.export(exports, "ol_coordinate_offsetCoords", ()=>ol_coordinate_offsetCoords);
parcelHelpers.export(exports, "ol_coordinate_splitH", ()=>ol_coordinate_splitH);
parcelHelpers.export(exports, "ol_coordinate_getIntersectionPoint", ()=>ol_coordinate_getIntersectionPoint);
parcelHelpers.export(exports, "ol_extent_intersection", ()=>ol_extent_intersection);
parcelHelpers.export(exports, "extentIntersection", ()=>ol_extent_intersection);
parcelHelpers.export(exports, "ol_coordinate_sampleAt", ()=>ol_coordinate_sampleAt);
var _lineStringJs = require("ol/geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _linearRingJs = require("ol/geom/LinearRing.js");
var _linearRingJsDefault = parcelHelpers.interopDefault(_linearRingJs);
var _multiLineStringJs = require("ol/geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPointJs = require("ol/geom/MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _multiPolygonJs = require("ol/geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _pointJs = require("ol/geom/Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _polygonJs = require("ol/geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _circleJs = require("ol/geom/Circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _extentJs = require("ol/extent.js");
/** Distance beetween 2 points
 *	Usefull geometric functions
 * @param {ol.Coordinate} p1 first point
 * @param {ol.Coordinate} p2 second point
 * @return {number} distance
 */ var ol_coordinate_dist2d = function(p1, p2) {
    var dx = p1[0] - p2[0];
    var dy = p1[1] - p2[1];
    return Math.sqrt(dx * dx + dy * dy);
};
/** 2 points are equal
 *	Usefull geometric functions
 * @param {ol.Coordinate} p1 first point
 * @param {ol.Coordinate} p2 second point
 * @return {boolean}
 */ var ol_coordinate_equal = function(p1, p2) {
    return p1[0] == p2[0] && p1[1] == p2[1];
};
/** Get center coordinate of a feature
 * @param {ol.Feature} f
 * @return {ol.coordinate} the center
 */ var ol_coordinate_getFeatureCenter = function(f) {
    return ol_coordinate_getGeomCenter(f.getGeometry());
};
/** Get center coordinate of a geometry
* @param {ol.geom.Geometry} geom
* @return {ol.Coordinate} the center
*/ var ol_coordinate_getGeomCenter = function(geom) {
    switch(geom.getType()){
        case 'Point':
            return geom.getCoordinates();
        case "MultiPolygon":
            geom = geom.getPolygon(0);
        // fallthrough
        case "Polygon":
            return geom.getInteriorPoint().getCoordinates();
        default:
            return geom.getClosestPoint((0, _extentJs.getCenter)(geom.getExtent()));
    }
};
/** Offset a polyline
 * @param {Array<ol.Coordinate>} coords
 * @param {number} offset
 * @return {Array<ol.Coordinate>} resulting coord
 * @see http://stackoverflow.com/a/11970006/796832
 * @see https://drive.google.com/viewerng/viewer?a=v&pid=sites&srcid=ZGVmYXVsdGRvbWFpbnxqa2dhZGdldHN0b3JlfGd4OjQ4MzI5M2Y0MjNmNzI2MjY
 */ var ol_coordinate_offsetCoords = function(coords, offset) {
    var path = [];
    var N = coords.length - 1;
    var max = N;
    var mi, mi1, li, li1, ri, ri1, si, si1, Xi1, Yi1;
    var p0, p1, p2;
    var isClosed = ol_coordinate_equal(coords[0], coords[N]);
    if (!isClosed) {
        p0 = coords[0];
        p1 = coords[1];
        p2 = [
            p0[0] + (p1[1] - p0[1]) / ol_coordinate_dist2d(p0, p1) * offset,
            p0[1] - (p1[0] - p0[0]) / ol_coordinate_dist2d(p0, p1) * offset
        ];
        path.push(p2);
        coords.push(coords[N]);
        N++;
        max--;
    }
    for(var i = 0; i < max; i++){
        p0 = coords[i];
        p1 = coords[(i + 1) % N];
        p2 = coords[(i + 2) % N];
        mi = (p1[1] - p0[1]) / (p1[0] - p0[0]);
        mi1 = (p2[1] - p1[1]) / (p2[0] - p1[0]);
        // Prevent alignements
        if (Math.abs(mi - mi1) > 1e-10) {
            li = Math.sqrt((p1[0] - p0[0]) * (p1[0] - p0[0]) + (p1[1] - p0[1]) * (p1[1] - p0[1]));
            li1 = Math.sqrt((p2[0] - p1[0]) * (p2[0] - p1[0]) + (p2[1] - p1[1]) * (p2[1] - p1[1]));
            ri = p0[0] + offset * (p1[1] - p0[1]) / li;
            ri1 = p1[0] + offset * (p2[1] - p1[1]) / li1;
            si = p0[1] - offset * (p1[0] - p0[0]) / li;
            si1 = p1[1] - offset * (p2[0] - p1[0]) / li1;
            Xi1 = (mi1 * ri1 - mi * ri + si - si1) / (mi1 - mi);
            Yi1 = (mi * mi1 * (ri1 - ri) + mi1 * si - mi * si1) / (mi1 - mi);
            // Correction for vertical lines
            if (p1[0] - p0[0] == 0) {
                Xi1 = p1[0] + offset * (p1[1] - p0[1]) / Math.abs(p1[1] - p0[1]);
                Yi1 = mi1 * Xi1 - mi1 * ri1 + si1;
            }
            if (p2[0] - p1[0] == 0) {
                Xi1 = p2[0] + offset * (p2[1] - p1[1]) / Math.abs(p2[1] - p1[1]);
                Yi1 = mi * Xi1 - mi * ri + si;
            }
            path.push([
                Xi1,
                Yi1
            ]);
        }
    }
    if (isClosed) path.push(path[0]);
    else {
        coords.pop();
        p0 = coords[coords.length - 1];
        p1 = coords[coords.length - 2];
        p2 = [
            p0[0] - (p1[1] - p0[1]) / ol_coordinate_dist2d(p0, p1) * offset,
            p0[1] + (p1[0] - p0[0]) / ol_coordinate_dist2d(p0, p1) * offset
        ];
        path.push(p2);
    }
    return path;
};
/** Find the segment a point belongs to
 * @param {ol.Coordinate} pt
 * @param {Array<ol.Coordinate>} coords
 * @return {} the index (-1 if not found) and the segment
 */ var ol_coordinate_findSegment = function(pt, coords) {
    for(var i = 0; i < coords.length - 1; i++){
        var p0 = coords[i];
        var p1 = coords[i + 1];
        if (ol_coordinate_equal(pt, p0) || ol_coordinate_equal(pt, p1)) return {
            index: 1,
            segment: [
                p0,
                p1
            ]
        };
        else {
            var d0 = ol_coordinate_dist2d(p0, p1);
            var v0 = [
                (p1[0] - p0[0]) / d0,
                (p1[1] - p0[1]) / d0
            ];
            var d1 = ol_coordinate_dist2d(p0, pt);
            var v1 = [
                (pt[0] - p0[0]) / d1,
                (pt[1] - p0[1]) / d1
            ];
            if (Math.abs(v0[0] * v1[1] - v0[1] * v1[0]) < 1e-10) return {
                index: 1,
                segment: [
                    p0,
                    p1
                ]
            };
        }
    }
    return {
        index: -1
    };
};
/**
 * Split a Polygon geom with horizontal lines
 * @param {Array<ol.Coordinate>} geom
 * @param {number} y the y to split
 * @param {number} n contour index
 * @return {Array<Array<ol.Coordinate>>}
 */ var ol_coordinate_splitH = function(geom, y, n) {
    var x, abs;
    var list = [];
    for(var i = 0; i < geom.length - 1; i++){
        // Hole separator?
        if (!geom[i].length || !geom[i + 1].length) continue;
        // Intersect
        if (geom[i][1] <= y && geom[i + 1][1] > y || geom[i][1] >= y && geom[i + 1][1] < y) {
            abs = (y - geom[i][1]) / (geom[i + 1][1] - geom[i][1]);
            x = abs * (geom[i + 1][0] - geom[i][0]) + geom[i][0];
            list.push({
                contour: n,
                index: i,
                pt: [
                    x,
                    y
                ],
                abs: abs
            });
        }
    }
    // Sort x
    list.sort(function(a, b) {
        return a.pt[0] - b.pt[0];
    });
    // Horizontal segment
    var result = [];
    for(var j = 0; j < list.length - 1; j += 2)result.push([
        list[j],
        list[j + 1]
    ]);
    return result;
};
/** Create a geometry given a type and coordinates */ var ol_geom_createFromType = function(type, coordinates) {
    switch(type){
        case 'LineString':
            return new (0, _lineStringJsDefault.default)(coordinates);
        case 'LinearRing':
            return new (0, _linearRingJsDefault.default)(coordinates);
        case 'MultiLineString':
            return new (0, _multiLineStringJsDefault.default)(coordinates);
        case 'MultiPoint':
            return new (0, _multiPointJsDefault.default)(coordinates);
        case 'MultiPolygon':
            return new (0, _multiPolygonJsDefault.default)(coordinates);
        case 'Point':
            return new (0, _pointJsDefault.default)(coordinates);
        case 'Polygon':
            return new (0, _polygonJsDefault.default)(coordinates);
        default:
            console.error('[createFromType] Unsupported type: ' + type);
            return null;
    }
};
/** Intersect 2 lines
 * @param {Arrar<ol.coordinate>} d1
 * @param {Arrar<ol.coordinate>} d2
 */ var ol_coordinate_getIntersectionPoint = function(d1, d2) {
    var d1x = d1[1][0] - d1[0][0];
    var d1y = d1[1][1] - d1[0][1];
    var d2x = d2[1][0] - d2[0][0];
    var d2y = d2[1][1] - d2[0][1];
    var det = d1x * d2y - d1y * d2x;
    if (det != 0) {
        var k = (d1x * d1[0][1] - d1x * d2[0][1] - d1y * d1[0][0] + d1y * d2[0][0]) / det;
        return [
            d2[0][0] + k * d2x,
            d2[0][1] + k * d2y
        ];
    } else return false;
};
var ol_extent_intersection;
(function() {
    // Split at x
    function splitX(pts, x) {
        var pt;
        for(let i = pts.length - 1; i > 0; i--)if (pts[i][0] > x && pts[i - 1][0] < x || pts[i][0] < x && pts[i - 1][0] > x) {
            pt = [
                x,
                (x - pts[i][0]) / (pts[i - 1][0] - pts[i][0]) * (pts[i - 1][1] - pts[i][1]) + pts[i][1]
            ];
            pts.splice(i, 0, pt);
        }
    }
    // Split at y
    function splitY(pts, y) {
        var pt;
        for(let i = pts.length - 1; i > 0; i--)if (pts[i][1] > y && pts[i - 1][1] < y || pts[i][1] < y && pts[i - 1][1] > y) {
            pt = [
                (y - pts[i][1]) / (pts[i - 1][1] - pts[i][1]) * (pts[i - 1][0] - pts[i][0]) + pts[i][0],
                y
            ];
            pts.splice(i, 0, pt);
        }
    }
    /** Fast polygon intersection with an extent (used for area calculation)
 * @param {ol_extent_Extent} extent
 * @param {ol_geom_Polygon|ol_geom_MultiPolygon} polygon
 * @returns {ol_geom_Polygon|ol_geom_MultiPolygon|null} return null if not a polygon geometry
 */ ol_extent_intersection = function(extent, polygon) {
        var poly = polygon.getType() === 'Polygon';
        if (!poly && polygon.getType() !== 'MultiPolygon') return null;
        var geom = polygon.getCoordinates();
        if (poly) geom = [
            geom
        ];
        geom.forEach(function(g) {
            g.forEach(function(c) {
                splitX(c, extent[0]);
                splitX(c, extent[2]);
                splitY(c, extent[1]);
                splitY(c, extent[3]);
            });
        });
        // Snap geom to the extent 
        geom.forEach(function(g) {
            g.forEach(function(c) {
                c.forEach(function(p) {
                    if (p[0] < extent[0]) p[0] = extent[0];
                    else if (p[0] > extent[2]) p[0] = extent[2];
                    if (p[1] < extent[1]) p[1] = extent[1];
                    else if (p[1] > extent[3]) p[1] = extent[3];
                });
            });
        });
        if (poly) return new (0, _polygonJsDefault.default)(geom[0]);
        else return new (0, _multiPolygonJsDefault.default)(geom);
    };
})();
/** Add points along a segment
 * @param {ol_Coordinate} p1 
 * @param {ol_Coordinate} p2 
 * @param {number} d 
 * @param {boolean} start include starting point, default true
 * @returns {Array<ol_Coordinate>}
 */ var ol_coordinate_sampleAt = function(p1, p2, d, start) {
    var pts = [];
    if (start !== false) pts.push(p1);
    var dl = ol_coordinate_dist2d(p1, p2);
    if (dl) {
        var nb = Math.round(dl / d);
        if (nb > 1) {
            var dx = (p2[0] - p1[0]) / nb;
            var dy = (p2[1] - p1[1]) / nb;
            for(var i = 1; i < nb; i++)pts.push([
                p1[0] + dx * i,
                p1[1] + dy * i
            ]);
        }
    }
    pts.push(p2);
    return pts;
};
/** Sample a LineString at a distance
 * @param {number} d
 * @returns {ol_geom_LineString}
 */ (0, _lineStringJsDefault.default).prototype.sampleAt = function(d) {
    var line = this.getCoordinates();
    var result = [];
    for(var i = 1; i < line.length; i++)result = result.concat(ol_coordinate_sampleAt(line[i - 1], line[i], d, i === 1));
    return new (0, _lineStringJsDefault.default)(result);
};
/** Sample a MultiLineString at a distance
 * @param {number} d
 * @returns {ol_geom_MultiLineString}
 */ (0, _multiLineStringJsDefault.default).prototype.sampleAt = function(d) {
    var lines = this.getCoordinates();
    var result = [];
    lines.forEach(function(p) {
        var l = [];
        for(var i = 1; i < p.length; i++)l = l.concat(ol_coordinate_sampleAt(p[i - 1], p[i], d, i === 1));
        result.push(l);
    });
    return new (0, _multiLineStringJsDefault.default)(result);
};
/** Sample a Polygon at a distance
 * @param {number} d
 * @returns {ol_geom_Polygon}
 */ (0, _polygonJsDefault.default).prototype.sampleAt = function(res) {
    var poly = this.getCoordinates();
    var result = [];
    poly.forEach(function(p) {
        var l = [];
        for(var i = 1; i < p.length; i++)l = l.concat(ol_coordinate_sampleAt(p[i - 1], p[i], res, i === 1));
        result.push(l);
    });
    return new (0, _polygonJsDefault.default)(result);
};
/** Sample a MultiPolygon at a distance
 * @param {number} res
 * @returns {ol_geom_MultiPolygon}
 */ (0, _multiPolygonJsDefault.default).prototype.sampleAt = function(res) {
    var mpoly = this.getCoordinates();
    var result = [];
    mpoly.forEach(function(poly) {
        var a = [];
        result.push(a);
        poly.forEach(function(p) {
            var l = [];
            for(var i = 1; i < p.length; i++)l = l.concat(ol_coordinate_sampleAt(p[i - 1], p[i], res, i === 1));
            a.push(l);
        });
    });
    return new (0, _multiPolygonJsDefault.default)(result);
};
/** Intersect a geometry using a circle
 * @param {ol_geom_Geometry} geom
 * @param {number} resolution circle resolution to sample the polygon on the circle, default 1
 * @returns {ol_geom_Geometry}
 */ (0, _circleJsDefault.default).prototype.intersection = function(geom, resolution) {
    if (geom.sampleAt) {
        var ext = (0, _extentJs.buffer)(this.getCenter().concat(this.getCenter()), this.getRadius());
        geom = ol_extent_intersection(ext, geom);
        geom = geom.simplify(resolution);
        var c = this.getCenter();
        var r = this.getRadius();
        //var res = (resolution||1) * r / 100;
        var g = geom.sampleAt(resolution).getCoordinates();
        switch(geom.getType()){
            case 'Polygon':
                g = [
                    g
                ];
            // fallthrough
            case 'MultiPolygon':
                var hasout = false;
                // var hasin = false;
                var result = [];
                g.forEach(function(poly) {
                    var a = [];
                    result.push(a);
                    poly.forEach(function(ring) {
                        var l = [];
                        a.push(l);
                        ring.forEach(function(p) {
                            var d = ol_coordinate_dist2d(c, p);
                            if (d > r) {
                                hasout = true;
                                l.push([
                                    c[0] + r / d * (p[0] - c[0]),
                                    c[1] + r / d * (p[1] - c[1])
                                ]);
                            } else // hasin = true;
                            l.push(p);
                        });
                    });
                });
                if (!hasout) return geom;
                if (geom.getType() === 'Polygon') return new (0, _polygonJsDefault.default)(result[0]);
                else return new (0, _multiPolygonJsDefault.default)(result);
        }
    } else console.warn('[ol/geom/Circle~intersection] Unsupported geometry type: ' + geom.getType());
    return geom;
};

},{"ol/geom/LineString.js":"223qD","ol/geom/LinearRing.js":"eChQS","ol/geom/MultiLineString.js":"5Cre5","ol/geom/MultiPoint.js":"jiQtb","ol/geom/MultiPolygon.js":"6i4VN","ol/geom/Point.js":"95T6m","ol/geom/Polygon.js":"3zws5","ol/geom/Circle.js":"13EZt","ol/extent.js":"MPjK5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fLW0o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _d3Format.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _d3Format.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuousJs.copy)(scale, log()).base(scale.base());
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":[["ticks","6Hd8r","default"]],"d3-format":[["format","37aOo"],["formatSpecifier","7C3W6","default"]],"./nice.js":"kYBVa","./continuous.js":"85Rin","./init.js":"j6yLu","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6Hd8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ticks);
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"37aOo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"7Jesm","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7Jesm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"aejnq","./formatGroup.js":"9Nq5K","./formatNumerals.js":"dQfuB","./formatSpecifier.js":"7C3W6","./formatTrim.js":"7h7CY","./formatTypes.js":"lwU2b","./formatPrefixAuto.js":"j5TCL","./identity.js":"ev24o","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aejnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"ck7h2","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ck7h2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9Nq5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dQfuB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7C3W6":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7h7CY":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lwU2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, _formatDecimalJsDefault.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRoundedJsDefault.default)(x * 100, p),
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

},{"./formatDecimal.js":"ck7h2","./formatPrefixAuto.js":"j5TCL","./formatRounded.js":"aSKaK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"j5TCL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"ck7h2","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aSKaK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"ck7h2","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ev24o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kYBVa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"85Rin":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":[["bisect","uF0iN","default"]],"d3-interpolate":[["interpolate","jgpno","default"],["interpolateNumber","9WNpM","default"],["interpolateRound","gNYaf","default"]],"./constant.js":"89Bjx","./number.js":"heLR5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"uF0iN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"1YX9w","./bisector.js":"4ZtcO","./number.js":"5aAlD","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1YX9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ascending);
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4ZtcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bisector);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
function bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, _ascendingJsDefault.default);
        compare2 = (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, _ascendingJsDefault.default) || f === (0, _descendingJsDefault.default) ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"./ascending.js":"1YX9w","./descending.js":"3sUM9","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3sUM9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>descending);
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5aAlD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
parcelHelpers.export(exports, "numbers", ()=>numbers);
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jgpno":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":[["color","e6qPb","default"]],"./rgb.js":"8Ihjm","./array.js":"fqiXJ","./date.js":"hI4jI","./number.js":"9WNpM","./object.js":"l9GER","./string.js":"8QgQR","./constant.js":"dCbFy","./numberArray.js":"gOXCl","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e6qPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"97t2y","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"97t2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8Ihjm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"e6qPb","./basis.js":"bHmsa","./basisClosed.js":"5mW1n","./color.js":"blP15","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bHmsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5mW1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"bHmsa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"blP15":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"dCbFy","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dCbFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fqiXJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"jgpno","./numberArray.js":"gOXCl","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gOXCl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hI4jI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9WNpM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"l9GER":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"jgpno","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8QgQR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"9WNpM","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gNYaf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"89Bjx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"heLR5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"j6yLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"04bfk":[function(require,module,exports,__globalThis) {
// src/data/LRConstants.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BLANK_VALUE_STRING_REPRESENTATION", ()=>BLANK_VALUE_STRING_REPRESENTATION);
parcelHelpers.export(exports, "CONCATENATE_DELIMITER", ()=>CONCATENATE_DELIMITER);
parcelHelpers.export(exports, "CONDITIONAL_KEYWORD", ()=>CONDITIONAL_KEYWORD);
parcelHelpers.export(exports, "CoordConverterGaussKruger", ()=>CoordConverterGaussKruger);
parcelHelpers.export(exports, "DISTANCE_DELIMITER", ()=>DISTANCE_DELIMITER);
parcelHelpers.export(exports, "DistributeType", ()=>DistributeType);
parcelHelpers.export(exports, "ELEMENT_KEY_VALUE_DELIMITER", ()=>ELEMENT_KEY_VALUE_DELIMITER);
parcelHelpers.export(exports, "InterpolationSpecType", ()=>InterpolationSpecType);
parcelHelpers.export(exports, "InterpolationType", ()=>InterpolationType);
parcelHelpers.export(exports, "KEY_INTERPOLATION_TYPE_DELIMITER", ()=>KEY_INTERPOLATION_TYPE_DELIMITER);
parcelHelpers.export(exports, "LRChain", ()=>LRChain);
parcelHelpers.export(exports, "LRChainEncoded", ()=>LRChainEncoded);
parcelHelpers.export(exports, "LRChainHelper", ()=>LRChainHelper);
parcelHelpers.export(exports, "LRChainRaw", ()=>LRChainRaw);
parcelHelpers.export(exports, "LRChains", ()=>LRChains);
parcelHelpers.export(exports, "LRChainsBuilder", ()=>LRChainsBuilder);
parcelHelpers.export(exports, "LRComponents", ()=>LRComponents);
parcelHelpers.export(exports, "LRComponentsBuilder", ()=>LRComponentsBuilder);
parcelHelpers.export(exports, "LRDecodeError", ()=>LRDecodeError);
parcelHelpers.export(exports, "LRDecoder", ()=>LRDecoder);
parcelHelpers.export(exports, "LREncodeError", ()=>LREncodeError);
parcelHelpers.export(exports, "LRFactory", ()=>LRFactory);
parcelHelpers.export(exports, "LRLinearRange", ()=>LRLinearRange);
parcelHelpers.export(exports, "LROffset", ()=>LROffset);
parcelHelpers.export(exports, "LRPoint", ()=>LRPoint);
parcelHelpers.export(exports, "LRPointBuilder", ()=>LRPointBuilder);
parcelHelpers.export(exports, "LRRange", ()=>LRRange);
parcelHelpers.export(exports, "LRSegment", ()=>LRSegment);
parcelHelpers.export(exports, "LRSegmentBuilder", ()=>LRSegmentBuilder);
parcelHelpers.export(exports, "NO_DISTANCE_DEFINED", ()=>NO_DISTANCE_DEFINED);
parcelHelpers.export(exports, "RAW_DELIMITER", ()=>RAW_DELIMITER);
parcelHelpers.export(exports, "Reinterpolator", ()=>Reinterpolator);
parcelHelpers.export(exports, "UNKNOWN_END_DISTANCE", ()=>UNKNOWN_END_DISTANCE);
parcelHelpers.export(exports, "ValueAtProducer", ()=>ValueAtProducer);
parcelHelpers.export(exports, "getConverter", ()=>getConverter);
parcelHelpers.export(exports, "lengthOnPlaneCm", ()=>lengthOnPlaneCm);
parcelHelpers.export(exports, "lengthOnPlaneM", ()=>lengthOnPlaneM);
// src/geometry/LineStrings.ts
var _bbox = require("@turf/bbox");
// src/geometry/LineStrings.ts
var _betterknown = require("betterknown");
var RAW_DELIMITER = "=";
var DISTANCE_DELIMITER = "-";
var BLANK_VALUE_STRING_REPRESENTATION = "null";
var CONCATENATE_DELIMITER = ";";
var CONDITIONAL_KEYWORD = "conditional";
var KEY_INTERPOLATION_TYPE_DELIMITER = ":";
var ELEMENT_KEY_VALUE_DELIMITER = "#";
var NO_DISTANCE_DEFINED = -1;
var UNKNOWN_END_DISTANCE = Number.MAX_VALUE;
// src/sectioning/model/LRComponents.ts
var LRComponents = class _LRComponents {
    points;
    segments;
    constructor(points, segments){
        this.points = points;
        this.segments = segments;
    }
    static builder() {
        return new LRComponentsBuilder();
    }
    getTotalLengthDefined() {
        return this.segments.map((seg)=>seg.endDistance === UNKNOWN_END_DISTANCE ? 0 : seg.getLength()).reduce((sum, length)=>sum + length, 0);
    }
    copy() {
        return _LRComponents.builder().segments(this.cloneSegments()).points(this.cloneSegmentPoints()).build();
    }
    cloneSegments() {
        return this.segments.map((segment)=>segment.copy());
    }
    cloneSegmentPoints() {
        return this.points.map((point)=>point.copy());
    }
};
var LRComponentsBuilder = class {
    _points = [];
    _segments = [];
    points(points) {
        this._points = points;
        return this;
    }
    segments(segments) {
        this._segments = segments;
        return this;
    }
    point(point) {
        this._points.push(point);
        return this;
    }
    segment(segment) {
        this._segments.push(segment);
        return this;
    }
    build() {
        return new LRComponents(this._points, this._segments);
    }
};
// src/sectioning/model/LRPoint.ts
var LRPoint = class _LRPoint {
    reference;
    distance;
    attributes;
    coordinate;
    shapePoint;
    constructor(reference, distance, attributes, coordinate, shapePoint){
        this.reference = reference;
        this.distance = distance;
        this.attributes = attributes;
        this.coordinate = coordinate;
        this.shapePoint = shapePoint;
    }
    static builder() {
        return new LRPointBuilder();
    }
    addAttribute(key, value) {
        this.attributes.set(key, value);
        return this;
    }
    copy() {
        return _LRPoint.builder().withReference(this.reference).withDistance(this.distance).withAttributes(new Map(this.attributes)).withCoordinate(this.coordinate).build();
    }
};
var LRPointBuilder = class {
    reference = "";
    distance = -1;
    attributes = /* @__PURE__ */ new Map();
    coordinate = null;
    shapePoint = false;
    withReference(reference) {
        this.reference = reference;
        return this;
    }
    withAttributes(values) {
        this.attributes = values;
        return this;
    }
    withDistance(distance) {
        this.distance = distance;
        return this;
    }
    addAttribute(key, value) {
        this.attributes.set(key, value);
        return this;
    }
    withCoordinate(coordinate) {
        this.coordinate = coordinate;
        return this;
    }
    isShapePoint() {
        this.shapePoint = true;
        return this;
    }
    build() {
        if (this.distance === -1) throw new Error("Distance must be defined");
        if (this.coordinate === null) throw new Error("Coordinate must be defined");
        return new LRPoint(this.reference, this.distance, this.attributes, this.coordinate, this.shapePoint);
    }
};
// src/data/InterpolationType.ts
var InterpolationType = /* @__PURE__ */ ((InterpolationType2)=>{
    InterpolationType2["SPOT"] = "spot";
    InterpolationType2["STEP"] = "step";
    InterpolationType2["LINEAR"] = "linear";
    return InterpolationType2;
})(InterpolationType || {});
((InterpolationType2)=>{
    const VALUES = [
        "spot" /* SPOT */ ,
        "step" /* STEP */ ,
        "linear" /* LINEAR */ 
    ];
    let cachedTypeCombinations = null;
    function fromValue(value) {
        const interpolationType = VALUES.find((v)=>v === value);
        if (!interpolationType) throw new Error(`Unknown interpolation type: "${value}"`);
        return interpolationType;
    }
    InterpolationType2.fromValue = fromValue;
    function interpolationTypeCombinations() {
        if (cachedTypeCombinations == null) cachedTypeCombinations = VALUES.flatMap((type)=>[
                `${KEY_INTERPOLATION_TYPE_DELIMITER}${type}`,
                `${KEY_INTERPOLATION_TYPE_DELIMITER}${type}${KEY_INTERPOLATION_TYPE_DELIMITER}${CONDITIONAL_KEYWORD}`
            ]);
        return cachedTypeCombinations;
    }
    InterpolationType2.interpolationTypeCombinations = interpolationTypeCombinations;
    function getValue(type) {
        return type;
    }
    InterpolationType2.getValue = getValue;
})(InterpolationType || (InterpolationType = {}));
// src/helper/data/LRKeyElements.ts
var LRKeyElements = class _LRKeyElements {
    static DEFAULT_INTERPOLATION_TYPE = "step" /* STEP */ ;
    static DEFAULT_CONDITIONAL = false;
    chainName;
    type;
    isConditional;
    constructor(chainName, type, isConditional){
        this.chainName = chainName;
        this.type = type;
        this.isConditional = isConditional;
    }
    static lrKey(chainName, type, isConditional) {
        return new _LRKeyElements(chainName, type, isConditional);
    }
};
// src/helper/data/LRKeyValue.ts
var LRKeyValue = class {
    key;
    value;
    constructor(key, value){
        this.key = key;
        this.value = value;
    }
    getKey() {
        return this.key;
    }
    getValue() {
        return this.value;
    }
};
// src/helper/KeyHelper.ts
var KeyHelper = class {
    static CONDITIONAL_KEY_WITH_DELIMITER = KEY_INTERPOLATION_TYPE_DELIMITER + CONDITIONAL_KEYWORD;
    /**
   * Return the chain name without the linear reference keywords. Linear, step and spot (and possible conditional)
   * will be removed.
   *
   * @param key string combination of name and interpolationType name
   * @return returned tagkey without interpolation type.
   */ static extractChainNameFromKey(key) {
        for (const typeCombo of InterpolationType.interpolationTypeCombinations()){
            const index = key.lastIndexOf(typeCombo);
            if (index !== -1 && key.length - index === typeCombo.length) return key.substring(0, index);
        }
        return key;
    }
    /**
   * Extracts the chain name, interpolation type and conditional flag from a provided key.
   * If the key is empty or not a linear reference key, an empty optional is returned.
   * If the key is a encoded linear reference key, the chain name, interpolation type and conditional flag are
   * extracted and being returned as a LRKeyElements object.
   *
   * @param key Encoded key string
   * @return LRKeyElements object containing the chain name, interpolation type and conditional flag
   */ static extractKeyElements(key) {
        const result = this.extractKeyValue(key);
        if (result === void 0 || !this.isInterpolatedFromKey(result.getKey())) return void 0;
        let extractResult;
        const keyTokens = result.getKey().split(KEY_INTERPOLATION_TYPE_DELIMITER);
        if (keyTokens[keyTokens.length - 1] === CONDITIONAL_KEYWORD) extractResult = LRKeyElements.lrKey(this.createChainName(keyTokens, 2), InterpolationType.fromValue(keyTokens[keyTokens.length - 2]), true);
        else extractResult = LRKeyElements.lrKey(this.createChainName(keyTokens, 1), InterpolationType.fromValue(keyTokens[keyTokens.length - 1]), false);
        return extractResult;
    }
    static createChainName(keyTokens, tokensToSkipAtEnd) {
        return keyTokens.slice(0, keyTokens.length - tokensToSkipAtEnd).join(KEY_INTERPOLATION_TYPE_DELIMITER);
    }
    static isInterpolatedFromKey(key) {
        for (const typeCombo of InterpolationType.interpolationTypeCombinations()){
            if (key.endsWith(typeCombo) && key.length > typeCombo.length) return true;
        }
        return false;
    }
    static isConditionalFromKey(key) {
        return key.endsWith(this.CONDITIONAL_KEY_WITH_DELIMITER);
    }
    static extractInterpolationTypeFromKey(key) {
        for (const typeCombo of InterpolationType.interpolationTypeCombinations())if (key.endsWith(typeCombo)) {
            const indexConditionalKeyWithDelimiter = typeCombo.indexOf(this.CONDITIONAL_KEY_WITH_DELIMITER);
            if (indexConditionalKeyWithDelimiter !== -1) {
                const value = typeCombo.substring(1, indexConditionalKeyWithDelimiter);
                return InterpolationType.fromValue(value);
            } else {
                const value = typeCombo.substring(1);
                return InterpolationType.fromValue(value);
            }
        }
        return InterpolationType.fromValue(key);
    }
    static extractInterpolationTypeFromKeyWithDefault(key, defaultType) {
        try {
            return this.extractInterpolationTypeFromKey(key);
        } catch  {
            return defaultType;
        }
    }
    static generateKeyFromChain(chain) {
        return this.generateKeyFromChainProperties(chain.chainName, chain.isConditional, chain.interpolationType);
    }
    static generateKeyFromChainProperties(chainName, isConditional, interpolationType) {
        if (chainName === void 0 || interpolationType === void 0) return void 0;
        let key = chainName + KEY_INTERPOLATION_TYPE_DELIMITER + interpolationType.valueOf();
        if (isConditional) key += this.CONDITIONAL_KEY_WITH_DELIMITER;
        return key;
    }
    /**
   * Return the key without the linear reference keywords. Interpolation type linear, step and spot will be removed.
   *
   * @param chain LRChain to generate key from
   * @return returned tagkey without interpolation type.
   */ static generateNonLrKeyFromChain(chain) {
        if (chain.chainName === void 0) return void 0;
        return chain.isConditional ? chain.chainName + this.CONDITIONAL_KEY_WITH_DELIMITER : chain.chainName;
    }
    /**
   * Return the key without the linear reference interpolation types. Linear, step and spot will be removed.
   *
   * @param key string combination of name and interpolationType name
   * @return returned tagkey without interpolation type
   */ static extractNonLrKeyFromKey(key) {
        if (this.isInterpolatedFromKey(key)) {
            let nonLrKey = this.extractChainNameFromKey(key);
            if (this.isConditionalFromKey(key)) nonLrKey += KEY_INTERPOLATION_TYPE_DELIMITER + CONDITIONAL_KEYWORD;
            return nonLrKey;
        }
        return key;
    }
    /**
   * Extracts the LR key and value from a provided key.
   * If the key is empty, an empty optional is returned.
   * If the key contains a value, the key and value are extracted and being returned as an LRKeyValue object.
   * If the key does not contain a value, the key is returned as an LRKeyValue object with an empty value.
   * @param key Encoded key string
   * @return LRKeyValue object
   */ static extractKeyValue(key) {
        if (!key || key.length === 0) return void 0;
        const split = key.split(RAW_DELIMITER, 2);
        if (split.length === 1) return new LRKeyValue(split[0]);
        return new LRKeyValue(split[0], split[1]);
    }
};
// src/data/InterpolationSpecType.ts
var InterpolationSpecType = /* @__PURE__ */ ((InterpolationSpecType2)=>{
    InterpolationSpecType2["TAG"] = "TAG";
    InterpolationSpecType2["ROLE"] = "ROLE";
    return InterpolationSpecType2;
})(InterpolationSpecType || {});
// src/data/LRChainRaw.ts
var LRChainRaw = class {
    value;
    constructor(value){
        this.value = value;
    }
    decode(specType) {
        return this.toLRChainEncoded(specType).decode();
    }
    toLRChainEncoded(specType) {
        const keyValueSplit = this.value.split(RAW_DELIMITER, 2);
        return new LRChainEncoded(keyValueSplit[0], keyValueSplit[1], specType);
    }
    getValue() {
        return this.value;
    }
};
// src/data/LRChains.ts
var LRChains = class {
    lrChainList;
    distributed;
    // Constructor to initialize properties
    constructor(lrChainList, distributed){
        this.lrChainList = lrChainList;
        this.distributed = distributed;
    }
    /**
   * @deprecated use {@link #getChains()}
   */ getListOfLRChain() {
        return this.getChains();
    }
    getChains() {
        return this.lrChainList;
    }
    isDistributed() {
        return this.distributed;
    }
    static builder() {
        return new LRChainsBuilder();
    }
};
var LRChainsBuilder = class {
    lrChainList = [];
    distributed = false;
    addLRChain(lrChain) {
        this.lrChainList.push(lrChain);
        return this;
    }
    withLRChainList(lrChainList) {
        this.lrChainList = lrChainList;
        return this;
    }
    withDistribute() {
        this.distributed = true;
        return this;
    }
    build() {
        return new LRChains(this.lrChainList, this.distributed);
    }
};
// src/data/LRElement.ts
var AbstractLRElement = class {
    hasBlankValue() {
        return this.getValue() === BLANK_VALUE_STRING_REPRESENTATION;
    }
    getStartDistance() {
        return parseInt(this.getKey().split(DISTANCE_DELIMITER)[0], 10);
    }
};
// src/data/LRRange.ts
var LRRange = class _LRRange extends AbstractLRElement {
    startDistance;
    endDistance;
    value;
    constructor(startDistance, endDistance, value){
        super();
        this.startDistance = startDistance;
        this.endDistance = endDistance;
        this.value = value;
    }
    static createRange(startDistance, endDistance, value) {
        return new _LRRange(startDistance, endDistance, value);
    }
    static createNoValueRange(startDistance, endDistance) {
        return new _LRRange(startDistance, endDistance, BLANK_VALUE_STRING_REPRESENTATION);
    }
    isFollowedBy(nextElement) {
        return this.getEndDistance() === nextElement.getStartDistance();
    }
    getKey() {
        return `${this.startDistance}${DISTANCE_DELIMITER}${this.endDistance}`;
    }
    getValue() {
        return this.value;
    }
    getEndDistance() {
        return this.endDistance;
    }
    getLength() {
        return this.endDistance - this.startDistance;
    }
    withValue(newValue) {
        return new _LRRange(this.startDistance, this.endDistance, newValue);
    }
};
// src/data/LRLinearRange.ts
var LRLinearRange = class _LRLinearRange extends LRRange {
    endValue;
    constructor(startDistance, endDistance, startValue, endValue){
        super(startDistance, endDistance, startValue);
        this.endValue = endValue;
    }
    static createLinearStartRange(endDistance, startValue, endValue) {
        return new _LRLinearRange(0, endDistance, startValue, endValue);
    }
    static createLinearRange(startDistance, endDistance, startValue, endValue) {
        return new _LRLinearRange(startDistance, endDistance, startValue, endValue);
    }
    static createLinearRangeGap(startDistance, endDistance) {
        return new _LRLinearRange(startDistance, endDistance, BLANK_VALUE_STRING_REPRESENTATION, BLANK_VALUE_STRING_REPRESENTATION);
    }
    isFollowedBy(_nextElement) {
        return false;
    }
    getStartValue() {
        return this.getValue();
    }
    isGap() {
        return this.hasBlankValue();
    }
    getEndValue() {
        return this.endValue;
    }
    withStartValue(newValue) {
        return new _LRLinearRange(this.getStartDistance(), this.getEndDistance(), newValue, this.getEndValue());
    }
    withEndValue(newValue) {
        return new _LRLinearRange(this.getStartDistance(), this.getEndDistance(), this.getStartValue(), newValue);
    }
};
// src/data/LROffset.ts
var LROffset = class _LROffset extends AbstractLRElement {
    offsetDistance;
    value;
    constructor(offsetDistance, value){
        super();
        this.offsetDistance = offsetDistance;
        this.value = value;
    }
    static createOffset(offset, value) {
        return new _LROffset(offset, value);
    }
    static createNoValueOffset(offset) {
        return new _LROffset(offset, BLANK_VALUE_STRING_REPRESENTATION);
    }
    getKey() {
        return `${this.offsetDistance}`;
    }
    getValue() {
        return this.value;
    }
    isFollowedBy(nextElement) {
        return nextElement.getStartDistance() > this.offsetDistance;
    }
    getOffsetDistance() {
        return this.offsetDistance;
    }
    withValue(newValue) {
        return new _LROffset(this.offsetDistance, newValue);
    }
};
// src/data/LRChainHelper.ts
var LRChainHelper = class {
    static convertElementsToRanges(lrChain) {
        const transformedElements = [];
        for(let elementIndex = 0; elementIndex < lrChain.elements.length; elementIndex++){
            const startElement = lrChain.elements[elementIndex];
            const endElement = this.getLRElementWithNextStartDistance(lrChain.elements.slice(elementIndex + 1), startElement, lrChain.isConditional);
            if (endElement === void 0) {
                if (startElement instanceof LRRange) transformedElements.push(startElement);
                else if (!startElement.hasBlankValue()) {
                    const startOffset = startElement;
                    transformedElements.push(LRRange.createRange(startOffset.getOffsetDistance(), lrChain.maxDistance > NO_DISTANCE_DEFINED ? lrChain.maxDistance : UNKNOWN_END_DISTANCE, startElement.getValue()));
                } else if (startElement.hasBlankValue() && lrChain.elements.length === 1) {
                    const startOffset = startElement;
                    transformedElements.push(LRRange.createRange(startOffset.getOffsetDistance(), UNKNOWN_END_DISTANCE, BLANK_VALUE_STRING_REPRESENTATION));
                }
            } else if (startElement instanceof LRRange) transformedElements.push(startElement);
            else transformedElements.push(LRRange.createRange(this.extractStartOffset(startElement), this.extractStartOffset(endElement), startElement.getValue()));
        }
        return transformedElements;
    }
    static convertToRangesLinear(elements) {
        const transformedElements = [];
        const lastElementIndex = elements.length - 2;
        for(let elementIndex = 0; elementIndex <= lastElementIndex; elementIndex++){
            if (elements[elementIndex] instanceof LRLinearRange) {
                transformedElements.push(elements[elementIndex]);
                continue;
            }
            const currentElement = elements[elementIndex];
            const nextElement = elements[elementIndex + 1];
            if (nextElement.hasBlankValue()) {
                if (elementIndex === lastElementIndex) transformedElements.push(LRLinearRange.createLinearRangeGap(nextElement.getStartDistance(), nextElement.getEndDistance()));
                continue;
            }
            if (currentElement.hasBlankValue()) {
                transformedElements.push(LRLinearRange.createLinearRangeGap(currentElement.getStartDistance(), currentElement.getEndDistance()));
                if (elementIndex === lastElementIndex) transformedElements.push(LRLinearRange.createLinearRange(currentElement.getEndDistance(), currentElement.getEndDistance(), nextElement.getValue(), nextElement.getValue()));
            } else transformedElements.push(LRLinearRange.createLinearRange(currentElement.getStartDistance(), currentElement.getEndDistance(), currentElement.getValue(), nextElement.getValue()));
        }
        return transformedElements;
    }
    static concatenateOverlappingElements(elements, isConditional) {
        const pointDistances = [];
        elements.forEach((lrElement)=>{
            if (lrElement instanceof LROffset) this.putDistanceInDistanceList(pointDistances, Number(lrElement.getKey()));
            else lrElement.getKey().split(DISTANCE_DELIMITER).forEach((s)=>{
                this.putDistanceInDistanceList(pointDistances, Number(s));
            });
        });
        if (pointDistances.length === 1) return elements;
        const transformedElements = [];
        pointDistances.sort((a, b)=>a - b);
        let indexDistances = 0;
        for (const distance of pointDistances){
            if (indexDistances + 1 < pointDistances.length) {
                const endDistance = pointDistances[indexDistances + 1];
                const chain = this.concatenateOverlappingElementForRange(elements, distance, endDistance, isConditional);
                if (chain !== BLANK_VALUE_STRING_REPRESENTATION || pointDistances.length === 2) transformedElements.push(new LRRange(distance, endDistance, chain));
            } else {
                const chain = this.concatenateOverlappingElementForRange(elements, distance, UNKNOWN_END_DISTANCE, isConditional);
                transformedElements.push(new LROffset(distance, chain));
            }
            indexDistances++;
        }
        if (elements.length > 0 && elements[elements.length - 1] instanceof LRRange) transformedElements.pop();
        return transformedElements;
    }
    static getConcatenatedChain(lrElements, startDistance, endDistance) {
        return this.concatenateOverlappingElementForRange(lrElements, startDistance, endDistance, true);
    }
    static getLRElementWithNextStartDistance(lrElements, lrElement, isConditional) {
        if (isConditional) return lrElements.find((element)=>element.getStartDistance() > lrElement.getStartDistance());
        return lrElements.length == 0 ? void 0 : lrElements[0];
    }
    static convertToOffsets(elements, maxDistance) {
        const transformedElements = [];
        let elementIndex = 0;
        for (const lrElement of elements){
            if (lrElement instanceof LROffset) this.addLROffset(elementIndex, lrElement, elements, transformedElements, maxDistance);
            else this.addLRRange(elementIndex, lrElement, elements, transformedElements);
            elementIndex++;
        }
        return transformedElements;
    }
    static between(value, minValueInclusive, maxValueInclusive) {
        return value >= minValueInclusive && (value <= maxValueInclusive || maxValueInclusive === NO_DISTANCE_DEFINED);
    }
    static concatenateOverlappingElementForRange(lrElements, startDistance, endDistance, isConditional) {
        const chains = [];
        let elementNotAdded = true;
        let elementIndex = 0;
        for (const lrElement of lrElements){
            let elementEnd;
            if (lrElement instanceof LROffset) {
                const nextLRElements = lrElements.slice(elementIndex + 1);
                elementEnd = this.getEndDistanceOfOffset(nextLRElements, lrElement, isConditional);
            } else elementEnd = lrElement.getEndDistance();
            if (this.linesOverlaps(startDistance, endDistance - 1, lrElement.getStartDistance(), elementEnd - 1) && !lrElement.hasBlankValue()) {
                if (elementNotAdded) elementNotAdded = false;
                else chains.push(CONCATENATE_DELIMITER);
                chains.push(lrElement.getValue());
            }
            elementIndex++;
        }
        return this.buildConcatenatedChain(chains);
    }
    static extractStartOffset(element) {
        if (element instanceof LRRange) return element.getStartDistance();
        return Number(element.getKey());
    }
    static addLROffset(elementIndex, lrElement, elementList, newElementList, maxDistance) {
        newElementList.push(lrElement);
        if (this.shouldMakeNewOffsetWithMaxDistance(elementIndex, elementList, maxDistance)) newElementList.push(LROffset.createOffset(maxDistance, BLANK_VALUE_STRING_REPRESENTATION));
    }
    static addLRRange(elementIndex, lrElement, elementList, newElementList) {
        const lrRange = lrElement;
        newElementList.push(LROffset.createOffset(lrRange.getStartDistance(), lrElement.getValue()));
        if (this.shouldMakeNewOffsetWithRangeEndDistance(elementIndex, elementList)) newElementList.push(LROffset.createOffset(lrRange.getEndDistance(), BLANK_VALUE_STRING_REPRESENTATION));
    }
    static shouldMakeNewOffsetWithMaxDistance(elementIndex, elementList, maxDistance) {
        return maxDistance > NO_DISTANCE_DEFINED && elementIndex + 1 === elementList.length && elementList[elementIndex].getStartDistance() !== maxDistance;
    }
    static shouldMakeNewOffsetWithRangeEndDistance(elementIndex, elementList) {
        const lrRange = elementList[elementIndex];
        if (elementIndex + 1 < elementList.length) {
            const nextElement = elementList[elementIndex + 1];
            return nextElement.getStartDistance() !== lrRange.getEndDistance();
        }
        return true;
    }
    static putDistanceInDistanceList(pointDistances, distance) {
        if (!pointDistances.includes(distance)) pointDistances.push(distance);
    }
    static linesOverlaps(lineOneStart, lineOneEnd, lineTwoStart, lineTwoEnd) {
        return this.between(lineOneStart, lineTwoStart, lineTwoEnd) && this.between(lineOneEnd, lineTwoStart, lineTwoEnd) || lineOneEnd === lineTwoEnd;
    }
    static buildConcatenatedChain(chains) {
        if (chains.length === 0) return BLANK_VALUE_STRING_REPRESENTATION;
        return chains.join("");
    }
    static getEndDistanceOfOffset(lrElements, lrOffset, isConditional) {
        const element = this.getLRElementWithNextStartDistance(lrElements, lrOffset, isConditional);
        if (element === void 0) return UNKNOWN_END_DISTANCE;
        return element.getStartDistance();
    }
};
// src/data/LRChain.ts
var DistributeType = /* @__PURE__ */ ((DistributeType2)=>{
    DistributeType2[DistributeType2["OFFSET"] = 0] = "OFFSET";
    DistributeType2[DistributeType2["RANGES"] = 1] = "RANGES";
    DistributeType2[DistributeType2["RANGES_LINEAR"] = 2] = "RANGES_LINEAR";
    return DistributeType2;
})(DistributeType || {});
var LRChain = class _LRChain {
    chainName;
    interpolationType;
    isConditional;
    elements;
    interpolationSpecType;
    maxDistance;
    distributeTypeInternal;
    $encodedInternal = null;
    constructor(chainName, interpolationType, isConditional, elements, specType, maxDistance, distributeTypeInternal = "NOT_DISTRIBUTED" /* NOT_DISTRIBUTED */ ){
        if (maxDistance < NO_DISTANCE_DEFINED) throw new Error("Max distance must not be negative (default value -1 is allowed since it indicates no max distance)");
        this.chainName = chainName;
        this.interpolationType = interpolationType;
        this.isConditional = isConditional;
        this.elements = elements;
        this.interpolationSpecType = specType;
        this.maxDistance = maxDistance;
        this.distributeTypeInternal = distributeTypeInternal;
    }
    static createChain(chainName, interpolationType, isConditional, elements, maxDistance = NO_DISTANCE_DEFINED, specType = "TAG" /* TAG */ ) {
        return new _LRChain(chainName, interpolationType, isConditional ?? false, elements, specType, maxDistance);
    }
    encode() {
        return this.getEncodedInternal();
    }
    // validate(): LRChainValidationResult {
    //   // Implement the validation logic
    //   return {} as LRChainValidationResult;
    // }
    key() {
        return this.getEncodedInternal().getKey();
    }
    value() {
        return this.getEncodedInternal().getValue();
    }
    getInterpolationSpecType() {
        return this.interpolationSpecType;
    }
    getEncodedInternal() {
        if (this.$encodedInternal === null) {
            if (this.interpolationType === "step" /* STEP */ ) {
                if (this.elements.length === 0) {
                    this.$encodedInternal = new LRChainEncoded(KeyHelper.generateNonLrKeyFromChain(this) ?? "", "", this.interpolationSpecType);
                    return this.$encodedInternal;
                } else if (this.isOneOffsetOverTotalDistance()) {
                    this.$encodedInternal = new LRChainEncoded(KeyHelper.generateNonLrKeyFromChain(this) ?? "", this.elements[0].getValue(), this.interpolationSpecType);
                    return this.$encodedInternal;
                }
            }
            let encoder = this.chainName === void 0 ? LRFactory.createEncoder() : LRFactory.createEncoder(this.chainName).withInterpolationSpecType(this.interpolationSpecType).withIsConditional(this.isConditional);
            if (this.interpolationType !== void 0) encoder = encoder.withInterpolationType(this.interpolationType);
            this.$encodedInternal = encoder.encode(this.elements);
        }
        return this.$encodedInternal;
    }
    distributeDefault() {
        if (this.interpolationType === "linear" /* LINEAR */ ) return this.distribute(2 /* RANGES_LINEAR */ );
        return this.distribute(0 /* OFFSET */ );
    }
    distribute(type) {
        if (type === void 0) return this.distributeDefault();
        this.validateDistributionRequest(type, this.elements);
        if (alreadyDistributed(this.distributeTypeInternal, type)) return this;
        switch(type){
            case 1 /* RANGES */ :
                return this.distributeRanges();
            case 2 /* RANGES_LINEAR */ :
                return this.distributeRangesLinear();
            case 0 /* OFFSET */ :
                return this.distributeOffset();
            default:
                throw new Error(`No distribute defined for type ${type}`);
        }
    }
    validateDistributionRequest(type, elements) {
        if (type !== 2 /* RANGES_LINEAR */ ) {
            if (this.interpolationType === "linear" /* LINEAR */ ) throw new Error("Linear interpolation type can only be distributed as linear ranges!");
            else if (elements.some((element)=>element instanceof LRLinearRange)) throw new Error("Linear ranges can only be distributed as linear ranges!");
        }
        if (this.interpolationType === "spot" /* SPOT */ ) throw new Error("Spot interpolation type cannot be distributed!");
    }
    distributeRanges() {
        const ranges = LRChainHelper.convertElementsToRanges(this);
        const concatenatedRanges = LRChainHelper.concatenateOverlappingElements(ranges, this.isConditional);
        return new _LRChain(this.chainName, this.interpolationType, this.isConditional, concatenatedRanges, this.interpolationSpecType, this.maxDistance, "RANGES" /* RANGES */ );
    }
    distributeRangesLinear() {
        if (this.elements.some((element)=>!(element instanceof LRLinearRange))) {
            const ranges = LRChainHelper.convertElementsToRanges(this);
            const linearRanges = LRChainHelper.convertToRangesLinear(ranges);
            return new _LRChain(this.chainName, this.interpolationType, this.isConditional, linearRanges, this.interpolationSpecType, this.maxDistance, "RANGES_LINEAR" /* RANGES_LINEAR */ );
        }
        this.distributeTypeInternal = "RANGES_LINEAR" /* RANGES_LINEAR */ ;
        return this;
    }
    distributeOffset() {
        const concatenatedRanges = LRChainHelper.concatenateOverlappingElements(this.elements, this.isConditional);
        const offsets = LRChainHelper.convertToOffsets(concatenatedRanges, this.maxDistance);
        return new _LRChain(this.chainName, this.interpolationType, this.isConditional, offsets, this.interpolationSpecType, this.maxDistance, "OFFSET" /* OFFSET */ );
    }
    normalize() {
        if (this.containsLinearRanges()) return this;
        const normalized = [];
        this.distribute(1 /* RANGES */ ).elements.forEach((range)=>{
            if (normalized.length === 0) normalized.push(this.normalizeElement(this, range));
            else {
                const current = normalized.pop();
                if (current) normalized.push(...this.merge(current, this.normalizeElement(this, range)));
            }
        });
        return _LRChain.createChain(this.chainName, this.interpolationType, this.isConditional, normalized, this.maxDistance, this.interpolationSpecType);
    }
    reverse(lengthOfChain) {
        if (lengthOfChain === 0) return this;
        else if (lengthOfChain < 0) throw new Error("Length of chain must be greater than 0");
        else if (this.maxDistanceAlongInElements() > lengthOfChain) throw new Error(`Length of chain must be greater than the max distance along in the chain (provided: ${lengthOfChain}, minimum needed distance along: ${this.maxDistanceAlongInElements()})`);
        const distributed = this.distribute(1 /* RANGES */ );
        const rangeElements = distributed.elements;
        const reversedElements = rangeElements.toReversed().map((element)=>{
            const range = element;
            if (range.getEndDistance() === UNKNOWN_END_DISTANCE) return new LROffset(0, range.getValue());
            else if (range.getStartDistance() === 0) return new LROffset(lengthOfChain - range.getEndDistance(), range.getValue());
            return new LRRange(lengthOfChain - range.getEndDistance(), lengthOfChain - range.getStartDistance(), element.getValue());
        });
        const chainWithReverseElements = _LRChain.createChain(this.chainName, this.interpolationType, this.isConditional, reversedElements, this.maxDistance, this.interpolationSpecType);
        return chainWithReverseElements.normalize();
    }
    maxDistanceAlongInElements() {
        return Math.max(...this.elements.map((element)=>this.getMaxDistanceAlongOfElement(element)));
    }
    getMaxDistanceAlongOfElement(element) {
        if (element instanceof LRRange) return element.getEndDistance();
        else if (element instanceof LROffset) return element.getOffsetDistance() + 1;
        return 0;
    }
    containsLinearRanges() {
        return this.elements.some((element)=>element instanceof LRLinearRange);
    }
    normalizeElement(chain, element) {
        if (element instanceof LRRange) {
            const range = element;
            if (range.getEndDistance() === UNKNOWN_END_DISTANCE || chain.maxDistance > 0 && Math.abs(range.getEndDistance() - chain.maxDistance) <= 1) return new LROffset(range.getStartDistance(), range.getValue());
        }
        return element;
    }
    merge(currentElement, nextElement) {
        if (currentElement.isFollowedBy(nextElement)) {
            if (currentElement.getValue() !== nextElement.getValue()) return [
                new LROffset(currentElement.getStartDistance(), currentElement.getValue()),
                nextElement
            ];
            if (nextElement instanceof LRRange) return [
                new LRRange(currentElement.getStartDistance(), nextElement.getEndDistance(), nextElement.getValue())
            ];
            if (nextElement instanceof LROffset) return [
                new LROffset(currentElement.getStartDistance(), nextElement.getValue())
            ];
        }
        return [
            currentElement,
            nextElement
        ];
    }
    isOneOffsetOverTotalDistance() {
        return this.elements.length === 1 && this.elements[0] instanceof LROffset && this.elements[0].getStartDistance() === 0;
    }
};
function alreadyDistributed(distributeTypeInternal, distributeType) {
    switch(distributeTypeInternal){
        case "NOT_DISTRIBUTED" /* NOT_DISTRIBUTED */ :
            return false;
        case "OFFSET" /* OFFSET */ :
            return distributeType === 0 /* OFFSET */ ;
        case "RANGES" /* RANGES */ :
            return distributeType === 1 /* RANGES */ ;
        case "RANGES_LINEAR" /* RANGES_LINEAR */ :
            return distributeType === 2 /* RANGES_LINEAR */ ;
        default:
            throw new Error(`Unexpected distribute type: ${distributeTypeInternal}`);
    }
}
// src/escaping/LRValueEscaper.ts
var LRValueEscaper = class _LRValueEscaper {
    static ESCAPE_CHARACTER = "\\";
    static ILLEGAL_CHARACTERS = /* @__PURE__ */ new Set([
        CONCATENATE_DELIMITER.charAt(0),
        ELEMENT_KEY_VALUE_DELIMITER.charAt(0),
        _LRValueEscaper.ESCAPE_CHARACTER
    ]);
    static escape(input) {
        if (this.isEmpty(input)) return input;
        return Array.from(input).map((char)=>{
            return (_LRValueEscaper.ILLEGAL_CHARACTERS.has(char) ? _LRValueEscaper.ESCAPE_CHARACTER : "") + char;
        }).join("");
    }
    static unescape(input) {
        if (this.isEmpty(input)) return input;
        return this.unescapeJava(input);
    }
    static unescapeJava(input) {
        return input.replace(/\\(.)/g, "$1");
    }
    static isEmpty(input) {
        return !input || input.trim().length === 0;
    }
};
// src/decode/DecoderConstants.ts
var LOOK_BEHIND_NON_ESCAPING_REGEX_STRING = "(?<=[^\\\\](?:\\\\\\\\){0,999})";
var VALUE_DELIMITER_REGEX = new RegExp(LOOK_BEHIND_NON_ESCAPING_REGEX_STRING + CONCATENATE_DELIMITER);
var PROPERTY_VALUE_DELIMITER_REGEX = new RegExp(LOOK_BEHIND_NON_ESCAPING_REGEX_STRING + ELEMENT_KEY_VALUE_DELIMITER);
// src/decode/decoders/AbstractDecodingRule.ts
var AbstractDecodingRule = class _AbstractDecodingRule {
    static TOKEN_INDEX_NON_CONDITIONAL = 1;
    static TOKEN_INDEX_CONDITIONAL = 2;
    static ALL_SPACES_REGEX = /\s+/;
    decode(data) {
        const decodedLR = this.decodeInternal(this.getKey(data), this.getSpecType(data), this.getType(data), this.isConditional(data), this.getValue(data));
        if (data.isDistribute()) return new LRChainsBuilder().withLRChainList([
            decodedLR.distribute()
        ]).withDistribute().build();
        return new LRChainsBuilder().withLRChainList([
            decodedLR
        ]).build();
    }
    decodeInternal(chainName, specType, type, isConditional, value) {
        let ranges = [];
        if (value !== void 0) ranges = this.splitValue(value).map((rangeString)=>rangeString.split(PROPERTY_VALUE_DELIMITER_REGEX)).map((rangeElements)=>{
            if (specType === "TAG" /* TAG */ ) {
                if (rangeElements.length > 2) throw new Error(`Element value contains unescaped LR spec character (value=${rangeElements})`);
                rangeElements[1] = LRValueEscaper.unescape(rangeElements[1]);
            }
            return rangeElements;
        }).map((rangeElements)=>this.getLRElement(rangeElements)).reduce((acc, elem)=>{
            acc.push(elem);
            return acc;
        }, []);
        return LRChain.createChain(chainName, type, isConditional, ranges, NO_DISTANCE_DEFINED, specType);
    }
    splitValue(value) {
        const tagValues = value.split(VALUE_DELIMITER_REGEX);
        if (tagValues.at(-1) === "") tagValues.pop();
        return tagValues;
    }
    getKeyRaw(fullChainKey) {
        const tokens = fullChainKey.split(KEY_INTERPOLATION_TYPE_DELIMITER);
        let endTokenIndex = tokens.length - _AbstractDecodingRule.TOKEN_INDEX_NON_CONDITIONAL;
        if (this.isConditionalRaw(fullChainKey)) endTokenIndex = tokens.length - _AbstractDecodingRule.TOKEN_INDEX_CONDITIONAL;
        return tokens.slice(0, endTokenIndex).join(KEY_INTERPOLATION_TYPE_DELIMITER);
    }
    getTypeRaw(chainFullKey) {
        const tokens = chainFullKey.split(KEY_INTERPOLATION_TYPE_DELIMITER);
        if (this.isConditionalRaw(chainFullKey)) return InterpolationType.fromValue(tokens[tokens.length - _AbstractDecodingRule.TOKEN_INDEX_CONDITIONAL]);
        else return InterpolationType.fromValue(tokens[tokens.length - _AbstractDecodingRule.TOKEN_INDEX_NON_CONDITIONAL]);
    }
    isConditionalRaw(chainFullKey) {
        const tokens = chainFullKey.split(KEY_INTERPOLATION_TYPE_DELIMITER);
        return tokens[tokens.length - 1] === CONDITIONAL_KEYWORD;
    }
    getLRElement(rangeInput) {
        return rangeInput[0].includes(DISTANCE_DELIMITER) ? this.getLRRangeElement(rangeInput) : this.getLROffsetElement(rangeInput);
    }
    getLROffsetElement(rangeInput) {
        const offsetValue = rangeInput.length > 1 ? rangeInput[1] : BLANK_VALUE_STRING_REPRESENTATION;
        return LROffset.createOffset(parseInt(rangeInput[0].trim()), offsetValue);
    }
    getLRRangeElement(rangeInput) {
        const rangePositions = rangeInput[0].replace(_AbstractDecodingRule.ALL_SPACES_REGEX, "").split(DISTANCE_DELIMITER);
        const rangeValue = rangeInput.length > 1 ? rangeInput[1] : BLANK_VALUE_STRING_REPRESENTATION;
        return LRRange.createRange(parseInt(rangePositions[0]), parseInt(rangePositions[1]), rangeValue);
    }
    getTagValues(data) {
        return data.getEncodedChains().map((chain)=>chain.getValue());
    }
};
// src/decode/decoders/StringDecodingRule.ts
var StringDecodingRule = class _StringDecodingRule extends AbstractDecodingRule {
    static ELEMENT_STRUCTURE_REGEX = "([0-9|\\-|\\s]+)" + ELEMENT_KEY_VALUE_DELIMITER + ".*";
    static elementStructurePattern = new RegExp(_StringDecodingRule.ELEMENT_STRUCTURE_REGEX, "s");
    canDecode(data) {
        return this.isValidKey(data) && this.isValidValue(data);
    }
    getKey(data) {
        const key = data.getKey();
        if (key === void 0) return void 0;
        return this.getKeyRaw(key);
    }
    isConditional(data) {
        const key = data.getKey();
        if (key === void 0) return void 0;
        return this.isConditionalRaw(key);
    }
    getSpecType(data) {
        return data.getSpecType();
    }
    getType(data) {
        const key = data.getKey();
        if (key === void 0) return void 0;
        return this.getTypeRaw(key);
    }
    getValue(data) {
        return data.getValue();
    }
    isValidValue(data) {
        const value = data.getValue();
        if (value === void 0) return false;
        const tagValues = this.splitValue(value);
        for (const tagValue of tagValues){
            if (!_StringDecodingRule.elementStructurePattern.test(tagValue) || tagValue.split(PROPERTY_VALUE_DELIMITER_REGEX).length < 1) return false;
        }
        return true;
    }
    isValidKey(data) {
        const key = data.getKey();
        if (key === void 0) return false;
        return KeyHelper.isInterpolatedFromKey(key);
    }
    // Helper methods to maintain consistent naming with abstract class methods
    getKeyInternal(fullChainKey) {
        return this.getKeyRaw(fullChainKey);
    }
    getTypeInternal(chainFullKey) {
        return this.getTypeRaw(chainFullKey);
    }
    isConditionalInternal(chainFullKey) {
        return this.isConditionalRaw(chainFullKey);
    }
};
// src/decode/LRDecoderData.ts
var LRDecoderData = class {
    encodedChains = [];
    key;
    // example: maxspeed:linear
    value;
    // example: 0#10;100#50
    distribute = false;
    validation = true;
    specType = "TAG" /* TAG */ ;
    getValue() {
        if (this.specType === "ROLE" /* ROLE */  && this.value && !this.value.includes(ELEMENT_KEY_VALUE_DELIMITER)) return this.value + ELEMENT_KEY_VALUE_DELIMITER + BLANK_VALUE_STRING_REPRESENTATION;
        return this.value;
    }
    getEncodedChains() {
        return this.encodedChains;
    }
    isDistribute() {
        return this.distribute;
    }
    addChainEncoded(chainEncoded) {
        this.encodedChains.push(chainEncoded);
    }
    withDistribute() {
        this.distribute = true;
    }
    withoutValidation() {
        this.validation = false;
    }
    resetEncodedChainList() {
        this.encodedChains = [];
    }
    setKey(key) {
        this.key = key;
    }
    getKey() {
        return this.key;
    }
    setValue(value) {
        this.value = value;
    }
    setSpecType(specType) {
        this.specType = specType;
    }
    getSpecType() {
        return this.specType;
    }
    isValidation() {
        return this.validation;
    }
    toString() {
        return `LRDecoderData(encodedChains=${this.encodedChains}, key=${this.key}, value=${this.value}, distribute=${this.distribute}, validation=${this.validation}, specType=${this.specType})`;
    }
};
// src/error/LRDecodeError.ts
var LRDecodeError = class _LRDecodeError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
        this.name = "LRDecodeError";
        Object.setPrototypeOf(this, _LRDecodeError.prototype);
    }
};
// src/decode/decoders/EncodeChainsDecodingRule.ts
var EncodedChainsDecodingRule = class _EncodedChainsDecodingRule extends AbstractDecodingRule {
    static EXCEPTION_MESSAGE_CANT_DO = "Can't do that";
    canDecode(data) {
        return data.getEncodedChains() !== null && data.getEncodedChains().length > 0 && data.getEncodedChains().every((t)=>t.getKey().length > 0 && t.getValue().length > 0);
    }
    decode(data) {
        const lrChainsBuilder = new LRChainsBuilder().withLRChainList(data.getEncodedChains().flatMap(this.decodeChain.bind(this)).map((lrChain)=>{
            if (lrChain.getInterpolationSpecType() !== "ROLE" /* ROLE */  && data.isDistribute()) return lrChain.distribute(0 /* OFFSET */ );
            else return lrChain;
        }));
        if (data.isDistribute()) return lrChainsBuilder.withDistribute().build();
        return lrChainsBuilder.build();
    }
    decodeChain(chain) {
        try {
            return [
                this.decodeInternal(this.getKeyRaw(chain.getKey()), chain.getInterpolationSpecType(), this.getTypeRaw(chain.getKey()), this.isConditionalRaw(chain.getKey()), chain.getValue())
            ];
        } catch  {
            return [];
        }
    }
    getKey(_data) {
        throw new LRDecodeError(_EncodedChainsDecodingRule.EXCEPTION_MESSAGE_CANT_DO);
    }
    isConditional(_data) {
        throw new LRDecodeError(_EncodedChainsDecodingRule.EXCEPTION_MESSAGE_CANT_DO);
    }
    getSpecType(_data) {
        throw new LRDecodeError(_EncodedChainsDecodingRule.EXCEPTION_MESSAGE_CANT_DO);
    }
    getType(_data) {
        throw new Error(_EncodedChainsDecodingRule.EXCEPTION_MESSAGE_CANT_DO);
    }
    getValue(_data) {
        throw new LRDecodeError(_EncodedChainsDecodingRule.EXCEPTION_MESSAGE_CANT_DO);
    }
};
// src/decode/LRDecoder.ts
var LRDecoder = class _LRDecoder {
    static RULES = [
        new StringDecodingRule(),
        new EncodedChainsDecodingRule()
    ];
    data = new LRDecoderData();
    // TODO: add validation
    // private readonly validator: LRValidator = LRValidator.createValidator();
    withInterpolationSpecType(specType) {
        this.data.setSpecType(specType);
        return this;
    }
    withDistribute() {
        this.data.withDistribute();
        return this;
    }
    withoutValidation() {
        this.data.withoutValidation();
        return this;
    }
    decodeEncodedChain(encodedChain) {
        this.data.resetEncodedChainList();
        this.data.addChainEncoded(encodedChain);
        return this.decodeInternal().getChains().find((chain)=>chain) || (()=>{
            throw new LRDecodeError(`Unable to decode Chain (chain=${encodedChain})`);
        })();
    }
    decodeValue(value) {
        this.data.setValue(value);
        return this.decodeInternal().getChains().find((chain)=>chain) || (()=>{
            throw new LRDecodeError(`Unable to decode value (value=${value})`);
        })();
    }
    decodeKeyValue(key, value) {
        this.data.setKey(key);
        this.data.setValue(value);
        return this.decodeInternal().getChains().find((chain)=>chain) || (()=>{
            throw new LRDecodeError(`Unable to decode (key=${key}, value=${value})`);
        })();
    }
    decodeEncodedChains(encodedChains) {
        this.data.resetEncodedChainList();
        encodedChains.forEach((chain)=>this.data.addChainEncoded(chain));
        return this.decodeInternal();
    }
    decode(arg1, arg2) {
        if (Array.isArray(arg1)) return this.decodeEncodedChains(arg1);
        else if (typeof arg1 === "string" && arg2 !== void 0) return this.decodeKeyValue(arg1, arg2);
        else if (typeof arg1 === "string") return this.decodeValue(arg1);
        else if (arg1 instanceof LRChainEncoded) return this.decodeEncodedChain(arg1);
        else return this.decodeInternal();
    }
    decodeInternal() {
        try {
            for (const rule of _LRDecoder.RULES)if (rule.canDecode(this.data)) {
                const decodedLR = rule.decode(this.data);
                this.data.isValidation();
                return decodedLR;
            }
        } catch (e) {
            if (e instanceof Error) throw new LRDecodeError(`Cannot decode <${this.data}>. Format not supported. `, e);
        }
        throw new LRDecodeError(`Cannot decode <${this.data}>. Format not supported`);
    }
    withEncodedChains(chains) {
        chains.forEach((chain)=>this.data.addChainEncoded(chain));
        return this;
    }
    withEncodedChain(chain) {
        this.data.addChainEncoded(chain);
        return this;
    }
    withKey(key) {
        this.data.setKey(key);
        return this;
    }
    withValue(value) {
        this.data.setValue(value);
        return this;
    }
};
// src/encode/LREncoderData.ts
var LREncoderData = class {
    // Assuming required properties and methods for LREncoderData
    chainName = "";
    conditional = false;
    withNormalisation = false;
    type = void 0;
    interpolationSpecType = "TAG" /* TAG */ ;
    withAutoEscaping = true;
    elements = [];
    setChainName(name) {
        this.chainName = name;
    }
    setConditional(value) {
        this.conditional = value;
    }
    setWithNormalisation(value) {
        this.withNormalisation = value;
    }
    setType(type) {
        this.type = type;
    }
    setInterpolationSpecType(specType) {
        this.interpolationSpecType = specType;
    }
    getElements() {
        return this.elements;
    }
    setElements(elements) {
        this.elements = elements;
    }
    getKey() {
        if (this.chainName === void 0) return "";
        else if (this.type === void 0) return this.chainName;
        return this.chainName + KEY_INTERPOLATION_TYPE_DELIMITER + this.type.valueOf();
    }
    reset() {
        this.chainName = "";
        this.conditional = false;
        this.withNormalisation = false;
        this.type = void 0;
        this.interpolationSpecType = "TAG" /* TAG */ ;
        this.withAutoEscaping = true;
        this.elements = [];
    }
};
// src/encode/encoders/AbstractEncoder.ts
var AbstractEncoder = class _AbstractEncoder {
    encode(data) {
        return new LRChainEncoded(this.encodeKey(data), this.encodeValue(data), data.interpolationSpecType);
    }
    static joinRangeValue(range, needsEscaping, isLastElement, isFollowedByGap) {
        if (range instanceof LRLinearRange && !range.hasBlankValue()) {
            const linearRange = range;
            if ((isLastElement || isFollowedByGap) && linearRange.getStartDistance() !== linearRange.getEndDistance()) return `${linearRange.getStartDistance()}#${linearRange.getStartValue()};${linearRange.getEndDistance()}#${linearRange.getEndValue()}`;
            else return `${linearRange.getStartDistance()}#${linearRange.getStartValue()}`;
        } else {
            const rangeValue = needsEscaping ? LRValueEscaper.escape(range.getValue()) : range.getValue();
            return `${range.getKey()}${ELEMENT_KEY_VALUE_DELIMITER}${rangeValue}`;
        }
    }
    encodeKey(data) {
        const keyParts = [
            data.chainName
        ];
        if (data.type !== void 0) keyParts.push(data.type.valueOf());
        if (data.conditional) keyParts.push(CONDITIONAL_KEYWORD);
        return keyParts.join(KEY_INTERPOLATION_TYPE_DELIMITER);
    }
    encodeElementList(elements, isWithAutoEscaping) {
        return elements.map((lrElement, index)=>{
            const isLastElement = index === elements.length - 1;
            let isFollowedByGap = false;
            if (!isLastElement) isFollowedByGap = elements[index + 1].hasBlankValue();
            return _AbstractEncoder.joinRangeValue(lrElement, isWithAutoEscaping, isLastElement, isFollowedByGap);
        }).join(CONCATENATE_DELIMITER);
    }
};
// src/encode/encoders/SimpleRangeEncoder.ts
var SimpleRangeEncoder = class extends AbstractEncoder {
    canEncode(data) {
        return !data.withNormalisation && data.interpolationSpecType === "TAG" /* TAG */ ;
    }
    encodeValue(data) {
        return this.encodeElementList(data.getElements(), data.withAutoEscaping);
    }
};
// src/encode/encoders/RoleEncoder.ts
var RoleEncoder = class extends AbstractEncoder {
    canEncode(data) {
        return data.interpolationSpecType === "ROLE" /* ROLE */  && data.getElements().length === 1;
    }
    encodeValue(data) {
        return data.getElements()[0].getKey();
    }
};
// src/error/LREncodeError.ts
var LREncodeError = class _LREncodeError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
        this.name = "LREncodeError";
        Object.setPrototypeOf(this, _LREncodeError.prototype);
    }
};
// src/encode/LREncoder.ts
var LREncoder = class _LREncoder {
    validate = true;
    static ENCODERS = [
        new SimpleRangeEncoder(),
        // TODO add
        // new NormalisationEncoder(),
        new RoleEncoder()
    ];
    data = new LREncoderData();
    constructor(attributeName){
        if (attributeName) this.data.setChainName(attributeName);
    }
    withoutValidation() {
        this.validate = false;
        return this;
    }
    isConditional() {
        this.data.setConditional(true);
        return this;
    }
    withIsConditional(isConditional) {
        this.data.setConditional(isConditional);
        return this;
    }
    withNormalisation() {
        this.data.setWithNormalisation(true);
        return this;
    }
    withChainName(chainName) {
        this.data.setChainName(chainName);
        return this;
    }
    spot() {
        this.data.setType("spot" /* SPOT */ );
        return this;
    }
    step() {
        this.data.setType("step" /* STEP */ );
        return this;
    }
    linear() {
        this.data.setType("linear" /* LINEAR */ );
        return this;
    }
    withInterpolationType(type) {
        if (type !== void 0) this.data.setType(type);
        return this;
    }
    withInterpolationSpecType(specType) {
        this.data.setInterpolationSpecType(specType);
        return this;
    }
    withoutAutoEscaping() {
        this.data.withAutoEscaping = false;
        return this;
    }
    addElement(element) {
        this.data.getElements().push(element);
        return this;
    }
    reset() {
        this.data.reset();
        return this;
    }
    encode(elements) {
        if (elements === void 0) elements = this.data.getElements();
        if (elements.length === 0) throw new LREncodeError("No LRElement(s) provided.");
        this.data.setElements(elements);
        if (this.validate) this.validateData();
        const encodedChain = _LREncoder.ENCODERS.filter((enc)=>enc.canEncode(this.data)).map((enc)=>enc.encode(this.data)).find((encoded)=>encoded !== void 0);
        if (!encodedChain) throw new LREncodeError(`Collection of elements could not be encoded (element=${elements})!`);
        return encodedChain;
    }
    validateData() {
        if (!this.data.chainName || this.data.chainName.trim() === "") throw new LREncodeError("Name is not set.");
        if (!this.data.type) throw new LREncodeError("Interpolation type not set.");
    }
};
// src/LRFactory.ts
var LRFactory = class {
    static createDecoder() {
        return new LRDecoder();
    }
    static createEncoder(attributeName) {
        if (attributeName === void 0) return new LREncoder();
        return new LREncoder(attributeName);
    }
    static createEncoderForRoles() {
        return new LREncoder().withInterpolationSpecType("ROLE" /* ROLE */ );
    }
};
// src/data/LRChainEncoded.ts
var LRChainEncoded = class {
    key;
    value;
    interpolationSpecType = "TAG" /* TAG */ ;
    constructor(key, value, interpolationSpecType = "TAG" /* TAG */ ){
        this.key = key;
        this.value = value;
        this.interpolationSpecType = interpolationSpecType;
    }
    getKey() {
        return this.key;
    }
    getValue() {
        return this.value;
    }
    getInterpolationSpecType() {
        return this.interpolationSpecType;
    }
    decode() {
        switch(this.interpolationSpecType){
            case "TAG" /* TAG */ :
            case "ROLE" /* ROLE */ :
                return LRFactory.createDecoder().withInterpolationSpecType(this.interpolationSpecType).decode(this.key, this.value);
            default:
                throw new Error(`Unknown interpolation spec type: "${this.interpolationSpecType}"`);
        }
    }
    isLrEncoded() {
        return InterpolationType.interpolationTypeCombinations().some((type)=>this.key.endsWith(type));
    }
    toString() {
        return `LRChainEncoded(key=${this.key}, value=${this.value}, interpolationSpecType=${this.interpolationSpecType.valueOf()})`;
    }
    getChainName() {
        return InterpolationType.interpolationTypeCombinations().filter((type)=>this.key.endsWith(type)).map((type)=>this.key.substring(0, this.key.length - type.length)).find((name)=>name !== void 0) || this.key;
    }
    isNonLrEncoded() {
        return !this.isLrEncoded();
    }
    toLRChainRaw() {
        return new LRChainRaw(this.key + RAW_DELIMITER + this.value);
    }
};
// src/sectioning/model/LRSegment.ts
var LRSegment = class _LRSegment {
    get attributes() {
        return this._attributes;
    }
    get wktGeometry() {
        return this._wktGeometry;
    }
    get reference() {
        return this._reference;
    }
    get endDistance() {
        return this._endDistance;
    }
    get startDistance() {
        return this._startDistance;
    }
    _reference;
    _startDistance;
    _endDistance;
    _wktGeometry;
    _attributes;
    constructor(reference, startDistance, endDistance, wktGeometry, attributes){
        this._reference = reference;
        this._startDistance = startDistance;
        this._endDistance = endDistance;
        this._wktGeometry = wktGeometry;
        this._attributes = attributes;
    }
    static builder() {
        return new LRSegmentBuilder();
    }
    addAttribute(key, value) {
        this._attributes.set(key, value);
        return this;
    }
    getAttributesAsList() {
        return Array.from(this._attributes.entries()).map(([key, value])=>`${key}=${value}`);
    }
    copy() {
        return _LRSegment.builder().withReference(this._reference).withStartDistance(this._startDistance).withEndDistance(this._endDistance).withWktGeometry(this._wktGeometry).withAttributes(new Map(this._attributes)).build();
    }
    getLength() {
        return this._endDistance - this._startDistance;
    }
    generateInterpolatedKey(key) {
        if (!KeyHelper.isInterpolatedFromKey(key)) return `${key}${KEY_INTERPOLATION_TYPE_DELIMITER}${"step" /* STEP */ .valueOf}`;
        else return key;
    }
    generateInterpolatedValue(key, offsetSegmentCm, lengthSegmentCm, segmentKeyValue, reversed) {
        if (KeyHelper.isInterpolatedFromKey(key)) {
            const chainEncoded = new LRChainEncoded(key, segmentKeyValue, "TAG" /* TAG */ );
            let decode = chainEncoded.decode();
            if (reversed) decode = decode.reverse(lengthSegmentCm);
            return decode.elements.map((element)=>{
                const newStartDistance = element.getStartDistance() + offsetSegmentCm;
                if (element instanceof LRRange) {
                    const range = element;
                    const newEndDistance = newStartDistance + lengthSegmentCm;
                    return LRRange.createRange(newStartDistance, newEndDistance, range.getValue());
                } else {
                    const offset = element;
                    return LROffset.createOffset(newStartDistance, offset.getValue());
                }
            });
        } else return [
            LRRange.createRange(offsetSegmentCm, offsetSegmentCm + lengthSegmentCm, segmentKeyValue)
        ];
    }
};
var LRSegmentBuilder = class {
    reference = "";
    endDistance = NO_DISTANCE_DEFINED;
    startDistance = NO_DISTANCE_DEFINED;
    attributes = /* @__PURE__ */ new Map();
    wktGeometry = "";
    withReference(reference) {
        this.reference = reference;
        return this;
    }
    withStartDistance(startDistance) {
        this.startDistance = startDistance;
        return this;
    }
    withEndDistance(endDistance) {
        this.endDistance = endDistance;
        return this;
    }
    addAttribute(key, value) {
        this.attributes.set(key, value);
        return this;
    }
    withWktGeometry(wktGeometry) {
        this.wktGeometry = wktGeometry;
        return this;
    }
    withAttributes(attributes) {
        this.attributes = attributes;
        return this;
    }
    build() {
        if (this.startDistance < 0) throw new Error(`LRSegment cannot be created without a start distance (attributes: ${this})`);
        return new LRSegment(this.reference, this.startDistance, this.endDistance, this.wktGeometry, this.attributes);
    }
};
// src/reinterpolation/handlers/ReinterpolateLRChain.ts
var ReinterpolateLRChain = class {
    attachRecalculatedKeyValueToSegment(chain, element, segment) {
        const encoded = LRFactory.createEncoder(chain.chainName).withInterpolationType(chain.interpolationType).withIsConditional(chain.isConditional).withoutValidation().encode([
            element
        ]);
        let lrPreviousKeyValues = "";
        if (segment.attributes.get(encoded.getKey())) lrPreviousKeyValues = segment.attributes.get(encoded.getKey()) + CONCATENATE_DELIMITER;
        segment.addAttribute(encoded.getKey(), lrPreviousKeyValues + encoded.getValue());
    }
    rangeWithinSegment(segment, range) {
        return segment.startDistance <= range.getStartDistance() && segment.endDistance >= range.getEndDistance();
    }
    segmentWithinRange(segment, range) {
        return segment.startDistance >= range.getStartDistance() && segment.endDistance <= range.getEndDistance();
    }
    rangeOverlapsSegmentStart(segment, range) {
        return segment.startDistance > range.getStartDistance() && segment.startDistance < range.getEndDistance();
    }
    rangeOverlapsSegmentEnd(segment, range) {
        return segment.startDistance < range.getStartDistance() && segment.endDistance > range.getStartDistance();
    }
};
// src/reinterpolation/handlers/ReinterpolateLinearChain.ts
var ReinterpolateLinearChain = class _ReinterpolateLinearChain extends ReinterpolateLRChain {
    static INSTANCE = new _ReinterpolateLinearChain();
    reinterpolate(components, unsectionedChain) {
        unsectionedChain.distribute(2 /* RANGES_LINEAR */ ).elements.map((element)=>element).forEach((linearRange)=>this.updateComponentsWithReInterpolateBasedOnLinearRange(components, linearRange, unsectionedChain));
        return components;
    }
    updateComponentsWithReInterpolateBasedOnLinearRange(components, linearRange, chain) {
        components.segments.forEach((segment)=>{
            let newLinearRange = null;
            if (this.rangeWithinSegment(segment, linearRange)) newLinearRange = LRLinearRange.createLinearRange(linearRange.getStartDistance() - segment.startDistance, linearRange.getEndDistance() - segment.startDistance, linearRange.getStartValue(), linearRange.getEndValue());
            else if (this.segmentWithinRange(segment, linearRange)) {
                if (this.rangeMatchingAtEnd(linearRange, segment)) newLinearRange = LRLinearRange.createLinearStartRange(segment.getLength(), this.recalculateValue(linearRange, segment.startDistance - linearRange.getStartDistance()), linearRange.getEndValue());
                else newLinearRange = LRLinearRange.createLinearStartRange(segment.getLength(), this.recalculateValue(linearRange, segment.startDistance - linearRange.getStartDistance()), this.recalculateValue(linearRange, segment.endDistance - linearRange.getStartDistance()));
            } else if (this.rangeOverlapsSegmentStart(segment, linearRange)) {
                const newEndDistance = linearRange.getEndDistance() - segment.startDistance;
                newLinearRange = LRLinearRange.createLinearStartRange(newEndDistance, this.recalculateValue(linearRange, segment.startDistance - linearRange.getStartDistance()), linearRange.getEndValue());
            } else if (this.rangeOverlapsSegmentEnd(segment, linearRange)) {
                const newStartDistance = linearRange.getStartDistance() - segment.startDistance;
                const newEndDistance = segment.getLength();
                newLinearRange = LRLinearRange.createLinearRange(newStartDistance, newEndDistance, linearRange.getStartValue(), this.recalculateValue(linearRange, newEndDistance - newStartDistance));
            }
            this.addLinearRangeToSegment(segment, newLinearRange, chain);
        });
    }
    addLinearRangeToSegment(segment, newLinearRange, chain) {
        if (newLinearRange == null) return;
        if (newLinearRange.isGap()) {
            if (!this.isFullSegment(newLinearRange, segment)) this.attachRecalculatedKeyValueToSegment(chain, LRLinearRange.createLinearRangeGap(newLinearRange.getStartDistance(), newLinearRange.getEndDistance()), segment);
        } else {
            this.attachRecalculatedKeyValueToSegment(chain, LROffset.createOffset(newLinearRange.getStartDistance(), newLinearRange.getStartValue()), segment);
            if (this.isOnEndOfSegment(newLinearRange, segment) || this.nextSegmentIsGap(newLinearRange, segment, chain) || this.isLastLinearRange(newLinearRange, segment, chain)) this.attachRecalculatedKeyValueToSegment(chain, LROffset.createOffset(newLinearRange.getEndDistance(), newLinearRange.getEndValue()), segment);
        }
    }
    isFullSegment(newLinearRange, segment) {
        return segment.getLength() === newLinearRange.getEndDistance() - newLinearRange.getStartDistance();
    }
    isOnEndOfSegment(newLinearRange, segment) {
        return newLinearRange.getEndDistance() === segment.getLength();
    }
    nextSegmentIsGap(newLinearRange, segment, chain) {
        if (newLinearRange.isGap()) return false;
        return chain.elements.some((e)=>e.hasBlankValue() && e.getStartDistance() === segment.startDistance + newLinearRange.getEndDistance());
    }
    isLastLinearRange(newLinearRange, segment, chain) {
        const lastElementOfChain = chain.elements[chain.elements.length - 1];
        return lastElementOfChain.getStartDistance() === segment.startDistance + newLinearRange.getEndDistance();
    }
    recalculateValue(linearRange, spreadDistance) {
        if (linearRange.getValue() === BLANK_VALUE_STRING_REPRESENTATION) return BLANK_VALUE_STRING_REPRESENTATION;
        const startValue = parseFloat(linearRange.getStartValue());
        const endValue = parseFloat(linearRange.getEndValue());
        const deltaValue = endValue - startValue;
        const deltaDistance = linearRange.getEndDistance() - linearRange.getStartDistance();
        return String(Math.round(startValue + deltaValue / deltaDistance * spreadDistance));
    }
    rangeMatchingAtEnd(linearRange, segment) {
        return segment.startDistance >= linearRange.getStartDistance() && segment.endDistance === linearRange.getEndDistance();
    }
};
// src/reinterpolation/handlers/ReinterpolateSpotChain.ts
var ReinterpolateSpotChain = class _ReinterpolateSpotChain extends ReinterpolateLRChain {
    static INSTANCE = new _ReinterpolateSpotChain();
    reinterpolate(components, unsectionedChain) {
        unsectionedChain.elements.map((element)=>element).forEach((offset)=>this.updateComponentsWithReInterpolateBasedOnOffset(components, offset, unsectionedChain));
        return components;
    }
    updateComponentsWithReInterpolateBasedOnOffset(components, offset, chain) {
        const maxDistance = components.getTotalLengthDefined();
        components.segments.forEach((segment)=>{
            if (this.isOffsetOnStartOrEndDistance(offset, segment)) {
                if (chain.interpolationSpecType === "TAG") this.attachKeyValueToSegmentPoint(chain, offset, components.points);
                else if (chain.interpolationSpecType === "ROLE") {
                    if (segment.startDistance === offset.getOffsetDistance()) {
                        const newOffset = LROffset.createOffset(0, offset.getValue());
                        this.attachRecalculatedKeyValueToSegment(chain, newOffset, segment);
                    } else if (maxDistance === offset.getOffsetDistance()) {
                        const newOffset = LROffset.createOffset(segment.endDistance - segment.startDistance, offset.getValue());
                        this.attachRecalculatedKeyValueToSegment(chain, newOffset, segment);
                    }
                }
            } else if (this.isOffsetInsideRange(offset, segment)) {
                const newOffset = LROffset.createOffset(offset.getOffsetDistance() - segment.startDistance, offset.getValue());
                this.attachRecalculatedKeyValueToSegment(chain, newOffset, segment);
            }
        });
    }
    isOffsetInsideRange(offset, segment) {
        return segment.startDistance < offset.getOffsetDistance() && segment.endDistance > offset.getOffsetDistance();
    }
    isOffsetOnStartOrEndDistance(offset, segment) {
        return segment.startDistance === offset.getOffsetDistance() || segment.endDistance === offset.getOffsetDistance();
    }
    attachKeyValueToSegmentPoint(chain, offset, points) {
        const key = KeyHelper.generateNonLrKeyFromChain(chain);
        if (key !== void 0) points.filter((point)=>point.distance === offset.getOffsetDistance()).forEach((point)=>point.addAttribute(key, offset.getValue()));
    }
};
// src/reinterpolation/handlers/ReinterpolateStepChain.ts
var ReinterpolateStepChain = class _ReinterpolateStepChain extends ReinterpolateLRChain {
    static INSTANCE = new _ReinterpolateStepChain();
    reinterpolate(components, unsectionedChain) {
        unsectionedChain.distribute(1 /* RANGES */ ).elements.map((element)=>element).forEach((range)=>this.updateComponentsWithReInterpolateBasedOnRange(components, range, unsectionedChain));
        return components;
    }
    updateComponentsWithReInterpolateBasedOnRange(components, range, chain) {
        components.segments.forEach((segment)=>{
            let newRange = null;
            if (this.rangeWithinSegment(segment, range)) newRange = LRRange.createRange(range.getStartDistance() - segment.startDistance, range.getEndDistance() - segment.startDistance, range.getValue());
            else if (this.segmentWithinRange(segment, range)) newRange = LRRange.createRange(0, segment.getLength(), range.getValue());
            else if (this.rangeOverlapsSegmentStart(segment, range)) newRange = LRRange.createRange(0, range.getEndDistance() - segment.startDistance, range.getValue());
            else if (this.rangeOverlapsSegmentEnd(segment, range)) newRange = LRRange.createRange(range.getStartDistance() - segment.startDistance, segment.getLength(), range.getValue());
            this.addRangeToSegment(segment, newRange, chain);
        });
    }
    addRangeToSegment(segment, newRange, chain) {
        if (newRange == null) return;
        let encodingElement = newRange;
        if (newRange.getEndDistance() === segment.getLength()) encodingElement = LROffset.createOffset(newRange.getStartDistance(), newRange.getValue());
        if (encodingElement instanceof LROffset && encodingElement.getOffsetDistance() === 0) {
            const key = KeyHelper.generateNonLrKeyFromChain(chain);
            if (key !== void 0) segment.addAttribute(key, encodingElement.getValue());
        } else this.attachRecalculatedKeyValueToSegment(chain, encodingElement, segment);
    }
};
// src/reinterpolation/Reinterpolator.ts
var Reinterpolator = class _Reinterpolator {
    reinterpolate(components, encodedChain) {
        let encodedChainList;
        if (encodedChain instanceof LRChainEncoded) encodedChainList = [
            encodedChain
        ];
        else encodedChainList = encodedChain;
        let reinterpolatedComponents = components;
        for (const myEncodedChain of encodedChainList)reinterpolatedComponents = this.reinterpolateInternal(reinterpolatedComponents, myEncodedChain.decode());
        return reinterpolatedComponents;
    }
    reinterpolateInternal(components, unSectionedChain) {
        return _Reinterpolator.createReinterpolator(unSectionedChain, components.copy());
    }
    static createReinterpolator(unSectionedChain, reInterpolatedResultForChain) {
        if (unSectionedChain.interpolationType === void 0) throw new Error("Interpolation type not provided");
        switch(unSectionedChain.interpolationType){
            case "spot" /* SPOT */ :
                return ReinterpolateSpotChain.INSTANCE.reinterpolate(reInterpolatedResultForChain, unSectionedChain);
            case "step" /* STEP */ :
                return ReinterpolateStepChain.INSTANCE.reinterpolate(reInterpolatedResultForChain, unSectionedChain);
            case "linear" /* LINEAR */ :
                return ReinterpolateLinearChain.INSTANCE.reinterpolate(reInterpolatedResultForChain, unSectionedChain);
            default:
                throw new Error("Interpolation type not supported");
        }
    }
};
// src/geometry/CoordConverterGaussKruger.ts
var CoordConverterGaussKruger = class {
    deg2rad = Math.PI / 180;
    rad2deg = 180 / Math.PI;
    centerMeridian;
    longOrigin = -1;
    k0 = -1;
    eastOffset = -1;
    northOffset = -1;
    longOriginRad;
    equatorialRadius = -1;
    eccentricitySquared;
    eccentricitySquared_pow2;
    eccentricitySquared_pow3;
    e1;
    e1_pow2;
    // e1 * e1
    e1_pow3;
    // e1 * e1 * e1
    e1_pow4;
    // e1 * e1 * e1
    eccPrimeSquared;
    constructor(centralMeridian, scaleFactor = 1, falseEasting = 0, falseNorthing = 0){
        this.centerMeridian = centralMeridian;
        this.k0 = scaleFactor;
        this.longOrigin = this.centerMeridian;
        this.eastOffset = falseEasting;
        this.northOffset = falseNorthing;
        this.eccentricitySquared = 669438e-8;
        this.equatorialRadius = 6378137;
        this.eccentricitySquared_pow2 = this.eccentricitySquared * this.eccentricitySquared;
        this.eccentricitySquared_pow3 = this.eccentricitySquared * this.eccentricitySquared * this.eccentricitySquared;
        this.eccPrimeSquared = this.eccentricitySquared / (1 - this.eccentricitySquared);
        this.longOriginRad = this.longOrigin * this.deg2rad;
        this.e1 = (1 - Math.sqrt(1 - this.eccentricitySquared)) / (1 + Math.sqrt(1 - this.eccentricitySquared));
        this.e1_pow2 = this.e1 * this.e1;
        this.e1_pow3 = this.e1_pow2 * this.e1;
        this.e1_pow4 = this.e1_pow3 * this.e1;
    }
    convertWgsToGaussKrueger(lon, lat) {
        let utmNorthing;
        const longTemp = lon + 180 - Math.floor((lon + 180) / 360) * 360 - 180;
        const latRad = lat * this.deg2rad;
        const longRad = longTemp * this.deg2rad;
        const N = this.equatorialRadius / Math.sqrt(1 - this.eccentricitySquared * Math.sin(latRad) * Math.sin(latRad));
        const T = Math.tan(latRad) * Math.tan(latRad);
        const C = this.eccPrimeSquared * Math.cos(latRad) * Math.cos(latRad);
        const A = Math.cos(latRad) * (longRad - this.longOriginRad);
        const M = this.equatorialRadius * ((1 - this.eccentricitySquared / 4 - 3 * this.eccentricitySquared_pow2 / 64 - 5 * this.eccentricitySquared_pow3 / 256) * latRad - (3 * this.eccentricitySquared / 8 + 3 * this.eccentricitySquared_pow2 / 32 + 45 * this.eccentricitySquared_pow3 / 1024) * Math.sin(2 * latRad) + (15 * this.eccentricitySquared_pow2 / 256 + 45 * this.eccentricitySquared_pow3 / 1024) * Math.sin(4 * latRad) - 35 * this.eccentricitySquared_pow3 / 3072 * Math.sin(6 * latRad));
        const utmEasting = this.k0 * N * (A + (1 - T + C) * A * A * A / 6 + (5 - 18 * T + T * T + 72 * C - 58 * this.eccPrimeSquared) * A * A * A * A * A / 120) - this.eastOffset;
        utmNorthing = this.k0 * (M + N * Math.tan(latRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24 + (61 - 58 * T + T * T + 600 * C - 330 * this.eccPrimeSquared) * A * A * A * A * A * A / 720));
        utmNorthing -= this.northOffset;
        return [
            utmEasting,
            utmNorthing
        ];
    }
    convertGaussKruegerToWgs(easting, northing) {
        const x = easting + this.eastOffset;
        const y = northing + this.northOffset;
        const M = y / this.k0;
        const mu = M / (this.equatorialRadius * (1 - this.eccentricitySquared / 4 - 3 * this.eccentricitySquared_pow2 / 64 - 5 * this.eccentricitySquared_pow3 / 256));
        const phi1Rad = mu + (3 * this.e1 / 2 - 27 * this.e1_pow3 / 32) * Math.sin(2 * mu) + (21 * this.e1_pow2 / 16 - 55 * this.e1_pow4 / 32) * Math.sin(4 * mu) + 151 * this.e1_pow3 / 96 * Math.sin(6 * mu);
        const N1 = this.equatorialRadius / Math.sqrt(1 - this.eccentricitySquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
        const T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
        const C1 = this.eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
        const R1 = this.equatorialRadius * (1 - this.eccentricitySquared) / Math.pow(1 - this.eccentricitySquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
        const D = x / (N1 * this.k0);
        const Lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * this.eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * this.eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
        const LatDeg = Lat * this.rad2deg;
        const Longitude = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * this.eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
        const LongitudeDeg = this.longOrigin + Longitude * this.rad2deg;
        return [
            LongitudeDeg,
            LatDeg
        ];
    }
};
// src/valueat/ValueAtProducer.ts
var ValueAtProducer = class {
    static getValueAt(tagKey, tagValue, distanceCm, interpolationSpecType = "TAG" /* TAG */ ) {
        if (tagValue === void 0) return void 0;
        if (!KeyHelper.isInterpolatedFromKey(tagKey)) return tagValue;
        const lrComponents = LRComponents.builder().point(LRPoint.builder().withDistance(distanceCm).withCoordinate({
            x: 0,
            y: 0
        }).build()).segment(LRSegment.builder().withStartDistance(distanceCm - 1).withEndDistance(distanceCm).build()).segment(LRSegment.builder().withStartDistance(distanceCm).withEndDistance(distanceCm + 1).build()).build();
        const reinterpolated = new Reinterpolator().reinterpolate(lrComponents, new LRChainEncoded(tagKey, tagValue, interpolationSpecType));
        const valueFromPoint = this.getTagValue(reinterpolated.points[0].attributes, tagKey, 0);
        if (valueFromPoint !== void 0) return valueFromPoint;
        const valueFromSecondSegment = this.getTagValue(reinterpolated.segments[1].attributes, tagKey, 0);
        if (valueFromSecondSegment !== void 0) return valueFromSecondSegment;
        const valueFromFirstSegment = this.getTagValue(reinterpolated.segments[0].attributes, tagKey, 1);
        return valueFromFirstSegment;
    }
    static getTagValue(attributes, tagKey, distanceCm) {
        let lookupTagKey;
        if (attributes.has(tagKey)) lookupTagKey = tagKey;
        else lookupTagKey = KeyHelper.extractChainNameFromKey(tagKey);
        const value = attributes.get(lookupTagKey);
        if (value === void 0) return void 0;
        if (!KeyHelper.isInterpolatedFromKey(lookupTagKey)) return value;
        const lrChainLRChains = new LRDecoder().withInterpolationSpecType("TAG" /* TAG */ ).withKey(lookupTagKey).withValue(value).decode();
        const offsets = lrChainLRChains.getChains()[0].elements.filter((element)=>element.getStartDistance() === distanceCm);
        if (offsets.length === 0) return void 0;
        return offsets[0].getValue();
    }
};
// src/geometry/Conversions.ts
var Conversions = class {
    static toCm(lengthM) {
        return Math.round(lengthM * 100);
    }
    static toM(lengthCm) {
        return lengthCm / 100;
    }
};
function lengthOnPlaneCm(lineString, converter = null) {
    return Conversions.toCm(lengthOnPlaneM(toLineString(lineString), converter));
}
function getConverter(lineStringOrWkt) {
    const myLineString = toLineString(lineStringOrWkt);
    const boundingBox = (0, _bbox.bbox)(myLineString);
    const minLon = boundingBox[0];
    const maxLon = boundingBox[2];
    const centroidLon = (maxLon + minLon) / 2;
    return new CoordConverterGaussKruger(centroidLon);
}
function lengthOnPlaneM(lineStringOrWkt, converter = null) {
    const myLineString = toLineString(lineStringOrWkt);
    const myConverter = toConverter(converter, myLineString);
    const planarCoordinates = myLineString.coordinates.map((position)=>myConverter.convertWgsToGaussKrueger(position[0], position[1]));
    const lengthM = planarCoordinates.toSpliced(-1).map((position, index)=>{
        const nextPosition = planarCoordinates[index + 1];
        return Math.sqrt(Math.pow(position[0] - nextPosition[0], 2) + Math.pow(position[1] - nextPosition[1], 2));
    }).reduce((a, b)=>a + b);
    return lengthM;
}
function toLineString(lineString) {
    if (typeof lineString === "string") {
        const geometry = (0, _betterknown.wktToGeoJSON)(lineString.valueOf());
        if (geometry !== null && geometry.type === "LineString") return geometry;
        else throw new Error("WKT could not be translated to a LineString");
    } else return lineString;
}
function toConverter(converter, myLineString) {
    if (converter == null) return getConverter(myLineString);
    else return converter;
}

},{"@turf/bbox":"gAlU9","betterknown":"28MuN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gAlU9":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bbox", ()=>bbox);
parcelHelpers.export(exports, "default", ()=>index_default);
var _meta = require("@turf/meta");
function bbox(geojson, options = {}) {
    if (geojson.bbox != null && true !== options.recompute) return geojson.bbox;
    const result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, _meta.coordEach)(geojson, (coord)=>{
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
var index_default = bbox;

},{"@turf/meta":"7ABec","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7ABec":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "coordAll", ()=>coordAll);
parcelHelpers.export(exports, "coordEach", ()=>coordEach);
parcelHelpers.export(exports, "coordReduce", ()=>coordReduce);
parcelHelpers.export(exports, "featureEach", ()=>featureEach);
parcelHelpers.export(exports, "featureReduce", ()=>featureReduce);
parcelHelpers.export(exports, "findPoint", ()=>findPoint);
parcelHelpers.export(exports, "findSegment", ()=>findSegment);
parcelHelpers.export(exports, "flattenEach", ()=>flattenEach);
parcelHelpers.export(exports, "flattenReduce", ()=>flattenReduce);
parcelHelpers.export(exports, "geomEach", ()=>geomEach);
parcelHelpers.export(exports, "geomReduce", ()=>geomReduce);
parcelHelpers.export(exports, "lineEach", ()=>lineEach);
parcelHelpers.export(exports, "lineReduce", ()=>lineReduce);
parcelHelpers.export(exports, "propEach", ()=>propEach);
parcelHelpers.export(exports, "propReduce", ()=>propReduce);
parcelHelpers.export(exports, "segmentEach", ()=>segmentEach);
parcelHelpers.export(exports, "segmentReduce", ()=>segmentReduce);
var _helpers = require("@turf/helpers");
function coordEach(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[featureIndex].geometry : isFeature ? // @ts-expect-error: Known type conflict
        geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (// @ts-expect-error: Known type conflict
                    callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (// @ts-expect-error: Known type conflict
                        callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (// @ts-expect-error: Known type conflict
                            callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (// @ts-expect-error: Known type conflict
                                callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if (// @ts-expect-error: Known type conflict
                    coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    coordEach(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(// @ts-expect-error: Known type conflict
        previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function propEach(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function propReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    propEach(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function featureEach(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function featureReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    featureEach(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function coordAll(geojson) {
    var coords = [];
    coordEach(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function geomEach(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].geometry : isFeature ? // @ts-expect-error: Known type conflict
        geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].properties : isFeature ? // @ts-expect-error: Known type conflict
        geojson.properties : {};
        featureBBox = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].bbox : isFeature ? // @ts-expect-error: Known type conflict
        geojson.bbox : void 0;
        featureId = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].id : isFeature ? // @ts-expect-error: Known type conflict
        geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (// @ts-expect-error: Known type conflict
                callback(// @ts-expect-error: Known type conflict
                null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (// @ts-expect-error: Known type conflict
                    callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (// @ts-expect-error: Known type conflict
                        callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function geomReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    geomEach(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(// @ts-expect-error: Known type conflict
        previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function flattenEach(geojson, callback) {
    geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (// @ts-expect-error: Known type conflict
                callback((0, _helpers.feature)(geometry, properties, {
                    bbox,
                    id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; // @ts-expect-error: Known type conflict
        multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (// @ts-expect-error: Known type conflict
            callback((0, _helpers.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function flattenReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    flattenEach(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(// @ts-expect-error: Known type conflict
        previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function segmentEach(geojson, callback) {
    flattenEach(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if (// @ts-expect-error: Known type conflict
        coordEach(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (// @ts-expect-error: Known type conflict
            previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, _helpers.lineString)(// @ts-expect-error: Known type conflict
            [
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (// @ts-expect-error: Known type conflict
            callback(// @ts-expect-error: Known type conflict
            currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function segmentReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    segmentEach(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, // @ts-expect-error: Known type conflict
        currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function lineEach(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    flattenEach(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (// @ts-expect-error: Known type conflict
                    callback(// @ts-expect-error: Known type conflict
                    (0, _helpers.lineString)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function lineReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    lineEach(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function findSegment(geojson, options) {
    options = options || {};
    if (!(0, _helpers.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, _helpers.lineString)(// @ts-expect-error: Known type conflict
            [
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, _helpers.lineString)([
                // @ts-expect-error: Known type conflict
                coords[geometryIndex][segmentIndex],
                // @ts-expect-error: Known type conflict
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, _helpers.lineString)([
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][segmentIndex],
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, _helpers.lineString)([
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function findPoint(geojson, options) {
    options = options || {};
    if (!(0, _helpers.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, _helpers.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, _helpers.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, _helpers.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, _helpers.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, _helpers.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, _helpers.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

},{"@turf/helpers":"ityOQ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ityOQ":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areaFactors", ()=>areaFactors);
parcelHelpers.export(exports, "azimuthToBearing", ()=>azimuthToBearing);
parcelHelpers.export(exports, "bearingToAzimuth", ()=>bearingToAzimuth);
parcelHelpers.export(exports, "convertArea", ()=>convertArea);
parcelHelpers.export(exports, "convertLength", ()=>convertLength);
parcelHelpers.export(exports, "degreesToRadians", ()=>degreesToRadians);
parcelHelpers.export(exports, "earthRadius", ()=>earthRadius);
parcelHelpers.export(exports, "factors", ()=>factors);
parcelHelpers.export(exports, "feature", ()=>feature);
parcelHelpers.export(exports, "featureCollection", ()=>featureCollection);
parcelHelpers.export(exports, "geometry", ()=>geometry);
parcelHelpers.export(exports, "geometryCollection", ()=>geometryCollection);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "lengthToDegrees", ()=>lengthToDegrees);
parcelHelpers.export(exports, "lengthToRadians", ()=>lengthToRadians);
parcelHelpers.export(exports, "lineString", ()=>lineString);
parcelHelpers.export(exports, "lineStrings", ()=>lineStrings);
parcelHelpers.export(exports, "multiLineString", ()=>multiLineString);
parcelHelpers.export(exports, "multiPoint", ()=>multiPoint);
parcelHelpers.export(exports, "multiPolygon", ()=>multiPolygon);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "points", ()=>points);
parcelHelpers.export(exports, "polygon", ()=>polygon);
parcelHelpers.export(exports, "polygons", ()=>polygons);
parcelHelpers.export(exports, "radiansToDegrees", ()=>radiansToDegrees);
parcelHelpers.export(exports, "radiansToLength", ()=>radiansToLength);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "validateBBox", ()=>validateBBox);
parcelHelpers.export(exports, "validateId", ()=>validateId);
var earthRadius = 63710088e-1;
var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: 360 / (2 * Math.PI),
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1e3,
    kilometres: earthRadius / 1e3,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1e3,
    millimetres: earthRadius * 1e3,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936
};
var areaFactors = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function feature(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function geometry(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function point(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates
    };
    return feature(geom, properties, options);
}
function points(coordinates, properties, options = {}) {
    return featureCollection(coordinates.map((coords)=>{
        return point(coords, properties);
    }), options);
}
function polygon(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates
    };
    return feature(geom, properties, options);
}
function polygons(coordinates, properties, options = {}) {
    return featureCollection(coordinates.map((coords)=>{
        return polygon(coords, properties);
    }), options);
}
function lineString(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates
    };
    return feature(geom, properties, options);
}
function lineStrings(coordinates, properties, options = {}) {
    return featureCollection(coordinates.map((coords)=>{
        return lineString(coords, properties);
    }), options);
}
function featureCollection(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function multiLineString(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates
    };
    return feature(geom, properties, options);
}
function multiPoint(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates
    };
    return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates
    };
    return feature(geom, properties, options);
}
function geometryCollection(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries
    };
    return feature(geom, properties, options);
}
function round(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians, units = "kilometers") {
    const factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function lengthToRadians(distance, units = "kilometers") {
    const factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
function bearingToAzimuth(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function azimuthToBearing(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function radiansToDegrees(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function degreesToRadians(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function convertLength(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
function convertArea(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = areaFactors[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = areaFactors[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function validateBBox(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!isNumber(num)) throw new Error("bbox must only contain numbers");
    });
}
function validateId(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"28MuN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoJSONToWkt", ()=>y);
parcelHelpers.export(exports, "wktToGeoJSON", ()=>C);
const u = [
    "POINT",
    "LINESTRING",
    "POLYGON",
    "MULTIPOINT",
    "MULTILINESTRING",
    "MULTIPOLYGON",
    "GEOMETRYCOLLECTION"
], d = [
    "ZM",
    "Z",
    "M"
], o = "EMPTY";
class l {
    constructor(n){
        this.value = n, this.position = 0;
    }
    match(n) {
        this.skipWhitespaces();
        for (const e of n)if (this.value.startsWith(e, this.position)) return this.position += e.length, e;
        return null;
    }
    matchRegex(n) {
        this.skipWhitespaces();
        for (const e of n){
            const r = this.value.substring(this.position).match(e);
            if (r) return this.position += r[0].length, r;
        }
        return null;
    }
    isMatch(n) {
        return this.skipWhitespaces(), this.value.startsWith(n, this.position) ? (this.position += n.length, !0) : !1;
    }
    matchType() {
        const n = this.match(u);
        if (!n) throw new Error("Expected geometry type");
        return n;
    }
    matchDimension() {
        switch(this.match(d)){
            case "ZM":
                return {
                    hasZ: !0,
                    hasM: !0
                };
            case "Z":
                return {
                    hasZ: !0,
                    hasM: !1
                };
            case "M":
                return {
                    hasZ: !1,
                    hasM: !0
                };
            default:
                return {
                    hasZ: !1,
                    hasM: !1
                };
        }
    }
    expectGroupStart() {
        if (!this.isMatch("(")) throw new Error("Expected group start");
    }
    expectGroupEnd() {
        if (!this.isMatch(")")) throw new Error("Expected group end");
    }
    matchCoordinate(n) {
        let e;
        if (n.hasZ && n.hasM ? e = this.matchRegex([
            /^(\S*)\s+(\S*)\s+(\S*)\s+([^\s,)]*)/
        ]) : n.hasZ || n.hasM ? e = this.matchRegex([
            /^(\S*)\s+(\S*)\s+([^\s,)]*)/
        ]) : e = this.matchRegex([
            /^(\S*)\s+([^\s,)]*)/
        ]), !e) throw new Error("Expected coordinates");
        const r = n.hasZ && n.hasM ? [
            parseFloat(e[1]),
            parseFloat(e[2]),
            parseFloat(e[3]),
            parseFloat(e[4])
        ] : n.hasZ ? [
            parseFloat(e[1]),
            parseFloat(e[2]),
            parseFloat(e[3])
        ] : n.hasM ? [
            parseFloat(e[1]),
            parseFloat(e[2])
        ] : [
            parseFloat(e[1]),
            parseFloat(e[2])
        ];
        if (n.srid && n.srid !== 4326) {
            if (n.proj) return n.proj(`EPSG:${n.srid}`, "EPSG:4326", r);
            throw new Error(`EWKT data in an unknown SRID (${n.srid}) was provided, but a proj function was not`);
        }
        return r;
    }
    matchCoordinates(n) {
        const e = [];
        do {
            const r = this.isMatch("(");
            e.push(this.matchCoordinate(n)), r && this.expectGroupEnd();
        }while (this.isMatch(","));
        return e;
    }
    skipWhitespaces() {
        for(; this.position < this.value.length && this.value[this.position] === " ";)this.position++;
    }
}
const M = (t, n)=>{
    if (t.isMatch(o)) return n.emptyAsNull ? null : {
        type: "Point",
        coordinates: []
    };
    t.expectGroupStart();
    const e = t.matchCoordinate(n);
    return t.expectGroupEnd(), {
        type: "Point",
        coordinates: e
    };
}, f = (t, n)=>{
    if (t.isMatch(o)) return n.emptyAsNull ? null : {
        type: "LineString",
        coordinates: []
    };
    t.expectGroupStart();
    const e = t.matchCoordinates(n);
    return t.expectGroupEnd(), {
        type: "LineString",
        coordinates: e
    };
}, E = (t, n)=>{
    if (t.isMatch(o)) return n.emptyAsNull ? null : {
        type: "Polygon",
        coordinates: []
    };
    const e = [];
    for(t.expectGroupStart(), t.expectGroupStart(), e.push(t.matchCoordinates(n)), t.expectGroupEnd(); t.isMatch(",");)t.expectGroupStart(), e.push(t.matchCoordinates(n)), t.expectGroupEnd();
    return t.expectGroupEnd(), {
        type: "Polygon",
        coordinates: e
    };
}, G = (t, n)=>{
    if (t.isMatch(o)) return n.emptyAsNull ? null : {
        type: "MultiPoint",
        coordinates: []
    };
    t.expectGroupStart();
    const e = t.matchCoordinates(n);
    return t.expectGroupEnd(), {
        type: "MultiPoint",
        coordinates: e
    };
}, T = (t, n)=>{
    if (t.isMatch(o)) return n.emptyAsNull ? null : {
        type: "MultiLineString",
        coordinates: []
    };
    t.expectGroupStart();
    const e = [];
    do t.expectGroupStart(), e.push(t.matchCoordinates(n)), t.expectGroupEnd();
    while (t.isMatch(","));
    return t.expectGroupEnd(), {
        type: "MultiLineString",
        coordinates: e
    };
}, N = (t, n)=>{
    if (t.isMatch(o)) return n.emptyAsNull ? null : {
        type: "MultiPolygon",
        coordinates: []
    };
    t.expectGroupStart();
    const e = [];
    do {
        t.expectGroupStart();
        const r = [], s = [];
        for(t.expectGroupStart(), r.push.apply(r, t.matchCoordinates(n)), t.expectGroupEnd(); t.isMatch(",");)t.expectGroupStart(), s.push(t.matchCoordinates(n)), t.expectGroupEnd();
        e.push([
            r,
            ...s
        ]), t.expectGroupEnd();
    }while (t.isMatch(","));
    return t.expectGroupEnd(), {
        type: "MultiPolygon",
        coordinates: e
    };
}, L = (t, n)=>{
    if (t.isMatch(o)) return n.emptyAsNull ? null : {
        type: "GeometryCollection",
        geometries: []
    };
    t.expectGroupStart();
    const e = [];
    do {
        const r = p(t, n);
        r && e.push(r);
    }while (t.isMatch(","));
    return t.expectGroupEnd(), {
        type: "GeometryCollection",
        geometries: e
    };
};
function c(t) {
    return t.join(" ");
}
function a(t) {
    if (t === void 0) return " ";
    switch(t.length){
        case 3:
            return " Z ";
        default:
            return " ";
    }
}
function S(t) {
    return t.coordinates.length === 0 ? "POINT EMPTY" : `POINT${a(t.coordinates)}(${c(t.coordinates)})`;
}
function m(t) {
    return t.coordinates.length === 0 ? "MULTIPOINT EMPTY" : `MULTIPOINT${a(t.coordinates[0])}(${t.coordinates.map((n)=>c(n)).join(",")})`;
}
function I(t) {
    if (t.coordinates.length === 0) return "LINESTRING EMPTY";
    const n = `(${t.coordinates.map((e)=>c(e)).join(",")})`;
    return `LINESTRING${a(t.coordinates[0])}${n}`;
}
function g(t) {
    return t.geometries.length === 0 ? "GEOMETRYCOLLECTION EMPTY" : `GEOMETRYCOLLECTION${`(${t.geometries.map((e)=>y(e)).join(",")})`}`;
}
function x(t) {
    if (t.coordinates.length === 0) return "MULTILINESTRING EMPTY";
    const n = `(${t.coordinates.map((e)=>`(${e.map((r)=>c(r))})`)})`;
    return `MULTILINESTRING${a(t.coordinates[0][0])}${n}`;
}
function O(t) {
    var e;
    if (t.coordinates.length === 0) return "POLYGON EMPTY";
    const n = `(${t.coordinates.map((r)=>`(${r.map((s)=>c(s))})`)})`;
    return `POLYGON${a((e = t.coordinates[0]) == null ? void 0 : e[0])}${n}`;
}
function P(t) {
    var e, r;
    if (t.coordinates.length === 0) return "MULTIPOLYGON EMPTY";
    const n = `(${t.coordinates.map((s)=>`(${s.map((h)=>`(${h.map((i)=>c(i))})`)})`)})`;
    return `MULTIPOLYGON${a((r = (e = t.coordinates[0]) == null ? void 0 : e[0]) == null ? void 0 : r[0])}${n}`;
}
function p(t, n) {
    let e = null;
    const r = t.matchRegex([
        /^SRID=(\d+);/
    ]);
    r && (e = parseInt(r[1], 10));
    const s = t.matchType(), h = t.matchDimension(), i = {
        ...n,
        srid: e,
        hasZ: h.hasZ,
        hasM: h.hasM
    };
    switch(s){
        case "POINT":
            return M(t, i);
        case "LINESTRING":
            return f(t, i);
        case "POLYGON":
            return E(t, i);
        case "MULTIPOINT":
            return G(t, i);
        case "MULTILINESTRING":
            return T(t, i);
        case "MULTIPOLYGON":
            return N(t, i);
        case "GEOMETRYCOLLECTION":
            return L(t, i);
    }
}
function y(t) {
    switch(t.type){
        case "Point":
            return S(t);
        case "LineString":
            return I(t);
        case "MultiPoint":
            return m(t);
        case "GeometryCollection":
            return g(t);
        case "Polygon":
            return O(t);
        case "MultiPolygon":
            return P(t);
        case "MultiLineString":
            return x(t);
    }
}
function C(t, n = {
    emptyAsNull: !0
}) {
    return p(new l(t), n);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4IC9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureTo4326Geometry", ()=>featureTo4326Geometry);
parcelHelpers.export(exports, "toLatLon", ()=>toLatLon);
parcelHelpers.export(exports, "distanceAlongCm", ()=>distanceAlongCm);
parcelHelpers.export(exports, "getCoordinateAtCm", ()=>getCoordinateAtCm);
// Decode a relation member role ("key=value") into the distance ranges (cm)
// along that member's own geometry where the member participates in the
// relation. Distances are measured on the orbis-lr-sdk Gauss-Krüger plane —
// the same metric as distanceAlongCm() and ValueAtProducer.getValueAt(ROLE).
parcelHelpers.export(exports, "getRoleRangesCm", ()=>getRoleRangesCm);
// Slice a [lon, lat] coordinate array between two cm offsets using the
// orbis-lr-sdk Gauss-Krüger plane distance (same metric as getRoleRangesCm /
// distanceAlongCm). Walks segment-by-segment and interpolates the cut points.
parcelHelpers.export(exports, "sliceLonLatLineByCm", ()=>sliceLonLatLineByCm);
// Slice an OL LineString geometry (EPSG:3857) to a [startCm, endCm] range,
// returning a new EPSG:3857 LineString. Distances are measured on the GK plane.
parcelHelpers.export(exports, "sliceOlLineByCm", ()=>sliceOlLineByCm);
parcelHelpers.export(exports, "rowHeader", ()=>rowHeader);
parcelHelpers.export(exports, "rowHint", ()=>rowHint);
parcelHelpers.export(exports, "row", ()=>row);
parcelHelpers.export(exports, "getTagValueAt", ()=>getTagValueAt);
parcelHelpers.export(exports, "getMembers", ()=>getMembers);
parcelHelpers.export(exports, "getMembersWithRole", ()=>getMembersWithRole);
parcelHelpers.export(exports, "getTags", ()=>getTags);
var _geoJSONJs = require("ol/format/GeoJSON.js");
var _geoJSONJsDefault = parcelHelpers.interopDefault(_geoJSONJs);
var _geom = require("ol/geom");
var _proj = require("ol/proj");
var _proj4 = require("proj4");
var _proj4Default = parcelHelpers.interopDefault(_proj4);
var _turf = require("@turf/turf");
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _nearestPointOnLineDefault = parcelHelpers.interopDefault(_nearestPointOnLine);
var _lineSlice = require("@turf/line-slice");
function featureTo4326Geometry(feature) {
    const format = new (0, _geoJSONJsDefault.default)();
    const geometry = format.writeFeatureObject(feature, {
        featureProjection: "EPSG:3857",
        dataProjection: "EPSG:4326"
    }).geometry;
    return geometry;
}
function toLatLon(geometry) {
    const proj = (0, _proj4Default.default)("EPSG:3857", "EPSG:4326");
    const latLonGeometry = (0, _turf.clone)(geometry);
    if (is2DArray(geometry.coordinates)) latLonGeometry.coordinates = geometry.coordinates.map((coordinate)=>proj.forward(coordinate));
    else latLonGeometry.coordinates = proj.forward(geometry.coordinates);
    return latLonGeometry;
}
function is2DArray(arr) {
    return Array.isArray(arr) && arr.every((element)=>Array.isArray(element));
}
function distanceAlongCm(latLonGeometry, latLonEventPoint) {
    const converter = (0, _orbisLrSdk.getConverter)(latLonGeometry);
    const closestPoint = (0, _nearestPointOnLineDefault.default)(latLonGeometry, latLonEventPoint);
    const sliceTurfFeature = (0, _lineSlice.lineSlice)(latLonGeometry.coordinates[0], closestPoint, latLonGeometry);
    const lengthCm = (0, _orbisLrSdk.lengthOnPlaneCm)(sliceTurfFeature.geometry, converter);
    return lengthCm;
}
function getCoordinateAtCm(olGeometry, distanceCm, lengthCm) {
    if (lengthCm <= 0) return olGeometry.getCoordinateAt(0);
    const fraction = Math.max(0, Math.min(1, distanceCm / lengthCm));
    return olGeometry.getCoordinateAt(fraction);
}
function getRoleRangesCm(role) {
    if (typeof role !== "string" || !role.includes("=")) return [];
    const [key, value] = role.split("=", 2);
    let chain;
    try {
        chain = new (0, _orbisLrSdk.LRDecoder)().withInterpolationSpecType((0, _orbisLrSdk.InterpolationSpecType).ROLE).decode(key, value);
    } catch  {
        return [];
    }
    return chain.elements.map((element)=>{
        const endCm = typeof element.getEndDistance === "function" ? element.getEndDistance() : undefined;
        return {
            startCm: element.getStartDistance(),
            // The LR spec allows the end to be omitted: the member is then involved
            // from this offset till the end of the segment (decoded as an open-ended
            // LROffset). Represent that as Infinity — sliceOlLineByCm clamps it to
            // the geometry's actual length.
            endCm: endCm === undefined || endCm === null ? Infinity : endCm
        };
    }).filter((range)=>range.endCm > range.startCm);
}
function sliceLonLatLineByCm(coords, startCm, endCm) {
    if (coords.length < 2) return coords.slice();
    const midCoord = coords[Math.floor(coords.length / 2)];
    const converter = (0, _orbisLrSdk.getConverter)({
        type: "LineString",
        coordinates: [
            midCoord,
            midCoord
        ]
    });
    const projected = coords.map((c)=>converter.convertWgsToGaussKrueger(c[0], c[1]));
    const cumDistCm = [
        0
    ];
    for(let i = 1; i < projected.length; i++){
        const dx = projected[i][0] - projected[i - 1][0];
        const dy = projected[i][1] - projected[i - 1][1];
        cumDistCm.push(cumDistCm[i - 1] + Math.sqrt(dx * dx + dy * dy) * 100);
    }
    const totalCm = cumDistCm[cumDistCm.length - 1];
    const clampedStart = Math.max(0, Math.min(startCm, totalCm));
    const clampedEnd = Math.max(clampedStart, Math.min(endCm, totalCm));
    const result = [
        interpolateLonLatAtCm(coords, cumDistCm, clampedStart)
    ];
    for(let i = 0; i < coords.length; i++)if (cumDistCm[i] > clampedStart && cumDistCm[i] < clampedEnd) result.push(coords[i]);
    result.push(interpolateLonLatAtCm(coords, cumDistCm, clampedEnd));
    return result;
}
function sliceOlLineByCm(olLineString, startCm, endCm) {
    const lonLat = olLineString.getCoordinates().map((c)=>(0, _proj.toLonLat)(c));
    const sliced = sliceLonLatLineByCm(lonLat, startCm, endCm);
    return new (0, _geom.LineString)(sliced.map((c)=>(0, _proj.fromLonLat)(c)));
}
function interpolateLonLatAtCm(coords, cumDistCm, targetCm) {
    if (targetCm <= 0) return coords[0];
    if (targetCm >= cumDistCm[cumDistCm.length - 1]) return coords[coords.length - 1];
    for(let i = 1; i < cumDistCm.length; i++)if (cumDistCm[i] >= targetCm) {
        const segLen = cumDistCm[i] - cumDistCm[i - 1];
        if (segLen === 0) return coords[i - 1];
        const t = (targetCm - cumDistCm[i - 1]) / segLen;
        return [
            coords[i - 1][0] + t * (coords[i][0] - coords[i - 1][0]),
            coords[i - 1][1] + t * (coords[i][1] - coords[i - 1][1])
        ];
    }
    return coords[coords.length - 1];
}
function rowHeader(value) {
    const tr = document.createElement("tr");
    const cell = document.createElement("th");
    cell.colSpan = 2;
    if (typeof value === "object") cell.appendChild(value);
    else cell.textContent = value;
    tr.append(cell);
    return tr;
}
function rowHint(value) {
    const tr = document.createElement("tr");
    const cell = document.createElement("td");
    cell.colSpan = 2;
    cell.className = "hint";
    cell.textContent = value;
    tr.append(cell);
    return tr;
}
function row(label, value) {
    const tr = document.createElement("tr");
    const cellLabel = document.createElement("td");
    cellLabel.classList.add("label");
    const cellValue = document.createElement("td");
    cellValue.classList.add("value");
    if (typeof label === "object") cellLabel.appendChild(label);
    else cellLabel.textContent = label;
    if (typeof value === "object") cellValue.appendChild(value);
    else cellValue.textContent = value;
    tr.append(cellLabel);
    tr.append(cellValue);
    return tr;
}
function getTagValueAt(tagKey, tagValue, lengthCm) {
    if (tagValue === undefined) return undefined;
    const lrComponents = (0, _orbisLrSdk.LRComponents).builder().segment((0, _orbisLrSdk.LRSegment).builder().withStartDistance(0).withEndDistance(lengthCm).build()).build();
    const reinterpolated = new (0, _orbisLrSdk.Reinterpolator)().reinterpolate(lrComponents, new (0, _orbisLrSdk.LRChainEncoded)(tagKey, tagValue));
    const reinterpolatedSegment = reinterpolated.segments[0];
    let lookupTagKey;
    if (reinterpolatedSegment.attributes.has(tagKey)) lookupTagKey = tagKey;
    else {
        const interpolationType = (0, _orbisLrSdk.InterpolationType).fromValue(tagKey);
        const baseTagKey = tagKey.replace(new RegExp(`:${interpolationType}$`), "");
        if (reinterpolatedSegment.attributes.has(baseTagKey)) lookupTagKey = baseTagKey;
        else return "";
    }
    const lrChainLRChains = new (0, _orbisLrSdk.LRDecoder)().withInterpolationSpecType((0, _orbisLrSdk.InterpolationSpecType).TAG).withKey(lookupTagKey).withValue(reinterpolatedSegment.attributes.get(lookupTagKey)).decode();
    return lrChainLRChains.getChains()[0].elements.slice(-1)[0].value;
}
function getMembers(feature) {
    const members = [];
    let i = 0;
    while(feature.get(`relation-member-${i}-id`) !== undefined){
        const id = feature.get(`relation-member-${i}-id`);
        const role = feature.get(`relation-member-${i}-role`);
        const member = {
            id,
            role
        };
        const lrStart = feature.get(`relation-member-${i}-lr-start`);
        const lrEnd = feature.get(`relation-member-${i}-lr-end`);
        const lrType = feature.get(`relation-member-${i}-lr-type`);
        if (lrStart !== undefined || lrEnd !== undefined || lrType !== undefined) {
            member.lrRange = {};
            if (lrStart !== undefined) member.lrRange.start = Number(lrStart);
            if (lrEnd !== undefined) member.lrRange.end = Number(lrEnd);
            if (lrType !== undefined) member.lrRange.type = lrType;
        }
        members.push(member);
        i++;
    }
    return members;
}
function getMembersWithRole(feature, requestedRole) {
    return getMembers(feature).filter((member)=>member.role === requestedRole);
}
function getTags(feature) {
    const properties = feature.getProperties();
    return Object.entries(properties).reduce((acc, [property, tagValue])=>{
        const match = property.match(/^(\d+)-(.+)$/);
        if (match) {
            const layerId = parseInt(match[1], 10);
            const key = match[2];
            const revision = properties[`revision-${property}`];
            acc.push({
                tagKey: {
                    layerId,
                    key
                },
                tagValue: tagValue,
                revision: revision ? parseInt(revision, 10) : null
            });
        }
        return acc;
    }, []);
}

},{"ol/format/GeoJSON.js":"aL7Lr","ol/geom":[["LineString","223qD","default"]],"ol/proj":"gN0IK","proj4":"aXaqI","@turf/turf":"QJU1H","@orbis-lr-sdk/orbis-lr-sdk":"04bfk","@turf/nearest-point-on-line":"bwWlY","@turf/line-slice":"lgD6Y","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aL7Lr":[function(require,module,exports,__globalThis) {
/**
 * @module ol/format/GeoJSON
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _simpleGeometryJs = require("../geom/SimpleGeometry.js");
var _deflateJs = require("../geom/flat/deflate.js");
var _objJs = require("../obj.js");
var _projJs = require("../proj.js");
var _featureJs = require("../render/Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _featureJs1 = require("./Feature.js");
var _jsonfeatureJs = require("./JSONFeature.js");
var _jsonfeatureJsDefault = parcelHelpers.interopDefault(_jsonfeatureJs);
/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {JSONFeature<FeatureType>}
 * @api
 */ class GeoJSON extends (0, _jsonfeatureJsDefault.default) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, _projJs.get)(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, _projJs.get)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            'application/geo+json',
            'application/vnd.geo+json'
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object['type'] === 'Feature') geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            'type': 'Feature',
            'geometry': /** @type {GeoJSONGeometry} */ object,
            'properties': null
        };
        const geometry = readGeometryInternal(geoJSONFeature['geometry'], options);
        if (this.featureClass === (0, _featureJsDefault.default)) return /** @type {FeatureType|Array<FeatureType>} */ (0, _featureJs1.createRenderFeature)({
            geometry,
            id: geoJSONFeature['id'],
            properties: geoJSONFeature['properties']
        }, options);
        const FeatureClass = /** @type {typeof import("../Feature.js").default} */ this.featureClass;
        const feature = new FeatureClass();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature['geometry_name']) feature.setGeometryName(geoJSONFeature['geometry_name']);
        feature.setGeometry((0, _featureJs1.createGeometry)(geometry, options));
        if ('id' in geoJSONFeature) feature.setId(geoJSONFeature['id']);
        if (geoJSONFeature['properties']) feature.setProperties(geoJSONFeature['properties'], true);
        return /** @type {FeatureType|Array<FeatureType>} */ feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        let features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection['features'];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return /** @type {Array<FeatureType>} */ features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromObject(object, options) {
        return readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */ readProjectionFromObject(object) {
        const crs = object['crs'];
        let projection;
        if (crs) {
            if (crs['type'] == 'name') projection = (0, _projJs.get)(crs['properties']['name']);
            else if (crs['type'] === 'EPSG') projection = (0, _projJs.get)('EPSG:' + crs['properties']['code']);
            else throw new Error('Unknown SRS type');
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            'type': 'Feature',
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, _objJs.isEmpty)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: 'FeatureCollection',
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */ writeGeometryObject(geometry, options) {
        return writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object['type']){
        case 'Point':
            geometry = readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case 'LineString':
            geometry = readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case 'Polygon':
            geometry = readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case 'MultiPoint':
            geometry = readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case 'MultiLineString':
            geometry = readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case 'MultiPolygon':
            geometry = readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case 'GeometryCollection':
            geometry = readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error('Unsupported GeoJSON type: ' + object['type']);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function readGeometry(object, options) {
    const geometryObject = readGeometryInternal(object, options);
    return (0, _featureJs1.createGeometry)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function readGeometryCollectionGeometry(object, options) {
    const geometries = object['geometries'].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function readPointGeometry(object) {
    const flatCoordinates = object['coordinates'];
    return {
        type: 'Point',
        flatCoordinates,
        layout: (0, _simpleGeometryJs.getLayoutForStride)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function readLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = coordinates.flat();
    return {
        type: 'LineString',
        flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, _simpleGeometryJs.getLayoutForStride)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function readMultiLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, _deflateJs.deflateCoordinatesArray)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiLineString',
        flatCoordinates,
        ends,
        layout: (0, _simpleGeometryJs.getLayoutForStride)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function readMultiPointGeometry(object) {
    const coordinates = object['coordinates'];
    return {
        type: 'MultiPoint',
        flatCoordinates: coordinates.flat(),
        layout: (0, _simpleGeometryJs.getLayoutForStride)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function readMultiPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, _deflateJs.deflateMultiCoordinatesArray)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiPolygon',
        flatCoordinates,
        ends: endss,
        layout: (0, _simpleGeometryJs.getLayoutForStride)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function readPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, _deflateJs.deflateCoordinatesArray)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'Polygon',
        flatCoordinates,
        ends,
        layout: (0, _simpleGeometryJs.getLayoutForStride)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function writeGeometry(geometry, options) {
    geometry = (0, _featureJs1.transformGeometryWithOptions)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case 'Point':
            geoJSON = writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case 'LineString':
            geoJSON = writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case 'Polygon':
            geoJSON = writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case 'MultiPoint':
            geoJSON = writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case 'MultiLineString':
            geoJSON = writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case 'MultiPolygon':
            geoJSON = writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case 'GeometryCollection':
            geoJSON = writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case 'Circle':
            geoJSON = {
                type: 'GeometryCollection',
                geometries: []
            };
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function writeLineStringGeometry(geometry, options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function writeMultiLineStringGeometry(geometry, options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function writeMultiPointGeometry(geometry, options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function writePointGeometry(geometry, options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right)
    };
}
exports.default = GeoJSON;

},{"../geom/SimpleGeometry.js":"5Lm1Z","../geom/flat/deflate.js":"8nFry","../obj.js":"GxveT","../proj.js":"gN0IK","../render/Feature.js":"THre5","./Feature.js":"lq6wN","./JSONFeature.js":"z3mVW","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"z3mVW":[function(require,module,exports,__globalThis) {
/**
 * @module ol/format/JSONFeature
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilJs = require("../util.js");
var _featureJs = require("./Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {FeatureFormat<FeatureType>}
 * @abstract
 */ class JSONFeature extends (0, _featureJsDefault.default) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'json';
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromObject(getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromObject(getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromObject(getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromObject(getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, _utilJs.abstract)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, _utilJs.abstract)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function getObject(source) {
    if (typeof source === 'string') {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
exports.default = JSONFeature;

},{"../util.js":"9Y20j","./Feature.js":"lq6wN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aXaqI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("./core");
var _coreDefault = parcelHelpers.interopDefault(_core);
var _proj = require("./Proj");
var _projDefault = parcelHelpers.interopDefault(_proj);
var _point = require("./Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _toPoint = require("./common/toPoint");
var _toPointDefault = parcelHelpers.interopDefault(_toPoint);
var _defs = require("./defs");
var _defsDefault = parcelHelpers.interopDefault(_defs);
var _nadgrid = require("./nadgrid");
var _nadgridDefault = parcelHelpers.interopDefault(_nadgrid);
var _transform = require("./transform");
var _transformDefault = parcelHelpers.interopDefault(_transform);
var _mgrs = require("mgrs");
var _mgrsDefault = parcelHelpers.interopDefault(_mgrs);
var _projs = require("../projs");
var _projsDefault = parcelHelpers.interopDefault(_projs);
/**
 * @typedef {Object} Mgrs
 * @property {(lonlat: [number, number]) => string} forward
 * @property {(mgrsString: string) => [number, number, number, number]} inverse
 * @property {(mgrsString: string) => [number, number]} toPoint
 */ /**
 * @typedef {import('./defs').ProjectionDefinition} ProjectionDefinition
 * @typedef {import('./core').TemplateCoordinates} TemplateCoordinates
 * @typedef {import('./core').InterfaceCoordinates} InterfaceCoordinates
 * @typedef {import('./core').Converter} Converter
 * @typedef {import('./Proj').DatumDefinition} DatumDefinition
 */ /**
 * @template {import('./core').TemplateCoordinates} T
 * @type {core<T> & {defaultDatum: string, Proj: typeof Proj, WGS84: Proj, Point: typeof Point, toPoint: typeof common, defs: typeof defs, nadgrid: typeof nadgrid, transform: typeof transform, mgrs: Mgrs, version: string}}
 */ const proj4 = Object.assign((0, _coreDefault.default), {
    defaultDatum: 'WGS84',
    Proj: (0, _projDefault.default),
    WGS84: new (0, _projDefault.default)('WGS84'),
    Point: (0, _pointDefault.default),
    toPoint: (0, _toPointDefault.default),
    defs: (0, _defsDefault.default),
    nadgrid: (0, _nadgridDefault.default),
    transform: (0, _transformDefault.default),
    mgrs: (0, _mgrsDefault.default),
    version: '__VERSION__'
});
(0, _projsDefault.default)(proj4);
exports.default = proj4;

},{"./core":"9RUj2","./Proj":"fIBov","./Point":"eH5et","./common/toPoint":"gQMMx","./defs":"4pDy1","./nadgrid":"4NCwA","./transform":"1wQLK","mgrs":"bDcex","../projs":"hWgEL","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9RUj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _proj = require("./Proj");
var _projDefault = parcelHelpers.interopDefault(_proj);
var _transform = require("./transform");
var _toPoint = require("./common/toPoint");
var _toPointDefault = parcelHelpers.interopDefault(_toPoint);
var wgs84 = (0, _projDefault.default)('WGS84');
/**
 * @typedef {{x: number, y: number, z?: number, m?: number}} InterfaceCoordinates
 */ /**
 * @typedef {Array<number> | InterfaceCoordinates} TemplateCoordinates
 */ /**
 * @typedef {Object} Converter
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {proj} [oProj]
 */ /**
 * @typedef {Object} PROJJSONDefinition
 * @property {string} [$schema]
 * @property {string} type
 * @property {string} [name]
 * @property {{authority: string, code: number}} [id]
 * @property {string} [scope]
 * @property {string} [area]
 * @property {{south_latitude: number, west_longitude: number, north_latitude: number, east_longitude: number}} [bbox]
 * @property {PROJJSONDefinition[]} [components]
 * @property {{type: string, name: string}} [datum]
 * @property {{
 *   name: string,
 *   members: Array<{
 *     name: string,
 *     id?: {authority: string, code: number}
 *   }>,
 *   ellipsoid?: {
 *     name: string,
 *     semi_major_axis: number,
 *     inverse_flattening?: number
 *   },
 *   accuracy?: string,
 *   id?: {authority: string, code: number}
 * }} [datum_ensemble]
 * @property {{
 *   subtype: string,
 *   axis: Array<{
 *     name: string,
 *     abbreviation?: string,
 *     direction: string,
 *     unit: string
 *   }>
 * }} [coordinate_system]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string
 *   }>
 * }} [conversion]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string,
 *     type?: string,
 *     file_name?: string
 *   }>
 * }} [transformation]
 */ /**
 * @template {TemplateCoordinates} T
 * @param {proj} from
 * @param {proj} to
 * @param {T} coords
 * @param {boolean} [enforceAxis]
 * @returns {T}
 */ function transformer(from, to, coords, enforceAxis) {
    var out, geocent, keys;
    if (Array.isArray(coords)) {
        out = (0, _transform.transformInternal)(from, to, (0, _toPointDefault.default)(coords), enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            geocent = typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent';
            if (geocent) {
                if (typeof out.z === 'number') return /** @type {T} */ [
                    out.x,
                    out.y,
                    out.z
                ].concat(coords.slice(3));
                return /** @type {T} */ [
                    out.x,
                    out.y,
                    coords[2]
                ].concat(coords.slice(3));
            }
            if (enforceAxis && typeof out.z === 'number') return /** @type {T} */ [
                out.x,
                out.y,
                out.z
            ].concat(coords.slice(3));
            return /** @type {T} */ [
                out.x,
                out.y
            ].concat(coords.slice(2));
        }
        return /** @type {T} */ [
            out.x,
            out.y
        ];
    } else {
        out = (0, _transform.transformInternal)(from, to, {
            x: coords.x,
            y: coords.y,
            z: coords.z,
            m: coords.m
        }, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        keys = Object.keys(coords);
        if (keys.length === 2) return /** @type {T} */ out;
        geocent = typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent';
        keys.forEach(function(key) {
            if (key === 'x' || key === 'y') return;
            if (key === 'z' && (geocent || enforceAxis)) return;
            out[key] = coords[key];
        });
        return /** @type {T} */ out;
    }
}
/**
 * @param {proj | string | PROJJSONDefinition | Converter} item
 * @returns {import('./Proj').default}
 */ function checkProj(item) {
    if (item instanceof (0, _projDefault.default)) return item;
    if (typeof item === 'object' && 'oProj' in item) return item.oProj;
    return (0, _projDefault.default)(/** @type {string | PROJJSONDefinition} */ item);
}
/**
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @param {string | PROJJSONDefinition | proj} fromProjOrToProj
 * @param {string | PROJJSONDefinition | proj | TemplateCoordinates} [toProjOrCoord]
 * @param {T} [coord]
 * @returns {T|Converter}
 */ function proj4(fromProjOrToProj, toProjOrCoord, coord) {
    /** @type {proj} */ var fromProj;
    /** @type {proj} */ var toProj;
    var single = false;
    /** @type {Converter} */ var obj;
    if (typeof toProjOrCoord === 'undefined') {
        toProj = checkProj(fromProjOrToProj);
        fromProj = wgs84;
        single = true;
    } else if (typeof /** @type {?} */ toProjOrCoord.x !== 'undefined' || Array.isArray(toProjOrCoord)) {
        coord = /** @type {?} */ toProjOrCoord;
        toProj = checkProj(fromProjOrToProj);
        fromProj = wgs84;
        single = true;
    }
    if (!fromProj) fromProj = checkProj(fromProjOrToProj);
    if (!toProj) toProj = checkProj(/** @type {string | PROJJSONDefinition | proj } */ toProjOrCoord);
    if (coord) return transformer(fromProj, toProj, coord);
    else {
        obj = {
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ forward: function(coords, enforceAxis) {
                return transformer(fromProj, toProj, coords, enforceAxis);
            },
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ inverse: function(coords, enforceAxis) {
                return transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
exports.default = proj4;

},{"./Proj":"fIBov","./transform":"1wQLK","./common/toPoint":"gQMMx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fIBov":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _parseCode = require("./parseCode");
var _parseCodeDefault = parcelHelpers.interopDefault(_parseCode);
var _extend = require("./extend");
var _extendDefault = parcelHelpers.interopDefault(_extend);
var _projections = require("./projections");
var _projectionsDefault = parcelHelpers.interopDefault(_projections);
var _deriveConstants = require("./deriveConstants");
var _datum = require("./constants/Datum");
var _datumDefault = parcelHelpers.interopDefault(_datum);
var _datum1 = require("./datum");
var _datumDefault1 = parcelHelpers.interopDefault(_datum1);
var _match = require("./match");
var _matchDefault = parcelHelpers.interopDefault(_match);
var _nadgrid = require("./nadgrid");
/**
 * @typedef {Object} DatumDefinition
 * @property {number} datum_type - The type of datum.
 * @property {number} a - Semi-major axis of the ellipsoid.
 * @property {number} b - Semi-minor axis of the ellipsoid.
 * @property {number} es - Eccentricity squared of the ellipsoid.
 * @property {number} ep2 - Second eccentricity squared of the ellipsoid.
 */ /**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} srsCode
 * @param {(errorMessage?: string, instance?: Projection) => void} [callback]
 */ function Projection(srsCode, callback) {
    if (!(this instanceof Projection)) return new Projection(srsCode);
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.forward = null;
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.inverse = null;
    /** @type {function(): void} */ this.init = null;
    /** @type {string} */ this.name;
    /** @type {string} */ this.axis;
    /** @type {Array<string>} */ this.names = null;
    /** @type {string} */ this.title;
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, _parseCodeDefault.default)(srsCode);
    if (typeof json !== 'object') {
        callback('Could not parse to valid json: ' + srsCode);
        return;
    }
    var ourProj = Projection.projections.get(json.projName);
    if (!ourProj) {
        callback('Could not get projection name from: ' + srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== 'none') {
        var datumDef = (0, _matchDefault.default)((0, _datumDefault.default), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.axis = json.axis || 'enu';
    json.ellps = json.ellps || 'wgs84';
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, _deriveConstants.sphere)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, _deriveConstants.eccentricity)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, _nadgrid.getNadgrids)(json.nadgrids);
    /** @type {DatumDefinition} */ var datumObj = json.datum || (0, _datumDefault1.default)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, _extendDefault.default)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, _extendDefault.default)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    if ('init' in this && typeof this.init === 'function') this.init();
    // only default the scale factor once the projection had a chance to set its own
    if (!this.k0) this.k0 = 1.0;
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
Projection.projections = (0, _projectionsDefault.default);
Projection.projections.start();
exports.default = Projection;

},{"./parseCode":"e5iJ0","./extend":"5pzbh","./projections":"3oYp6","./deriveConstants":"isWoF","./constants/Datum":"Z1kSQ","./datum":"iKf0s","./match":"6R730","./nadgrid":"4NCwA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e5iJ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defs = require("./defs");
var _defsDefault = parcelHelpers.interopDefault(_defs);
var _wktParser = require("wkt-parser");
var _wktParserDefault = parcelHelpers.interopDefault(_wktParser);
var _projString = require("./projString");
var _projStringDefault = parcelHelpers.interopDefault(_projString);
var _match = require("./match");
var _matchDefault = parcelHelpers.interopDefault(_match);
function testObj(code) {
    return typeof code === 'string';
}
function testDef(code) {
    return code in (0, _defsDefault.default);
}
function testWKT(code) {
    return code.indexOf('+') !== 0 && code.indexOf('[') !== -1 || typeof code === 'object' && !('srsCode' in code);
}
var codes = [
    '3857',
    '900913',
    '3785',
    '102113'
];
function checkMercator(item) {
    if (item.title) return item.title.toLowerCase().indexOf('epsg:') === 0 && codes.indexOf(item.title.substr(5)) > -1;
    var auth = (0, _matchDefault.default)(item, 'authority');
    if (!auth) return;
    var code = (0, _matchDefault.default)(auth, 'epsg');
    return code && codes.indexOf(code) > -1;
}
function checkProjStr(item) {
    var ext = (0, _matchDefault.default)(item, 'extension');
    if (!ext) return;
    return (0, _matchDefault.default)(ext, 'proj4');
}
function testProj(code) {
    return code[0] === '+';
}
/**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} code
 * @returns {import('./defs').ProjectionDefinition}
 */ function parse(code) {
    let out;
    if (testObj(code)) {
        // check to see if this is a WKT string
        if (testDef(code)) out = (0, _defsDefault.default)[code];
        else if (testWKT(code)) {
            out = (0, _wktParserDefault.default)(code);
            var maybeProjStr = checkProjStr(out);
            if (maybeProjStr) out = (0, _projStringDefault.default)(maybeProjStr);
        } else if (testProj(code)) out = (0, _projStringDefault.default)(code);
    } else if (!('projName' in code)) out = (0, _wktParserDefault.default)(code);
    else out = code;
    // test for special Web Mercator case, due to this being a very common and often malformed
    return out && checkMercator(out) ? (0, _defsDefault.default)['EPSG:3857'] : out;
}
exports.default = parse;

},{"./defs":"4pDy1","wkt-parser":"dtn98","./projString":"loaLg","./match":"6R730","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4pDy1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _global = require("./global");
var _globalDefault = parcelHelpers.interopDefault(_global);
var _projString = require("./projString");
var _projStringDefault = parcelHelpers.interopDefault(_projString);
var _wktParser = require("wkt-parser");
var _wktParserDefault = parcelHelpers.interopDefault(_wktParser);
/**
 * @typedef {Object} ProjectionDefinition
 * @property {string} title
 * @property {string} [projName]
 * @property {string} [ellps]
 * @property {import('./Proj.js').DatumDefinition} [datum]
 * @property {string} [datumName]
 * @property {number} [rf]
 * @property {number} [lat0]
 * @property {number} [lat1]
 * @property {number} [lat2]
 * @property {number} [lat_ts]
 * @property {number} [long0]
 * @property {number} [long1]
 * @property {number} [long2]
 * @property {number} [long_wrap]
 * @property {number} [alpha]
 * @property {number} [longc]
 * @property {number} [x0]
 * @property {number} [y0]
 * @property {number} [k0]
 * @property {number} [a]
 * @property {number} [b]
 * @property {true} [R_A]
 * @property {number} [zone]
 * @property {true} [utmSouth]
 * @property {string|Array<number>} [datum_params]
 * @property {number} [to_meter]
 * @property {string} [units]
 * @property {number} [from_greenwich]
 * @property {string} [datumCode]
 * @property {string} [nadgrids]
 * @property {string} [axis]
 * @property {boolean} [sphere]
 * @property {number} [rectified_grid_angle]
 * @property {boolean} [approx]
 * @property {boolean} [over]
 * @property {string} [projStr]
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 */ /**
 * @overload
 * @param {string} name
 * @param {string|ProjectionDefinition|import('./core.js').PROJJSONDefinition} projection
 * @returns {void}
 */ /**
 * @overload
 * @param {Array<[string, string]>} name
 * @returns {Array<ProjectionDefinition|undefined>}
 */ /**
 * @overload
 * @param {string} name
 * @returns {ProjectionDefinition}
 */ /**
 * @param {string | Array<Array<string>> | Partial<Record<'EPSG'|'ESRI'|'IAU2000', ProjectionDefinition>>} name
 * @returns {ProjectionDefinition | Array<ProjectionDefinition|undefined> | void}
 */ function defs(name) {
    /* global console */ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === 'string') {
            if (def.charAt(0) === '+') defs[/** @type {string} */ name] = (0, _projStringDefault.default)(arguments[1]);
            else defs[/** @type {string} */ name] = (0, _wktParserDefault.default)(arguments[1]);
        } else if (def && typeof def === 'object' && !('projName' in def)) // PROJJSON
        defs[/** @type {string} */ name] = (0, _wktParserDefault.default)(arguments[1]);
        else {
            defs[/** @type {string} */ name] = def;
            if (!def) delete defs[/** @type {string} */ name];
        }
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) return defs.apply(that, v);
            else return defs(v);
        });
        else if (typeof name === 'string') {
            if (name in defs) return defs[name];
        } else if ('EPSG' in name) defs['EPSG:' + name.EPSG] = name;
        else if ('ESRI' in name) defs['ESRI:' + name.ESRI] = name;
        else if ('IAU2000' in name) defs['IAU2000:' + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, _globalDefault.default)(defs);
exports.default = defs;

},{"./global":"h4YpU","./projString":"loaLg","wkt-parser":"dtn98","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"h4YpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(defs) {
        defs('EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees');
        defs('EPSG:4269', '+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees');
        defs('EPSG:3857', '+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs');
        // UTM WGS84
        for(var i = 1; i <= 60; ++i){
            defs('EPSG:' + (32600 + i), '+proj=utm +zone=' + i + ' +datum=WGS84 +units=m');
            defs('EPSG:' + (32700 + i), '+proj=utm +zone=' + i + ' +south +datum=WGS84 +units=m');
        }
        defs('EPSG:5041', '+title=WGS 84 / UPS North (E,N) +proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
        defs('EPSG:5042', '+title=WGS 84 / UPS South (E,N) +proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
        defs.WGS84 = defs['EPSG:4326'];
        defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
        defs.GOOGLE = defs['EPSG:3857'];
        defs['EPSG:900913'] = defs['EPSG:3857'];
        defs['EPSG:102113'] = defs['EPSG:3857'];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"loaLg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} defData
 * @returns {import('./defs').ProjectionDefinition}
 */ parcelHelpers.export(exports, "default", ()=>function(defData) {
        /** @type {import('./defs').ProjectionDefinition} */ var self = {};
        var paramObj = defData.split('+').map(function(v) {
            return v.trim();
        }).filter(function(a) {
            return a;
        }).reduce(function(p, a) {
            /** @type {Array<?>} */ var split = a.split('=');
            split.push(true);
            p[split[0].toLowerCase()] = split[1];
            return p;
        }, {});
        var paramName, paramVal, paramOutname;
        var params = {
            proj: 'projName',
            datum: 'datumCode',
            rf: function(v) {
                self.rf = parseFloat(v);
            },
            lat_0: function(v) {
                self.lat0 = v * (0, _values.D2R);
            },
            lat_1: function(v) {
                self.lat1 = v * (0, _values.D2R);
            },
            lat_2: function(v) {
                self.lat2 = v * (0, _values.D2R);
            },
            lat_ts: function(v) {
                self.lat_ts = v * (0, _values.D2R);
            },
            lon_0: function(v) {
                self.long0 = v * (0, _values.D2R);
            },
            lon_wrap: function(v) {
                self.long_wrap = parseFloat(v) * (0, _values.D2R);
            },
            lon_1: function(v) {
                self.long1 = v * (0, _values.D2R);
            },
            lon_2: function(v) {
                self.long2 = v * (0, _values.D2R);
            },
            alpha: function(v) {
                self.alpha = parseFloat(v) * (0, _values.D2R);
            },
            gamma: function(v) {
                self.rectified_grid_angle = parseFloat(v) * (0, _values.D2R);
            },
            lonc: function(v) {
                self.longc = v * (0, _values.D2R);
            },
            x_0: function(v) {
                self.x0 = parseFloat(v);
            },
            y_0: function(v) {
                self.y0 = parseFloat(v);
            },
            k_0: function(v) {
                self.k0 = parseFloat(v);
            },
            k: function(v) {
                self.k0 = parseFloat(v);
            },
            a: function(v) {
                self.a = parseFloat(v);
            },
            b: function(v) {
                self.b = parseFloat(v);
            },
            r: function(v) {
                self.a = self.b = parseFloat(v);
            },
            r_a: function() {
                self.R_A = true;
            },
            zone: function(v) {
                self.zone = parseInt(v, 10);
            },
            south: function() {
                self.utmSouth = true;
            },
            towgs84: function(v) {
                self.datum_params = v.split(',').map(function(a) {
                    return parseFloat(a);
                });
            },
            to_meter: function(v) {
                self.to_meter = parseFloat(v);
            },
            units: function(v) {
                self.units = v;
                var unit = (0, _matchDefault.default)((0, _unitsDefault.default), v);
                if (unit) self.to_meter = unit.to_meter;
            },
            from_greenwich: function(v) {
                self.from_greenwich = v * (0, _values.D2R);
            },
            pm: function(v) {
                var pm = (0, _matchDefault.default)((0, _primeMeridianDefault.default), v);
                self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, _values.D2R);
            },
            nadgrids: function(v) {
                if (v === '@null') self.datumCode = 'none';
                else self.nadgrids = v;
            },
            axis: function(v) {
                var legalAxis = 'ewnsud';
                if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
            },
            approx: function() {
                self.approx = true;
            },
            over: function() {
                self.over = true;
            }
        };
        for(paramName in paramObj){
            paramVal = paramObj[paramName];
            if (paramName in params) {
                paramOutname = params[paramName];
                if (typeof paramOutname === 'function') paramOutname(paramVal);
                else self[paramOutname] = paramVal;
            } else self[paramName] = paramVal;
        }
        if (typeof self.datumCode === 'string' && self.datumCode !== 'WGS84') self.datumCode = self.datumCode.toLowerCase();
        self['projStr'] = defData;
        return self;
    });
var _values = require("./constants/values");
var _primeMeridian = require("./constants/PrimeMeridian");
var _primeMeridianDefault = parcelHelpers.interopDefault(_primeMeridian);
var _units = require("./constants/units");
var _unitsDefault = parcelHelpers.interopDefault(_units);
var _match = require("./match");
var _matchDefault = parcelHelpers.interopDefault(_match);

},{"./constants/values":"8tAZZ","./constants/PrimeMeridian":"6kYHz","./constants/units":"hbIB6","./match":"6R730","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8tAZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PJD_3PARAM", ()=>PJD_3PARAM);
parcelHelpers.export(exports, "PJD_7PARAM", ()=>PJD_7PARAM);
parcelHelpers.export(exports, "PJD_GRIDSHIFT", ()=>PJD_GRIDSHIFT);
parcelHelpers.export(exports, "PJD_WGS84", ()=>PJD_WGS84);
parcelHelpers.export(exports, "PJD_NODATUM", ()=>PJD_NODATUM);
parcelHelpers.export(exports, "SRS_WGS84_SEMIMAJOR", ()=>SRS_WGS84_SEMIMAJOR);
parcelHelpers.export(exports, "SRS_WGS84_SEMIMINOR", ()=>SRS_WGS84_SEMIMINOR);
parcelHelpers.export(exports, "SRS_WGS84_ESQUARED", ()=>SRS_WGS84_ESQUARED);
parcelHelpers.export(exports, "SEC_TO_RAD", ()=>SEC_TO_RAD);
parcelHelpers.export(exports, "HALF_PI", ()=>HALF_PI);
parcelHelpers.export(exports, "SIXTH", ()=>SIXTH);
parcelHelpers.export(exports, "RA4", ()=>RA4);
parcelHelpers.export(exports, "RA6", ()=>RA6);
parcelHelpers.export(exports, "EPSLN", ()=>EPSLN);
parcelHelpers.export(exports, "D2R", ()=>D2R);
parcelHelpers.export(exports, "R2D", ()=>R2D);
parcelHelpers.export(exports, "FORTPI", ()=>FORTPI);
parcelHelpers.export(exports, "TWO_PI", ()=>TWO_PI);
parcelHelpers.export(exports, "SPI", ()=>SPI);
var PJD_3PARAM = 1;
var PJD_7PARAM = 2;
var PJD_GRIDSHIFT = 3;
var PJD_WGS84 = 4; // WGS84 or equivalent
var PJD_NODATUM = 5; // WGS84 or equivalent
var SRS_WGS84_SEMIMAJOR = 6378137.0; // only used in grid shift transforms
var SRS_WGS84_SEMIMINOR = 6356752.314; // only used in grid shift transforms
var SRS_WGS84_ESQUARED = 0.0066943799901413165; // only used in grid shift transforms
var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
var HALF_PI = Math.PI / 2;
var SIXTH = 0.1666666666666666667;
var RA4 = 0.04722222222222222222;
var RA6 = 0.02215608465608465608;
var EPSLN = 1.0e-10;
var D2R = 0.01745329251994329577;
var R2D = 57.29577951308232088;
var FORTPI = Math.PI / 4;
var TWO_PI = Math.PI * 2;
var SPI = 3.14159265359;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6kYHz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var primeMeridian = {};
primeMeridian.greenwich = 0.0; // "0dE",
primeMeridian.lisbon = -9.131906111111; // "9d07'54.862\"W",
primeMeridian.paris = 2.337229166667; // "2d20'14.025\"E",
primeMeridian.bogota = -74.080916666667; // "74d04'51.3\"W",
primeMeridian.madrid = -3.687938888889; // "3d41'16.58\"W",
primeMeridian.rome = 12.452333333333; // "12d27'8.4\"E",
primeMeridian.bern = 7.439583333333; // "7d26'22.5\"E",
primeMeridian.jakarta = 106.807719444444; // "106d48'27.79\"E",
primeMeridian.ferro = -17.666666666667; // "17d40'W",
primeMeridian.brussels = 4.367975; // "4d22'4.71\"E",
primeMeridian.stockholm = 18.058277777778; // "18d3'29.8\"E",
primeMeridian.athens = 23.7163375; // "23d42'58.815\"E",
primeMeridian.oslo = 10.722916666667; // "10d43'22.5\"E"
exports.default = primeMeridian;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hbIB6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    mm: {
        to_meter: 0.001
    },
    cm: {
        to_meter: 0.01
    },
    ft: {
        to_meter: 0.3048
    },
    'us-ft': {
        to_meter: 1200 / 3937
    },
    fath: {
        to_meter: 1.8288
    },
    kmi: {
        to_meter: 1852
    },
    'us-ch': {
        to_meter: 20.1168402336805
    },
    'us-mi': {
        to_meter: 1609.34721869444
    },
    km: {
        to_meter: 1000
    },
    'ind-ft': {
        to_meter: 0.30479841
    },
    'ind-yd': {
        to_meter: 0.91439523
    },
    mi: {
        to_meter: 1609.344
    },
    yd: {
        to_meter: 0.9144
    },
    ch: {
        to_meter: 20.1168
    },
    link: {
        to_meter: 0.201168
    },
    dm: {
        to_meter: 0.1
    },
    in: {
        to_meter: 0.0254
    },
    'ind-ch': {
        to_meter: 20.11669506
    },
    'us-in': {
        to_meter: 0.025400050800101
    },
    'us-yd': {
        to_meter: 0.914401828803658
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6R730":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>match);
var ignoredChar = /[\s_\-\/\(\)]/g;
function match(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace(ignoredChar, '');
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace(ignoredChar, '');
        if (processedKey === lkey) return obj[testkey];
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dtn98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(wkt) {
        if (typeof wkt === 'object') return (0, _transformPROJJSONJs.transformPROJJSON)(wkt);
        const version = (0, _detectWKTVersionJs.detectWKTVersion)(wkt);
        var lisp = (0, _parserJsDefault.default)(wkt);
        if (version === 'WKT2') {
            const projjson = (0, _buildPROJJSONJs.buildPROJJSON)(lisp);
            return (0, _transformPROJJSONJs.transformPROJJSON)(projjson);
        }
        var type = lisp[0];
        var obj = {};
        (0, _processJs.sExpr)(lisp, obj);
        cleanWKT(obj);
        return obj[type];
    });
var _buildPROJJSONJs = require("./buildPROJJSON.js");
var _detectWKTVersionJs = require("./detectWKTVersion.js");
var _parserJs = require("./parser.js");
var _parserJsDefault = parcelHelpers.interopDefault(_parserJs);
var _processJs = require("./process.js");
var _transformPROJJSONJs = require("./transformPROJJSON.js");
var _utilJs = require("./util.js");
var knownTypes = [
    'PROJECTEDCRS',
    'PROJCRS',
    'GEOGCS',
    'GEOCCS',
    'PROJCS',
    'LOCAL_CS',
    'GEODCRS',
    'GEODETICCRS',
    'GEODETICDATUM',
    'ENGCRS',
    'ENGINEERINGCRS'
];
function rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function cleanWKT(wkt) {
    var keys = Object.keys(wkt);
    for(var i = 0, ii = keys.length; i < ii; ++i){
        var key = keys[i];
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        if (knownTypes.indexOf(key) !== -1) setPropertiesFromWkt(wkt[key]);
        if (typeof wkt[key] === 'object') cleanWKT(wkt[key]);
    }
}
function setPropertiesFromWkt(wkt) {
    if (wkt.AUTHORITY) {
        var authority = Object.keys(wkt.AUTHORITY)[0];
        if (authority && authority in wkt.AUTHORITY) wkt.title = authority + ':' + wkt.AUTHORITY[authority];
    }
    if (wkt.type === 'GEOGCS') wkt.projName = 'longlat';
    else if (wkt.type === 'LOCAL_CS') {
        wkt.projName = 'identity';
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === 'object') wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = '';
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf('north') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'north') axisOrder += 'n';
            else if (axis[0].indexOf('south') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'south') axisOrder += 's';
            else if (axis[0].indexOf('east') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'east') axisOrder += 'e';
            else if (axis[0].indexOf('west') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'west') axisOrder += 'w';
        }
        if (axisOrder.length === 2) axisOrder += 'u';
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === 'metre') wkt.units = 'meter';
        if (wkt.UNIT.convert) {
            if (wkt.type === 'GEOGCS') {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === 'GEOGCS') geogcs = wkt;
    if (geogcs) {
        if (geogcs.PRIMEM && geogcs.PRIMEM.convert) wkt.from_greenwich = (0, _utilJs.d2r)(geogcs.PRIMEM.convert);
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === 'd_') wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === 'new_zealand_1949') wkt.datumCode = 'nzgd49';
        if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
            if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') wkt.sphere = true;
            wkt.datumCode = 'wgs84';
        }
        if (wkt.datumCode === 'belge_1972') wkt.datumCode = 'rnb72';
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
            if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') wkt.ellps = 'intl';
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf('osgb_1936')) wkt.datumCode = 'osgb36';
        if (~wkt.datumCode.indexOf('osni_1952')) wkt.datumCode = 'osni52';
        if (~wkt.datumCode.indexOf('tm65') || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) wkt.datumCode = 'ire65';
        if (wkt.datumCode === 'ch1903+') wkt.datumCode = 'ch1903';
        if (~wkt.datumCode.indexOf('israel')) wkt.datumCode = 'isr93';
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    if (wkt.rectified_grid_angle) wkt.rectified_grid_angle = (0, _utilJs.d2r)(wkt.rectified_grid_angle);
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return rename(wkt, a);
    };
    var list = [
        [
            'standard_parallel_1',
            'Standard_Parallel_1'
        ],
        [
            'standard_parallel_1',
            'Latitude of 1st standard parallel'
        ],
        [
            'standard_parallel_2',
            'Standard_Parallel_2'
        ],
        [
            'standard_parallel_2',
            'Latitude of 2nd standard parallel'
        ],
        [
            'false_easting',
            'False_Easting'
        ],
        [
            'false_easting',
            'False easting'
        ],
        [
            'false-easting',
            'Easting at false origin'
        ],
        [
            'false_northing',
            'False_Northing'
        ],
        [
            'false_northing',
            'False northing'
        ],
        [
            'false_northing',
            'Northing at false origin'
        ],
        [
            'central_meridian',
            'Central_Meridian'
        ],
        [
            'central_meridian',
            'Longitude of natural origin'
        ],
        [
            'central_meridian',
            'Longitude of false origin'
        ],
        [
            'latitude_of_origin',
            'Latitude_Of_Origin'
        ],
        [
            'latitude_of_origin',
            'Central_Parallel'
        ],
        [
            'latitude_of_origin',
            'Latitude of natural origin'
        ],
        [
            'latitude_of_origin',
            'Latitude of false origin'
        ],
        [
            'scale_factor',
            'Scale_Factor'
        ],
        [
            'k0',
            'scale_factor'
        ],
        [
            'latitude_of_center',
            'Latitude_Of_Center'
        ],
        [
            'latitude_of_center',
            'Latitude_of_center'
        ],
        [
            'lat0',
            'latitude_of_center',
            (0, _utilJs.d2r)
        ],
        [
            'longitude_of_center',
            'Longitude_Of_Center'
        ],
        [
            'longitude_of_center',
            'Longitude_of_center'
        ],
        [
            'longc',
            'longitude_of_center',
            (0, _utilJs.d2r)
        ],
        [
            'x0',
            'false_easting',
            toMeter
        ],
        [
            'y0',
            'false_northing',
            toMeter
        ],
        [
            'long0',
            'central_meridian',
            (0, _utilJs.d2r)
        ],
        [
            'lat0',
            'latitude_of_origin',
            (0, _utilJs.d2r)
        ],
        [
            'lat0',
            'standard_parallel_1',
            (0, _utilJs.d2r)
        ],
        [
            'lat1',
            'standard_parallel_1',
            (0, _utilJs.d2r)
        ],
        [
            'lat2',
            'standard_parallel_2',
            (0, _utilJs.d2r)
        ],
        [
            'azimuth',
            'Azimuth'
        ],
        [
            'alpha',
            'azimuth',
            (0, _utilJs.d2r)
        ],
        [
            'srsCode',
            'name'
        ]
    ];
    list.forEach(renamer);
    (0, _utilJs.applyProjectionDefaults)(wkt);
}

},{"./buildPROJJSON.js":"7Gqzk","./detectWKTVersion.js":"26erS","./parser.js":"kYdjT","./process.js":"5wy7m","./transformPROJJSON.js":"gugJK","./util.js":"gOVx9","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7Gqzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Builds a PROJJSON object from a WKT array structure.
 * @param {Array} root The root WKT array node.
 * @returns {Object} The PROJJSON object.
 */ parcelHelpers.export(exports, "buildPROJJSON", ()=>buildPROJJSON);
var _projjsonbuilder2015Js = require("./PROJJSONBuilder2015.js");
var _projjsonbuilder2015JsDefault = parcelHelpers.interopDefault(_projjsonbuilder2015Js);
var _projjsonbuilder2019Js = require("./PROJJSONBuilder2019.js");
var _projjsonbuilder2019JsDefault = parcelHelpers.interopDefault(_projjsonbuilder2019Js);
/**
 * Detects the WKT2 version based on the structure of the WKT.
 * @param {Array} root The root WKT array node.
 * @returns {string} The detected version ("2015" or "2019").
 */ function detectWKT2Version(root) {
    // Check for WKT2-2019-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'USAGE')) return '2019'; // `USAGE` is specific to WKT2-2019
    // Check for WKT2-2015-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'CS')) return '2015'; // `CS` is valid in both, but default to 2015 unless `USAGE` is present
    if (root[0] === 'BOUNDCRS' || root[0] === 'PROJCRS' || root[0] === 'GEOGCRS') return '2015'; // These are valid in both, but default to 2015
    // Default to WKT2-2015 if no specific indicators are found
    return '2015';
}
function buildPROJJSON(root) {
    const version = detectWKT2Version(root);
    const builder = version === '2019' ? (0, _projjsonbuilder2019JsDefault.default) : (0, _projjsonbuilder2015JsDefault.default);
    return builder.convert(root);
}

},{"./PROJJSONBuilder2015.js":"7vd4s","./PROJJSONBuilder2019.js":"69jfR","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7vd4s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _projjsonbuilderBaseJs = require("./PROJJSONBuilderBase.js");
var _projjsonbuilderBaseJsDefault = parcelHelpers.interopDefault(_projjsonbuilderBaseJs);
class PROJJSONBuilder2015 extends (0, _projjsonbuilderBaseJsDefault.default) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Skip `CS` and `USAGE` nodes for WKT2-2015
        if (result.coordinate_system && result.coordinate_system.subtype === 'Cartesian') delete result.coordinate_system;
        if (result.usage) delete result.usage;
        return result;
    }
}
exports.default = PROJJSONBuilder2015;

},{"./PROJJSONBuilderBase.js":"jwOMH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jwOMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class PROJJSONBuilderBase {
    static getId(node) {
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        if (idNode && idNode.length >= 3) return {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        };
        return null;
    }
    static convertUnit(node, type = 'unit') {
        if (!node || node.length < 3) return {
            type,
            name: 'unknown',
            conversion_factor: null
        };
        const name = node[1];
        const conversionFactor = parseFloat(node[2]) || null;
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        const id = idNode ? {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        } : null;
        return {
            type,
            name,
            conversion_factor: conversionFactor,
            id
        };
    }
    static convertAxis(node) {
        const name = node[1] || 'Unknown';
        // Determine the direction
        let direction;
        const abbreviationMatch = name.match(/^\((.)\)$/); // Match abbreviations like "(E)" or "(N)"
        if (abbreviationMatch) {
            // Use the abbreviation to determine the direction
            const abbreviation = abbreviationMatch[1].toUpperCase();
            if (abbreviation === 'E') direction = 'east';
            else if (abbreviation === 'N') direction = 'north';
            else if (abbreviation === 'U') direction = 'up';
            else if (node[2]) direction = node[2];
            else throw new Error(`Unknown axis abbreviation: ${abbreviation}`);
        } else // Use the explicit direction provided in the AXIS node
        direction = node[2] || 'unknown';
        const orderNode = node.find((child)=>Array.isArray(child) && child[0] === 'ORDER');
        const order = orderNode ? parseInt(orderNode[1], 10) : null;
        const unitNode = node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT'));
        const unit = this.convertUnit(unitNode);
        return {
            name,
            direction,
            unit,
            order
        };
    }
    static extractAxes(node) {
        return node.filter((child)=>Array.isArray(child) && child[0] === 'AXIS').map((axis)=>this.convertAxis(axis)).sort((a, b)=>(a.order || 0) - (b.order || 0)); // Sort by the "order" property
    }
    static convert(node, result = {}) {
        switch(node[0]){
            case 'PROJCRS':
                result.type = 'ProjectedCRS';
                result.name = node[1];
                result.base_crs = node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS')) : null;
                result.conversion = node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION')) : null;
                const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
                if (csNode) result.coordinate_system = {
                    type: csNode[1],
                    axis: this.extractAxes(node)
                };
                const lengthUnitNode = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT');
                if (lengthUnitNode) {
                    const unit = this.convertUnit(lengthUnitNode);
                    result.coordinate_system.unit = unit; // Add unit to coordinate_system
                }
                result.id = this.getId(node);
                break;
            case 'BASEGEOGCRS':
            case 'GEOGCRS':
            case 'GEODCRS':
                result.type = node[0] === 'GEODCRS' ? 'GeodeticCRS' : 'GeographicCRS';
                result.name = node[1];
                // Handle DATUM or ENSEMBLE
                const datumOrEnsembleNode = node.find((child)=>Array.isArray(child) && (child[0] === 'DATUM' || child[0] === 'ENSEMBLE'));
                if (datumOrEnsembleNode) {
                    const datumOrEnsemble = this.convert(datumOrEnsembleNode);
                    if (datumOrEnsembleNode[0] === 'ENSEMBLE') result.datum_ensemble = datumOrEnsemble;
                    else result.datum = datumOrEnsemble;
                    const primem = node.find((child)=>Array.isArray(child) && child[0] === 'PRIMEM');
                    if (primem && primem[1] !== 'Greenwich') datumOrEnsemble.prime_meridian = {
                        name: primem[1],
                        longitude: parseFloat(primem[2])
                    };
                }
                result.coordinate_system = {
                    type: 'ellipsoidal',
                    axis: this.extractAxes(node)
                };
                result.id = this.getId(node);
                break;
            case 'DATUM':
                result.type = 'GeodeticReferenceFrame';
                result.name = node[1];
                result.ellipsoid = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID')) : null;
                break;
            case 'ENSEMBLE':
                result.type = 'DatumEnsemble';
                result.name = node[1];
                // Extract ensemble members
                result.members = node.filter((child)=>Array.isArray(child) && child[0] === 'MEMBER').map((member)=>({
                        type: 'DatumEnsembleMember',
                        name: member[1],
                        id: this.getId(member)
                    }));
                // Extract accuracy
                const accuracyNode = node.find((child)=>Array.isArray(child) && child[0] === 'ENSEMBLEACCURACY');
                if (accuracyNode) result.accuracy = parseFloat(accuracyNode[1]);
                // Extract ellipsoid
                const ellipsoidNode = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID');
                if (ellipsoidNode) result.ellipsoid = this.convert(ellipsoidNode); // Convert the ellipsoid node
                // Extract identifier for the ensemble
                result.id = this.getId(node);
                break;
            case 'ELLIPSOID':
                result.type = 'Ellipsoid';
                result.name = node[1];
                result.semi_major_axis = parseFloat(node[2]);
                result.inverse_flattening = parseFloat(node[3]);
                const units = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT'), result) : null;
                break;
            case 'CONVERSION':
                result.type = 'Conversion';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && child[0] === 'PARAMETER').map((param)=>this.convert(param));
                break;
            case 'METHOD':
                result.type = 'Method';
                result.name = node[1];
                result.id = this.getId(node);
                break;
            case 'PARAMETER':
                result.type = 'Parameter';
                result.name = node[1];
                result.value = parseFloat(node[2]);
                result.unit = this.convertUnit(node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT')));
                result.id = this.getId(node);
                break;
            case 'BOUNDCRS':
                result.type = 'BoundCRS';
                // Process SOURCECRS
                const sourceCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'SOURCECRS');
                if (sourceCrsNode) {
                    const sourceCrsContent = sourceCrsNode.find((child)=>Array.isArray(child));
                    result.source_crs = sourceCrsContent ? this.convert(sourceCrsContent) : null;
                }
                // Process TARGETCRS
                const targetCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'TARGETCRS');
                if (targetCrsNode) {
                    const targetCrsContent = targetCrsNode.find((child)=>Array.isArray(child));
                    result.target_crs = targetCrsContent ? this.convert(targetCrsContent) : null;
                }
                // Process ABRIDGEDTRANSFORMATION
                const transformationNode = node.find((child)=>Array.isArray(child) && child[0] === 'ABRIDGEDTRANSFORMATION');
                if (transformationNode) result.transformation = this.convert(transformationNode);
                else result.transformation = null;
                break;
            case 'ABRIDGEDTRANSFORMATION':
                result.type = 'Transformation';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && (child[0] === 'PARAMETER' || child[0] === 'PARAMETERFILE')).map((param)=>{
                    if (param[0] === 'PARAMETER') return this.convert(param);
                    else if (param[0] === 'PARAMETERFILE') return {
                        name: param[1],
                        value: param[2],
                        id: {
                            'authority': 'EPSG',
                            'code': 8656
                        }
                    };
                });
                // Adjust the Scale difference parameter if present
                if (result.parameters.length === 7) {
                    const scaleDifference = result.parameters[6];
                    if (scaleDifference.name === 'Scale difference') scaleDifference.value = Math.round((scaleDifference.value - 1) * 1e12) / 1e6;
                }
                result.id = this.getId(node);
                break;
            case 'AXIS':
                if (!result.coordinate_system) result.coordinate_system = {
                    type: 'unspecified',
                    axis: []
                };
                result.coordinate_system.axis.push(this.convertAxis(node));
                break;
            case 'LENGTHUNIT':
                const unit = this.convertUnit(node, 'LinearUnit');
                if (result.coordinate_system && result.coordinate_system.axis) result.coordinate_system.axis.forEach((axis)=>{
                    if (!axis.unit) axis.unit = unit;
                });
                if (unit.conversion_factor && unit.conversion_factor !== 1) {
                    if (result.semi_major_axis) result.semi_major_axis = {
                        value: result.semi_major_axis,
                        unit
                    };
                }
                break;
            default:
                result.keyword = node[0];
                break;
        }
        return result;
    }
}
exports.default = PROJJSONBuilderBase;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"69jfR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _projjsonbuilderBaseJs = require("./PROJJSONBuilderBase.js");
var _projjsonbuilderBaseJsDefault = parcelHelpers.interopDefault(_projjsonbuilderBaseJs);
class PROJJSONBuilder2019 extends (0, _projjsonbuilderBaseJsDefault.default) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Handle `CS` node for WKT2-2019
        const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
        if (csNode) result.coordinate_system = {
            subtype: csNode[1],
            axis: this.extractAxes(node)
        };
        // Handle `USAGE` node for WKT2-2019
        const usageNode = node.find((child)=>Array.isArray(child) && child[0] === 'USAGE');
        if (usageNode) {
            const scope = usageNode.find((child)=>Array.isArray(child) && child[0] === 'SCOPE');
            const area = usageNode.find((child)=>Array.isArray(child) && child[0] === 'AREA');
            const bbox = usageNode.find((child)=>Array.isArray(child) && child[0] === 'BBOX');
            result.usage = {};
            if (scope) result.usage.scope = scope[1];
            if (area) result.usage.area = area[1];
            if (bbox) result.usage.bbox = bbox.slice(1);
        }
        return result;
    }
}
exports.default = PROJJSONBuilder2019;

},{"./PROJJSONBuilderBase.js":"jwOMH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"26erS":[function(require,module,exports,__globalThis) {
/**
 * Detects whether the WKT string is WKT1 or WKT2.
 * @param {string} wkt The WKT string.
 * @returns {string} The detected version ("WKT1" or "WKT2").
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectWKTVersion", ()=>detectWKTVersion);
function detectWKTVersion(wkt) {
    // Normalize the WKT string for easier keyword matching
    const normalizedWKT = wkt.toUpperCase();
    // Check for WKT2-specific keywords
    if (normalizedWKT.includes('PROJCRS') || normalizedWKT.includes('GEOGCRS') || normalizedWKT.includes('BOUNDCRS') || normalizedWKT.includes('VERTCRS') || normalizedWKT.includes('LENGTHUNIT') || normalizedWKT.includes('ANGLEUNIT') || normalizedWKT.includes('SCALEUNIT')) return 'WKT2';
    // Check for WKT1-specific keywords
    if (normalizedWKT.includes('PROJCS') || normalizedWKT.includes('GEOGCS') || normalizedWKT.includes('LOCAL_CS') || normalizedWKT.includes('VERT_CS') || normalizedWKT.includes('UNIT')) return 'WKT1';
    // Default to WKT1 if no specific indicators are found
    return 'WKT1';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kYdjT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = parseString;
var NEUTRAL = 1;
var KEYWORD = 2;
var NUMBER = 3;
var QUOTED = 4;
var AFTERQUOTE = 5;
var ENDED = -1;
var whitespace = /\s/;
var latin = /[A-Za-z]/;
var keyword = /[A-Za-z84_]/;
var endThings = /[,\]]/;
var digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function Parser(text) {
    if (typeof text !== 'string') throw new Error('not a string');
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = NEUTRAL;
}
Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== QUOTED) while(whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case NEUTRAL:
            return this.neutral(char);
        case KEYWORD:
            return this.keyword(char);
        case QUOTED:
            return this.quoted(char);
        case AFTERQUOTE:
            return this.afterquote(char);
        case NUMBER:
            return this.number(char);
        case ENDED:
            return;
    }
};
Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = QUOTED;
        return;
    }
    if (endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in afterquote yet, index ' + this.place);
};
Parser.prototype.afterItem = function(char) {
    if (char === ',') {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = NEUTRAL;
        return;
    }
    if (char === ']') {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = ENDED;
        return;
    }
};
Parser.prototype.number = function(char) {
    if (digets.test(char)) {
        this.word += char;
        return;
    }
    if (endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in number yet, index ' + this.place);
};
Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
Parser.prototype.keyword = function(char) {
    if (keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === '[') {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = NEUTRAL;
        return;
    }
    if (endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in keyword yet, index ' + this.place);
};
Parser.prototype.neutral = function(char) {
    if (latin.test(char)) {
        this.word = char;
        this.state = KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = '';
        this.state = QUOTED;
        return;
    }
    if (digets.test(char)) {
        this.word = char;
        this.state = NUMBER;
        return;
    }
    if (endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in neutral yet, index ' + this.place);
};
Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function parseString(txt) {
    var parser = new Parser(txt);
    return parser.output();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5wy7m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sExpr", ()=>sExpr);
function mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        sExpr(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function sExpr(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === 'PARAMETER') key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            sExpr(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === 'TOWGS84') {
        obj[key] = v;
        return;
    }
    if (key === 'AXIS') {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case 'UNIT':
        case 'PRIMEM':
        case 'VERT_DATUM':
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) sExpr(v[2], obj[key]);
            return;
        case 'SPHEROID':
        case 'ELLIPSOID':
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) sExpr(v[3], obj[key]);
            return;
        case 'EDATUM':
        case 'ENGINEERINGDATUM':
        case 'LOCAL_DATUM':
        case 'DATUM':
        case 'VERT_CS':
        case 'VERTCRS':
        case 'VERTICALCRS':
            v[0] = [
                'name',
                v[0]
            ];
            mapit(obj, key, v);
            return;
        case 'COMPD_CS':
        case 'COMPOUNDCRS':
        case 'FITTED_CS':
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        case 'PROJECTEDCRS':
        case 'PROJCRS':
        case 'GEOGCS':
        case 'GEOCCS':
        case 'PROJCS':
        case 'LOCAL_CS':
        case 'GEODCRS':
        case 'GEODETICCRS':
        case 'GEODETICDATUM':
        case 'ENGCRS':
        case 'ENGINEERINGCRS':
            v[0] = [
                'name',
                v[0]
            ];
            mapit(obj, key, v);
            obj[key].type = key;
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return sExpr(v, obj[key]);
            }
            return mapit(obj, key, v);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gugJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformPROJJSON", ()=>transformPROJJSON);
var _utilJs = require("./util.js");
// Helper function to process units and to_meter
function processUnit(unit) {
    let result = {
        units: null,
        to_meter: undefined
    };
    if (typeof unit === 'string') {
        result.units = unit.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        if (result.units === 'meter') result.to_meter = 1; // Only set to_meter if units are 'meter'
    } else if (unit && unit.name) {
        result.units = unit.name.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        result.to_meter = unit.conversion_factor;
    }
    return result;
}
function toValue(valueOrObject) {
    if (typeof valueOrObject === 'object') return valueOrObject.value * valueOrObject.unit.conversion_factor;
    return valueOrObject;
}
function calculateEllipsoid(value, result) {
    if (value.ellipsoid.radius) {
        result.a = value.ellipsoid.radius;
        result.rf = 0;
    } else {
        result.a = toValue(value.ellipsoid.semi_major_axis);
        if (value.ellipsoid.inverse_flattening !== undefined) result.rf = value.ellipsoid.inverse_flattening;
        else if (value.ellipsoid.semi_major_axis !== undefined && value.ellipsoid.semi_minor_axis !== undefined) result.rf = result.a / (result.a - toValue(value.ellipsoid.semi_minor_axis));
    }
}
function transformPROJJSON(projjson, result = {}) {
    if (!projjson || typeof projjson !== 'object') return projjson; // Return primitive values as-is
    if (projjson.type === 'BoundCRS') {
        transformPROJJSON(projjson.source_crs, result);
        if (projjson.transformation) {
            if (projjson.transformation.method && projjson.transformation.method.name === 'NTv2') // Set nadgrids to the filename from the parameterfile
            result.nadgrids = projjson.transformation.parameters[0].value;
            else // Populate datum_params if no parameterfile is found
            result.datum_params = projjson.transformation.parameters.map((param)=>param.value);
        }
        return result; // Return early for BoundCRS
    }
    // Handle specific keys in PROJJSON
    Object.keys(projjson).forEach((key)=>{
        const value = projjson[key];
        if (value === null) return;
        switch(key){
            case 'name':
                if (result.srsCode) break;
                result.name = value;
                result.srsCode = value; // Map `name` to `srsCode`
                break;
            case 'type':
                if (value === 'GeographicCRS') result.projName = 'longlat';
                else if (value === 'GeodeticCRS') {
                    if (projjson.coordinate_system && projjson.coordinate_system.subtype === 'Cartesian') result.projName = 'geocent';
                    else result.projName = 'longlat';
                } else if (value === 'ProjectedCRS' && projjson.conversion && projjson.conversion.method) result.projName = projjson.conversion.method.name; // Retain original capitalization
                break;
            case 'datum':
            case 'datum_ensemble':
                if (value.ellipsoid) {
                    // Extract ellipsoid properties
                    result.ellps = value.ellipsoid.name;
                    calculateEllipsoid(value, result);
                }
                if (value.prime_meridian) result.from_greenwich = value.prime_meridian.longitude * Math.PI / 180; // Convert to radians
                break;
            case 'ellipsoid':
                result.ellps = value.name;
                calculateEllipsoid(value, result);
                break;
            case 'prime_meridian':
                result.long0 = (value.longitude || 0) * Math.PI / 180; // Convert to radians
                break;
            case 'coordinate_system':
                if (value.axis) {
                    const directionMap = {
                        'east': 'e',
                        'north': 'n',
                        'west': 'w',
                        'south': 's',
                        'up': 'u',
                        'down': 'd',
                        'geocentricx': 'e',
                        'geocentricy': 'n',
                        'geocentricz': 'u'
                    };
                    const mapped = value.axis.map((axis)=>directionMap[axis.direction.toLowerCase()]);
                    if (mapped.every(Boolean)) {
                        result.axis = mapped.join('');
                        if (result.axis.length === 2) result.axis += 'u';
                    }
                    if (value.unit) {
                        const { units, to_meter } = processUnit(value.unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    } else if (value.axis[0] && value.axis[0].unit) {
                        const { units, to_meter } = processUnit(value.axis[0].unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    }
                }
                break;
            case 'id':
                if (value.authority && value.code) result.title = value.authority + ':' + value.code;
                break;
            case 'conversion':
                if (value.method && value.method.name) result.projName = value.method.name; // Retain original capitalization
                if (value.parameters) value.parameters.forEach((param)=>{
                    const paramName = param.name.toLowerCase().replace(/\s+/g, '_');
                    const paramValue = param.value;
                    if (param.unit && param.unit.conversion_factor) result[paramName] = paramValue * param.unit.conversion_factor; // Convert to radians or meters
                    else if (param.unit === 'degree') result[paramName] = paramValue * Math.PI / 180; // Convert to radians
                    else result[paramName] = paramValue;
                });
                break;
            case 'unit':
                if (value.name) {
                    result.units = value.name.toLowerCase();
                    if (result.units === 'metre') result.units = 'meter';
                }
                if (value.conversion_factor) result.to_meter = value.conversion_factor;
                break;
            case 'base_crs':
                transformPROJJSON(value, result); // Pass `result` directly
                result.datumCode = value.id ? value.id.authority + '_' + value.id.code : value.name; // Set datumCode
                break;
            default:
                break;
        }
    });
    // Additional calculated properties
    if (result.latitude_of_false_origin !== undefined) result.lat0 = result.latitude_of_false_origin; // Already in radians
    if (result.longitude_of_false_origin !== undefined) result.long0 = result.longitude_of_false_origin;
    if (result.latitude_of_standard_parallel !== undefined) {
        result.lat0 = result.latitude_of_standard_parallel;
        result.lat1 = result.latitude_of_standard_parallel;
    }
    if (result.latitude_of_1st_standard_parallel !== undefined) result.lat1 = result.latitude_of_1st_standard_parallel;
    if (result.latitude_of_2nd_standard_parallel !== undefined) result.lat2 = result.latitude_of_2nd_standard_parallel;
    if (result.latitude_of_projection_centre !== undefined) result.lat0 = result.latitude_of_projection_centre;
    if (result.longitude_of_projection_centre !== undefined) result.longc = result.longitude_of_projection_centre;
    if (result.easting_at_false_origin !== undefined) result.x0 = result.easting_at_false_origin;
    if (result.northing_at_false_origin !== undefined) result.y0 = result.northing_at_false_origin;
    if (result.latitude_of_natural_origin !== undefined) result.lat0 = result.latitude_of_natural_origin;
    if (result.longitude_of_natural_origin !== undefined) result.long0 = result.longitude_of_natural_origin;
    if (result.longitude_of_origin !== undefined) result.long0 = result.longitude_of_origin;
    if (result.false_easting !== undefined) result.x0 = result.false_easting;
    if (result.easting_at_projection_centre) result.x0 = result.easting_at_projection_centre;
    if (result.false_northing !== undefined) result.y0 = result.false_northing;
    if (result.northing_at_projection_centre) result.y0 = result.northing_at_projection_centre;
    if (result.standard_parallel_1 !== undefined) result.lat1 = result.standard_parallel_1;
    if (result.standard_parallel_2 !== undefined) result.lat2 = result.standard_parallel_2;
    if (result.scale_factor_at_natural_origin !== undefined) result.k0 = result.scale_factor_at_natural_origin;
    if (result.scale_factor_at_projection_centre !== undefined) result.k0 = result.scale_factor_at_projection_centre;
    if (result.scale_factor_on_pseudo_standard_parallel !== undefined) result.k0 = result.scale_factor_on_pseudo_standard_parallel;
    if (result.azimuth !== undefined) result.alpha = result.azimuth;
    if (result.azimuth_at_projection_centre !== undefined) result.alpha = result.azimuth_at_projection_centre;
    if (result.angle_from_rectified_to_skew_grid) result.rectified_grid_angle = result.angle_from_rectified_to_skew_grid;
    // Apply projection defaults
    (0, _utilJs.applyProjectionDefaults)(result);
    return result;
}

},{"./util.js":"gOVx9","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gOVx9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "d2r", ()=>d2r);
parcelHelpers.export(exports, "applyProjectionDefaults", ()=>applyProjectionDefaults);
var D2R = 0.01745329251994329577;
function d2r(input) {
    return input * D2R;
}
function applyProjectionDefaults(wkt) {
    // Normalize projName for WKT2 compatibility
    const normalizedProjName = (wkt.projName || '').toLowerCase().replace(/_/g, ' ');
    if (wkt.long0 === undefined && wkt.longc !== undefined) wkt.long0 = wkt.longc; // keep in the projection's native prime meridian frame
    if (!wkt.lat_ts && wkt.lat1 && (normalizedProjName === 'stereographic south pole' || normalizedProjName === 'polar stereographic (variant b)')) {
        wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
        delete wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && (normalizedProjName === 'polar stereographic' || normalizedProjName === 'polar stereographic (variant a)')) {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = d2r(wkt.lat0 > 0 ? 90 : -90);
        delete wkt.lat1;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5pzbh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(destination, source) {
        destination = destination || {};
        var value, property;
        if (!source) return destination;
        for(property in source){
            value = source[property];
            if (value !== undefined) destination[property] = value;
        }
        return destination;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3oYp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {import('./Proj').default} proj
 * @param {number} i
 */ parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "getNormalizedProjName", ()=>getNormalizedProjName);
/**
 * Get a projection by name.
 * @param {string} name
 * @returns {import('./Proj').default|false}
 */ parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "start", ()=>start);
var _merc = require("./projections/merc");
var _mercDefault = parcelHelpers.interopDefault(_merc);
var _longlat = require("./projections/longlat");
var _longlatDefault = parcelHelpers.interopDefault(_longlat);
/** @type {Array<Partial<import('./Proj').default>>} */ var projs = [
    (0, _mercDefault.default),
    (0, _longlatDefault.default)
];
var names = {};
var projStore = [];
function add(proj, i) {
    var len = projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    projStore[len] = proj;
    proj.names.forEach(function(n) {
        names[n.toLowerCase()] = len;
    });
    return this;
}
function getNormalizedProjName(n) {
    return n.replace(/[-\(\)\s]+/g, ' ').trim().replace(/ /g, '_');
}
function get(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof names[n] !== 'undefined' && projStore[names[n]]) return projStore[names[n]];
    n = getNormalizedProjName(n);
    if (n in names && projStore[names[n]]) return projStore[names[n]];
}
function start() {
    projs.forEach(add);
}
exports.default = {
    start: start,
    add: add,
    get: get
};

},{"./projections/merc":"bsWxh","./projections/longlat":"4A0lU","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bsWxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} es
 * @property {number} e
 * @property {number} k
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/* Mercator forward equations--mapping lat,long to x,y
  -------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
/* Mercator inverse equations--mapping x,y to lat/long
  -------------------------------------------------- */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _msfnz = require("../common/msfnz");
var _msfnzDefault = parcelHelpers.interopDefault(_msfnz);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _tsfnz = require("../common/tsfnz");
var _tsfnzDefault = parcelHelpers.interopDefault(_tsfnz);
var _phi2Z = require("../common/phi2z");
var _phi2ZDefault = parcelHelpers.interopDefault(_phi2Z);
var _values = require("../constants/values");
function init() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!('x0' in this)) this.x0 = 0;
    if (!('y0' in this)) this.y0 = 0;
    this.long0 = this.long0 || 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, _msfnzDefault.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, _values.R2D) > 90 && lat * (0, _values.R2D) < -90 && lon * (0, _values.R2D) > 180 && lon * (0, _values.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, _values.HALF_PI)) <= (0, _values.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, _adjustLonDefault.default)(lon - this.long0, this.over);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, _values.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, _tsfnzDefault.default)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, _adjustLonDefault.default)(lon - this.long0, this.over);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function inverse(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, _values.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, _phi2ZDefault.default)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, _adjustLonDefault.default)(this.long0 + x / (this.a * this.k0), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Mercator',
    'Popular Visualisation Pseudo Mercator',
    'Mercator_1SP',
    'Mercator_Auxiliary_Sphere',
    'Mercator_Variant_A',
    'merc'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/msfnz":"aVAwM","../common/adjust_lon":"l07Jx","../common/tsfnz":"8z6AD","../common/phi2z":"623YG","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aVAwM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(eccent, sinphi, cosphi) {
        var con = eccent * sinphi;
        return cosphi / Math.sqrt(1 - con * con);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"l07Jx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, skipAdjust) {
        if (skipAdjust) return x;
        return Math.abs(x) <= (0, _values.SPI) ? x : x - (0, _signDefault.default)(x) * (0, _values.TWO_PI);
    });
var _values = require("../constants/values");
var _sign = require("./sign");
var _signDefault = parcelHelpers.interopDefault(_sign);

},{"../constants/values":"8tAZZ","./sign":"iFEtg","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iFEtg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x < 0 ? -1 : 1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8z6AD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(eccent, phi, sinphi) {
        var con = eccent * sinphi;
        var com = 0.5 * eccent;
        con = Math.pow((1 - con) / (1 + con), com);
        return Math.tan(0.5 * ((0, _values.HALF_PI) - phi)) / con;
    });
var _values = require("../constants/values");

},{"../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"623YG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(eccent, ts) {
        var eccnth = 0.5 * eccent;
        var con, dphi;
        var phi = (0, _values.HALF_PI) - 2 * Math.atan(ts);
        for(var i = 0; i <= 15; i++){
            con = eccent * Math.sin(phi);
            dphi = (0, _values.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
            phi += dphi;
            if (Math.abs(dphi) <= 0.0000000001) return phi;
        }
        // console.log("phi2z has NoConvergence");
        return -9999;
    });
var _values = require("../constants/values");

},{"../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4A0lU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>identity);
parcelHelpers.export(exports, "inverse", ()=>identity);
parcelHelpers.export(exports, "names", ()=>names);
function init() {
// no-op for longlat
}
function identity(pt) {
    return pt;
}
var names = [
    'longlat',
    'identity'
];
exports.default = {
    init: init,
    forward: identity,
    inverse: identity,
    names: names
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"isWoF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eccentricity", ()=>eccentricity);
parcelHelpers.export(exports, "sphere", ()=>sphere);
var _values = require("./constants/values");
var _ellipsoid = require("./constants/Ellipsoid");
var _ellipsoidDefault = parcelHelpers.interopDefault(_ellipsoid);
var _match = require("./match");
var _matchDefault = parcelHelpers.interopDefault(_match);
const WGS84 = (0, _ellipsoidDefault.default).WGS84; // default ellipsoid
function eccentricity(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, _values.SIXTH) + es * ((0, _values.RA4) + es * (0, _values.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function sphere(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, _matchDefault.default)((0, _ellipsoidDefault.default), ellps);
        if (!ellipse) ellipse = WGS84;
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, _values.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}

},{"./constants/values":"8tAZZ","./constants/Ellipsoid":"8QDQ9","./match":"6R730","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8QDQ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var ellipsoids = {
    MERIT: {
        a: 6378137,
        rf: 298.257,
        ellipseName: 'MERIT 1983'
    },
    SGS85: {
        a: 6378136,
        rf: 298.257,
        ellipseName: 'Soviet Geodetic System 85'
    },
    GRS80: {
        a: 6378137,
        rf: 298.257222101,
        ellipseName: 'GRS 1980(IUGG, 1980)'
    },
    IAU76: {
        a: 6378140,
        rf: 298.257,
        ellipseName: 'IAU 1976'
    },
    airy: {
        a: 6377563.396,
        b: 6356256.91,
        ellipseName: 'Airy 1830'
    },
    APL4: {
        a: 6378137,
        rf: 298.25,
        ellipseName: 'Appl. Physics. 1965'
    },
    NWL9D: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'Naval Weapons Lab., 1965'
    },
    mod_airy: {
        a: 6377340.189,
        b: 6356034.446,
        ellipseName: 'Modified Airy'
    },
    andrae: {
        a: 6377104.43,
        rf: 300,
        ellipseName: 'Andrae 1876 (Den., Iclnd.)'
    },
    aust_SA: {
        a: 6378160,
        rf: 298.25,
        ellipseName: 'Australian Natl & S. Amer. 1969'
    },
    GRS67: {
        a: 6378160,
        rf: 298.247167427,
        ellipseName: 'GRS 67(IUGG 1967)'
    },
    bessel: {
        a: 6377397.155,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841'
    },
    bess_nam: {
        a: 6377483.865,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841 (Namibia)'
    },
    clrk66: {
        a: 6378206.4,
        b: 6356583.8,
        ellipseName: 'Clarke 1866'
    },
    clrk80: {
        a: 6378249.145,
        rf: 293.4663,
        ellipseName: 'Clarke 1880 mod.'
    },
    clrk80ign: {
        a: 6378249.2,
        b: 6356515,
        rf: 293.4660213,
        ellipseName: 'Clarke 1880 (IGN)'
    },
    clrk58: {
        a: 6378293.645208759,
        rf: 294.2606763692654,
        ellipseName: 'Clarke 1858'
    },
    CPM: {
        a: 6375738.7,
        rf: 334.29,
        ellipseName: 'Comm. des Poids et Mesures 1799'
    },
    delmbr: {
        a: 6376428,
        rf: 311.5,
        ellipseName: 'Delambre 1810 (Belgium)'
    },
    engelis: {
        a: 6378136.05,
        rf: 298.2566,
        ellipseName: 'Engelis 1985'
    },
    evrst30: {
        a: 6377276.345,
        rf: 300.8017,
        ellipseName: 'Everest 1830'
    },
    evrst48: {
        a: 6377304.063,
        rf: 300.8017,
        ellipseName: 'Everest 1948'
    },
    evrst56: {
        a: 6377301.243,
        rf: 300.8017,
        ellipseName: 'Everest 1956'
    },
    evrst69: {
        a: 6377295.664,
        rf: 300.8017,
        ellipseName: 'Everest 1969'
    },
    evrstSS: {
        a: 6377298.556,
        rf: 300.8017,
        ellipseName: 'Everest (Sabah & Sarawak)'
    },
    fschr60: {
        a: 6378166,
        rf: 298.3,
        ellipseName: 'Fischer (Mercury Datum) 1960'
    },
    fschr60m: {
        a: 6378155,
        rf: 298.3,
        ellipseName: 'Fischer 1960'
    },
    fschr68: {
        a: 6378150,
        rf: 298.3,
        ellipseName: 'Fischer 1968'
    },
    helmert: {
        a: 6378200,
        rf: 298.3,
        ellipseName: 'Helmert 1906'
    },
    hough: {
        a: 6378270,
        rf: 297,
        ellipseName: 'Hough'
    },
    intl: {
        a: 6378388,
        rf: 297,
        ellipseName: 'International 1909 (Hayford)'
    },
    kaula: {
        a: 6378163,
        rf: 298.24,
        ellipseName: 'Kaula 1961'
    },
    lerch: {
        a: 6378139,
        rf: 298.257,
        ellipseName: 'Lerch 1979'
    },
    mprts: {
        a: 6397300,
        rf: 191,
        ellipseName: 'Maupertius 1738'
    },
    new_intl: {
        a: 6378157.5,
        b: 6356772.2,
        ellipseName: 'New International 1967'
    },
    plessis: {
        a: 6376523,
        b: 6355863,
        ellipseName: 'Plessis 1817 (France)'
    },
    krass: {
        a: 6378245,
        rf: 298.3,
        ellipseName: 'Krassovsky, 1942'
    },
    SEasia: {
        a: 6378155,
        b: 6356773.3205,
        ellipseName: 'Southeast Asia'
    },
    walbeck: {
        a: 6376896,
        b: 6355834.8467,
        ellipseName: 'Walbeck'
    },
    WGS60: {
        a: 6378165,
        rf: 298.3,
        ellipseName: 'WGS 60'
    },
    WGS66: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'WGS 66'
    },
    WGS7: {
        a: 6378135,
        rf: 298.26,
        ellipseName: 'WGS 72'
    },
    WGS84: {
        a: 6378137,
        rf: 298.257223563,
        ellipseName: 'WGS 84'
    },
    sphere: {
        a: 6370997,
        b: 6370997,
        ellipseName: 'Normal Sphere (r=6370997)'
    }
};
exports.default = ellipsoids;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"Z1kSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var datums = {
    wgs84: {
        towgs84: '0,0,0',
        ellipse: 'WGS84',
        datumName: 'WGS84'
    },
    ch1903: {
        towgs84: '674.374,15.056,405.346',
        ellipse: 'bessel',
        datumName: 'swiss'
    },
    ggrs87: {
        towgs84: '-199.87,74.79,246.62',
        ellipse: 'GRS80',
        datumName: 'Greek_Geodetic_Reference_System_1987'
    },
    nad83: {
        towgs84: '0,0,0',
        ellipse: 'GRS80',
        datumName: 'North_American_Datum_1983'
    },
    nad27: {
        nadgrids: '@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat',
        ellipse: 'clrk66',
        datumName: 'North_American_Datum_1927'
    },
    potsdam: {
        towgs84: '598.1,73.7,418.2,0.202,0.045,-2.455,6.7',
        ellipse: 'bessel',
        datumName: 'Potsdam Rauenberg 1950 DHDN'
    },
    carthage: {
        towgs84: '-263.0,6.0,431.0',
        ellipse: 'clrk80ign',
        datumName: 'Carthage 1934 Tunisia'
    },
    hermannskogel: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Hermannskogel'
    },
    mgi: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Militar-Geographische Institut'
    },
    osni52: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'airy',
        datumName: 'Irish National'
    },
    ire65: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'mod_airy',
        datumName: 'Ireland 1965'
    },
    rassadiran: {
        towgs84: '-133.63,-157.5,-158.62',
        ellipse: 'intl',
        datumName: 'Rassadiran'
    },
    nzgd49: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993',
        ellipse: 'intl',
        datumName: 'New Zealand Geodetic Datum 1949'
    },
    osgb36: {
        towgs84: '446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894',
        ellipse: 'airy',
        datumName: 'Ordnance Survey of Great Britain 1936'
    },
    s_jtsk: {
        towgs84: '589,76,480',
        ellipse: 'bessel',
        datumName: 'S-JTSK (Ferro)'
    },
    beduaram: {
        towgs84: '-106,-87,188',
        ellipse: 'clrk80',
        datumName: 'Beduaram'
    },
    gunung_segara: {
        towgs84: '-403,684,41',
        ellipse: 'bessel',
        datumName: 'Gunung Segara Jakarta'
    },
    rnb72: {
        towgs84: '106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1',
        ellipse: 'intl',
        datumName: 'Reseau National Belge 1972'
    },
    EPSG_5451: {
        towgs84: '6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649'
    },
    IGNF_LURESG: {
        towgs84: '-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43'
    },
    EPSG_4614: {
        towgs84: '-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065'
    },
    EPSG_4615: {
        towgs84: '-494.088,-312.129,279.877,-1.423,-1.013,1.59,-0.748'
    },
    ESRI_37241: {
        towgs84: '-76.822,257.457,-12.817,2.136,-0.033,-2.392,-0.031'
    },
    ESRI_37249: {
        towgs84: '-440.296,58.548,296.265,1.128,10.202,4.559,-0.438'
    },
    ESRI_37245: {
        towgs84: '-511.151,-181.269,139.609,1.05,2.703,1.798,3.071'
    },
    EPSG_4178: {
        towgs84: '24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01'
    },
    EPSG_4622: {
        towgs84: '-472.29,-5.63,-304.12,0.4362,-0.8374,0.2563,1.8984'
    },
    EPSG_4625: {
        towgs84: '126.93,547.94,130.41,-2.7867,5.1612,-0.8584,13.8227'
    },
    EPSG_5252: {
        towgs84: '0.023,0.036,-0.068,0.00176,0.00912,-0.01136,0.00439'
    },
    EPSG_4314: {
        towgs84: '597.1,71.4,412.1,0.894,0.068,-1.563,7.58'
    },
    EPSG_4282: {
        towgs84: '-178.3,-316.7,-131.5,5.278,6.077,10.979,19.166'
    },
    EPSG_4231: {
        towgs84: '-83.11,-97.38,-117.22,0.005693,-0.044698,0.044285,0.1218'
    },
    EPSG_4274: {
        towgs84: '-230.994,102.591,25.199,0.633,-0.239,0.9,1.95'
    },
    EPSG_4134: {
        towgs84: '-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006'
    },
    EPSG_4254: {
        towgs84: '18.38,192.45,96.82,0.056,-0.142,-0.2,-0.0013'
    },
    EPSG_4159: {
        towgs84: '-194.513,-63.978,-25.759,-3.4027,3.756,-3.352,-0.9175'
    },
    EPSG_4687: {
        towgs84: '0.072,-0.507,-0.245,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_4227: {
        towgs84: '-83.58,-397.54,458.78,-17.595,-2.847,4.256,3.225'
    },
    EPSG_4746: {
        towgs84: '599.4,72.4,419.2,-0.062,-0.022,-2.723,6.46'
    },
    EPSG_4745: {
        towgs84: '612.4,77,440.2,-0.054,0.057,-2.797,2.55'
    },
    EPSG_6311: {
        towgs84: '8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926'
    },
    EPSG_4289: {
        towgs84: '565.7381,50.4018,465.2904,-0.395026,0.330772,-1.876073,4.07244'
    },
    EPSG_4230: {
        towgs84: '-68.863,-134.888,-111.49,-0.53,-0.14,0.57,-3.4'
    },
    EPSG_4154: {
        towgs84: '-123.02,-158.95,-168.47'
    },
    EPSG_4156: {
        towgs84: '570.8,85.7,462.8,4.998,1.587,5.261,3.56'
    },
    EPSG_4299: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4179: {
        towgs84: '33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84'
    },
    EPSG_4313: {
        towgs84: '-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747'
    },
    EPSG_4194: {
        towgs84: '163.511,127.533,-159.789'
    },
    EPSG_4195: {
        towgs84: '105,326,-102.5'
    },
    EPSG_4196: {
        towgs84: '-45,417,-3.5'
    },
    EPSG_4611: {
        towgs84: '-162.619,-276.959,-161.764,0.067753,-2.243648,-1.158828,-1.094246'
    },
    EPSG_4633: {
        towgs84: '137.092,131.66,91.475,-1.9436,-11.5993,-4.3321,-7.4824'
    },
    EPSG_4641: {
        towgs84: '-408.809,366.856,-412.987,1.8842,-0.5308,2.1655,-121.0993'
    },
    EPSG_4643: {
        towgs84: '-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002'
    },
    EPSG_4300: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4188: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4660: {
        towgs84: '982.6087,552.753,-540.873,6.681627,-31.611492,-19.848161,16.805'
    },
    EPSG_4662: {
        towgs84: '97.295,-263.247,310.882,-1.5999,0.8386,3.1409,13.3259'
    },
    EPSG_3906: {
        towgs84: '577.88891,165.22205,391.18289,4.9145,-0.94729,-13.05098,7.78664'
    },
    EPSG_4307: {
        towgs84: '-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547'
    },
    EPSG_6892: {
        towgs84: '-76.269,-16.683,68.562,-6.275,10.536,-4.286,-13.686'
    },
    EPSG_4690: {
        towgs84: '221.597,152.441,176.523,2.403,1.3893,0.884,11.4648'
    },
    EPSG_4691: {
        towgs84: '218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817'
    },
    EPSG_4629: {
        towgs84: '72.51,345.411,79.241,-1.5862,-0.8826,-0.5495,1.3653'
    },
    EPSG_4630: {
        towgs84: '165.804,216.213,180.26,-0.6251,-0.4515,-0.0721,7.4111'
    },
    EPSG_4692: {
        towgs84: '217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_9333: {
        towgs84: '0,0,0,-0.008393,0.000749,-0.010276,0'
    },
    EPSG_9059: {
        towgs84: '0,0,0'
    },
    EPSG_4312: {
        towgs84: '601.705,84.263,485.227,4.7354,1.3145,5.393,-2.3887'
    },
    EPSG_4123: {
        towgs84: '-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496'
    },
    EPSG_4309: {
        towgs84: '-124.45,183.74,44.64,-0.4384,0.5446,-0.9706,-2.1365'
    },
    ESRI_104106: {
        towgs84: '-283.088,-70.693,117.445,-1.157,0.059,-0.652,-4.058'
    },
    EPSG_4281: {
        towgs84: '-219.247,-73.802,269.529'
    },
    EPSG_4322: {
        towgs84: '0,0,4.5'
    },
    EPSG_4324: {
        towgs84: '0,0,1.9'
    },
    EPSG_4284: {
        towgs84: '43.822,-108.842,-119.585,1.455,-0.761,0.737,0.549'
    },
    EPSG_4277: {
        towgs84: '446.448,-125.157,542.06,0.15,0.247,0.842,-20.489'
    },
    EPSG_4207: {
        towgs84: '-282.1,-72.2,120,-1.529,0.145,-0.89,-4.46'
    },
    EPSG_4688: {
        towgs84: '347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647'
    },
    EPSG_4689: {
        towgs84: '410.793,54.542,80.501,-2.5596,-2.3517,-0.6594,17.3218'
    },
    EPSG_4720: {
        towgs84: '0,0,4.5'
    },
    EPSG_4273: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    EPSG_4240: {
        towgs84: '204.64,834.74,293.8'
    },
    EPSG_4817: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    ESRI_104131: {
        towgs84: '426.62,142.62,460.09,4.98,4.49,-12.42,-17.1'
    },
    EPSG_4265: {
        towgs84: '-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68'
    },
    EPSG_4263: {
        towgs84: '-111.92,-87.85,114.5,1.875,0.202,0.219,0.032'
    },
    EPSG_4298: {
        towgs84: '-689.5937,623.84046,-65.93566,-0.02331,1.17094,-0.80054,5.88536'
    },
    EPSG_4270: {
        towgs84: '-253.4392,-148.452,386.5267,0.15605,0.43,-0.1013,-0.0424'
    },
    EPSG_4229: {
        towgs84: '-121.8,98.1,-10.7'
    },
    EPSG_4220: {
        towgs84: '-55.5,-348,-229.2'
    },
    EPSG_4214: {
        towgs84: '12.646,-155.176,-80.863'
    },
    EPSG_4232: {
        towgs84: '-345,3,223'
    },
    EPSG_4238: {
        towgs84: '-1.977,-13.06,-9.993,0.364,0.254,0.689,-1.037'
    },
    EPSG_4168: {
        towgs84: '-170,33,326'
    },
    EPSG_4131: {
        towgs84: '199,931,318.9'
    },
    EPSG_4152: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_5228: {
        towgs84: '572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378'
    },
    EPSG_8351: {
        towgs84: '485.021,169.465,483.839,7.786342,4.397554,4.102655,0'
    },
    EPSG_4683: {
        towgs84: '-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06'
    },
    EPSG_4133: {
        towgs84: '0,0,0'
    },
    EPSG_7373: {
        towgs84: '0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693'
    },
    EPSG_9075: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9072: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9294: {
        towgs84: '1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388'
    },
    EPSG_4212: {
        towgs84: '-267.434,173.496,181.814,-13.4704,8.7154,7.3926,14.7492'
    },
    EPSG_4191: {
        towgs84: '-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703'
    },
    EPSG_4237: {
        towgs84: '52.684,-71.194,-13.975,-0.312,-0.1063,-0.3729,1.0191'
    },
    EPSG_4740: {
        towgs84: '-1.08,-0.27,-0.9'
    },
    EPSG_4124: {
        towgs84: '419.3836,99.3335,591.3451,0.850389,1.817277,-7.862238,-0.99496'
    },
    EPSG_5681: {
        towgs84: '584.9636,107.7175,413.8067,1.1155,0.2824,-3.1384,7.9922'
    },
    EPSG_4141: {
        towgs84: '23.772,17.49,17.859,-0.3132,-1.85274,1.67299,-5.4262'
    },
    EPSG_4204: {
        towgs84: '-85.645,-273.077,-79.708,2.289,-1.421,2.532,3.194'
    },
    EPSG_4319: {
        towgs84: '226.702,-193.337,-35.371,-2.229,-4.391,9.238,0.9798'
    },
    EPSG_4200: {
        towgs84: '24.82,-131.21,-82.66'
    },
    EPSG_4130: {
        towgs84: '0,0,0'
    },
    EPSG_4127: {
        towgs84: '-82.875,-57.097,-156.768,-2.158,1.524,-0.982,-0.359'
    },
    EPSG_4149: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4617: {
        towgs84: '-0.991,1.9072,0.5129,0.02579,0.00965,0.01166,0'
    },
    EPSG_4663: {
        towgs84: '-210.502,-66.902,-48.476,2.094,-15.067,-5.817,0.485'
    },
    EPSG_4664: {
        towgs84: '-211.939,137.626,58.3,-0.089,0.251,0.079,0.384'
    },
    EPSG_4665: {
        towgs84: '-105.854,165.589,-38.312,-0.003,-0.026,0.024,-0.048'
    },
    EPSG_4666: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    EPSG_4756: {
        towgs84: '-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188'
    },
    EPSG_4723: {
        towgs84: '-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925'
    },
    EPSG_4726: {
        towgs84: '8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081'
    },
    EPSG_4267: {
        towgs84: '-8.0,160.0,176.0'
    },
    EPSG_5365: {
        towgs84: '-0.16959,0.35312,0.51846,0.03385,-0.16325,0.03446,0.03693'
    },
    EPSG_4218: {
        towgs84: '304.5,306.5,-318.1'
    },
    EPSG_4242: {
        towgs84: '-33.722,153.789,94.959,-8.581,-4.478,4.54,8.95'
    },
    EPSG_4216: {
        towgs84: '-292.295,248.758,429.447,4.9971,2.99,6.6906,1.0289'
    },
    ESRI_104105: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    ESRI_104129: {
        towgs84: '0,0,0'
    },
    EPSG_4673: {
        towgs84: '174.05,-25.49,112.57'
    },
    EPSG_4202: {
        towgs84: '-124,-60,154'
    },
    EPSG_4203: {
        towgs84: '-117.763,-51.51,139.061,0.292,0.443,0.277,-0.191'
    },
    EPSG_3819: {
        towgs84: '595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408'
    },
    EPSG_8694: {
        towgs84: '-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169'
    },
    EPSG_4145: {
        towgs84: '275.57,676.78,229.6'
    },
    EPSG_4283: {
        towgs84: '0.06155,-0.01087,-0.04019,0.039492,0.032722,0.032898,-0.009994'
    },
    EPSG_4317: {
        towgs84: '2.3287,-147.0425,-92.0802,-0.309248,0.324822,0.497299,5.689063'
    },
    EPSG_4272: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993'
    },
    EPSG_4248: {
        towgs84: '-307.7,265.3,-363.5'
    },
    EPSG_5561: {
        towgs84: '24,-121,-76'
    },
    EPSG_5233: {
        towgs84: '-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338'
    },
    ESRI_104130: {
        towgs84: '-86,-98,-119'
    },
    ESRI_104102: {
        towgs84: '682,-203,480'
    },
    ESRI_37207: {
        towgs84: '7,-10,-26'
    },
    EPSG_4675: {
        towgs84: '59.935,118.4,-10.871'
    },
    ESRI_104109: {
        towgs84: '-89.121,-348.182,260.871'
    },
    ESRI_104112: {
        towgs84: '-185.583,-230.096,281.361'
    },
    ESRI_104113: {
        towgs84: '25.1,-275.6,222.6'
    },
    IGNF_WGS72G: {
        towgs84: '0,12,6'
    },
    IGNF_NTFG: {
        towgs84: '-168,-60,320'
    },
    IGNF_EFATE57G: {
        towgs84: '-127,-769,472'
    },
    IGNF_PGP50G: {
        towgs84: '324.8,153.6,172.1'
    },
    IGNF_REUN47G: {
        towgs84: '94,-948,-1262'
    },
    IGNF_CSG67G: {
        towgs84: '-186,230,110'
    },
    IGNF_GUAD48G: {
        towgs84: '-467,-16,-300'
    },
    IGNF_TAHI51G: {
        towgs84: '162,117,154'
    },
    IGNF_TAHAAG: {
        towgs84: '65,342,77'
    },
    IGNF_NUKU72G: {
        towgs84: '84,274,65'
    },
    IGNF_PETRELS72G: {
        towgs84: '365,194,166'
    },
    IGNF_WALL78G: {
        towgs84: '253,-133,-127'
    },
    IGNF_MAYO50G: {
        towgs84: '-382,-59,-262'
    },
    IGNF_TANNAG: {
        towgs84: '-139,-967,436'
    },
    IGNF_IGN72G: {
        towgs84: '-13,-348,292'
    },
    IGNF_ATIGG: {
        towgs84: '1118,23,66'
    },
    IGNF_FANGA84G: {
        towgs84: '150.57,158.33,118.32'
    },
    IGNF_RUSAT84G: {
        towgs84: '202.13,174.6,-15.74'
    },
    IGNF_KAUE70G: {
        towgs84: '126.74,300.1,-75.49'
    },
    IGNF_MOP90G: {
        towgs84: '-10.8,-1.8,12.77'
    },
    IGNF_MHPF67G: {
        towgs84: '338.08,212.58,-296.17'
    },
    IGNF_TAHI79G: {
        towgs84: '160.61,116.05,153.69'
    },
    IGNF_ANAA92G: {
        towgs84: '1.5,3.84,4.81'
    },
    IGNF_MARQUI72G: {
        towgs84: '330.91,-13.92,58.56'
    },
    IGNF_APAT86G: {
        towgs84: '143.6,197.82,74.05'
    },
    IGNF_TUBU69G: {
        towgs84: '237.17,171.61,-77.84'
    },
    IGNF_STPM50G: {
        towgs84: '11.363,424.148,373.13'
    },
    EPSG_4150: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4754: {
        towgs84: '-208.4058,-109.8777,-2.5764'
    },
    ESRI_104101: {
        towgs84: '372.87,149.23,585.29'
    },
    EPSG_4693: {
        towgs84: '0,-0.15,0.68'
    },
    EPSG_6207: {
        towgs84: '293.17,726.18,245.36'
    },
    EPSG_4153: {
        towgs84: '-133.63,-157.5,-158.62'
    },
    EPSG_4132: {
        towgs84: '-241.54,-163.64,396.06'
    },
    EPSG_4221: {
        towgs84: '-154.5,150.7,100.4'
    },
    EPSG_4266: {
        towgs84: '-80.7,-132.5,41.1'
    },
    EPSG_4193: {
        towgs84: '-70.9,-151.8,-41.4'
    },
    EPSG_5340: {
        towgs84: '-0.41,0.46,-0.35'
    },
    EPSG_4246: {
        towgs84: '-294.7,-200.1,525.5'
    },
    EPSG_4318: {
        towgs84: '-3.2,-5.7,2.8'
    },
    EPSG_4121: {
        towgs84: '-199.87,74.79,246.62'
    },
    EPSG_4223: {
        towgs84: '-260.1,5.5,432.2'
    },
    EPSG_4158: {
        towgs84: '-0.465,372.095,171.736'
    },
    EPSG_4285: {
        towgs84: '-128.16,-282.42,21.93'
    },
    EPSG_4613: {
        towgs84: '-404.78,685.68,45.47'
    },
    EPSG_4607: {
        towgs84: '195.671,332.517,274.607'
    },
    EPSG_4475: {
        towgs84: '-381.788,-57.501,-256.673'
    },
    EPSG_4208: {
        towgs84: '-157.84,308.54,-146.6'
    },
    EPSG_4743: {
        towgs84: '70.995,-335.916,262.898'
    },
    EPSG_4710: {
        towgs84: '-323.65,551.39,-491.22'
    },
    EPSG_7881: {
        towgs84: '-0.077,0.079,0.086'
    },
    EPSG_4682: {
        towgs84: '283.729,735.942,261.143'
    },
    EPSG_4739: {
        towgs84: '-156,-271,-189'
    },
    EPSG_4679: {
        towgs84: '-80.01,253.26,291.19'
    },
    EPSG_4750: {
        towgs84: '-56.263,16.136,-22.856'
    },
    EPSG_4644: {
        towgs84: '-10.18,-350.43,291.37'
    },
    EPSG_4695: {
        towgs84: '-103.746,-9.614,-255.95'
    },
    EPSG_4292: {
        towgs84: '-355,21,72'
    },
    EPSG_4302: {
        towgs84: '-61.702,284.488,472.052'
    },
    EPSG_4143: {
        towgs84: '-124.76,53,466.79'
    },
    EPSG_4606: {
        towgs84: '-153,153,307'
    },
    EPSG_4699: {
        towgs84: '-770.1,158.4,-498.2'
    },
    EPSG_4247: {
        towgs84: '-273.5,110.6,-357.9'
    },
    EPSG_4160: {
        towgs84: '8.88,184.86,106.69'
    },
    EPSG_4161: {
        towgs84: '-233.43,6.65,173.64'
    },
    EPSG_9251: {
        towgs84: '-9.5,122.9,138.2'
    },
    EPSG_9253: {
        towgs84: '-78.1,101.6,133.3'
    },
    EPSG_4297: {
        towgs84: '-198.383,-240.517,-107.909'
    },
    EPSG_4269: {
        towgs84: '0,0,0'
    },
    EPSG_4301: {
        towgs84: '-147,506,687'
    },
    EPSG_4618: {
        towgs84: '-59,-11,-52'
    },
    EPSG_4612: {
        towgs84: '0,0,0'
    },
    EPSG_4678: {
        towgs84: '44.585,-131.212,-39.544'
    },
    EPSG_4250: {
        towgs84: '-130,29,364'
    },
    EPSG_4144: {
        towgs84: '214,804,268'
    },
    EPSG_4147: {
        towgs84: '-17.51,-108.32,-62.39'
    },
    EPSG_4259: {
        towgs84: '-254.1,-5.36,-100.29'
    },
    EPSG_4164: {
        towgs84: '-76,-138,67'
    },
    EPSG_4211: {
        towgs84: '-378.873,676.002,-46.255'
    },
    EPSG_4182: {
        towgs84: '-422.651,-172.995,84.02'
    },
    EPSG_4224: {
        towgs84: '-143.87,243.37,-33.52'
    },
    EPSG_4225: {
        towgs84: '-205.57,168.77,-4.12'
    },
    EPSG_5527: {
        towgs84: '-67.35,3.88,-38.22'
    },
    EPSG_4752: {
        towgs84: '98,390,-22'
    },
    EPSG_4310: {
        towgs84: '-30,190,89'
    },
    EPSG_9248: {
        towgs84: '-192.26,65.72,132.08'
    },
    EPSG_4680: {
        towgs84: '124.5,-63.5,-281'
    },
    EPSG_4701: {
        towgs84: '-79.9,-158,-168.9'
    },
    EPSG_4706: {
        towgs84: '-146.21,112.63,4.05'
    },
    EPSG_4805: {
        towgs84: '682,-203,480'
    },
    EPSG_4201: {
        towgs84: '-165,-11,206'
    },
    EPSG_4210: {
        towgs84: '-157,-2,-299'
    },
    EPSG_4183: {
        towgs84: '-104,167,-38'
    },
    EPSG_4139: {
        towgs84: '11,72,-101'
    },
    EPSG_4668: {
        towgs84: '-86,-98,-119'
    },
    EPSG_4717: {
        towgs84: '-2,151,181'
    },
    EPSG_4732: {
        towgs84: '102,52,-38'
    },
    EPSG_4280: {
        towgs84: '-377,681,-50'
    },
    EPSG_4209: {
        towgs84: '-138,-105,-289'
    },
    EPSG_4261: {
        towgs84: '31,146,47'
    },
    EPSG_4658: {
        towgs84: '-73,46,-86'
    },
    EPSG_4721: {
        towgs84: '265.025,384.929,-194.046'
    },
    EPSG_4222: {
        towgs84: '-136,-108,-292'
    },
    EPSG_4601: {
        towgs84: '-255,-15,71'
    },
    EPSG_4602: {
        towgs84: '725,685,536'
    },
    EPSG_4603: {
        towgs84: '72,213.7,93'
    },
    EPSG_4605: {
        towgs84: '9,183,236'
    },
    EPSG_4621: {
        towgs84: '137,248,-430'
    },
    EPSG_4657: {
        towgs84: '-28,199,5'
    },
    EPSG_4316: {
        towgs84: '103.25,-100.4,-307.19'
    },
    EPSG_4642: {
        towgs84: '-13,-348,292'
    },
    EPSG_4698: {
        towgs84: '145,-187,103'
    },
    EPSG_4192: {
        towgs84: '-206.1,-174.7,-87.7'
    },
    EPSG_4311: {
        towgs84: '-265,120,-358'
    },
    EPSG_4135: {
        towgs84: '58,-283,-182'
    },
    ESRI_104138: {
        towgs84: '198,-226,-347'
    },
    EPSG_4245: {
        towgs84: '-11,851,5'
    },
    EPSG_4142: {
        towgs84: '-125,53,467'
    },
    EPSG_4213: {
        towgs84: '-106,-87,188'
    },
    EPSG_4253: {
        towgs84: '-133,-77,-51'
    },
    EPSG_4129: {
        towgs84: '-132,-110,-335'
    },
    EPSG_4713: {
        towgs84: '-77,-128,142'
    },
    EPSG_4239: {
        towgs84: '217,823,299'
    },
    EPSG_4146: {
        towgs84: '295,736,257'
    },
    EPSG_4155: {
        towgs84: '-83,37,124'
    },
    EPSG_4165: {
        towgs84: '-173,253,27'
    },
    EPSG_4672: {
        towgs84: '175,-38,113'
    },
    EPSG_4236: {
        towgs84: '-637,-549,-203'
    },
    EPSG_4251: {
        towgs84: '-90,40,88'
    },
    EPSG_4271: {
        towgs84: '-2,374,172'
    },
    EPSG_4175: {
        towgs84: '-88,4,101'
    },
    EPSG_4716: {
        towgs84: '298,-304,-375'
    },
    EPSG_4315: {
        towgs84: '-23,259,-9'
    },
    EPSG_4744: {
        towgs84: '-242.2,-144.9,370.3'
    },
    EPSG_4244: {
        towgs84: '-97,787,86'
    },
    EPSG_4293: {
        towgs84: '616,97,-251'
    },
    EPSG_4714: {
        towgs84: '-127,-769,472'
    },
    EPSG_4736: {
        towgs84: '260,12,-147'
    },
    EPSG_6883: {
        towgs84: '-235,-110,393'
    },
    EPSG_6894: {
        towgs84: '-63,176,185'
    },
    EPSG_4205: {
        towgs84: '-43,-163,45'
    },
    EPSG_4256: {
        towgs84: '41,-220,-134'
    },
    EPSG_4262: {
        towgs84: '639,405,60'
    },
    EPSG_4604: {
        towgs84: '174,359,365'
    },
    EPSG_4169: {
        towgs84: '-115,118,426'
    },
    EPSG_4620: {
        towgs84: '-106,-129,165'
    },
    EPSG_4184: {
        towgs84: '-203,141,53'
    },
    EPSG_4616: {
        towgs84: '-289,-124,60'
    },
    EPSG_9403: {
        towgs84: '-307,-92,127'
    },
    EPSG_4684: {
        towgs84: '-133,-321,50'
    },
    EPSG_4708: {
        towgs84: '-491,-22,435'
    },
    EPSG_4707: {
        towgs84: '114,-116,-333'
    },
    EPSG_4709: {
        towgs84: '145,75,-272'
    },
    EPSG_4712: {
        towgs84: '-205,107,53'
    },
    EPSG_4711: {
        towgs84: '124,-234,-25'
    },
    EPSG_4718: {
        towgs84: '230,-199,-752'
    },
    EPSG_4719: {
        towgs84: '211,147,111'
    },
    EPSG_4724: {
        towgs84: '208,-435,-229'
    },
    EPSG_4725: {
        towgs84: '189,-79,-202'
    },
    EPSG_4735: {
        towgs84: '647,1777,-1124'
    },
    EPSG_4722: {
        towgs84: '-794,119,-298'
    },
    EPSG_4728: {
        towgs84: '-307,-92,127'
    },
    EPSG_4734: {
        towgs84: '-632,438,-609'
    },
    EPSG_4727: {
        towgs84: '912,-58,1227'
    },
    EPSG_4729: {
        towgs84: '185,165,42'
    },
    EPSG_4730: {
        towgs84: '170,42,84'
    },
    EPSG_4733: {
        towgs84: '276,-57,149'
    },
    ESRI_37218: {
        towgs84: '230,-199,-752'
    },
    ESRI_37240: {
        towgs84: '-7,215,225'
    },
    ESRI_37221: {
        towgs84: '252,-209,-751'
    },
    ESRI_4305: {
        towgs84: '-123,-206,219'
    },
    ESRI_104139: {
        towgs84: '-73,-247,227'
    },
    EPSG_4748: {
        towgs84: '51,391,-36'
    },
    EPSG_4219: {
        towgs84: '-384,664,-48'
    },
    EPSG_4255: {
        towgs84: '-333,-222,114'
    },
    EPSG_4257: {
        towgs84: '-587.8,519.75,145.76'
    },
    EPSG_4646: {
        towgs84: '-963,510,-359'
    },
    EPSG_6881: {
        towgs84: '-24,-203,268'
    },
    EPSG_6882: {
        towgs84: '-183,-15,273'
    },
    EPSG_4715: {
        towgs84: '-104,-129,239'
    },
    IGNF_RGF93GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGM04GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGSPM06GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGTAAF07GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGFG95GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGNCG: {
        towgs84: '0,0,0'
    },
    IGNF_RGPFGDD: {
        towgs84: '0,0,0'
    },
    IGNF_ETRS89G: {
        towgs84: '0,0,0'
    },
    IGNF_RGR92GDD: {
        towgs84: '0,0,0'
    },
    EPSG_4173: {
        towgs84: '0,0,0'
    },
    EPSG_4180: {
        towgs84: '0,0,0'
    },
    EPSG_4619: {
        towgs84: '0,0,0'
    },
    EPSG_4667: {
        towgs84: '0,0,0'
    },
    EPSG_4075: {
        towgs84: '0,0,0'
    },
    EPSG_6706: {
        towgs84: '0,0,0'
    },
    EPSG_7798: {
        towgs84: '0,0,0'
    },
    EPSG_4661: {
        towgs84: '0,0,0'
    },
    EPSG_4669: {
        towgs84: '0,0,0'
    },
    EPSG_8685: {
        towgs84: '0,0,0'
    },
    EPSG_4151: {
        towgs84: '0,0,0'
    },
    EPSG_9702: {
        towgs84: '0,0,0'
    },
    EPSG_4758: {
        towgs84: '0,0,0'
    },
    EPSG_4761: {
        towgs84: '0,0,0'
    },
    EPSG_4765: {
        towgs84: '0,0,0'
    },
    EPSG_8997: {
        towgs84: '0,0,0'
    },
    EPSG_4023: {
        towgs84: '0,0,0'
    },
    EPSG_4670: {
        towgs84: '0,0,0'
    },
    EPSG_4694: {
        towgs84: '0,0,0'
    },
    EPSG_4148: {
        towgs84: '0,0,0'
    },
    EPSG_4163: {
        towgs84: '0,0,0'
    },
    EPSG_4167: {
        towgs84: '0,0,0'
    },
    EPSG_4189: {
        towgs84: '0,0,0'
    },
    EPSG_4190: {
        towgs84: '0,0,0'
    },
    EPSG_4176: {
        towgs84: '0,0,0'
    },
    EPSG_4659: {
        towgs84: '0,0,0'
    },
    EPSG_3824: {
        towgs84: '0,0,0'
    },
    EPSG_3889: {
        towgs84: '0,0,0'
    },
    EPSG_4046: {
        towgs84: '0,0,0'
    },
    EPSG_4081: {
        towgs84: '0,0,0'
    },
    EPSG_4558: {
        towgs84: '0,0,0'
    },
    EPSG_4483: {
        towgs84: '0,0,0'
    },
    EPSG_5013: {
        towgs84: '0,0,0'
    },
    EPSG_5264: {
        towgs84: '0,0,0'
    },
    EPSG_5324: {
        towgs84: '0,0,0'
    },
    EPSG_5354: {
        towgs84: '0,0,0'
    },
    EPSG_5371: {
        towgs84: '0,0,0'
    },
    EPSG_5373: {
        towgs84: '0,0,0'
    },
    EPSG_5381: {
        towgs84: '0,0,0'
    },
    EPSG_5393: {
        towgs84: '0,0,0'
    },
    EPSG_5489: {
        towgs84: '0,0,0'
    },
    EPSG_5593: {
        towgs84: '0,0,0'
    },
    EPSG_6135: {
        towgs84: '0,0,0'
    },
    EPSG_6365: {
        towgs84: '0,0,0'
    },
    EPSG_5246: {
        towgs84: '0,0,0'
    },
    EPSG_7886: {
        towgs84: '0,0,0'
    },
    EPSG_8431: {
        towgs84: '0,0,0'
    },
    EPSG_8427: {
        towgs84: '0,0,0'
    },
    EPSG_8699: {
        towgs84: '0,0,0'
    },
    EPSG_8818: {
        towgs84: '0,0,0'
    },
    EPSG_4757: {
        towgs84: '0,0,0'
    },
    EPSG_9140: {
        towgs84: '0,0,0'
    },
    EPSG_8086: {
        towgs84: '0,0,0'
    },
    EPSG_4686: {
        towgs84: '0,0,0'
    },
    EPSG_4737: {
        towgs84: '0,0,0'
    },
    EPSG_4702: {
        towgs84: '0,0,0'
    },
    EPSG_4747: {
        towgs84: '0,0,0'
    },
    EPSG_4749: {
        towgs84: '0,0,0'
    },
    EPSG_4674: {
        towgs84: '0,0,0'
    },
    EPSG_4755: {
        towgs84: '0,0,0'
    },
    EPSG_4759: {
        towgs84: '0,0,0'
    },
    EPSG_4762: {
        towgs84: '0,0,0'
    },
    EPSG_4763: {
        towgs84: '0,0,0'
    },
    EPSG_4764: {
        towgs84: '0,0,0'
    },
    EPSG_4166: {
        towgs84: '0,0,0'
    },
    EPSG_4170: {
        towgs84: '0,0,0'
    },
    EPSG_5546: {
        towgs84: '0,0,0'
    },
    EPSG_7844: {
        towgs84: '0,0,0'
    },
    EPSG_4818: {
        towgs84: '589,76,480'
    },
    EPSG_10328: {
        towgs84: '0,0,0'
    },
    EPSG_9782: {
        towgs84: '0,0,0'
    },
    EPSG_9777: {
        towgs84: '0,0,0'
    },
    EPSG_10690: {
        towgs84: '0,0,0'
    },
    EPSG_10639: {
        towgs84: '0,0,0'
    },
    EPSG_10739: {
        towgs84: '0,0,0'
    },
    EPSG_7686: {
        towgs84: '0,0,0'
    },
    EPSG_8900: {
        towgs84: '0,0,0'
    },
    EPSG_5886: {
        towgs84: '0,0,0'
    },
    EPSG_7683: {
        towgs84: '0,0,0'
    },
    EPSG_6668: {
        towgs84: '0,0,0'
    },
    EPSG_20046: {
        towgs84: '0,0,0'
    },
    EPSG_10299: {
        towgs84: '0,0,0'
    },
    EPSG_10310: {
        towgs84: '0,0,0'
    },
    EPSG_10475: {
        towgs84: '0,0,0'
    },
    EPSG_4742: {
        towgs84: '0,0,0'
    },
    EPSG_10671: {
        towgs84: '0,0,0'
    },
    EPSG_10762: {
        towgs84: '0,0,0'
    },
    EPSG_10725: {
        towgs84: '0,0,0'
    },
    EPSG_10791: {
        towgs84: '0,0,0'
    },
    EPSG_10800: {
        towgs84: '0,0,0'
    },
    EPSG_10305: {
        towgs84: '0,0,0'
    },
    EPSG_10941: {
        towgs84: '0,0,0'
    },
    EPSG_10968: {
        towgs84: '0,0,0'
    },
    EPSG_10875: {
        towgs84: '0,0,0'
    },
    EPSG_6318: {
        towgs84: '0,0,0'
    },
    EPSG_10910: {
        towgs84: '0,0,0'
    }
};
for(var key in datums){
    var datum = datums[key];
    if (!datum.datumName) continue;
    datums[datum.datumName] = datum;
}
exports.default = datums;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iKf0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _values = require("./constants/values");
function datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    out.datum_type = (0, _values.PJD_NODATUM);
    if (datum_params) {
        out.datum_type = (0, _values.PJD_WGS84);
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, _values.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, _values.PJD_7PARAM);
                out.datum_params[3] *= (0, _values.SEC_TO_RAD);
                out.datum_params[4] *= (0, _values.SEC_TO_RAD);
                out.datum_params[5] *= (0, _values.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, _values.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; // datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
exports.default = datum;

},{"./constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4NCwA":[function(require,module,exports,__globalThis) {
/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ /**
 * @typedef {Object} NadgridInfo
 * @property {string} name The name of the NAD grid or 'null' if not specified.
 * @property {boolean} mandatory Indicates if the grid is mandatory (true) or optional (false).
 * @property {*} grid The loaded NAD grid object, or null if not loaded or not applicable.
 * @property {boolean} isNull True if the grid is explicitly 'null', otherwise false.
 */ /**
 * @typedef {Object} NTV2GridOptions
 * @property {boolean} [includeErrorFields=true] Whether to include error fields in the subgrids.
 */ /**
 * @typedef {Object} NadgridHeader
 * @property {number} [nFields] Number of fields in the header.
 * @property {number} [nSubgridFields] Number of fields in each subgrid header.
 * @property {number} nSubgrids Number of subgrids in the file.
 * @property {string} [shiftType] Type of shift (e.g., "SECONDS").
 * @property {number} [fromSemiMajorAxis] Source ellipsoid semi-major axis.
 * @property {number} [fromSemiMinorAxis] Source ellipsoid semi-minor axis.
 * @property {number} [toSemiMajorAxis] Target ellipsoid semi-major axis.
 * @property {number} [toSemiMinorAxis] Target ellipsoid semi-minor axis.
 */ /**
 * @typedef {Object} Subgrid
 * @property {Array<number>} ll Lower left corner of the grid in radians [longitude, latitude].
 * @property {Array<number>} del Grid spacing in radians [longitude interval, latitude interval].
 * @property {Array<number>} lim Number of columns in the grid [longitude columns, latitude columns].
 * @property {number} [count] Total number of grid nodes.
 * @property {Array} cvs Mapped node values for the grid.
 */ /** @typedef {{header: NadgridHeader, subgrids: Array<Subgrid>}} NADGrid */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nadgrid);
/**
 * Given a proj4 value for nadgrids, return an array of loaded grids
 * @param {string} nadgrids A comma-separated list of grid names, optionally prefixed with '@' to indicate optional grids.
 * @returns
 */ parcelHelpers.export(exports, "getNadgrids", ()=>getNadgrids);
var loadedNadgrids = {};
function nadgrid(key, data, options) {
    if (data instanceof ArrayBuffer) return readNTV2Grid(key, data, options);
    return {
        ready: readGeotiffGrid(key, data)
    };
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {ArrayBuffer} data The NTv2 grid data as an ArrayBuffer.
 * @param {NTV2GridOptions} [options] Optional parameters for loading the grid.
 * @returns {NADGrid} The loaded NAD grid information.
 */ function readNTV2Grid(key, data, options) {
    var includeErrorFields = true;
    if (options !== undefined && options.includeErrorFields === false) includeErrorFields = false;
    var view = new DataView(data);
    var isLittleEndian = detectLittleEndian(view);
    var header = readHeader(view, isLittleEndian);
    var subgrids = readSubgrids(view, header, isLittleEndian, includeErrorFields);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {import('geotiff').GeoTIFF} tiff The GeoTIFF instance to read the grid from.
 * @returns {Promise<NADGrid>} A promise that resolves to the loaded NAD grid information.
 */ async function readGeotiffGrid(key, tiff) {
    var subgrids = [];
    var subGridCount = await tiff.getImageCount();
    // proj produced tiff grid shift files appear to organize lower res subgrids first, higher res/ child subgrids last.
    for(var subgridIndex = subGridCount - 1; subgridIndex >= 0; subgridIndex--){
        var image = await tiff.getImage(subgridIndex);
        var rasters = await image.readRasters();
        var data = rasters;
        var lim = [
            image.getWidth(),
            image.getHeight()
        ];
        var imageBBoxRadians = image.getBoundingBox().map(degreesToRadians);
        var modelPixelScale = typeof image.fileDirectory.getValue === 'function' ? image.fileDirectory.getValue('ModelPixelScale') : /** @type {any} */ image.fileDirectory.ModelPixelScale;
        var del = [
            modelPixelScale[0],
            modelPixelScale[1]
        ].map(degreesToRadians);
        var maxX = imageBBoxRadians[0] + (lim[0] - 1) * del[0];
        var minY = imageBBoxRadians[3] - (lim[1] - 1) * del[1];
        var latitudeOffsetBand = data[0];
        var longitudeOffsetBand = data[1];
        var nodes = [];
        for(let i = lim[1] - 1; i >= 0; i--)for(let j = lim[0] - 1; j >= 0; j--){
            var index = i * lim[0] + j;
            nodes.push([
                -secondsToRadians(longitudeOffsetBand[index]),
                secondsToRadians(latitudeOffsetBand[index])
            ]);
        }
        subgrids.push({
            del: del,
            lim: lim,
            ll: [
                -maxX,
                minY
            ],
            cvs: nodes
        });
    }
    var tifGrid = {
        header: {
            nSubgrids: subGridCount
        },
        subgrids: subgrids
    };
    loadedNadgrids[key] = tifGrid;
    return tifGrid;
}
function getNadgrids(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(',');
    return grids.map(parseNadgridString);
}
/**
 * @param {string} value The nadgrid string to get information for.
 * @returns {NadgridInfo|null} An object with grid information, or null if the input is empty.
 */ function parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === '@';
    if (optional) value = value.slice(1);
    if (value === 'null') return {
        name: 'null',
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: loadedNadgrids[value] || null,
        isNull: false
    };
}
function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}
function secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
    return true;
}
function readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function readSubgrids(view, header, isLittleEndian, includeErrorFields) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = readGridNodes(view, gridOffset, subHeader, isLittleEndian, includeErrorFields);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                secondsToRadians(subHeader.lowerLongitude),
                secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                secondsToRadians(subHeader.longitudeInterval),
                secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: mapNodes(nodes)
        });
        var rowSize = 16;
        if (includeErrorFields === false) rowSize = 8;
        gridOffset += 176 + subHeader.gridNodeCount * rowSize;
    }
    return grids;
}
/**
 * @param {*} nodes
 * @returns Array<Array<number>>
 */ function mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            secondsToRadians(r.longitudeShift),
            secondsToRadians(r.latitudeShift)
        ];
    });
}
function readGridHeader(view, offset, isLittleEndian) {
    return {
        name: decodeString(view, offset + 8, offset + 16).trim(),
        parent: decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function readGridNodes(view, offset, gridHeader, isLittleEndian, includeErrorFields) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    if (includeErrorFields === false) gridRecordLength = 8;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian)
        };
        if (includeErrorFields !== false) {
            record.latitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian);
            record.longitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian);
        }
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1wQLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Internal transform: accepts an already-cloned point object, returns transformed point object.
 * @param {import('./defs').ProjectionDefinition} source
 * @param {import('./defs').ProjectionDefinition} dest
 * @param {import('./core').InterfaceCoordinates} point
 * @param {boolean} [enforceAxis]
 * @returns {import('./core').InterfaceCoordinates | undefined}
 */ parcelHelpers.export(exports, "transformInternal", ()=>transformInternal);
parcelHelpers.export(exports, "default", ()=>transform);
var _values = require("./constants/values");
var _datumTransform = require("./datum_transform");
var _datumTransformDefault = parcelHelpers.interopDefault(_datumTransform);
var _adjustLon = require("./common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _adjustAxis = require("./adjust_axis");
var _proj = require("./Proj");
var _projDefault = parcelHelpers.interopDefault(_proj);
var _toPoint = require("./common/toPoint");
var _toPointDefault = parcelHelpers.interopDefault(_toPoint);
var _checkSanity = require("./checkSanity");
var _checkSanityDefault = parcelHelpers.interopDefault(_checkSanity);
function checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, _values.PJD_3PARAM) || source.datum.datum_type === (0, _values.PJD_7PARAM) || source.datum.datum_type === (0, _values.PJD_GRIDSHIFT)) && dest.datumCode !== 'WGS84' || (dest.datum.datum_type === (0, _values.PJD_3PARAM) || dest.datum.datum_type === (0, _values.PJD_7PARAM) || dest.datum.datum_type === (0, _values.PJD_GRIDSHIFT)) && source.datumCode !== 'WGS84';
}
function transformInternal(source, dest, point, enforceAxis) {
    var wgs84;
    var hasZ = point.z !== undefined;
    (0, _checkSanityDefault.default)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && checkNotWGS(source, dest)) {
        wgs84 = new (0, _projDefault.default)('WGS84');
        point = transformInternal(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== 'enu') point = (0, _adjustAxis.adjustAxisToEnu)(source, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === 'longlat') point = {
        x: point.x * (0, _values.D2R),
        y: point.y * (0, _values.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, _datumTransformDefault.default)(source.datum, dest.datum, point);
    if (!point) return;
    /** @type {import('./core').InterfaceCoordinates} */ point;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === 'longlat') {
        // wrap longitude into the range centered on dest.long_wrap, if requested (+lon_wrap)
        if (dest.long_wrap !== undefined) point.x = dest.long_wrap + (0, _adjustLonDefault.default)(point.x - dest.long_wrap);
        // convert radians to decimal degrees
        point = {
            x: point.x * (0, _values.R2D),
            y: point.y * (0, _values.R2D),
            z: point.z || 0
        };
    } else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== 'enu') return (0, _adjustAxis.adjustAxisFromEnu)(dest, point);
    if (point && !hasZ && dest.projName !== 'geocent') delete point.z;
    return point;
}
function transform(source, dest, point, enforceAxis) {
    var pt;
    if (Array.isArray(point)) pt = (0, _toPointDefault.default)(point);
    else // Clone the point object so inputs don't get modified
    pt = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
    };
    return transformInternal(source, dest, pt, enforceAxis);
}

},{"./constants/values":"8tAZZ","./datum_transform":"1qJZx","./common/adjust_lon":"l07Jx","./adjust_axis":"gzzIu","./Proj":"fIBov","./common/toPoint":"gQMMx","./checkSanity":"dSq22","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1qJZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(source, dest, point) {
        // Short cut if the datums are identical.
        if ((0, _datumUtils.compareDatums)(source, dest)) return point; // in this case, zero is sucess,
        // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
        if (source.datum_type === (0, _values.PJD_NODATUM) || dest.datum_type === (0, _values.PJD_NODATUM)) return point;
        // If this datum requires grid shifts, then apply it to geodetic coordinates.
        var source_a = source.a;
        var source_es = source.es;
        if (source.datum_type === (0, _values.PJD_GRIDSHIFT)) {
            var gridShiftCode = applyGridShift(source, false, point);
            if (gridShiftCode !== 0) return undefined;
            source_a = (0, _values.SRS_WGS84_SEMIMAJOR);
            source_es = (0, _values.SRS_WGS84_ESQUARED);
        }
        var dest_a = dest.a;
        var dest_b = dest.b;
        var dest_es = dest.es;
        if (dest.datum_type === (0, _values.PJD_GRIDSHIFT)) {
            dest_a = (0, _values.SRS_WGS84_SEMIMAJOR);
            dest_b = (0, _values.SRS_WGS84_SEMIMINOR);
            dest_es = (0, _values.SRS_WGS84_ESQUARED);
        }
        // Do we need to go through geocentric coordinates?
        if (source_es === dest_es && source_a === dest_a && !checkParams(source.datum_type) && !checkParams(dest.datum_type)) return point;
        // Convert to geocentric coordinates.
        point = (0, _datumUtils.geodeticToGeocentric)(point, source_es, source_a);
        // Convert between datums
        if (checkParams(source.datum_type)) point = (0, _datumUtils.geocentricToWgs84)(point, source.datum_type, source.datum_params);
        if (checkParams(dest.datum_type)) point = (0, _datumUtils.geocentricFromWgs84)(point, dest.datum_type, dest.datum_params);
        point = (0, _datumUtils.geocentricToGeodetic)(point, dest_es, dest_a, dest_b);
        if (dest.datum_type === (0, _values.PJD_GRIDSHIFT)) {
            var destGridShiftResult = applyGridShift(dest, true, point);
            if (destGridShiftResult !== 0) return undefined;
        }
        return point;
    });
parcelHelpers.export(exports, "applyGridShift", ()=>applyGridShift);
var _values = require("./constants/values");
var _datumUtils = require("./datumUtils");
var _adjustLon = require("./common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
function checkParams(type) {
    return type === (0, _values.PJD_3PARAM) || type === (0, _values.PJD_7PARAM);
}
function applyGridShift(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log('Grid shift grids not found');
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var attemptedGrids = [];
    outer: for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log('Unable to find mandatory grid \'' + grid.name + '\'');
                return -1;
            }
            continue;
        }
        var subgrids = grid.grid.subgrids;
        for(var j = 0, jj = subgrids.length; j < jj; j++){
            var subgrid = subgrids[j];
            // skip tables that don't match our point at all
            var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
            var minX = subgrid.ll[0] - epsilon;
            var minY = subgrid.ll[1] - epsilon;
            var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
            var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
            if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
            output = applySubgridShift(input, inverse, subgrid);
            if (!isNaN(output.x)) break outer;
        }
    }
    if (isNaN(output.x)) {
        console.log('Failed to find a grid shift table for location \'' + -input.x * (0, _values.R2D) + ' ' + input.y * (0, _values.R2D) + ' tried: \'' + attemptedGrids + '\'');
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, _adjustLonDefault.default)(tb.x - Math.PI) + Math.PI;
    var t = nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log('Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.');
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log('Inverse grid shift iterator failed to converge.');
            return val;
        }
        val.x = (0, _adjustLonDefault.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}

},{"./constants/values":"8tAZZ","./datumUtils":"kslr6","./common/adjust_lon":"l07Jx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kslr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareDatums", ()=>compareDatums) // cs_compare_datums()
;
/*
 * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
 * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
 * according to the current ellipsoid parameters.
 *
 *    Latitude  : Geodetic latitude in radians                     (input)
 *    Longitude : Geodetic longitude in radians                    (input)
 *    Height    : Geodetic height, in meters                       (input)
 *    X         : Calculated Geocentric X coordinate, in meters    (output)
 *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
 *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
 *
 */ parcelHelpers.export(exports, "geodeticToGeocentric", ()=>geodeticToGeocentric) // cs_geodetic_to_geocentric()
;
parcelHelpers.export(exports, "geocentricToGeodetic", ()=>geocentricToGeodetic) // cs_geocentric_to_geodetic()
;
/****************************************************************/ // pj_geocentic_to_wgs84( p )
//  p = point to transform in geocentric coordinates (x,y,z)
/** point object, nothing fancy, just allows values to be
    passed back and forth by reference rather than by value.
    Other point classes may be used as long as they have
    x and y properties, which will get modified in the transform method.
*/ parcelHelpers.export(exports, "geocentricToWgs84", ()=>geocentricToWgs84) // cs_geocentric_to_wgs84
;
/****************************************************************/ // pj_geocentic_from_wgs84()
//  coordinate system definition,
//  point to transform in geocentric coordinates (x,y,z)
parcelHelpers.export(exports, "geocentricFromWgs84", ()=>geocentricFromWgs84);
var _values = require("./constants/values");
'use strict';
function compareDatums(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, _values.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, _values.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
}
function geodeticToGeocentric(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; // Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, _values.HALF_PI) && Latitude > -1.001 * (0, _values.HALF_PI)) Latitude = -(0, _values.HALF_PI);
    else if (Latitude > (0, _values.HALF_PI) && Latitude < 1.001 * (0, _values.HALF_PI)) Latitude = (0, _values.HALF_PI);
    else if (Latitude < -(0, _values.HALF_PI)) /* Latitude out of range */ // ..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, _values.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
}
function geocentricToGeodetic(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; // Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, _values.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
}
function geocentricToWgs84(p, datum_type, datum_params) {
    if (datum_type === (0, _values.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, _values.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
}
function geocentricFromWgs84(p, datum_type, datum_params) {
    if (datum_type === (0, _values.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, _values.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } // cs_geocentric_from_wgs84()
}

},{"./constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gzzIu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert a point in a given CRS axis order to ENU (east/north/up) order
 * @param {import('./defs').ProjectionDefinition} crs
 * @param {import('./core').InterfaceCoordinates} point
 * @returns {import('./core').InterfaceCoordinates | null}
 */ parcelHelpers.export(exports, "adjustAxisToEnu", ()=>adjustAxisToEnu);
/**
 * Convert a point in ENU (east/north/up) order to the given CRS axis order.
 * @param {import('./defs').ProjectionDefinition} crs
 * @param {import('./core').InterfaceCoordinates} point
 * @returns {import('./core').InterfaceCoordinates | null}
 */ parcelHelpers.export(exports, "adjustAxisFromEnu", ()=>adjustAxisFromEnu);
var order = [
    'x',
    'y',
    'z'
];
function adjustAxisToEnu(crs, point) {
    /** @type {import("./core").InterfaceCoordinates} */ const out = {};
    for(let i = 0, ii = crs.axis.length; i < ii; i++){
        if (i === 2 && point.z === undefined) continue;
        let v = point[order[i]];
        switch(crs.axis[i]){
            case 'e':
                out.x = v;
                break;
            case 'w':
                out.x = -v;
                break;
            case 'n':
                out.y = v;
                break;
            case 's':
                out.y = -v;
                break;
            case 'u':
                out.z = v;
                break;
            case 'd':
                out.z = -v;
                break;
            default:
                // console.log("ERROR: unknown axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}
function adjustAxisFromEnu(crs, point) {
    const out = /** @type {import("./core").InterfaceCoordinates} */ {};
    for(let i = 0, ii = crs.axis.length; i < ii; i++){
        if (i === 2 && point.z === undefined) continue;
        switch(crs.axis[i]){
            case 'e':
                out[order[i]] = point.x;
                break;
            case 'w':
                out[order[i]] = -point.x;
                break;
            case 'n':
                out[order[i]] = point.y;
                break;
            case 's':
                out[order[i]] = -point.y;
                break;
            case 'u':
                out[order[i]] = point.z;
                break;
            case 'd':
                out[order[i]] = -point.z;
                break;
            default:
                // console.log("ERROR: unknown axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gQMMx":[function(require,module,exports,__globalThis) {
/**
 * @param {Array<number>} array
 * @returns {import("../core").InterfaceCoordinates}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array) {
        var out = {
            x: array[0],
            y: array[1]
        };
        if (array.length > 2) out.z = array[2];
        if (array.length > 3) out.m = array[3];
        return out;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dSq22":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(point) {
        checkCoord(point.x);
        checkCoord(point.y);
    });
function checkCoord(num) {
    if (typeof Number.isFinite === 'function') {
        if (Number.isFinite(num)) return;
        throw new TypeError('coordinates must be finite numbers');
    }
    if (typeof num !== 'number' || num !== num || !isFinite(num)) throw new TypeError('coordinates must be finite numbers');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eH5et":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mgrs = require("mgrs");
/**
 * @deprecated v3.0.0 - use proj4.toPoint instead
 * @param {number | import('./core').TemplateCoordinates | string} x
 * @param {number} [y]
 * @param {number} [z]
 */ function Point(x, y, z) {
    if (!(this instanceof Point)) return new Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === 'object') {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === 'string' && typeof y === 'undefined') {
        var coords = x.split(',');
        this.x = parseFloat(coords[0]);
        this.y = parseFloat(coords[1]);
        this.z = parseFloat(coords[2]) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
}
Point.fromMGRS = function(mgrsStr) {
    return new Point((0, _mgrs.toPoint)(mgrsStr));
};
Point.prototype.toMGRS = function(accuracy) {
    return (0, _mgrs.forward)([
        this.x,
        this.y
    ], accuracy);
};
exports.default = Point;

},{"mgrs":"bDcex","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bDcex":[function(require,module,exports,__globalThis) {
/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Conversion of lat/lon to MGRS.
 *
 * @param {object} ll Object literal with lat and lon properties on a
 *     WGS84 ellipsoid.
 * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
 *      100 m, 2 for 1000 m or 1 for 10000 m). Optional, default is 5.
 * @return {string} the MGRS string for the given location and accuracy.
 */ parcelHelpers.export(exports, "forward", ()=>forward);
/**
 * Conversion of MGRS to lat/lon.
 *
 * @param {string} mgrs MGRS string.
 * @return {array} An array with left (longitude), bottom (latitude), right
 *     (longitude) and top (latitude) values in WGS84, representing the
 *     bounding box for the provided MGRS reference.
 */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "toPoint", ()=>toPoint);
var NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';
var A = 65; // A
var I = 73; // I
var O = 79; // O
var V = 86; // V
var Z = 90; // Z
exports.default = {
    forward: forward,
    inverse: inverse,
    toPoint: toPoint
};
function forward(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return encode(LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function inverse(mgrs) {
    var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function toPoint(mgrs) {
    var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = degToRad(Lat);
    var LongRad = degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < 'N') y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = 'Z';
    if (84 >= lat && lat >= 72) LetterDesignator = 'X';
    else if (72 > lat && lat >= 64) LetterDesignator = 'W';
    else if (64 > lat && lat >= 56) LetterDesignator = 'V';
    else if (56 > lat && lat >= 48) LetterDesignator = 'U';
    else if (48 > lat && lat >= 40) LetterDesignator = 'T';
    else if (40 > lat && lat >= 32) LetterDesignator = 'S';
    else if (32 > lat && lat >= 24) LetterDesignator = 'R';
    else if (24 > lat && lat >= 16) LetterDesignator = 'Q';
    else if (16 > lat && lat >= 8) LetterDesignator = 'P';
    else if (8 > lat && lat >= 0) LetterDesignator = 'N';
    else if (0 > lat && lat >= -8) LetterDesignator = 'M';
    else if (-8 > lat && lat >= -16) LetterDesignator = 'L';
    else if (-16 > lat && lat >= -24) LetterDesignator = 'K';
    else if (-24 > lat && lat >= -32) LetterDesignator = 'J';
    else if (-32 > lat && lat >= -40) LetterDesignator = 'H';
    else if (-40 > lat && lat >= -48) LetterDesignator = 'G';
    else if (-48 > lat && lat >= -56) LetterDesignator = 'F';
    else if (-56 > lat && lat >= -64) LetterDesignator = 'E';
    else if (-64 > lat && lat >= -72) LetterDesignator = 'D';
    else if (-72 > lat && lat >= -80) LetterDesignator = 'C';
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function get100kID(easting, northing, zoneNumber) {
    var setParm = get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function get100kSetForZone(i) {
    var setParm = i % NUM_100K_SETS;
    if (setParm === 0) setParm = NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > Z) {
        colInt = colInt - Z + A - 1;
        rollover = true;
    }
    if (colInt === I || colOrigin < I && colInt > I || (colInt > I || colOrigin < I) && rollover) colInt++;
    if (colInt === O || colOrigin < O && colInt > O || (colInt > O || colOrigin < O) && rollover) {
        colInt++;
        if (colInt === I) colInt++;
    }
    if (colInt > Z) colInt = colInt - Z + A - 1;
    if (rowInt > V) {
        rowInt = rowInt - V + A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === I || rowOrigin < I && rowInt > I || (rowInt > I || rowOrigin < I) && rollover) rowInt++;
    if (rowInt === O || rowOrigin < O && rowInt > O || (rowInt > O || rowOrigin < O) && rollover) {
        rowInt++;
        if (rowInt === I) rowInt++;
    }
    if (rowInt > V) rowInt = rowInt - V + A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = get100kSetForZone(zoneNumber);
    var east100k = getEastingFromChar(hunK.charAt(0), set);
    var north100k = getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === I) curCol++;
        if (curCol === O) curCol++;
        if (curCol > Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function getNorthingFromChar(n, set) {
    if (n > 'V') throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === I) curRow++;
        if (curRow === O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case 'C':
            northing = 1100000.0;
            break;
        case 'D':
            northing = 2000000.0;
            break;
        case 'E':
            northing = 2800000.0;
            break;
        case 'F':
            northing = 3700000.0;
            break;
        case 'G':
            northing = 4600000.0;
            break;
        case 'H':
            northing = 5500000.0;
            break;
        case 'J':
            northing = 6400000.0;
            break;
        case 'K':
            northing = 7300000.0;
            break;
        case 'L':
            northing = 8200000.0;
            break;
        case 'M':
            northing = 9100000.0;
            break;
        case 'N':
            northing = 0.0;
            break;
        case 'P':
            northing = 800000.0;
            break;
        case 'Q':
            northing = 1700000.0;
            break;
        case 'R':
            northing = 2600000.0;
            break;
        case 'S':
            northing = 3500000.0;
            break;
        case 'T':
            northing = 4400000.0;
            break;
        case 'U':
            northing = 5300000.0;
            break;
        case 'V':
            northing = 6200000.0;
            break;
        case 'W':
            northing = 7000000.0;
            break;
        case 'X':
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hWgEL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(proj4) {
        proj4.Proj.projections.add((0, _tmercDefault.default));
        proj4.Proj.projections.add((0, _etmercDefault.default));
        proj4.Proj.projections.add((0, _utmDefault.default));
        proj4.Proj.projections.add((0, _stereaDefault.default));
        proj4.Proj.projections.add((0, _stereDefault.default));
        proj4.Proj.projections.add((0, _somercDefault.default));
        proj4.Proj.projections.add((0, _omercDefault.default));
        proj4.Proj.projections.add((0, _lccDefault.default));
        proj4.Proj.projections.add((0, _krovakDefault.default));
        proj4.Proj.projections.add((0, _cassDefault.default));
        proj4.Proj.projections.add((0, _laeaDefault.default));
        proj4.Proj.projections.add((0, _aeaDefault.default));
        proj4.Proj.projections.add((0, _gnomDefault.default));
        proj4.Proj.projections.add((0, _ceaDefault.default));
        proj4.Proj.projections.add((0, _eqcDefault.default));
        proj4.Proj.projections.add((0, _polyDefault.default));
        proj4.Proj.projections.add((0, _nzmgDefault.default));
        proj4.Proj.projections.add((0, _millDefault.default));
        proj4.Proj.projections.add((0, _sinuDefault.default));
        proj4.Proj.projections.add((0, _eck6Default.default));
        proj4.Proj.projections.add((0, _mollDefault.default));
        proj4.Proj.projections.add((0, _eqdcDefault.default));
        proj4.Proj.projections.add((0, _vandgDefault.default));
        proj4.Proj.projections.add((0, _aeqdDefault.default));
        proj4.Proj.projections.add((0, _orthoDefault.default));
        proj4.Proj.projections.add((0, _qscDefault.default));
        proj4.Proj.projections.add((0, _robinDefault.default));
        proj4.Proj.projections.add((0, _geocentDefault.default));
        proj4.Proj.projections.add((0, _tpersDefault.default));
        proj4.Proj.projections.add((0, _geosDefault.default));
        proj4.Proj.projections.add((0, _eqearthDefault.default));
        proj4.Proj.projections.add((0, _bonneDefault.default));
        proj4.Proj.projections.add((0, _obTranDefault.default));
    });
var _tmerc = require("./lib/projections/tmerc");
var _tmercDefault = parcelHelpers.interopDefault(_tmerc);
var _etmerc = require("./lib/projections/etmerc");
var _etmercDefault = parcelHelpers.interopDefault(_etmerc);
var _utm = require("./lib/projections/utm");
var _utmDefault = parcelHelpers.interopDefault(_utm);
var _sterea = require("./lib/projections/sterea");
var _stereaDefault = parcelHelpers.interopDefault(_sterea);
var _stere = require("./lib/projections/stere");
var _stereDefault = parcelHelpers.interopDefault(_stere);
var _somerc = require("./lib/projections/somerc");
var _somercDefault = parcelHelpers.interopDefault(_somerc);
var _omerc = require("./lib/projections/omerc");
var _omercDefault = parcelHelpers.interopDefault(_omerc);
var _lcc = require("./lib/projections/lcc");
var _lccDefault = parcelHelpers.interopDefault(_lcc);
var _krovak = require("./lib/projections/krovak");
var _krovakDefault = parcelHelpers.interopDefault(_krovak);
var _cass = require("./lib/projections/cass");
var _cassDefault = parcelHelpers.interopDefault(_cass);
var _laea = require("./lib/projections/laea");
var _laeaDefault = parcelHelpers.interopDefault(_laea);
var _aea = require("./lib/projections/aea");
var _aeaDefault = parcelHelpers.interopDefault(_aea);
var _gnom = require("./lib/projections/gnom");
var _gnomDefault = parcelHelpers.interopDefault(_gnom);
var _cea = require("./lib/projections/cea");
var _ceaDefault = parcelHelpers.interopDefault(_cea);
var _eqc = require("./lib/projections/eqc");
var _eqcDefault = parcelHelpers.interopDefault(_eqc);
var _poly = require("./lib/projections/poly");
var _polyDefault = parcelHelpers.interopDefault(_poly);
var _nzmg = require("./lib/projections/nzmg");
var _nzmgDefault = parcelHelpers.interopDefault(_nzmg);
var _mill = require("./lib/projections/mill");
var _millDefault = parcelHelpers.interopDefault(_mill);
var _sinu = require("./lib/projections/sinu");
var _sinuDefault = parcelHelpers.interopDefault(_sinu);
var _eck6 = require("./lib/projections/eck6");
var _eck6Default = parcelHelpers.interopDefault(_eck6);
var _moll = require("./lib/projections/moll");
var _mollDefault = parcelHelpers.interopDefault(_moll);
var _eqdc = require("./lib/projections/eqdc");
var _eqdcDefault = parcelHelpers.interopDefault(_eqdc);
var _vandg = require("./lib/projections/vandg");
var _vandgDefault = parcelHelpers.interopDefault(_vandg);
var _aeqd = require("./lib/projections/aeqd");
var _aeqdDefault = parcelHelpers.interopDefault(_aeqd);
var _ortho = require("./lib/projections/ortho");
var _orthoDefault = parcelHelpers.interopDefault(_ortho);
var _qsc = require("./lib/projections/qsc");
var _qscDefault = parcelHelpers.interopDefault(_qsc);
var _robin = require("./lib/projections/robin");
var _robinDefault = parcelHelpers.interopDefault(_robin);
var _geocent = require("./lib/projections/geocent");
var _geocentDefault = parcelHelpers.interopDefault(_geocent);
var _tpers = require("./lib/projections/tpers");
var _tpersDefault = parcelHelpers.interopDefault(_tpers);
var _geos = require("./lib/projections/geos");
var _geosDefault = parcelHelpers.interopDefault(_geos);
var _eqearth = require("./lib/projections/eqearth");
var _eqearthDefault = parcelHelpers.interopDefault(_eqearth);
var _bonne = require("./lib/projections/bonne");
var _bonneDefault = parcelHelpers.interopDefault(_bonne);
var _obTran = require("./lib/projections/ob_tran");
var _obTranDefault = parcelHelpers.interopDefault(_obTran);

},{"./lib/projections/tmerc":"5swGp","./lib/projections/etmerc":"j9KNv","./lib/projections/utm":"izMCX","./lib/projections/sterea":"lXiyn","./lib/projections/stere":"bHKwL","./lib/projections/somerc":"4t852","./lib/projections/omerc":"cehl1","./lib/projections/lcc":"d8I3x","./lib/projections/krovak":"0JYxP","./lib/projections/cass":"cz5zO","./lib/projections/laea":"eNDDw","./lib/projections/aea":"5RWkc","./lib/projections/gnom":"4c0jB","./lib/projections/cea":"gnDHL","./lib/projections/eqc":"cIgzC","./lib/projections/poly":"bsDTr","./lib/projections/nzmg":"i1Prb","./lib/projections/mill":"kP6zr","./lib/projections/sinu":"ic6hZ","./lib/projections/eck6":"lue2D","./lib/projections/moll":"4TIrL","./lib/projections/eqdc":"4k7M9","./lib/projections/vandg":"2kmk9","./lib/projections/aeqd":"dS3hB","./lib/projections/ortho":"aIdnc","./lib/projections/qsc":"4kYLV","./lib/projections/robin":"61r0D","./lib/projections/geocent":"7iJ84","./lib/projections/tpers":"lidQP","./lib/projections/geos":"bx3c7","./lib/projections/eqearth":"d0X1O","./lib/projections/bonne":"h5nVe","./lib/projections/ob_tran":"i3Pld","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5swGp":[function(require,module,exports,__globalThis) {
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} es
 * @property {Array<number>} en
 * @property {number} ml0
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/**
    Transverse Mercator Forward  - long/lat to x/y
    long/lat in radians
  */ parcelHelpers.export(exports, "forward", ()=>forward);
/**
    Transverse Mercator Inverse  -  x/y to long/lat
  */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _pjEnfn = require("../common/pj_enfn");
var _pjEnfnDefault = parcelHelpers.interopDefault(_pjEnfn);
var _pjMlfn = require("../common/pj_mlfn");
var _pjMlfnDefault = parcelHelpers.interopDefault(_pjMlfn);
var _pjInvMlfn = require("../common/pj_inv_mlfn");
var _pjInvMlfnDefault = parcelHelpers.interopDefault(_pjInvMlfn);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _values = require("../constants/values");
var _sign = require("../common/sign");
var _signDefault = parcelHelpers.interopDefault(_sign);
function init() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, _pjEnfnDefault.default)(this.es);
        this.ml0 = (0, _pjMlfnDefault.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, _values.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, _values.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, _values.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, _pjMlfnDefault.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, _adjustLonDefault.default)(Math.atan2(g, h) + this.long0, this.over);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, _pjInvMlfnDefault.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, _values.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, _values.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, _adjustLonDefault.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi, this.over);
        } else {
            lat = (0, _values.HALF_PI) * (0, _signDefault.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Fast_Transverse_Mercator',
    'Fast Transverse Mercator'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/pj_enfn":"a6UY0","../common/pj_mlfn":"gAMYp","../common/pj_inv_mlfn":"kb8Su","../common/adjust_lon":"l07Jx","../constants/values":"8tAZZ","../common/sign":"iFEtg","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"a6UY0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(es) {
        var en = [];
        en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
        en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
        var t = es * es;
        en[2] = t * (C44 - es * (C46 + es * C48));
        t *= es;
        en[3] = t * (C66 - es * C68);
        en[4] = t * es * C88;
        return en;
    });
var C00 = 1;
var C02 = 0.25;
var C04 = 0.046875;
var C06 = 0.01953125;
var C08 = 0.01068115234375;
var C22 = 0.75;
var C44 = 0.46875;
var C46 = 0.01302083333333333333;
var C48 = 0.00712076822916666666;
var C66 = 0.36458333333333333333;
var C68 = 0.00569661458333333333;
var C88 = 0.3076171875;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gAMYp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(phi, sphi, cphi, en) {
        cphi *= sphi;
        sphi *= sphi;
        return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kb8Su":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(arg, es, en) {
        var k = 1 / (1 - es);
        var phi = arg;
        for(var i = MAX_ITER; i; --i){
            var s = Math.sin(phi);
            var t = 1 - es * s * s;
            // t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
            // phi -= t * (t * Math.sqrt(t)) * k;
            t = ((0, _pjMlfnDefault.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
            phi -= t;
            if (Math.abs(t) < (0, _values.EPSLN)) return phi;
        }
        // ..reportError("cass:pj_inv_mlfn: Convergence error");
        return phi;
    });
var _pjMlfn = require("./pj_mlfn");
var _pjMlfnDefault = parcelHelpers.interopDefault(_pjMlfn);
var _values = require("../constants/values");
var MAX_ITER = 20;

},{"./pj_mlfn":"gAMYp","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"j9KNv":[function(require,module,exports,__globalThis) {
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} es
 * @property {Array<number>} cbg
 * @property {Array<number>} cgb
 * @property {Array<number>} utg
 * @property {Array<number>} gtu
 * @property {number} Qn
 * @property {number} Zb
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _tmerc = require("../projections/tmerc");
var _tmercDefault = parcelHelpers.interopDefault(_tmerc);
var _sinh = require("../common/sinh");
var _sinhDefault = parcelHelpers.interopDefault(_sinh);
var _hypot = require("../common/hypot");
var _hypotDefault = parcelHelpers.interopDefault(_hypot);
var _asinhy = require("../common/asinhy");
var _asinhyDefault = parcelHelpers.interopDefault(_asinhy);
var _gatg = require("../common/gatg");
var _gatgDefault = parcelHelpers.interopDefault(_gatg);
var _clens = require("../common/clens");
var _clensDefault = parcelHelpers.interopDefault(_clens);
var _clensCmplx = require("../common/clens_cmplx");
var _clensCmplxDefault = parcelHelpers.interopDefault(_clensCmplx);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, _tmercDefault.default).init.apply(this);
        this.forward = (0, _tmercDefault.default).forward;
        this.inverse = (0, _tmercDefault.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.k0 = this.k0 !== undefined ? this.k0 : 1;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, _gatgDefault.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, _clensDefault.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, _adjustLonDefault.default)(p.x - this.long0, this.over);
    var Cn = p.y;
    Cn = (0, _gatgDefault.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, _hypotDefault.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, _asinhyDefault.default)(Math.tan(Ce));
    var tmp = (0, _clensCmplxDefault.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, _clensCmplxDefault.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, _sinhDefault.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, _hypotDefault.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, _adjustLonDefault.default)(Ce + this.long0, this.over);
        lat = (0, _gatgDefault.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Extended_Transverse_Mercator',
    'Extended Transverse Mercator',
    'etmerc',
    'Transverse_Mercator',
    'Transverse Mercator',
    'Gauss Kruger',
    'Gauss_Kruger',
    'tmerc'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../projections/tmerc":"5swGp","../common/sinh":"dHFrp","../common/hypot":"f4r5Q","../common/asinhy":"fujJZ","../common/gatg":"k05qV","../common/clens":"bZ5PQ","../common/clens_cmplx":"6nffR","../common/adjust_lon":"l07Jx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dHFrp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var r = Math.exp(x);
        r = (r - 1 / r) / 2;
        return r;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"f4r5Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        x = Math.abs(x);
        y = Math.abs(y);
        var a = Math.max(x, y);
        var b = Math.min(x, y) / (a ? a : 1);
        return a * Math.sqrt(1 + Math.pow(b, 2));
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fujJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var y = Math.abs(x);
        y = (0, _log1PyDefault.default)(y * (1 + y / ((0, _hypotDefault.default)(1, y) + 1)));
        return x < 0 ? -y : y;
    });
var _hypot = require("./hypot");
var _hypotDefault = parcelHelpers.interopDefault(_hypot);
var _log1Py = require("./log1py");
var _log1PyDefault = parcelHelpers.interopDefault(_log1Py);

},{"./hypot":"f4r5Q","./log1py":"jDkCG","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jDkCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var y = 1 + x;
        var z = y - 1;
        return z === 0 ? x : x * Math.log(y) / z;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"k05qV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pp, B) {
        var cos_2B = 2 * Math.cos(2 * B);
        var i = pp.length - 1;
        var h1 = pp[i];
        var h2 = 0;
        var h;
        while(--i >= 0){
            h = -h2 + cos_2B * h1 + pp[i];
            h2 = h1;
            h1 = h;
        }
        return B + h * Math.sin(2 * B);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bZ5PQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pp, arg_r) {
        var r = 2 * Math.cos(arg_r);
        var i = pp.length - 1;
        var hr1 = pp[i];
        var hr2 = 0;
        var hr;
        while(--i >= 0){
            hr = -hr2 + r * hr1 + pp[i];
            hr2 = hr1;
            hr1 = hr;
        }
        return Math.sin(arg_r) * hr;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6nffR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pp, arg_r, arg_i) {
        var sin_arg_r = Math.sin(arg_r);
        var cos_arg_r = Math.cos(arg_r);
        var sinh_arg_i = (0, _sinhDefault.default)(arg_i);
        var cosh_arg_i = (0, _coshDefault.default)(arg_i);
        var r = 2 * cos_arg_r * cosh_arg_i;
        var i = -2 * sin_arg_r * sinh_arg_i;
        var j = pp.length - 1;
        var hr = pp[j];
        var hi1 = 0;
        var hr1 = 0;
        var hi = 0;
        var hr2;
        var hi2;
        while(--j >= 0){
            hr2 = hr1;
            hi2 = hi1;
            hr1 = hr;
            hi1 = hi;
            hr = -hr2 + r * hr1 - i * hi1 + pp[j];
            hi = -hi2 + i * hr1 + r * hi1;
        }
        r = sin_arg_r * cosh_arg_i;
        i = cos_arg_r * sinh_arg_i;
        return [
            r * hr - i * hi,
            r * hi + i * hr
        ];
    });
var _sinh = require("./sinh");
var _sinhDefault = parcelHelpers.interopDefault(_sinh);
var _cosh = require("./cosh");
var _coshDefault = parcelHelpers.interopDefault(_cosh);

},{"./sinh":"dHFrp","./cosh":"iG2bv","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iG2bv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var r = Math.exp(x);
        r = (r + 1 / r) / 2;
        return r;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"izMCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dependsOn", ()=>dependsOn);
/** @this {import('../defs.js').ProjectionDefinition} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustZone = require("../common/adjust_zone");
var _adjustZoneDefault = parcelHelpers.interopDefault(_adjustZone);
var _etmerc = require("./etmerc");
var _etmercDefault = parcelHelpers.interopDefault(_etmerc);
var _values = require("../constants/values");
var dependsOn = 'etmerc';
function init() {
    var zone = (0, _adjustZoneDefault.default)(this.zone, this.long0);
    if (zone === undefined) throw new Error('unknown utm zone');
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, _values.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, _etmercDefault.default).init.apply(this);
    this.forward = (0, _etmercDefault.default).forward;
    this.inverse = (0, _etmercDefault.default).inverse;
}
var names = [
    'Universal Transverse Mercator System',
    'utm'
];
exports.default = {
    init: init,
    names: names,
    dependsOn: dependsOn
};

},{"../common/adjust_zone":"2pLKi","./etmerc":"j9KNv","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2pLKi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(zone, lon) {
        if (zone === undefined) {
            zone = Math.floor(((0, _adjustLonDefault.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
            if (zone < 0) return 0;
            else if (zone > 60) return 60;
        }
        return zone;
    });
var _adjustLon = require("./adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);

},{"./adjust_lon":"l07Jx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lXiyn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} sinc0
 * @property {number} cosc0
 * @property {number} R2
 * @property {number} rc
 * @property {number} phic0
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _gauss = require("./gauss");
var _gaussDefault = parcelHelpers.interopDefault(_gauss);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _hypot = require("../common/hypot");
var _hypotDefault = parcelHelpers.interopDefault(_hypot);
function init() {
    (0, _gaussDefault.default).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = 'Oblique Stereographic Alternative';
}
function forward(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, _adjustLonDefault.default)(p.x - this.long0, this.over);
    (0, _gaussDefault.default).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function inverse(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = (0, _hypotDefault.default)(p.x, p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, _gaussDefault.default).inverse.apply(this, [
        p
    ]);
    p.x = (0, _adjustLonDefault.default)(p.x + this.long0, this.over);
    return p;
}
var names = [
    'Stereographic_North_Pole',
    'Oblique_Stereographic',
    'sterea',
    'Oblique Stereographic Alternative',
    'Double_Stereographic'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"./gauss":"6moht","../common/adjust_lon":"l07Jx","../common/hypot":"f4r5Q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6moht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} rc
 * @property {number} C
 * @property {number} phic0
 * @property {number} ratexp
 * @property {number} K
 * @property {number} e
 * @property {number} es
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _srat = require("../common/srat");
var _sratDefault = parcelHelpers.interopDefault(_srat);
var _values = require("../constants/values");
var MAX_ITER = 20;
function init() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, _values.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, _values.FORTPI)), this.C) * (0, _sratDefault.default)(this.e * sphi, this.ratexp));
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, _values.FORTPI)), this.C) * (0, _sratDefault.default)(this.e * Math.sin(lat), this.ratexp)) - (0, _values.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function inverse(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, _values.FORTPI)) / this.K, 1 / this.C);
    for(var i = MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, _sratDefault.default)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, _values.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'gauss'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/srat":"kmwKx","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kmwKx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(esinp, exp) {
        return Math.pow((1 - esinp) / (1 + esinp), exp);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bHKwL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} coslat0
 * @property {number} sinlat0
 * @property {number} ms1
 * @property {number} X0
 * @property {number} cosX0
 * @property {number} sinX0
 * @property {number} con
 * @property {number} cons
 * @property {number} e
 */ parcelHelpers.export(exports, "ssfn_", ()=>ssfn_);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
// Stereographic forward equations--mapping lat,long to x,y
parcelHelpers.export(exports, "forward", ()=>forward);
//* Stereographic inverse equations--mapping x,y to lat/long
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _values = require("../constants/values");
var _sign = require("../common/sign");
var _signDefault = parcelHelpers.interopDefault(_sign);
var _msfnz = require("../common/msfnz");
var _msfnzDefault = parcelHelpers.interopDefault(_msfnz);
var _tsfnz = require("../common/tsfnz");
var _tsfnzDefault = parcelHelpers.interopDefault(_tsfnz);
var _phi2Z = require("../common/phi2z");
var _phi2ZDefault = parcelHelpers.interopDefault(_phi2Z);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
function ssfn_(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, _values.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function init() {
    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (!isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, _values.EPSLN)) this.k0 = 0.5 * (1 + (0, _signDefault.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, _values.EPSLN)) {
            if (this.lat0 > 0) // North pole
            // trace('stere:north pole');
            this.con = 1;
            else // South pole
            // trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (!isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, _values.EPSLN) && Math.abs(Math.cos(this.lat_ts)) > (0, _values.EPSLN)) // Polar Stereographic variant B: k0 is derived from lat_ts (EPSG guidance note 7-2, method 9829)
        // https://epsg.org/coord-operation-method_9829/Polar-Stereographic-variant-B.html
        this.k0 = 0.5 * this.cons * (0, _msfnzDefault.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, _tsfnzDefault.default)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, _msfnzDefault.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan(ssfn_(this.lat0, this.sinlat0, this.e)) - (0, _values.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, _values.EPSLN) && Math.abs(lat + this.lat0) <= (0, _values.EPSLN)) {
        // case of the origine point
        // trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        // trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan(ssfn_(lat, sinlat, this.e)) - (0, _values.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, _values.EPSLN)) {
            ts = (0, _tsfnzDefault.default)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            // trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, _values.EPSLN)) {
            // Eq
            // trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            // other case
            // trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    // trace(p.toString());
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, _values.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, _values.EPSLN)) {
            if (this.lat0 > 0) lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            else lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
        } else lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, _values.EPSLN)) {
        if (rh <= (0, _values.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            // trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, _phi2ZDefault.default)(this.e, ts);
        lon = this.con * (0, _adjustLonDefault.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, _values.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)), this.over);
        }
        lat = -1 * (0, _phi2ZDefault.default)(this.e, Math.tan(0.5 * ((0, _values.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    // trace(p.toString());
    return p;
}
var names = [
    'stere',
    'Stereographic_South_Pole',
    'Polar_Stereographic_variant_A',
    'Polar_Stereographic_variant_B',
    'Polar_Stereographic'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    ssfn_: ssfn_
};

},{"../constants/values":"8tAZZ","../common/sign":"iFEtg","../common/msfnz":"aVAwM","../common/tsfnz":"8z6AD","../common/phi2z":"623YG","../common/adjust_lon":"l07Jx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4t852":[function(require,module,exports,__globalThis) {
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ /**
 * @typedef {Object} LocalThis
 * @property {number} lambda0
 * @property {number} e
 * @property {number} R
 * @property {number} b0
 * @property {number} K
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
function init() {
    if (!this.k0) this.k0 = 1;
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function forward(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function inverse(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) // ...reportError("omercFwdInfinity");
        return;
        // S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var names = [
    'somerc'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cehl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Initialize the Oblique Mercator  projection
 * @this {import('../defs.js').ProjectionDefinition & LocalThis}
 */ parcelHelpers.export(exports, "init", ()=>init);
/* Oblique Mercator forward equations--mapping lat,long to x,y
    ---------------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _tsfnz = require("../common/tsfnz");
var _tsfnzDefault = parcelHelpers.interopDefault(_tsfnz);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _phi2Z = require("../common/phi2z");
var _phi2ZDefault = parcelHelpers.interopDefault(_phi2Z);
var _values = require("../constants/values");
var _projections = require("../projections");
/**
 * @typedef {Object} LocalThis
 * @property {boolean} no_off
 * @property {boolean} no_rot
 * @property {number} rectified_grid_angle
 * @property {number} es
 * @property {number} A
 * @property {number} B
 * @property {number} E
 * @property {number} e
 * @property {number} lam0
 * @property {number} singam
 * @property {number} cosgam
 * @property {number} sinrot
 * @property {number} cosrot
 * @property {number} rB
 * @property {number} ArB
 * @property {number} BrA
 * @property {number} u_0
 * @property {number} v_pole_n
 * @property {number} v_pole_s
 */ var TOL = 1e-7;
function isTypeA(P) {
    var typeAProjections = [
        'Hotine_Oblique_Mercator',
        'Hotine_Oblique_Mercator_variant_A',
        'Hotine_Oblique_Mercator_Azimuth_Natural_Origin'
    ];
    var projectionName = typeof P.projName === 'object' ? Object.keys(P.projName)[0] : P.projName;
    return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1 || typeAProjections.indexOf((0, _projections.getNormalizedProjName)(projectionName)) !== -1;
}
function init() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
    if (!this.k0) this.k0 = 1;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = isTypeA(this);
    this.no_rot = 'no_rot' in this;
    var alp = false;
    if ('alpha' in this) alp = true;
    var gam = false;
    if ('rectified_grid_angle' in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) {
        gamma = this.rectified_grid_angle;
        if (!alp) {
            alpha_c = 0;
            alp = true;
        }
    }
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= TOL || (con = Math.abs(phi1)) <= TOL || Math.abs(con - (0, _values.HALF_PI)) <= TOL || Math.abs(Math.abs(this.lat0) - (0, _values.HALF_PI)) <= TOL || Math.abs(Math.abs(phi2) - (0, _values.HALF_PI)) <= TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, _values.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, _tsfnzDefault.default)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, _tsfnzDefault.default)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, _tsfnzDefault.default)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.PI) lam2 -= (0, _values.TWO_PI);
        else if (con > Math.PI) lam2 += (0, _values.TWO_PI);
        this.lam0 = (0, _adjustLonDefault.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B, this.over);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, _adjustLonDefault.default)(lam1 - this.lam0, this.over)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, _values.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, _values.FORTPI) + F));
}
function forward(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, _values.HALF_PI)) > (0, _values.EPSLN)) {
        W = this.E / Math.pow((0, _tsfnzDefault.default)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, _values.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function inverse(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, _values.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, _values.HALF_PI) : (0, _values.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, _phi2ZDefault.default)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var names = [
    'Hotine_Oblique_Mercator',
    'Hotine Oblique Mercator',
    'Hotine_Oblique_Mercator_variant_A',
    'Hotine_Oblique_Mercator_Variant_B',
    'Hotine_Oblique_Mercator_Azimuth_Natural_Origin',
    'Hotine_Oblique_Mercator_Two_Point_Natural_Origin',
    'Hotine_Oblique_Mercator_Azimuth_Center',
    'Oblique_Mercator',
    'omerc'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/tsfnz":"8z6AD","../common/adjust_lon":"l07Jx","../common/phi2z":"623YG","../constants/values":"8tAZZ","../projections":"3oYp6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"d8I3x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} e
 * @property {number} ns
 * @property {number} f0
 * @property {number} rh
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
// Lambert Conformal conic forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
parcelHelpers.export(exports, "forward", ()=>forward);
// Lambert Conformal Conic inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _msfnz = require("../common/msfnz");
var _msfnzDefault = parcelHelpers.interopDefault(_msfnz);
var _tsfnz = require("../common/tsfnz");
var _tsfnzDefault = parcelHelpers.interopDefault(_tsfnz);
var _sign = require("../common/sign");
var _signDefault = parcelHelpers.interopDefault(_sign);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _phi2Z = require("../common/phi2z");
var _phi2ZDefault = parcelHelpers.interopDefault(_phi2Z);
var _values = require("../constants/values");
function init() {
    // double lat0;                    /* the reference latitude               */
    // double long0;                   /* the reference longitude              */
    // double lat1;                    /* first standard parallel              */
    // double lat2;                    /* second standard parallel             */
    // double r_maj;                   /* major axis                           */
    // double r_min;                   /* minor axis                           */
    // double false_east;              /* x offset in meters                   */
    // double false_north;             /* y offset in meters                   */
    // the above value can be set with proj4.defs
    // example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     // if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, _values.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, _msfnzDefault.default)(this.e, sin1, cos1);
    var ts1 = (0, _tsfnzDefault.default)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, _msfnzDefault.default)(this.e, sin2, cos2);
    var ts2 = (0, _tsfnzDefault.default)(this.e, this.lat2, sin2);
    var ts0 = (0, _tsfnzDefault.default)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, _values.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = Math.abs(Math.abs(this.lat0) - (0, _values.HALF_PI)) < (0, _values.EPSLN) ? 0 // Handle poles by setting rh to 0
     : this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = 'Lambert Conformal Conic';
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, _values.EPSLN)) lat = (0, _signDefault.default)(lat) * ((0, _values.HALF_PI) - 2 * (0, _values.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, _values.HALF_PI));
    var ts, rh1;
    if (con > (0, _values.EPSLN)) {
        ts = (0, _tsfnzDefault.default)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function inverse(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, _phi2ZDefault.default)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, _values.HALF_PI);
    lon = (0, _adjustLonDefault.default)(theta / this.ns + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Lambert Tangential Conformal Conic Projection',
    'Lambert_Conformal_Conic',
    'Lambert_Conformal_Conic_1SP',
    'Lambert_Conformal_Conic_2SP',
    'lcc',
    'Lambert Conic Conformal (1SP)',
    'Lambert Conic Conformal (2SP)'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/msfnz":"aVAwM","../common/tsfnz":"8z6AD","../common/sign":"iFEtg","../common/adjust_lon":"l07Jx","../common/phi2z":"623YG","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"0JYxP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
/* ellipsoid */ /* calculate xy from lat/lon */ /* Constants, identical to inverse transform function */ parcelHelpers.export(exports, "forward", ()=>forward);
/* calculate lat/lon from xy */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
function init() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251; // 42.5° from Ferro = 24.833° from Greenwich
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function forward(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function inverse(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x */ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var names = [
    'Krovak',
    'Krovak Modified',
    'Krovak (North Orientated)',
    'Krovak Modified (North Orientated)',
    'krovak'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cz5zO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} es
 * @property {number} e0
 * @property {number} e1
 * @property {number} e2
 * @property {number} e3
 * @property {number} ml0
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/* Cassini forward equations--mapping lat,long to x,y
  ----------------------------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
/* Inverse equations
  ----------------- */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _mlfn = require("../common/mlfn");
var _mlfnDefault = parcelHelpers.interopDefault(_mlfn);
var _e0Fn = require("../common/e0fn");
var _e0FnDefault = parcelHelpers.interopDefault(_e0Fn);
var _e1Fn = require("../common/e1fn");
var _e1FnDefault = parcelHelpers.interopDefault(_e1Fn);
var _e2Fn = require("../common/e2fn");
var _e2FnDefault = parcelHelpers.interopDefault(_e2Fn);
var _e3Fn = require("../common/e3fn");
var _e3FnDefault = parcelHelpers.interopDefault(_e3Fn);
var _gN = require("../common/gN");
var _gNDefault = parcelHelpers.interopDefault(_gN);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _adjustLat = require("../common/adjust_lat");
var _adjustLatDefault = parcelHelpers.interopDefault(_adjustLat);
var _imlfn = require("../common/imlfn");
var _imlfnDefault = parcelHelpers.interopDefault(_imlfn);
var _values = require("../constants/values");
function init() {
    if (!this.sphere) {
        this.e0 = (0, _e0FnDefault.default)(this.es);
        this.e1 = (0, _e1FnDefault.default)(this.es);
        this.e2 = (0, _e2FnDefault.default)(this.es);
        this.e3 = (0, _e3FnDefault.default)(this.es);
        this.ml0 = this.a * (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      ----------------- */ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, _adjustLonDefault.default)(lam - this.long0, this.over);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        // ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, _gNDefault.default)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, _imlfnDefault.default)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, _values.HALF_PI)) <= (0, _values.EPSLN)) {
            p.x = this.long0;
            p.y = (0, _values.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, _gNDefault.default)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, _adjustLonDefault.default)(lam + this.long0, this.over);
    p.y = (0, _adjustLatDefault.default)(phi);
    return p;
}
var names = [
    'Cassini',
    'Cassini_Soldner',
    'cass'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/mlfn":"h0pMr","../common/e0fn":"eEUN4","../common/e1fn":"7mVOn","../common/e2fn":"ckc0u","../common/e3fn":"22vbx","../common/gN":"4k9Xp","../common/adjust_lon":"l07Jx","../common/adjust_lat":"6bp2t","../common/imlfn":"8v9HT","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"h0pMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(e0, e1, e2, e3, phi) {
        return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eEUN4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7mVOn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ckc0u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return 0.05859375 * x * x * (1 + 0.75 * x);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"22vbx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x * x * x * (35 / 3072);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4k9Xp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, e, sinphi) {
        var temp = e * sinphi;
        return a / Math.sqrt(1 - temp * temp);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6bp2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x) < (0, _values.HALF_PI) ? x : x - (0, _signDefault.default)(x) * Math.PI;
    });
var _values = require("../constants/values");
var _sign = require("./sign");
var _signDefault = parcelHelpers.interopDefault(_sign);

},{"../constants/values":"8tAZZ","./sign":"iFEtg","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8v9HT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ml, e0, e1, e2, e3) {
        var phi;
        var dphi;
        phi = ml / e0;
        for(var i = 0; i < 15; i++){
            dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
            phi += dphi;
            if (Math.abs(dphi) <= 0.0000000001) return phi;
        }
        // ..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
        return NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eNDDw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S_POLE", ()=>S_POLE);
parcelHelpers.export(exports, "N_POLE", ()=>N_POLE);
parcelHelpers.export(exports, "EQUIT", ()=>EQUIT);
parcelHelpers.export(exports, "OBLIQ", ()=>OBLIQ);
/**
 * Initialize the Lambert Azimuthal Equal Area projection
 * @this {import('../defs.js').ProjectionDefinition & LocalThis}
 */ parcelHelpers.export(exports, "init", ()=>init);
/* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
  ----------------------------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
/* Inverse equations
  ----------------- */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _values = require("../constants/values");
var _qsfnz = require("../common/qsfnz");
var _qsfnzDefault = parcelHelpers.interopDefault(_qsfnz);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _authset = require("../common/authset");
var _authsetDefault = parcelHelpers.interopDefault(_authset);
var _authlat = require("../common/authlat");
var _authlatDefault = parcelHelpers.interopDefault(_authlat);
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, _values.HALF_PI)) < (0, _values.EPSLN)) this.mode = this.lat0 < 0 ? S_POLE : N_POLE;
    else if (Math.abs(t) < (0, _values.EPSLN)) this.mode = EQUIT;
    else this.mode = OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, _qsfnzDefault.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = (0, _authsetDefault.default)(this.es);
        switch(this.mode){
            case N_POLE:
                this.dd = 1;
                break;
            case S_POLE:
                this.dd = 1;
                break;
            case EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, _qsfnzDefault.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      ----------------- */ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, _adjustLonDefault.default)(lam - this.long0, this.over);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, _values.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, _values.EPSLN)) return null;
            y = (0, _values.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, _qsfnzDefault.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, _values.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, _values.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, _values.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, _values.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, _values.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, _values.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, _values.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, _values.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = (0, _authlatDefault.default)(Math.asin(ab), this.apa);
    }
    p.x = (0, _adjustLonDefault.default)(this.long0 + lam, this.over);
    p.y = phi;
    return p;
}
var names = [
    'Lambert Azimuthal Equal Area',
    'Lambert_Azimuthal_Equal_Area',
    'laea'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

},{"../constants/values":"8tAZZ","../common/qsfnz":"gS1NK","../common/adjust_lon":"l07Jx","../common/authset":"kEmwX","../common/authlat":"lhb6p","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gS1NK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(eccent, sinphi) {
        var con;
        if (eccent > 1.0e-7) {
            con = eccent * sinphi;
            return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        } else return 2 * sinphi;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kEmwX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>authset);
var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lhb6p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>authlat);
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5RWkc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} temp
 * @property {number} es
 * @property {number} e3
 * @property {number} sin_po
 * @property {number} cos_po
 * @property {number} t1
 * @property {number} con
 * @property {number} ms1
 * @property {number} qs1
 * @property {number} t2
 * @property {number} ms2
 * @property {number} qs2
 * @property {number} t3
 * @property {number} qs0
 * @property {number} ns0
 * @property {number} c
 * @property {number} rh
 * @property {number} sin_phi
 * @property {number} cos_phi
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/* Albers Conical Equal Area forward equations--mapping lat,long to x,y
  ------------------------------------------------------------------- */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
/* Function to compute phi1, the latitude for the inverse of the
   Albers Conical Equal-Area projection.
------------------------------------------- */ parcelHelpers.export(exports, "phi1z", ()=>phi1z);
parcelHelpers.export(exports, "names", ()=>names);
var _msfnz = require("../common/msfnz");
var _msfnzDefault = parcelHelpers.interopDefault(_msfnz);
var _qsfnz = require("../common/qsfnz");
var _qsfnzDefault = parcelHelpers.interopDefault(_qsfnz);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _asinz = require("../common/asinz");
var _asinzDefault = parcelHelpers.interopDefault(_asinz);
var _values = require("../constants/values");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, _values.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, _msfnzDefault.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, _qsfnzDefault.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, _msfnzDefault.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, _qsfnzDefault.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, _qsfnzDefault.default)(this.e3, this.sin_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, _values.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, _qsfnzDefault.default)(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, _adjustLonDefault.default)(theta / this.ns0 + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, _asinzDefault.default)(0.5 * qs);
    if (eccent < (0, _values.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    'Albers_Conic_Equal_Area',
    'Albers_Equal_Area',
    'Albers',
    'aea'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

},{"../common/msfnz":"aVAwM","../common/qsfnz":"gS1NK","../common/adjust_lon":"l07Jx","../common/asinz":"aJap8","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aJap8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
        return Math.asin(x);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4c0jB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} sin_p14
 * @property {number} cos_p14
 * @property {number} infinity_dist
 * @property {number} rc
 */ /**
  reference:
    Wolfram Mathworld "Gnomonic Projection"
    http://mathworld.wolfram.com/GnomonicProjection.html
    Accessed: 12th November 2009
   @this {import('../defs.js').ProjectionDefinition & LocalThis}
 */ parcelHelpers.export(exports, "init", ()=>init);
/* Gnomonic forward equations--mapping lat,long to x,y
    --------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _asinz = require("../common/asinz");
var _asinzDefault = parcelHelpers.interopDefault(_asinz);
var _values = require("../constants/values");
function init() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function forward(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, _values.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, _asinzDefault.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, _adjustLonDefault.default)(this.long0 + lon, this.over);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'gnom'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../common/asinz":"aJap8","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gnDHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} e
 */ /**
  reference:
    "Cartographic Projection Procedures for the UNIX Environment-
    A User's Manual" by Gerald I. Evenden,
    USGS Open File Report 90-284and Release 4 Interim Reports (2003)
  @this {import('../defs.js').ProjectionDefinition & LocalThis}
*/ parcelHelpers.export(exports, "init", ()=>init);
/* Cylindrical Equal Area forward equations--mapping lat,long to x,y
    ------------------------------------------------------------ */ parcelHelpers.export(exports, "forward", ()=>forward);
/* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------ */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _qsfnz = require("../common/qsfnz");
var _qsfnzDefault = parcelHelpers.interopDefault(_qsfnz);
var _msfnz = require("../common/msfnz");
var _msfnzDefault = parcelHelpers.interopDefault(_msfnz);
var _iqsfnz = require("../common/iqsfnz");
var _iqsfnzDefault = parcelHelpers.interopDefault(_iqsfnz);
function init() {
    // no-op
    if (!this.sphere) this.k0 = (0, _msfnzDefault.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      ----------------- */ var dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, _qsfnzDefault.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, _adjustLonDefault.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts), this.over);
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, _iqsfnzDefault.default)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, _adjustLonDefault.default)(this.long0 + p.x / (this.a * this.k0), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'cea'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../common/qsfnz":"gS1NK","../common/msfnz":"aVAwM","../common/iqsfnz":"j1wVh","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"j1wVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(eccent, q) {
        var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
        if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
            if (q < 0) return -1 * (0, _values.HALF_PI);
            else return 0, _values.HALF_PI;
        }
        // var phi = 0.5* q/(1-eccent*eccent);
        var phi = Math.asin(0.5 * q);
        var dphi;
        var sin_phi;
        var cos_phi;
        var con;
        for(var i = 0; i < 30; i++){
            sin_phi = Math.sin(phi);
            cos_phi = Math.cos(phi);
            con = eccent * sin_phi;
            dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
            phi += dphi;
            if (Math.abs(dphi) <= 0.0000000001) return phi;
        }
        // console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
        return NaN;
    });
var _values = require("../constants/values");

},{"../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cIgzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
// forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
parcelHelpers.export(exports, "forward", ()=>forward);
// inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _adjustLat = require("../common/adjust_lat");
var _adjustLatDefault = parcelHelpers.interopDefault(_adjustLat);
function init() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Equidistant Cylindrical (Plate Carre)';
    this.rc = Math.cos(this.lat_ts);
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var dlat = (0, _adjustLatDefault.default)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function inverse(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, _adjustLonDefault.default)(this.long0 + (x - this.x0) / (this.a * this.rc), this.over);
    p.y = (0, _adjustLatDefault.default)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var names = [
    'Equirectangular',
    'Equidistant_Cylindrical',
    'Equidistant_Cylindrical_Spherical',
    'eqc'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../common/adjust_lat":"6bp2t","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bsDTr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/* Polyconic forward equations--mapping lat,long to x,y
    --------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
/* Inverse equations
  ----------------- */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _e0Fn = require("../common/e0fn");
var _e0FnDefault = parcelHelpers.interopDefault(_e0Fn);
var _e1Fn = require("../common/e1fn");
var _e1FnDefault = parcelHelpers.interopDefault(_e1Fn);
var _e2Fn = require("../common/e2fn");
var _e2FnDefault = parcelHelpers.interopDefault(_e2Fn);
var _e3Fn = require("../common/e3fn");
var _e3FnDefault = parcelHelpers.interopDefault(_e3Fn);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _adjustLat = require("../common/adjust_lat");
var _adjustLatDefault = parcelHelpers.interopDefault(_adjustLat);
var _mlfn = require("../common/mlfn");
var _mlfnDefault = parcelHelpers.interopDefault(_mlfn);
var _values = require("../constants/values");
var _gN = require("../common/gN");
var _gNDefault = parcelHelpers.interopDefault(_gN);
/**
 * @typedef {Object} LocalThis
 * @property {number} temp
 * @property {number} es
 * @property {number} e
 * @property {number} e0
 * @property {number} e1
 * @property {number} e2
 * @property {number} e3
 * @property {number} ml0
 */ var MAX_ITER = 20;
function init() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, _e0FnDefault.default)(this.es);
    this.e1 = (0, _e1FnDefault.default)(this.es);
    this.e2 = (0, _e2FnDefault.default)(this.es);
    this.e3 = (0, _e3FnDefault.default)(this.es);
    this.ml0 = this.a * (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, this.lat0); // si que des zeros le calcul ne se fait pas
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, _values.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, _adjustLatDefault.default)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, _values.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, _gNDefault.default)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function inverse(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, _values.EPSLN)) {
            lon = (0, _adjustLonDefault.default)(x / this.a + this.long0, this.over);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, _values.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, _adjustLonDefault.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat), this.over);
        }
    } else if (Math.abs(y + this.ml0) <= (0, _values.EPSLN)) {
        lat = 0;
        lon = (0, _adjustLonDefault.default)(this.long0 + x / this.a, this.over);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, _values.EPSLN)) {
                lat = phi;
                break;
            }
        }
        // lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, _adjustLonDefault.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Polyconic',
    'American_Polyconic',
    'poly'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/e0fn":"eEUN4","../common/e1fn":"7mVOn","../common/e2fn":"ckc0u","../common/e3fn":"22vbx","../common/adjust_lon":"l07Jx","../common/adjust_lat":"6bp2t","../common/mlfn":"h0pMr","../constants/values":"8tAZZ","../common/gN":"4k9Xp","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"i1Prb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iterations", ()=>iterations);
parcelHelpers.export(exports, "init", ()=>init);
/**
    New Zealand Map Grid Forward  - long/lat to x/y
    long/lat in radians
  */ parcelHelpers.export(exports, "forward", ()=>forward);
/**
    New Zealand Map Grid Inverse  -  x/y to long/lat
  */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _values = require("../constants/values");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, _values.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, _values.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'New_Zealand_Map_Grid',
    'nzmg'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    iterations: iterations
};

},{"../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kP6zr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
  reference
    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
  */ /* Initialize the Miller Cylindrical projection
  ------------------------------------------- */ parcelHelpers.export(exports, "init", ()=>init);
/* Miller Cylindrical forward equations--mapping lat,long to x,y
    ------------------------------------------------------------ */ parcelHelpers.export(exports, "forward", ()=>forward);
/* Miller Cylindrical inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------ */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
function init() {
// no-op
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ var dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, _adjustLonDefault.default)(this.long0 + p.x / this.a, this.over);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Miller_Cylindrical',
    'mill'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ic6hZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {Array<number>} en
 * @property {number} n
 * @property {number} m
 * @property {number} C_y
 * @property {number} C_x
 * @property {number} es
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/* Sinusoidal forward equations--mapping lat,long to x,y
  ----------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _adjustLat = require("../common/adjust_lat");
var _adjustLatDefault = parcelHelpers.interopDefault(_adjustLat);
var _pjEnfn = require("../common/pj_enfn");
var _pjEnfnDefault = parcelHelpers.interopDefault(_pjEnfn);
var _pjMlfn = require("../common/pj_mlfn");
var _pjMlfnDefault = parcelHelpers.interopDefault(_pjMlfn);
var _pjInvMlfn = require("../common/pj_inv_mlfn");
var _pjInvMlfnDefault = parcelHelpers.interopDefault(_pjInvMlfn);
var _values = require("../constants/values");
var _asinz = require("../common/asinz");
var _asinzDefault = parcelHelpers.interopDefault(_asinz);
var MAX_ITER = 20;
function init() {
    /* Place parameters in static storage for common use
    ------------------------------------------------- */ this.long0 = this.long0 || 0;
    if (!this.sphere) this.en = (0, _pjEnfnDefault.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function forward(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ lon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, _values.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, _pjMlfnDefault.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, _asinzDefault.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, _asinzDefault.default)(Math.sin(lat) / this.n);
        lon = (0, _adjustLonDefault.default)(lon + this.long0, this.over);
        lat = (0, _adjustLatDefault.default)(lat);
    } else {
        lat = (0, _pjInvMlfnDefault.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, _values.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            // temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, _adjustLonDefault.default)(temp, this.over);
        } else if (s - (0, _values.EPSLN) < (0, _values.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Sinusoidal',
    'sinu'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../common/adjust_lat":"6bp2t","../common/pj_enfn":"a6UY0","../common/pj_mlfn":"gAMYp","../common/pj_inv_mlfn":"kb8Su","../constants/values":"8tAZZ","../common/asinz":"aJap8","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lue2D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Eckert VI projection — spherical sinusoidal variant with m=1, n=1+π/2.
 * Always forces spherical computation regardless of the ellipsoid.
 *
 * @typedef {Object} LocalThis
 * @property {number} m
 * @property {number} n
 * @property {number} C_y
 * @property {number} C_x
 * @property {number} es
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _sinu = require("./sinu");
function init() {
    /* Force spherical handling */ this.sphere = true;
    this.b = this.a;
    this.m = 1.0;
    this.n = 2.570796326794896619231321691; /* 1 + π/2 */ 
    this.es = 0;
    this.C_y = Math.sqrt((this.m + 1.0) / this.n);
    this.C_x = this.C_y / (this.m + 1.0);
}
var forward = (0, _sinu.forward);
var inverse = (0, _sinu.inverse);
var names = [
    'Eckert_VI',
    'eck6'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"./sinu":"ic6hZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4TIrL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @this {import('../defs.js').ProjectionDefinition} */ parcelHelpers.export(exports, "init", ()=>init);
/* Mollweide forward equations--mapping lat,long to x,y
    ---------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _values = require("../constants/values");
function init() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
}
function forward(p) {
    /* Forward equations
      ----------------- */ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      ----------------------------------------------------- */ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, _values.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       -------------------------------------------------------------------------- */ if (Math.PI / 2 - Math.abs(lat) < (0, _values.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var theta;
    var arg;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       ------------------------------------------------------------------- */ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, _adjustLonDefault.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)), this.over);
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Mollweide',
    'moll'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4k7M9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} temp
 * @property {number} es
 * @property {number} e
 * @property {number} e0
 * @property {number} e1
 * @property {number} e2
 * @property {number} e3
 * @property {number} sin_phi
 * @property {number} cos_phi
 * @property {number} ms1
 * @property {number} ml1
 * @property {number} ms2
 * @property {number} ml2
 * @property {number} ns
 * @property {number} g
 * @property {number} ml0
 * @property {number} rh
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/* Equidistant Conic forward equations--mapping lat,long to x,y
  ----------------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
/* Inverse equations
  ----------------- */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _e0Fn = require("../common/e0fn");
var _e0FnDefault = parcelHelpers.interopDefault(_e0Fn);
var _e1Fn = require("../common/e1fn");
var _e1FnDefault = parcelHelpers.interopDefault(_e1Fn);
var _e2Fn = require("../common/e2fn");
var _e2FnDefault = parcelHelpers.interopDefault(_e2Fn);
var _e3Fn = require("../common/e3fn");
var _e3FnDefault = parcelHelpers.interopDefault(_e3Fn);
var _msfnz = require("../common/msfnz");
var _msfnzDefault = parcelHelpers.interopDefault(_msfnz);
var _mlfn = require("../common/mlfn");
var _mlfnDefault = parcelHelpers.interopDefault(_mlfn);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _adjustLat = require("../common/adjust_lat");
var _adjustLatDefault = parcelHelpers.interopDefault(_adjustLat);
var _imlfn = require("../common/imlfn");
var _imlfnDefault = parcelHelpers.interopDefault(_imlfn);
var _values = require("../constants/values");
function init() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, _values.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, _e0FnDefault.default)(this.es);
    this.e1 = (0, _e1FnDefault.default)(this.es);
    this.e2 = (0, _e2FnDefault.default)(this.es);
    this.e3 = (0, _e3FnDefault.default)(this.es);
    this.sin_phi = Math.sin(this.lat1);
    this.cos_phi = Math.cos(this.lat1);
    this.ms1 = (0, _msfnzDefault.default)(this.e, this.sin_phi, this.cos_phi);
    this.ml1 = (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, _values.EPSLN)) this.ns = this.sin_phi;
    else {
        this.sin_phi = Math.sin(this.lat2);
        this.cos_phi = Math.cos(this.lat2);
        this.ms2 = (0, _msfnzDefault.default)(this.e, this.sin_phi, this.cos_phi);
        this.ml2 = (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      ----------------- */ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, _mlfnDefault.default)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, _adjustLonDefault.default)(this.long0 + theta / this.ns, this.over);
        lat = (0, _adjustLatDefault.default)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, _imlfnDefault.default)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, _adjustLonDefault.default)(this.long0 + theta / this.ns, this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var names = [
    'Equidistant_Conic',
    'eqdc'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/e0fn":"eEUN4","../common/e1fn":"7mVOn","../common/e2fn":"ckc0u","../common/e3fn":"22vbx","../common/msfnz":"aVAwM","../common/mlfn":"h0pMr","../common/adjust_lon":"l07Jx","../common/adjust_lat":"6bp2t","../common/imlfn":"8v9HT","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2kmk9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} R - Radius of the Earth
 */ /**
 * Initialize the Van Der Grinten projection
 * @this {import('../defs.js').ProjectionDefinition & LocalThis}
 */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
/* Van Der Grinten inverse equations--mapping x,y to lat/long
  --------------------------------------------------------- */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _values = require("../constants/values");
var _asinz = require("../common/asinz");
var _asinzDefault = parcelHelpers.interopDefault(_asinz);
function init() {
    // this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ var dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var x, y;
    if (Math.abs(lat) <= (0, _values.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
        p.x = x;
        p.y = y;
        return p;
    }
    var theta = (0, _asinzDefault.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, _values.EPSLN) || Math.abs(Math.abs(lat) - (0, _values.HALF_PI)) <= (0, _values.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
        p.x = x;
        p.y = y;
        return p;
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    // con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) // y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else // y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, _values.EPSLN)) lon = this.long0;
    else lon = (0, _adjustLonDefault.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Van_der_Grinten_I',
    'VanDerGrinten',
    'Van_der_Grinten',
    'vandg'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../constants/values":"8tAZZ","../common/asinz":"aJap8","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dS3hB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} es
 * @property {number} sin_p12
 * @property {number} cos_p12
 * @property {number} a
 * @property {number} f
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _values = require("../constants/values");
var _mlfn = require("../common/mlfn");
var _mlfnDefault = parcelHelpers.interopDefault(_mlfn);
var _e0Fn = require("../common/e0fn");
var _e0FnDefault = parcelHelpers.interopDefault(_e0Fn);
var _e1Fn = require("../common/e1fn");
var _e1FnDefault = parcelHelpers.interopDefault(_e1Fn);
var _e2Fn = require("../common/e2fn");
var _e2FnDefault = parcelHelpers.interopDefault(_e2Fn);
var _e3Fn = require("../common/e3fn");
var _e3FnDefault = parcelHelpers.interopDefault(_e3Fn);
var _asinz = require("../common/asinz");
var _asinzDefault = parcelHelpers.interopDefault(_asinz);
var _imlfn = require("../common/imlfn");
var _imlfnDefault = parcelHelpers.interopDefault(_imlfn);
var _vincenty = require("../common/vincenty");
function init() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    // flattening for ellipsoid
    this.f = this.es / (1 + Math.sqrt(1 - this.es));
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, _adjustLonDefault.default)(lon - this.long0, this.over);
    var e0, e1, e2, e3, Mlp, Ml, c, kp, cos_c, vars, azi1;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, _values.EPSLN)) {
            // North Pole case
            p.x = this.x0 + this.a * ((0, _values.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, _values.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, _values.EPSLN)) {
            // South Pole case
            p.x = this.x0 + this.a * ((0, _values.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, _values.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            // default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, _e0FnDefault.default)(this.es);
        e1 = (0, _e1FnDefault.default)(this.es);
        e2 = (0, _e2FnDefault.default)(this.es);
        e3 = (0, _e3FnDefault.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, _values.EPSLN)) {
            // North Pole case
            Mlp = this.a * (0, _mlfnDefault.default)(e0, e1, e2, e3, (0, _values.HALF_PI));
            Ml = this.a * (0, _mlfnDefault.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, _values.EPSLN)) {
            // South Pole case
            Mlp = this.a * (0, _mlfnDefault.default)(e0, e1, e2, e3, (0, _values.HALF_PI));
            Ml = this.a * (0, _mlfnDefault.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            // Default case
            if (Math.abs(lon) < (0, _values.EPSLN) && Math.abs(lat - this.lat0) < (0, _values.EPSLN)) {
                p.x = this.x0;
                p.y = this.y0;
                return p;
            }
            vars = (0, _vincenty.vincentyInverse)(this.lat0, this.long0, lat, lon, this.a, this.f);
            azi1 = vars.azi1;
            p.x = this.x0 + vars.s12 * Math.sin(azi1);
            p.y = this.y0 + vars.s12 * Math.cos(azi1);
            return p;
        }
    }
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, azi1, s12, vars;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, _values.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, _values.EPSLN)) lat = this.lat0;
        else {
            lat = (0, _asinzDefault.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, _values.HALF_PI);
            if (Math.abs(con) <= (0, _values.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x, -p.y), this.over);
                else lon = (0, _adjustLonDefault.default)(this.long0 - Math.atan2(-p.x, p.y), this.over);
            } else lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz), this.over);
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, _e0FnDefault.default)(this.es);
        e1 = (0, _e1FnDefault.default)(this.es);
        e2 = (0, _e2FnDefault.default)(this.es);
        e3 = (0, _e3FnDefault.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, _values.EPSLN)) {
            // North pole case
            Mlp = this.a * (0, _mlfnDefault.default)(e0, e1, e2, e3, (0, _values.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, _imlfnDefault.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, _values.EPSLN)) {
            // South pole case
            Mlp = this.a * (0, _mlfnDefault.default)(e0, e1, e2, e3, (0, _values.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, _imlfnDefault.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, _adjustLonDefault.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            // default case
            azi1 = Math.atan2(p.x, p.y);
            s12 = Math.sqrt(p.x * p.x + p.y * p.y);
            vars = (0, _vincenty.vincentyDirect)(this.lat0, this.long0, azi1, s12, this.a, this.f);
            p.x = vars.lon2;
            p.y = vars.lat2;
            return p;
        }
    }
}
var names = [
    'Azimuthal_Equidistant',
    'aeqd'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../constants/values":"8tAZZ","../common/mlfn":"h0pMr","../common/e0fn":"eEUN4","../common/e1fn":"7mVOn","../common/e2fn":"ckc0u","../common/e3fn":"22vbx","../common/asinz":"aJap8","../common/imlfn":"8v9HT","../common/vincenty":"fKwyo","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fKwyo":[function(require,module,exports,__globalThis) {
/**
 * Calculates the inverse geodesic problem using Vincenty's formulae.
 * Computes the forward azimuth and ellipsoidal distance between two points
 * specified by latitude and longitude on the surface of an ellipsoid.
 *
 * @param {number} lat1 Latitude of the first point in radians.
 * @param {number} lon1 Longitude of the first point in radians.
 * @param {number} lat2 Latitude of the second point in radians.
 * @param {number} lon2 Longitude of the second point in radians.
 * @param {number} a Semi-major axis of the ellipsoid (meters).
 * @param {number} f Flattening of the ellipsoid.
 * @returns {{ azi1: number, s12: number }} An object containing:
 *   - azi1: Forward azimuth from the first point to the second point (radians).
 *   - s12: Ellipsoidal distance between the two points (meters).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vincentyInverse", ()=>vincentyInverse);
/**
 * Solves the direct geodetic problem using Vincenty's formulae.
 * Given a starting point, initial azimuth, and distance, computes the destination point on the ellipsoid.
 *
 * @param {number} lat1 Latitude of the starting point in radians.
 * @param {number} lon1 Longitude of the starting point in radians.
 * @param {number} azi1 Initial azimuth (forward azimuth) in radians.
 * @param {number} s12 Distance to travel from the starting point in meters.
 * @param {number} a Semi-major axis of the ellipsoid in meters.
 * @param {number} f Flattening of the ellipsoid.
 * @returns {{lat2: number, lon2: number}} The latitude and longitude (in radians) of the destination point.
 */ parcelHelpers.export(exports, "vincentyDirect", ()=>vincentyDirect);
function vincentyInverse(lat1, lon1, lat2, lon2, a, f) {
    const L = lon2 - lon1;
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const U2 = Math.atan((1 - f) * Math.tan(lat2));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinU2 = Math.sin(U2), cosU2 = Math.cos(U2);
    let lambda = L, lambdaP, iterLimit = 100;
    let sinLambda, cosLambda, sinSigma, cosSigma, sigma, sinAlpha, cos2Alpha, cos2SigmaM, C;
    let uSq, A, B, deltaSigma, s;
    do {
        sinLambda = Math.sin(lambda);
        cosLambda = Math.cos(lambda);
        sinSigma = Math.sqrt(cosU2 * sinLambda * (cosU2 * sinLambda) + (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda) * (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda));
        if (sinSigma === 0) return {
            azi1: 0,
            s12: 0
        }; // coincident points
        cosSigma = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
        sigma = Math.atan2(sinSigma, cosSigma);
        sinAlpha = cosU1 * cosU2 * sinLambda / sinSigma;
        cos2Alpha = 1 - sinAlpha * sinAlpha;
        cos2SigmaM = cos2Alpha !== 0 ? cosSigma - 2 * sinU1 * sinU2 / cos2Alpha : 0;
        C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
        lambdaP = lambda;
        lambda = L + (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    }while (Math.abs(lambda - lambdaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        azi1: NaN,
        s12: NaN
    }; // formula failed to converge
    uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
    s = a * (1 - f) * A * (sigma - deltaSigma);
    // Forward azimuth
    const azi1 = Math.atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
    return {
        azi1,
        s12: s
    };
}
function vincentyDirect(lat1, lon1, azi1, s12, a, f) {
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinAlpha1 = Math.sin(azi1), cosAlpha1 = Math.cos(azi1);
    const sigma1 = Math.atan2(sinU1, cosU1 * cosAlpha1);
    const sinAlpha = cosU1 * sinAlpha1;
    const cos2Alpha = 1 - sinAlpha * sinAlpha;
    const uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    const A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    const B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    let sigma = s12 / (a * (1 - f) * A), sigmaP, iterLimit = 100;
    let cos2SigmaM, sinSigma, cosSigma, deltaSigma;
    do {
        cos2SigmaM = Math.cos(2 * sigma1 + sigma);
        sinSigma = Math.sin(sigma);
        cosSigma = Math.cos(sigma);
        deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
        sigmaP = sigma;
        sigma = s12 / (a * (1 - f) * A) + deltaSigma;
    }while (Math.abs(sigma - sigmaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        lat2: NaN,
        lon2: NaN
    };
    const tmp = sinU1 * sinSigma - cosU1 * cosSigma * cosAlpha1;
    const lat2 = Math.atan2(sinU1 * cosSigma + cosU1 * sinSigma * cosAlpha1, (1 - f) * Math.sqrt(sinAlpha * sinAlpha + tmp * tmp));
    const lambda = Math.atan2(sinSigma * sinAlpha1, cosU1 * cosSigma - sinU1 * sinSigma * cosAlpha1);
    const C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
    const L = lambda - (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    const lon2 = lon1 + L;
    return {
        lat2,
        lon2
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aIdnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} sin_p14
 * @property {number} cos_p14
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/* Orthographic forward equations--mapping lat,long to x,y
    --------------------------------------------------- */ parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _asinz = require("../common/asinz");
var _asinzDefault = parcelHelpers.interopDefault(_asinz);
var _values = require("../constants/values");
function init() {
    // double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0 || 0);
    this.cos_p14 = Math.cos(this.lat0 || 0);
}
function forward(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, _adjustLonDefault.default)(lon - (this.long0 || 0), this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, _values.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = (this.y0 || 0) + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    var long0, lat0;
    /* Inverse equations
      ----------------- */ p.x -= this.x0 || 0;
    p.y -= this.y0 || 0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, _asinzDefault.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    long0 = this.long0 || 0;
    lat0 = this.lat0 || 0;
    lon = long0;
    if (Math.abs(rh) <= (0, _values.EPSLN)) {
        lat = lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, _asinzDefault.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(lat0) - (0, _values.HALF_PI);
    if (Math.abs(con) <= (0, _values.EPSLN)) {
        if (lat0 >= 0) lon = (0, _adjustLonDefault.default)(long0 + Math.atan2(p.x, -p.y), this.over);
        else lon = (0, _adjustLonDefault.default)(long0 - Math.atan2(-p.x, p.y), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, _adjustLonDefault.default)(long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'ortho'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../common/asinz":"aJap8","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4kYLV":[function(require,module,exports,__globalThis) {
// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
// QSC forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
parcelHelpers.export(exports, "forward", ()=>forward);
// QSC inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _values = require("../constants/values");
/**
 * @typedef {Object} LocalThis
 * @property {number} face
 * @property {number} x0
 * @property {number} y0
 * @property {number} es
 * @property {number} one_minus_f
 * @property {number} one_minus_f_squared
 */ /* constants */ var FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function init() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Quadrilateralized Spherical Cube';
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, _values.HALF_PI) - (0, _values.FORTPI) / 2.0) this.face = FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, _values.HALF_PI) - (0, _values.FORTPI) / 2.0)) this.face = FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, _values.FORTPI)) this.face = FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, _values.HALF_PI) + (0, _values.FORTPI)) this.face = this.long0 > 0.0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
    else this.face = FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function forward(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; // lon = lp.lam;
    if (this.face === FACE_ENUM.TOP) {
        phi = (0, _values.HALF_PI) - lat;
        if (lon >= (0, _values.FORTPI) && lon <= (0, _values.HALF_PI) + (0, _values.FORTPI)) {
            area.value = AREA_ENUM.AREA_0;
            theta = lon - (0, _values.HALF_PI);
        } else if (lon > (0, _values.HALF_PI) + (0, _values.FORTPI) || lon <= -((0, _values.HALF_PI) + (0, _values.FORTPI))) {
            area.value = AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, _values.SPI) : lon + (0, _values.SPI);
        } else if (lon > -((0, _values.HALF_PI) + (0, _values.FORTPI)) && lon <= -(0, _values.FORTPI)) {
            area.value = AREA_ENUM.AREA_2;
            theta = lon + (0, _values.HALF_PI);
        } else {
            area.value = AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === FACE_ENUM.BOTTOM) {
        phi = (0, _values.HALF_PI) + lat;
        if (lon >= (0, _values.FORTPI) && lon <= (0, _values.HALF_PI) + (0, _values.FORTPI)) {
            area.value = AREA_ENUM.AREA_0;
            theta = -lon + (0, _values.HALF_PI);
        } else if (lon < (0, _values.FORTPI) && lon >= -(0, _values.FORTPI)) {
            area.value = AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, _values.FORTPI) && lon >= -((0, _values.HALF_PI) + (0, _values.FORTPI))) {
            area.value = AREA_ENUM.AREA_2;
            theta = -lon - (0, _values.HALF_PI);
        } else {
            area.value = AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, _values.SPI) : -lon - (0, _values.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === FACE_ENUM.RIGHT) lon = qsc_shift_lon_origin(lon, +(0, _values.HALF_PI));
        else if (this.face === FACE_ENUM.BACK) lon = qsc_shift_lon_origin(lon, +(0, _values.SPI));
        else if (this.face === FACE_ENUM.LEFT) lon = qsc_shift_lon_origin(lon, -(0, _values.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, _values.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, _values.FORTPI))) - (0, _values.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === AREA_ENUM.AREA_1) mu += (0, _values.HALF_PI);
    else if (area.value === AREA_ENUM.AREA_2) mu += (0, _values.SPI);
    else if (area.value === AREA_ENUM.AREA_3) mu += 1.5 * (0, _values.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function inverse(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = AREA_ENUM.AREA_1;
        mu -= (0, _values.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, _values.SPI) : mu - (0, _values.SPI);
    } else {
        area.value = AREA_ENUM.AREA_3;
        mu += (0, _values.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, _values.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, _values.HALF_PI) - phi;
        if (area.value === AREA_ENUM.AREA_0) lp.lam = theta + (0, _values.HALF_PI);
        else if (area.value === AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, _values.SPI) : theta - (0, _values.SPI);
        else if (area.value === AREA_ENUM.AREA_2) lp.lam = theta - (0, _values.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, _values.HALF_PI);
        if (area.value === AREA_ENUM.AREA_0) lp.lam = -theta + (0, _values.HALF_PI);
        else if (area.value === AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === AREA_ENUM.AREA_2) lp.lam = -theta - (0, _values.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, _values.SPI) : -theta + (0, _values.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, _values.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === FACE_ENUM.RIGHT) lp.lam = qsc_shift_lon_origin(lp.lam, -(0, _values.HALF_PI));
        else if (this.face === FACE_ENUM.BACK) lp.lam = qsc_shift_lon_origin(lp.lam, -(0, _values.SPI));
        else if (this.face === FACE_ENUM.LEFT) lp.lam = qsc_shift_lon_origin(lp.lam, +(0, _values.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, _values.EPSLN)) {
        area.value = AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, _values.FORTPI)) area.value = AREA_ENUM.AREA_0;
        else if (theta > (0, _values.FORTPI) && theta <= (0, _values.HALF_PI) + (0, _values.FORTPI)) {
            area.value = AREA_ENUM.AREA_1;
            theta -= (0, _values.HALF_PI);
        } else if (theta > (0, _values.HALF_PI) + (0, _values.FORTPI) || theta <= -((0, _values.HALF_PI) + (0, _values.FORTPI))) {
            area.value = AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, _values.SPI) : theta + (0, _values.SPI);
        } else {
            area.value = AREA_ENUM.AREA_3;
            theta += (0, _values.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, _values.SPI)) slon += (0, _values.TWO_PI);
    else if (slon > +(0, _values.SPI)) slon -= (0, _values.TWO_PI);
    return slon;
}
var names = [
    'Quadrilateralized Spherical Cube',
    'Quadrilateralized_Spherical_Cube',
    'qsc'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"61r0D":[function(require,module,exports,__globalThis) {
// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _values = require("../constants/values");
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var FXC = 0.8487;
var FYC = 1.3523;
var C1 = (0, _values.R2D) / 5; // rad to 5-degree interval
var RC1 = 1 / C1;
var NODES = 18;
var poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function init() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || 'Robinson';
}
function forward(ll) {
    var lon = (0, _adjustLonDefault.default)(ll.x - this.long0, this.over);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * C1);
    if (i < 0) i = 0;
    else if (i >= NODES) i = NODES - 1;
    dphi = (0, _values.R2D) * (dphi - RC1 * i);
    var xy = {
        x: poly3_val(COEFS_X[i], dphi) * lon,
        y: poly3_val(COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * FXC + this.x0;
    xy.y = xy.y * this.a * FYC + this.y0;
    return xy;
}
function inverse(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * FYC)
    };
    if (ll.y >= 1) {
        ll.x /= COEFS_X[NODES][0];
        ll.y = xy.y < 0 ? -(0, _values.HALF_PI) : (0, _values.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * NODES);
        if (i < 0) i = 0;
        else if (i >= NODES) i = NODES - 1;
        for(;;){
            if (COEFS_Y[i][0] > ll.y) --i;
            else if (COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / (COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = newton_rapshon(function(x) {
            return (poly3_val(coefs, x) - ll.y) / poly3_der(coefs, x);
        }, t, (0, _values.EPSLN), 100);
        ll.x /= poly3_val(COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, _values.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, _adjustLonDefault.default)(ll.x + this.long0, this.over);
    return ll;
}
var names = [
    'Robinson',
    'robin'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../constants/values":"8tAZZ","../common/adjust_lon":"l07Jx","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7iJ84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _datumUtils = require("../datumUtils");
function init() {
    this.name = 'geocent';
}
function forward(p) {
    var point = (0, _datumUtils.geodeticToGeocentric)(p, this.es, this.a);
    return point;
}
function inverse(p) {
    var point = (0, _datumUtils.geocentricToGeodetic)(p, this.es, this.a, this.b);
    return point;
}
var names = [
    'Geocentric',
    'geocentric',
    'geocent',
    'Geocent'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../datumUtils":"kslr6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lidQP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "forward", ()=>forward);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _values = require("../constants/values");
var _hypot = require("../common/hypot");
var _hypotDefault = parcelHelpers.interopDefault(_hypot);
/**
 * @typedef {Object} LocalThis
 * @property {number} mode
 * @property {number} sinph0
 * @property {number} cosph0
 * @property {number} pn1
 * @property {number} h
 * @property {number} rp
 * @property {number} p
 * @property {number} h1
 * @property {number} pfact
 * @property {number} es
 * @property {number} tilt
 * @property {number} azi
 * @property {number} cg
 * @property {number} sg
 * @property {number} cw
 * @property {number} sw
 */ var mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function init() {
    Object.keys(params).forEach((function(p) {
        if (typeof this[p] === 'undefined') this[p] = params[p].def;
        else if (params[p].num && isNaN(this[p])) throw new Error('Invalid parameter value, must be numeric ' + p + ' = ' + this[p]);
        else if (params[p].num) this[p] = parseFloat(this[p]);
        if (params[p].degrees) this[p] = this[p] * (0, _values.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, _values.HALF_PI)) < (0, _values.EPSLN)) this.mode = this.lat0 < 0 ? mode.S_POLE : mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, _values.EPSLN)) this.mode = mode.EQUIT;
    else {
        this.mode = mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error('Invalid height');
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function forward(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case mode.EQUIT:
            y = cosphi * coslam;
            break;
        case mode.S_POLE:
            y = -sinphi;
            break;
        case mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case mode.EQUIT:
            y *= sinphi;
            break;
        case mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function inverse(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, _hypotDefault.default)(p.x, p.y);
    if (Math.abs(rh) < (0, _values.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var names = [
    'Tilted_Perspective',
    'tpers'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../constants/values":"8tAZZ","../common/hypot":"f4r5Q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bx3c7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {1 | 0} flip_axis
 * @property {number} h
 * @property {number} radius_g_1
 * @property {number} radius_g
 * @property {number} radius_p
 * @property {number} radius_p2
 * @property {number} radius_p_inv2
 * @property {'ellipse'|'sphere'} shape
 * @property {number} C
 * @property {string} sweep
 * @property {number} es
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "names", ()=>names);
var _hypot = require("../common/hypot");
var _hypotDefault = parcelHelpers.interopDefault(_hypot);
function init() {
    this.flip_axis = this.sweep === 'x' ? 1 : 0;
    this.h = Number(this.h);
    this.radius_g_1 = this.h / this.a;
    if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
    this.radius_g = 1.0 + this.radius_g_1;
    this.C = this.radius_g * this.radius_g - 1.0;
    if (this.es !== 0.0) {
        var one_es = 1.0 - this.es;
        var rone_es = 1 / one_es;
        this.radius_p = Math.sqrt(one_es);
        this.radius_p2 = one_es;
        this.radius_p_inv2 = rone_es;
        this.shape = 'ellipse'; // Use as a condition in the forward and inverse functions.
    } else {
        this.radius_p = 1.0;
        this.radius_p2 = 1.0;
        this.radius_p_inv2 = 1.0;
        this.shape = 'sphere'; // Use as a condition in the forward and inverse functions.
    }
    if (!this.title) this.title = 'Geostationary Satellite View';
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var tmp, v_x, v_y, v_z;
    lon = lon - this.long0;
    if (this.shape === 'ellipse') {
        lat = Math.atan(this.radius_p2 * Math.tan(lat));
        var r = this.radius_p / (0, _hypotDefault.default)(this.radius_p * Math.cos(lat), Math.sin(lat));
        v_x = r * Math.cos(lon) * Math.cos(lat);
        v_y = r * Math.sin(lon) * Math.cos(lat);
        v_z = r * Math.sin(lat);
        if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, _hypotDefault.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, _hypotDefault.default)(v_y, tmp));
        }
    } else if (this.shape === 'sphere') {
        tmp = Math.cos(lat);
        v_x = Math.cos(lon) * tmp;
        v_y = Math.sin(lon) * tmp;
        v_z = Math.sin(lat);
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, _hypotDefault.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, _hypotDefault.default)(v_y, tmp));
        }
    }
    p.x = p.x * this.a;
    p.y = p.y * this.a;
    return p;
}
function inverse(p) {
    var v_x = -1;
    var v_y = 0.0;
    var v_z = 0.0;
    var a, b, det, k;
    p.x = p.x / this.a;
    p.y = p.y / this.a;
    if (this.shape === 'ellipse') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * (0, _hypotDefault.default)(1.0, v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * (0, _hypotDefault.default)(1.0, v_y);
        }
        var v_zp = v_z / this.radius_p;
        a = v_y * v_y + v_zp * v_zp + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
    } else if (this.shape === 'sphere') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
        }
        a = v_y * v_y + v_z * v_z + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
    }
    p.x = p.x + this.long0;
    return p;
}
var names = [
    'Geostationary Satellite View',
    'Geostationary_Satellite',
    'geos'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/hypot":"f4r5Q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"d0X1O":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Equal Earth is a projection inspired by the Robinson projection, but unlike
 * the Robinson projection retains the relative size of areas. The projection
 * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
 *
 * Publication:
 * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
 * projection, International Journal of Geographical Information Science,
 * DOI: 10.1080/13658816.2018.1504949
 *
 * Code released August 2018
 * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
 * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} LocalThis
 * @property {number} es
 * @property {number} e
 * @property {Array<number>} apa
 * @property {number} qp
 * @property {number} rqda
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "forward", ()=>forward);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _qsfnz = require("../common/qsfnz");
var _qsfnzDefault = parcelHelpers.interopDefault(_qsfnz);
var _authset = require("../common/authset");
var _authsetDefault = parcelHelpers.interopDefault(_authset);
var _authlat = require("../common/authlat");
var _authlatDefault = parcelHelpers.interopDefault(_authlat);
var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = Math.sqrt(3) / 2.0;
function init() {
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    if (this.es !== 0) {
        this.apa = (0, _authsetDefault.default)(this.es);
        this.qp = (0, _qsfnzDefault.default)(this.e, 1);
        this.rqda = Math.sqrt(0.5 * this.qp);
    }
}
function forward(p) {
    var lam = (0, _adjustLonDefault.default)(p.x - this.long0, this.over);
    var phi = p.y;
    var sinphi = Math.sin(phi);
    if (this.es !== 0) sinphi = (0, _qsfnzDefault.default)(this.e, sinphi) / this.qp;
    var paramLat = Math.asin(M * sinphi), paramLatSq = paramLat * paramLat, paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = lam * Math.cos(paramLat) / (M * (A1 + 3 * A2 * paramLatSq + paramLatPow6 * (7 * A3 + 9 * A4 * paramLatSq)));
    p.y = paramLat * (A1 + A2 * paramLatSq + paramLatPow6 * (A3 + A4 * paramLatSq));
    if (this.es !== 0) {
        p.x *= this.rqda;
        p.y *= this.rqda;
    }
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function inverse(p) {
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    if (this.es !== 0) {
        p.x /= this.rqda;
        p.y /= this.rqda;
    }
    var EPS = 1e-9, NITER = 12, paramLat = p.y, paramLatSq, paramLatPow6, fy, fpy, dlat, i;
    for(i = 0; i < NITER; ++i){
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * (A1 + A2 * paramLatSq + paramLatPow6 * (A3 + A4 * paramLatSq)) - p.y;
        fpy = A1 + 3 * A2 * paramLatSq + paramLatPow6 * (7 * A3 + 9 * A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) break;
    }
    paramLatSq = paramLat * paramLat;
    paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = M * p.x * (A1 + 3 * A2 * paramLatSq + paramLatPow6 * (7 * A3 + 9 * A4 * paramLatSq)) / Math.cos(paramLat);
    p.y = Math.asin(Math.sin(paramLat) / M);
    if (this.es !== 0) p.y = (0, _authlatDefault.default)(p.y, this.apa);
    p.x = (0, _adjustLonDefault.default)(p.x + this.long0, this.over);
    return p;
}
var names = [
    'eqearth',
    'Equal Earth',
    'Equal_Earth'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../common/qsfnz":"gS1NK","../common/authset":"kEmwX","../common/authlat":"lhb6p","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"h5nVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLat = require("../common/adjust_lat");
var _adjustLatDefault = parcelHelpers.interopDefault(_adjustLat);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _hypot = require("../common/hypot");
var _hypotDefault = parcelHelpers.interopDefault(_hypot);
var _pjEnfn = require("../common/pj_enfn");
var _pjEnfnDefault = parcelHelpers.interopDefault(_pjEnfn);
var _pjInvMlfn = require("../common/pj_inv_mlfn");
var _pjInvMlfnDefault = parcelHelpers.interopDefault(_pjInvMlfn);
var _pjMlfn = require("../common/pj_mlfn");
var _pjMlfnDefault = parcelHelpers.interopDefault(_pjMlfn);
var _values = require("../constants/values");
/**
 * @typedef {Object} LocalThis
 * @property {number} phi1
 * @property {number} cphi1
 * @property {number} es
 * @property {Array<number>} en
 * @property {number} m1
 * @property {number} am1
 */ var EPS10 = 1e-10;
function init() {
    var c;
    this.phi1 = this.lat1;
    if (Math.abs(this.phi1) < EPS10) throw new Error();
    if (this.es) {
        this.en = (0, _pjEnfnDefault.default)(this.es);
        this.m1 = (0, _pjMlfnDefault.default)(this.phi1, this.am1 = Math.sin(this.phi1), c = Math.cos(this.phi1), this.en);
        this.am1 = c / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1);
        this.inverse = e_inv;
        this.forward = e_fwd;
    } else {
        if (Math.abs(this.phi1) + EPS10 >= (0, _values.HALF_PI)) this.cphi1 = 0;
        else this.cphi1 = 1 / Math.tan(this.phi1);
        this.inverse = s_inv;
        this.forward = s_fwd;
    }
}
function e_fwd(p) {
    var lam = (0, _adjustLonDefault.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var rh, E, c;
    rh = this.am1 + this.m1 - (0, _pjMlfnDefault.default)(phi, E = Math.sin(phi), c = Math.cos(phi), this.en);
    E = c * lam / (rh * Math.sqrt(1 - this.es * E * E));
    p.x = rh * Math.sin(E);
    p.y = this.am1 - rh * Math.cos(E);
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function e_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var s, rh, lam, phi;
    rh = (0, _hypotDefault.default)(p.x, p.y = this.am1 - p.y);
    phi = (0, _pjInvMlfnDefault.default)(this.am1 + this.m1 - rh, this.es, this.en);
    if ((s = Math.abs(phi)) < (0, _values.HALF_PI)) {
        s = Math.sin(phi);
        lam = rh * Math.atan2(p.x, p.y) * Math.sqrt(1 - this.es * s * s) / Math.cos(phi);
    } else if (Math.abs(s - (0, _values.HALF_PI)) <= EPS10) lam = 0;
    else throw new Error();
    p.x = (0, _adjustLonDefault.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, _adjustLatDefault.default)(phi);
    return p;
}
function s_fwd(p) {
    var lam = (0, _adjustLonDefault.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var E, rh;
    rh = this.cphi1 + this.phi1 - phi;
    if (Math.abs(rh) > EPS10) {
        p.x = rh * Math.sin(E = lam * Math.cos(phi) / rh);
        p.y = this.cphi1 - rh * Math.cos(E);
    } else p.x = p.y = 0;
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function s_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var lam, phi;
    var rh = (0, _hypotDefault.default)(p.x, p.y = this.cphi1 - p.y);
    phi = this.cphi1 + this.phi1 - rh;
    if (Math.abs(phi) > (0, _values.HALF_PI)) throw new Error();
    if (Math.abs(Math.abs(phi) - (0, _values.HALF_PI)) <= EPS10) lam = 0;
    else lam = rh * Math.atan2(p.x, p.y) / Math.cos(phi);
    p.x = (0, _adjustLonDefault.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, _adjustLatDefault.default)(phi);
    return p;
}
var names = [
    'bonne',
    'Bonne (Werner lat_1=90)'
];
exports.default = {
    init: init,
    names: names
};

},{"../common/adjust_lat":"6bp2t","../common/adjust_lon":"l07Jx","../common/hypot":"f4r5Q","../common/pj_enfn":"a6UY0","../common/pj_inv_mlfn":"kb8Su","../common/pj_mlfn":"gAMYp","../constants/values":"8tAZZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"i3Pld":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "init", ()=>init);
// ob_tran forward equations--mapping (lat,long) to (x,y)
// transverse (90 degrees from normal orientation) - forwardTransverse
// or oblique (arbitrary angle) used based on parameters - forwardOblique
// -----------------------------------------------------------------
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "forward", ()=>forward);
// inverse equations--mapping (x,y) to (lat,long)
// transverse: inverseTransverse
// oblique: inverseOblique
// -----------------------------------------------------------------
/** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "names", ()=>names);
var _adjustLon = require("../common/adjust_lon");
var _adjustLonDefault = parcelHelpers.interopDefault(_adjustLon);
var _values = require("../constants/values");
var _proj = require("../Proj");
var _projDefault = parcelHelpers.interopDefault(_proj);
var _longlat = require("./longlat");
/**
    Original projection implementation:
        https://github.com/OSGeo/PROJ/blob/46c47e9adf6376ae06afabe5d24a0016a05ced82/src/projections/ob_tran.cpp

    Documentation:
        https://proj.org/operations/projections/ob_tran.html

    References/Formulas:
        https://pubs.usgs.gov/pp/1395/report.pdf

    Examples:
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=60
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=-90
*/ const projectionType = {
    OBLIQUE: {
        forward: forwardOblique,
        inverse: inverseOblique
    },
    TRANSVERSE: {
        forward: forwardTransverse,
        inverse: inverseTransverse
    }
};
/**
 * @typedef {Object} LocalThis
 * @property {number} lamp
 * @property {number} cphip
 * @property {number} sphip
 * @property {Object} projectionType
 * @property {string | undefined} o_proj
 * @property {string | undefined} o_lon_p
 * @property {string | undefined} o_lat_p
 * @property {string | undefined} o_alpha
 * @property {string | undefined} o_lon_c
 * @property {string | undefined} o_lat_c
 * @property {string | undefined} o_lon_1
 * @property {string | undefined} o_lat_1
 * @property {string | undefined} o_lon_2
 * @property {string | undefined} o_lat_2
 * @property {number | undefined} oLongP
 * @property {number | undefined} oLatP
 * @property {number | undefined} oAlpha
 * @property {number | undefined} oLongC
 * @property {number | undefined} oLatC
 * @property {number | undefined} oLong1
 * @property {number | undefined} oLat1
 * @property {number | undefined} oLong2
 * @property {number | undefined} oLat2
 * @property {boolean} isIdentity
 * @property {import('..').Converter} obliqueProjection
 *
 */ /**
 *    Parameters can be from the following sets:
 *       New pole --> o_lat_p, o_lon_p
 *       Rotate about point --> o_alpha, o_lon_c, o_lat_c
 *       New equator points --> lon_1, lat_1, lon_2, lat_2
 *
 *    Per the original source code, the parameter sets are
 *    checked in the order of the object below.
 */ const paramSets = {
    ROTATE: {
        o_alpha: 'oAlpha',
        o_lon_c: 'oLongC',
        o_lat_c: 'oLatC'
    },
    NEW_POLE: {
        o_lat_p: 'oLatP',
        o_lon_p: 'oLongP'
    },
    NEW_EQUATOR: {
        o_lon_1: 'oLong1',
        o_lat_1: 'oLat1',
        o_lon_2: 'oLong2',
        o_lat_2: 'oLat2'
    }
};
function init() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.title = this.title || 'General Oblique Transformation';
    this.isIdentity = (0, _longlat.names).includes(this.o_proj);
    /** Verify required parameters exist */ if (!this.o_proj) throw new Error('Missing parameter: o_proj');
    if (this.o_proj === `ob_tran`) throw new Error('Invalid value for o_proj: ' + this.o_proj);
    const newProjStr = this.projStr.replace('+proj=ob_tran', '').replace('+o_proj=', '+proj=').trim();
    /** @type {import('../defs.js').ProjectionDefinition} */ const oProj = (0, _projDefault.default)(newProjStr);
    if (!oProj) throw new Error('Invalid parameter: o_proj. Unknown projection ' + this.o_proj);
    oProj.long0 = 0; // we handle long0 before/after forward/inverse
    this.obliqueProjection = oProj;
    let matchedSet;
    const paramSetsKeys = Object.keys(paramSets);
    /**
   * parse strings, convert to radians, throw on NaN
   * @param {string} name
   * @returns {number | undefined}
   */ const parseParam = (name)=>{
        if (typeof this[name] === `undefined`) return undefined;
        const val = parseFloat(this[name]) * (0, _values.D2R);
        if (isNaN(val)) throw new Error('Invalid value for ' + name + ': ' + this[name]);
        return val;
    };
    for(let i = 0; i < paramSetsKeys.length; i++){
        const setKey = paramSetsKeys[i];
        const set = paramSets[setKey];
        const params = Object.entries(set);
        const setHasParams = params.some(([p])=>typeof this[p] !== 'undefined');
        if (!setHasParams) continue;
        matchedSet = set;
        for(let ii = 0; ii < params.length; ii++){
            const [inputParam, param] = params[ii];
            const val = parseParam(inputParam);
            if (typeof val === 'undefined') throw new Error('Missing parameter: ' + inputParam + '.');
            this[param] = val;
        }
        break;
    }
    if (!matchedSet) throw new Error('No valid parameters provided for ob_tran projection.');
    const { lamp, phip } = createRotation(this, matchedSet);
    this.lamp = lamp;
    if (Math.abs(phip) > (0, _values.EPSLN)) {
        this.cphip = Math.cos(phip);
        this.sphip = Math.sin(phip);
        this.projectionType = projectionType.OBLIQUE;
    } else this.projectionType = projectionType.TRANSVERSE;
}
function forward(p) {
    return this.projectionType.forward(this, p);
}
function inverse(p) {
    return this.projectionType.inverse(this, p);
}
/**
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} params - Initialized projection definition
 * @param {Object} how - Transformation method
 * @returns {{phip: number, lamp: number}}
 */ function createRotation(params, how) {
    let phip, lamp;
    if (how === paramSets.ROTATE) {
        let lamc = params.oLongC;
        let phic = params.oLatC;
        let alpha = params.oAlpha;
        if (Math.abs(Math.abs(phic) - (0, _values.HALF_PI)) <= (0, _values.EPSLN)) throw new Error('Invalid value for o_lat_c: ' + params.o_lat_c + " should be < 90\xb0");
        lamp = lamc + Math.atan2(-1 * Math.cos(alpha), -1 * Math.sin(alpha) * Math.sin(phic));
        phip = Math.asin(Math.cos(phic) * Math.sin(alpha));
    } else if (how === paramSets.NEW_POLE) {
        lamp = params.oLongP;
        phip = params.oLatP;
    } else {
        let lam1 = params.oLong1;
        let phi1 = params.oLat1;
        let lam2 = params.oLong2;
        let phi2 = params.oLat2;
        let con = Math.abs(phi1);
        if (Math.abs(phi1) > (0, _values.HALF_PI) - (0, _values.EPSLN)) throw new Error('Invalid value for o_lat_1: ' + params.o_lat_1 + " should be < 90\xb0");
        if (Math.abs(phi2) > (0, _values.HALF_PI) - (0, _values.EPSLN)) throw new Error('Invalid value for o_lat_2: ' + params.o_lat_2 + " should be < 90\xb0");
        if (Math.abs(phi1 - phi2) < (0, _values.EPSLN)) throw new Error('Invalid value for o_lat_1 and o_lat_2: o_lat_1 should be different from o_lat_2');
        if (con < (0, _values.EPSLN)) throw new Error('Invalid value for o_lat_1: o_lat_1 should be different from zero');
        lamp = Math.atan2(Math.cos(phi1) * Math.sin(phi2) * Math.cos(lam1) - Math.sin(phi1) * Math.cos(phi2) * Math.cos(lam2), Math.sin(phi1) * Math.cos(phi2) * Math.sin(lam2) - Math.cos(phi1) * Math.sin(phi2) * Math.sin(lam1));
        phip = Math.atan(-1 * Math.cos(lamp - lam1) / Math.tan(phi1));
    }
    return {
        lamp,
        phip
    };
}
/**
 * Forward (lng, lat) to (x, y) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function forwardOblique(self, lp) {
    let { x: lam, y: phi } = lp;
    lam = (0, _adjustLonDefault.default)(lam - self.long0, self.over);
    const coslam = Math.cos(lam);
    const sinphi = Math.sin(phi);
    const cosphi = Math.cos(phi);
    lp.x = (0, _adjustLonDefault.default)(Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam + self.cphip * sinphi) + self.lamp);
    lp.y = Math.asin(self.sphip * sinphi - self.cphip * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, _values.R2D);
        result.y *= (0, _values.R2D);
    }
    return result;
}
/**
 * Forward (lng, lat) to (x, y) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function forwardTransverse(self, lp) {
    let { x: lam, y: phi } = lp;
    lam = (0, _adjustLonDefault.default)(lam - self.long0, self.over);
    const cosphi = Math.cos(phi);
    const coslam = Math.cos(lam);
    lp.x = (0, _adjustLonDefault.default)(Math.atan2(cosphi * Math.sin(lam), Math.sin(phi)) + self.lamp);
    lp.y = Math.asin(-1 * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, _values.R2D);
        result.y *= (0, _values.R2D);
    }
    return result;
}
/**
 * Inverse (x, y) to (lng, lat) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function inverseOblique(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, _values.D2R);
        lp.y *= (0, _values.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        lam -= self.lamp;
        const coslam = Math.cos(lam);
        const sinphi = Math.sin(phi);
        const cosphi = Math.cos(phi);
        lp.x = Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam - self.cphip * sinphi);
        lp.y = Math.asin(self.sphip * sinphi + self.cphip * cosphi * coslam);
    }
    lp.x = (0, _adjustLonDefault.default)(lp.x + self.long0);
    return lp;
}
/**
 * Inverse (x, y) to (lng, lat) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function inverseTransverse(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, _values.D2R);
        lp.y *= (0, _values.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        const cosphi = Math.cos(phi);
        lam -= self.lamp;
        lp.x = Math.atan2(cosphi * Math.sin(lam), -1 * Math.sin(phi));
        lp.y = Math.asin(cosphi * Math.cos(lam));
    }
    lp.x = (0, _adjustLonDefault.default)(lp.x + self.long0);
    return lp;
}
var names = [
    'General Oblique Transformation',
    'General_Oblique_Transformation',
    'ob_tran'
];
exports.default = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

},{"../common/adjust_lon":"l07Jx","../constants/values":"8tAZZ","../Proj":"fIBov","./longlat":"4A0lU","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"QJU1H":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clone", ()=>clone);
parcelHelpers.export(exports, "cloneProperties", ()=>cloneProperties);
parcelHelpers.export(exports, "default", ()=>index_default);
function clone(geojson) {
    if (!geojson) throw new Error("geojson is required");
    switch(geojson.type){
        case "Feature":
            return cloneFeature(geojson);
        case "FeatureCollection":
            return cloneFeatureCollection(geojson);
        case "Point":
        case "LineString":
        case "Polygon":
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
        case "GeometryCollection":
            return cloneGeometry(geojson);
        default:
            throw new Error("unknown GeoJSON type");
    }
}
function cloneFeature(geojson) {
    const cloned = {
        type: "Feature"
    };
    Object.keys(geojson).forEach((key)=>{
        switch(key){
            case "type":
            case "properties":
            case "geometry":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    cloned.properties = cloneProperties(geojson.properties);
    if (geojson.geometry == null) cloned.geometry = null;
    else cloned.geometry = cloneGeometry(geojson.geometry);
    return cloned;
}
function cloneProperties(properties) {
    const cloned = {};
    if (!properties) return cloned;
    Object.keys(properties).forEach((key)=>{
        const value = properties[key];
        if (typeof value === "object") {
            if (value === null) cloned[key] = null;
            else if (Array.isArray(value)) cloned[key] = value.map((item)=>{
                return item;
            });
            else cloned[key] = cloneProperties(value);
        } else cloned[key] = value;
    });
    return cloned;
}
function cloneFeatureCollection(geojson) {
    const cloned = {
        type: "FeatureCollection"
    };
    Object.keys(geojson).forEach((key)=>{
        switch(key){
            case "type":
            case "features":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    cloned.features = geojson.features.map((feature)=>{
        return cloneFeature(feature);
    });
    return cloned;
}
function cloneGeometry(geometry) {
    const geom = {
        type: geometry.type
    };
    if (geometry.bbox) geom.bbox = geometry.bbox;
    if (geometry.type === "GeometryCollection") {
        geom.geometries = geometry.geometries.map((g)=>{
            return cloneGeometry(g);
        });
        return geom;
    }
    geom.coordinates = deepSlice(geometry.coordinates);
    return geom;
}
function deepSlice(coords) {
    const cloned = coords;
    if (typeof cloned[0] !== "object") return cloned.slice();
    return cloned.map((coord)=>{
        return deepSlice(coord);
    });
}
var index_default = clone;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bwWlY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "nearestPointOnLine", ()=>nearestPointOnLine);
// index.ts
var _distance = require("@turf/distance");
var _meta = require("@turf/meta");
var _helpers = require("@turf/helpers");
var _invariant = require("@turf/invariant");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
function nearestPointOnLine(lines, inputPoint, options = {}) {
    if (!lines || !inputPoint) throw new Error("lines and inputPoint are required arguments");
    const inputPos = (0, _invariant.getCoord)(inputPoint);
    let closestPt = (0, _helpers.point)([
        Infinity,
        Infinity
    ], {
        lineStringIndex: -1,
        segmentIndex: -1,
        totalDistance: -1,
        lineDistance: -1,
        segmentDistance: -1,
        pointDistance: Infinity,
        // deprecated properties START
        multiFeatureIndex: -1,
        index: -1,
        location: -1,
        dist: Infinity
    });
    let totalDistance = 0;
    let lineDistance = 0;
    let currentLineStringIndex = -1;
    (0, _meta.flattenEach)(lines, function(line, _featureIndex, lineStringIndex) {
        if (currentLineStringIndex !== lineStringIndex) {
            currentLineStringIndex = lineStringIndex;
            lineDistance = 0;
        }
        const coords = (0, _invariant.getCoords)(line);
        for(let i = 0; i < coords.length - 1; i++){
            const start = (0, _helpers.point)(coords[i]);
            const startPos = (0, _invariant.getCoord)(start);
            const stop = (0, _helpers.point)(coords[i + 1]);
            const stopPos = (0, _invariant.getCoord)(stop);
            const segmentLength = (0, _distance.distance)(start, stop, options);
            let intersectPos;
            let wasEnd;
            if (stopPos[0] === inputPos[0] && stopPos[1] === inputPos[1]) [intersectPos, wasEnd] = [
                stopPos,
                true
            ];
            else if (startPos[0] === inputPos[0] && startPos[1] === inputPos[1]) [intersectPos, wasEnd] = [
                startPos,
                false
            ];
            else [intersectPos, wasEnd] = nearestPointOnSegment(startPos, stopPos, inputPos);
            const pointDistance = (0, _distance.distance)(inputPoint, intersectPos, options);
            if (pointDistance < closestPt.properties.pointDistance) {
                const segmentDistance = (0, _distance.distance)(start, intersectPos, options);
                closestPt = (0, _helpers.point)(intersectPos, {
                    lineStringIndex,
                    // Legacy behaviour where index progresses to next segment # if we
                    // went with the end point this iteration.
                    segmentIndex: wasEnd ? i + 1 : i,
                    totalDistance: totalDistance + segmentDistance,
                    lineDistance: lineDistance + segmentDistance,
                    segmentDistance,
                    pointDistance,
                    // deprecated properties START
                    multiFeatureIndex: -1,
                    index: -1,
                    location: -1,
                    dist: Infinity
                });
                closestPt.properties = __spreadProps(__spreadValues({}, closestPt.properties), {
                    multiFeatureIndex: closestPt.properties.lineStringIndex,
                    index: closestPt.properties.segmentIndex,
                    location: closestPt.properties.totalDistance,
                    dist: closestPt.properties.pointDistance
                });
            }
            totalDistance += segmentLength;
            lineDistance += segmentLength;
        }
    });
    return closestPt;
}
function dot(v1, v2) {
    const [v1x, v1y, v1z] = v1;
    const [v2x, v2y, v2z] = v2;
    return v1x * v2x + v1y * v2y + v1z * v2z;
}
function cross(v1, v2) {
    const [v1x, v1y, v1z] = v1;
    const [v2x, v2y, v2z] = v2;
    return [
        v1y * v2z - v1z * v2y,
        v1z * v2x - v1x * v2z,
        v1x * v2y - v1y * v2x
    ];
}
function magnitude(v) {
    return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2) + Math.pow(v[2], 2));
}
function normalize(v) {
    const mag = magnitude(v);
    return [
        v[0] / mag,
        v[1] / mag,
        v[2] / mag
    ];
}
function lngLatToVector(a) {
    const lat = (0, _helpers.degreesToRadians)(a[1]);
    const lng = (0, _helpers.degreesToRadians)(a[0]);
    return [
        Math.cos(lat) * Math.cos(lng),
        Math.cos(lat) * Math.sin(lng),
        Math.sin(lat)
    ];
}
function vectorToLngLat(v) {
    const [x, y, z] = v;
    const zClamp = Math.min(Math.max(z, -1), 1);
    const lat = (0, _helpers.radiansToDegrees)(Math.asin(zClamp));
    const lng = (0, _helpers.radiansToDegrees)(Math.atan2(y, x));
    return [
        lng,
        lat
    ];
}
function nearestPointOnSegment(posA, posB, posC) {
    const A = lngLatToVector(posA);
    const B = lngLatToVector(posB);
    const C = lngLatToVector(posC);
    const segmentAxis = cross(A, B);
    if (segmentAxis[0] === 0 && segmentAxis[1] === 0 && segmentAxis[2] === 0) {
        if (dot(A, B) > 0) return [
            [
                ...posB
            ],
            true
        ];
        else return [
            [
                ...posC
            ],
            false
        ];
    }
    const targetAxis = cross(segmentAxis, C);
    if (targetAxis[0] === 0 && targetAxis[1] === 0 && targetAxis[2] === 0) return [
        [
            ...posB
        ],
        true
    ];
    const intersectionAxis = cross(targetAxis, segmentAxis);
    const I1 = normalize(intersectionAxis);
    const I2 = [
        -I1[0],
        -I1[1],
        -I1[2]
    ];
    const I = dot(C, I1) > dot(C, I2) ? I1 : I2;
    const segmentAxisNorm = normalize(segmentAxis);
    const cmpAI = dot(cross(A, I), segmentAxisNorm);
    const cmpIB = dot(cross(I, B), segmentAxisNorm);
    if (cmpAI >= 0 && cmpIB >= 0) return [
        vectorToLngLat(I),
        false
    ];
    if (dot(A, C) > dot(B, C)) return [
        [
            ...posA
        ],
        false
    ];
    else return [
        [
            ...posB
        ],
        true
    ];
}
var index_default = nearestPointOnLine;

},{"@turf/distance":"7dX7I","@turf/meta":"7ABec","@turf/helpers":"ityOQ","@turf/invariant":"8Sv4q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7dX7I":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "distance", ()=>distance);
var _invariant = require("@turf/invariant");
var _helpers = require("@turf/helpers");
function distance(from, to, options = {}) {
    var coordinates1 = (0, _invariant.getCoord)(from);
    var coordinates2 = (0, _invariant.getCoord)(to);
    var dLat = (0, _helpers.degreesToRadians)(coordinates2[1] - coordinates1[1]);
    var dLon = (0, _helpers.degreesToRadians)(coordinates2[0] - coordinates1[0]);
    var lat1 = (0, _helpers.degreesToRadians)(coordinates1[1]);
    var lat2 = (0, _helpers.degreesToRadians)(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return (0, _helpers.radiansToLength)(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
var index_default = distance;

},{"@turf/invariant":"8Sv4q","@turf/helpers":"ityOQ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8Sv4q":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "collectionOf", ()=>collectionOf);
parcelHelpers.export(exports, "containsNumber", ()=>containsNumber);
parcelHelpers.export(exports, "featureOf", ()=>featureOf);
parcelHelpers.export(exports, "geojsonType", ()=>geojsonType);
parcelHelpers.export(exports, "getCoord", ()=>getCoord);
parcelHelpers.export(exports, "getCoords", ()=>getCoords);
parcelHelpers.export(exports, "getGeom", ()=>getGeom);
parcelHelpers.export(exports, "getType", ()=>getType);
var _helpers = require("@turf/helpers");
function getCoord(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return [
            ...coord.geometry.coordinates
        ];
        if (coord.type === "Point") return [
            ...coord.coordinates
        ];
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return [
        ...coord
    ];
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords(coords) {
    if (Array.isArray(coords)) return coords;
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function containsNumber(coordinates) {
    if (coordinates.length > 1 && (0, _helpers.isNumber)(coordinates[0]) && (0, _helpers.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return containsNumber(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function geojsonType(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function featureOf(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function collectionOf(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for (const feature of featureCollection.features){
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function getGeom(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function getType(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

},{"@turf/helpers":"ityOQ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lgD6Y":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "lineSlice", ()=>lineSlice);
var _invariant = require("@turf/invariant");
var _helpers = require("@turf/helpers");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
function lineSlice(startPt, stopPt, line) {
    const coords = (0, _invariant.getCoords)(line);
    if ((0, _invariant.getType)(line) !== "LineString") throw new Error("line must be a LineString");
    const startVertex = (0, _nearestPointOnLine.nearestPointOnLine)(line, startPt);
    const stopVertex = (0, _nearestPointOnLine.nearestPointOnLine)(line, stopPt);
    fixSegmentIndexBounds(line, startVertex);
    fixSegmentIndexBounds(line, stopVertex);
    const ends = startVertex.properties.segmentIndex <= stopVertex.properties.segmentIndex ? [
        startVertex,
        stopVertex
    ] : [
        stopVertex,
        startVertex
    ];
    const clipCoords = [
        ends[0].geometry.coordinates
    ];
    for(let i = ends[0].properties.segmentIndex + 1; i < ends[1].properties.segmentIndex + 1; i++)clipCoords.push(coords[i]);
    clipCoords.push(ends[1].geometry.coordinates);
    return (0, _helpers.lineString)(clipCoords, line.type === "Feature" ? line.properties : {});
}
function fixSegmentIndexBounds(line, vertex) {
    let geometry = line.type === "Feature" ? line.geometry : line;
    if (vertex.properties.segmentIndex >= geometry.coordinates.length - 1) vertex.properties.segmentIndex = geometry.coordinates.length - 2;
}
var index_default = lineSlice;

},{"@turf/invariant":"8Sv4q","@turf/helpers":"ityOQ","@turf/nearest-point-on-line":"bwWlY","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dM5mO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Orbis curvature (physical curvature * 10000, right = negative) -> NDS Live
// 10-bit curvature (0-1023, centered at 511, right = >511). The two domains
// use opposite signs, so the sign is flipped once, then a progressively
// coarser piecewise scale is applied as |c| grows. Table per
// https://tomtom.atlassian.net/wiki/spaces/AMF/pages/836405587 (see also the
// nds-orbis-curvature skill, which implements the same table in Python).
parcelHelpers.export(exports, "orbisCurvatureToNds", ()=>orbisCurvatureToNds);
// Lateral-acceleration-derived speed (km/h) from a TomTom curvature value.
// radiusMeters = 10000 / |curvature|. Capped at 130 km/h.
parcelHelpers.export(exports, "maxSpeedFromCurvature", ()=>maxSpeedFromCurvature);
// Display string "X km/h (at Y m/s² lateral acceleration)" — surfaces the
// design lateral-accel threshold used to derive the speed. When the result
// hits the 130 km/h cap, the lateral-accel threshold was not the limiter,
// so we surface that instead.
parcelHelpers.export(exports, "maxSpeedDisplayFromCurvature", ()=>maxSpeedDisplayFromCurvature);
// Display rows for a `curvature_at_junction` value — the same three rows the
// WKT viewer renders on hover. Empty array if missing or zero.
parcelHelpers.export(exports, "curvatureAtJunctionKeyValues", ()=>curvatureAtJunctionKeyValues);
parcelHelpers.export(exports, "getCurvatureStyleNormalOrbisSD", ()=>getCurvatureStyleNormalOrbisSD);
parcelHelpers.export(exports, "getCurvatureStyleClickOrbisSD", ()=>getCurvatureStyleClickOrbisSD);
parcelHelpers.export(exports, "getCurvatureStyleHoverOrbisSD", ()=>getCurvatureStyleHoverOrbisSD);
parcelHelpers.export(exports, "getCurvatureStyleNormalOrbisHD", ()=>getCurvatureStyleNormalOrbisHD);
parcelHelpers.export(exports, "getCurvatureStyleClickOrbisHD", ()=>getCurvatureStyleClickOrbisHD);
parcelHelpers.export(exports, "getCurvatureStyleHoverOrbisHD", ()=>getCurvatureStyleHoverOrbisHD);
parcelHelpers.export(exports, "getCurvatureStyleNormalGenesis", ()=>getCurvatureStyleNormalGenesis);
parcelHelpers.export(exports, "getCurvatureStyleClickGenesis", ()=>getCurvatureStyleClickGenesis);
parcelHelpers.export(exports, "getCurvatureStyleHoverGenesis", ()=>getCurvatureStyleHoverGenesis);
var _style = require("ol/style");
var _colorScale = require("./util/colorScale");
var _linearStyling = require("./linearStyling");
var _geom = require("ol/geom");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _color = require("ol/color");
var _curvatureLinearHandler = require("../addfeaturehandlers/CurvatureLinearHandler");
var _propertyExtraction = require("./propertyExtraction");
var _laneDirectionArrows = require("./util/laneDirectionArrows");
const rdylgnInterpolator = (t)=>{
    const [r, g, b] = (0, _colorScale.spectralColor)(t);
    return `rgb(${r},${g},${b})`;
};
// Max lateral acceleration assumed when deriving a comfortable speed from
// curvature. 0.3g ≈ 2.94 m/s².
const MAX_LATERAL_ACCELERATION_MS2 = 3.0;
function orbisCurvatureToNds(orbisCurvature) {
    const c = -(orbisCurvature / 10000);
    const absC = Math.abs(c);
    const sign = c >= 0 ? 1 : -1;
    let v;
    if (absC < 0.00064) v = 511 + Math.round(c * 100000);
    else if (absC < 0.00192) v = 511 + sign * 32 + Math.round(c * 100000 / 2);
    else if (absC < 0.00448) v = 511 + sign * 80 + Math.round(c * 100000 / 4);
    else if (absC < 0.0096) v = 511 + sign * 136 + Math.round(c * 100000 / 8);
    else if (absC < 0.01984) v = 511 + sign * 196 + Math.round(c * 100000 / 16);
    else if (absC < 0.04032) v = 511 + sign * 258 + Math.round(c * 100000 / 32);
    else if (absC < 0.08128) v = 511 + sign * 321 + Math.round(c * 100000 / 64);
    else if (absC < 0.16192) v = 511 + sign * 384.5 + Math.round(c * 100000 / 128);
    else v = 511 + sign * 511;
    return Math.trunc(Math.max(0, Math.min(1023, v)));
}
function maxSpeedFromCurvature(curvature) {
    if (curvature === 0) return 130;
    const radius = 10000 / Math.abs(curvature);
    const maxSpeedMs = Math.sqrt(MAX_LATERAL_ACCELERATION_MS2 * radius);
    return Math.min(Math.round(maxSpeedMs * 3.6), 130);
}
function maxSpeedDisplayFromCurvature(curvature) {
    const speedKmh = maxSpeedFromCurvature(curvature);
    if (speedKmh >= 130) return `${speedKmh} km/h (capped at 130 km/h speed limit)`;
    return `${speedKmh} km/h (at ${MAX_LATERAL_ACCELERATION_MS2.toFixed(2)} m/s\xb2 lateral acceleration)`;
}
function curvatureAtJunctionKeyValues(curvatureAtJunction) {
    if (curvatureAtJunction === undefined || curvatureAtJunction === null) return [];
    const curvature = Number(curvatureAtJunction);
    if (curvature === 0 || isNaN(curvature)) return [];
    const radius = 10000 / Math.abs(curvature);
    return [
        [
            "curvature_at_junction",
            curvature
        ],
        [
            "NDS curvature",
            orbisCurvatureToNds(curvature)
        ],
        [
            "radius",
            Math.round(radius) + " m"
        ],
        [
            "max speed (based on curvature)",
            maxSpeedDisplayFromCurvature(curvature)
        ]
    ];
}
function getCurvatureStyleNormalOrbisSD(feature, resolution) {
    return getCurvatureColorStyle(feature, false, false, rdylgnInterpolator, resolution);
}
function getCurvatureStyleClickOrbisSD(feature, resolution) {
    return getCurvatureColorStyle(feature, true, false, rdylgnInterpolator, resolution);
}
function getCurvatureStyleHoverOrbisSD(feature, resolution) {
    return getCurvatureColorStyle(feature, false, true, rdylgnInterpolator, resolution);
}
function getCurvatureStyleNormalOrbisHD(feature, resolution) {
    return getCurvatureColorStyle(feature, false, false, rdylgnInterpolator, resolution);
}
function getCurvatureStyleClickOrbisHD(feature, resolution) {
    return getCurvatureColorStyle(feature, true, false, rdylgnInterpolator, resolution);
}
function getCurvatureStyleHoverOrbisHD(feature, resolution) {
    return getCurvatureColorStyle(feature, false, true, rdylgnInterpolator, resolution);
}
function getCurvatureStyleNormalGenesis(feature, resolution) {
    return getCurvatureColorStyle(feature, false, false, rdylgnInterpolator, resolution);
}
function getCurvatureStyleClickGenesis(feature, resolution) {
    return getCurvatureColorStyle(feature, true, false, rdylgnInterpolator, resolution);
}
function getCurvatureStyleHoverGenesis(feature, resolution) {
    return getCurvatureColorStyle(feature, false, true, rdylgnInterpolator, resolution);
}
function getCurvatureColorStyle(feature, click, hover, colorInterpolator, resolution) {
    let width, backgroundColor, backgroundWidth;
    // Style for reconstructed curvature-linear curves
    const featureType = feature.get("type");
    if (featureType === (0, _curvatureLinearHandler.CURVATURE_LINEAR_RECONSTRUCTED_TYPE)) {
        let color = colorInterpolator(1);
        const bgColor = (0, _color.asArray)("white").slice();
        bgColor[3] = 0.6;
        if (hover || click) return [
            new (0, _style.Style)({
                zIndex: 10,
                stroke: new (0, _style.Stroke)({
                    color: bgColor,
                    width: 8
                })
            }),
            new (0, _style.Style)({
                zIndex: 11,
                stroke: new (0, _style.Stroke)({
                    color: color,
                    width: 4,
                    lineDash: [
                        5,
                        5
                    ]
                })
            })
        ];
        return [
            new (0, _style.Style)({
                zIndex: 8,
                stroke: new (0, _style.Stroke)({
                    color: bgColor,
                    width: 6
                })
            }),
            new (0, _style.Style)({
                zIndex: 9,
                stroke: new (0, _style.Stroke)({
                    color: color,
                    width: 3,
                    lineDash: [
                        5,
                        5
                    ]
                })
            })
        ];
    }
    let hdmapType = feature.get("hdmap_type");
    if (hdmapType === undefined) hdmapType = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-hdmap");
    const osmHighway = feature.get("osm-highway");
    if (hdmapType !== undefined && hdmapType !== "lane_center_line" && hdmapType !== "lane_trajectory_line") return;
    const laneDirection = (0, _laneDirectionArrows.LANE_TYPES).includes(hdmapType) ? (0, _propertyExtraction.getProperty)(feature, "lane_direction") : undefined;
    let orbisCurvature = feature.get("orbis-curvature");
    if (orbisCurvature === undefined) orbisCurvature = feature.get("orbis-curvature:linear");
    if (orbisCurvature === undefined) orbisCurvature = feature.get("orbis-curvature:linear");
    if (orbisCurvature === undefined) orbisCurvature = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-curvature:linear");
    if (orbisCurvature === undefined) {
        let color;
        if (osmHighway === undefined) color = "grey";
        else if (!(0, _supportedHighwayTypes.CURVATURE_HIGHWAY_TYPES).includes(osmHighway)) color = "black";
        else color = "grey";
        backgroundColor = "white";
        width = 1;
        backgroundWidth = 4;
        const arrows = (0, _laneDirectionArrows.getLaneDirectionArrowStyles)(feature, laneDirection, "black", resolution);
        if (hover || click) return [
            new (0, _style.Style)({
                zIndex: 0,
                stroke: new (0, _style.Stroke)({
                    color: backgroundColor,
                    width: backgroundWidth
                })
            }),
            new (0, _style.Style)({
                zIndex: 1,
                stroke: new (0, _style.Stroke)({
                    color: color,
                    width: width
                })
            }),
            ...arrows
        ];
        return [
            new (0, _style.Style)({
                zIndex: 1,
                stroke: new (0, _style.Stroke)({
                    color: color,
                    width: width
                })
            }),
            ...arrows
        ];
    } else {
        if (hover) backgroundColor = "black";
        else if (click) backgroundColor = "orange";
        else backgroundColor = "black";
        if (hover || click) {
            width = 7;
            backgroundWidth = 10;
        } else {
            width = 5;
            backgroundWidth = 9;
        }
        const flowStyle = (0, _linearStyling.getLinearTagFlowStyle)(orbisCurvature, width, feature, colorInterpolator, "curvature", 7);
        const styles = [
            flowStyle,
            new (0, _style.Style)({
                zIndex: 6,
                stroke: new (0, _style.Stroke)({
                    color: backgroundColor,
                    width: backgroundWidth
                })
            })
        ];
        // Bars at each curvature LR element (value data point), not at each geometry coordinate
        const geometry = feature.getGeometry();
        if (geometry && geometry.getType && geometry.getType() === "LineString") {
            const lenCm = (0, _linearStyling.getLengthCm)(feature);
            if (lenCm > 0) {
                const lrChain = (0, _linearStyling.lrDecode)("bla:linear", orbisCurvature);
                const offsets = lrChain?.elements?.map((el)=>el.getStartDistance() / lenCm).filter((t)=>Number.isFinite(t)).map((t)=>Math.min(1, Math.max(0, t)));
                if (offsets && offsets.length) {
                    const line = /** @type {LineString} */ geometry;
                    // helper: point + tangent at normalized offset along the line
                    const pointAndTangentAt = (t)=>{
                        if (t <= 0) {
                            const a = line.getCoordinateAt(0);
                            const b = line.getCoordinateAt(1e-6);
                            return {
                                x: a[0],
                                y: a[1],
                                dx: b[0] - a[0],
                                dy: b[1] - a[1]
                            };
                        }
                        if (t >= 1) {
                            const a = line.getCoordinateAt(1);
                            const b = line.getCoordinateAt(1 - 1e-6);
                            return {
                                x: a[0],
                                y: a[1],
                                dx: a[0] - b[0],
                                dy: a[1] - b[1]
                            };
                        }
                        const p = line.getCoordinateAt(t);
                        const p0 = line.getCoordinateAt(Math.max(0, t - 1e-6));
                        const p1 = line.getCoordinateAt(Math.min(1, t + 1e-6));
                        return {
                            x: p[0],
                            y: p[1],
                            dx: p1[0] - p0[0],
                            dy: p1[1] - p0[1]
                        };
                    };
                    for (const t of offsets){
                        const { x, y, dx, dy } = pointAndTangentAt(t);
                        const mag = Math.hypot(dx, dy);
                        if (!mag) continue;
                        const ux = dx / mag;
                        const uy = dy / mag;
                        // perpendicular unit vector
                        const px = -uy;
                        const py = ux;
                        // Screen-pixel length (not map units) so it can't stretch out far enough
                        // at high zoom to cross into the lane-direction arrows offset from the
                        // same line (see ARROW_OFFSET_PX in laneDirectionArrows.js). Sized
                        // relative to backgroundWidth (the line's casing) so it always pokes a
                        // few px past the casing on each side instead of being swallowed by it.
                        const barLengthPx = backgroundWidth + 8;
                        const half = barLengthPx * (resolution || 1) / 2;
                        const x1 = x + px * half;
                        const y1 = y + py * half;
                        const x2 = x - px * half;
                        const y2 = y - py * half;
                        styles.push(new (0, _style.Style)({
                            geometry: new (0, _geom.LineString)([
                                [
                                    x1,
                                    y1
                                ],
                                [
                                    x2,
                                    y2
                                ]
                            ]),
                            stroke: new (0, _style.Stroke)({
                                color: "rgba(0, 0, 0, 0.5)",
                                width: 2
                            })
                        }));
                    }
                }
            }
        }
        styles.push(...(0, _laneDirectionArrows.getLaneDirectionArrowStyles)(feature, laneDirection, "black", resolution));
        return styles;
    }
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./util/colorScale":"dOPOB","./linearStyling":"1P32G","ol/geom":[["LineString","223qD","default"]],"./supportedHighwayTypes":"90HT0","ol/color":"jC16r","../addfeaturehandlers/CurvatureLinearHandler":"1rcYN","./propertyExtraction":"i6VX6","./util/laneDirectionArrows":"cYzT8","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1rcYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CURVATURE_LINEAR_RECONSTRUCTED_TYPE", ()=>CURVATURE_LINEAR_RECONSTRUCTED_TYPE);
parcelHelpers.export(exports, "curvatureLinearHandler", ()=>curvatureLinearHandler);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _geom = require("ol/geom");
var _linearInterpolation = require("../style/util/linearInterpolation");
var _lrDecoding = require("../style/util/lrDecoding");
var _propertyExtraction = require("../style/propertyExtraction");
const CURVATURE_LINEAR_RECONSTRUCTED_TYPE = "curvature-linear-reconstructed";
const curvatureLinearHandler = (event)=>{
    const features = event.target.getFeatures();
    features.forEach((feature)=>{
        if (feature.getGeometry()?.getType() !== "LineString") return;
        // The curvature linear value is stored as "orbis-curvature:linear" on the feature
        let curvatureLinearValue = feature.get("orbis-curvature:linear");
        // without tag-selection in the WFS
        if (curvatureLinearValue === undefined) curvatureLinearValue = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-curvature:linear");
        if (!curvatureLinearValue || !curvatureLinearValue.includes("#")) return;
        // Parse the curvature:linear tag using lrDecode
        // Format: "0#1;50#300;100#0"
        const lrChain = (0, _lrDecoding.lrDecode)("curvature:linear", curvatureLinearValue);
        const dataPoints = lrChain.elements.map((element)=>({
                distance: element.getStartDistance(),
                value: Number(element.getValue())
            }));
        if (dataPoints.length < 2) return;
        // Get the feature's geometry to determine start point and end point
        const geometry = feature.getGeometry();
        const coordinates = geometry.getCoordinates();
        if (coordinates.length < 2) return;
        // Start point and end point in EPSG:3857
        const startPoint = coordinates[0];
        const endPoint = coordinates[coordinates.length - 1];
        // Total length of the curvature data in centimeters
        const totalLengthCm = dataPoints[dataPoints.length - 1].distance;
        if (totalLengthCm <= 0) return;
        // We need to convert from real-world cm to EPSG:3857 units.
        // EPSG:3857 meters per real meter depends on latitude.
        // Use the start point to compute the scale factor.
        const mercatorScale = getMercatorScale(startPoint[1]);
        // Reconstruct the curve in a local coordinate system (origin at startPoint,
        // initial heading = 0), so we can later fit it to the actual start/end points.
        const localCoords = reconstructCurveLocal(dataPoints, mercatorScale);
        // Fit the local curve to the actual start→end vector via rotation + uniform scale.
        const reconstructedCoords = fitCurveToEndpoints(localCoords, startPoint, endPoint);
        if (reconstructedCoords.length < 2) return;
        // Create a new feature for the reconstructed curve
        const curveFeature = new (0, _featureDefault.default)({
            geometry: new (0, _geom.LineString)(reconstructedCoords)
        });
        curveFeature.set("type", CURVATURE_LINEAR_RECONSTRUCTED_TYPE);
        curveFeature.set("source-feature-id", feature.getId());
        curveFeature.set("nonInteractive", true);
        event.target.addFeature(curveFeature);
    });
};
/**
 * Get the Mercator scale factor at a given Y coordinate in EPSG:3857.
 * In EPSG:3857, 1 unit at the equator = 1 meter, but at other latitudes
 * the scale is sec(latitude). So to convert real-world meters to 3857 units:
 * epsg3857_units = real_meters * mercatorScale
 */ function getMercatorScale(y3857) {
    // Convert 3857 Y to latitude in radians
    // lat = 2 * atan(exp(y / 6378137)) - pi/2
    const EARTH_RADIUS = 6378137;
    const latRad = 2 * Math.atan(Math.exp(y3857 / EARTH_RADIUS)) - Math.PI / 2;
    // Mercator scale = 1 / cos(lat)
    return 1 / Math.cos(latRad);
}
/**
 * Reconstruct a curve from curvature data points in a local coordinate system.
 * The curve starts at the origin [0, 0] with an initial heading of 0 (pointing
 * along the positive X axis). The caller is responsible for rotating, scaling,
 * and translating the result to world coordinates via fitCurveToEndpoints().
 *
 * @param {Array<{distance: number, value: number}>} dataPoints - Curvature data (distance in cm, value is curvature)
 * @param {number} mercatorScale - Scale factor to convert real meters to EPSG:3857 units
 * @returns {Array<number[]>} Array of [x, y] coordinates in local space
 */ function reconstructCurveLocal(dataPoints, mercatorScale) {
    const totalLengthCm = dataPoints[dataPoints.length - 1].distance;
    const interpolateCurvature = (0, _linearInterpolation.createLinearInterpolator)(dataPoints);
    // Use a step size of about 10 cm for smooth curves, but at least 100 steps
    const numSteps = Math.max(100, Math.ceil(totalLengthCm / 10));
    const dsCm = totalLengthCm / numSteps; // step size in cm
    const dsM = dsCm / 100; // step size in real-world meters
    const points = [
        [
            0,
            0
        ]
    ];
    let x = 0;
    let y = 0;
    let heading = 0; // start heading = 0 (along positive X axis)
    for(let i = 0; i < numSteps; i++){
        const distanceCm = (i + 0.5) * dsCm; // midpoint of step for better accuracy
        // Get interpolated curvature at this distance
        const curvatureValue = interpolateCurvature(distanceCm);
        // Convert curvature value to 1/m: κ = curvatureValue / 10000
        const kappa = curvatureValue / 10000;
        // Update heading: dθ = κ * ds (in meters)
        heading += kappa * dsM;
        // Step forward
        const ds3857 = dsM * mercatorScale;
        x += Math.cos(heading) * ds3857;
        y += Math.sin(heading) * ds3857;
        points.push([
            x,
            y
        ]);
    }
    return points;
}
/**
 * Rotate and uniformly scale a locally-reconstructed curve so that it starts at
 * `startPoint` and its last point coincides exactly with `endPoint`.
 *
 * The local curve already starts at [0, 0]. We compute the rotation angle and
 * scale factor that map the local endpoint to the vector (endPoint - startPoint),
 * then apply the same transform to every point and translate to world space.
 *
 * @param {Array<number[]>} localCoords - Points in local space (first point is origin)
 * @param {number[]} startPoint - [x, y] world coordinates for the curve start
 * @param {number[]} endPoint - [x, y] world coordinates the curve end must hit
 * @returns {Array<number[]>} Transformed coordinates in EPSG:3857
 */ function fitCurveToEndpoints(localCoords, startPoint, endPoint) {
    const localEnd = localCoords[localCoords.length - 1];
    const localEndX = localEnd[0];
    const localEndY = localEnd[1];
    // Vector the curve must match in world space
    const targetDX = endPoint[0] - startPoint[0];
    const targetDY = endPoint[1] - startPoint[1];
    const localLen = Math.sqrt(localEndX * localEndX + localEndY * localEndY);
    const targetLen = Math.sqrt(targetDX * targetDX + targetDY * targetDY);
    // If either length is (near) zero, just return a straight line
    if (localLen < 1e-10 || targetLen < 1e-10) return localCoords.map((_, i)=>{
        const t = i / (localCoords.length - 1);
        return [
            startPoint[0] + t * targetDX,
            startPoint[1] + t * targetDY
        ];
    });
    // Rotation angle: angle of target vector minus angle of local endpoint vector
    const localAngle = Math.atan2(localEndY, localEndX);
    const targetAngle = Math.atan2(targetDY, targetDX);
    const rotation = targetAngle - localAngle;
    // Uniform scale factor
    const scale = targetLen / localLen;
    const cosR = Math.cos(rotation);
    const sinR = Math.sin(rotation);
    return localCoords.map(([lx, ly])=>{
        const rx = lx * cosR - ly * sinR;
        const ry = lx * sinR + ly * cosR;
        return [
            startPoint[0] + rx * scale,
            startPoint[1] + ry * scale
        ];
    });
}

},{"ol/Feature":"iVSSP","ol/geom":[["LineString","223qD","default"]],"../style/util/linearInterpolation":"dzt22","../style/util/lrDecoding":"elFsF","../style/propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dzt22":[function(require,module,exports,__globalThis) {
/**
 * Creates an interpolation function from an array of data points.
 *
 * @param {Array<{distance: number, value: number}>} dataPoints - Sorted array of data points
 *   where `distance` is the position along the geometry and `value` is the value at that position.
 * @returns {function(number): number} A function that takes a distance and returns the interpolated value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLinearInterpolator", ()=>createLinearInterpolator);
function createLinearInterpolator(dataPoints) {
    if (dataPoints.length === 0) return ()=>0;
    if (dataPoints.length === 1) return ()=>dataPoints[0].value;
    return function interpolate(distance) {
        if (distance <= dataPoints[0].distance) return dataPoints[0].value;
        if (distance >= dataPoints[dataPoints.length - 1].distance) return dataPoints[dataPoints.length - 1].value;
        for(let i = 0; i < dataPoints.length - 1; i++){
            const p0 = dataPoints[i];
            const p1 = dataPoints[i + 1];
            if (distance >= p0.distance && distance <= p1.distance) {
                const range = p1.distance - p0.distance;
                if (range === 0) return p0.value;
                const t = (distance - p0.distance) / range;
                return p0.value + t * (p1.value - p0.value);
            }
        }
        return 0;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"elFsF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lrDecode", ()=>lrDecode);
parcelHelpers.export(exports, "lrDecodeRelation", ()=>lrDecodeRelation);
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
function lrDecode(key, lrTag) {
    const decoder = new (0, _orbisLrSdk.LRDecoder)().withInterpolationSpecType((0, _orbisLrSdk.InterpolationSpecType).TAG);
    return decoder.decode(key, lrTag);
}
function lrDecodeRelation(lrTag) {
    const decoder = new (0, _orbisLrSdk.LRDecoder)().withInterpolationSpecType((0, _orbisLrSdk.InterpolationSpecType).ROLE);
    return decoder.decode(lrTag);
}

},{"@orbis-lr-sdk/orbis-lr-sdk":"04bfk","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cYzT8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANE_TYPES", ()=>LANE_TYPES);
// Driving direction = geometry directionality (digitized start->end heading) combined
// with lane_direction (forward/backward/both/none). Each spec is a headingOffset
// against the digitized heading: forward [0], backward [PI], both [0, PI] (rendered
// as a double-headed arrow). "none"/missing returns [].
parcelHelpers.export(exports, "laneDirectionArrowSpecs", ()=>laneDirectionArrowSpecs);
// Builds the halo+arrow Style pair for ONE arrow centered on `point`, given the
// geometry's digitized heading `rotation` and a `{headingOffset}` spec from
// laneDirectionArrowSpecs(). "backward"'s headingOffset of Math.PI flips the
// travel direction.
parcelHelpers.export(exports, "buildArrowStyles", ()=>buildArrowStyles);
parcelHelpers.export(exports, "getLaneDirectionArrowStyles", ()=>getLaneDirectionArrowStyles);
var _geom = require("ol/geom");
var _style = require("ol/style");
var _color = require("ol/color");
var _polylineMjs = require("./polyline.mjs");
const LANE_TYPES = [
    "lane_center_line",
    "lane_trajectory_line"
];
const ARROW_FRACTIONS_LONG = [
    1 / 3,
    2 / 3
];
const ARROW_FRACTIONS_SHORT = [
    0.5
];
// HD lane models chop roads into many short adjacent segments (often 15-30m), each
// carrying its own lane_direction — with two arrows per feature that piles up into
// dense, overlapping clusters at junctions. Below this length (map units, roughly
// meters — ignores Mercator latitude stretch since this is just a clutter heuristic,
// not a measurement) a segment gets a single centered arrow instead of two.
const SHORT_LINE_LENGTH = 30;
// Zooming out brings many more lane segments into view at once (each still drawing
// its own arrow), so density is also capped by resolution (map units/px — roughly
// zoom 19 at the equator for a standard EPSG:3857 view), not just per-segment
// length: past this, arrows stop rendering entirely — at that scale they're too
// small to read and are pure clutter.
const ARROW_HIDE_RESOLUTION = 0.3;
// Faded rather than solid so the arrows read as annotation, not data.
const ARROW_OPACITY = 0.6;
// The arrow is drawn as plain strokes (shaft + two head wings) rather than the
// icon-arrow.png asset: the icon's source pixels are yellow and OL's Icon `color`
// tint is a per-channel multiply, so it can only darken toward black — a white halo
// copy of the icon is impossible. Vector strokes take any color. All lengths are in
// screen pixels (scaled by resolution). The arrow sits directly ON the line,
// centered on the sample point — the white halo plus the above-the-roads zIndex
// keep it legible over the line stroke (an offset-to-the-side placement was tried
// first and read as clutter next to dense parallel lanes). A "both" lane draws two
// opposite arrows centered on the same point, which merge into one double-headed
// arrow.
const SHAFT_LENGTH_PX = 9;
const SHAFT_WIDTH = 1.5;
const HEAD_LENGTH_PX = 4.5;
// Half-angle between each wing and the shaft, radians (~30°).
const HEAD_SPREAD = 0.5;
// White halo behind the whole arrow so the (dark) arrow still reads against dark
// basemaps (satellite, night styles).
const HALO_COLOR = "rgba(255, 255, 255, 1)";
const HALO_EXTRA_WIDTH = 2;
// Above every stroke the curvature/hdmap styles draw (their zIndexes go up to 11
// for hovered reconstructed curves) so the arrows always paint on top of the roads.
const HALO_Z_INDEX = 20;
const ARROW_Z_INDEX = 21;
function withAlpha(color, alpha) {
    const [r, g, b] = (0, _color.asArray)(color);
    return (0, _color.asString)([
        r,
        g,
        b,
        alpha
    ]);
}
function polylineLength(coords) {
    let total = 0;
    for(let i = 1; i < coords.length; i++)total += Math.hypot(coords[i][0] - coords[i - 1][0], coords[i][1] - coords[i - 1][1]);
    return total;
}
function laneDirectionArrowSpecs(laneDirection) {
    if (!laneDirection || laneDirection === "none") return [];
    if (laneDirection === "both") return [
        {
            headingOffset: 0
        },
        {
            headingOffset: Math.PI
        }
    ];
    return [
        {
            headingOffset: laneDirection === "backward" ? Math.PI : 0
        }
    ];
}
function buildArrowStyles(point, rotation, headingOffset, color, resolution) {
    const travelHeading = rotation + headingOffset;
    const res = resolution || 1;
    const half = SHAFT_LENGTH_PX / 2 * res;
    const tip = [
        point[0] + Math.cos(travelHeading) * half,
        point[1] + Math.sin(travelHeading) * half
    ];
    const back = travelHeading + Math.PI;
    const backPoint = (angle, lengthPx)=>[
            tip[0] + Math.cos(angle) * lengthPx * res,
            tip[1] + Math.sin(angle) * lengthPx * res
        ];
    const arrow = new (0, _geom.MultiLineString)([
        [
            backPoint(back, SHAFT_LENGTH_PX),
            tip
        ],
        [
            backPoint(back + HEAD_SPREAD, HEAD_LENGTH_PX),
            tip,
            backPoint(back - HEAD_SPREAD, HEAD_LENGTH_PX)
        ]
    ]);
    return [
        // Halo below, colored arrow on top — the two strokes trace the same
        // geometry, so zIndex alone decides which one shows.
        new (0, _style.Style)({
            geometry: arrow,
            stroke: new (0, _style.Stroke)({
                color: HALO_COLOR,
                width: SHAFT_WIDTH + HALO_EXTRA_WIDTH,
                lineCap: "round",
                lineJoin: "round"
            }),
            zIndex: HALO_Z_INDEX
        }),
        new (0, _style.Style)({
            geometry: arrow,
            stroke: new (0, _style.Stroke)({
                color: withAlpha(color, ARROW_OPACITY),
                width: SHAFT_WIDTH,
                lineCap: "round",
                lineJoin: "round"
            }),
            zIndex: ARROW_Z_INDEX
        })
    ];
}
function getLaneDirectionArrowStyles(feature, laneDirection, color, resolution) {
    const arrowSpecs = laneDirectionArrowSpecs(laneDirection);
    if (!arrowSpecs.length) return [];
    if (resolution && resolution > ARROW_HIDE_RESOLUTION) return [];
    const geometry = feature.getGeometry();
    if (typeof geometry.getCoordinates !== "function") return [];
    const coords = geometry.getCoordinates();
    if (!Array.isArray(coords) || coords.length < 2) return [];
    const arrowFractions = polylineLength(coords) < SHORT_LINE_LENGTH ? ARROW_FRACTIONS_SHORT : ARROW_FRACTIONS_LONG;
    const styles = [];
    for (const fraction of arrowFractions){
        const { point, rotation } = (0, _polylineMjs.sampleAlong)(coords, fraction);
        for (const { headingOffset } of arrowSpecs)styles.push(...buildArrowStyles(point, rotation, headingOffset, color, resolution));
    }
    return styles;
}

},{"ol/geom":[["MultiLineString","5Cre5","default"]],"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/color":"jC16r","./polyline.mjs":"iGzK1","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iGzK1":[function(require,module,exports,__globalThis) {
// Pure polyline geometry helpers for arc rendering. No OpenLayers imports —
// unit-tested with `node --test`. Coordinates are [x, y] in map units (EPSG:3857).
// Right-of-travel normal of heading (tx, ty) is (ty, -tx).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sign of the polyline's net turning (sum of segment cross products):
 * +1 = left/CCW, −1 = right/CW, 0 = straight (or fewer than 3 vertices).
 * Map coordinates (y up). Used to find the inside of a curved arc's bend.
 */ parcelHelpers.export(exports, "turningSign", ()=>turningSign);
/**
 * Rubber-sheet the polyline so its first vertex lands on `startNode` and its last on
 * `endNode`, distributing each end's correction linearly by arc-length fraction.
 * Used to pull a group's overlapping arcs onto shared junction nodes (their raw
 * endpoints drift ~0.5m apart) so they meet before being bowed apart. New array;
 * input not mutated. A <2-point line is returned copied.
 */ parcelHelpers.export(exports, "snapEndpoints", ()=>snapEndpoints);
/**
 * Shift every vertex along its local right-of-travel normal by `distance` map-units
 * (signed: + = right of travel, − = left) — a uniform PARALLEL offset, including the
 * endpoints. Used to separate an overlapping pair so they run side by side the whole
 * length. A constant (un-tapered) offset is deliberate: it keeps the body straight
 * and, crucially, leaves the end tangent undistorted, so the hover curvature circle —
 * which reads its tangent from the arc's last segment — parallel-shifts to hug the
 * offset line instead of being rotated off it by a taper ramp. Returns a new array; a
 * line with no interior vertex (2 points) is returned unshifted (guards the hover
 * tangent probe). Coordinates are not mutated.
 */ parcelHelpers.export(exports, "offsetPolyline", ()=>offsetPolyline);
/**
 * Point + heading at `fraction` (0..1) of the polyline's total length.
 * heading = atan2(dy, dx) of the segment that contains the point.
 */ parcelHelpers.export(exports, "sampleAlong", ()=>sampleAlong);
function rightNormal(tx, ty) {
    const len = Math.hypot(tx, ty);
    if (len === 0) return [
        0,
        0
    ];
    return [
        ty / len,
        -tx / len
    ];
}
// Per-vertex tangent via central difference (endpoints use their one segment).
function tangentAt(coords, i) {
    const prev = coords[Math.max(0, i - 1)];
    const next = coords[Math.min(coords.length - 1, i + 1)];
    return [
        next[0] - prev[0],
        next[1] - prev[1]
    ];
}
function turningSign(coords) {
    let sum = 0;
    for(let i = 1; i < coords.length - 1; i++){
        const ax = coords[i][0] - coords[i - 1][0];
        const ay = coords[i][1] - coords[i - 1][1];
        const bx = coords[i + 1][0] - coords[i][0];
        const by = coords[i + 1][1] - coords[i][1];
        sum += ax * by - ay * bx;
    }
    return Math.sign(sum);
}
function snapEndpoints(coords, startNode, endNode) {
    const n = coords.length;
    if (n < 2) return coords.map((c)=>[
            c[0],
            c[1]
        ]);
    const first = coords[0];
    const last = coords[n - 1];
    const dsx = startNode[0] - first[0];
    const dsy = startNode[1] - first[1];
    const dex = endNode[0] - last[0];
    const dey = endNode[1] - last[1];
    const cum = [
        0
    ];
    let total = 0;
    for(let i = 1; i < n; i++){
        total += Math.hypot(coords[i][0] - coords[i - 1][0], coords[i][1] - coords[i - 1][1]);
        cum.push(total);
    }
    return coords.map((c, i)=>{
        const s = total === 0 ? 0 : cum[i] / total;
        return [
            c[0] + (1 - s) * dsx + s * dex,
            c[1] + (1 - s) * dsy + s * dey
        ];
    });
}
function offsetPolyline(coords, distance) {
    const n = coords.length;
    if (n < 3) return coords.map((c)=>[
            c[0],
            c[1]
        ]);
    return coords.map((c, i)=>{
        const [tx, ty] = tangentAt(coords, i);
        const [nx, ny] = rightNormal(tx, ty);
        return [
            c[0] + nx * distance,
            c[1] + ny * distance
        ];
    });
}
function sampleAlong(coords, fraction) {
    if (coords.length < 2) return {
        point: [
            coords[0][0],
            coords[0][1]
        ],
        rotation: 0
    };
    const segLengths = [];
    let total = 0;
    for(let i = 0; i < coords.length - 1; i++){
        const d = Math.hypot(coords[i + 1][0] - coords[i][0], coords[i + 1][1] - coords[i][1]);
        segLengths.push(d);
        total += d;
    }
    const target = Math.max(0, Math.min(1, fraction)) * total;
    let acc = 0;
    for(let i = 0; i < segLengths.length; i++){
        const next = acc + segLengths[i];
        if (next >= target || i === segLengths.length - 1) {
            const t = segLengths[i] === 0 ? 0 : (target - acc) / segLengths[i];
            const dx = coords[i + 1][0] - coords[i][0];
            const dy = coords[i + 1][1] - coords[i][1];
            return {
                point: [
                    coords[i][0] + dx * t,
                    coords[i][1] + dy * t
                ],
                rotation: Math.atan2(dy, dx)
            };
        }
        acc = next;
    }
    // Unreachable for length >= 2, but keep a defined return.
    const last = coords[coords.length - 1];
    return {
        point: [
            last[0],
            last[1]
        ],
        rotation: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"B4rqX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDMapStyleNormal", ()=>getHDMapStyleNormal);
parcelHelpers.export(exports, "getHDMapStyleClick", ()=>getHDMapStyleClick);
parcelHelpers.export(exports, "getHDMapStyleHover", ()=>getHDMapStyleHover);
var _style = require("ol/style");
var _propertyExtraction = require("./propertyExtraction");
var _laneDirectionArrows = require("./util/laneDirectionArrows");
function getHDMapStyleNormal(feature, resolution) {
    return getHDMapColorStyle(feature, false, false, resolution);
}
function getHDMapStyleClick(feature, resolution) {
    return getHDMapColorStyle(feature, true, false, resolution);
}
function getHDMapStyleHover(feature, resolution) {
    return getHDMapColorStyle(feature, false, true, resolution);
}
function getHDMapColorStyle(feature, click, hover, resolution) {
    let color, width, backgroundColor, backgroundWidth;
    const tags = (0, _propertyExtraction.extractTags)(feature);
    let hdmapType = tags.hdMap;
    if (hdmapType !== undefined) {
        if (hdmapType !== "lane_center_line" && hdmapType !== "lane_trajectory_line") return;
    }
    let type = feature.get("type");
    if (type === "ORBIS_RELATION") return;
    if (hdmapType === "lane_center_line") color = "blue";
    else if (hdmapType === "lane_trajectory_line") color = "red";
    else color = "lightgreen";
    backgroundColor = "white";
    width = 2;
    backgroundWidth = 4;
    const arrows = (0, _laneDirectionArrows.LANE_TYPES).includes(hdmapType) ? (0, _laneDirectionArrows.getLaneDirectionArrowStyles)(feature, tags.laneDirection, "black", resolution) : [];
    if (hover || click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: backgroundColor,
                width: backgroundWidth
            })
        }),
        ...arrows
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        }),
        ...arrows
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./propertyExtraction":"i6VX6","./util/laneDirectionArrows":"cYzT8","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3Tely":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHoverLayer", ()=>getHoverLayer);
// Build a 2-point "tangent" LineString from the point before the
// closest-on-line to the closest-on-line itself, in EPSG:3857 so it can go
// straight into a hover layer. Copies all non-geometry properties from the
// source feature so hover-style functions can read them.
//
// Returns `{ tangent, latLonGeometry, closestPointLatLon }` — callers that
// need `distanceAlongCm` (e.g. FeatureInfoControl for LR decoding at cursor)
// can reuse the intermediate lat/lon results. Returns null if the source
// isn't a LineString.
parcelHelpers.export(exports, "buildTangentFeature", ()=>buildTangentFeature);
var _vector = require("ol/layer/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/source/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _geom = require("ol/geom");
var _proj = require("ol/proj");
var _helpers = require("@turf/helpers");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _nearestPointOnLineDefault = parcelHelpers.interopDefault(_nearestPointOnLine);
var _util = require("../util");
function getHoverLayer(styleFunction) {
    const vectorSource = new (0, _vectorDefault1.default)({});
    const vectorLayer = new (0, _vectorDefault.default)({
        source: vectorSource,
        style: styleFunction
    });
    vectorLayer.setZIndex(100);
    return vectorLayer;
}
function buildTangentFeature(sourceFeature, position) {
    const geometry = sourceFeature.getGeometry();
    if (!geometry || geometry.getType() !== "LineString") return null;
    const latLonGeometry = (0, _util.toLatLon)((0, _helpers.lineString)(geometry.getCoordinates()).geometry);
    const latLonEventPoint = (0, _util.toLatLon)((0, _helpers.point)(position).geometry);
    const closestPointLatLon = (0, _nearestPointOnLineDefault.default)(latLonGeometry, latLonEventPoint);
    const idx = closestPointLatLon.properties.index;
    const beforeCoord = latLonGeometry.coordinates[idx];
    const closestCoord = closestPointLatLon.geometry.coordinates;
    const tangent = new (0, _featureDefault.default)({
        geometry: new (0, _geom.LineString)([
            (0, _proj.fromLonLat)(beforeCoord),
            (0, _proj.fromLonLat)(closestCoord)
        ])
    });
    sourceFeature.getKeys().forEach((key)=>{
        if (key !== "geometry") tangent.set(key, sourceFeature.get(key));
    });
    return {
        tangent,
        latLonGeometry,
        closestPointLatLon
    };
}

},{"ol/layer/Vector":"7ga2c","ol/source/Vector":"7zHxp","ol/Feature":"iVSSP","ol/geom":[["LineString","223qD","default"]],"ol/proj":"gN0IK","@turf/helpers":"ityOQ","@turf/nearest-point-on-line":"bwWlY","../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}]},[], null, "parcelRequire05b1", {})

//# sourceMappingURL=open-maps-restriction-wkt-viewer.6fc94509.js.map
